//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import * as moment from 'moment';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class AccountServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    isTenantAvailable(body: IsTenantAvailableInput | undefined): Observable<IsTenantAvailableOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/IsTenantAvailable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsTenantAvailable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsTenantAvailable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IsTenantAvailableOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IsTenantAvailableOutput>;
        }));
    }

    protected processIsTenantAvailable(response: HttpResponseBase): Observable<IsTenantAvailableOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IsTenantAvailableOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    register(body: RegisterInput | undefined): Observable<RegisterOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/Register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegister(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RegisterOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RegisterOutput>;
        }));
    }

    protected processRegister(response: HttpResponseBase): Observable<RegisterOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegisterOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AuditLogServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param userName (optional) 
     * @param serviceName (optional) 
     * @param methodName (optional) 
     * @param browserInfo (optional) 
     * @param hasException (optional) 
     * @param minExecutionDuration (optional) 
     * @param maxExecutionDuration (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAuditLogs(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, userName: string | undefined, serviceName: string | undefined, methodName: string | undefined, browserInfo: string | undefined, hasException: boolean | undefined, minExecutionDuration: number | undefined, maxExecutionDuration: number | undefined, keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<AuditLogListDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetAuditLogs?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (userName === null)
            throw new Error("The parameter 'userName' cannot be null.");
        else if (userName !== undefined)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&";
        if (serviceName === null)
            throw new Error("The parameter 'serviceName' cannot be null.");
        else if (serviceName !== undefined)
            url_ += "ServiceName=" + encodeURIComponent("" + serviceName) + "&";
        if (methodName === null)
            throw new Error("The parameter 'methodName' cannot be null.");
        else if (methodName !== undefined)
            url_ += "MethodName=" + encodeURIComponent("" + methodName) + "&";
        if (browserInfo === null)
            throw new Error("The parameter 'browserInfo' cannot be null.");
        else if (browserInfo !== undefined)
            url_ += "BrowserInfo=" + encodeURIComponent("" + browserInfo) + "&";
        if (hasException === null)
            throw new Error("The parameter 'hasException' cannot be null.");
        else if (hasException !== undefined)
            url_ += "HasException=" + encodeURIComponent("" + hasException) + "&";
        if (minExecutionDuration === null)
            throw new Error("The parameter 'minExecutionDuration' cannot be null.");
        else if (minExecutionDuration !== undefined)
            url_ += "MinExecutionDuration=" + encodeURIComponent("" + minExecutionDuration) + "&";
        if (maxExecutionDuration === null)
            throw new Error("The parameter 'maxExecutionDuration' cannot be null.");
        else if (maxExecutionDuration !== undefined)
            url_ += "MaxExecutionDuration=" + encodeURIComponent("" + maxExecutionDuration) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAuditLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAuditLogs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditLogListDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditLogListDtoPagedResultDto>;
        }));
    }

    protected processGetAuditLogs(response: HttpResponseBase): Observable<AuditLogListDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditLogListDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getEntityHistoryObjectTypes(): Observable<NameValueDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetEntityHistoryObjectTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEntityHistoryObjectTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntityHistoryObjectTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NameValueDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NameValueDto[]>;
        }));
    }

    protected processGetEntityHistoryObjectTypes(response: HttpResponseBase): Observable<NameValueDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(NameValueDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param userName (optional) 
     * @param entityTypeFullName (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getEntityChanges(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, userName: string | undefined, entityTypeFullName: string | undefined, keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<EntityChangeListDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetEntityChanges?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (userName === null)
            throw new Error("The parameter 'userName' cannot be null.");
        else if (userName !== undefined)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&";
        if (entityTypeFullName === null)
            throw new Error("The parameter 'entityTypeFullName' cannot be null.");
        else if (entityTypeFullName !== undefined)
            url_ += "EntityTypeFullName=" + encodeURIComponent("" + entityTypeFullName) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEntityChanges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntityChanges(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EntityChangeListDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EntityChangeListDtoPagedResultDto>;
        }));
    }

    protected processGetEntityChanges(response: HttpResponseBase): Observable<EntityChangeListDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EntityChangeListDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param entityTypeFullName (optional) 
     * @param entityId (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getEntityTypeChanges(entityTypeFullName: string | undefined, entityId: string | undefined, keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<EntityChangeListDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetEntityTypeChanges?";
        if (entityTypeFullName === null)
            throw new Error("The parameter 'entityTypeFullName' cannot be null.");
        else if (entityTypeFullName !== undefined)
            url_ += "EntityTypeFullName=" + encodeURIComponent("" + entityTypeFullName) + "&";
        if (entityId === null)
            throw new Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEntityTypeChanges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntityTypeChanges(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EntityChangeListDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EntityChangeListDtoPagedResultDto>;
        }));
    }

    protected processGetEntityTypeChanges(response: HttpResponseBase): Observable<EntityChangeListDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EntityChangeListDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param entityChangeId (optional) 
     * @return Success
     */
    getEntityPropertyChanges(entityChangeId: number | undefined): Observable<EntityPropertyChangeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetEntityPropertyChanges?";
        if (entityChangeId === null)
            throw new Error("The parameter 'entityChangeId' cannot be null.");
        else if (entityChangeId !== undefined)
            url_ += "entityChangeId=" + encodeURIComponent("" + entityChangeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEntityPropertyChanges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntityPropertyChanges(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EntityPropertyChangeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EntityPropertyChangeDto[]>;
        }));
    }

    protected processGetEntityPropertyChanges(response: HttpResponseBase): Observable<EntityPropertyChangeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(EntityPropertyChangeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AwsS3ServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filePath (optional) 
     * @param file (optional) 
     * @return Success
     */
    uploadFile(filePath: string | undefined, file: FileParameter | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/AwsS3/UploadFile?";
        if (filePath === null)
            throw new Error("The parameter 'filePath' cannot be null.");
        else if (filePath !== undefined)
            url_ += "filePath=" + encodeURIComponent("" + filePath) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUploadFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param key (optional) 
     * @return Success
     */
    deleteFile(key: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/AwsS3/DeleteFile?";
        if (key === null)
            throw new Error("The parameter 'key' cannot be null.");
        else if (key !== undefined)
            url_ += "key=" + encodeURIComponent("" + key) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CancellationRequestServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param status (optional) 
     * @param requestType (optional) 
     * @param violationId (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(status: string | undefined, requestType: string | undefined, violationId: string | undefined, keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CancellationRequestResponsePagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CancellationRequest/GetAll?";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (requestType === null)
            throw new Error("The parameter 'requestType' cannot be null.");
        else if (requestType !== undefined)
            url_ += "RequestType=" + encodeURIComponent("" + requestType) + "&";
        if (violationId === null)
            throw new Error("The parameter 'violationId' cannot be null.");
        else if (violationId !== undefined)
            url_ += "ViolationId=" + encodeURIComponent("" + violationId) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CancellationRequestResponsePagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CancellationRequestResponsePagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CancellationRequestResponsePagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CancellationRequestResponsePagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<CancellationRequestReadModel> {
        let url_ = this.baseUrl + "/api/services/app/CancellationRequest/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CancellationRequestReadModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CancellationRequestReadModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CancellationRequestReadModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CancellationRequestReadModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    approve(body: ApproveCancellationRequest | undefined): Observable<CancellationRequestResponse> {
        let url_ = this.baseUrl + "/api/services/app/CancellationRequest/Approve";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApprove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApprove(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CancellationRequestResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CancellationRequestResponse>;
        }));
    }

    protected processApprove(response: HttpResponseBase): Observable<CancellationRequestResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CancellationRequestResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    reject(body: RejectCancellationRequest | undefined): Observable<CancellationRequestResponse> {
        let url_ = this.baseUrl + "/api/services/app/CancellationRequest/Reject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CancellationRequestResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CancellationRequestResponse>;
        }));
    }

    protected processReject(response: HttpResponseBase): Observable<CancellationRequestResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CancellationRequestResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ConfigurationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeUiTheme(body: ChangeUiThemeInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Configuration/ChangeUiTheme";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeUiTheme(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeUiTheme(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeUiTheme(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getWindowsTimezones(): Observable<NameValueDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Configuration/GetWindowsTimezones";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWindowsTimezones(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWindowsTimezones(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NameValueDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NameValueDto[]>;
        }));
    }

    protected processGetWindowsTimezones(response: HttpResponseBase): Observable<NameValueDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(NameValueDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllSettings(): Observable<SettingEditDto> {
        let url_ = this.baseUrl + "/api/services/app/Configuration/GetAllSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SettingEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SettingEditDto>;
        }));
    }

    protected processGetAllSettings(response: HttpResponseBase): Observable<SettingEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SettingEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateAllSettings(body: SettingEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Configuration/UpdateAllSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAllSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAllSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateAllSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getEmailSettings(): Observable<EmailSettingsEditDto> {
        let url_ = this.baseUrl + "/api/services/app/Configuration/GetEmailSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmailSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmailSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmailSettingsEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmailSettingsEditDto>;
        }));
    }

    protected processGetEmailSettings(response: HttpResponseBase): Observable<EmailSettingsEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmailSettingsEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateEmailSettings(body: EmailSettingsEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Configuration/UpdateEmailSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateEmailSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEmailSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateEmailSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getPaymentSettings(): Observable<PaymentSettingsEditDto> {
        let url_ = this.baseUrl + "/api/services/app/Configuration/GetPaymentSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaymentSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaymentSettingsEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaymentSettingsEditDto>;
        }));
    }

    protected processGetPaymentSettings(response: HttpResponseBase): Observable<PaymentSettingsEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaymentSettingsEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updatePaymentSettings(body: PaymentSettingsEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Configuration/UpdatePaymentSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePaymentSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePaymentSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdatePaymentSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getSMSSettings(): Observable<SMSSettingsEditDto> {
        let url_ = this.baseUrl + "/api/services/app/Configuration/GetSMSSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSMSSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSMSSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SMSSettingsEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SMSSettingsEditDto>;
        }));
    }

    protected processGetSMSSettings(response: HttpResponseBase): Observable<SMSSettingsEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SMSSettingsEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateSMSSettings(body: SMSSettingsEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Configuration/UpdateSMSSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSMSSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSMSSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateSMSSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getReceiptSettings(): Observable<ReceiptSettingsEditDto> {
        let url_ = this.baseUrl + "/api/services/app/Configuration/GetReceiptSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReceiptSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReceiptSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReceiptSettingsEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReceiptSettingsEditDto>;
        }));
    }

    protected processGetReceiptSettings(response: HttpResponseBase): Observable<ReceiptSettingsEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReceiptSettingsEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateReceiptSettings(body: ReceiptSettingsEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Configuration/UpdateReceiptSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateReceiptSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateReceiptSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateReceiptSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getViolationSettings(): Observable<ViolationSettingsDto> {
        let url_ = this.baseUrl + "/api/services/app/Configuration/GetViolationSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetViolationSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetViolationSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ViolationSettingsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ViolationSettingsDto>;
        }));
    }

    protected processGetViolationSettings(response: HttpResponseBase): Observable<ViolationSettingsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ViolationSettingsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateSettings(body: ViolationSettingsDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Configuration/UpdateSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getReservationSettings(): Observable<ReservationSettingsDto> {
        let url_ = this.baseUrl + "/api/services/app/Configuration/GetReservationSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReservationSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReservationSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReservationSettingsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReservationSettingsDto>;
        }));
    }

    protected processGetReservationSettings(response: HttpResponseBase): Observable<ReservationSettingsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReservationSettingsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getMetrixSystemSettings(): Observable<MetrixSystemSettingsEditDto> {
        let url_ = this.baseUrl + "/api/services/app/Configuration/GetMetrixSystemSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMetrixSystemSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMetrixSystemSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MetrixSystemSettingsEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MetrixSystemSettingsEditDto>;
        }));
    }

    protected processGetMetrixSystemSettings(response: HttpResponseBase): Observable<MetrixSystemSettingsEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MetrixSystemSettingsEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateMetrixSystemSettings(body: MetrixSystemSettingsEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Configuration/UpdateMetrixSystemSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMetrixSystemSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMetrixSystemSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateMetrixSystemSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateReservationSettings(body: ReservationSettingsDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Configuration/UpdateReservationSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateReservationSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateReservationSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateReservationSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAppEmailSettings(): Observable<AppEmailSettingsDto> {
        let url_ = this.baseUrl + "/api/services/app/Configuration/GetAppEmailSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAppEmailSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAppEmailSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AppEmailSettingsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AppEmailSettingsDto>;
        }));
    }

    protected processGetAppEmailSettings(response: HttpResponseBase): Observable<AppEmailSettingsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppEmailSettingsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateAppEmailSettings(body: AppEmailSettingsDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Configuration/UpdateAppEmailSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAppEmailSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAppEmailSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateAppEmailSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getPaymentBaseURL(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Configuration/GetPaymentBaseURL";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaymentBaseURL(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentBaseURL(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetPaymentBaseURL(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getSubscriptionConfiguration(): Observable<SubscriptionSettingsDto> {
        let url_ = this.baseUrl + "/api/services/app/Configuration/GetSubscriptionConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSubscriptionConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubscriptionConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubscriptionSettingsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubscriptionSettingsDto>;
        }));
    }

    protected processGetSubscriptionConfiguration(response: HttpResponseBase): Observable<SubscriptionSettingsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubscriptionSettingsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateSubscriptionConfiguration(body: SubscriptionSettingsDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Configuration/UpdateSubscriptionConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSubscriptionConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSubscriptionConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateSubscriptionConfiguration(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CustomerServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateCustomerInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Customer/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateCustomerInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Customer/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    view(id: string | undefined): Observable<ViewCustomerDto> {
        let url_ = this.baseUrl + "/api/services/app/Customer/View?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ViewCustomerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ViewCustomerDto>;
        }));
    }

    protected processView(response: HttpResponseBase): Observable<ViewCustomerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ViewCustomerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param firstName (optional) 
     * @param lastName (optional) 
     * @param isActive (optional) 
     * @param phoneNumber (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(firstName: string | undefined, lastName: string | undefined, isActive: boolean | undefined, phoneNumber: string | undefined, keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ViewCustomerDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Customer/GetAll?";
        if (firstName === null)
            throw new Error("The parameter 'firstName' cannot be null.");
        else if (firstName !== undefined)
            url_ += "FirstName=" + encodeURIComponent("" + firstName) + "&";
        if (lastName === null)
            throw new Error("The parameter 'lastName' cannot be null.");
        else if (lastName !== undefined)
            url_ += "LastName=" + encodeURIComponent("" + lastName) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (phoneNumber === null)
            throw new Error("The parameter 'phoneNumber' cannot be null.");
        else if (phoneNumber !== undefined)
            url_ += "PhoneNumber=" + encodeURIComponent("" + phoneNumber) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ViewCustomerDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ViewCustomerDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ViewCustomerDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ViewCustomerDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CustomerQRCodeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param qrCodeId (optional) 
     * @return Success
     */
    downloadQRCode(qrCodeId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/CustomerQRCode/DownloadQRCode?";
        if (qrCodeId === null)
            throw new Error("The parameter 'qrCodeId' cannot be null.");
        else if (qrCodeId !== undefined)
            url_ += "qrCodeId=" + encodeURIComponent("" + qrCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadQRCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadQRCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDownloadQRCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param count (optional) 
     * @return Success
     */
    downloadCodes(count: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/CustomerQRCode/DownloadCodes?";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDownloadCodes(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CustomerSupportStatusLogHistoryServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param violationId (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getViolationCustomerSupportLogHistory(violationId: string | undefined, keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<GetViolationCustomerSupportLogHistoryListDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CustomerSupportStatusLogHistory/GetViolationCustomerSupportLogHistory?";
        if (violationId === null)
            throw new Error("The parameter 'violationId' cannot be null.");
        else if (violationId !== undefined)
            url_ += "ViolationId=" + encodeURIComponent("" + violationId) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetViolationCustomerSupportLogHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetViolationCustomerSupportLogHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetViolationCustomerSupportLogHistoryListDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetViolationCustomerSupportLogHistoryListDtoPagedResultDto>;
        }));
    }

    protected processGetViolationCustomerSupportLogHistory(response: HttpResponseBase): Observable<GetViolationCustomerSupportLogHistoryListDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetViolationCustomerSupportLogHistoryListDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateCustomerSupportStatus(body: UpdateCustomerSupportStatusInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CustomerSupportStatusLogHistory/UpdateCustomerSupportStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCustomerSupportStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCustomerSupportStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateCustomerSupportStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ExportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param slotId (optional) 
     * @param locationId (optional) 
     * @param numberHours (optional) 
     * @param paymentMethod (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param carPlateDigits (optional) 
     * @param carPlateLetters (optional) 
     * @param reservationStatus (optional) 
     * @param shiftId (optional) 
     * @param invoiceNumber (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    exportReservationsToExcel(slotId: number | undefined, locationId: number | undefined, numberHours: number | undefined, paymentMethod: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, carPlateDigits: number | undefined, carPlateLetters: string | undefined, reservationStatus: ReservationStatus | undefined, shiftId: string | undefined, invoiceNumber: string | undefined, keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Export/ExportReservationsToExcel?";
        if (slotId === null)
            throw new Error("The parameter 'slotId' cannot be null.");
        else if (slotId !== undefined)
            url_ += "SlotId=" + encodeURIComponent("" + slotId) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        if (numberHours === null)
            throw new Error("The parameter 'numberHours' cannot be null.");
        else if (numberHours !== undefined)
            url_ += "NumberHours=" + encodeURIComponent("" + numberHours) + "&";
        if (paymentMethod === null)
            throw new Error("The parameter 'paymentMethod' cannot be null.");
        else if (paymentMethod !== undefined)
            url_ += "PaymentMethod=" + encodeURIComponent("" + paymentMethod) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (carPlateDigits === null)
            throw new Error("The parameter 'carPlateDigits' cannot be null.");
        else if (carPlateDigits !== undefined)
            url_ += "CarPlateDigits=" + encodeURIComponent("" + carPlateDigits) + "&";
        if (carPlateLetters === null)
            throw new Error("The parameter 'carPlateLetters' cannot be null.");
        else if (carPlateLetters !== undefined)
            url_ += "CarPlateLetters=" + encodeURIComponent("" + carPlateLetters) + "&";
        if (reservationStatus === null)
            throw new Error("The parameter 'reservationStatus' cannot be null.");
        else if (reservationStatus !== undefined)
            url_ += "ReservationStatus=" + encodeURIComponent("" + reservationStatus) + "&";
        if (shiftId === null)
            throw new Error("The parameter 'shiftId' cannot be null.");
        else if (shiftId !== undefined)
            url_ += "ShiftId=" + encodeURIComponent("" + shiftId) + "&";
        if (invoiceNumber === null)
            throw new Error("The parameter 'invoiceNumber' cannot be null.");
        else if (invoiceNumber !== undefined)
            url_ += "InvoiceNumber=" + encodeURIComponent("" + invoiceNumber) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportReservationsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportReservationsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExportReservationsToExcel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param fromCreationDate (optional) 
     * @param toCreationDate (optional) 
     * @param fromPaymentReceivedDate (optional) 
     * @param toPaymentReceivedDate (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    exportExternalInvoicesToExcel(fromCreationDate: moment.Moment | undefined, toCreationDate: moment.Moment | undefined, fromPaymentReceivedDate: moment.Moment | undefined, toPaymentReceivedDate: moment.Moment | undefined, keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Export/ExportExternalInvoicesToExcel?";
        if (fromCreationDate === null)
            throw new Error("The parameter 'fromCreationDate' cannot be null.");
        else if (fromCreationDate !== undefined)
            url_ += "FromCreationDate=" + encodeURIComponent(fromCreationDate ? "" + fromCreationDate.toISOString() : "") + "&";
        if (toCreationDate === null)
            throw new Error("The parameter 'toCreationDate' cannot be null.");
        else if (toCreationDate !== undefined)
            url_ += "ToCreationDate=" + encodeURIComponent(toCreationDate ? "" + toCreationDate.toISOString() : "") + "&";
        if (fromPaymentReceivedDate === null)
            throw new Error("The parameter 'fromPaymentReceivedDate' cannot be null.");
        else if (fromPaymentReceivedDate !== undefined)
            url_ += "FromPaymentReceivedDate=" + encodeURIComponent(fromPaymentReceivedDate ? "" + fromPaymentReceivedDate.toISOString() : "") + "&";
        if (toPaymentReceivedDate === null)
            throw new Error("The parameter 'toPaymentReceivedDate' cannot be null.");
        else if (toPaymentReceivedDate !== undefined)
            url_ += "ToPaymentReceivedDate=" + encodeURIComponent(toPaymentReceivedDate ? "" + toPaymentReceivedDate.toISOString() : "") + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportExternalInvoicesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportExternalInvoicesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExportExternalInvoicesToExcel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param paymentType (optional) 
     * @param invoiceNumber (optional) 
     * @param shiftId (optional) 
     * @param locationId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param carPlateDigits (optional) 
     * @param carPlateLetters (optional) 
     * @param statusIds (optional) 
     * @param vehicleStatusId (optional) 
     * @param customerSupportStatusId (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    exportViolationsToExcel(paymentType: PaymentType | undefined, invoiceNumber: string | undefined, shiftId: string | undefined, locationId: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, carPlateDigits: number | undefined, carPlateLetters: string | undefined, statusIds: number[] | undefined, vehicleStatusId: number | undefined, customerSupportStatusId: number | undefined, keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Export/ExportViolationsToExcel?";
        if (paymentType === null)
            throw new Error("The parameter 'paymentType' cannot be null.");
        else if (paymentType !== undefined)
            url_ += "PaymentType=" + encodeURIComponent("" + paymentType) + "&";
        if (invoiceNumber === null)
            throw new Error("The parameter 'invoiceNumber' cannot be null.");
        else if (invoiceNumber !== undefined)
            url_ += "InvoiceNumber=" + encodeURIComponent("" + invoiceNumber) + "&";
        if (shiftId === null)
            throw new Error("The parameter 'shiftId' cannot be null.");
        else if (shiftId !== undefined)
            url_ += "ShiftId=" + encodeURIComponent("" + shiftId) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (carPlateDigits === null)
            throw new Error("The parameter 'carPlateDigits' cannot be null.");
        else if (carPlateDigits !== undefined)
            url_ += "CarPlateDigits=" + encodeURIComponent("" + carPlateDigits) + "&";
        if (carPlateLetters === null)
            throw new Error("The parameter 'carPlateLetters' cannot be null.");
        else if (carPlateLetters !== undefined)
            url_ += "CarPlateLetters=" + encodeURIComponent("" + carPlateLetters) + "&";
        if (statusIds === null)
            throw new Error("The parameter 'statusIds' cannot be null.");
        else if (statusIds !== undefined)
            statusIds && statusIds.forEach(item => { url_ += "StatusIds=" + encodeURIComponent("" + item) + "&"; });
        if (vehicleStatusId === null)
            throw new Error("The parameter 'vehicleStatusId' cannot be null.");
        else if (vehicleStatusId !== undefined)
            url_ += "VehicleStatusId=" + encodeURIComponent("" + vehicleStatusId) + "&";
        if (customerSupportStatusId === null)
            throw new Error("The parameter 'customerSupportStatusId' cannot be null.");
        else if (customerSupportStatusId !== undefined)
            url_ += "CustomerSupportStatusId=" + encodeURIComponent("" + customerSupportStatusId) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportViolationsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportViolationsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExportViolationsToExcel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param subscriberType (optional) 
     * @param subscriptionType (optional) 
     * @param creationDateFrom (optional) 
     * @param creationDateTo (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param carPlateLetters (optional) 
     * @param carPlateDigits (optional) 
     * @param companyId (optional) 
     * @param creatorId (optional) 
     * @param paymentType (optional) 
     * @param paymentIdentifier (optional) 
     * @param locationId (optional) 
     * @param shiftId (optional) 
     * @param subscriptionPackageId (optional) 
     * @param invoiceNumber (optional) 
     * @param statuses (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    exportSubscriptions(subscriberType: SubscriberType | undefined, subscriptionType: SubscriptionType | undefined, creationDateFrom: moment.Moment | undefined, creationDateTo: moment.Moment | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, carPlateLetters: string | undefined, carPlateDigits: number | undefined, companyId: string | undefined, creatorId: number | undefined, paymentType: PaymentType | undefined, paymentIdentifier: string | undefined, locationId: number | undefined, shiftId: string | undefined, subscriptionPackageId: string | undefined, invoiceNumber: string | undefined, statuses: string[] | undefined, keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Export/ExportSubscriptions?";
        if (subscriberType === null)
            throw new Error("The parameter 'subscriberType' cannot be null.");
        else if (subscriberType !== undefined)
            url_ += "SubscriberType=" + encodeURIComponent("" + subscriberType) + "&";
        if (subscriptionType === null)
            throw new Error("The parameter 'subscriptionType' cannot be null.");
        else if (subscriptionType !== undefined)
            url_ += "SubscriptionType=" + encodeURIComponent("" + subscriptionType) + "&";
        if (creationDateFrom === null)
            throw new Error("The parameter 'creationDateFrom' cannot be null.");
        else if (creationDateFrom !== undefined)
            url_ += "CreationDateFrom=" + encodeURIComponent(creationDateFrom ? "" + creationDateFrom.toISOString() : "") + "&";
        if (creationDateTo === null)
            throw new Error("The parameter 'creationDateTo' cannot be null.");
        else if (creationDateTo !== undefined)
            url_ += "CreationDateTo=" + encodeURIComponent(creationDateTo ? "" + creationDateTo.toISOString() : "") + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (carPlateLetters === null)
            throw new Error("The parameter 'carPlateLetters' cannot be null.");
        else if (carPlateLetters !== undefined)
            url_ += "CarPlateLetters=" + encodeURIComponent("" + carPlateLetters) + "&";
        if (carPlateDigits === null)
            throw new Error("The parameter 'carPlateDigits' cannot be null.");
        else if (carPlateDigits !== undefined)
            url_ += "CarPlateDigits=" + encodeURIComponent("" + carPlateDigits) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (creatorId === null)
            throw new Error("The parameter 'creatorId' cannot be null.");
        else if (creatorId !== undefined)
            url_ += "CreatorId=" + encodeURIComponent("" + creatorId) + "&";
        if (paymentType === null)
            throw new Error("The parameter 'paymentType' cannot be null.");
        else if (paymentType !== undefined)
            url_ += "PaymentType=" + encodeURIComponent("" + paymentType) + "&";
        if (paymentIdentifier === null)
            throw new Error("The parameter 'paymentIdentifier' cannot be null.");
        else if (paymentIdentifier !== undefined)
            url_ += "PaymentIdentifier=" + encodeURIComponent("" + paymentIdentifier) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        if (shiftId === null)
            throw new Error("The parameter 'shiftId' cannot be null.");
        else if (shiftId !== undefined)
            url_ += "ShiftId=" + encodeURIComponent("" + shiftId) + "&";
        if (subscriptionPackageId === null)
            throw new Error("The parameter 'subscriptionPackageId' cannot be null.");
        else if (subscriptionPackageId !== undefined)
            url_ += "SubscriptionPackageId=" + encodeURIComponent("" + subscriptionPackageId) + "&";
        if (invoiceNumber === null)
            throw new Error("The parameter 'invoiceNumber' cannot be null.");
        else if (invoiceNumber !== undefined)
            url_ += "InvoiceNumber=" + encodeURIComponent("" + invoiceNumber) + "&";
        if (statuses === null)
            throw new Error("The parameter 'statuses' cannot be null.");
        else if (statuses !== undefined)
            statuses && statuses.forEach(item => { url_ += "Statuses=" + encodeURIComponent("" + item) + "&"; });
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportSubscriptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportSubscriptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExportSubscriptions(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param source (optional) 
     * @param paymentType (optional) 
     * @param locationId (optional) 
     * @param slotId (optional) 
     * @param shiftId (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param creatorUserId (optional) 
     * @param invoiceNumber (optional) 
     * @param minAmount (optional) 
     * @param maxAmount (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    exportInovicesToExcel(source: TransactionSource | undefined, paymentType: PaymentType | undefined, locationId: number | undefined, slotId: number | undefined, shiftId: string | undefined, fromDate: moment.Moment | undefined, toDate: moment.Moment | undefined, creatorUserId: number | undefined, invoiceNumber: string | undefined, minAmount: number | undefined, maxAmount: number | undefined, keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Export/ExportInovicesToExcel?";
        if (source === null)
            throw new Error("The parameter 'source' cannot be null.");
        else if (source !== undefined)
            url_ += "Source=" + encodeURIComponent("" + source) + "&";
        if (paymentType === null)
            throw new Error("The parameter 'paymentType' cannot be null.");
        else if (paymentType !== undefined)
            url_ += "PaymentType=" + encodeURIComponent("" + paymentType) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        if (slotId === null)
            throw new Error("The parameter 'slotId' cannot be null.");
        else if (slotId !== undefined)
            url_ += "SlotId=" + encodeURIComponent("" + slotId) + "&";
        if (shiftId === null)
            throw new Error("The parameter 'shiftId' cannot be null.");
        else if (shiftId !== undefined)
            url_ += "ShiftId=" + encodeURIComponent("" + shiftId) + "&";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (creatorUserId === null)
            throw new Error("The parameter 'creatorUserId' cannot be null.");
        else if (creatorUserId !== undefined)
            url_ += "CreatorUserId=" + encodeURIComponent("" + creatorUserId) + "&";
        if (invoiceNumber === null)
            throw new Error("The parameter 'invoiceNumber' cannot be null.");
        else if (invoiceNumber !== undefined)
            url_ += "InvoiceNumber=" + encodeURIComponent("" + invoiceNumber) + "&";
        if (minAmount === null)
            throw new Error("The parameter 'minAmount' cannot be null.");
        else if (minAmount !== undefined)
            url_ += "MinAmount=" + encodeURIComponent("" + minAmount) + "&";
        if (maxAmount === null)
            throw new Error("The parameter 'maxAmount' cannot be null.");
        else if (maxAmount !== undefined)
            url_ += "MaxAmount=" + encodeURIComponent("" + maxAmount) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportInovicesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportInovicesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExportInovicesToExcel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param carPlateDigits (optional) 
     * @param carPlateLetters (optional) 
     * @param numberHours (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param slotId (optional) 
     * @param locationId (optional) 
     * @param paymentType (optional) 
     * @param firstname (optional) 
     * @param lastname (optional) 
     * @param mobileNumber (optional) 
     * @param reservationStatus (optional) 
     * @param invoiceNumber (optional) 
     * @param creator (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    exportReservationsDetailsToExcel(carPlateDigits: number | undefined, carPlateLetters: string | undefined, numberHours: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, slotId: number | undefined, locationId: number | undefined, paymentType: PaymentType | undefined, firstname: string | undefined, lastname: string | undefined, mobileNumber: string | undefined, reservationStatus: ReservationStatus | undefined, invoiceNumber: string | undefined, creator: string | undefined, keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Export/ExportReservationsDetailsToExcel?";
        if (carPlateDigits === null)
            throw new Error("The parameter 'carPlateDigits' cannot be null.");
        else if (carPlateDigits !== undefined)
            url_ += "CarPlateDigits=" + encodeURIComponent("" + carPlateDigits) + "&";
        if (carPlateLetters === null)
            throw new Error("The parameter 'carPlateLetters' cannot be null.");
        else if (carPlateLetters !== undefined)
            url_ += "CarPlateLetters=" + encodeURIComponent("" + carPlateLetters) + "&";
        if (numberHours === null)
            throw new Error("The parameter 'numberHours' cannot be null.");
        else if (numberHours !== undefined)
            url_ += "NumberHours=" + encodeURIComponent("" + numberHours) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (slotId === null)
            throw new Error("The parameter 'slotId' cannot be null.");
        else if (slotId !== undefined)
            url_ += "SlotId=" + encodeURIComponent("" + slotId) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        if (paymentType === null)
            throw new Error("The parameter 'paymentType' cannot be null.");
        else if (paymentType !== undefined)
            url_ += "PaymentType=" + encodeURIComponent("" + paymentType) + "&";
        if (firstname === null)
            throw new Error("The parameter 'firstname' cannot be null.");
        else if (firstname !== undefined)
            url_ += "Firstname=" + encodeURIComponent("" + firstname) + "&";
        if (lastname === null)
            throw new Error("The parameter 'lastname' cannot be null.");
        else if (lastname !== undefined)
            url_ += "Lastname=" + encodeURIComponent("" + lastname) + "&";
        if (mobileNumber === null)
            throw new Error("The parameter 'mobileNumber' cannot be null.");
        else if (mobileNumber !== undefined)
            url_ += "MobileNumber=" + encodeURIComponent("" + mobileNumber) + "&";
        if (reservationStatus === null)
            throw new Error("The parameter 'reservationStatus' cannot be null.");
        else if (reservationStatus !== undefined)
            url_ += "ReservationStatus=" + encodeURIComponent("" + reservationStatus) + "&";
        if (invoiceNumber === null)
            throw new Error("The parameter 'invoiceNumber' cannot be null.");
        else if (invoiceNumber !== undefined)
            url_ += "InvoiceNumber=" + encodeURIComponent("" + invoiceNumber) + "&";
        if (creator === null)
            throw new Error("The parameter 'creator' cannot be null.");
        else if (creator !== undefined)
            url_ += "Creator=" + encodeURIComponent("" + creator) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportReservationsDetailsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportReservationsDetailsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExportReservationsDetailsToExcel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param source (optional) 
     * @param category (optional) 
     * @param paymentType (optional) 
     * @param isReported (optional) 
     * @param reportingDateFrom (optional) 
     * @param reportingDateTo (optional) 
     * @param status (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    exportParkingInvoicesToExcel(source: string | undefined, category: string | undefined, paymentType: string | undefined, isReported: boolean | undefined, reportingDateFrom: moment.Moment | undefined, reportingDateTo: moment.Moment | undefined, status: string | undefined, keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Export/ExportParkingInvoicesToExcel?";
        if (source === null)
            throw new Error("The parameter 'source' cannot be null.");
        else if (source !== undefined)
            url_ += "Source=" + encodeURIComponent("" + source) + "&";
        if (category === null)
            throw new Error("The parameter 'category' cannot be null.");
        else if (category !== undefined)
            url_ += "Category=" + encodeURIComponent("" + category) + "&";
        if (paymentType === null)
            throw new Error("The parameter 'paymentType' cannot be null.");
        else if (paymentType !== undefined)
            url_ += "PaymentType=" + encodeURIComponent("" + paymentType) + "&";
        if (isReported === null)
            throw new Error("The parameter 'isReported' cannot be null.");
        else if (isReported !== undefined)
            url_ += "IsReported=" + encodeURIComponent("" + isReported) + "&";
        if (reportingDateFrom === null)
            throw new Error("The parameter 'reportingDateFrom' cannot be null.");
        else if (reportingDateFrom !== undefined)
            url_ += "ReportingDateFrom=" + encodeURIComponent(reportingDateFrom ? "" + reportingDateFrom.toISOString() : "") + "&";
        if (reportingDateTo === null)
            throw new Error("The parameter 'reportingDateTo' cannot be null.");
        else if (reportingDateTo !== undefined)
            url_ += "ReportingDateTo=" + encodeURIComponent(reportingDateTo ? "" + reportingDateTo.toISOString() : "") + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportParkingInvoicesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportParkingInvoicesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExportParkingInvoicesToExcel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    downloadReport(exportId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/Export/DownloadReport/{exportId}";
        if (exportId === undefined || exportId === null)
            throw new Error("The parameter 'exportId' must be defined.");
        url_ = url_.replace("{exportId}", encodeURIComponent("" + exportId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDownloadReport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class GetUserExportRequestsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param exportStatus (optional) 
     * @param reportType (optional) 
     * @param keyword (optional) 
     * @param pageSize (optional) 
     * @param pageNumber (optional) 
     * @return Success
     */
    requests(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, exportStatus: string | undefined, reportType: string | undefined, keyword: string | undefined, pageSize: number | undefined, pageNumber: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Export/GetUserExportRequests/requests?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (exportStatus === null)
            throw new Error("The parameter 'exportStatus' cannot be null.");
        else if (exportStatus !== undefined)
            url_ += "exportStatus=" + encodeURIComponent("" + exportStatus) + "&";
        if (reportType === null)
            throw new Error("The parameter 'reportType' cannot be null.");
        else if (reportType !== undefined)
            url_ += "reportType=" + encodeURIComponent("" + reportType) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequests(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRequests(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FailureLogsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<FailureLogResponsePagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/FailureLogs/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FailureLogResponsePagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FailureLogResponsePagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<FailureLogResponsePagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FailureLogResponsePagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getForView(id: string | undefined): Observable<FailureLogResponse> {
        let url_ = this.baseUrl + "/api/services/app/FailureLogs/GetForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FailureLogResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FailureLogResponse>;
        }));
    }

    protected processGetForView(response: HttpResponseBase): Observable<FailureLogResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FailureLogResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FileServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param invoiceId (optional) 
     * @return Success
     */
    downloadInvoiceXml(invoiceId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/File/DownloadInvoiceXml?";
        if (invoiceId === null)
            throw new Error("The parameter 'invoiceId' cannot be null.");
        else if (invoiceId !== undefined)
            url_ += "invoiceId=" + encodeURIComponent("" + invoiceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadInvoiceXml(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadInvoiceXml(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDownloadInvoiceXml(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param parkingInvoiceId (optional) 
     * @return Success
     */
    downloadInvoicePdf(parkingInvoiceId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/File/DownloadInvoicePdf?";
        if (parkingInvoiceId === null)
            throw new Error("The parameter 'parkingInvoiceId' cannot be null.");
        else if (parkingInvoiceId !== undefined)
            url_ += "parkingInvoiceId=" + encodeURIComponent("" + parkingInvoiceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadInvoicePdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadInvoicePdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDownloadInvoicePdf(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    uploadImages(): Observable<void> {
        let url_ = this.baseUrl + "/api/File/UploadImages";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadImages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadImages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUploadImages(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    downloadTempFile(fileName: string, fileType: string, fileToken: string): Observable<void> {
        let url_ = this.baseUrl + "/api/File/DownloadTempFile?";
        if (fileName === undefined || fileName === null)
            throw new Error("The parameter 'fileName' must be defined and cannot be null.");
        else
            url_ += "FileName=" + encodeURIComponent("" + fileName) + "&";
        if (fileType === undefined || fileType === null)
            throw new Error("The parameter 'fileType' must be defined and cannot be null.");
        else
            url_ += "FileType=" + encodeURIComponent("" + fileType) + "&";
        if (fileToken === undefined || fileToken === null)
            throw new Error("The parameter 'fileToken' must be defined and cannot be null.");
        else
            url_ += "FileToken=" + encodeURIComponent("" + fileToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadTempFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadTempFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDownloadTempFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param reservationId (optional) 
     * @return Success
     */
    downloadTransactionQRCode(reservationId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/File/DownloadTransactionQRCode?";
        if (reservationId === null)
            throw new Error("The parameter 'reservationId' cannot be null.");
        else if (reservationId !== undefined)
            url_ += "reservationId=" + encodeURIComponent("" + reservationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadTransactionQRCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadTransactionQRCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDownloadTransactionQRCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param violationId (optional) 
     * @return Success
     */
    downloadViolationQRCode(violationId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/File/DownloadViolationQRCode?";
        if (violationId === null)
            throw new Error("The parameter 'violationId' cannot be null.");
        else if (violationId !== undefined)
            url_ += "violationId=" + encodeURIComponent("" + violationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadViolationQRCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadViolationQRCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDownloadViolationQRCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param transactionId (optional) 
     * @return Success
     */
    downloadTransactionQRCodeByTransactionId(transactionId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/File/DownloadTransactionQRCodeByTransactionId?";
        if (transactionId === null)
            throw new Error("The parameter 'transactionId' cannot be null.");
        else if (transactionId !== undefined)
            url_ += "transactionId=" + encodeURIComponent("" + transactionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadTransactionQRCodeByTransactionId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadTransactionQRCodeByTransactionId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDownloadTransactionQRCodeByTransactionId(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param invoiceNumber (optional) 
     * @param transactionId (optional) 
     * @return Success
     */
    downloadTransactionQRCodeByParkingInvoice(invoiceNumber: string | undefined, transactionId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/File/DownloadTransactionQRCodeByParkingInvoice?";
        if (invoiceNumber === null)
            throw new Error("The parameter 'invoiceNumber' cannot be null.");
        else if (invoiceNumber !== undefined)
            url_ += "invoiceNumber=" + encodeURIComponent("" + invoiceNumber) + "&";
        if (transactionId === null)
            throw new Error("The parameter 'transactionId' cannot be null.");
        else if (transactionId !== undefined)
            url_ += "transactionId=" + encodeURIComponent("" + transactionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadTransactionQRCodeByParkingInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadTransactionQRCodeByParkingInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDownloadTransactionQRCodeByParkingInvoice(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param invoiceId (optional) 
     * @return Success
     */
    downloadExternalInvoiceQRCodeByInvoiceId(invoiceId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/File/DownloadExternalInvoiceQRCodeByInvoiceId?";
        if (invoiceId === null)
            throw new Error("The parameter 'invoiceId' cannot be null.");
        else if (invoiceId !== undefined)
            url_ += "invoiceId=" + encodeURIComponent("" + invoiceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadExternalInvoiceQRCodeByInvoiceId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadExternalInvoiceQRCodeByInvoiceId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDownloadExternalInvoiceQRCodeByInvoiceId(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param templateName (optional) 
     * @return Success
     */
    testReadEmailTemplate(templateName: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/File/TestReadEmailTemplate?";
        if (templateName === null)
            throw new Error("The parameter 'templateName' cannot be null.");
        else if (templateName !== undefined)
            url_ += "templateName=" + encodeURIComponent("" + templateName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTestReadEmailTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTestReadEmailTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processTestReadEmailTemplate(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FileDataReaderServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    integrateIntervoWithDropBox(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FileDataReader/IntegrateIntervoWithDropBox";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIntegrateIntervoWithDropBox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIntegrateIntervoWithDropBox(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processIntegrateIntervoWithDropBox(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    integrateSpaceParkingWithDropBox(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FileDataReader/IntegrateSpaceParkingWithDropBox";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIntegrateSpaceParkingWithDropBox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIntegrateSpaceParkingWithDropBox(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processIntegrateSpaceParkingWithDropBox(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FinancialServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param source (optional) 
     * @param paymentType (optional) 
     * @param locationId (optional) 
     * @param slotId (optional) 
     * @param shiftId (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param creatorUserId (optional) 
     * @param invoiceNumber (optional) 
     * @param minAmount (optional) 
     * @param maxAmount (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getInvoices(source: TransactionSource | undefined, paymentType: PaymentType | undefined, locationId: number | undefined, slotId: number | undefined, shiftId: string | undefined, fromDate: moment.Moment | undefined, toDate: moment.Moment | undefined, creatorUserId: number | undefined, invoiceNumber: string | undefined, minAmount: number | undefined, maxAmount: number | undefined, keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<InvoiceDto_V2PagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Financial/GetInvoices?";
        if (source === null)
            throw new Error("The parameter 'source' cannot be null.");
        else if (source !== undefined)
            url_ += "Source=" + encodeURIComponent("" + source) + "&";
        if (paymentType === null)
            throw new Error("The parameter 'paymentType' cannot be null.");
        else if (paymentType !== undefined)
            url_ += "PaymentType=" + encodeURIComponent("" + paymentType) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        if (slotId === null)
            throw new Error("The parameter 'slotId' cannot be null.");
        else if (slotId !== undefined)
            url_ += "SlotId=" + encodeURIComponent("" + slotId) + "&";
        if (shiftId === null)
            throw new Error("The parameter 'shiftId' cannot be null.");
        else if (shiftId !== undefined)
            url_ += "ShiftId=" + encodeURIComponent("" + shiftId) + "&";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (creatorUserId === null)
            throw new Error("The parameter 'creatorUserId' cannot be null.");
        else if (creatorUserId !== undefined)
            url_ += "CreatorUserId=" + encodeURIComponent("" + creatorUserId) + "&";
        if (invoiceNumber === null)
            throw new Error("The parameter 'invoiceNumber' cannot be null.");
        else if (invoiceNumber !== undefined)
            url_ += "InvoiceNumber=" + encodeURIComponent("" + invoiceNumber) + "&";
        if (minAmount === null)
            throw new Error("The parameter 'minAmount' cannot be null.");
        else if (minAmount !== undefined)
            url_ += "MinAmount=" + encodeURIComponent("" + minAmount) + "&";
        if (maxAmount === null)
            throw new Error("The parameter 'maxAmount' cannot be null.");
        else if (maxAmount !== undefined)
            url_ += "MaxAmount=" + encodeURIComponent("" + maxAmount) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvoices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvoices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvoiceDto_V2PagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvoiceDto_V2PagedResultDto>;
        }));
    }

    protected processGetInvoices(response: HttpResponseBase): Observable<InvoiceDto_V2PagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceDto_V2PagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param shiftId (optional) 
     * @param source (optional) 
     * @param paymentType (optional) 
     * @param locationId (optional) 
     * @param slotId (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param creatorUserId (optional) 
     * @param invoiceNumber (optional) 
     * @param minAmount (optional) 
     * @param maxAmount (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getInvoicesByShift(shiftId: string | undefined, source: TransactionSource | undefined, paymentType: PaymentType | undefined, locationId: number | undefined, slotId: number | undefined, fromDate: moment.Moment | undefined, toDate: moment.Moment | undefined, creatorUserId: number | undefined, invoiceNumber: string | undefined, minAmount: number | undefined, maxAmount: number | undefined, keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<InvoiceDto_V2PagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Financial/GetInvoicesByShift?";
        if (shiftId === null)
            throw new Error("The parameter 'shiftId' cannot be null.");
        else if (shiftId !== undefined)
            url_ += "ShiftId=" + encodeURIComponent("" + shiftId) + "&";
        if (source === null)
            throw new Error("The parameter 'source' cannot be null.");
        else if (source !== undefined)
            url_ += "Source=" + encodeURIComponent("" + source) + "&";
        if (paymentType === null)
            throw new Error("The parameter 'paymentType' cannot be null.");
        else if (paymentType !== undefined)
            url_ += "PaymentType=" + encodeURIComponent("" + paymentType) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        if (slotId === null)
            throw new Error("The parameter 'slotId' cannot be null.");
        else if (slotId !== undefined)
            url_ += "SlotId=" + encodeURIComponent("" + slotId) + "&";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (creatorUserId === null)
            throw new Error("The parameter 'creatorUserId' cannot be null.");
        else if (creatorUserId !== undefined)
            url_ += "CreatorUserId=" + encodeURIComponent("" + creatorUserId) + "&";
        if (invoiceNumber === null)
            throw new Error("The parameter 'invoiceNumber' cannot be null.");
        else if (invoiceNumber !== undefined)
            url_ += "InvoiceNumber=" + encodeURIComponent("" + invoiceNumber) + "&";
        if (minAmount === null)
            throw new Error("The parameter 'minAmount' cannot be null.");
        else if (minAmount !== undefined)
            url_ += "MinAmount=" + encodeURIComponent("" + minAmount) + "&";
        if (maxAmount === null)
            throw new Error("The parameter 'maxAmount' cannot be null.");
        else if (maxAmount !== undefined)
            url_ += "MaxAmount=" + encodeURIComponent("" + maxAmount) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvoicesByShift(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvoicesByShift(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvoiceDto_V2PagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvoiceDto_V2PagedResultDto>;
        }));
    }

    protected processGetInvoicesByShift(response: HttpResponseBase): Observable<InvoiceDto_V2PagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceDto_V2PagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param source (optional) 
     * @param paymentType (optional) 
     * @param locationId (optional) 
     * @param slotId (optional) 
     * @param shiftId (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param creatorUserId (optional) 
     * @param invoiceNumber (optional) 
     * @param minAmount (optional) 
     * @param maxAmount (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getInvoices_V1(source: TransactionSource | undefined, paymentType: PaymentType | undefined, locationId: number | undefined, slotId: number | undefined, shiftId: string | undefined, fromDate: moment.Moment | undefined, toDate: moment.Moment | undefined, creatorUserId: number | undefined, invoiceNumber: string | undefined, minAmount: number | undefined, maxAmount: number | undefined, keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<InvoiceDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Financial/GetInvoices_V1?";
        if (source === null)
            throw new Error("The parameter 'source' cannot be null.");
        else if (source !== undefined)
            url_ += "Source=" + encodeURIComponent("" + source) + "&";
        if (paymentType === null)
            throw new Error("The parameter 'paymentType' cannot be null.");
        else if (paymentType !== undefined)
            url_ += "PaymentType=" + encodeURIComponent("" + paymentType) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        if (slotId === null)
            throw new Error("The parameter 'slotId' cannot be null.");
        else if (slotId !== undefined)
            url_ += "SlotId=" + encodeURIComponent("" + slotId) + "&";
        if (shiftId === null)
            throw new Error("The parameter 'shiftId' cannot be null.");
        else if (shiftId !== undefined)
            url_ += "ShiftId=" + encodeURIComponent("" + shiftId) + "&";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (creatorUserId === null)
            throw new Error("The parameter 'creatorUserId' cannot be null.");
        else if (creatorUserId !== undefined)
            url_ += "CreatorUserId=" + encodeURIComponent("" + creatorUserId) + "&";
        if (invoiceNumber === null)
            throw new Error("The parameter 'invoiceNumber' cannot be null.");
        else if (invoiceNumber !== undefined)
            url_ += "InvoiceNumber=" + encodeURIComponent("" + invoiceNumber) + "&";
        if (minAmount === null)
            throw new Error("The parameter 'minAmount' cannot be null.");
        else if (minAmount !== undefined)
            url_ += "MinAmount=" + encodeURIComponent("" + minAmount) + "&";
        if (maxAmount === null)
            throw new Error("The parameter 'maxAmount' cannot be null.");
        else if (maxAmount !== undefined)
            url_ += "MaxAmount=" + encodeURIComponent("" + maxAmount) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvoices_V1(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvoices_V1(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvoiceDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvoiceDtoPagedResultDto>;
        }));
    }

    protected processGetInvoices_V1(response: HttpResponseBase): Observable<InvoiceDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param source (optional) 
     * @param paymentType (optional) 
     * @param locationId (optional) 
     * @param slotId (optional) 
     * @param shiftId (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param creatorUserId (optional) 
     * @param invoiceNumber (optional) 
     * @param minAmount (optional) 
     * @param maxAmount (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getInvoicesReport(source: TransactionSource | undefined, paymentType: PaymentType | undefined, locationId: number | undefined, slotId: number | undefined, shiftId: string | undefined, fromDate: moment.Moment | undefined, toDate: moment.Moment | undefined, creatorUserId: number | undefined, invoiceNumber: string | undefined, minAmount: number | undefined, maxAmount: number | undefined, keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<InvoiceReportDto> {
        let url_ = this.baseUrl + "/api/services/app/Financial/GetInvoicesReport?";
        if (source === null)
            throw new Error("The parameter 'source' cannot be null.");
        else if (source !== undefined)
            url_ += "Source=" + encodeURIComponent("" + source) + "&";
        if (paymentType === null)
            throw new Error("The parameter 'paymentType' cannot be null.");
        else if (paymentType !== undefined)
            url_ += "PaymentType=" + encodeURIComponent("" + paymentType) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        if (slotId === null)
            throw new Error("The parameter 'slotId' cannot be null.");
        else if (slotId !== undefined)
            url_ += "SlotId=" + encodeURIComponent("" + slotId) + "&";
        if (shiftId === null)
            throw new Error("The parameter 'shiftId' cannot be null.");
        else if (shiftId !== undefined)
            url_ += "ShiftId=" + encodeURIComponent("" + shiftId) + "&";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (creatorUserId === null)
            throw new Error("The parameter 'creatorUserId' cannot be null.");
        else if (creatorUserId !== undefined)
            url_ += "CreatorUserId=" + encodeURIComponent("" + creatorUserId) + "&";
        if (invoiceNumber === null)
            throw new Error("The parameter 'invoiceNumber' cannot be null.");
        else if (invoiceNumber !== undefined)
            url_ += "InvoiceNumber=" + encodeURIComponent("" + invoiceNumber) + "&";
        if (minAmount === null)
            throw new Error("The parameter 'minAmount' cannot be null.");
        else if (minAmount !== undefined)
            url_ += "MinAmount=" + encodeURIComponent("" + minAmount) + "&";
        if (maxAmount === null)
            throw new Error("The parameter 'maxAmount' cannot be null.");
        else if (maxAmount !== undefined)
            url_ += "MaxAmount=" + encodeURIComponent("" + maxAmount) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvoicesReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvoicesReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvoiceReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvoiceReportDto>;
        }));
    }

    protected processGetInvoicesReport(response: HttpResponseBase): Observable<InvoiceReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceReportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param fromCreationDate (optional) 
     * @param toCreationDate (optional) 
     * @param fromPaymentReceivedDate (optional) 
     * @param toPaymentReceivedDate (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getExternalInvoices(fromCreationDate: moment.Moment | undefined, toCreationDate: moment.Moment | undefined, fromPaymentReceivedDate: moment.Moment | undefined, toPaymentReceivedDate: moment.Moment | undefined, keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ExternalInvoiceDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Financial/GetExternalInvoices?";
        if (fromCreationDate === null)
            throw new Error("The parameter 'fromCreationDate' cannot be null.");
        else if (fromCreationDate !== undefined)
            url_ += "FromCreationDate=" + encodeURIComponent(fromCreationDate ? "" + fromCreationDate.toISOString() : "") + "&";
        if (toCreationDate === null)
            throw new Error("The parameter 'toCreationDate' cannot be null.");
        else if (toCreationDate !== undefined)
            url_ += "ToCreationDate=" + encodeURIComponent(toCreationDate ? "" + toCreationDate.toISOString() : "") + "&";
        if (fromPaymentReceivedDate === null)
            throw new Error("The parameter 'fromPaymentReceivedDate' cannot be null.");
        else if (fromPaymentReceivedDate !== undefined)
            url_ += "FromPaymentReceivedDate=" + encodeURIComponent(fromPaymentReceivedDate ? "" + fromPaymentReceivedDate.toISOString() : "") + "&";
        if (toPaymentReceivedDate === null)
            throw new Error("The parameter 'toPaymentReceivedDate' cannot be null.");
        else if (toPaymentReceivedDate !== undefined)
            url_ += "ToPaymentReceivedDate=" + encodeURIComponent(toPaymentReceivedDate ? "" + toPaymentReceivedDate.toISOString() : "") + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExternalInvoices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExternalInvoices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalInvoiceDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalInvoiceDtoPagedResultDto>;
        }));
    }

    protected processGetExternalInvoices(response: HttpResponseBase): Observable<ExternalInvoiceDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalInvoiceDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportExternalInvoices(body: GetExternalInvoicesInputDto | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Financial/ExportExternalInvoices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportExternalInvoices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportExternalInvoices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processExportExternalInvoices(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FinancialExporterServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportExternalInvoices(body: ExternalInvoiceDto[] | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/FinancialExporter/ExportExternalInvoices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportExternalInvoices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportExternalInvoices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processExportExternalInvoices(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class InOutReservationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param code (optional) 
     * @param number (optional) 
     * @param invoiceNumber (optional) 
     * @param startTime (optional) 
     * @param endTime (optional) 
     * @param locationId (optional) 
     * @param staffAccountShiftId (optional) 
     * @param status (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(code: string | undefined, number: number | undefined, invoiceNumber: string | undefined, startTime: moment.Moment | undefined, endTime: moment.Moment | undefined, locationId: number | undefined, staffAccountShiftId: string | undefined, status: InOutReservationStatus | undefined, keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<InOutReservationListDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/InOutReservation/GetAll?";
        if (code === null)
            throw new Error("The parameter 'code' cannot be null.");
        else if (code !== undefined)
            url_ += "Code=" + encodeURIComponent("" + code) + "&";
        if (number === null)
            throw new Error("The parameter 'number' cannot be null.");
        else if (number !== undefined)
            url_ += "Number=" + encodeURIComponent("" + number) + "&";
        if (invoiceNumber === null)
            throw new Error("The parameter 'invoiceNumber' cannot be null.");
        else if (invoiceNumber !== undefined)
            url_ += "InvoiceNumber=" + encodeURIComponent("" + invoiceNumber) + "&";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "StartTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime === null)
            throw new Error("The parameter 'endTime' cannot be null.");
        else if (endTime !== undefined)
            url_ += "EndTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        if (staffAccountShiftId === null)
            throw new Error("The parameter 'staffAccountShiftId' cannot be null.");
        else if (staffAccountShiftId !== undefined)
            url_ += "StaffAccountShiftId=" + encodeURIComponent("" + staffAccountShiftId) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InOutReservationListDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InOutReservationListDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<InOutReservationListDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InOutReservationListDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param code (optional) 
     * @param number (optional) 
     * @param invoiceNumber (optional) 
     * @param startTime (optional) 
     * @param endTime (optional) 
     * @param locationId (optional) 
     * @param staffAccountShiftId (optional) 
     * @param status (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getByShift(code: string | undefined, number: number | undefined, invoiceNumber: string | undefined, startTime: moment.Moment | undefined, endTime: moment.Moment | undefined, locationId: number | undefined, staffAccountShiftId: string | undefined, status: InOutReservationStatus | undefined, keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<InOutReservationListDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/InOutReservation/GetByShift?";
        if (code === null)
            throw new Error("The parameter 'code' cannot be null.");
        else if (code !== undefined)
            url_ += "Code=" + encodeURIComponent("" + code) + "&";
        if (number === null)
            throw new Error("The parameter 'number' cannot be null.");
        else if (number !== undefined)
            url_ += "Number=" + encodeURIComponent("" + number) + "&";
        if (invoiceNumber === null)
            throw new Error("The parameter 'invoiceNumber' cannot be null.");
        else if (invoiceNumber !== undefined)
            url_ += "InvoiceNumber=" + encodeURIComponent("" + invoiceNumber) + "&";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "StartTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime === null)
            throw new Error("The parameter 'endTime' cannot be null.");
        else if (endTime !== undefined)
            url_ += "EndTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        if (staffAccountShiftId === null)
            throw new Error("The parameter 'staffAccountShiftId' cannot be null.");
        else if (staffAccountShiftId !== undefined)
            url_ += "StaffAccountShiftId=" + encodeURIComponent("" + staffAccountShiftId) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByShift(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByShift(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InOutReservationListDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InOutReservationListDtoPagedResultDto>;
        }));
    }

    protected processGetByShift(response: HttpResponseBase): Observable<InOutReservationListDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InOutReservationListDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param groupShiftId (optional) 
     * @return Success
     */
    getSummaryByGroupShiftId(groupShiftId: string | undefined): Observable<InOutReservationsSummaryDto> {
        let url_ = this.baseUrl + "/api/services/app/InOutReservation/GetSummaryByGroupShiftId?";
        if (groupShiftId === null)
            throw new Error("The parameter 'groupShiftId' cannot be null.");
        else if (groupShiftId !== undefined)
            url_ += "groupShiftId=" + encodeURIComponent("" + groupShiftId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSummaryByGroupShiftId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSummaryByGroupShiftId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InOutReservationsSummaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InOutReservationsSummaryDto>;
        }));
    }

    protected processGetSummaryByGroupShiftId(response: HttpResponseBase): Observable<InOutReservationsSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InOutReservationsSummaryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param shiftId (optional) 
     * @return Success
     */
    getSummaryByShiftId(shiftId: string | undefined): Observable<InOutReservationsSummaryDto> {
        let url_ = this.baseUrl + "/api/services/app/InOutReservation/GetSummaryByShiftId?";
        if (shiftId === null)
            throw new Error("The parameter 'shiftId' cannot be null.");
        else if (shiftId !== undefined)
            url_ += "shiftId=" + encodeURIComponent("" + shiftId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSummaryByShiftId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSummaryByShiftId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InOutReservationsSummaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InOutReservationsSummaryDto>;
        }));
    }

    protected processGetSummaryByShiftId(response: HttpResponseBase): Observable<InOutReservationsSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InOutReservationsSummaryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param reservationId (optional) 
     * @return Success
     */
    getForView(reservationId: string | undefined): Observable<InOutReservationViewDto> {
        let url_ = this.baseUrl + "/api/services/app/InOutReservation/GetForView?";
        if (reservationId === null)
            throw new Error("The parameter 'reservationId' cannot be null.");
        else if (reservationId !== undefined)
            url_ += "reservationId=" + encodeURIComponent("" + reservationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InOutReservationViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InOutReservationViewDto>;
        }));
    }

    protected processGetForView(response: HttpResponseBase): Observable<InOutReservationViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InOutReservationViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param code (optional) 
     * @return Success
     */
    getInOutReservationByCode(code: string | undefined): Observable<InOutReservationViewDto> {
        let url_ = this.baseUrl + "/api/services/app/InOutReservation/GetInOutReservationByCode?";
        if (code === null)
            throw new Error("The parameter 'code' cannot be null.");
        else if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInOutReservationByCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInOutReservationByCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InOutReservationViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InOutReservationViewDto>;
        }));
    }

    protected processGetInOutReservationByCode(response: HttpResponseBase): Observable<InOutReservationViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InOutReservationViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param locationId (optional) 
     * @return Success
     */
    startInOutReservation(locationId: number | undefined): Observable<InOutReservationOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/InOutReservation/StartInOutReservation?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStartInOutReservation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStartInOutReservation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InOutReservationOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InOutReservationOutputDto>;
        }));
    }

    protected processStartInOutReservation(response: HttpResponseBase): Observable<InOutReservationOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InOutReservationOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    endInOutReservation(body: EndInOutReservationInputDto | undefined): Observable<InOutReservationOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/InOutReservation/EndInOutReservation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEndInOutReservation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEndInOutReservation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InOutReservationOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InOutReservationOutputDto>;
        }));
    }

    protected processEndInOutReservation(response: HttpResponseBase): Observable<InOutReservationOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InOutReservationOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getInOutReservationRecieptInfo(id: string | undefined): Observable<InOutReservationViewDtoRecieptDto> {
        let url_ = this.baseUrl + "/api/services/app/InOutReservation/GetInOutReservationRecieptInfo?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInOutReservationRecieptInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInOutReservationRecieptInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InOutReservationViewDtoRecieptDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InOutReservationViewDtoRecieptDto>;
        }));
    }

    protected processGetInOutReservationRecieptInfo(response: HttpResponseBase): Observable<InOutReservationViewDtoRecieptDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InOutReservationViewDtoRecieptDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class InOutReservationPricingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param name (optional) 
     * @param isEnabled (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(name: string | undefined, isEnabled: boolean | undefined, keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<InOutReservationPricingListDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/InOutReservationPricing/GetAll?";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (isEnabled === null)
            throw new Error("The parameter 'isEnabled' cannot be null.");
        else if (isEnabled !== undefined)
            url_ += "IsEnabled=" + encodeURIComponent("" + isEnabled) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InOutReservationPricingListDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InOutReservationPricingListDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<InOutReservationPricingListDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InOutReservationPricingListDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param pricingId (optional) 
     * @return Success
     */
    view(pricingId: number | undefined): Observable<InOutReservationPricingViewDto> {
        let url_ = this.baseUrl + "/api/services/app/InOutReservationPricing/View?";
        if (pricingId === null)
            throw new Error("The parameter 'pricingId' cannot be null.");
        else if (pricingId !== undefined)
            url_ += "pricingId=" + encodeURIComponent("" + pricingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InOutReservationPricingViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InOutReservationPricingViewDto>;
        }));
    }

    protected processView(response: HttpResponseBase): Observable<InOutReservationPricingViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InOutReservationPricingViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    add(body: InOutReservationPricingCreateOrEditDto | undefined): Observable<InOutReservationPricingCreateOrEditDto> {
        let url_ = this.baseUrl + "/api/services/app/InOutReservationPricing/Add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InOutReservationPricingCreateOrEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InOutReservationPricingCreateOrEditDto>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<InOutReservationPricingCreateOrEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InOutReservationPricingCreateOrEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    edit(body: InOutReservationPricingCreateOrEditDto | undefined): Observable<InOutReservationPricingCreateOrEditDto> {
        let url_ = this.baseUrl + "/api/services/app/InOutReservationPricing/Edit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InOutReservationPricingCreateOrEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InOutReservationPricingCreateOrEditDto>;
        }));
    }

    protected processEdit(response: HttpResponseBase): Observable<InOutReservationPricingCreateOrEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InOutReservationPricingCreateOrEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateDiscount(body: UpdateInOutReservationPricingDiscount | undefined): Observable<InOutReservationPricingCreateOrEditDto> {
        let url_ = this.baseUrl + "/api/services/app/InOutReservationPricing/UpdateDiscount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDiscount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDiscount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InOutReservationPricingCreateOrEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InOutReservationPricingCreateOrEditDto>;
        }));
    }

    protected processUpdateDiscount(response: HttpResponseBase): Observable<InOutReservationPricingCreateOrEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InOutReservationPricingCreateOrEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class IntegratedInvoiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<IntegratedInvoiceDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/IntegratedInvoice/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IntegratedInvoiceDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IntegratedInvoiceDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<IntegratedInvoiceDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IntegratedInvoiceDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateIntegratedInvoiceDto | undefined): Observable<IntegratedInvoiceDto> {
        let url_ = this.baseUrl + "/api/services/app/IntegratedInvoice/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IntegratedInvoiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IntegratedInvoiceDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<IntegratedInvoiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IntegratedInvoiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class IntegrationIntegrityLogsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param status (optional) 
     * @param source (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(status: string | undefined, source: string | undefined, keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<IntegrationDataMigrationIntegrityLogResponsePagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/IntegrationIntegrityLogs/GetAll?";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (source === null)
            throw new Error("The parameter 'source' cannot be null.");
        else if (source !== undefined)
            url_ += "Source=" + encodeURIComponent("" + source) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IntegrationDataMigrationIntegrityLogResponsePagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IntegrationDataMigrationIntegrityLogResponsePagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<IntegrationDataMigrationIntegrityLogResponsePagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IntegrationDataMigrationIntegrityLogResponsePagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LocationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getMyLocations(keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<LocationDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Location/GetMyLocations?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyLocations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyLocations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationDtoPagedResultDto>;
        }));
    }

    protected processGetMyLocations(response: HttpResponseBase): Observable<LocationDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocationDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param locationId (optional) 
     * @return Success
     */
    getLocationDetails(locationId: number | undefined): Observable<LocationDetailsDto> {
        let url_ = this.baseUrl + "/api/services/app/Location/GetLocationDetails?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocationDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocationDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationDetailsDto>;
        }));
    }

    protected processGetLocationDetails(response: HttpResponseBase): Observable<LocationDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocationDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param locationId (optional) 
     * @param qRCodeId (optional) 
     * @param shiftId (optional) 
     * @param paymentMethod (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param carPlateDigits (optional) 
     * @param carPlateLetters (optional) 
     * @param paymentType (optional) 
     * @param paymentStatus (optional) 
     * @param isActive (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getReservationsByLocation(locationId: number | undefined, qRCodeId: number | undefined, shiftId: string | undefined, paymentMethod: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, carPlateDigits: number | undefined, carPlateLetters: string | undefined, paymentType: PaymentType | undefined, paymentStatus: number | undefined, isActive: boolean | undefined, keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ReservationListDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Location/GetReservationsByLocation?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        if (qRCodeId === null)
            throw new Error("The parameter 'qRCodeId' cannot be null.");
        else if (qRCodeId !== undefined)
            url_ += "QRCodeId=" + encodeURIComponent("" + qRCodeId) + "&";
        if (shiftId === null)
            throw new Error("The parameter 'shiftId' cannot be null.");
        else if (shiftId !== undefined)
            url_ += "ShiftId=" + encodeURIComponent("" + shiftId) + "&";
        if (paymentMethod === null)
            throw new Error("The parameter 'paymentMethod' cannot be null.");
        else if (paymentMethod !== undefined)
            url_ += "PaymentMethod=" + encodeURIComponent("" + paymentMethod) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (carPlateDigits === null)
            throw new Error("The parameter 'carPlateDigits' cannot be null.");
        else if (carPlateDigits !== undefined)
            url_ += "CarPlateDigits=" + encodeURIComponent("" + carPlateDigits) + "&";
        if (carPlateLetters === null)
            throw new Error("The parameter 'carPlateLetters' cannot be null.");
        else if (carPlateLetters !== undefined)
            url_ += "CarPlateLetters=" + encodeURIComponent("" + carPlateLetters) + "&";
        if (paymentType === null)
            throw new Error("The parameter 'paymentType' cannot be null.");
        else if (paymentType !== undefined)
            url_ += "PaymentType=" + encodeURIComponent("" + paymentType) + "&";
        if (paymentStatus === null)
            throw new Error("The parameter 'paymentStatus' cannot be null.");
        else if (paymentStatus !== undefined)
            url_ += "PaymentStatus=" + encodeURIComponent("" + paymentStatus) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReservationsByLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReservationsByLocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReservationListDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReservationListDtoPagedResultDto>;
        }));
    }

    protected processGetReservationsByLocation(response: HttpResponseBase): Observable<ReservationListDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReservationListDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param locationId (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getViolationTypesByLocation(locationId: number | undefined, keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<LocationViolationPriceDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Location/GetViolationTypesByLocation?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetViolationTypesByLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetViolationTypesByLocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationViolationPriceDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationViolationPriceDtoPagedResultDto>;
        }));
    }

    protected processGetViolationTypesByLocation(response: HttpResponseBase): Observable<LocationViolationPriceDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocationViolationPriceDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LocationManagementServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param isActive (optional) 
     * @param inOutReservationEnabled (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllLocations(isActive: boolean | undefined, inOutReservationEnabled: boolean | undefined, keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<LocationListDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/LocationManagement/GetAllLocations?";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (inOutReservationEnabled === null)
            throw new Error("The parameter 'inOutReservationEnabled' cannot be null.");
        else if (inOutReservationEnabled !== undefined)
            url_ += "InOutReservationEnabled=" + encodeURIComponent("" + inOutReservationEnabled) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllLocations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllLocations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationListDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationListDtoPagedResultDto>;
        }));
    }

    protected processGetAllLocations(response: HttpResponseBase): Observable<LocationListDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocationListDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getLocationForEdit(id: number | undefined): Observable<CreateOrUpdateLocationDto> {
        let url_ = this.baseUrl + "/api/services/app/LocationManagement/GetLocationForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocationForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocationForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrUpdateLocationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrUpdateLocationDto>;
        }));
    }

    protected processGetLocationForEdit(response: HttpResponseBase): Observable<CreateOrUpdateLocationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrUpdateLocationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateLocation(body: CreateOrUpdateLocationDto | undefined): Observable<CreateOrUpdateLocationDto> {
        let url_ = this.baseUrl + "/api/services/app/LocationManagement/CreateOrUpdateLocation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateLocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrUpdateLocationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrUpdateLocationDto>;
        }));
    }

    protected processCreateOrUpdateLocation(response: HttpResponseBase): Observable<CreateOrUpdateLocationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrUpdateLocationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param locationId (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getLocationStaffAccounts(locationId: number | undefined, keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<StaffAccountDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/LocationManagement/GetLocationStaffAccounts?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocationStaffAccounts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocationStaffAccounts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StaffAccountDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StaffAccountDtoPagedResultDto>;
        }));
    }

    protected processGetLocationStaffAccounts(response: HttpResponseBase): Observable<StaffAccountDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StaffAccountDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param locationId (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getLocationStaffGroups(locationId: number | undefined, keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<LocationStaffGroupDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/LocationManagement/GetLocationStaffGroups?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocationStaffGroups(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocationStaffGroups(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationStaffGroupDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationStaffGroupDtoPagedResultDto>;
        }));
    }

    protected processGetLocationStaffGroups(response: HttpResponseBase): Observable<LocationStaffGroupDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocationStaffGroupDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    assignStaffAccount(body: AssignStaffAccountInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LocationManagement/AssignStaffAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignStaffAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignStaffAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAssignStaffAccount(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param locationId (optional) 
     * @param staffAccountId (optional) 
     * @return Success
     */
    removeStaffAccount(locationId: number | undefined, staffAccountId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LocationManagement/RemoveStaffAccount?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        if (staffAccountId === null)
            throw new Error("The parameter 'staffAccountId' cannot be null.");
        else if (staffAccountId !== undefined)
            url_ += "StaffAccountId=" + encodeURIComponent("" + staffAccountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveStaffAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveStaffAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveStaffAccount(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param locationId (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getLocationViolationPrices(locationId: number | undefined, keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<LocationViolationPriceDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/LocationManagement/GetLocationViolationPrices?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocationViolationPrices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocationViolationPrices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationViolationPriceDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationViolationPriceDtoPagedResultDto>;
        }));
    }

    protected processGetLocationViolationPrices(response: HttpResponseBase): Observable<LocationViolationPriceDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocationViolationPriceDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateViolationTypePrice(body: CreateOrUpdateViolationTypePriceDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LocationManagement/CreateOrUpdateViolationTypePrice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateViolationTypePrice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateViolationTypePrice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrUpdateViolationTypePrice(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param locationId (optional) 
     * @return Success
     */
    removeViolationTypePrice(id: string | undefined, locationId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LocationManagement/RemoveViolationTypePrice?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveViolationTypePrice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveViolationTypePrice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveViolationTypePrice(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LookupServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param counntryId (optional) 
     * @return Success
     */
    getAllCitiesByCountryId(counntryId: number | undefined): Observable<CityDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Lookup/GetAllCitiesByCountryId?";
        if (counntryId === null)
            throw new Error("The parameter 'counntryId' cannot be null.");
        else if (counntryId !== undefined)
            url_ += "counntryId=" + encodeURIComponent("" + counntryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCitiesByCountryId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCitiesByCountryId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CityDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CityDtoPagedResultDto>;
        }));
    }

    protected processGetAllCitiesByCountryId(response: HttpResponseBase): Observable<CityDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CityDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllCountries(sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CountryDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Lookup/GetAllCountries?";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCountries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCountries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CountryDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CountryDtoPagedResultDto>;
        }));
    }

    protected processGetAllCountries(response: HttpResponseBase): Observable<CountryDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CountryDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param cityId (optional) 
     * @return Success
     */
    getAllAreasByCityId(cityId: number | undefined): Observable<AreaDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Lookup/GetAllAreasByCityId?";
        if (cityId === null)
            throw new Error("The parameter 'cityId' cannot be null.");
        else if (cityId !== undefined)
            url_ += "cityId=" + encodeURIComponent("" + cityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAreasByCityId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAreasByCityId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AreaDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AreaDtoPagedResultDto>;
        }));
    }

    protected processGetAllAreasByCityId(response: HttpResponseBase): Observable<AreaDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AreaDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param areaId (optional) 
     * @return Success
     */
    getAllDistrictByAreaId(areaId: number | undefined): Observable<DistrictDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Lookup/GetAllDistrictByAreaId?";
        if (areaId === null)
            throw new Error("The parameter 'areaId' cannot be null.");
        else if (areaId !== undefined)
            url_ += "areaId=" + encodeURIComponent("" + areaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllDistrictByAreaId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDistrictByAreaId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DistrictDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DistrictDtoPagedResultDto>;
        }));
    }

    protected processGetAllDistrictByAreaId(response: HttpResponseBase): Observable<DistrictDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DistrictDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllCountriesForDropDownList(): Observable<CountryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Lookup/GetAllCountriesForDropDownList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCountriesForDropDownList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCountriesForDropDownList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CountryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CountryDto[]>;
        }));
    }

    protected processGetAllCountriesForDropDownList(response: HttpResponseBase): Observable<CountryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CountryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param includeInActive (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getLocations(includeInActive: boolean | undefined, keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<LocationLookupDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Lookup/GetLocations?";
        if (includeInActive === null)
            throw new Error("The parameter 'includeInActive' cannot be null.");
        else if (includeInActive !== undefined)
            url_ += "IncludeInActive=" + encodeURIComponent("" + includeInActive) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationLookupDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationLookupDtoPagedResultDto>;
        }));
    }

    protected processGetLocations(response: HttpResponseBase): Observable<LocationLookupDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocationLookupDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param locationId (optional) 
     * @param includeInActive (optional) 
     * @return Success
     */
    getAllSlotsByLocationIdId(locationId: number | undefined, includeInActive: boolean | undefined): Observable<SlotListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Lookup/GetAllSlotsByLocationIdId?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        if (includeInActive === null)
            throw new Error("The parameter 'includeInActive' cannot be null.");
        else if (includeInActive !== undefined)
            url_ += "includeInActive=" + encodeURIComponent("" + includeInActive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSlotsByLocationIdId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSlotsByLocationIdId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SlotListDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SlotListDto[]>;
        }));
    }

    protected processGetAllSlotsByLocationIdId(response: HttpResponseBase): Observable<SlotListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(SlotListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllPrices(): Observable<PriceDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Lookup/GetAllPrices";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPrices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPrices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PriceDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PriceDto[]>;
        }));
    }

    protected processGetAllPrices(response: HttpResponseBase): Observable<PriceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PriceDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getStaffAccounts(keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<StaffAccountDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Lookup/GetStaffAccounts?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStaffAccounts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStaffAccounts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StaffAccountDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StaffAccountDtoPagedResultDto>;
        }));
    }

    protected processGetStaffAccounts(response: HttpResponseBase): Observable<StaffAccountDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StaffAccountDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getViolationTypes(keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ViolationTypeLookupDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Lookup/GetViolationTypes?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetViolationTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetViolationTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ViolationTypeLookupDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ViolationTypeLookupDtoPagedResultDto>;
        }));
    }

    protected processGetViolationTypes(response: HttpResponseBase): Observable<ViolationTypeLookupDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ViolationTypeLookupDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getVehicleTypes(): Observable<VehicleTypeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Lookup/GetVehicleTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVehicleTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVehicleTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VehicleTypeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VehicleTypeDto[]>;
        }));
    }

    protected processGetVehicleTypes(response: HttpResponseBase): Observable<VehicleTypeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(VehicleTypeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllCustomerSupportStatuses(): Observable<CustomerSupportStatusDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Lookup/GetAllCustomerSupportStatuses";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCustomerSupportStatuses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCustomerSupportStatuses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerSupportStatusDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerSupportStatusDto[]>;
        }));
    }

    protected processGetAllCustomerSupportStatuses(response: HttpResponseBase): Observable<CustomerSupportStatusDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CustomerSupportStatusDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param customerId (optional) 
     * @param keyword (optional) 
     * @return Success
     */
    getVehicleLookup(customerId: string | undefined, keyword: string | undefined): Observable<VehicleLookupDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Lookup/GetVehicleLookup?";
        if (customerId === null)
            throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVehicleLookup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVehicleLookup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VehicleLookupDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VehicleLookupDto[]>;
        }));
    }

    protected processGetVehicleLookup(response: HttpResponseBase): Observable<VehicleLookupDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(VehicleLookupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param name (optional) 
     * @return Success
     */
    getCustomerLookup(name: string | undefined): Observable<CustomerLookupDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Lookup/GetCustomerLookup?";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomerLookup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomerLookup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerLookupDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerLookupDto[]>;
        }));
    }

    protected processGetCustomerLookup(response: HttpResponseBase): Observable<CustomerLookupDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CustomerLookupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LostInOutReservationTicketServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param invoiceNumber (optional) 
     * @param number (optional) 
     * @param creatorUserId (optional) 
     * @param staffAccountShiftId (optional) 
     * @param locationId (optional) 
     * @param startTime (optional) 
     * @param endTime (optional) 
     * @param carPlateLetters (optional) 
     * @param carPlateDigits (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(invoiceNumber: string | undefined, number: number | undefined, creatorUserId: number | undefined, staffAccountShiftId: string | undefined, locationId: number | undefined, startTime: moment.Moment | undefined, endTime: moment.Moment | undefined, carPlateLetters: string | undefined, carPlateDigits: number | undefined, keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<LostInOutReservationTicketListDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/LostInOutReservationTicket/GetAll?";
        if (invoiceNumber === null)
            throw new Error("The parameter 'invoiceNumber' cannot be null.");
        else if (invoiceNumber !== undefined)
            url_ += "InvoiceNumber=" + encodeURIComponent("" + invoiceNumber) + "&";
        if (number === null)
            throw new Error("The parameter 'number' cannot be null.");
        else if (number !== undefined)
            url_ += "Number=" + encodeURIComponent("" + number) + "&";
        if (creatorUserId === null)
            throw new Error("The parameter 'creatorUserId' cannot be null.");
        else if (creatorUserId !== undefined)
            url_ += "CreatorUserId=" + encodeURIComponent("" + creatorUserId) + "&";
        if (staffAccountShiftId === null)
            throw new Error("The parameter 'staffAccountShiftId' cannot be null.");
        else if (staffAccountShiftId !== undefined)
            url_ += "StaffAccountShiftId=" + encodeURIComponent("" + staffAccountShiftId) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "StartTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime === null)
            throw new Error("The parameter 'endTime' cannot be null.");
        else if (endTime !== undefined)
            url_ += "EndTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        if (carPlateLetters === null)
            throw new Error("The parameter 'carPlateLetters' cannot be null.");
        else if (carPlateLetters !== undefined)
            url_ += "CarPlateLetters=" + encodeURIComponent("" + carPlateLetters) + "&";
        if (carPlateDigits === null)
            throw new Error("The parameter 'carPlateDigits' cannot be null.");
        else if (carPlateDigits !== undefined)
            url_ += "CarPlateDigits=" + encodeURIComponent("" + carPlateDigits) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LostInOutReservationTicketListDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LostInOutReservationTicketListDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<LostInOutReservationTicketListDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LostInOutReservationTicketListDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param invoiceNumber (optional) 
     * @param number (optional) 
     * @param creatorUserId (optional) 
     * @param staffAccountShiftId (optional) 
     * @param locationId (optional) 
     * @param startTime (optional) 
     * @param endTime (optional) 
     * @param carPlateLetters (optional) 
     * @param carPlateDigits (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getByShift(invoiceNumber: string | undefined, number: number | undefined, creatorUserId: number | undefined, staffAccountShiftId: string | undefined, locationId: number | undefined, startTime: moment.Moment | undefined, endTime: moment.Moment | undefined, carPlateLetters: string | undefined, carPlateDigits: number | undefined, keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<LostInOutReservationTicketListDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/LostInOutReservationTicket/GetByShift?";
        if (invoiceNumber === null)
            throw new Error("The parameter 'invoiceNumber' cannot be null.");
        else if (invoiceNumber !== undefined)
            url_ += "InvoiceNumber=" + encodeURIComponent("" + invoiceNumber) + "&";
        if (number === null)
            throw new Error("The parameter 'number' cannot be null.");
        else if (number !== undefined)
            url_ += "Number=" + encodeURIComponent("" + number) + "&";
        if (creatorUserId === null)
            throw new Error("The parameter 'creatorUserId' cannot be null.");
        else if (creatorUserId !== undefined)
            url_ += "CreatorUserId=" + encodeURIComponent("" + creatorUserId) + "&";
        if (staffAccountShiftId === null)
            throw new Error("The parameter 'staffAccountShiftId' cannot be null.");
        else if (staffAccountShiftId !== undefined)
            url_ += "StaffAccountShiftId=" + encodeURIComponent("" + staffAccountShiftId) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "StartTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime === null)
            throw new Error("The parameter 'endTime' cannot be null.");
        else if (endTime !== undefined)
            url_ += "EndTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        if (carPlateLetters === null)
            throw new Error("The parameter 'carPlateLetters' cannot be null.");
        else if (carPlateLetters !== undefined)
            url_ += "CarPlateLetters=" + encodeURIComponent("" + carPlateLetters) + "&";
        if (carPlateDigits === null)
            throw new Error("The parameter 'carPlateDigits' cannot be null.");
        else if (carPlateDigits !== undefined)
            url_ += "CarPlateDigits=" + encodeURIComponent("" + carPlateDigits) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByShift(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByShift(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LostInOutReservationTicketListDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LostInOutReservationTicketListDtoPagedResultDto>;
        }));
    }

    protected processGetByShift(response: HttpResponseBase): Observable<LostInOutReservationTicketListDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LostInOutReservationTicketListDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    add(body: LostInOutReservationTicketCreateOrEditDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/LostInOutReservationTicket/Add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getForView(id: string | undefined): Observable<LostInOutReservationTicketViewDto> {
        let url_ = this.baseUrl + "/api/services/app/LostInOutReservationTicket/GetForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LostInOutReservationTicketViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LostInOutReservationTicketViewDto>;
        }));
    }

    protected processGetForView(response: HttpResponseBase): Observable<LostInOutReservationTicketViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LostInOutReservationTicketViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getLostTicketRecieptInfo(id: string | undefined): Observable<LostInOutReservationTicketViewDtoRecieptDto> {
        let url_ = this.baseUrl + "/api/services/app/LostInOutReservationTicket/GetLostTicketRecieptInfo?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLostTicketRecieptInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLostTicketRecieptInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LostInOutReservationTicketViewDtoRecieptDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LostInOutReservationTicketViewDtoRecieptDto>;
        }));
    }

    protected processGetLostTicketRecieptInfo(response: HttpResponseBase): Observable<LostInOutReservationTicketViewDtoRecieptDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LostInOutReservationTicketViewDtoRecieptDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param groupShiftId (optional) 
     * @return Success
     */
    getSummaryByGroupShiftId(groupShiftId: string | undefined): Observable<LostTicketReservationsSummaryDto> {
        let url_ = this.baseUrl + "/api/services/app/LostInOutReservationTicket/GetSummaryByGroupShiftId?";
        if (groupShiftId === null)
            throw new Error("The parameter 'groupShiftId' cannot be null.");
        else if (groupShiftId !== undefined)
            url_ += "groupShiftId=" + encodeURIComponent("" + groupShiftId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSummaryByGroupShiftId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSummaryByGroupShiftId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LostTicketReservationsSummaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LostTicketReservationsSummaryDto>;
        }));
    }

    protected processGetSummaryByGroupShiftId(response: HttpResponseBase): Observable<LostTicketReservationsSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LostTicketReservationsSummaryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param shiftId (optional) 
     * @return Success
     */
    getSummaryByShiftId(shiftId: string | undefined): Observable<LostTicketReservationsSummaryDto> {
        let url_ = this.baseUrl + "/api/services/app/LostInOutReservationTicket/GetSummaryByShiftId?";
        if (shiftId === null)
            throw new Error("The parameter 'shiftId' cannot be null.");
        else if (shiftId !== undefined)
            url_ += "shiftId=" + encodeURIComponent("" + shiftId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSummaryByShiftId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSummaryByShiftId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LostTicketReservationsSummaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LostTicketReservationsSummaryDto>;
        }));
    }

    protected processGetSummaryByShiftId(response: HttpResponseBase): Observable<LostTicketReservationsSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LostTicketReservationsSummaryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ManualIncomeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param paymentType (optional) 
     * @param shiftId (optional) 
     * @param invoiceNumber (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(paymentType: PaymentType | undefined, shiftId: string | undefined, invoiceNumber: string | undefined, keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ManualIncomeDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ManualIncome/GetAll?";
        if (paymentType === null)
            throw new Error("The parameter 'paymentType' cannot be null.");
        else if (paymentType !== undefined)
            url_ += "PaymentType=" + encodeURIComponent("" + paymentType) + "&";
        if (shiftId === null)
            throw new Error("The parameter 'shiftId' cannot be null.");
        else if (shiftId !== undefined)
            url_ += "ShiftId=" + encodeURIComponent("" + shiftId) + "&";
        if (invoiceNumber === null)
            throw new Error("The parameter 'invoiceNumber' cannot be null.");
        else if (invoiceNumber !== undefined)
            url_ += "InvoiceNumber=" + encodeURIComponent("" + invoiceNumber) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ManualIncomeDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ManualIncomeDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ManualIncomeDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ManualIncomeDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getManualIncomeInvoiceInfo(id: string | undefined): Observable<ManualIncomeInvoiceInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/ManualIncome/GetManualIncomeInvoiceInfo?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetManualIncomeInvoiceInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetManualIncomeInvoiceInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ManualIncomeInvoiceInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ManualIncomeInvoiceInfoDto>;
        }));
    }

    protected processGetManualIncomeInvoiceInfo(response: HttpResponseBase): Observable<ManualIncomeInvoiceInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ManualIncomeInvoiceInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createManualIncome(body: CreateManualIncomeDto | undefined): Observable<ManualIncomeDto> {
        let url_ = this.baseUrl + "/api/services/app/ManualIncome/CreateManualIncome";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateManualIncome(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateManualIncome(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ManualIncomeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ManualIncomeDto>;
        }));
    }

    protected processCreateManualIncome(response: HttpResponseBase): Observable<ManualIncomeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ManualIncomeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getForView(id: string | undefined): Observable<ManualIncomeViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ManualIncome/GetForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ManualIncomeViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ManualIncomeViewDto>;
        }));
    }

    protected processGetForView(response: HttpResponseBase): Observable<ManualIncomeViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ManualIncomeViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MetricServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param date (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getTransactions(date: moment.Moment | undefined, carPlate: string, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<MetricTransactionViewDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Metric/GetTransactions?";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "Date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        if (carPlate === undefined || carPlate === null)
            throw new Error("The parameter 'carPlate' must be defined and cannot be null.");
        else
            url_ += "CarPlate=" + encodeURIComponent("" + carPlate) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTransactions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTransactions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MetricTransactionViewDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MetricTransactionViewDto[]>;
        }));
    }

    protected processGetTransactions(response: HttpResponseBase): Observable<MetricTransactionViewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MetricTransactionViewDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param date (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getTransactions_V1(date: moment.Moment | undefined, carPlate: string, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<MetricTransactionViewDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Metric/GetTransactions_V1?";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "Date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        if (carPlate === undefined || carPlate === null)
            throw new Error("The parameter 'carPlate' must be defined and cannot be null.");
        else
            url_ += "CarPlate=" + encodeURIComponent("" + carPlate) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTransactions_V1(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTransactions_V1(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MetricTransactionViewDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MetricTransactionViewDtoPagedResultDto>;
        }));
    }

    protected processGetTransactions_V1(response: HttpResponseBase): Observable<MetricTransactionViewDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MetricTransactionViewDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param transactionId (optional) 
     * @return Success
     */
    getExternalInvoice(transactionId: string | undefined): Observable<MetricInvoiceWithTransactionDto> {
        let url_ = this.baseUrl + "/api/services/app/Metric/GetExternalInvoice?";
        if (transactionId === null)
            throw new Error("The parameter 'transactionId' cannot be null.");
        else if (transactionId !== undefined)
            url_ += "transactionId=" + encodeURIComponent("" + transactionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExternalInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExternalInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MetricInvoiceWithTransactionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MetricInvoiceWithTransactionDto>;
        }));
    }

    protected processGetExternalInvoice(response: HttpResponseBase): Observable<MetricInvoiceWithTransactionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MetricInvoiceWithTransactionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param isActive (optional) 
     * @param plateLetters (optional) 
     * @param plateDigits (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllTransactionsForMobile(fromDate: moment.Moment | undefined, toDate: moment.Moment | undefined, isActive: boolean | undefined, plateLetters: string | undefined, plateDigits: number | undefined, keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<MetricTransactionViewDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Metric/GetAllTransactionsForMobile?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (plateLetters === null)
            throw new Error("The parameter 'plateLetters' cannot be null.");
        else if (plateLetters !== undefined)
            url_ += "PlateLetters=" + encodeURIComponent("" + plateLetters) + "&";
        if (plateDigits === null)
            throw new Error("The parameter 'plateDigits' cannot be null.");
        else if (plateDigits !== undefined)
            url_ += "PlateDigits=" + encodeURIComponent("" + plateDigits) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTransactionsForMobile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTransactionsForMobile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MetricTransactionViewDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MetricTransactionViewDtoPagedResultDto>;
        }));
    }

    protected processGetAllTransactionsForMobile(response: HttpResponseBase): Observable<MetricTransactionViewDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MetricTransactionViewDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MetricAdminServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param isActive (optional) 
     * @param plateLetters (optional) 
     * @param plateDigits (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllTransactions(fromDate: moment.Moment | undefined, toDate: moment.Moment | undefined, isActive: boolean | undefined, plateLetters: string | undefined, plateDigits: number | undefined, keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<MetricTransactionViewDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/MetricAdmin/GetAllTransactions?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (plateLetters === null)
            throw new Error("The parameter 'plateLetters' cannot be null.");
        else if (plateLetters !== undefined)
            url_ += "PlateLetters=" + encodeURIComponent("" + plateLetters) + "&";
        if (plateDigits === null)
            throw new Error("The parameter 'plateDigits' cannot be null.");
        else if (plateDigits !== undefined)
            url_ += "PlateDigits=" + encodeURIComponent("" + plateDigits) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTransactions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTransactions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MetricTransactionViewDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MetricTransactionViewDtoPagedResultDto>;
        }));
    }

    protected processGetAllTransactions(response: HttpResponseBase): Observable<MetricTransactionViewDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MetricTransactionViewDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param transactionId (optional) 
     * @return Success
     */
    getTransactionForView(transactionId: string | undefined): Observable<MetricTransactionWithInvoiceViewDto> {
        let url_ = this.baseUrl + "/api/services/app/MetricAdmin/GetTransactionForView?";
        if (transactionId === null)
            throw new Error("The parameter 'transactionId' cannot be null.");
        else if (transactionId !== undefined)
            url_ += "transactionId=" + encodeURIComponent("" + transactionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTransactionForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTransactionForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MetricTransactionWithInvoiceViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MetricTransactionWithInvoiceViewDto>;
        }));
    }

    protected processGetTransactionForView(response: HttpResponseBase): Observable<MetricTransactionWithInvoiceViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MetricTransactionWithInvoiceViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    fetchRegisteredTransactions(body: FetchMetricTransactionByDatesDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MetricAdmin/FetchRegisteredTransactions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFetchRegisteredTransactions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFetchRegisteredTransactions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFetchRegisteredTransactions(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param isSuccess (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllTransactionsSyncs(fromDate: moment.Moment | undefined, toDate: moment.Moment | undefined, isSuccess: boolean | undefined, keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<MetricTransactionsSyncDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/MetricAdmin/GetAllTransactionsSyncs?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (isSuccess === null)
            throw new Error("The parameter 'isSuccess' cannot be null.");
        else if (isSuccess !== undefined)
            url_ += "IsSuccess=" + encodeURIComponent("" + isSuccess) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTransactionsSyncs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTransactionsSyncs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MetricTransactionsSyncDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MetricTransactionsSyncDtoPagedResultDto>;
        }));
    }

    protected processGetAllTransactionsSyncs(response: HttpResponseBase): Observable<MetricTransactionsSyncDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MetricTransactionsSyncDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class OperationNoteServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<OperationNoteDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/OperationNote/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationNoteDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationNoteDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<OperationNoteDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationNoteDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOperationNote(body: CreateOperationNoteDto | undefined): Observable<CreateOperationNoteDto> {
        let url_ = this.baseUrl + "/api/services/app/OperationNote/CreateOperationNote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOperationNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOperationNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOperationNoteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOperationNoteDto>;
        }));
    }

    protected processCreateOperationNote(response: HttpResponseBase): Observable<CreateOperationNoteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOperationNoteDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param violationId (optional) 
     * @return Success
     */
    getViolationOperationNotes(violationId: string | undefined): Observable<OperationNoteDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OperationNote/GetViolationOperationNotes?";
        if (violationId === null)
            throw new Error("The parameter 'violationId' cannot be null.");
        else if (violationId !== undefined)
            url_ += "violationId=" + encodeURIComponent("" + violationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetViolationOperationNotes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetViolationOperationNotes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationNoteDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationNoteDto[]>;
        }));
    }

    protected processGetViolationOperationNotes(response: HttpResponseBase): Observable<OperationNoteDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(OperationNoteDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ParkingInvoicesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param source (optional) 
     * @param category (optional) 
     * @param paymentType (optional) 
     * @param isReported (optional) 
     * @param reportingDateFrom (optional) 
     * @param reportingDateTo (optional) 
     * @param status (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(source: string | undefined, category: string | undefined, paymentType: string | undefined, isReported: boolean | undefined, reportingDateFrom: moment.Moment | undefined, reportingDateTo: moment.Moment | undefined, status: string | undefined, keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ParkingInvoiceResponsePagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ParkingInvoices/GetAll?";
        if (source === null)
            throw new Error("The parameter 'source' cannot be null.");
        else if (source !== undefined)
            url_ += "Source=" + encodeURIComponent("" + source) + "&";
        if (category === null)
            throw new Error("The parameter 'category' cannot be null.");
        else if (category !== undefined)
            url_ += "Category=" + encodeURIComponent("" + category) + "&";
        if (paymentType === null)
            throw new Error("The parameter 'paymentType' cannot be null.");
        else if (paymentType !== undefined)
            url_ += "PaymentType=" + encodeURIComponent("" + paymentType) + "&";
        if (isReported === null)
            throw new Error("The parameter 'isReported' cannot be null.");
        else if (isReported !== undefined)
            url_ += "IsReported=" + encodeURIComponent("" + isReported) + "&";
        if (reportingDateFrom === null)
            throw new Error("The parameter 'reportingDateFrom' cannot be null.");
        else if (reportingDateFrom !== undefined)
            url_ += "ReportingDateFrom=" + encodeURIComponent(reportingDateFrom ? "" + reportingDateFrom.toISOString() : "") + "&";
        if (reportingDateTo === null)
            throw new Error("The parameter 'reportingDateTo' cannot be null.");
        else if (reportingDateTo !== undefined)
            url_ += "ReportingDateTo=" + encodeURIComponent(reportingDateTo ? "" + reportingDateTo.toISOString() : "") + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParkingInvoiceResponsePagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParkingInvoiceResponsePagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ParkingInvoiceResponsePagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ParkingInvoiceResponsePagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getForView(id: string | undefined): Observable<ParkingInvoiceResponse> {
        let url_ = this.baseUrl + "/api/services/app/ParkingInvoices/GetForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParkingInvoiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParkingInvoiceResponse>;
        }));
    }

    protected processGetForView(response: HttpResponseBase): Observable<ParkingInvoiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ParkingInvoiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param source (optional) 
     * @param category (optional) 
     * @param paymentType (optional) 
     * @param isReported (optional) 
     * @param reportingDateFrom (optional) 
     * @param reportingDateTo (optional) 
     * @param status (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getForExportExcel(source: string | undefined, category: string | undefined, paymentType: string | undefined, isReported: boolean | undefined, reportingDateFrom: moment.Moment | undefined, reportingDateTo: moment.Moment | undefined, status: string | undefined, keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ParkingInvoiceExportExcelResponse[]> {
        let url_ = this.baseUrl + "/api/services/app/ParkingInvoices/GetForExportExcel?";
        if (source === null)
            throw new Error("The parameter 'source' cannot be null.");
        else if (source !== undefined)
            url_ += "Source=" + encodeURIComponent("" + source) + "&";
        if (category === null)
            throw new Error("The parameter 'category' cannot be null.");
        else if (category !== undefined)
            url_ += "Category=" + encodeURIComponent("" + category) + "&";
        if (paymentType === null)
            throw new Error("The parameter 'paymentType' cannot be null.");
        else if (paymentType !== undefined)
            url_ += "PaymentType=" + encodeURIComponent("" + paymentType) + "&";
        if (isReported === null)
            throw new Error("The parameter 'isReported' cannot be null.");
        else if (isReported !== undefined)
            url_ += "IsReported=" + encodeURIComponent("" + isReported) + "&";
        if (reportingDateFrom === null)
            throw new Error("The parameter 'reportingDateFrom' cannot be null.");
        else if (reportingDateFrom !== undefined)
            url_ += "ReportingDateFrom=" + encodeURIComponent(reportingDateFrom ? "" + reportingDateFrom.toISOString() : "") + "&";
        if (reportingDateTo === null)
            throw new Error("The parameter 'reportingDateTo' cannot be null.");
        else if (reportingDateTo !== undefined)
            url_ += "ReportingDateTo=" + encodeURIComponent(reportingDateTo ? "" + reportingDateTo.toISOString() : "") + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForExportExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForExportExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParkingInvoiceExportExcelResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParkingInvoiceExportExcelResponse[]>;
        }));
    }

    protected processGetForExportExcel(response: HttpResponseBase): Observable<ParkingInvoiceExportExcelResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ParkingInvoiceExportExcelResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateParkingInvoiceRequest | undefined): Observable<ParkingInvoiceResponse> {
        let url_ = this.baseUrl + "/api/services/app/ParkingInvoices/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParkingInvoiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParkingInvoiceResponse>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<ParkingInvoiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ParkingInvoiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    cancel(body: CancelParkingInvoiceRequest | undefined): Observable<ZatcaIntegrityLogResponse> {
        let url_ = this.baseUrl + "/api/services/app/ParkingInvoices/Cancel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ZatcaIntegrityLogResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ZatcaIntegrityLogResponse>;
        }));
    }

    protected processCancel(response: HttpResponseBase): Observable<ZatcaIntegrityLogResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ZatcaIntegrityLogResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    cancelInvoice(body: CancelParkingInvoiceRequest | undefined): Observable<ZatcaIntegrityLogResponse> {
        let url_ = this.baseUrl + "/api/services/app/ParkingInvoices/CancelInvoice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ZatcaIntegrityLogResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ZatcaIntegrityLogResponse>;
        }));
    }

    protected processCancelInvoice(response: HttpResponseBase): Observable<ZatcaIntegrityLogResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ZatcaIntegrityLogResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    report(body: ReportParkingInvoiceRequest | undefined): Observable<ZatcaIntegrityLogResponse> {
        let url_ = this.baseUrl + "/api/services/app/ParkingInvoices/Report";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ZatcaIntegrityLogResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ZatcaIntegrityLogResponse>;
        }));
    }

    protected processReport(response: HttpResponseBase): Observable<ZatcaIntegrityLogResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ZatcaIntegrityLogResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateMany(body: CreateOrUpdateManyParkingInvoicesCommand | undefined): Observable<ParkingInvoice[]> {
        let url_ = this.baseUrl + "/api/services/app/ParkingInvoices/CreateOrUpdateMany";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateMany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateMany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParkingInvoice[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParkingInvoice[]>;
        }));
    }

    protected processCreateOrUpdateMany(response: HttpResponseBase): Observable<ParkingInvoice[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ParkingInvoice.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateManyFromEasyValley(body: CreateOrUpdateManyFromEasyValley | undefined): Observable<ParkingInvoice[]> {
        let url_ = this.baseUrl + "/api/services/app/ParkingInvoices/CreateOrUpdateManyFromEasyValley";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateManyFromEasyValley(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateManyFromEasyValley(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParkingInvoice[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParkingInvoice[]>;
        }));
    }

    protected processCreateOrUpdateManyFromEasyValley(response: HttpResponseBase): Observable<ParkingInvoice[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ParkingInvoice.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateManyFromEntervo(body: CreateOrUpdateManyFromEntervo | undefined): Observable<ParkingInvoice[]> {
        let url_ = this.baseUrl + "/api/services/app/ParkingInvoices/CreateOrUpdateManyFromEntervo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateManyFromEntervo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateManyFromEntervo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParkingInvoice[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParkingInvoice[]>;
        }));
    }

    protected processCreateOrUpdateManyFromEntervo(response: HttpResponseBase): Observable<ParkingInvoice[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ParkingInvoice.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateManyFromSpaceParking(body: CreateOrUpdateManyFromSpaceParking | undefined): Observable<ParkingInvoice[]> {
        let url_ = this.baseUrl + "/api/services/app/ParkingInvoices/CreateOrUpdateManyFromSpaceParking";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateManyFromSpaceParking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateManyFromSpaceParking(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParkingInvoice[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParkingInvoice[]>;
        }));
    }

    protected processCreateOrUpdateManyFromSpaceParking(response: HttpResponseBase): Observable<ParkingInvoice[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ParkingInvoice.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    fetchInvoices(body: FetchInvoicesRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ParkingInvoices/FetchInvoices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFetchInvoices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFetchInvoices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFetchInvoices(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param accessToken (optional) 
     * @return Success
     */
    setDropBoxAccessToken(accessToken: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ParkingInvoices/SetDropBoxAccessToken?";
        if (accessToken === null)
            throw new Error("The parameter 'accessToken' cannot be null.");
        else if (accessToken !== undefined)
            url_ += "accessToken=" + encodeURIComponent("" + accessToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetDropBoxAccessToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetDropBoxAccessToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetDropBoxAccessToken(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PricingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param hourRate (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(hourRate: number | undefined, keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PriceListDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Pricing/GetAll?";
        if (hourRate === null)
            throw new Error("The parameter 'hourRate' cannot be null.");
        else if (hourRate !== undefined)
            url_ += "HourRate=" + encodeURIComponent("" + hourRate) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PriceListDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PriceListDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PriceListDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PriceListDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getPriceForEdit(id: number | undefined): Observable<CreateOrUpdatePriceDto> {
        let url_ = this.baseUrl + "/api/services/app/Pricing/GetPriceForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPriceForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPriceForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrUpdatePriceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrUpdatePriceDto>;
        }));
    }

    protected processGetPriceForEdit(response: HttpResponseBase): Observable<CreateOrUpdatePriceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrUpdatePriceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdatePrice(body: CreateOrUpdatePriceDto | undefined): Observable<CreateOrUpdatePriceDto> {
        let url_ = this.baseUrl + "/api/services/app/Pricing/CreateOrUpdatePrice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdatePrice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdatePrice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrUpdatePriceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrUpdatePriceDto>;
        }));
    }

    protected processCreateOrUpdatePrice(response: HttpResponseBase): Observable<CreateOrUpdatePriceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrUpdatePriceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class QRCodeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param locationId (optional) 
     * @param isActive (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getQRCodesByLocation(locationId: number | undefined, isActive: boolean | undefined, keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<QRCodeListDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/QRCode/GetQRCodesByLocation?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQRCodesByLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQRCodesByLocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QRCodeListDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QRCodeListDtoPagedResultDto>;
        }));
    }

    protected processGetQRCodesByLocation(response: HttpResponseBase): Observable<QRCodeListDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QRCodeListDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getQRCodeForEdit(id: number | undefined): Observable<CreateOrUpdateQRCodeDto> {
        let url_ = this.baseUrl + "/api/services/app/QRCode/GetQRCodeForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQRCodeForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQRCodeForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrUpdateQRCodeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrUpdateQRCodeDto>;
        }));
    }

    protected processGetQRCodeForEdit(response: HttpResponseBase): Observable<CreateOrUpdateQRCodeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrUpdateQRCodeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateQRCode(body: CreateOrUpdateQRCodeDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/QRCode/CreateOrUpdateQRCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateQRCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateQRCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrUpdateQRCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param qrCode (optional) 
     * @return Success
     */
    getQRCodeDetails(qrCode: string | undefined): Observable<QRCodeDetailsDto> {
        let url_ = this.baseUrl + "/api/services/app/QRCode/GetQRCodeDetails?";
        if (qrCode === null)
            throw new Error("The parameter 'qrCode' cannot be null.");
        else if (qrCode !== undefined)
            url_ += "qrCode=" + encodeURIComponent("" + qrCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQRCodeDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQRCodeDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QRCodeDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QRCodeDetailsDto>;
        }));
    }

    protected processGetQRCodeDetails(response: HttpResponseBase): Observable<QRCodeDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QRCodeDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ReservationAppServiceV2ServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    checkout(body: CreateReservationInputDto | undefined): Observable<CheckoutReservationResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/ReservationAppServiceV2/Checkout";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckout(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckout(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CheckoutReservationResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CheckoutReservationResponseDto>;
        }));
    }

    protected processCheckout(response: HttpResponseBase): Observable<CheckoutReservationResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CheckoutReservationResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    checkoutByOldReservation(body: OldReservationCheckoutDto | undefined): Observable<CheckoutReservationResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/ReservationAppServiceV2/CheckoutByOldReservation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckoutByOldReservation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckoutByOldReservation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CheckoutReservationResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CheckoutReservationResponseDto>;
        }));
    }

    protected processCheckoutByOldReservation(response: HttpResponseBase): Observable<CheckoutReservationResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CheckoutReservationResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param transactionId (optional) 
     * @param resourcePath (optional) 
     * @return Success
     */
    getPaymentStatus(transactionId: string | undefined, resourcePath: string | undefined): Observable<ReservationWithPaymentDto> {
        let url_ = this.baseUrl + "/api/services/app/ReservationAppServiceV2/GetPaymentStatus?";
        if (transactionId === null)
            throw new Error("The parameter 'transactionId' cannot be null.");
        else if (transactionId !== undefined)
            url_ += "transactionId=" + encodeURIComponent("" + transactionId) + "&";
        if (resourcePath === null)
            throw new Error("The parameter 'resourcePath' cannot be null.");
        else if (resourcePath !== undefined)
            url_ += "resourcePath=" + encodeURIComponent("" + resourcePath) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaymentStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReservationWithPaymentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReservationWithPaymentDto>;
        }));
    }

    protected processGetPaymentStatus(response: HttpResponseBase): Observable<ReservationWithPaymentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReservationWithPaymentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createCashReservation(body: CreateCashReservationInputDto | undefined): Observable<CheckoutReservationOutput> {
        let url_ = this.baseUrl + "/api/services/app/ReservationAppServiceV2/CreateCashReservation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCashReservation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCashReservation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CheckoutReservationOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CheckoutReservationOutput>;
        }));
    }

    protected processCreateCashReservation(response: HttpResponseBase): Observable<CheckoutReservationOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CheckoutReservationOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createPOSReservation(body: CreatePOSReservationInput | undefined): Observable<CheckoutReservationOutput> {
        let url_ = this.baseUrl + "/api/services/app/ReservationAppServiceV2/CreatePOSReservation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePOSReservation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePOSReservation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CheckoutReservationOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CheckoutReservationOutput>;
        }));
    }

    protected processCreatePOSReservation(response: HttpResponseBase): Observable<CheckoutReservationOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CheckoutReservationOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param slotId (optional) 
     * @param locationId (optional) 
     * @param numberHours (optional) 
     * @param paymentMethod (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param carPlateDigits (optional) 
     * @param carPlateLetters (optional) 
     * @param reservationStatus (optional) 
     * @param shiftId (optional) 
     * @param invoiceNumber (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(slotId: number | undefined, locationId: number | undefined, numberHours: number | undefined, paymentMethod: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, carPlateDigits: number | undefined, carPlateLetters: string | undefined, reservationStatus: ReservationStatus | undefined, shiftId: string | undefined, invoiceNumber: string | undefined, keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ReservationListDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ReservationAppServiceV2/GetAll?";
        if (slotId === null)
            throw new Error("The parameter 'slotId' cannot be null.");
        else if (slotId !== undefined)
            url_ += "SlotId=" + encodeURIComponent("" + slotId) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        if (numberHours === null)
            throw new Error("The parameter 'numberHours' cannot be null.");
        else if (numberHours !== undefined)
            url_ += "NumberHours=" + encodeURIComponent("" + numberHours) + "&";
        if (paymentMethod === null)
            throw new Error("The parameter 'paymentMethod' cannot be null.");
        else if (paymentMethod !== undefined)
            url_ += "PaymentMethod=" + encodeURIComponent("" + paymentMethod) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (carPlateDigits === null)
            throw new Error("The parameter 'carPlateDigits' cannot be null.");
        else if (carPlateDigits !== undefined)
            url_ += "CarPlateDigits=" + encodeURIComponent("" + carPlateDigits) + "&";
        if (carPlateLetters === null)
            throw new Error("The parameter 'carPlateLetters' cannot be null.");
        else if (carPlateLetters !== undefined)
            url_ += "CarPlateLetters=" + encodeURIComponent("" + carPlateLetters) + "&";
        if (reservationStatus === null)
            throw new Error("The parameter 'reservationStatus' cannot be null.");
        else if (reservationStatus !== undefined)
            url_ += "ReservationStatus=" + encodeURIComponent("" + reservationStatus) + "&";
        if (shiftId === null)
            throw new Error("The parameter 'shiftId' cannot be null.");
        else if (shiftId !== undefined)
            url_ += "ShiftId=" + encodeURIComponent("" + shiftId) + "&";
        if (invoiceNumber === null)
            throw new Error("The parameter 'invoiceNumber' cannot be null.");
        else if (invoiceNumber !== undefined)
            url_ += "InvoiceNumber=" + encodeURIComponent("" + invoiceNumber) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReservationListDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReservationListDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ReservationListDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReservationListDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param slotId (optional) 
     * @param locationId (optional) 
     * @param numberHours (optional) 
     * @param paymentMethod (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param carPlateDigits (optional) 
     * @param carPlateLetters (optional) 
     * @param reservationStatus (optional) 
     * @param shiftId (optional) 
     * @param invoiceNumber (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getByShift(slotId: number | undefined, locationId: number | undefined, numberHours: number | undefined, paymentMethod: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, carPlateDigits: number | undefined, carPlateLetters: string | undefined, reservationStatus: ReservationStatus | undefined, shiftId: string | undefined, invoiceNumber: string | undefined, keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ReservationListDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ReservationAppServiceV2/GetByShift?";
        if (slotId === null)
            throw new Error("The parameter 'slotId' cannot be null.");
        else if (slotId !== undefined)
            url_ += "SlotId=" + encodeURIComponent("" + slotId) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        if (numberHours === null)
            throw new Error("The parameter 'numberHours' cannot be null.");
        else if (numberHours !== undefined)
            url_ += "NumberHours=" + encodeURIComponent("" + numberHours) + "&";
        if (paymentMethod === null)
            throw new Error("The parameter 'paymentMethod' cannot be null.");
        else if (paymentMethod !== undefined)
            url_ += "PaymentMethod=" + encodeURIComponent("" + paymentMethod) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (carPlateDigits === null)
            throw new Error("The parameter 'carPlateDigits' cannot be null.");
        else if (carPlateDigits !== undefined)
            url_ += "CarPlateDigits=" + encodeURIComponent("" + carPlateDigits) + "&";
        if (carPlateLetters === null)
            throw new Error("The parameter 'carPlateLetters' cannot be null.");
        else if (carPlateLetters !== undefined)
            url_ += "CarPlateLetters=" + encodeURIComponent("" + carPlateLetters) + "&";
        if (reservationStatus === null)
            throw new Error("The parameter 'reservationStatus' cannot be null.");
        else if (reservationStatus !== undefined)
            url_ += "ReservationStatus=" + encodeURIComponent("" + reservationStatus) + "&";
        if (shiftId === null)
            throw new Error("The parameter 'shiftId' cannot be null.");
        else if (shiftId !== undefined)
            url_ += "ShiftId=" + encodeURIComponent("" + shiftId) + "&";
        if (invoiceNumber === null)
            throw new Error("The parameter 'invoiceNumber' cannot be null.");
        else if (invoiceNumber !== undefined)
            url_ += "InvoiceNumber=" + encodeURIComponent("" + invoiceNumber) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByShift(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByShift(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReservationListDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReservationListDtoPagedResultDto>;
        }));
    }

    protected processGetByShift(response: HttpResponseBase): Observable<ReservationListDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReservationListDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getForView(id: string | undefined): Observable<ReservationDto> {
        let url_ = this.baseUrl + "/api/services/app/ReservationAppServiceV2/GetForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReservationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReservationDto>;
        }));
    }

    protected processGetForView(response: HttpResponseBase): Observable<ReservationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReservationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param locationId (optional) 
     * @param qRCodeId (optional) 
     * @param shiftId (optional) 
     * @param paymentMethod (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param carPlateDigits (optional) 
     * @param carPlateLetters (optional) 
     * @param reservationStatus (optional) 
     * @param isActive (optional) 
     * @param invoiceNumber (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getReservations(locationId: number | undefined, qRCodeId: number | undefined, shiftId: string | undefined, paymentMethod: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, carPlateDigits: number | undefined, carPlateLetters: string | undefined, reservationStatus: ReservationStatus | undefined, isActive: boolean | undefined, invoiceNumber: string | undefined, keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ReservationListDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ReservationAppServiceV2/GetReservations?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        if (qRCodeId === null)
            throw new Error("The parameter 'qRCodeId' cannot be null.");
        else if (qRCodeId !== undefined)
            url_ += "QRCodeId=" + encodeURIComponent("" + qRCodeId) + "&";
        if (shiftId === null)
            throw new Error("The parameter 'shiftId' cannot be null.");
        else if (shiftId !== undefined)
            url_ += "ShiftId=" + encodeURIComponent("" + shiftId) + "&";
        if (paymentMethod === null)
            throw new Error("The parameter 'paymentMethod' cannot be null.");
        else if (paymentMethod !== undefined)
            url_ += "PaymentMethod=" + encodeURIComponent("" + paymentMethod) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (carPlateDigits === null)
            throw new Error("The parameter 'carPlateDigits' cannot be null.");
        else if (carPlateDigits !== undefined)
            url_ += "CarPlateDigits=" + encodeURIComponent("" + carPlateDigits) + "&";
        if (carPlateLetters === null)
            throw new Error("The parameter 'carPlateLetters' cannot be null.");
        else if (carPlateLetters !== undefined)
            url_ += "CarPlateLetters=" + encodeURIComponent("" + carPlateLetters) + "&";
        if (reservationStatus === null)
            throw new Error("The parameter 'reservationStatus' cannot be null.");
        else if (reservationStatus !== undefined)
            url_ += "ReservationStatus=" + encodeURIComponent("" + reservationStatus) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (invoiceNumber === null)
            throw new Error("The parameter 'invoiceNumber' cannot be null.");
        else if (invoiceNumber !== undefined)
            url_ += "InvoiceNumber=" + encodeURIComponent("" + invoiceNumber) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReservations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReservations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReservationListDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReservationListDtoPagedResultDto>;
        }));
    }

    protected processGetReservations(response: HttpResponseBase): Observable<ReservationListDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReservationListDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    renewReservationOnline(body: RenewReservationOnlineInputDTO | undefined): Observable<RenewReservationResponse> {
        let url_ = this.baseUrl + "/api/services/app/ReservationAppServiceV2/RenewReservationOnline";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRenewReservationOnline(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRenewReservationOnline(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RenewReservationResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RenewReservationResponse>;
        }));
    }

    protected processRenewReservationOnline(response: HttpResponseBase): Observable<RenewReservationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RenewReservationResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    renewReservationCash(body: RenewReservationCashInputDTO | undefined): Observable<RenewReservationResponse> {
        let url_ = this.baseUrl + "/api/services/app/ReservationAppServiceV2/RenewReservationCash";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRenewReservationCash(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRenewReservationCash(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RenewReservationResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RenewReservationResponse>;
        }));
    }

    protected processRenewReservationCash(response: HttpResponseBase): Observable<RenewReservationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RenewReservationResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    renewReservationPOS(body: RenewReservationPOSInputDTO | undefined): Observable<RenewReservationResponse> {
        let url_ = this.baseUrl + "/api/services/app/ReservationAppServiceV2/RenewReservationPOS";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRenewReservationPOS(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRenewReservationPOS(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RenewReservationResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RenewReservationResponse>;
        }));
    }

    protected processRenewReservationPOS(response: HttpResponseBase): Observable<RenewReservationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RenewReservationResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param source (optional) 
     * @param status_Code (optional) 
     * @param status_Name (optional) 
     * @param status_Id (optional) 
     * @param from (optional) 
     * @param to (optional) 
     * @param createdByUserId (optional) 
     * @param shiftId (optional) 
     * @param reservationId (optional) 
     * @param reservationDetailId (optional) 
     * @param locationId (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllTransactions(source: TransactionSource | undefined, status_Code: string | undefined, status_Name: string | undefined, status_Id: number | undefined, from: moment.Moment | undefined, to: moment.Moment | undefined, createdByUserId: number | undefined, shiftId: string | undefined, reservationId: string | undefined, reservationDetailId: string | undefined, locationId: number | undefined, keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<TransactionDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ReservationAppServiceV2/GetAllTransactions?";
        if (source === null)
            throw new Error("The parameter 'source' cannot be null.");
        else if (source !== undefined)
            url_ += "Source=" + encodeURIComponent("" + source) + "&";
        if (status_Code === null)
            throw new Error("The parameter 'status_Code' cannot be null.");
        else if (status_Code !== undefined)
            url_ += "Status.Code=" + encodeURIComponent("" + status_Code) + "&";
        if (status_Name === null)
            throw new Error("The parameter 'status_Name' cannot be null.");
        else if (status_Name !== undefined)
            url_ += "Status.Name=" + encodeURIComponent("" + status_Name) + "&";
        if (status_Id === null)
            throw new Error("The parameter 'status_Id' cannot be null.");
        else if (status_Id !== undefined)
            url_ += "Status.Id=" + encodeURIComponent("" + status_Id) + "&";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (createdByUserId === null)
            throw new Error("The parameter 'createdByUserId' cannot be null.");
        else if (createdByUserId !== undefined)
            url_ += "CreatedByUserId=" + encodeURIComponent("" + createdByUserId) + "&";
        if (shiftId === null)
            throw new Error("The parameter 'shiftId' cannot be null.");
        else if (shiftId !== undefined)
            url_ += "ShiftId=" + encodeURIComponent("" + shiftId) + "&";
        if (reservationId === null)
            throw new Error("The parameter 'reservationId' cannot be null.");
        else if (reservationId !== undefined)
            url_ += "ReservationId=" + encodeURIComponent("" + reservationId) + "&";
        if (reservationDetailId === null)
            throw new Error("The parameter 'reservationDetailId' cannot be null.");
        else if (reservationDetailId !== undefined)
            url_ += "ReservationDetailId=" + encodeURIComponent("" + reservationDetailId) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTransactions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTransactions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransactionDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransactionDtoPagedResultDto>;
        }));
    }

    protected processGetAllTransactions(response: HttpResponseBase): Observable<TransactionDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransactionDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param reservationId (optional) 
     * @return Success
     */
    getReservationForOnlineRenewal(reservationId: string | undefined): Observable<GetReservationForOnlineRenewalOutput> {
        let url_ = this.baseUrl + "/api/services/app/ReservationAppServiceV2/GetReservationForOnlineRenewal?";
        if (reservationId === null)
            throw new Error("The parameter 'reservationId' cannot be null.");
        else if (reservationId !== undefined)
            url_ += "reservationId=" + encodeURIComponent("" + reservationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReservationForOnlineRenewal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReservationForOnlineRenewal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetReservationForOnlineRenewalOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetReservationForOnlineRenewalOutput>;
        }));
    }

    protected processGetReservationForOnlineRenewal(response: HttpResponseBase): Observable<GetReservationForOnlineRenewalOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetReservationForOnlineRenewalOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param reservationNumber (optional) 
     * @return Success
     */
    getReservationForOnlineRenewalByReservationNumber(reservationNumber: number | undefined): Observable<GetReservationForOnlineRenewalOutput> {
        let url_ = this.baseUrl + "/api/services/app/ReservationAppServiceV2/GetReservationForOnlineRenewalByReservationNumber?";
        if (reservationNumber === null)
            throw new Error("The parameter 'reservationNumber' cannot be null.");
        else if (reservationNumber !== undefined)
            url_ += "reservationNumber=" + encodeURIComponent("" + reservationNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReservationForOnlineRenewalByReservationNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReservationForOnlineRenewalByReservationNumber(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetReservationForOnlineRenewalOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetReservationForOnlineRenewalOutput>;
        }));
    }

    protected processGetReservationForOnlineRenewalByReservationNumber(response: HttpResponseBase): Observable<GetReservationForOnlineRenewalOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetReservationForOnlineRenewalOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param reservationDetailId (optional) 
     * @return Success
     */
    getReservationDetailsInvoiceInfo(reservationDetailId: string | undefined): Observable<GetReservationDetailsInvoiceInfoOutput> {
        let url_ = this.baseUrl + "/api/services/app/ReservationAppServiceV2/GetReservationDetailsInvoiceInfo?";
        if (reservationDetailId === null)
            throw new Error("The parameter 'reservationDetailId' cannot be null.");
        else if (reservationDetailId !== undefined)
            url_ += "reservationDetailId=" + encodeURIComponent("" + reservationDetailId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReservationDetailsInvoiceInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReservationDetailsInvoiceInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetReservationDetailsInvoiceInfoOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetReservationDetailsInvoiceInfoOutput>;
        }));
    }

    protected processGetReservationDetailsInvoiceInfo(response: HttpResponseBase): Observable<GetReservationDetailsInvoiceInfoOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetReservationDetailsInvoiceInfoOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param groupShiftId (optional) 
     * @return Success
     */
    getOnlineReservationByGroupShiftId(groupShiftId: string | undefined): Observable<OnlineReservationDetailsCountDto> {
        let url_ = this.baseUrl + "/api/services/app/ReservationAppServiceV2/GetOnlineReservationByGroupShiftId?";
        if (groupShiftId === null)
            throw new Error("The parameter 'groupShiftId' cannot be null.");
        else if (groupShiftId !== undefined)
            url_ += "groupShiftId=" + encodeURIComponent("" + groupShiftId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOnlineReservationByGroupShiftId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOnlineReservationByGroupShiftId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnlineReservationDetailsCountDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnlineReservationDetailsCountDto>;
        }));
    }

    protected processGetOnlineReservationByGroupShiftId(response: HttpResponseBase): Observable<OnlineReservationDetailsCountDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OnlineReservationDetailsCountDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param carPlateDigits (optional) 
     * @param carPlateLetters (optional) 
     * @param numberHours (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param slotId (optional) 
     * @param locationId (optional) 
     * @param paymentType (optional) 
     * @param firstname (optional) 
     * @param lastname (optional) 
     * @param mobileNumber (optional) 
     * @param reservationStatus (optional) 
     * @param invoiceNumber (optional) 
     * @param creator (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getParentReservations(carPlateDigits: number | undefined, carPlateLetters: string | undefined, numberHours: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, slotId: number | undefined, locationId: number | undefined, paymentType: PaymentType | undefined, firstname: string | undefined, lastname: string | undefined, mobileNumber: string | undefined, reservationStatus: ReservationStatus | undefined, invoiceNumber: string | undefined, creator: string | undefined, keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ParentReservationDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ReservationAppServiceV2/GetParentReservations?";
        if (carPlateDigits === null)
            throw new Error("The parameter 'carPlateDigits' cannot be null.");
        else if (carPlateDigits !== undefined)
            url_ += "CarPlateDigits=" + encodeURIComponent("" + carPlateDigits) + "&";
        if (carPlateLetters === null)
            throw new Error("The parameter 'carPlateLetters' cannot be null.");
        else if (carPlateLetters !== undefined)
            url_ += "CarPlateLetters=" + encodeURIComponent("" + carPlateLetters) + "&";
        if (numberHours === null)
            throw new Error("The parameter 'numberHours' cannot be null.");
        else if (numberHours !== undefined)
            url_ += "NumberHours=" + encodeURIComponent("" + numberHours) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (slotId === null)
            throw new Error("The parameter 'slotId' cannot be null.");
        else if (slotId !== undefined)
            url_ += "SlotId=" + encodeURIComponent("" + slotId) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        if (paymentType === null)
            throw new Error("The parameter 'paymentType' cannot be null.");
        else if (paymentType !== undefined)
            url_ += "PaymentType=" + encodeURIComponent("" + paymentType) + "&";
        if (firstname === null)
            throw new Error("The parameter 'firstname' cannot be null.");
        else if (firstname !== undefined)
            url_ += "Firstname=" + encodeURIComponent("" + firstname) + "&";
        if (lastname === null)
            throw new Error("The parameter 'lastname' cannot be null.");
        else if (lastname !== undefined)
            url_ += "Lastname=" + encodeURIComponent("" + lastname) + "&";
        if (mobileNumber === null)
            throw new Error("The parameter 'mobileNumber' cannot be null.");
        else if (mobileNumber !== undefined)
            url_ += "MobileNumber=" + encodeURIComponent("" + mobileNumber) + "&";
        if (reservationStatus === null)
            throw new Error("The parameter 'reservationStatus' cannot be null.");
        else if (reservationStatus !== undefined)
            url_ += "ReservationStatus=" + encodeURIComponent("" + reservationStatus) + "&";
        if (invoiceNumber === null)
            throw new Error("The parameter 'invoiceNumber' cannot be null.");
        else if (invoiceNumber !== undefined)
            url_ += "InvoiceNumber=" + encodeURIComponent("" + invoiceNumber) + "&";
        if (creator === null)
            throw new Error("The parameter 'creator' cannot be null.");
        else if (creator !== undefined)
            url_ += "Creator=" + encodeURIComponent("" + creator) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParentReservations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParentReservations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParentReservationDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParentReservationDtoPagedResultDto>;
        }));
    }

    protected processGetParentReservations(response: HttpResponseBase): Observable<ParentReservationDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ParentReservationDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param reservationDetailsId (optional) 
     * @return Success
     */
    getParentReservationDetailsById(reservationDetailsId: string | undefined): Observable<ReservationDetailsView[]> {
        let url_ = this.baseUrl + "/api/services/app/ReservationAppServiceV2/GetParentReservationDetailsById?";
        if (reservationDetailsId === null)
            throw new Error("The parameter 'reservationDetailsId' cannot be null.");
        else if (reservationDetailsId !== undefined)
            url_ += "reservationDetailsId=" + encodeURIComponent("" + reservationDetailsId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParentReservationDetailsById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParentReservationDetailsById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReservationDetailsView[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReservationDetailsView[]>;
        }));
    }

    protected processGetParentReservationDetailsById(response: HttpResponseBase): Observable<ReservationDetailsView[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ReservationDetailsView.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getReservationSummary(id: string | undefined): Observable<ReservationSummaryDto> {
        let url_ = this.baseUrl + "/api/services/app/ReservationAppServiceV2/GetReservationSummary?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReservationSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReservationSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReservationSummaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReservationSummaryDto>;
        }));
    }

    protected processGetReservationSummary(response: HttpResponseBase): Observable<ReservationSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReservationSummaryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param carPlateDigits (optional) 
     * @param carPlateLetters (optional) 
     * @param numberHours (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param slotId (optional) 
     * @param locationId (optional) 
     * @param paymentType (optional) 
     * @param firstname (optional) 
     * @param lastname (optional) 
     * @param mobileNumber (optional) 
     * @param reservationStatus (optional) 
     * @param invoiceNumber (optional) 
     * @param creator (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllReservationDetails(carPlateDigits: number | undefined, carPlateLetters: string | undefined, numberHours: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, slotId: number | undefined, locationId: number | undefined, paymentType: PaymentType | undefined, firstname: string | undefined, lastname: string | undefined, mobileNumber: string | undefined, reservationStatus: ReservationStatus | undefined, invoiceNumber: string | undefined, creator: string | undefined, keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ReservationDetailsViewDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ReservationAppServiceV2/GetAllReservationDetails?";
        if (carPlateDigits === null)
            throw new Error("The parameter 'carPlateDigits' cannot be null.");
        else if (carPlateDigits !== undefined)
            url_ += "CarPlateDigits=" + encodeURIComponent("" + carPlateDigits) + "&";
        if (carPlateLetters === null)
            throw new Error("The parameter 'carPlateLetters' cannot be null.");
        else if (carPlateLetters !== undefined)
            url_ += "CarPlateLetters=" + encodeURIComponent("" + carPlateLetters) + "&";
        if (numberHours === null)
            throw new Error("The parameter 'numberHours' cannot be null.");
        else if (numberHours !== undefined)
            url_ += "NumberHours=" + encodeURIComponent("" + numberHours) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (slotId === null)
            throw new Error("The parameter 'slotId' cannot be null.");
        else if (slotId !== undefined)
            url_ += "SlotId=" + encodeURIComponent("" + slotId) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        if (paymentType === null)
            throw new Error("The parameter 'paymentType' cannot be null.");
        else if (paymentType !== undefined)
            url_ += "PaymentType=" + encodeURIComponent("" + paymentType) + "&";
        if (firstname === null)
            throw new Error("The parameter 'firstname' cannot be null.");
        else if (firstname !== undefined)
            url_ += "Firstname=" + encodeURIComponent("" + firstname) + "&";
        if (lastname === null)
            throw new Error("The parameter 'lastname' cannot be null.");
        else if (lastname !== undefined)
            url_ += "Lastname=" + encodeURIComponent("" + lastname) + "&";
        if (mobileNumber === null)
            throw new Error("The parameter 'mobileNumber' cannot be null.");
        else if (mobileNumber !== undefined)
            url_ += "MobileNumber=" + encodeURIComponent("" + mobileNumber) + "&";
        if (reservationStatus === null)
            throw new Error("The parameter 'reservationStatus' cannot be null.");
        else if (reservationStatus !== undefined)
            url_ += "ReservationStatus=" + encodeURIComponent("" + reservationStatus) + "&";
        if (invoiceNumber === null)
            throw new Error("The parameter 'invoiceNumber' cannot be null.");
        else if (invoiceNumber !== undefined)
            url_ += "InvoiceNumber=" + encodeURIComponent("" + invoiceNumber) + "&";
        if (creator === null)
            throw new Error("The parameter 'creator' cannot be null.");
        else if (creator !== undefined)
            url_ += "Creator=" + encodeURIComponent("" + creator) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllReservationDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllReservationDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReservationDetailsViewDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReservationDetailsViewDtoPagedResultDto>;
        }));
    }

    protected processGetAllReservationDetails(response: HttpResponseBase): Observable<ReservationDetailsViewDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReservationDetailsViewDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param carPlateDigits (optional) 
     * @param carPlateLetters (optional) 
     * @param numberHours (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param slotId (optional) 
     * @param locationId (optional) 
     * @param paymentType (optional) 
     * @param firstname (optional) 
     * @param lastname (optional) 
     * @param mobileNumber (optional) 
     * @param reservationStatus (optional) 
     * @param invoiceNumber (optional) 
     * @param creator (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllReservationDetails_V1(carPlateDigits: number | undefined, carPlateLetters: string | undefined, numberHours: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, slotId: number | undefined, locationId: number | undefined, paymentType: PaymentType | undefined, firstname: string | undefined, lastname: string | undefined, mobileNumber: string | undefined, reservationStatus: ReservationStatus | undefined, invoiceNumber: string | undefined, creator: string | undefined, keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ReservationDetailOutputDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ReservationAppServiceV2/GetAllReservationDetails_V1?";
        if (carPlateDigits === null)
            throw new Error("The parameter 'carPlateDigits' cannot be null.");
        else if (carPlateDigits !== undefined)
            url_ += "CarPlateDigits=" + encodeURIComponent("" + carPlateDigits) + "&";
        if (carPlateLetters === null)
            throw new Error("The parameter 'carPlateLetters' cannot be null.");
        else if (carPlateLetters !== undefined)
            url_ += "CarPlateLetters=" + encodeURIComponent("" + carPlateLetters) + "&";
        if (numberHours === null)
            throw new Error("The parameter 'numberHours' cannot be null.");
        else if (numberHours !== undefined)
            url_ += "NumberHours=" + encodeURIComponent("" + numberHours) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (slotId === null)
            throw new Error("The parameter 'slotId' cannot be null.");
        else if (slotId !== undefined)
            url_ += "SlotId=" + encodeURIComponent("" + slotId) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        if (paymentType === null)
            throw new Error("The parameter 'paymentType' cannot be null.");
        else if (paymentType !== undefined)
            url_ += "PaymentType=" + encodeURIComponent("" + paymentType) + "&";
        if (firstname === null)
            throw new Error("The parameter 'firstname' cannot be null.");
        else if (firstname !== undefined)
            url_ += "Firstname=" + encodeURIComponent("" + firstname) + "&";
        if (lastname === null)
            throw new Error("The parameter 'lastname' cannot be null.");
        else if (lastname !== undefined)
            url_ += "Lastname=" + encodeURIComponent("" + lastname) + "&";
        if (mobileNumber === null)
            throw new Error("The parameter 'mobileNumber' cannot be null.");
        else if (mobileNumber !== undefined)
            url_ += "MobileNumber=" + encodeURIComponent("" + mobileNumber) + "&";
        if (reservationStatus === null)
            throw new Error("The parameter 'reservationStatus' cannot be null.");
        else if (reservationStatus !== undefined)
            url_ += "ReservationStatus=" + encodeURIComponent("" + reservationStatus) + "&";
        if (invoiceNumber === null)
            throw new Error("The parameter 'invoiceNumber' cannot be null.");
        else if (invoiceNumber !== undefined)
            url_ += "InvoiceNumber=" + encodeURIComponent("" + invoiceNumber) + "&";
        if (creator === null)
            throw new Error("The parameter 'creator' cannot be null.");
        else if (creator !== undefined)
            url_ += "Creator=" + encodeURIComponent("" + creator) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllReservationDetails_V1(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllReservationDetails_V1(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReservationDetailOutputDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReservationDetailOutputDtoPagedResultDto>;
        }));
    }

    protected processGetAllReservationDetails_V1(response: HttpResponseBase): Observable<ReservationDetailOutputDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReservationDetailOutputDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param reservationDetailsId (optional) 
     * @return Success
     */
    getAllReservationDetailsForViewById(reservationDetailsId: string | undefined): Observable<ReservationDetailsViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ReservationAppServiceV2/GetAllReservationDetailsForViewById?";
        if (reservationDetailsId === null)
            throw new Error("The parameter 'reservationDetailsId' cannot be null.");
        else if (reservationDetailsId !== undefined)
            url_ += "ReservationDetailsId=" + encodeURIComponent("" + reservationDetailsId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllReservationDetailsForViewById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllReservationDetailsForViewById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReservationDetailsViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReservationDetailsViewDto>;
        }));
    }

    protected processGetAllReservationDetailsForViewById(response: HttpResponseBase): Observable<ReservationDetailsViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReservationDetailsViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param parentReservationId (optional) 
     * @return Success
     */
    getReservationDetailsInvoices(parentReservationId: string | undefined): Observable<ReservationDetailInvoiceDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ReservationAppServiceV2/GetReservationDetailsInvoices?";
        if (parentReservationId === null)
            throw new Error("The parameter 'parentReservationId' cannot be null.");
        else if (parentReservationId !== undefined)
            url_ += "parentReservationId=" + encodeURIComponent("" + parentReservationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReservationDetailsInvoices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReservationDetailsInvoices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReservationDetailInvoiceDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReservationDetailInvoiceDto[]>;
        }));
    }

    protected processGetReservationDetailsInvoices(response: HttpResponseBase): Observable<ReservationDetailInvoiceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ReservationDetailInvoiceDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getReservationDetailsForView(id: string | undefined): Observable<ReservationDetailDTO> {
        let url_ = this.baseUrl + "/api/services/app/ReservationAppServiceV2/GetReservationDetailsForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReservationDetailsForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReservationDetailsForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReservationDetailDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReservationDetailDTO>;
        }));
    }

    protected processGetReservationDetailsForView(response: HttpResponseBase): Observable<ReservationDetailDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReservationDetailDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    send(body: SendSMSInput | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/ReservationAppServiceV2/Send";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSend(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSend(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSend(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param reservationId (optional) 
     * @return Success
     */
    test(reservationId: string | undefined): Observable<ReservationListDto> {
        let url_ = this.baseUrl + "/api/services/app/ReservationAppServiceV2/Test?";
        if (reservationId === null)
            throw new Error("The parameter 'reservationId' cannot be null.");
        else if (reservationId !== undefined)
            url_ += "reservationId=" + encodeURIComponent("" + reservationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReservationListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReservationListDto>;
        }));
    }

    protected processTest(response: HttpResponseBase): Observable<ReservationListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReservationListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ReservationExporterServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportToFile(body: ExportReservationDto[] | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/ReservationExporter/ExportToFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportToFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportToFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processExportToFile(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class RoleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateRoleDto | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param permission (optional) 
     * @param roleType (optional) 
     * @return Success
     */
    getRoles(permission: string | undefined, roleType: RoleType | undefined): Observable<RoleListDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoles?";
        if (permission === null)
            throw new Error("The parameter 'permission' cannot be null.");
        else if (permission !== undefined)
            url_ += "Permission=" + encodeURIComponent("" + permission) + "&";
        if (roleType === null)
            throw new Error("The parameter 'roleType' cannot be null.");
        else if (roleType !== undefined)
            url_ += "RoleType=" + encodeURIComponent("" + roleType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleListDtoListResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleListDtoListResultDto>;
        }));
    }

    protected processGetRoles(response: HttpResponseBase): Observable<RoleListDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleListDtoListResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: RoleDto | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Role/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllPermissions(): Observable<PermissionDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetAllPermissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PermissionDtoListResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PermissionDtoListResultDto>;
        }));
    }

    protected processGetAllPermissions(response: HttpResponseBase): Observable<PermissionDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PermissionDtoListResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getRoleForEdit(id: number | undefined): Observable<GetRoleForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoleForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoleForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoleForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRoleForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRoleForEditOutput>;
        }));
    }

    protected processGetRoleForEdit(response: HttpResponseBase): Observable<GetRoleForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRoleForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<RoleDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<RoleDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SessionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getCurrentLoginInformations(): Observable<GetCurrentLoginInformationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Session/GetCurrentLoginInformations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentLoginInformations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentLoginInformations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCurrentLoginInformationsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCurrentLoginInformationsOutput>;
        }));
    }

    protected processGetCurrentLoginInformations(response: HttpResponseBase): Observable<GetCurrentLoginInformationsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCurrentLoginInformationsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SlotServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param locationId (optional) 
     * @param isActive (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getSlotsByLocation(locationId: number | undefined, isActive: boolean | undefined, keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<SlotListDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Slot/GetSlotsByLocation?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSlotsByLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSlotsByLocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SlotListDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SlotListDtoPagedResultDto>;
        }));
    }

    protected processGetSlotsByLocation(response: HttpResponseBase): Observable<SlotListDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SlotListDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    generateSlots(body: GenerateSlotsInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Slot/GenerateSlots";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateSlots(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateSlots(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGenerateSlots(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param locationId (optional) 
     * @param slotId (optional) 
     * @return Success
     */
    removeSlot(locationId: number | undefined, slotId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Slot/RemoveSlot?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        if (slotId === null)
            throw new Error("The parameter 'slotId' cannot be null.");
        else if (slotId !== undefined)
            url_ += "slotId=" + encodeURIComponent("" + slotId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveSlot(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveSlot(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveSlot(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param locationId (optional) 
     * @param slotId (optional) 
     * @param isActive (optional) 
     * @return Success
     */
    activateOrDeactivateSlot(locationId: number | undefined, slotId: number | undefined, isActive: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Slot/ActivateOrDeactivateSlot?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        if (slotId === null)
            throw new Error("The parameter 'slotId' cannot be null.");
        else if (slotId !== undefined)
            url_ += "slotId=" + encodeURIComponent("" + slotId) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "isActive=" + encodeURIComponent("" + isActive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivateOrDeactivateSlot(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivateOrDeactivateSlot(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processActivateOrDeactivateSlot(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param locationId (optional) 
     * @param isActive (optional) 
     * @return Success
     */
    activateOrDeactivateAll(locationId: number | undefined, isActive: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Slot/ActivateOrDeactivateAll?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "isActive=" + encodeURIComponent("" + isActive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivateOrDeactivateAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivateOrDeactivateAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processActivateOrDeactivateAll(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class StaffAccountServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param isActive (optional) 
     * @param roleTypes (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, isActive: boolean | undefined, roleTypes: RoleType[] | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<StaffAccountDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/StaffAccount/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (roleTypes === null)
            throw new Error("The parameter 'roleTypes' cannot be null.");
        else if (roleTypes !== undefined)
            roleTypes && roleTypes.forEach(item => { url_ += "RoleTypes=" + encodeURIComponent("" + item) + "&"; });
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StaffAccountDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StaffAccountDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<StaffAccountDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StaffAccountDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateStaffAccountDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StaffAccount/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: StaffAccountEditDto | undefined): Observable<StaffAccountEditDto> {
        let url_ = this.baseUrl + "/api/services/app/StaffAccount/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StaffAccountEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StaffAccountEditDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<StaffAccountEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StaffAccountEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: number | undefined): Observable<StaffAccountEditDto> {
        let url_ = this.baseUrl + "/api/services/app/StaffAccount/GetForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StaffAccountEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StaffAccountEditDto>;
        }));
    }

    protected processGetForEdit(response: HttpResponseBase): Observable<StaffAccountEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StaffAccountEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StaffAccount/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param roleTypes (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getRoles(roleTypes: RoleType[] | undefined, keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<RoleDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/StaffAccount/GetRoles?";
        if (roleTypes === null)
            throw new Error("The parameter 'roleTypes' cannot be null.");
        else if (roleTypes !== undefined)
            roleTypes && roleTypes.forEach(item => { url_ += "RoleTypes=" + encodeURIComponent("" + item) + "&"; });
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDtoListResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDtoListResultDto>;
        }));
    }

    protected processGetRoles(response: HttpResponseBase): Observable<RoleDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDtoListResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class StaffAccountShiftServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param isActive (optional) 
     * @param userId (optional) 
     * @param startTime (optional) 
     * @param endTime (optional) 
     * @param shiftNumber (optional) 
     * @param groupShiftId (optional) 
     * @param staffGroupShiftNumber (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(isActive: boolean | undefined, userId: number | undefined, startTime: moment.Moment | undefined, endTime: moment.Moment | undefined, shiftNumber: number | undefined, groupShiftId: string | undefined, staffGroupShiftNumber: number | undefined, keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<StaffAccountShiftDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/StaffAccountShift/GetAll?";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "StartTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime === null)
            throw new Error("The parameter 'endTime' cannot be null.");
        else if (endTime !== undefined)
            url_ += "EndTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        if (shiftNumber === null)
            throw new Error("The parameter 'shiftNumber' cannot be null.");
        else if (shiftNumber !== undefined)
            url_ += "ShiftNumber=" + encodeURIComponent("" + shiftNumber) + "&";
        if (groupShiftId === null)
            throw new Error("The parameter 'groupShiftId' cannot be null.");
        else if (groupShiftId !== undefined)
            url_ += "GroupShiftId=" + encodeURIComponent("" + groupShiftId) + "&";
        if (staffGroupShiftNumber === null)
            throw new Error("The parameter 'staffGroupShiftNumber' cannot be null.");
        else if (staffGroupShiftNumber !== undefined)
            url_ += "StaffGroupShiftNumber=" + encodeURIComponent("" + staffGroupShiftNumber) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StaffAccountShiftDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StaffAccountShiftDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<StaffAccountShiftDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StaffAccountShiftDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param isActive (optional) 
     * @param userId (optional) 
     * @param startTime (optional) 
     * @param endTime (optional) 
     * @param shiftNumber (optional) 
     * @param groupShiftId (optional) 
     * @param staffGroupShiftNumber (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getByGroupShift(isActive: boolean | undefined, userId: number | undefined, startTime: moment.Moment | undefined, endTime: moment.Moment | undefined, shiftNumber: number | undefined, groupShiftId: string | undefined, staffGroupShiftNumber: number | undefined, keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<StaffAccountShiftDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/StaffAccountShift/GetByGroupShift?";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "StartTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime === null)
            throw new Error("The parameter 'endTime' cannot be null.");
        else if (endTime !== undefined)
            url_ += "EndTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        if (shiftNumber === null)
            throw new Error("The parameter 'shiftNumber' cannot be null.");
        else if (shiftNumber !== undefined)
            url_ += "ShiftNumber=" + encodeURIComponent("" + shiftNumber) + "&";
        if (groupShiftId === null)
            throw new Error("The parameter 'groupShiftId' cannot be null.");
        else if (groupShiftId !== undefined)
            url_ += "GroupShiftId=" + encodeURIComponent("" + groupShiftId) + "&";
        if (staffGroupShiftNumber === null)
            throw new Error("The parameter 'staffGroupShiftNumber' cannot be null.");
        else if (staffGroupShiftNumber !== undefined)
            url_ += "StaffGroupShiftNumber=" + encodeURIComponent("" + staffGroupShiftNumber) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByGroupShift(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByGroupShift(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StaffAccountShiftDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StaffAccountShiftDtoPagedResultDto>;
        }));
    }

    protected processGetByGroupShift(response: HttpResponseBase): Observable<StaffAccountShiftDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StaffAccountShiftDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    currentShift(): Observable<StaffAccountShiftDto> {
        let url_ = this.baseUrl + "/api/services/app/StaffAccountShift/CurrentShift";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCurrentShift(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCurrentShift(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StaffAccountShiftDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StaffAccountShiftDto>;
        }));
    }

    protected processCurrentShift(response: HttpResponseBase): Observable<StaffAccountShiftDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StaffAccountShiftDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    startShift(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/StaffAccountShift/StartShift";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStartShift(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStartShift(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processStartShift(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    endShift(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/StaffAccountShift/EndShift";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEndShift(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEndShift(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processEndShift(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getMyShifts(keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<StaffAccountShiftDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/StaffAccountShift/GetMyShifts?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyShifts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyShifts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StaffAccountShiftDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StaffAccountShiftDtoPagedResultDto>;
        }));
    }

    protected processGetMyShifts(response: HttpResponseBase): Observable<StaffAccountShiftDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StaffAccountShiftDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param shiftId (optional) 
     * @return Success
     */
    getShiftDetails(shiftId: string | undefined): Observable<ShiftDetailsDto> {
        let url_ = this.baseUrl + "/api/services/app/StaffAccountShift/GetShiftDetails?";
        if (shiftId === null)
            throw new Error("The parameter 'shiftId' cannot be null.");
        else if (shiftId !== undefined)
            url_ += "shiftId=" + encodeURIComponent("" + shiftId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShiftDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShiftDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShiftDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShiftDetailsDto>;
        }));
    }

    protected processGetShiftDetails(response: HttpResponseBase): Observable<ShiftDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShiftDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param shiftId (optional) 
     * @return Success
     */
    getShiftSummary(shiftId: string | undefined): Observable<ShiftSummaryDto> {
        let url_ = this.baseUrl + "/api/services/app/StaffAccountShift/GetShiftSummary?";
        if (shiftId === null)
            throw new Error("The parameter 'shiftId' cannot be null.");
        else if (shiftId !== undefined)
            url_ += "shiftId=" + encodeURIComponent("" + shiftId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShiftSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShiftSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShiftSummaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShiftSummaryDto>;
        }));
    }

    protected processGetShiftSummary(response: HttpResponseBase): Observable<ShiftSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShiftSummaryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param groupShiftId (optional) 
     * @return Success
     */
    getStaffAccountShiftsForGroupShift(groupShiftId: string | undefined): Observable<ShiftDetailsDto[]> {
        let url_ = this.baseUrl + "/api/services/app/StaffAccountShift/GetStaffAccountShiftsForGroupShift?";
        if (groupShiftId === null)
            throw new Error("The parameter 'groupShiftId' cannot be null.");
        else if (groupShiftId !== undefined)
            url_ += "groupShiftId=" + encodeURIComponent("" + groupShiftId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStaffAccountShiftsForGroupShift(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStaffAccountShiftsForGroupShift(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShiftDetailsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShiftDetailsDto[]>;
        }));
    }

    protected processGetStaffAccountShiftsForGroupShift(response: HttpResponseBase): Observable<ShiftDetailsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ShiftDetailsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class StaffGroupServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param locationId (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(locationId: number | undefined, keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<StaffGroupListItemDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/StaffGroup/GetAll?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StaffGroupListItemDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StaffGroupListItemDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<StaffGroupListItemDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StaffGroupListItemDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateStaffGroupDto | undefined): Observable<StaffGroupsDto> {
        let url_ = this.baseUrl + "/api/services/app/StaffGroup/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StaffGroupsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StaffGroupsDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<StaffGroupsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StaffGroupsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateStaffGroupDto | undefined): Observable<StaffGroupsDto> {
        let url_ = this.baseUrl + "/api/services/app/StaffGroup/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StaffGroupsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StaffGroupsDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<StaffGroupsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StaffGroupsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StaffGroup/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addLocationStaffGroup(body: CreateLocationStaffGroupInput | undefined): Observable<LocationStaffGroupDto[]> {
        let url_ = this.baseUrl + "/api/services/app/StaffGroup/AddLocationStaffGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddLocationStaffGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddLocationStaffGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationStaffGroupDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationStaffGroupDto[]>;
        }));
    }

    protected processAddLocationStaffGroup(response: HttpResponseBase): Observable<LocationStaffGroupDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(LocationStaffGroupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param locationId (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getStaffAdminAccountsForGroup(locationId: number | undefined, keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<StaffAccountDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/StaffGroup/GetStaffAdminAccountsForGroup?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStaffAdminAccountsForGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStaffAdminAccountsForGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StaffAccountDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StaffAccountDtoPagedResultDto>;
        }));
    }

    protected processGetStaffAdminAccountsForGroup(response: HttpResponseBase): Observable<StaffAccountDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StaffAccountDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param locationId (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getStaffMemberAccountsForGroup(locationId: number | undefined, keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<StaffAccountDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/StaffGroup/GetStaffMemberAccountsForGroup?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStaffMemberAccountsForGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStaffMemberAccountsForGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StaffAccountDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StaffAccountDtoPagedResultDto>;
        }));
    }

    protected processGetStaffMemberAccountsForGroup(response: HttpResponseBase): Observable<StaffAccountDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StaffAccountDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param groupId (optional) 
     * @return Success
     */
    getGroupDetails(groupId: string | undefined): Observable<GetStaffAccountGroupDetailsDto> {
        let url_ = this.baseUrl + "/api/services/app/StaffGroup/GetGroupDetails?";
        if (groupId === null)
            throw new Error("The parameter 'groupId' cannot be null.");
        else if (groupId !== undefined)
            url_ += "GroupId=" + encodeURIComponent("" + groupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGroupDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGroupDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetStaffAccountGroupDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetStaffAccountGroupDetailsDto>;
        }));
    }

    protected processGetGroupDetails(response: HttpResponseBase): Observable<GetStaffAccountGroupDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetStaffAccountGroupDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param staffAccountId (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getStaffAccountGroupDetails(staffAccountId: number | undefined, keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<GetStaffAccountGroupDetailsDto> {
        let url_ = this.baseUrl + "/api/services/app/StaffGroup/GetStaffAccountGroupDetails?";
        if (staffAccountId === null)
            throw new Error("The parameter 'staffAccountId' cannot be null.");
        else if (staffAccountId !== undefined)
            url_ += "StaffAccountId=" + encodeURIComponent("" + staffAccountId) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStaffAccountGroupDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStaffAccountGroupDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetStaffAccountGroupDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetStaffAccountGroupDetailsDto>;
        }));
    }

    protected processGetStaffAccountGroupDetails(response: HttpResponseBase): Observable<GetStaffAccountGroupDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetStaffAccountGroupDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param staffGroupId (optional) 
     * @param staffAccountId (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getStaffAccountLocations(staffGroupId: string | undefined, staffAccountId: number | undefined, keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<LocationStaffGroupDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/StaffGroup/GetStaffAccountLocations?";
        if (staffGroupId === null)
            throw new Error("The parameter 'staffGroupId' cannot be null.");
        else if (staffGroupId !== undefined)
            url_ += "StaffGroupId=" + encodeURIComponent("" + staffGroupId) + "&";
        if (staffAccountId === null)
            throw new Error("The parameter 'staffAccountId' cannot be null.");
        else if (staffAccountId !== undefined)
            url_ += "StaffAccountId=" + encodeURIComponent("" + staffAccountId) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStaffAccountLocations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStaffAccountLocations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationStaffGroupDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationStaffGroupDtoPagedResultDto>;
        }));
    }

    protected processGetStaffAccountLocations(response: HttpResponseBase): Observable<LocationStaffGroupDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocationStaffGroupDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getStaffAccountLocationsById(keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<LocationDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/StaffGroup/GetStaffAccountLocationsById?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStaffAccountLocationsById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStaffAccountLocationsById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationDtoPagedResultDto>;
        }));
    }

    protected processGetStaffAccountLocationsById(response: HttpResponseBase): Observable<LocationDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocationDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param groupId (optional) 
     * @param locationId (optional) 
     * @return Success
     */
    removeGroupFromLocation(groupId: string | undefined, locationId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StaffGroup/RemoveGroupFromLocation?";
        if (groupId === null)
            throw new Error("The parameter 'groupId' cannot be null.");
        else if (groupId !== undefined)
            url_ += "GroupId=" + encodeURIComponent("" + groupId) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveGroupFromLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveGroupFromLocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveGroupFromLocation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getStaffAccountAdminGroup(): Observable<GetStaffAccountGroupDetailsDto> {
        let url_ = this.baseUrl + "/api/services/app/StaffGroup/GetStaffAccountAdminGroup";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStaffAccountAdminGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStaffAccountAdminGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetStaffAccountGroupDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetStaffAccountGroupDetailsDto>;
        }));
    }

    protected processGetStaffAccountAdminGroup(response: HttpResponseBase): Observable<GetStaffAccountGroupDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetStaffAccountGroupDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class StaffGroupShiftServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getCurrentGroupShift(): Observable<StaffGroupShiftDto> {
        let url_ = this.baseUrl + "/api/services/app/StaffGroupShift/GetCurrentGroupShift";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentGroupShift(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentGroupShift(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StaffGroupShiftDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StaffGroupShiftDto>;
        }));
    }

    protected processGetCurrentGroupShift(response: HttpResponseBase): Observable<StaffGroupShiftDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StaffGroupShiftDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    startGroupShift(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/StaffGroupShift/StartGroupShift";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStartGroupShift(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStartGroupShift(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processStartGroupShift(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    endGroupShift(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/StaffGroupShift/EndGroupShift";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEndGroupShift(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEndGroupShift(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processEndGroupShift(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param groupId (optional) 
     * @param startStaffAccountId (optional) 
     * @param endStaffAccountId (optional) 
     * @param startTime (optional) 
     * @param endTime (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(groupId: string | undefined, startStaffAccountId: number | undefined, endStaffAccountId: number | undefined, startTime: moment.Moment | undefined, endTime: moment.Moment | undefined, keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<GroupShiftDetailsDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/StaffGroupShift/GetAll?";
        if (groupId === null)
            throw new Error("The parameter 'groupId' cannot be null.");
        else if (groupId !== undefined)
            url_ += "GroupId=" + encodeURIComponent("" + groupId) + "&";
        if (startStaffAccountId === null)
            throw new Error("The parameter 'startStaffAccountId' cannot be null.");
        else if (startStaffAccountId !== undefined)
            url_ += "StartStaffAccountId=" + encodeURIComponent("" + startStaffAccountId) + "&";
        if (endStaffAccountId === null)
            throw new Error("The parameter 'endStaffAccountId' cannot be null.");
        else if (endStaffAccountId !== undefined)
            url_ += "EndStaffAccountId=" + encodeURIComponent("" + endStaffAccountId) + "&";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "StartTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime === null)
            throw new Error("The parameter 'endTime' cannot be null.");
        else if (endTime !== undefined)
            url_ += "EndTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GroupShiftDetailsDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GroupShiftDetailsDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<GroupShiftDetailsDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GroupShiftDetailsDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getMyGroupShifts(keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<GroupShiftDetailsDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/StaffGroupShift/GetMyGroupShifts?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyGroupShifts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyGroupShifts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GroupShiftDetailsDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GroupShiftDetailsDtoPagedResultDto>;
        }));
    }

    protected processGetMyGroupShifts(response: HttpResponseBase): Observable<GroupShiftDetailsDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GroupShiftDetailsDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param groupShiftId (optional) 
     * @return Success
     */
    getGroupShiftDetails(groupShiftId: string | undefined): Observable<GroupShiftDetailsDto> {
        let url_ = this.baseUrl + "/api/services/app/StaffGroupShift/GetGroupShiftDetails?";
        if (groupShiftId === null)
            throw new Error("The parameter 'groupShiftId' cannot be null.");
        else if (groupShiftId !== undefined)
            url_ += "groupShiftId=" + encodeURIComponent("" + groupShiftId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGroupShiftDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGroupShiftDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GroupShiftDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GroupShiftDetailsDto>;
        }));
    }

    protected processGetGroupShiftDetails(response: HttpResponseBase): Observable<GroupShiftDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GroupShiftDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param groupShiftId (optional) 
     * @return Success
     */
    getGroupShiftSummary(groupShiftId: string | undefined): Observable<GroupShiftSummaryDto> {
        let url_ = this.baseUrl + "/api/services/app/StaffGroupShift/GetGroupShiftSummary?";
        if (groupShiftId === null)
            throw new Error("The parameter 'groupShiftId' cannot be null.");
        else if (groupShiftId !== undefined)
            url_ += "groupShiftId=" + encodeURIComponent("" + groupShiftId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGroupShiftSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGroupShiftSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GroupShiftSummaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GroupShiftSummaryDto>;
        }));
    }

    protected processGetGroupShiftSummary(response: HttpResponseBase): Observable<GroupShiftSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GroupShiftSummaryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class StatisticsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param digits (optional) 
     * @param letters (optional) 
     * @return Success
     */
    getVehicleCounts(digits: number | undefined, letters: string | undefined): Observable<GetVehicleCountsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Statistics/GetVehicleCounts?";
        if (digits === null)
            throw new Error("The parameter 'digits' cannot be null.");
        else if (digits !== undefined)
            url_ += "Digits=" + encodeURIComponent("" + digits) + "&";
        if (letters === null)
            throw new Error("The parameter 'letters' cannot be null.");
        else if (letters !== undefined)
            url_ += "Letters=" + encodeURIComponent("" + letters) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVehicleCounts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVehicleCounts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetVehicleCountsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetVehicleCountsOutput>;
        }));
    }

    protected processGetVehicleCounts(response: HttpResponseBase): Observable<GetVehicleCountsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetVehicleCountsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getInvoicesStatisticsReport(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined): Observable<InvoicesStatisticsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Statistics/GetInvoicesStatisticsReport?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvoicesStatisticsReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvoicesStatisticsReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvoicesStatisticsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvoicesStatisticsOutput>;
        }));
    }

    protected processGetInvoicesStatisticsReport(response: HttpResponseBase): Observable<InvoicesStatisticsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoicesStatisticsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SubscriptionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setConfigurationValues(body: SetSubscriptionConfigurationInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Subscription/SetConfigurationValues";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetConfigurationValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetConfigurationValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetConfigurationValues(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getConfigurationValues(): Observable<SubscriptionConfigurationOutput> {
        let url_ = this.baseUrl + "/api/services/app/Subscription/GetConfigurationValues";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConfigurationValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConfigurationValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubscriptionConfigurationOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubscriptionConfigurationOutput>;
        }));
    }

    protected processGetConfigurationValues(response: HttpResponseBase): Observable<SubscriptionConfigurationOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubscriptionConfigurationOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getSubscriptionTypesInfo(): Observable<SubscriptionTypesInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Subscription/GetSubscriptionTypesInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSubscriptionTypesInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubscriptionTypesInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubscriptionTypesInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubscriptionTypesInfoDto[]>;
        }));
    }

    protected processGetSubscriptionTypesInfo(response: HttpResponseBase): Observable<SubscriptionTypesInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(SubscriptionTypesInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateSubscriptionInput | undefined): Observable<CreateSubscriptionOutput> {
        let url_ = this.baseUrl + "/api/services/app/Subscription/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateSubscriptionOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateSubscriptionOutput>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CreateSubscriptionOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateSubscriptionOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    editVehicles(body: EditSubscriptionVehiclesInput | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Subscription/EditVehicles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditVehicles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditVehicles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processEditVehicles(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    cancel(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Subscription/Cancel?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCancel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<GetSubscriptionByIdOutput> {
        let url_ = this.baseUrl + "/api/services/app/Subscription/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSubscriptionByIdOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSubscriptionByIdOutput>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetSubscriptionByIdOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSubscriptionByIdOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSubscriptionInvoiceInfo(id: string | undefined): Observable<GetSubscriptionInvoiceInfoOutput> {
        let url_ = this.baseUrl + "/api/services/app/Subscription/GetSubscriptionInvoiceInfo?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSubscriptionInvoiceInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubscriptionInvoiceInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSubscriptionInvoiceInfoOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSubscriptionInvoiceInfoOutput>;
        }));
    }

    protected processGetSubscriptionInvoiceInfo(response: HttpResponseBase): Observable<GetSubscriptionInvoiceInfoOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSubscriptionInvoiceInfoOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getByVehicleId(id: string | undefined): Observable<SubscriptionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Subscription/GetByVehicleId?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByVehicleId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByVehicleId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubscriptionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubscriptionDto[]>;
        }));
    }

    protected processGetByVehicleId(response: HttpResponseBase): Observable<SubscriptionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(SubscriptionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param subscriberType (optional) 
     * @param subscriptionType (optional) 
     * @param creationDateFrom (optional) 
     * @param creationDateTo (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param carPlateLetters (optional) 
     * @param carPlateDigits (optional) 
     * @param companyId (optional) 
     * @param creatorId (optional) 
     * @param paymentType (optional) 
     * @param paymentIdentifier (optional) 
     * @param locationId (optional) 
     * @param shiftId (optional) 
     * @param subscriptionPackageId (optional) 
     * @param invoiceNumber (optional) 
     * @param statuses (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getByCarPlate(subscriberType: SubscriberType | undefined, subscriptionType: SubscriptionType | undefined, creationDateFrom: moment.Moment | undefined, creationDateTo: moment.Moment | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, carPlateLetters: string | undefined, carPlateDigits: number | undefined, companyId: string | undefined, creatorId: number | undefined, paymentType: PaymentType | undefined, paymentIdentifier: string | undefined, locationId: number | undefined, shiftId: string | undefined, subscriptionPackageId: string | undefined, invoiceNumber: string | undefined, statuses: string[] | undefined, keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<GetByCarPlateOutputPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Subscription/GetByCarPlate?";
        if (subscriberType === null)
            throw new Error("The parameter 'subscriberType' cannot be null.");
        else if (subscriberType !== undefined)
            url_ += "SubscriberType=" + encodeURIComponent("" + subscriberType) + "&";
        if (subscriptionType === null)
            throw new Error("The parameter 'subscriptionType' cannot be null.");
        else if (subscriptionType !== undefined)
            url_ += "SubscriptionType=" + encodeURIComponent("" + subscriptionType) + "&";
        if (creationDateFrom === null)
            throw new Error("The parameter 'creationDateFrom' cannot be null.");
        else if (creationDateFrom !== undefined)
            url_ += "CreationDateFrom=" + encodeURIComponent(creationDateFrom ? "" + creationDateFrom.toISOString() : "") + "&";
        if (creationDateTo === null)
            throw new Error("The parameter 'creationDateTo' cannot be null.");
        else if (creationDateTo !== undefined)
            url_ += "CreationDateTo=" + encodeURIComponent(creationDateTo ? "" + creationDateTo.toISOString() : "") + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (carPlateLetters === null)
            throw new Error("The parameter 'carPlateLetters' cannot be null.");
        else if (carPlateLetters !== undefined)
            url_ += "CarPlateLetters=" + encodeURIComponent("" + carPlateLetters) + "&";
        if (carPlateDigits === null)
            throw new Error("The parameter 'carPlateDigits' cannot be null.");
        else if (carPlateDigits !== undefined)
            url_ += "CarPlateDigits=" + encodeURIComponent("" + carPlateDigits) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (creatorId === null)
            throw new Error("The parameter 'creatorId' cannot be null.");
        else if (creatorId !== undefined)
            url_ += "CreatorId=" + encodeURIComponent("" + creatorId) + "&";
        if (paymentType === null)
            throw new Error("The parameter 'paymentType' cannot be null.");
        else if (paymentType !== undefined)
            url_ += "PaymentType=" + encodeURIComponent("" + paymentType) + "&";
        if (paymentIdentifier === null)
            throw new Error("The parameter 'paymentIdentifier' cannot be null.");
        else if (paymentIdentifier !== undefined)
            url_ += "PaymentIdentifier=" + encodeURIComponent("" + paymentIdentifier) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        if (shiftId === null)
            throw new Error("The parameter 'shiftId' cannot be null.");
        else if (shiftId !== undefined)
            url_ += "ShiftId=" + encodeURIComponent("" + shiftId) + "&";
        if (subscriptionPackageId === null)
            throw new Error("The parameter 'subscriptionPackageId' cannot be null.");
        else if (subscriptionPackageId !== undefined)
            url_ += "SubscriptionPackageId=" + encodeURIComponent("" + subscriptionPackageId) + "&";
        if (invoiceNumber === null)
            throw new Error("The parameter 'invoiceNumber' cannot be null.");
        else if (invoiceNumber !== undefined)
            url_ += "InvoiceNumber=" + encodeURIComponent("" + invoiceNumber) + "&";
        if (statuses === null)
            throw new Error("The parameter 'statuses' cannot be null.");
        else if (statuses !== undefined)
            statuses && statuses.forEach(item => { url_ += "Statuses=" + encodeURIComponent("" + item) + "&"; });
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByCarPlate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByCarPlate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetByCarPlateOutputPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetByCarPlateOutputPagedResultDto>;
        }));
    }

    protected processGetByCarPlate(response: HttpResponseBase): Observable<GetByCarPlateOutputPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetByCarPlateOutputPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param qrCode (optional) 
     * @return Success
     */
    getByQRCode(qrCode: string | undefined): Observable<GetByQRCodeOutput[]> {
        let url_ = this.baseUrl + "/api/services/app/Subscription/GetByQRCode?";
        if (qrCode === null)
            throw new Error("The parameter 'qrCode' cannot be null.");
        else if (qrCode !== undefined)
            url_ += "qrCode=" + encodeURIComponent("" + qrCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByQRCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByQRCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetByQRCodeOutput[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetByQRCodeOutput[]>;
        }));
    }

    protected processGetByQRCode(response: HttpResponseBase): Observable<GetByQRCodeOutput[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(GetByQRCodeOutput.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param subscriberType (optional) 
     * @param subscriptionType (optional) 
     * @param creationDateFrom (optional) 
     * @param creationDateTo (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param carPlateLetters (optional) 
     * @param carPlateDigits (optional) 
     * @param companyId (optional) 
     * @param creatorId (optional) 
     * @param paymentType (optional) 
     * @param paymentIdentifier (optional) 
     * @param locationId (optional) 
     * @param shiftId (optional) 
     * @param subscriptionPackageId (optional) 
     * @param invoiceNumber (optional) 
     * @param statuses (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(subscriberType: SubscriberType | undefined, subscriptionType: SubscriptionType | undefined, creationDateFrom: moment.Moment | undefined, creationDateTo: moment.Moment | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, carPlateLetters: string | undefined, carPlateDigits: number | undefined, companyId: string | undefined, creatorId: number | undefined, paymentType: PaymentType | undefined, paymentIdentifier: string | undefined, locationId: number | undefined, shiftId: string | undefined, subscriptionPackageId: string | undefined, invoiceNumber: string | undefined, statuses: string[] | undefined, keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<SubscriptionListItemDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Subscription/GetAll?";
        if (subscriberType === null)
            throw new Error("The parameter 'subscriberType' cannot be null.");
        else if (subscriberType !== undefined)
            url_ += "SubscriberType=" + encodeURIComponent("" + subscriberType) + "&";
        if (subscriptionType === null)
            throw new Error("The parameter 'subscriptionType' cannot be null.");
        else if (subscriptionType !== undefined)
            url_ += "SubscriptionType=" + encodeURIComponent("" + subscriptionType) + "&";
        if (creationDateFrom === null)
            throw new Error("The parameter 'creationDateFrom' cannot be null.");
        else if (creationDateFrom !== undefined)
            url_ += "CreationDateFrom=" + encodeURIComponent(creationDateFrom ? "" + creationDateFrom.toISOString() : "") + "&";
        if (creationDateTo === null)
            throw new Error("The parameter 'creationDateTo' cannot be null.");
        else if (creationDateTo !== undefined)
            url_ += "CreationDateTo=" + encodeURIComponent(creationDateTo ? "" + creationDateTo.toISOString() : "") + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (carPlateLetters === null)
            throw new Error("The parameter 'carPlateLetters' cannot be null.");
        else if (carPlateLetters !== undefined)
            url_ += "CarPlateLetters=" + encodeURIComponent("" + carPlateLetters) + "&";
        if (carPlateDigits === null)
            throw new Error("The parameter 'carPlateDigits' cannot be null.");
        else if (carPlateDigits !== undefined)
            url_ += "CarPlateDigits=" + encodeURIComponent("" + carPlateDigits) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (creatorId === null)
            throw new Error("The parameter 'creatorId' cannot be null.");
        else if (creatorId !== undefined)
            url_ += "CreatorId=" + encodeURIComponent("" + creatorId) + "&";
        if (paymentType === null)
            throw new Error("The parameter 'paymentType' cannot be null.");
        else if (paymentType !== undefined)
            url_ += "PaymentType=" + encodeURIComponent("" + paymentType) + "&";
        if (paymentIdentifier === null)
            throw new Error("The parameter 'paymentIdentifier' cannot be null.");
        else if (paymentIdentifier !== undefined)
            url_ += "PaymentIdentifier=" + encodeURIComponent("" + paymentIdentifier) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        if (shiftId === null)
            throw new Error("The parameter 'shiftId' cannot be null.");
        else if (shiftId !== undefined)
            url_ += "ShiftId=" + encodeURIComponent("" + shiftId) + "&";
        if (subscriptionPackageId === null)
            throw new Error("The parameter 'subscriptionPackageId' cannot be null.");
        else if (subscriptionPackageId !== undefined)
            url_ += "SubscriptionPackageId=" + encodeURIComponent("" + subscriptionPackageId) + "&";
        if (invoiceNumber === null)
            throw new Error("The parameter 'invoiceNumber' cannot be null.");
        else if (invoiceNumber !== undefined)
            url_ += "InvoiceNumber=" + encodeURIComponent("" + invoiceNumber) + "&";
        if (statuses === null)
            throw new Error("The parameter 'statuses' cannot be null.");
        else if (statuses !== undefined)
            statuses && statuses.forEach(item => { url_ += "Statuses=" + encodeURIComponent("" + item) + "&"; });
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubscriptionListItemDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubscriptionListItemDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<SubscriptionListItemDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubscriptionListItemDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SubscriptionCompanyServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateSubscriptionCompanyInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SubscriptionCompany/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<SubscriptionCompanyDto> {
        let url_ = this.baseUrl + "/api/services/app/SubscriptionCompany/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubscriptionCompanyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubscriptionCompanyDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SubscriptionCompanyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubscriptionCompanyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateSubscriptionCompanyInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SubscriptionCompany/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<SubscriptionCompanyDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/SubscriptionCompany/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubscriptionCompanyDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubscriptionCompanyDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<SubscriptionCompanyDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubscriptionCompanyDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SubscriptionPackageServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateSubscriptionPackageInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SubscriptionPackage/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param isActive (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(isActive: boolean | undefined, keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<SubscriptionPackageListItemDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/SubscriptionPackage/GetAll?";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubscriptionPackageListItemDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubscriptionPackageListItemDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<SubscriptionPackageListItemDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubscriptionPackageListItemDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<SubscriptionPackageDto> {
        let url_ = this.baseUrl + "/api/services/app/SubscriptionPackage/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubscriptionPackageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubscriptionPackageDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SubscriptionPackageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubscriptionPackageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    activate(body: GuidEntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SubscriptionPackage/Activate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processActivate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deactivate(body: GuidEntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SubscriptionPackage/Deactivate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeactivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeactivate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeactivate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    edit(body: EditSubscripionPackageInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SubscriptionPackage/Edit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SubscriptionTimeZoneServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateSubscriptionTimeZoneInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SubscriptionTimeZone/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    activate(body: GuidEntityDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/SubscriptionTimeZone/Activate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processActivate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deActivate(body: GuidEntityDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/SubscriptionTimeZone/DeActivate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeActivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeActivate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeActivate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<SubscriptionTimeZoneItemDto> {
        let url_ = this.baseUrl + "/api/services/app/SubscriptionTimeZone/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubscriptionTimeZoneItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubscriptionTimeZoneItemDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SubscriptionTimeZoneItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubscriptionTimeZoneItemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param name (optional) 
     * @param description (optional) 
     * @param startTime (optional) 
     * @param endTime (optional) 
     * @param isActive (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(name: string | undefined, description: string | undefined, startTime: string | undefined, endTime: string | undefined, isActive: boolean | undefined, keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<SubscriptionTimeZoneItemDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/SubscriptionTimeZone/GetAll?";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (description === null)
            throw new Error("The parameter 'description' cannot be null.");
        else if (description !== undefined)
            url_ += "Description=" + encodeURIComponent("" + description) + "&";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "StartTime=" + encodeURIComponent("" + startTime) + "&";
        if (endTime === null)
            throw new Error("The parameter 'endTime' cannot be null.");
        else if (endTime !== undefined)
            url_ += "EndTime=" + encodeURIComponent("" + endTime) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubscriptionTimeZoneItemDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubscriptionTimeZoneItemDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<SubscriptionTimeZoneItemDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubscriptionTimeZoneItemDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    edit(body: EditSubscriptionTimeZoneInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SubscriptionTimeZone/Edit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SubscriptionVehicleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateVehicleInput | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/SubscriptionVehicle/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateVehicleInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SubscriptionVehicle/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<VehicleDto> {
        let url_ = this.baseUrl + "/api/services/app/SubscriptionVehicle/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VehicleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VehicleDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<VehicleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VehicleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param firstName (optional) 
     * @param lastName (optional) 
     * @param phoneNumber (optional) 
     * @param carPlateLetters (optional) 
     * @param carPlateDigits (optional) 
     * @param isActive (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(firstName: string | undefined, lastName: string | undefined, phoneNumber: string | undefined, carPlateLetters: string | undefined, carPlateDigits: number | undefined, isActive: boolean | undefined, keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<VehicleDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/SubscriptionVehicle/GetAll?";
        if (firstName === null)
            throw new Error("The parameter 'firstName' cannot be null.");
        else if (firstName !== undefined)
            url_ += "FirstName=" + encodeURIComponent("" + firstName) + "&";
        if (lastName === null)
            throw new Error("The parameter 'lastName' cannot be null.");
        else if (lastName !== undefined)
            url_ += "LastName=" + encodeURIComponent("" + lastName) + "&";
        if (phoneNumber === null)
            throw new Error("The parameter 'phoneNumber' cannot be null.");
        else if (phoneNumber !== undefined)
            url_ += "PhoneNumber=" + encodeURIComponent("" + phoneNumber) + "&";
        if (carPlateLetters === null)
            throw new Error("The parameter 'carPlateLetters' cannot be null.");
        else if (carPlateLetters !== undefined)
            url_ += "CarPlateLetters=" + encodeURIComponent("" + carPlateLetters) + "&";
        if (carPlateDigits === null)
            throw new Error("The parameter 'carPlateDigits' cannot be null.");
        else if (carPlateDigits !== undefined)
            url_ += "CarPlateDigits=" + encodeURIComponent("" + carPlateDigits) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VehicleDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VehicleDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<VehicleDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VehicleDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param carPlateDigits (optional) 
     * @param carPlateLetters (optional) 
     * @return Success
     */
    getCounts(carPlateDigits: number | undefined, carPlateLetters: string | undefined): Observable<GetCountsOutput> {
        let url_ = this.baseUrl + "/api/services/app/SubscriptionVehicle/GetCounts?";
        if (carPlateDigits === null)
            throw new Error("The parameter 'carPlateDigits' cannot be null.");
        else if (carPlateDigits !== undefined)
            url_ += "carPlateDigits=" + encodeURIComponent("" + carPlateDigits) + "&";
        if (carPlateLetters === null)
            throw new Error("The parameter 'carPlateLetters' cannot be null.");
        else if (carPlateLetters !== undefined)
            url_ += "carPlateLetters=" + encodeURIComponent("" + carPlateLetters) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCounts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCounts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCountsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCountsOutput>;
        }));
    }

    protected processGetCounts(response: HttpResponseBase): Observable<GetCountsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCountsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SubscriptionVehicleQRCodeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createManualQRCode(body: CreateManualQRCode | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SubscriptionVehicleQRCode/CreateManualQRCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateManualQRCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateManualQRCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateManualQRCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    assign(body: AssignQRCodeInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SubscriptionVehicleQRCode/Assign";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssign(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssign(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAssign(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    assignDifferentCode(body: AssignQRCodeInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SubscriptionVehicleQRCode/AssignDifferentCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignDifferentCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignDifferentCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAssignDifferentCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    generate(body: GenerateQRCodeInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SubscriptionVehicleQRCode/Generate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGenerate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param isAssigned (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(isAssigned: boolean | undefined, keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<VehicleQRCodeDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/SubscriptionVehicleQRCode/GetAll?";
        if (isAssigned === null)
            throw new Error("The parameter 'isAssigned' cannot be null.");
        else if (isAssigned !== undefined)
            url_ += "IsAssigned=" + encodeURIComponent("" + isAssigned) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VehicleQRCodeDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VehicleQRCodeDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<VehicleQRCodeDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VehicleQRCodeDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCode(id: number | undefined): Observable<VehicleQRCodeDto> {
        let url_ = this.baseUrl + "/api/services/app/SubscriptionVehicleQRCode/GetCode?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VehicleQRCodeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VehicleQRCodeDto>;
        }));
    }

    protected processGetCode(response: HttpResponseBase): Observable<VehicleQRCodeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VehicleQRCodeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    activate(body: Int64EntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SubscriptionVehicleQRCode/Activate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processActivate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deActivate(body: Int64EntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SubscriptionVehicleQRCode/DeActivate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeActivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeActivate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeActivate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param count (optional) 
     * @return Success
     */
    getAvailableCodes(count: number | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/SubscriptionVehicleQRCode/GetAvailableCodes?";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAvailableCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAvailableCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetAvailableCodes(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TenantServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateTenantDto | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param isActive (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, isActive: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<TenantDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<TenantDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: TenantDto | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TestBackgroundServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param queue (optional) 
     * @return Success
     */
    runTest(queue: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TestBackground/RunTest?";
        if (queue === null)
            throw new Error("The parameter 'queue' cannot be null.");
        else if (queue !== undefined)
            url_ += "queue=" + encodeURIComponent("" + queue) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRunTest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRunTest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRunTest(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    testLock(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TestBackground/TestLock";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTestLock(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTestLock(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTestLock(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TokenAuthServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    authenticate(body: AuthenticateModel | undefined): Observable<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/Authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthenticateResultModel>;
        }));
    }

    protected processAuthenticate(response: HttpResponseBase): Observable<AuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getExternalAuthenticationProviders(): Observable<ExternalLoginProviderInfoModel[]> {
        let url_ = this.baseUrl + "/api/TokenAuth/GetExternalAuthenticationProviders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExternalAuthenticationProviders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExternalAuthenticationProviders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalLoginProviderInfoModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalLoginProviderInfoModel[]>;
        }));
    }

    protected processGetExternalAuthenticationProviders(response: HttpResponseBase): Observable<ExternalLoginProviderInfoModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ExternalLoginProviderInfoModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    externalAuthenticate(body: ExternalAuthenticateModel | undefined): Observable<ExternalAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/ExternalAuthenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExternalAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExternalAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalAuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalAuthenticateResultModel>;
        }));
    }

    protected processExternalAuthenticate(response: HttpResponseBase): Observable<ExternalAuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalAuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TransactionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param paymentType (optional) 
     * @param statusId (optional) 
     * @param startTime (optional) 
     * @param endTime (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllTransactions(paymentType: PaymentType | undefined, statusId: number | undefined, startTime: moment.Moment | undefined, endTime: moment.Moment | undefined, keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<GetAllTransactionListDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Transaction/GetAllTransactions?";
        if (paymentType === null)
            throw new Error("The parameter 'paymentType' cannot be null.");
        else if (paymentType !== undefined)
            url_ += "PaymentType=" + encodeURIComponent("" + paymentType) + "&";
        if (statusId === null)
            throw new Error("The parameter 'statusId' cannot be null.");
        else if (statusId !== undefined)
            url_ += "StatusId=" + encodeURIComponent("" + statusId) + "&";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "StartTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime === null)
            throw new Error("The parameter 'endTime' cannot be null.");
        else if (endTime !== undefined)
            url_ += "EndTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTransactions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTransactions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAllTransactionListDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAllTransactionListDtoPagedResultDto>;
        }));
    }

    protected processGetAllTransactions(response: HttpResponseBase): Observable<GetAllTransactionListDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAllTransactionListDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getOnlineTransactionForView(id: string | undefined): Observable<GetOnlineTransactionViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Transaction/GetOnlineTransactionForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOnlineTransactionForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOnlineTransactionForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetOnlineTransactionViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetOnlineTransactionViewDto>;
        }));
    }

    protected processGetOnlineTransactionForView(response: HttpResponseBase): Observable<GetOnlineTransactionViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetOnlineTransactionViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param transactionId (optional) 
     * @return Success
     */
    refund(transactionId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Transaction/Refund?";
        if (transactionId === null)
            throw new Error("The parameter 'transactionId' cannot be null.");
        else if (transactionId !== undefined)
            url_ += "transactionId=" + encodeURIComponent("" + transactionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefund(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefund(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRefund(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param isActive (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, isActive: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<UserDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<UserDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateUserDto | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UserDto | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    activate(body: Int64EntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/Activate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processActivate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deActivate(body: Int64EntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/DeActivate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeActivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeActivate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeActivate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getRoles(): Observable<RoleDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetRoles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDtoListResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDtoListResultDto>;
        }));
    }

    protected processGetRoles(response: HttpResponseBase): Observable<RoleDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDtoListResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeLanguage(body: ChangeUserLanguageDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/ChangeLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changePassword(body: ChangePasswordDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processChangePassword(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resetPassword(body: ResetPasswordDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/ResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processResetPassword(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    isShouldChangePassword(userId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/IsShouldChangePassword?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsShouldChangePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsShouldChangePassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsShouldChangePassword(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class VehicleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateVehicleRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Vehicle/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateVehicleRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Vehicle/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    view(id: string | undefined): Observable<VehicleDto> {
        let url_ = this.baseUrl + "/api/services/app/Vehicle/View?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VehicleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VehicleDto>;
        }));
    }

    protected processView(response: HttpResponseBase): Observable<VehicleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VehicleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param countryId (optional) 
     * @param plateLetters (optional) 
     * @param plateDigits (optional) 
     * @param vehicleType (optional) 
     * @param customerId (optional) 
     * @param hasVerifiedCustomer (optional) 
     * @param assignedToQRCode (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(countryId: number | undefined, plateLetters: string | undefined, plateDigits: number | undefined, vehicleType: VehicleType | undefined, customerId: string | undefined, hasVerifiedCustomer: boolean | undefined, assignedToQRCode: boolean | undefined, keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<VehicleDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Vehicle/GetAll?";
        if (countryId === null)
            throw new Error("The parameter 'countryId' cannot be null.");
        else if (countryId !== undefined)
            url_ += "CountryId=" + encodeURIComponent("" + countryId) + "&";
        if (plateLetters === null)
            throw new Error("The parameter 'plateLetters' cannot be null.");
        else if (plateLetters !== undefined)
            url_ += "PlateLetters=" + encodeURIComponent("" + plateLetters) + "&";
        if (plateDigits === null)
            throw new Error("The parameter 'plateDigits' cannot be null.");
        else if (plateDigits !== undefined)
            url_ += "PlateDigits=" + encodeURIComponent("" + plateDigits) + "&";
        if (vehicleType === null)
            throw new Error("The parameter 'vehicleType' cannot be null.");
        else if (vehicleType !== undefined)
            url_ += "VehicleType=" + encodeURIComponent("" + vehicleType) + "&";
        if (customerId === null)
            throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "CustomerId=" + encodeURIComponent("" + customerId) + "&";
        if (hasVerifiedCustomer === null)
            throw new Error("The parameter 'hasVerifiedCustomer' cannot be null.");
        else if (hasVerifiedCustomer !== undefined)
            url_ += "HasVerifiedCustomer=" + encodeURIComponent("" + hasVerifiedCustomer) + "&";
        if (assignedToQRCode === null)
            throw new Error("The parameter 'assignedToQRCode' cannot be null.");
        else if (assignedToQRCode !== undefined)
            url_ += "AssignedToQRCode=" + encodeURIComponent("" + assignedToQRCode) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VehicleDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VehicleDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<VehicleDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VehicleDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class VehicleListingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: AddVehicleListingInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/VehicleListing/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateVehicleListingInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/VehicleListing/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/VehicleListing/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<VehicleListingDto> {
        let url_ = this.baseUrl + "/api/services/app/VehicleListing/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VehicleListingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VehicleListingDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<VehicleListingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VehicleListingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param letters (optional) 
     * @param digits (optional) 
     * @param status (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(letters: string | undefined, digits: number | undefined, status: string | undefined, keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<VehicleListingDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/VehicleListing/GetAll?";
        if (letters === null)
            throw new Error("The parameter 'letters' cannot be null.");
        else if (letters !== undefined)
            url_ += "Letters=" + encodeURIComponent("" + letters) + "&";
        if (digits === null)
            throw new Error("The parameter 'digits' cannot be null.");
        else if (digits !== undefined)
            url_ += "Digits=" + encodeURIComponent("" + digits) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VehicleListingDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VehicleListingDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<VehicleListingDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VehicleListingDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ViolationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    applyAction(body: ApplyActionInputDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Violation/ApplyAction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApplyAction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApplyAction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processApplyAction(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getForView(id: string | undefined): Observable<GetViolationViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Violation/GetForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetViolationViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetViolationViewDto>;
        }));
    }

    protected processGetForView(response: HttpResponseBase): Observable<GetViolationViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetViolationViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param shiftId (optional) 
     * @param locationId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param carPlateDigits (optional) 
     * @param carPlateLetters (optional) 
     * @param statusIds (optional) 
     * @param vehicleStatusId (optional) 
     * @param customerSupportStatusId (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getMyViolations(shiftId: string | undefined, locationId: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, carPlateDigits: number | undefined, carPlateLetters: string | undefined, statusIds: number[] | undefined, vehicleStatusId: number | undefined, customerSupportStatusId: number | undefined, keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ViolationDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Violation/GetMyViolations?";
        if (shiftId === null)
            throw new Error("The parameter 'shiftId' cannot be null.");
        else if (shiftId !== undefined)
            url_ += "ShiftId=" + encodeURIComponent("" + shiftId) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (carPlateDigits === null)
            throw new Error("The parameter 'carPlateDigits' cannot be null.");
        else if (carPlateDigits !== undefined)
            url_ += "CarPlateDigits=" + encodeURIComponent("" + carPlateDigits) + "&";
        if (carPlateLetters === null)
            throw new Error("The parameter 'carPlateLetters' cannot be null.");
        else if (carPlateLetters !== undefined)
            url_ += "CarPlateLetters=" + encodeURIComponent("" + carPlateLetters) + "&";
        if (statusIds === null)
            throw new Error("The parameter 'statusIds' cannot be null.");
        else if (statusIds !== undefined)
            statusIds && statusIds.forEach(item => { url_ += "StatusIds=" + encodeURIComponent("" + item) + "&"; });
        if (vehicleStatusId === null)
            throw new Error("The parameter 'vehicleStatusId' cannot be null.");
        else if (vehicleStatusId !== undefined)
            url_ += "VehicleStatusId=" + encodeURIComponent("" + vehicleStatusId) + "&";
        if (customerSupportStatusId === null)
            throw new Error("The parameter 'customerSupportStatusId' cannot be null.");
        else if (customerSupportStatusId !== undefined)
            url_ += "CustomerSupportStatusId=" + encodeURIComponent("" + customerSupportStatusId) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyViolations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyViolations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ViolationDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ViolationDtoPagedResultDto>;
        }));
    }

    protected processGetMyViolations(response: HttpResponseBase): Observable<ViolationDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ViolationDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param paymentType (optional) 
     * @param invoiceNumber (optional) 
     * @param shiftId (optional) 
     * @param locationId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param carPlateDigits (optional) 
     * @param carPlateLetters (optional) 
     * @param statusIds (optional) 
     * @param vehicleStatusId (optional) 
     * @param customerSupportStatusId (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(paymentType: PaymentType | undefined, invoiceNumber: string | undefined, shiftId: string | undefined, locationId: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, carPlateDigits: number | undefined, carPlateLetters: string | undefined, statusIds: number[] | undefined, vehicleStatusId: number | undefined, customerSupportStatusId: number | undefined, keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ViolationDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Violation/GetAll?";
        if (paymentType === null)
            throw new Error("The parameter 'paymentType' cannot be null.");
        else if (paymentType !== undefined)
            url_ += "PaymentType=" + encodeURIComponent("" + paymentType) + "&";
        if (invoiceNumber === null)
            throw new Error("The parameter 'invoiceNumber' cannot be null.");
        else if (invoiceNumber !== undefined)
            url_ += "InvoiceNumber=" + encodeURIComponent("" + invoiceNumber) + "&";
        if (shiftId === null)
            throw new Error("The parameter 'shiftId' cannot be null.");
        else if (shiftId !== undefined)
            url_ += "ShiftId=" + encodeURIComponent("" + shiftId) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (carPlateDigits === null)
            throw new Error("The parameter 'carPlateDigits' cannot be null.");
        else if (carPlateDigits !== undefined)
            url_ += "CarPlateDigits=" + encodeURIComponent("" + carPlateDigits) + "&";
        if (carPlateLetters === null)
            throw new Error("The parameter 'carPlateLetters' cannot be null.");
        else if (carPlateLetters !== undefined)
            url_ += "CarPlateLetters=" + encodeURIComponent("" + carPlateLetters) + "&";
        if (statusIds === null)
            throw new Error("The parameter 'statusIds' cannot be null.");
        else if (statusIds !== undefined)
            statusIds && statusIds.forEach(item => { url_ += "StatusIds=" + encodeURIComponent("" + item) + "&"; });
        if (vehicleStatusId === null)
            throw new Error("The parameter 'vehicleStatusId' cannot be null.");
        else if (vehicleStatusId !== undefined)
            url_ += "VehicleStatusId=" + encodeURIComponent("" + vehicleStatusId) + "&";
        if (customerSupportStatusId === null)
            throw new Error("The parameter 'customerSupportStatusId' cannot be null.");
        else if (customerSupportStatusId !== undefined)
            url_ += "CustomerSupportStatusId=" + encodeURIComponent("" + customerSupportStatusId) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ViolationDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ViolationDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ViolationDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ViolationDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param paymentType (optional) 
     * @param invoiceNumber (optional) 
     * @param shiftId (optional) 
     * @param locationId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param carPlateDigits (optional) 
     * @param carPlateLetters (optional) 
     * @param statusIds (optional) 
     * @param vehicleStatusId (optional) 
     * @param customerSupportStatusId (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    exportExcel(paymentType: PaymentType | undefined, invoiceNumber: string | undefined, shiftId: string | undefined, locationId: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, carPlateDigits: number | undefined, carPlateLetters: string | undefined, statusIds: number[] | undefined, vehicleStatusId: number | undefined, customerSupportStatusId: number | undefined, keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Violation/ExportExcel?";
        if (paymentType === null)
            throw new Error("The parameter 'paymentType' cannot be null.");
        else if (paymentType !== undefined)
            url_ += "PaymentType=" + encodeURIComponent("" + paymentType) + "&";
        if (invoiceNumber === null)
            throw new Error("The parameter 'invoiceNumber' cannot be null.");
        else if (invoiceNumber !== undefined)
            url_ += "InvoiceNumber=" + encodeURIComponent("" + invoiceNumber) + "&";
        if (shiftId === null)
            throw new Error("The parameter 'shiftId' cannot be null.");
        else if (shiftId !== undefined)
            url_ += "ShiftId=" + encodeURIComponent("" + shiftId) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (carPlateDigits === null)
            throw new Error("The parameter 'carPlateDigits' cannot be null.");
        else if (carPlateDigits !== undefined)
            url_ += "CarPlateDigits=" + encodeURIComponent("" + carPlateDigits) + "&";
        if (carPlateLetters === null)
            throw new Error("The parameter 'carPlateLetters' cannot be null.");
        else if (carPlateLetters !== undefined)
            url_ += "CarPlateLetters=" + encodeURIComponent("" + carPlateLetters) + "&";
        if (statusIds === null)
            throw new Error("The parameter 'statusIds' cannot be null.");
        else if (statusIds !== undefined)
            statusIds && statusIds.forEach(item => { url_ += "StatusIds=" + encodeURIComponent("" + item) + "&"; });
        if (vehicleStatusId === null)
            throw new Error("The parameter 'vehicleStatusId' cannot be null.");
        else if (vehicleStatusId !== undefined)
            url_ += "VehicleStatusId=" + encodeURIComponent("" + vehicleStatusId) + "&";
        if (customerSupportStatusId === null)
            throw new Error("The parameter 'customerSupportStatusId' cannot be null.");
        else if (customerSupportStatusId !== undefined)
            url_ += "CustomerSupportStatusId=" + encodeURIComponent("" + customerSupportStatusId) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processExportExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getViolationRecieptInfo(id: string | undefined): Observable<ViolationRecieptDtoRecieptWithTransactionDto> {
        let url_ = this.baseUrl + "/api/services/app/Violation/GetViolationRecieptInfo?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetViolationRecieptInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetViolationRecieptInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ViolationRecieptDtoRecieptWithTransactionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ViolationRecieptDtoRecieptWithTransactionDto>;
        }));
    }

    protected processGetViolationRecieptInfo(response: HttpResponseBase): Observable<ViolationRecieptDtoRecieptWithTransactionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ViolationRecieptDtoRecieptWithTransactionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param violationNumber (optional) 
     * @return Success
     */
    getViolationForOnlineSettlement(violationNumber: number | undefined): Observable<GetViolationForOnlineSettlementOutput> {
        let url_ = this.baseUrl + "/api/services/app/Violation/GetViolationForOnlineSettlement?";
        if (violationNumber === null)
            throw new Error("The parameter 'violationNumber' cannot be null.");
        else if (violationNumber !== undefined)
            url_ += "violationNumber=" + encodeURIComponent("" + violationNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetViolationForOnlineSettlement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetViolationForOnlineSettlement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetViolationForOnlineSettlementOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetViolationForOnlineSettlementOutput>;
        }));
    }

    protected processGetViolationForOnlineSettlement(response: HttpResponseBase): Observable<GetViolationForOnlineSettlementOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetViolationForOnlineSettlementOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param referenceNumber (optional) 
     * @return Success
     */
    getViolationForOnlineSettlementByReferenceNumber(referenceNumber: string | undefined): Observable<GetViolationForOnlineSettlementOutput> {
        let url_ = this.baseUrl + "/api/services/app/Violation/GetViolationForOnlineSettlementByReferenceNumber?";
        if (referenceNumber === null)
            throw new Error("The parameter 'referenceNumber' cannot be null.");
        else if (referenceNumber !== undefined)
            url_ += "referenceNumber=" + encodeURIComponent("" + referenceNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetViolationForOnlineSettlementByReferenceNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetViolationForOnlineSettlementByReferenceNumber(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetViolationForOnlineSettlementOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetViolationForOnlineSettlementOutput>;
        }));
    }

    protected processGetViolationForOnlineSettlementByReferenceNumber(response: HttpResponseBase): Observable<GetViolationForOnlineSettlementOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetViolationForOnlineSettlementOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getViolationForOnlineSettlementById(id: string | undefined): Observable<GetViolationForOnlineSettlementOutput> {
        let url_ = this.baseUrl + "/api/services/app/Violation/GetViolationForOnlineSettlementById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetViolationForOnlineSettlementById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetViolationForOnlineSettlementById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetViolationForOnlineSettlementOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetViolationForOnlineSettlementOutput>;
        }));
    }

    protected processGetViolationForOnlineSettlementById(response: HttpResponseBase): Observable<GetViolationForOnlineSettlementOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetViolationForOnlineSettlementOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    checkout(body: CheckoutViolationInput | undefined): Observable<CheckoutViolationDto> {
        let url_ = this.baseUrl + "/api/services/app/Violation/Checkout";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckout(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckout(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CheckoutViolationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CheckoutViolationDto>;
        }));
    }

    protected processCheckout(response: HttpResponseBase): Observable<CheckoutViolationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CheckoutViolationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    confirmPayment(body: ConfirmViolationPaymentInput | undefined): Observable<ConfirmPaymentOutput> {
        let url_ = this.baseUrl + "/api/services/app/Violation/ConfirmPayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmPayment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConfirmPaymentOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConfirmPaymentOutput>;
        }));
    }

    protected processConfirmPayment(response: HttpResponseBase): Observable<ConfirmPaymentOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConfirmPaymentOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getViolationTransactions(id: string | undefined): Observable<GetViolationTransactionsOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Violation/GetViolationTransactions?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetViolationTransactions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetViolationTransactions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetViolationTransactionsOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetViolationTransactionsOutputDto>;
        }));
    }

    protected processGetViolationTransactions(response: HttpResponseBase): Observable<GetViolationTransactionsOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetViolationTransactionsOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param shiftId (optional) 
     * @return Success
     */
    getViolationsActionsStatisticsByShiftId(shiftId: string | undefined): Observable<GetViolationsActionsStatisticsDto> {
        let url_ = this.baseUrl + "/api/services/app/Violation/GetViolationsActionsStatisticsByShiftId?";
        if (shiftId === null)
            throw new Error("The parameter 'shiftId' cannot be null.");
        else if (shiftId !== undefined)
            url_ += "shiftId=" + encodeURIComponent("" + shiftId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetViolationsActionsStatisticsByShiftId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetViolationsActionsStatisticsByShiftId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetViolationsActionsStatisticsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetViolationsActionsStatisticsDto>;
        }));
    }

    protected processGetViolationsActionsStatisticsByShiftId(response: HttpResponseBase): Observable<GetViolationsActionsStatisticsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetViolationsActionsStatisticsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param groupShiftId (optional) 
     * @return Success
     */
    getViolationsActionsStatisticsByGroupShiftId(groupShiftId: string | undefined): Observable<GetViolationsActionsStatisticsDto> {
        let url_ = this.baseUrl + "/api/services/app/Violation/GetViolationsActionsStatisticsByGroupShiftId?";
        if (groupShiftId === null)
            throw new Error("The parameter 'groupShiftId' cannot be null.");
        else if (groupShiftId !== undefined)
            url_ += "groupShiftId=" + encodeURIComponent("" + groupShiftId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetViolationsActionsStatisticsByGroupShiftId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetViolationsActionsStatisticsByGroupShiftId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetViolationsActionsStatisticsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetViolationsActionsStatisticsDto>;
        }));
    }

    protected processGetViolationsActionsStatisticsByGroupShiftId(response: HttpResponseBase): Observable<GetViolationsActionsStatisticsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetViolationsActionsStatisticsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param groupShiftId (optional) 
     * @return Success
     */
    getCreatedViolationsStatisticsByGroupShiftId(groupShiftId: string | undefined): Observable<GetCreatedViolationsStatisticsDto> {
        let url_ = this.baseUrl + "/api/services/app/Violation/GetCreatedViolationsStatisticsByGroupShiftId?";
        if (groupShiftId === null)
            throw new Error("The parameter 'groupShiftId' cannot be null.");
        else if (groupShiftId !== undefined)
            url_ += "groupShiftId=" + encodeURIComponent("" + groupShiftId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCreatedViolationsStatisticsByGroupShiftId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCreatedViolationsStatisticsByGroupShiftId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCreatedViolationsStatisticsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCreatedViolationsStatisticsDto>;
        }));
    }

    protected processGetCreatedViolationsStatisticsByGroupShiftId(response: HttpResponseBase): Observable<GetCreatedViolationsStatisticsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCreatedViolationsStatisticsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param groupShiftId (optional) 
     * @return Success
     */
    getOnlineViolationsByGroupShiftId(groupShiftId: string | undefined): Observable<ViolationStatisticsResponse> {
        let url_ = this.baseUrl + "/api/services/app/Violation/GetOnlineViolationsByGroupShiftId?";
        if (groupShiftId === null)
            throw new Error("The parameter 'groupShiftId' cannot be null.");
        else if (groupShiftId !== undefined)
            url_ += "groupShiftId=" + encodeURIComponent("" + groupShiftId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOnlineViolationsByGroupShiftId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOnlineViolationsByGroupShiftId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ViolationStatisticsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ViolationStatisticsResponse>;
        }));
    }

    protected processGetOnlineViolationsByGroupShiftId(response: HttpResponseBase): Observable<ViolationStatisticsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ViolationStatisticsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ViolationAdminServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    applyAction(body: ApplyActionInputDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/ViolationAdmin/ApplyAction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApplyAction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApplyAction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processApplyAction(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param paymentType (optional) 
     * @param invoiceNumber (optional) 
     * @param shiftId (optional) 
     * @param locationId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param carPlateDigits (optional) 
     * @param carPlateLetters (optional) 
     * @param statusIds (optional) 
     * @param vehicleStatusId (optional) 
     * @param customerSupportStatusId (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(paymentType: PaymentType | undefined, invoiceNumber: string | undefined, shiftId: string | undefined, locationId: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, carPlateDigits: number | undefined, carPlateLetters: string | undefined, statusIds: number[] | undefined, vehicleStatusId: number | undefined, customerSupportStatusId: number | undefined, keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<GetViolationOutputDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ViolationAdmin/GetAll?";
        if (paymentType === null)
            throw new Error("The parameter 'paymentType' cannot be null.");
        else if (paymentType !== undefined)
            url_ += "PaymentType=" + encodeURIComponent("" + paymentType) + "&";
        if (invoiceNumber === null)
            throw new Error("The parameter 'invoiceNumber' cannot be null.");
        else if (invoiceNumber !== undefined)
            url_ += "InvoiceNumber=" + encodeURIComponent("" + invoiceNumber) + "&";
        if (shiftId === null)
            throw new Error("The parameter 'shiftId' cannot be null.");
        else if (shiftId !== undefined)
            url_ += "ShiftId=" + encodeURIComponent("" + shiftId) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (carPlateDigits === null)
            throw new Error("The parameter 'carPlateDigits' cannot be null.");
        else if (carPlateDigits !== undefined)
            url_ += "CarPlateDigits=" + encodeURIComponent("" + carPlateDigits) + "&";
        if (carPlateLetters === null)
            throw new Error("The parameter 'carPlateLetters' cannot be null.");
        else if (carPlateLetters !== undefined)
            url_ += "CarPlateLetters=" + encodeURIComponent("" + carPlateLetters) + "&";
        if (statusIds === null)
            throw new Error("The parameter 'statusIds' cannot be null.");
        else if (statusIds !== undefined)
            statusIds && statusIds.forEach(item => { url_ += "StatusIds=" + encodeURIComponent("" + item) + "&"; });
        if (vehicleStatusId === null)
            throw new Error("The parameter 'vehicleStatusId' cannot be null.");
        else if (vehicleStatusId !== undefined)
            url_ += "VehicleStatusId=" + encodeURIComponent("" + vehicleStatusId) + "&";
        if (customerSupportStatusId === null)
            throw new Error("The parameter 'customerSupportStatusId' cannot be null.");
        else if (customerSupportStatusId !== undefined)
            url_ += "CustomerSupportStatusId=" + encodeURIComponent("" + customerSupportStatusId) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetViolationOutputDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetViolationOutputDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<GetViolationOutputDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetViolationOutputDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param shiftId (optional) 
     * @param locationId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param carPlateDigits (optional) 
     * @param carPlateLetters (optional) 
     * @param statusIds (optional) 
     * @param vehicleStatusId (optional) 
     * @param customerSupportStatusId (optional) 
     * @param paymentType (optional) 
     * @param invoiceNumber (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getByShift(shiftId: string | undefined, locationId: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, carPlateDigits: number | undefined, carPlateLetters: string | undefined, statusIds: number[] | undefined, vehicleStatusId: number | undefined, customerSupportStatusId: number | undefined, paymentType: PaymentType | undefined, invoiceNumber: string | undefined, keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<GetViolationOutputDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ViolationAdmin/GetByShift?";
        if (shiftId === null)
            throw new Error("The parameter 'shiftId' cannot be null.");
        else if (shiftId !== undefined)
            url_ += "ShiftId=" + encodeURIComponent("" + shiftId) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (carPlateDigits === null)
            throw new Error("The parameter 'carPlateDigits' cannot be null.");
        else if (carPlateDigits !== undefined)
            url_ += "CarPlateDigits=" + encodeURIComponent("" + carPlateDigits) + "&";
        if (carPlateLetters === null)
            throw new Error("The parameter 'carPlateLetters' cannot be null.");
        else if (carPlateLetters !== undefined)
            url_ += "CarPlateLetters=" + encodeURIComponent("" + carPlateLetters) + "&";
        if (statusIds === null)
            throw new Error("The parameter 'statusIds' cannot be null.");
        else if (statusIds !== undefined)
            statusIds && statusIds.forEach(item => { url_ += "StatusIds=" + encodeURIComponent("" + item) + "&"; });
        if (vehicleStatusId === null)
            throw new Error("The parameter 'vehicleStatusId' cannot be null.");
        else if (vehicleStatusId !== undefined)
            url_ += "VehicleStatusId=" + encodeURIComponent("" + vehicleStatusId) + "&";
        if (customerSupportStatusId === null)
            throw new Error("The parameter 'customerSupportStatusId' cannot be null.");
        else if (customerSupportStatusId !== undefined)
            url_ += "CustomerSupportStatusId=" + encodeURIComponent("" + customerSupportStatusId) + "&";
        if (paymentType === null)
            throw new Error("The parameter 'paymentType' cannot be null.");
        else if (paymentType !== undefined)
            url_ += "PaymentType=" + encodeURIComponent("" + paymentType) + "&";
        if (invoiceNumber === null)
            throw new Error("The parameter 'invoiceNumber' cannot be null.");
        else if (invoiceNumber !== undefined)
            url_ += "InvoiceNumber=" + encodeURIComponent("" + invoiceNumber) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByShift(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByShift(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetViolationOutputDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetViolationOutputDtoPagedResultDto>;
        }));
    }

    protected processGetByShift(response: HttpResponseBase): Observable<GetViolationOutputDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetViolationOutputDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getForView(id: string | undefined): Observable<GetViolationOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/ViolationAdmin/GetForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetViolationOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetViolationOutputDto>;
        }));
    }

    protected processGetForView(response: HttpResponseBase): Observable<GetViolationOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetViolationOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param paymentType (optional) 
     * @param invoiceNumber (optional) 
     * @param shiftId (optional) 
     * @param locationId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param carPlateDigits (optional) 
     * @param carPlateLetters (optional) 
     * @param statusIds (optional) 
     * @param vehicleStatusId (optional) 
     * @param customerSupportStatusId (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    exportExcel(paymentType: PaymentType | undefined, invoiceNumber: string | undefined, shiftId: string | undefined, locationId: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, carPlateDigits: number | undefined, carPlateLetters: string | undefined, statusIds: number[] | undefined, vehicleStatusId: number | undefined, customerSupportStatusId: number | undefined, keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/ViolationAdmin/ExportExcel?";
        if (paymentType === null)
            throw new Error("The parameter 'paymentType' cannot be null.");
        else if (paymentType !== undefined)
            url_ += "PaymentType=" + encodeURIComponent("" + paymentType) + "&";
        if (invoiceNumber === null)
            throw new Error("The parameter 'invoiceNumber' cannot be null.");
        else if (invoiceNumber !== undefined)
            url_ += "InvoiceNumber=" + encodeURIComponent("" + invoiceNumber) + "&";
        if (shiftId === null)
            throw new Error("The parameter 'shiftId' cannot be null.");
        else if (shiftId !== undefined)
            url_ += "ShiftId=" + encodeURIComponent("" + shiftId) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (carPlateDigits === null)
            throw new Error("The parameter 'carPlateDigits' cannot be null.");
        else if (carPlateDigits !== undefined)
            url_ += "CarPlateDigits=" + encodeURIComponent("" + carPlateDigits) + "&";
        if (carPlateLetters === null)
            throw new Error("The parameter 'carPlateLetters' cannot be null.");
        else if (carPlateLetters !== undefined)
            url_ += "CarPlateLetters=" + encodeURIComponent("" + carPlateLetters) + "&";
        if (statusIds === null)
            throw new Error("The parameter 'statusIds' cannot be null.");
        else if (statusIds !== undefined)
            statusIds && statusIds.forEach(item => { url_ += "StatusIds=" + encodeURIComponent("" + item) + "&"; });
        if (vehicleStatusId === null)
            throw new Error("The parameter 'vehicleStatusId' cannot be null.");
        else if (vehicleStatusId !== undefined)
            url_ += "VehicleStatusId=" + encodeURIComponent("" + vehicleStatusId) + "&";
        if (customerSupportStatusId === null)
            throw new Error("The parameter 'customerSupportStatusId' cannot be null.");
        else if (customerSupportStatusId !== undefined)
            url_ += "CustomerSupportStatusId=" + encodeURIComponent("" + customerSupportStatusId) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processExportExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ViolationExporterServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportToFile(body: ExportViolationDto[] | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/ViolationExporter/ExportToFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportToFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportToFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processExportToFile(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ViolationTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ViolationTypeDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ViolationType/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ViolationTypeDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ViolationTypeDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ViolationTypeDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ViolationTypeDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getViolationTypeForEdit(id: string | undefined): Observable<CreateOrUpdateViolationTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/ViolationType/GetViolationTypeForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetViolationTypeForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetViolationTypeForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrUpdateViolationTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrUpdateViolationTypeDto>;
        }));
    }

    protected processGetViolationTypeForEdit(response: HttpResponseBase): Observable<CreateOrUpdateViolationTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrUpdateViolationTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateViolationType(body: CreateOrUpdateViolationTypeDto | undefined): Observable<CreateOrUpdateViolationTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/ViolationType/CreateOrUpdateViolationType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateViolationType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateViolationType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrUpdateViolationTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrUpdateViolationTypeDto>;
        }));
    }

    protected processCreateOrUpdateViolationType(response: HttpResponseBase): Observable<CreateOrUpdateViolationTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrUpdateViolationTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class WebhooksServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    paymentWebhook(body: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Webhooks/PaymentWebhook";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPaymentWebhook(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPaymentWebhook(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPaymentWebhook(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    paymentWebhook_V1(body: EncryptedRequestBody | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Webhooks/PaymentWebhook_V1";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPaymentWebhook_V1(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPaymentWebhook_V1(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPaymentWebhook_V1(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ZatcaDeviceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param isActive (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(isActive: boolean | undefined, keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ZatcaDeviceDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ZatcaDevice/GetAll?";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ZatcaDeviceDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ZatcaDeviceDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ZatcaDeviceDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ZatcaDeviceDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateZatcaDeviceDto | undefined): Observable<ZatcaDeviceDto> {
        let url_ = this.baseUrl + "/api/services/app/ZatcaDevice/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ZatcaDeviceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ZatcaDeviceDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ZatcaDeviceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ZatcaDeviceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    report(body: ReportInvoiceDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ZatcaDevice/Report";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    renew(body: RenewZatcaDeviceDto | undefined): Observable<ZatcaDeviceDto> {
        let url_ = this.baseUrl + "/api/services/app/ZatcaDevice/Renew";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRenew(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRenew(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ZatcaDeviceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ZatcaDeviceDto>;
        }));
    }

    protected processRenew(response: HttpResponseBase): Observable<ZatcaDeviceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ZatcaDeviceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    checkCertificate(body: CheckCertificateDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/ZatcaDevice/CheckCertificate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckCertificate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckCertificate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCheckCertificate(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ZatcaIntegrityLogsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param status (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(status: string | undefined, keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ZatcaIntegrityLogResponsePagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ZatcaIntegrityLogs/GetAll?";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ZatcaIntegrityLogResponsePagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ZatcaIntegrityLogResponsePagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ZatcaIntegrityLogResponsePagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ZatcaIntegrityLogResponsePagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param key (optional) 
     * @return Success
     */
    getByKey(key: string | undefined): Observable<ZatcaIntegrityLogResponse> {
        let url_ = this.baseUrl + "/api/services/app/ZatcaIntegrityLogs/GetByKey?";
        if (key === null)
            throw new Error("The parameter 'key' cannot be null.");
        else if (key !== undefined)
            url_ += "key=" + encodeURIComponent("" + key) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByKey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ZatcaIntegrityLogResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ZatcaIntegrityLogResponse>;
        }));
    }

    protected processGetByKey(response: HttpResponseBase): Observable<ZatcaIntegrityLogResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ZatcaIntegrityLogResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class ActionPermission implements IActionPermission {
    actionName: string | undefined;
    requiredPermission: string | undefined;

    constructor(data?: IActionPermission) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actionName = _data["actionName"];
            this.requiredPermission = _data["requiredPermission"];
        }
    }

    static fromJS(data: any): ActionPermission {
        data = typeof data === 'object' ? data : {};
        let result = new ActionPermission();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actionName"] = this.actionName;
        data["requiredPermission"] = this.requiredPermission;
        return data;
    }

    clone(): ActionPermission {
        const json = this.toJSON();
        let result = new ActionPermission();
        result.init(json);
        return result;
    }
}

export interface IActionPermission {
    actionName: string | undefined;
    requiredPermission: string | undefined;
}

export class AddVehicleListingInput implements IAddVehicleListingInput {
    status: string | undefined;
    vehiclePlate: VehiclePlate;
    notes: string | undefined;

    constructor(data?: IAddVehicleListingInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.vehiclePlate = _data["vehiclePlate"] ? VehiclePlate.fromJS(_data["vehiclePlate"]) : <any>undefined;
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): AddVehicleListingInput {
        data = typeof data === 'object' ? data : {};
        let result = new AddVehicleListingInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["vehiclePlate"] = this.vehiclePlate ? this.vehiclePlate.toJSON() : <any>undefined;
        data["notes"] = this.notes;
        return data;
    }

    clone(): AddVehicleListingInput {
        const json = this.toJSON();
        let result = new AddVehicleListingInput();
        result.init(json);
        return result;
    }
}

export interface IAddVehicleListingInput {
    status: string | undefined;
    vehiclePlate: VehiclePlate;
    notes: string | undefined;
}

export class Address implements IAddress {
    country: string;
    city: string | undefined;
    location: string | undefined;

    constructor(data?: IAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.country = _data["country"];
            this.city = _data["city"];
            this.location = _data["location"];
        }
    }

    static fromJS(data: any): Address {
        data = typeof data === 'object' ? data : {};
        let result = new Address();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["country"] = this.country;
        data["city"] = this.city;
        data["location"] = this.location;
        return data;
    }

    clone(): Address {
        const json = this.toJSON();
        let result = new Address();
        result.init(json);
        return result;
    }
}

export interface IAddress {
    country: string;
    city: string | undefined;
    location: string | undefined;
}

export class AddressResponse implements IAddressResponse {
    country: string | undefined;
    city: string | undefined;
    location: string | undefined;

    constructor(data?: IAddressResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.country = _data["country"];
            this.city = _data["city"];
            this.location = _data["location"];
        }
    }

    static fromJS(data: any): AddressResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddressResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["country"] = this.country;
        data["city"] = this.city;
        data["location"] = this.location;
        return data;
    }

    clone(): AddressResponse {
        const json = this.toJSON();
        let result = new AddressResponse();
        result.init(json);
        return result;
    }
}

export interface IAddressResponse {
    country: string | undefined;
    city: string | undefined;
    location: string | undefined;
}

export class AppAttachmentReadModel implements IAppAttachmentReadModel {
    id: string;
    entityId: string | undefined;
    attachmentName: string | undefined;
    path: string | undefined;

    constructor(data?: IAppAttachmentReadModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.entityId = _data["entityId"];
            this.attachmentName = _data["attachmentName"];
            this.path = _data["path"];
        }
    }

    static fromJS(data: any): AppAttachmentReadModel {
        data = typeof data === 'object' ? data : {};
        let result = new AppAttachmentReadModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["entityId"] = this.entityId;
        data["attachmentName"] = this.attachmentName;
        data["path"] = this.path;
        return data;
    }

    clone(): AppAttachmentReadModel {
        const json = this.toJSON();
        let result = new AppAttachmentReadModel();
        result.init(json);
        return result;
    }
}

export interface IAppAttachmentReadModel {
    id: string;
    entityId: string | undefined;
    attachmentName: string | undefined;
    path: string | undefined;
}

export class AppEmailSettingsDto implements IAppEmailSettingsDto {
    supportEmail: string | undefined;
    operationSupportEmail: string | undefined;
    issuesEmail: string | undefined;

    constructor(data?: IAppEmailSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.supportEmail = _data["supportEmail"];
            this.operationSupportEmail = _data["operationSupportEmail"];
            this.issuesEmail = _data["issuesEmail"];
        }
    }

    static fromJS(data: any): AppEmailSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppEmailSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["supportEmail"] = this.supportEmail;
        data["operationSupportEmail"] = this.operationSupportEmail;
        data["issuesEmail"] = this.issuesEmail;
        return data;
    }

    clone(): AppEmailSettingsDto {
        const json = this.toJSON();
        let result = new AppEmailSettingsDto();
        result.init(json);
        return result;
    }
}

export interface IAppEmailSettingsDto {
    supportEmail: string | undefined;
    operationSupportEmail: string | undefined;
    issuesEmail: string | undefined;
}

export class ApplicationInfoDto implements IApplicationInfoDto {
    version: string | undefined;
    releaseDate: moment.Moment;
    features: { [key: string]: boolean; } | undefined;

    constructor(data?: IApplicationInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
            this.releaseDate = _data["releaseDate"] ? moment(_data["releaseDate"].toString()) : <any>undefined;
            if (_data["features"]) {
                this.features = {} as any;
                for (let key in _data["features"]) {
                    if (_data["features"].hasOwnProperty(key))
                        (<any>this.features)[key] = _data["features"][key];
                }
            }
        }
    }

    static fromJS(data: any): ApplicationInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toISOString() : <any>undefined;
        if (this.features) {
            data["features"] = {};
            for (let key in this.features) {
                if (this.features.hasOwnProperty(key))
                    (<any>data["features"])[key] = (<any>this.features)[key];
            }
        }
        return data;
    }

    clone(): ApplicationInfoDto {
        const json = this.toJSON();
        let result = new ApplicationInfoDto();
        result.init(json);
        return result;
    }
}

export interface IApplicationInfoDto {
    version: string | undefined;
    releaseDate: moment.Moment;
    features: { [key: string]: boolean; } | undefined;
}

export class ApplyActionInputDto implements IApplyActionInputDto {
    violationId: string | undefined;
    posTransactionId: string | undefined;
    cancelledItems: string[] | undefined;
    newViolationItems: string[] | undefined;
    excludePricingCalculations: boolean | undefined;
    violation: CreateViolationDto;
    totalHours: number | undefined;
    action: ViolationActions;
    attachments: CreateAttachmentDto[] | undefined;
    notes: string | undefined;
    longitude: number;
    latitude: number;
    clampNumber: string | undefined;

    constructor(data?: IApplyActionInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.violationId = _data["violationId"];
            this.posTransactionId = _data["posTransactionId"];
            if (Array.isArray(_data["cancelledItems"])) {
                this.cancelledItems = [] as any;
                for (let item of _data["cancelledItems"])
                    this.cancelledItems.push(item);
            }
            if (Array.isArray(_data["newViolationItems"])) {
                this.newViolationItems = [] as any;
                for (let item of _data["newViolationItems"])
                    this.newViolationItems.push(item);
            }
            this.excludePricingCalculations = _data["excludePricingCalculations"];
            this.violation = _data["violation"] ? CreateViolationDto.fromJS(_data["violation"]) : <any>undefined;
            this.totalHours = _data["totalHours"];
            this.action = _data["action"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments.push(CreateAttachmentDto.fromJS(item));
            }
            this.notes = _data["notes"];
            this.longitude = _data["longitude"];
            this.latitude = _data["latitude"];
            this.clampNumber = _data["clampNumber"];
        }
    }

    static fromJS(data: any): ApplyActionInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplyActionInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["violationId"] = this.violationId;
        data["posTransactionId"] = this.posTransactionId;
        if (Array.isArray(this.cancelledItems)) {
            data["cancelledItems"] = [];
            for (let item of this.cancelledItems)
                data["cancelledItems"].push(item);
        }
        if (Array.isArray(this.newViolationItems)) {
            data["newViolationItems"] = [];
            for (let item of this.newViolationItems)
                data["newViolationItems"].push(item);
        }
        data["excludePricingCalculations"] = this.excludePricingCalculations;
        data["violation"] = this.violation ? this.violation.toJSON() : <any>undefined;
        data["totalHours"] = this.totalHours;
        data["action"] = this.action;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        data["notes"] = this.notes;
        data["longitude"] = this.longitude;
        data["latitude"] = this.latitude;
        data["clampNumber"] = this.clampNumber;
        return data;
    }

    clone(): ApplyActionInputDto {
        const json = this.toJSON();
        let result = new ApplyActionInputDto();
        result.init(json);
        return result;
    }
}

export interface IApplyActionInputDto {
    violationId: string | undefined;
    posTransactionId: string | undefined;
    cancelledItems: string[] | undefined;
    newViolationItems: string[] | undefined;
    excludePricingCalculations: boolean | undefined;
    violation: CreateViolationDto;
    totalHours: number | undefined;
    action: ViolationActions;
    attachments: CreateAttachmentDto[] | undefined;
    notes: string | undefined;
    longitude: number;
    latitude: number;
    clampNumber: string | undefined;
}

export class ApproveCancellationRequest implements IApproveCancellationRequest {
    requestId: string;
    notes: string | undefined;
    attachments: CreateAttachmentDto[] | undefined;

    constructor(data?: IApproveCancellationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestId = _data["requestId"];
            this.notes = _data["notes"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments.push(CreateAttachmentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ApproveCancellationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ApproveCancellationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestId"] = this.requestId;
        data["notes"] = this.notes;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        return data;
    }

    clone(): ApproveCancellationRequest {
        const json = this.toJSON();
        let result = new ApproveCancellationRequest();
        result.init(json);
        return result;
    }
}

export interface IApproveCancellationRequest {
    requestId: string;
    notes: string | undefined;
    attachments: CreateAttachmentDto[] | undefined;
}

export class Area implements IArea {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    nameEn: string | undefined;
    nameAr: string | undefined;
    cityId: number;
    city: City;
    districts: District[] | undefined;

    constructor(data?: IArea) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.nameEn = _data["nameEn"];
            this.nameAr = _data["nameAr"];
            this.cityId = _data["cityId"];
            this.city = _data["city"] ? City.fromJS(_data["city"]) : <any>undefined;
            if (Array.isArray(_data["districts"])) {
                this.districts = [] as any;
                for (let item of _data["districts"])
                    this.districts.push(District.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Area {
        data = typeof data === 'object' ? data : {};
        let result = new Area();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["nameEn"] = this.nameEn;
        data["nameAr"] = this.nameAr;
        data["cityId"] = this.cityId;
        data["city"] = this.city ? this.city.toJSON() : <any>undefined;
        if (Array.isArray(this.districts)) {
            data["districts"] = [];
            for (let item of this.districts)
                data["districts"].push(item.toJSON());
        }
        return data;
    }

    clone(): Area {
        const json = this.toJSON();
        let result = new Area();
        result.init(json);
        return result;
    }
}

export interface IArea {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    nameEn: string | undefined;
    nameAr: string | undefined;
    cityId: number;
    city: City;
    districts: District[] | undefined;
}

export class AreaDto implements IAreaDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    nameEn: string | undefined;
    nameAr: string | undefined;

    constructor(data?: IAreaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.nameEn = _data["nameEn"];
            this.nameAr = _data["nameAr"];
        }
    }

    static fromJS(data: any): AreaDto {
        data = typeof data === 'object' ? data : {};
        let result = new AreaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["nameEn"] = this.nameEn;
        data["nameAr"] = this.nameAr;
        return data;
    }

    clone(): AreaDto {
        const json = this.toJSON();
        let result = new AreaDto();
        result.init(json);
        return result;
    }
}

export interface IAreaDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    nameEn: string | undefined;
    nameAr: string | undefined;
}

export class AreaDtoPagedResultDto implements IAreaDtoPagedResultDto {
    items: AreaDto[] | undefined;
    totalCount: number;

    constructor(data?: IAreaDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(AreaDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): AreaDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AreaDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): AreaDtoPagedResultDto {
        const json = this.toJSON();
        let result = new AreaDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IAreaDtoPagedResultDto {
    items: AreaDto[] | undefined;
    totalCount: number;
}

export class AssignQRCodeInput implements IAssignQRCodeInput {
    qrCodeId: number;
    vehicleId: string;

    constructor(data?: IAssignQRCodeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qrCodeId = _data["qrCodeId"];
            this.vehicleId = _data["vehicleId"];
        }
    }

    static fromJS(data: any): AssignQRCodeInput {
        data = typeof data === 'object' ? data : {};
        let result = new AssignQRCodeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qrCodeId"] = this.qrCodeId;
        data["vehicleId"] = this.vehicleId;
        return data;
    }

    clone(): AssignQRCodeInput {
        const json = this.toJSON();
        let result = new AssignQRCodeInput();
        result.init(json);
        return result;
    }
}

export interface IAssignQRCodeInput {
    qrCodeId: number;
    vehicleId: string;
}

export class AssignStaffAccountInputDto implements IAssignStaffAccountInputDto {
    locationId: number;
    staffAccountId: number;

    constructor(data?: IAssignStaffAccountInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationId = _data["locationId"];
            this.staffAccountId = _data["staffAccountId"];
        }
    }

    static fromJS(data: any): AssignStaffAccountInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssignStaffAccountInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId;
        data["staffAccountId"] = this.staffAccountId;
        return data;
    }

    clone(): AssignStaffAccountInputDto {
        const json = this.toJSON();
        let result = new AssignStaffAccountInputDto();
        result.init(json);
        return result;
    }
}

export interface IAssignStaffAccountInputDto {
    locationId: number;
    staffAccountId: number;
}

export class AssignedLocationItemDto implements IAssignedLocationItemDto {
    id: number;
    name: string | undefined;

    constructor(data?: IAssignedLocationItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): AssignedLocationItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssignedLocationItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): AssignedLocationItemDto {
        const json = this.toJSON();
        let result = new AssignedLocationItemDto();
        result.init(json);
        return result;
    }
}

export interface IAssignedLocationItemDto {
    id: number;
    name: string | undefined;
}

export class AttachmentViewDto implements IAttachmentViewDto {
    attachmentName: string | undefined;
    path: string | undefined;
    creationTime: moment.Moment;
    creator: string | undefined;

    constructor(data?: IAttachmentViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attachmentName = _data["attachmentName"];
            this.path = _data["path"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creator = _data["creator"];
        }
    }

    static fromJS(data: any): AttachmentViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttachmentViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attachmentName"] = this.attachmentName;
        data["path"] = this.path;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creator"] = this.creator;
        return data;
    }

    clone(): AttachmentViewDto {
        const json = this.toJSON();
        let result = new AttachmentViewDto();
        result.init(json);
        return result;
    }
}

export interface IAttachmentViewDto {
    attachmentName: string | undefined;
    path: string | undefined;
    creationTime: moment.Moment;
    creator: string | undefined;
}

export class AuditLogListDto implements IAuditLogListDto {
    id: number;
    userId: number | undefined;
    userName: string | undefined;
    impersonatorTenantId: number | undefined;
    impersonatorUserId: number | undefined;
    serviceName: string | undefined;
    methodName: string | undefined;
    parameters: string | undefined;
    executionTime: moment.Moment;
    executionDuration: number;
    clientIpAddress: string | undefined;
    clientName: string | undefined;
    browserInfo: string | undefined;
    exception: string | undefined;
    customData: string | undefined;

    constructor(data?: IAuditLogListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.impersonatorTenantId = _data["impersonatorTenantId"];
            this.impersonatorUserId = _data["impersonatorUserId"];
            this.serviceName = _data["serviceName"];
            this.methodName = _data["methodName"];
            this.parameters = _data["parameters"];
            this.executionTime = _data["executionTime"] ? moment(_data["executionTime"].toString()) : <any>undefined;
            this.executionDuration = _data["executionDuration"];
            this.clientIpAddress = _data["clientIpAddress"];
            this.clientName = _data["clientName"];
            this.browserInfo = _data["browserInfo"];
            this.exception = _data["exception"];
            this.customData = _data["customData"];
        }
    }

    static fromJS(data: any): AuditLogListDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditLogListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["impersonatorTenantId"] = this.impersonatorTenantId;
        data["impersonatorUserId"] = this.impersonatorUserId;
        data["serviceName"] = this.serviceName;
        data["methodName"] = this.methodName;
        data["parameters"] = this.parameters;
        data["executionTime"] = this.executionTime ? this.executionTime.toISOString() : <any>undefined;
        data["executionDuration"] = this.executionDuration;
        data["clientIpAddress"] = this.clientIpAddress;
        data["clientName"] = this.clientName;
        data["browserInfo"] = this.browserInfo;
        data["exception"] = this.exception;
        data["customData"] = this.customData;
        return data;
    }

    clone(): AuditLogListDto {
        const json = this.toJSON();
        let result = new AuditLogListDto();
        result.init(json);
        return result;
    }
}

export interface IAuditLogListDto {
    id: number;
    userId: number | undefined;
    userName: string | undefined;
    impersonatorTenantId: number | undefined;
    impersonatorUserId: number | undefined;
    serviceName: string | undefined;
    methodName: string | undefined;
    parameters: string | undefined;
    executionTime: moment.Moment;
    executionDuration: number;
    clientIpAddress: string | undefined;
    clientName: string | undefined;
    browserInfo: string | undefined;
    exception: string | undefined;
    customData: string | undefined;
}

export class AuditLogListDtoPagedResultDto implements IAuditLogListDtoPagedResultDto {
    items: AuditLogListDto[] | undefined;
    totalCount: number;

    constructor(data?: IAuditLogListDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(AuditLogListDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): AuditLogListDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditLogListDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): AuditLogListDtoPagedResultDto {
        const json = this.toJSON();
        let result = new AuditLogListDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IAuditLogListDtoPagedResultDto {
    items: AuditLogListDto[] | undefined;
    totalCount: number;
}

export class AuthenticateModel implements IAuthenticateModel {
    userNameOrEmailAddress: string;
    password: string;
    rememberClient: boolean;

    constructor(data?: IAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userNameOrEmailAddress = _data["userNameOrEmailAddress"];
            this.password = _data["password"];
            this.rememberClient = _data["rememberClient"];
        }
    }

    static fromJS(data: any): AuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userNameOrEmailAddress"] = this.userNameOrEmailAddress;
        data["password"] = this.password;
        data["rememberClient"] = this.rememberClient;
        return data;
    }

    clone(): AuthenticateModel {
        const json = this.toJSON();
        let result = new AuthenticateModel();
        result.init(json);
        return result;
    }
}

export interface IAuthenticateModel {
    userNameOrEmailAddress: string;
    password: string;
    rememberClient: boolean;
}

export class AuthenticateResultModel implements IAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    userId: number;

    constructor(data?: IAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): AuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["userId"] = this.userId;
        return data;
    }

    clone(): AuthenticateResultModel {
        const json = this.toJSON();
        let result = new AuthenticateResultModel();
        result.init(json);
        return result;
    }
}

export interface IAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    userId: number;
}

export class BankTransferTransaction implements IBankTransferTransaction {
    referenceNumber: string | undefined;

    constructor(data?: IBankTransferTransaction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.referenceNumber = _data["referenceNumber"];
        }
    }

    static fromJS(data: any): BankTransferTransaction {
        data = typeof data === 'object' ? data : {};
        let result = new BankTransferTransaction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["referenceNumber"] = this.referenceNumber;
        return data;
    }

    clone(): BankTransferTransaction {
        const json = this.toJSON();
        let result = new BankTransferTransaction();
        result.init(json);
        return result;
    }
}

export interface IBankTransferTransaction {
    referenceNumber: string | undefined;
}

export class CancelParkingInvoiceRequest implements ICancelParkingInvoiceRequest {
    invoiceNumber: string | undefined;
    source: string | undefined;

    constructor(data?: ICancelParkingInvoiceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceNumber = _data["invoiceNumber"];
            this.source = _data["source"];
        }
    }

    static fromJS(data: any): CancelParkingInvoiceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CancelParkingInvoiceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceNumber"] = this.invoiceNumber;
        data["source"] = this.source;
        return data;
    }

    clone(): CancelParkingInvoiceRequest {
        const json = this.toJSON();
        let result = new CancelParkingInvoiceRequest();
        result.init(json);
        return result;
    }
}

export interface ICancelParkingInvoiceRequest {
    invoiceNumber: string | undefined;
    source: string | undefined;
}

export class CancellationRequest implements ICancellationRequest {
    id: string;
    readonly domainEvents: IEventData[] | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creatorUser: User;
    lastModifierUser: User;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    readonly requestNumber: number;
    readonly violationId: string;
    violation: Violation;
    requestType: RequestType;
    currentState: RequestState;
    readonly states: RequestState[] | undefined;

    constructor(data?: ICancellationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["domainEvents"])) {
                (<any>this).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (<any>this).domainEvents.push(IEventData.fromJS(item));
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            (<any>this).requestNumber = _data["requestNumber"];
            (<any>this).violationId = _data["violationId"];
            this.violation = _data["violation"] ? Violation.fromJS(_data["violation"]) : <any>undefined;
            this.requestType = _data["requestType"] ? RequestType.fromJS(_data["requestType"]) : <any>undefined;
            this.currentState = _data["currentState"] ? RequestState.fromJS(_data["currentState"]) : <any>undefined;
            if (Array.isArray(_data["states"])) {
                (<any>this).states = [] as any;
                for (let item of _data["states"])
                    (<any>this).states.push(RequestState.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CancellationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CancellationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item.toJSON());
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["requestNumber"] = this.requestNumber;
        data["violationId"] = this.violationId;
        data["violation"] = this.violation ? this.violation.toJSON() : <any>undefined;
        data["requestType"] = this.requestType ? this.requestType.toJSON() : <any>undefined;
        data["currentState"] = this.currentState ? this.currentState.toJSON() : <any>undefined;
        if (Array.isArray(this.states)) {
            data["states"] = [];
            for (let item of this.states)
                data["states"].push(item.toJSON());
        }
        return data;
    }

    clone(): CancellationRequest {
        const json = this.toJSON();
        let result = new CancellationRequest();
        result.init(json);
        return result;
    }
}

export interface ICancellationRequest {
    id: string;
    domainEvents: IEventData[] | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creatorUser: User;
    lastModifierUser: User;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    requestNumber: number;
    violationId: string;
    violation: Violation;
    requestType: RequestType;
    currentState: RequestState;
    states: RequestState[] | undefined;
}

export class CancellationRequestReadModel implements ICancellationRequestReadModel {
    id: string;
    violationCode: string | undefined;
    requestNumber: number;
    violationId: string;
    status: string | undefined;
    requestType: string | undefined;
    currentState: CancellationRequestStateReadModel;
    states: CancellationRequestStateReadModel[] | undefined;

    constructor(data?: ICancellationRequestReadModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.violationCode = _data["violationCode"];
            this.requestNumber = _data["requestNumber"];
            this.violationId = _data["violationId"];
            this.status = _data["status"];
            this.requestType = _data["requestType"];
            this.currentState = _data["currentState"] ? CancellationRequestStateReadModel.fromJS(_data["currentState"]) : <any>undefined;
            if (Array.isArray(_data["states"])) {
                this.states = [] as any;
                for (let item of _data["states"])
                    this.states.push(CancellationRequestStateReadModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CancellationRequestReadModel {
        data = typeof data === 'object' ? data : {};
        let result = new CancellationRequestReadModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["violationCode"] = this.violationCode;
        data["requestNumber"] = this.requestNumber;
        data["violationId"] = this.violationId;
        data["status"] = this.status;
        data["requestType"] = this.requestType;
        data["currentState"] = this.currentState ? this.currentState.toJSON() : <any>undefined;
        if (Array.isArray(this.states)) {
            data["states"] = [];
            for (let item of this.states)
                data["states"].push(item.toJSON());
        }
        return data;
    }

    clone(): CancellationRequestReadModel {
        const json = this.toJSON();
        let result = new CancellationRequestReadModel();
        result.init(json);
        return result;
    }
}

export interface ICancellationRequestReadModel {
    id: string;
    violationCode: string | undefined;
    requestNumber: number;
    violationId: string;
    status: string | undefined;
    requestType: string | undefined;
    currentState: CancellationRequestStateReadModel;
    states: CancellationRequestStateReadModel[] | undefined;
}

export class CancellationRequestResponse implements ICancellationRequestResponse {
    id: string;
    requestNumber: number;
    violationId: string;
    violationCode: string | undefined;
    requestType: string | undefined;
    currentState: CancellationRequestStateResponse;
    states: CancellationRequestStateResponse[] | undefined;

    constructor(data?: ICancellationRequestResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.requestNumber = _data["requestNumber"];
            this.violationId = _data["violationId"];
            this.violationCode = _data["violationCode"];
            this.requestType = _data["requestType"];
            this.currentState = _data["currentState"] ? CancellationRequestStateResponse.fromJS(_data["currentState"]) : <any>undefined;
            if (Array.isArray(_data["states"])) {
                this.states = [] as any;
                for (let item of _data["states"])
                    this.states.push(CancellationRequestStateResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CancellationRequestResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CancellationRequestResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["requestNumber"] = this.requestNumber;
        data["violationId"] = this.violationId;
        data["violationCode"] = this.violationCode;
        data["requestType"] = this.requestType;
        data["currentState"] = this.currentState ? this.currentState.toJSON() : <any>undefined;
        if (Array.isArray(this.states)) {
            data["states"] = [];
            for (let item of this.states)
                data["states"].push(item.toJSON());
        }
        return data;
    }

    clone(): CancellationRequestResponse {
        const json = this.toJSON();
        let result = new CancellationRequestResponse();
        result.init(json);
        return result;
    }
}

export interface ICancellationRequestResponse {
    id: string;
    requestNumber: number;
    violationId: string;
    violationCode: string | undefined;
    requestType: string | undefined;
    currentState: CancellationRequestStateResponse;
    states: CancellationRequestStateResponse[] | undefined;
}

export class CancellationRequestResponsePagedResultDto implements ICancellationRequestResponsePagedResultDto {
    items: CancellationRequestResponse[] | undefined;
    totalCount: number;

    constructor(data?: ICancellationRequestResponsePagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CancellationRequestResponse.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CancellationRequestResponsePagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CancellationRequestResponsePagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): CancellationRequestResponsePagedResultDto {
        const json = this.toJSON();
        let result = new CancellationRequestResponsePagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICancellationRequestResponsePagedResultDto {
    items: CancellationRequestResponse[] | undefined;
    totalCount: number;
}

export class CancellationRequestStateReadModel implements ICancellationRequestStateReadModel {
    id: string;
    status: string | undefined;
    notes: string | undefined;
    duration: number;
    isActive: boolean;
    creationTime: moment.Moment;
    actionTaker: string | undefined;
    attachments: AppAttachmentReadModel[] | undefined;

    constructor(data?: ICancellationRequestStateReadModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.notes = _data["notes"];
            this.duration = _data["duration"];
            this.isActive = _data["isActive"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.actionTaker = _data["actionTaker"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments.push(AppAttachmentReadModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CancellationRequestStateReadModel {
        data = typeof data === 'object' ? data : {};
        let result = new CancellationRequestStateReadModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["notes"] = this.notes;
        data["duration"] = this.duration;
        data["isActive"] = this.isActive;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["actionTaker"] = this.actionTaker;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        return data;
    }

    clone(): CancellationRequestStateReadModel {
        const json = this.toJSON();
        let result = new CancellationRequestStateReadModel();
        result.init(json);
        return result;
    }
}

export interface ICancellationRequestStateReadModel {
    id: string;
    status: string | undefined;
    notes: string | undefined;
    duration: number;
    isActive: boolean;
    creationTime: moment.Moment;
    actionTaker: string | undefined;
    attachments: AppAttachmentReadModel[] | undefined;
}

export class CancellationRequestStateResponse implements ICancellationRequestStateResponse {
    id: string;
    notes: string | undefined;
    duration: number;
    isActive: boolean;
    actionTaker: string | undefined;
    status: string | undefined;
    creationTime: moment.Moment;

    constructor(data?: ICancellationRequestStateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.notes = _data["notes"];
            this.duration = _data["duration"];
            this.isActive = _data["isActive"];
            this.actionTaker = _data["actionTaker"];
            this.status = _data["status"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CancellationRequestStateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CancellationRequestStateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["notes"] = this.notes;
        data["duration"] = this.duration;
        data["isActive"] = this.isActive;
        data["actionTaker"] = this.actionTaker;
        data["status"] = this.status;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): CancellationRequestStateResponse {
        const json = this.toJSON();
        let result = new CancellationRequestStateResponse();
        result.init(json);
        return result;
    }
}

export interface ICancellationRequestStateResponse {
    id: string;
    notes: string | undefined;
    duration: number;
    isActive: boolean;
    actionTaker: string | undefined;
    status: string | undefined;
    creationTime: moment.Moment;
}

export class CarPlate implements ICarPlate {
    countryCode: string | undefined;
    letters: string | undefined;
    digits: number;
    readonly fullCarPlate: string | undefined;
    vehicleType: VehicleType;

    constructor(data?: ICarPlate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryCode = _data["countryCode"];
            this.letters = _data["letters"];
            this.digits = _data["digits"];
            (<any>this).fullCarPlate = _data["fullCarPlate"];
            this.vehicleType = _data["vehicleType"];
        }
    }

    static fromJS(data: any): CarPlate {
        data = typeof data === 'object' ? data : {};
        let result = new CarPlate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryCode"] = this.countryCode;
        data["letters"] = this.letters;
        data["digits"] = this.digits;
        data["fullCarPlate"] = this.fullCarPlate;
        data["vehicleType"] = this.vehicleType;
        return data;
    }

    clone(): CarPlate {
        const json = this.toJSON();
        let result = new CarPlate();
        result.init(json);
        return result;
    }
}

export interface ICarPlate {
    countryCode: string | undefined;
    letters: string | undefined;
    digits: number;
    fullCarPlate: string | undefined;
    vehicleType: VehicleType;
}

export class ChangePasswordDto implements IChangePasswordDto {
    currentPassword: string;
    newPassword: string;

    constructor(data?: IChangePasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPassword = _data["currentPassword"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPassword"] = this.currentPassword;
        data["newPassword"] = this.newPassword;
        return data;
    }

    clone(): ChangePasswordDto {
        const json = this.toJSON();
        let result = new ChangePasswordDto();
        result.init(json);
        return result;
    }
}

export interface IChangePasswordDto {
    currentPassword: string;
    newPassword: string;
}

export class ChangeUiThemeInput implements IChangeUiThemeInput {
    theme: string;

    constructor(data?: IChangeUiThemeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.theme = _data["theme"];
        }
    }

    static fromJS(data: any): ChangeUiThemeInput {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUiThemeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["theme"] = this.theme;
        return data;
    }

    clone(): ChangeUiThemeInput {
        const json = this.toJSON();
        let result = new ChangeUiThemeInput();
        result.init(json);
        return result;
    }
}

export interface IChangeUiThemeInput {
    theme: string;
}

export class ChangeUserLanguageDto implements IChangeUserLanguageDto {
    languageName: string;

    constructor(data?: IChangeUserLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageName = _data["languageName"];
        }
    }

    static fromJS(data: any): ChangeUserLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUserLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageName"] = this.languageName;
        return data;
    }

    clone(): ChangeUserLanguageDto {
        const json = this.toJSON();
        let result = new ChangeUserLanguageDto();
        result.init(json);
        return result;
    }
}

export interface IChangeUserLanguageDto {
    languageName: string;
}

export class CheckCertificateDto implements ICheckCertificateDto {
    cert: string | undefined;

    constructor(data?: ICheckCertificateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cert = _data["cert"];
        }
    }

    static fromJS(data: any): CheckCertificateDto {
        data = typeof data === 'object' ? data : {};
        let result = new CheckCertificateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cert"] = this.cert;
        return data;
    }

    clone(): CheckCertificateDto {
        const json = this.toJSON();
        let result = new CheckCertificateDto();
        result.init(json);
        return result;
    }
}

export interface ICheckCertificateDto {
    cert: string | undefined;
}

export class CheckoutReservationOutput implements ICheckoutReservationOutput {
    reservationId: string;
    reservationDetailsId: string;
    invoiceNumber: number;
    transactionId: string | undefined;
    reservationCode: string | undefined;
    hours: number;
    hourRate: number;
    vatAmount: number;
    vatPercentage: number;
    subTotal: number;
    total: number;
    integrity: string | undefined;
    shouldRenew: boolean | undefined;

    constructor(data?: ICheckoutReservationOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reservationId = _data["reservationId"];
            this.reservationDetailsId = _data["reservationDetailsId"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.transactionId = _data["transactionId"];
            this.reservationCode = _data["reservationCode"];
            this.hours = _data["hours"];
            this.hourRate = _data["hourRate"];
            this.vatAmount = _data["vatAmount"];
            this.vatPercentage = _data["vatPercentage"];
            this.subTotal = _data["subTotal"];
            this.total = _data["total"];
            this.integrity = _data["integrity"];
            this.shouldRenew = _data["shouldRenew"];
        }
    }

    static fromJS(data: any): CheckoutReservationOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CheckoutReservationOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reservationId"] = this.reservationId;
        data["reservationDetailsId"] = this.reservationDetailsId;
        data["invoiceNumber"] = this.invoiceNumber;
        data["transactionId"] = this.transactionId;
        data["reservationCode"] = this.reservationCode;
        data["hours"] = this.hours;
        data["hourRate"] = this.hourRate;
        data["vatAmount"] = this.vatAmount;
        data["vatPercentage"] = this.vatPercentage;
        data["subTotal"] = this.subTotal;
        data["total"] = this.total;
        data["integrity"] = this.integrity;
        data["shouldRenew"] = this.shouldRenew;
        return data;
    }

    clone(): CheckoutReservationOutput {
        const json = this.toJSON();
        let result = new CheckoutReservationOutput();
        result.init(json);
        return result;
    }
}

export interface ICheckoutReservationOutput {
    reservationId: string;
    reservationDetailsId: string;
    invoiceNumber: number;
    transactionId: string | undefined;
    reservationCode: string | undefined;
    hours: number;
    hourRate: number;
    vatAmount: number;
    vatPercentage: number;
    subTotal: number;
    total: number;
    integrity: string | undefined;
    shouldRenew: boolean | undefined;
}

export class CheckoutReservationResponseDto implements ICheckoutReservationResponseDto {

    constructor(data?: ICheckoutReservationResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): CheckoutReservationResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CheckoutReservationResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): CheckoutReservationResponseDto {
        const json = this.toJSON();
        let result = new CheckoutReservationResponseDto();
        result.init(json);
        return result;
    }
}

export interface ICheckoutReservationResponseDto {
}

export class CheckoutViolationDto implements ICheckoutViolationDto {
    transactionId: string | undefined;
    integrity: string | undefined;

    constructor(data?: ICheckoutViolationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transactionId = _data["transactionId"];
            this.integrity = _data["integrity"];
        }
    }

    static fromJS(data: any): CheckoutViolationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CheckoutViolationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionId"] = this.transactionId;
        data["integrity"] = this.integrity;
        return data;
    }

    clone(): CheckoutViolationDto {
        const json = this.toJSON();
        let result = new CheckoutViolationDto();
        result.init(json);
        return result;
    }
}

export interface ICheckoutViolationDto {
    transactionId: string | undefined;
    integrity: string | undefined;
}

export class CheckoutViolationInput implements ICheckoutViolationInput {
    violationId: string;
    paymentMethodId: number;

    constructor(data?: ICheckoutViolationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.violationId = _data["violationId"];
            this.paymentMethodId = _data["paymentMethodId"];
        }
    }

    static fromJS(data: any): CheckoutViolationInput {
        data = typeof data === 'object' ? data : {};
        let result = new CheckoutViolationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["violationId"] = this.violationId;
        data["paymentMethodId"] = this.paymentMethodId;
        return data;
    }

    clone(): CheckoutViolationInput {
        const json = this.toJSON();
        let result = new CheckoutViolationInput();
        result.init(json);
        return result;
    }
}

export interface ICheckoutViolationInput {
    violationId: string;
    paymentMethodId: number;
}

export class City implements ICity {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    nameEn: string | undefined;
    nameAr: string | undefined;
    countryId: number;
    country: Country;
    areas: Area[] | undefined;

    constructor(data?: ICity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.nameEn = _data["nameEn"];
            this.nameAr = _data["nameAr"];
            this.countryId = _data["countryId"];
            this.country = _data["country"] ? Country.fromJS(_data["country"]) : <any>undefined;
            if (Array.isArray(_data["areas"])) {
                this.areas = [] as any;
                for (let item of _data["areas"])
                    this.areas.push(Area.fromJS(item));
            }
        }
    }

    static fromJS(data: any): City {
        data = typeof data === 'object' ? data : {};
        let result = new City();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["nameEn"] = this.nameEn;
        data["nameAr"] = this.nameAr;
        data["countryId"] = this.countryId;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        if (Array.isArray(this.areas)) {
            data["areas"] = [];
            for (let item of this.areas)
                data["areas"].push(item.toJSON());
        }
        return data;
    }

    clone(): City {
        const json = this.toJSON();
        let result = new City();
        result.init(json);
        return result;
    }
}

export interface ICity {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    nameEn: string | undefined;
    nameAr: string | undefined;
    countryId: number;
    country: Country;
    areas: Area[] | undefined;
}

export class CityDto implements ICityDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    nameEn: string | undefined;
    nameAr: string | undefined;

    constructor(data?: ICityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.nameEn = _data["nameEn"];
            this.nameAr = _data["nameAr"];
        }
    }

    static fromJS(data: any): CityDto {
        data = typeof data === 'object' ? data : {};
        let result = new CityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["nameEn"] = this.nameEn;
        data["nameAr"] = this.nameAr;
        return data;
    }

    clone(): CityDto {
        const json = this.toJSON();
        let result = new CityDto();
        result.init(json);
        return result;
    }
}

export interface ICityDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    nameEn: string | undefined;
    nameAr: string | undefined;
}

export class CityDtoPagedResultDto implements ICityDtoPagedResultDto {
    items: CityDto[] | undefined;
    totalCount: number;

    constructor(data?: ICityDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CityDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CityDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CityDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): CityDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CityDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICityDtoPagedResultDto {
    items: CityDto[] | undefined;
    totalCount: number;
}

export class CompanyProjectDetails implements ICompanyProjectDetails {
    company: string;
    project: string | undefined;
    site: string | undefined;

    constructor(data?: ICompanyProjectDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.company = _data["company"];
            this.project = _data["project"];
            this.site = _data["site"];
        }
    }

    static fromJS(data: any): CompanyProjectDetails {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyProjectDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["company"] = this.company;
        data["project"] = this.project;
        data["site"] = this.site;
        return data;
    }

    clone(): CompanyProjectDetails {
        const json = this.toJSON();
        let result = new CompanyProjectDetails();
        result.init(json);
        return result;
    }
}

export interface ICompanyProjectDetails {
    company: string;
    project: string | undefined;
    site: string | undefined;
}

export class CompanyProjectDetailsResponse implements ICompanyProjectDetailsResponse {
    company: string | undefined;
    project: string | undefined;
    site: string | undefined;

    constructor(data?: ICompanyProjectDetailsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.company = _data["company"];
            this.project = _data["project"];
            this.site = _data["site"];
        }
    }

    static fromJS(data: any): CompanyProjectDetailsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyProjectDetailsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["company"] = this.company;
        data["project"] = this.project;
        data["site"] = this.site;
        return data;
    }

    clone(): CompanyProjectDetailsResponse {
        const json = this.toJSON();
        let result = new CompanyProjectDetailsResponse();
        result.init(json);
        return result;
    }
}

export interface ICompanyProjectDetailsResponse {
    company: string | undefined;
    project: string | undefined;
    site: string | undefined;
}

export class ConfirmPaymentOutput implements IConfirmPaymentOutput {
    transaction: TransactionResponse;
    violation: ConfirmPaymentViolationDto;
    reporting: ReportDetailsResponse;

    constructor(data?: IConfirmPaymentOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transaction = _data["transaction"] ? TransactionResponse.fromJS(_data["transaction"]) : <any>undefined;
            this.violation = _data["violation"] ? ConfirmPaymentViolationDto.fromJS(_data["violation"]) : <any>undefined;
            this.reporting = _data["reporting"] ? ReportDetailsResponse.fromJS(_data["reporting"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ConfirmPaymentOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmPaymentOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transaction"] = this.transaction ? this.transaction.toJSON() : <any>undefined;
        data["violation"] = this.violation ? this.violation.toJSON() : <any>undefined;
        data["reporting"] = this.reporting ? this.reporting.toJSON() : <any>undefined;
        return data;
    }

    clone(): ConfirmPaymentOutput {
        const json = this.toJSON();
        let result = new ConfirmPaymentOutput();
        result.init(json);
        return result;
    }
}

export interface IConfirmPaymentOutput {
    transaction: TransactionResponse;
    violation: ConfirmPaymentViolationDto;
    reporting: ReportDetailsResponse;
}

export class ConfirmPaymentViolationDto implements IConfirmPaymentViolationDto {
    id: string;
    code: number;
    carPlate: CarPlate;
    vehicle: VehicleDto;
    customerName: string | undefined;
    phoneNumber: string | undefined;
    latitude: number | undefined;
    longitude: number | undefined;
    reservationId: string | undefined;
    reservation: ReservationDto;
    shift: StaffAccountShiftDto;
    location: LocationListDto;
    slot: SlotListDto;
    violationItems: ViolationItemDto[] | undefined;
    reservedTimeDetails: ReservedTimeDetailsDto;
    notes: string | undefined;
    currency: string | undefined;
    total: number;
    subTotal: number;
    vatAmount: number;
    creationTime: moment.Moment;
    creator: string | undefined;
    clampNumber: string | undefined;
    statusId: number;
    status: string | undefined;

    constructor(data?: IConfirmPaymentViolationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.carPlate = _data["carPlate"] ? CarPlate.fromJS(_data["carPlate"]) : <any>undefined;
            this.vehicle = _data["vehicle"] ? VehicleDto.fromJS(_data["vehicle"]) : <any>undefined;
            this.customerName = _data["customerName"];
            this.phoneNumber = _data["phoneNumber"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.reservationId = _data["reservationId"];
            this.reservation = _data["reservation"] ? ReservationDto.fromJS(_data["reservation"]) : <any>undefined;
            this.shift = _data["shift"] ? StaffAccountShiftDto.fromJS(_data["shift"]) : <any>undefined;
            this.location = _data["location"] ? LocationListDto.fromJS(_data["location"]) : <any>undefined;
            this.slot = _data["slot"] ? SlotListDto.fromJS(_data["slot"]) : <any>undefined;
            if (Array.isArray(_data["violationItems"])) {
                this.violationItems = [] as any;
                for (let item of _data["violationItems"])
                    this.violationItems.push(ViolationItemDto.fromJS(item));
            }
            this.reservedTimeDetails = _data["reservedTimeDetails"] ? ReservedTimeDetailsDto.fromJS(_data["reservedTimeDetails"]) : <any>undefined;
            this.notes = _data["notes"];
            this.currency = _data["currency"];
            this.total = _data["total"];
            this.subTotal = _data["subTotal"];
            this.vatAmount = _data["vatAmount"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creator = _data["creator"];
            this.clampNumber = _data["clampNumber"];
            this.statusId = _data["statusId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ConfirmPaymentViolationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmPaymentViolationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["carPlate"] = this.carPlate ? this.carPlate.toJSON() : <any>undefined;
        data["vehicle"] = this.vehicle ? this.vehicle.toJSON() : <any>undefined;
        data["customerName"] = this.customerName;
        data["phoneNumber"] = this.phoneNumber;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["reservationId"] = this.reservationId;
        data["reservation"] = this.reservation ? this.reservation.toJSON() : <any>undefined;
        data["shift"] = this.shift ? this.shift.toJSON() : <any>undefined;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["slot"] = this.slot ? this.slot.toJSON() : <any>undefined;
        if (Array.isArray(this.violationItems)) {
            data["violationItems"] = [];
            for (let item of this.violationItems)
                data["violationItems"].push(item.toJSON());
        }
        data["reservedTimeDetails"] = this.reservedTimeDetails ? this.reservedTimeDetails.toJSON() : <any>undefined;
        data["notes"] = this.notes;
        data["currency"] = this.currency;
        data["total"] = this.total;
        data["subTotal"] = this.subTotal;
        data["vatAmount"] = this.vatAmount;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creator"] = this.creator;
        data["clampNumber"] = this.clampNumber;
        data["statusId"] = this.statusId;
        data["status"] = this.status;
        return data;
    }

    clone(): ConfirmPaymentViolationDto {
        const json = this.toJSON();
        let result = new ConfirmPaymentViolationDto();
        result.init(json);
        return result;
    }
}

export interface IConfirmPaymentViolationDto {
    id: string;
    code: number;
    carPlate: CarPlate;
    vehicle: VehicleDto;
    customerName: string | undefined;
    phoneNumber: string | undefined;
    latitude: number | undefined;
    longitude: number | undefined;
    reservationId: string | undefined;
    reservation: ReservationDto;
    shift: StaffAccountShiftDto;
    location: LocationListDto;
    slot: SlotListDto;
    violationItems: ViolationItemDto[] | undefined;
    reservedTimeDetails: ReservedTimeDetailsDto;
    notes: string | undefined;
    currency: string | undefined;
    total: number;
    subTotal: number;
    vatAmount: number;
    creationTime: moment.Moment;
    creator: string | undefined;
    clampNumber: string | undefined;
    statusId: number;
    status: string | undefined;
}

export class ConfirmViolationPaymentInput implements IConfirmViolationPaymentInput {
    transactionId: string | undefined;
    resourcePath: string | undefined;

    constructor(data?: IConfirmViolationPaymentInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transactionId = _data["transactionId"];
            this.resourcePath = _data["resourcePath"];
        }
    }

    static fromJS(data: any): ConfirmViolationPaymentInput {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmViolationPaymentInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionId"] = this.transactionId;
        data["resourcePath"] = this.resourcePath;
        return data;
    }

    clone(): ConfirmViolationPaymentInput {
        const json = this.toJSON();
        let result = new ConfirmViolationPaymentInput();
        result.init(json);
        return result;
    }
}

export interface IConfirmViolationPaymentInput {
    transactionId: string | undefined;
    resourcePath: string | undefined;
}

export class Coordinate implements ICoordinate {
    x: number;
    y: number;
    z: number;
    m: number;
    coordinateValue: Coordinate;
    readonly isValid: boolean;

    constructor(data?: ICoordinate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.x = _data["x"];
            this.y = _data["y"];
            this.z = _data["z"];
            this.m = _data["m"];
            this.coordinateValue = _data["coordinateValue"] ? Coordinate.fromJS(_data["coordinateValue"]) : <any>undefined;
            (<any>this).isValid = _data["isValid"];
        }
    }

    static fromJS(data: any): Coordinate {
        data = typeof data === 'object' ? data : {};
        let result = new Coordinate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["x"] = this.x;
        data["y"] = this.y;
        data["z"] = this.z;
        data["m"] = this.m;
        data["coordinateValue"] = this.coordinateValue ? this.coordinateValue.toJSON() : <any>undefined;
        data["isValid"] = this.isValid;
        return data;
    }

    clone(): Coordinate {
        const json = this.toJSON();
        let result = new Coordinate();
        result.init(json);
        return result;
    }
}

export interface ICoordinate {
    x: number;
    y: number;
    z: number;
    m: number;
    coordinateValue: Coordinate;
    isValid: boolean;
}

export class CoordinateEqualityComparer implements ICoordinateEqualityComparer {

    constructor(data?: ICoordinateEqualityComparer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): CoordinateEqualityComparer {
        data = typeof data === 'object' ? data : {};
        let result = new CoordinateEqualityComparer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): CoordinateEqualityComparer {
        const json = this.toJSON();
        let result = new CoordinateEqualityComparer();
        result.init(json);
        return result;
    }
}

export interface ICoordinateEqualityComparer {
}

export class CoordinateSequence implements ICoordinateSequence {
    readonly dimension: number;
    readonly measures: number;
    readonly spatial: number;
    ordinates: Ordinates;
    readonly hasZ: boolean;
    readonly hasM: boolean;
    readonly zOrdinateIndex: number;
    readonly mOrdinateIndex: number;
    first: Coordinate;
    last: Coordinate;
    readonly count: number;

    constructor(data?: ICoordinateSequence) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).dimension = _data["dimension"];
            (<any>this).measures = _data["measures"];
            (<any>this).spatial = _data["spatial"];
            this.ordinates = _data["ordinates"];
            (<any>this).hasZ = _data["hasZ"];
            (<any>this).hasM = _data["hasM"];
            (<any>this).zOrdinateIndex = _data["zOrdinateIndex"];
            (<any>this).mOrdinateIndex = _data["mOrdinateIndex"];
            this.first = _data["first"] ? Coordinate.fromJS(_data["first"]) : <any>undefined;
            this.last = _data["last"] ? Coordinate.fromJS(_data["last"]) : <any>undefined;
            (<any>this).count = _data["count"];
        }
    }

    static fromJS(data: any): CoordinateSequence {
        data = typeof data === 'object' ? data : {};
        let result = new CoordinateSequence();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dimension"] = this.dimension;
        data["measures"] = this.measures;
        data["spatial"] = this.spatial;
        data["ordinates"] = this.ordinates;
        data["hasZ"] = this.hasZ;
        data["hasM"] = this.hasM;
        data["zOrdinateIndex"] = this.zOrdinateIndex;
        data["mOrdinateIndex"] = this.mOrdinateIndex;
        data["first"] = this.first ? this.first.toJSON() : <any>undefined;
        data["last"] = this.last ? this.last.toJSON() : <any>undefined;
        data["count"] = this.count;
        return data;
    }

    clone(): CoordinateSequence {
        const json = this.toJSON();
        let result = new CoordinateSequence();
        result.init(json);
        return result;
    }
}

export interface ICoordinateSequence {
    dimension: number;
    measures: number;
    spatial: number;
    ordinates: Ordinates;
    hasZ: boolean;
    hasM: boolean;
    zOrdinateIndex: number;
    mOrdinateIndex: number;
    first: Coordinate;
    last: Coordinate;
    count: number;
}

export class CoordinateSequenceFactory implements ICoordinateSequenceFactory {
    ordinates: Ordinates;

    constructor(data?: ICoordinateSequenceFactory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ordinates = _data["ordinates"];
        }
    }

    static fromJS(data: any): CoordinateSequenceFactory {
        data = typeof data === 'object' ? data : {};
        let result = new CoordinateSequenceFactory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ordinates"] = this.ordinates;
        return data;
    }

    clone(): CoordinateSequenceFactory {
        const json = this.toJSON();
        let result = new CoordinateSequenceFactory();
        result.init(json);
        return result;
    }
}

export interface ICoordinateSequenceFactory {
    ordinates: Ordinates;
}

export class Country implements ICountry {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    nameEn: string | undefined;
    nameAr: string | undefined;
    code: string | undefined;
    cities: City[] | undefined;
    plateMapLetters: PlateMapLetter[] | undefined;
    plateValidations: PlateValidation[] | undefined;

    constructor(data?: ICountry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.nameEn = _data["nameEn"];
            this.nameAr = _data["nameAr"];
            this.code = _data["code"];
            if (Array.isArray(_data["cities"])) {
                this.cities = [] as any;
                for (let item of _data["cities"])
                    this.cities.push(City.fromJS(item));
            }
            if (Array.isArray(_data["plateMapLetters"])) {
                this.plateMapLetters = [] as any;
                for (let item of _data["plateMapLetters"])
                    this.plateMapLetters.push(PlateMapLetter.fromJS(item));
            }
            if (Array.isArray(_data["plateValidations"])) {
                this.plateValidations = [] as any;
                for (let item of _data["plateValidations"])
                    this.plateValidations.push(PlateValidation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Country {
        data = typeof data === 'object' ? data : {};
        let result = new Country();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["nameEn"] = this.nameEn;
        data["nameAr"] = this.nameAr;
        data["code"] = this.code;
        if (Array.isArray(this.cities)) {
            data["cities"] = [];
            for (let item of this.cities)
                data["cities"].push(item.toJSON());
        }
        if (Array.isArray(this.plateMapLetters)) {
            data["plateMapLetters"] = [];
            for (let item of this.plateMapLetters)
                data["plateMapLetters"].push(item.toJSON());
        }
        if (Array.isArray(this.plateValidations)) {
            data["plateValidations"] = [];
            for (let item of this.plateValidations)
                data["plateValidations"].push(item.toJSON());
        }
        return data;
    }

    clone(): Country {
        const json = this.toJSON();
        let result = new Country();
        result.init(json);
        return result;
    }
}

export interface ICountry {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    nameEn: string | undefined;
    nameAr: string | undefined;
    code: string | undefined;
    cities: City[] | undefined;
    plateMapLetters: PlateMapLetter[] | undefined;
    plateValidations: PlateValidation[] | undefined;
}

export class CountryCarPlateMappingLettersDto implements ICountryCarPlateMappingLettersDto {
    mappingKey: string;
    mappingValue: string;

    constructor(data?: ICountryCarPlateMappingLettersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mappingKey = _data["mappingKey"];
            this.mappingValue = _data["mappingValue"];
        }
    }

    static fromJS(data: any): CountryCarPlateMappingLettersDto {
        data = typeof data === 'object' ? data : {};
        let result = new CountryCarPlateMappingLettersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mappingKey"] = this.mappingKey;
        data["mappingValue"] = this.mappingValue;
        return data;
    }

    clone(): CountryCarPlateMappingLettersDto {
        const json = this.toJSON();
        let result = new CountryCarPlateMappingLettersDto();
        result.init(json);
        return result;
    }
}

export interface ICountryCarPlateMappingLettersDto {
    mappingKey: string;
    mappingValue: string;
}

export class CountryDto implements ICountryDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    nameEn: string | undefined;
    nameAr: string | undefined;
    code: string | undefined;
    plateValidations: PlateValidationDto[] | undefined;
    mapping: CountryCarPlateMappingLettersDto[] | undefined;

    constructor(data?: ICountryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.nameEn = _data["nameEn"];
            this.nameAr = _data["nameAr"];
            this.code = _data["code"];
            if (Array.isArray(_data["plateValidations"])) {
                this.plateValidations = [] as any;
                for (let item of _data["plateValidations"])
                    this.plateValidations.push(PlateValidationDto.fromJS(item));
            }
            if (Array.isArray(_data["mapping"])) {
                this.mapping = [] as any;
                for (let item of _data["mapping"])
                    this.mapping.push(CountryCarPlateMappingLettersDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CountryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CountryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["nameEn"] = this.nameEn;
        data["nameAr"] = this.nameAr;
        data["code"] = this.code;
        if (Array.isArray(this.plateValidations)) {
            data["plateValidations"] = [];
            for (let item of this.plateValidations)
                data["plateValidations"].push(item.toJSON());
        }
        if (Array.isArray(this.mapping)) {
            data["mapping"] = [];
            for (let item of this.mapping)
                data["mapping"].push(item.toJSON());
        }
        return data;
    }

    clone(): CountryDto {
        const json = this.toJSON();
        let result = new CountryDto();
        result.init(json);
        return result;
    }
}

export interface ICountryDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    nameEn: string | undefined;
    nameAr: string | undefined;
    code: string | undefined;
    plateValidations: PlateValidationDto[] | undefined;
    mapping: CountryCarPlateMappingLettersDto[] | undefined;
}

export class CountryDtoPagedResultDto implements ICountryDtoPagedResultDto {
    items: CountryDto[] | undefined;
    totalCount: number;

    constructor(data?: ICountryDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CountryDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CountryDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CountryDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): CountryDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CountryDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICountryDtoPagedResultDto {
    items: CountryDto[] | undefined;
    totalCount: number;
}

export class CountryListDto implements ICountryListDto {
    id: number;
    nameEn: string | undefined;
    nameAr: string | undefined;
    code: string | undefined;
    carPlateMapLetters: CountryCarPlateMappingLettersDto[] | undefined;

    constructor(data?: ICountryListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.nameEn = _data["nameEn"];
            this.nameAr = _data["nameAr"];
            this.code = _data["code"];
            if (Array.isArray(_data["carPlateMapLetters"])) {
                this.carPlateMapLetters = [] as any;
                for (let item of _data["carPlateMapLetters"])
                    this.carPlateMapLetters.push(CountryCarPlateMappingLettersDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CountryListDto {
        data = typeof data === 'object' ? data : {};
        let result = new CountryListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["nameEn"] = this.nameEn;
        data["nameAr"] = this.nameAr;
        data["code"] = this.code;
        if (Array.isArray(this.carPlateMapLetters)) {
            data["carPlateMapLetters"] = [];
            for (let item of this.carPlateMapLetters)
                data["carPlateMapLetters"].push(item.toJSON());
        }
        return data;
    }

    clone(): CountryListDto {
        const json = this.toJSON();
        let result = new CountryListDto();
        result.init(json);
        return result;
    }
}

export interface ICountryListDto {
    id: number;
    nameEn: string | undefined;
    nameAr: string | undefined;
    code: string | undefined;
    carPlateMapLetters: CountryCarPlateMappingLettersDto[] | undefined;
}

export class CountryResponse implements ICountryResponse {
    id: number;
    nameEn: string | undefined;
    nameAr: string | undefined;
    code: string | undefined;

    constructor(data?: ICountryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.nameEn = _data["nameEn"];
            this.nameAr = _data["nameAr"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): CountryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CountryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["nameEn"] = this.nameEn;
        data["nameAr"] = this.nameAr;
        data["code"] = this.code;
        return data;
    }

    clone(): CountryResponse {
        const json = this.toJSON();
        let result = new CountryResponse();
        result.init(json);
        return result;
    }
}

export interface ICountryResponse {
    id: number;
    nameEn: string | undefined;
    nameAr: string | undefined;
    code: string | undefined;
}

export class CreateAddressCommand implements ICreateAddressCommand {
    country: string | undefined;
    city: string | undefined;
    location: string | undefined;

    constructor(data?: ICreateAddressCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.country = _data["country"];
            this.city = _data["city"];
            this.location = _data["location"];
        }
    }

    static fromJS(data: any): CreateAddressCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAddressCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["country"] = this.country;
        data["city"] = this.city;
        data["location"] = this.location;
        return data;
    }

    clone(): CreateAddressCommand {
        const json = this.toJSON();
        let result = new CreateAddressCommand();
        result.init(json);
        return result;
    }
}

export interface ICreateAddressCommand {
    country: string | undefined;
    city: string | undefined;
    location: string | undefined;
}

export class CreateAttachmentDto implements ICreateAttachmentDto {
    attachmentName: string | undefined;
    path: string | undefined;

    constructor(data?: ICreateAttachmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attachmentName = _data["attachmentName"];
            this.path = _data["path"];
        }
    }

    static fromJS(data: any): CreateAttachmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAttachmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attachmentName"] = this.attachmentName;
        data["path"] = this.path;
        return data;
    }

    clone(): CreateAttachmentDto {
        const json = this.toJSON();
        let result = new CreateAttachmentDto();
        result.init(json);
        return result;
    }
}

export interface ICreateAttachmentDto {
    attachmentName: string | undefined;
    path: string | undefined;
}

export class CreateCashReservationInputDto implements ICreateCashReservationInputDto {
    slotId: number;
    hours: number;
    carPlateDigits: number;
    carPlateLetters: string | undefined;
    countryCode: string | undefined;
    phoneNumber: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    vehicleType: VehicleType;
    mobilityType: string | undefined;

    constructor(data?: ICreateCashReservationInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.slotId = _data["slotId"];
            this.hours = _data["hours"];
            this.carPlateDigits = _data["carPlateDigits"];
            this.carPlateLetters = _data["carPlateLetters"];
            this.countryCode = _data["countryCode"];
            this.phoneNumber = _data["phoneNumber"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.vehicleType = _data["vehicleType"];
            this.mobilityType = _data["mobilityType"];
        }
    }

    static fromJS(data: any): CreateCashReservationInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCashReservationInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["slotId"] = this.slotId;
        data["hours"] = this.hours;
        data["carPlateDigits"] = this.carPlateDigits;
        data["carPlateLetters"] = this.carPlateLetters;
        data["countryCode"] = this.countryCode;
        data["phoneNumber"] = this.phoneNumber;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["vehicleType"] = this.vehicleType;
        data["mobilityType"] = this.mobilityType;
        return data;
    }

    clone(): CreateCashReservationInputDto {
        const json = this.toJSON();
        let result = new CreateCashReservationInputDto();
        result.init(json);
        return result;
    }
}

export interface ICreateCashReservationInputDto {
    slotId: number;
    hours: number;
    carPlateDigits: number;
    carPlateLetters: string | undefined;
    countryCode: string | undefined;
    phoneNumber: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    vehicleType: VehicleType;
    mobilityType: string | undefined;
}

export class CreateCompanyProjectDetailsCommand implements ICreateCompanyProjectDetailsCommand {
    company: string | undefined;
    project: string | undefined;
    site: string | undefined;

    constructor(data?: ICreateCompanyProjectDetailsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.company = _data["company"];
            this.project = _data["project"];
            this.site = _data["site"];
        }
    }

    static fromJS(data: any): CreateCompanyProjectDetailsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCompanyProjectDetailsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["company"] = this.company;
        data["project"] = this.project;
        data["site"] = this.site;
        return data;
    }

    clone(): CreateCompanyProjectDetailsCommand {
        const json = this.toJSON();
        let result = new CreateCompanyProjectDetailsCommand();
        result.init(json);
        return result;
    }
}

export interface ICreateCompanyProjectDetailsCommand {
    company: string | undefined;
    project: string | undefined;
    site: string | undefined;
}

export class CreateCustomerInput implements ICreateCustomerInput {
    firstName: string | undefined;
    lastName: string | undefined;
    phoneNumber: string | undefined;
    isActive: boolean;

    constructor(data?: ICreateCustomerInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phoneNumber = _data["phoneNumber"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CreateCustomerInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCustomerInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phoneNumber"] = this.phoneNumber;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): CreateCustomerInput {
        const json = this.toJSON();
        let result = new CreateCustomerInput();
        result.init(json);
        return result;
    }
}

export interface ICreateCustomerInput {
    firstName: string | undefined;
    lastName: string | undefined;
    phoneNumber: string | undefined;
    isActive: boolean;
}

export class CreateIntegratedInvoiceDto implements ICreateIntegratedInvoiceDto {
    company: string | undefined;
    customerVATCode: string | undefined;
    country: string | undefined;
    city: string | undefined;
    location: string | undefined;
    project: string | undefined;
    site: string | undefined;
    details: string | undefined;
    cashierID: number;
    shift: number;
    invoiceNo: string | undefined;
    date: moment.Moment;
    description: string | undefined;
    entryTime: moment.Moment | undefined;
    exitTime: moment.Moment | undefined;
    qty: number;
    totalAmount: number;
    netAmount: number;
    vatAmount: number;
    vatPercentage: number;
    paymentMethod: IntegratedInvoicePaymentTypes;

    constructor(data?: ICreateIntegratedInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.company = _data["company"];
            this.customerVATCode = _data["customerVATCode"];
            this.country = _data["country"];
            this.city = _data["city"];
            this.location = _data["location"];
            this.project = _data["project"];
            this.site = _data["site"];
            this.details = _data["details"];
            this.cashierID = _data["cashierID"];
            this.shift = _data["shift"];
            this.invoiceNo = _data["invoiceNo"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.description = _data["description"];
            this.entryTime = _data["entryTime"] ? moment(_data["entryTime"].toString()) : <any>undefined;
            this.exitTime = _data["exitTime"] ? moment(_data["exitTime"].toString()) : <any>undefined;
            this.qty = _data["qty"];
            this.totalAmount = _data["totalAmount"];
            this.netAmount = _data["netAmount"];
            this.vatAmount = _data["vatAmount"];
            this.vatPercentage = _data["vatPercentage"];
            this.paymentMethod = _data["paymentMethod"];
        }
    }

    static fromJS(data: any): CreateIntegratedInvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateIntegratedInvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["company"] = this.company;
        data["customerVATCode"] = this.customerVATCode;
        data["country"] = this.country;
        data["city"] = this.city;
        data["location"] = this.location;
        data["project"] = this.project;
        data["site"] = this.site;
        data["details"] = this.details;
        data["cashierID"] = this.cashierID;
        data["shift"] = this.shift;
        data["invoiceNo"] = this.invoiceNo;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["entryTime"] = this.entryTime ? this.entryTime.toISOString() : <any>undefined;
        data["exitTime"] = this.exitTime ? this.exitTime.toISOString() : <any>undefined;
        data["qty"] = this.qty;
        data["totalAmount"] = this.totalAmount;
        data["netAmount"] = this.netAmount;
        data["vatAmount"] = this.vatAmount;
        data["vatPercentage"] = this.vatPercentage;
        data["paymentMethod"] = this.paymentMethod;
        return data;
    }

    clone(): CreateIntegratedInvoiceDto {
        const json = this.toJSON();
        let result = new CreateIntegratedInvoiceDto();
        result.init(json);
        return result;
    }
}

export interface ICreateIntegratedInvoiceDto {
    company: string | undefined;
    customerVATCode: string | undefined;
    country: string | undefined;
    city: string | undefined;
    location: string | undefined;
    project: string | undefined;
    site: string | undefined;
    details: string | undefined;
    cashierID: number;
    shift: number;
    invoiceNo: string | undefined;
    date: moment.Moment;
    description: string | undefined;
    entryTime: moment.Moment | undefined;
    exitTime: moment.Moment | undefined;
    qty: number;
    totalAmount: number;
    netAmount: number;
    vatAmount: number;
    vatPercentage: number;
    paymentMethod: IntegratedInvoicePaymentTypes;
}

export class CreateLocationStaffGroupInput implements ICreateLocationStaffGroupInput {
    locationId: number;
    groupId: string;

    constructor(data?: ICreateLocationStaffGroupInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationId = _data["locationId"];
            this.groupId = _data["groupId"];
        }
    }

    static fromJS(data: any): CreateLocationStaffGroupInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateLocationStaffGroupInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId;
        data["groupId"] = this.groupId;
        return data;
    }

    clone(): CreateLocationStaffGroupInput {
        const json = this.toJSON();
        let result = new CreateLocationStaffGroupInput();
        result.init(json);
        return result;
    }
}

export interface ICreateLocationStaffGroupInput {
    locationId: number;
    groupId: string;
}

export class CreateManualIncomeDto implements ICreateManualIncomeDto {
    customerName: string | undefined;
    customerMobileNumber: string | undefined;
    description: string | undefined;
    countryCode: string | undefined;
    vehicleType: VehicleType;
    carPlate: CarPlate;
    paymentType: PaymentType;
    totalAmount: number;
    posTransactionId: string | undefined;
    mobilityType: string | undefined;

    constructor(data?: ICreateManualIncomeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerName = _data["customerName"];
            this.customerMobileNumber = _data["customerMobileNumber"];
            this.description = _data["description"];
            this.countryCode = _data["countryCode"];
            this.vehicleType = _data["vehicleType"];
            this.carPlate = _data["carPlate"] ? CarPlate.fromJS(_data["carPlate"]) : <any>undefined;
            this.paymentType = _data["paymentType"];
            this.totalAmount = _data["totalAmount"];
            this.posTransactionId = _data["posTransactionId"];
            this.mobilityType = _data["mobilityType"];
        }
    }

    static fromJS(data: any): CreateManualIncomeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateManualIncomeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerName"] = this.customerName;
        data["customerMobileNumber"] = this.customerMobileNumber;
        data["description"] = this.description;
        data["countryCode"] = this.countryCode;
        data["vehicleType"] = this.vehicleType;
        data["carPlate"] = this.carPlate ? this.carPlate.toJSON() : <any>undefined;
        data["paymentType"] = this.paymentType;
        data["totalAmount"] = this.totalAmount;
        data["posTransactionId"] = this.posTransactionId;
        data["mobilityType"] = this.mobilityType;
        return data;
    }

    clone(): CreateManualIncomeDto {
        const json = this.toJSON();
        let result = new CreateManualIncomeDto();
        result.init(json);
        return result;
    }
}

export interface ICreateManualIncomeDto {
    customerName: string | undefined;
    customerMobileNumber: string | undefined;
    description: string | undefined;
    countryCode: string | undefined;
    vehicleType: VehicleType;
    carPlate: CarPlate;
    paymentType: PaymentType;
    totalAmount: number;
    posTransactionId: string | undefined;
    mobilityType: string | undefined;
}

export class CreateManualQRCode implements ICreateManualQRCode {
    code: string | undefined;

    constructor(data?: ICreateManualQRCode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): CreateManualQRCode {
        data = typeof data === 'object' ? data : {};
        let result = new CreateManualQRCode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        return data;
    }

    clone(): CreateManualQRCode {
        const json = this.toJSON();
        let result = new CreateManualQRCode();
        result.init(json);
        return result;
    }
}

export interface ICreateManualQRCode {
    code: string | undefined;
}

export class CreateOperationNoteDto implements ICreateOperationNoteDto {
    violationId: string;
    comment: string | undefined;

    constructor(data?: ICreateOperationNoteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.violationId = _data["violationId"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): CreateOperationNoteDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOperationNoteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["violationId"] = this.violationId;
        data["comment"] = this.comment;
        return data;
    }

    clone(): CreateOperationNoteDto {
        const json = this.toJSON();
        let result = new CreateOperationNoteDto();
        result.init(json);
        return result;
    }
}

export interface ICreateOperationNoteDto {
    violationId: string;
    comment: string | undefined;
}

export class CreateOrUpdateLocationDto implements ICreateOrUpdateLocationDto {
    id: number;
    name: string | undefined;
    latitude: number | undefined;
    longitude: number | undefined;
    countryId: number;
    cityId: number;
    areaId: number;
    districtId: number;
    priceId: number;
    isActive: boolean;
    sendInvoiceSMS: boolean;
    sendRenewSMS: boolean;
    inOutReservationEnabled: boolean;
    inOutReservationPricingId: number | undefined;
    allowanceTime: number | undefined;

    constructor(data?: ICreateOrUpdateLocationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.countryId = _data["countryId"];
            this.cityId = _data["cityId"];
            this.areaId = _data["areaId"];
            this.districtId = _data["districtId"];
            this.priceId = _data["priceId"];
            this.isActive = _data["isActive"];
            this.sendInvoiceSMS = _data["sendInvoiceSMS"];
            this.sendRenewSMS = _data["sendRenewSMS"];
            this.inOutReservationEnabled = _data["inOutReservationEnabled"];
            this.inOutReservationPricingId = _data["inOutReservationPricingId"];
            this.allowanceTime = _data["allowanceTime"];
        }
    }

    static fromJS(data: any): CreateOrUpdateLocationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateLocationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["countryId"] = this.countryId;
        data["cityId"] = this.cityId;
        data["areaId"] = this.areaId;
        data["districtId"] = this.districtId;
        data["priceId"] = this.priceId;
        data["isActive"] = this.isActive;
        data["sendInvoiceSMS"] = this.sendInvoiceSMS;
        data["sendRenewSMS"] = this.sendRenewSMS;
        data["inOutReservationEnabled"] = this.inOutReservationEnabled;
        data["inOutReservationPricingId"] = this.inOutReservationPricingId;
        data["allowanceTime"] = this.allowanceTime;
        return data;
    }

    clone(): CreateOrUpdateLocationDto {
        const json = this.toJSON();
        let result = new CreateOrUpdateLocationDto();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateLocationDto {
    id: number;
    name: string | undefined;
    latitude: number | undefined;
    longitude: number | undefined;
    countryId: number;
    cityId: number;
    areaId: number;
    districtId: number;
    priceId: number;
    isActive: boolean;
    sendInvoiceSMS: boolean;
    sendRenewSMS: boolean;
    inOutReservationEnabled: boolean;
    inOutReservationPricingId: number | undefined;
    allowanceTime: number | undefined;
}

export class CreateOrUpdateManyFromEasyValley implements ICreateOrUpdateManyFromEasyValley {
    date: string | undefined;
    page: number | undefined;
    pageSize: number | undefined;

    constructor(data?: ICreateOrUpdateManyFromEasyValley) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"];
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): CreateOrUpdateManyFromEasyValley {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateManyFromEasyValley();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date;
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        return data;
    }

    clone(): CreateOrUpdateManyFromEasyValley {
        const json = this.toJSON();
        let result = new CreateOrUpdateManyFromEasyValley();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateManyFromEasyValley {
    date: string | undefined;
    page: number | undefined;
    pageSize: number | undefined;
}

export class CreateOrUpdateManyFromEntervo implements ICreateOrUpdateManyFromEntervo {
    folderPath: string | undefined;
    fileName: string | undefined;
    page: number | undefined;
    pageSize: number | undefined;

    constructor(data?: ICreateOrUpdateManyFromEntervo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.folderPath = _data["folderPath"];
            this.fileName = _data["fileName"];
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): CreateOrUpdateManyFromEntervo {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateManyFromEntervo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["folderPath"] = this.folderPath;
        data["fileName"] = this.fileName;
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        return data;
    }

    clone(): CreateOrUpdateManyFromEntervo {
        const json = this.toJSON();
        let result = new CreateOrUpdateManyFromEntervo();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateManyFromEntervo {
    folderPath: string | undefined;
    fileName: string | undefined;
    page: number | undefined;
    pageSize: number | undefined;
}

export class CreateOrUpdateManyFromSpaceParking implements ICreateOrUpdateManyFromSpaceParking {
    folderPath: string | undefined;
    fileName: string | undefined;
    page: number | undefined;
    pageSize: number | undefined;

    constructor(data?: ICreateOrUpdateManyFromSpaceParking) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.folderPath = _data["folderPath"];
            this.fileName = _data["fileName"];
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): CreateOrUpdateManyFromSpaceParking {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateManyFromSpaceParking();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["folderPath"] = this.folderPath;
        data["fileName"] = this.fileName;
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        return data;
    }

    clone(): CreateOrUpdateManyFromSpaceParking {
        const json = this.toJSON();
        let result = new CreateOrUpdateManyFromSpaceParking();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateManyFromSpaceParking {
    folderPath: string | undefined;
    fileName: string | undefined;
    page: number | undefined;
    pageSize: number | undefined;
}

export class CreateOrUpdateManyParkingInvoicesCommand implements ICreateOrUpdateManyParkingInvoicesCommand {
    commands: CreateOrUpdateParkingInvoiceCommand[] | undefined;

    constructor(data?: ICreateOrUpdateManyParkingInvoicesCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["commands"])) {
                this.commands = [] as any;
                for (let item of _data["commands"])
                    this.commands.push(CreateOrUpdateParkingInvoiceCommand.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateManyParkingInvoicesCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateManyParkingInvoicesCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.commands)) {
            data["commands"] = [];
            for (let item of this.commands)
                data["commands"].push(item.toJSON());
        }
        return data;
    }

    clone(): CreateOrUpdateManyParkingInvoicesCommand {
        const json = this.toJSON();
        let result = new CreateOrUpdateManyParkingInvoicesCommand();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateManyParkingInvoicesCommand {
    commands: CreateOrUpdateParkingInvoiceCommand[] | undefined;
}

export class CreateOrUpdateParkingInvoiceCommand implements ICreateOrUpdateParkingInvoiceCommand {
    invoiceNumber: string | undefined;
    customerVatCode: string | undefined;
    invoiceSource: string | undefined;
    invoiceDateUtc: moment.Moment;
    payment: CreateParkingPaymentCommand;
    address: CreateAddressCommand;
    companyProjectDetails: CreateCompanyProjectDetailsCommand;
    customer: CreateParkingInvoiceCustomerCommand;
    invoiceItems: CreateParkingInvoiceItemCommand[] | undefined;
    locations: CreateParkingInvoiceLocationCommand[] | undefined;
    referenceId: string | undefined;
    excludedVAT: boolean;

    constructor(data?: ICreateOrUpdateParkingInvoiceCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceNumber = _data["invoiceNumber"];
            this.customerVatCode = _data["customerVatCode"];
            this.invoiceSource = _data["invoiceSource"];
            this.invoiceDateUtc = _data["invoiceDateUtc"] ? moment(_data["invoiceDateUtc"].toString()) : <any>undefined;
            this.payment = _data["payment"] ? CreateParkingPaymentCommand.fromJS(_data["payment"]) : <any>undefined;
            this.address = _data["address"] ? CreateAddressCommand.fromJS(_data["address"]) : <any>undefined;
            this.companyProjectDetails = _data["companyProjectDetails"] ? CreateCompanyProjectDetailsCommand.fromJS(_data["companyProjectDetails"]) : <any>undefined;
            this.customer = _data["customer"] ? CreateParkingInvoiceCustomerCommand.fromJS(_data["customer"]) : <any>undefined;
            if (Array.isArray(_data["invoiceItems"])) {
                this.invoiceItems = [] as any;
                for (let item of _data["invoiceItems"])
                    this.invoiceItems.push(CreateParkingInvoiceItemCommand.fromJS(item));
            }
            if (Array.isArray(_data["locations"])) {
                this.locations = [] as any;
                for (let item of _data["locations"])
                    this.locations.push(CreateParkingInvoiceLocationCommand.fromJS(item));
            }
            this.referenceId = _data["referenceId"];
            this.excludedVAT = _data["excludedVAT"];
        }
    }

    static fromJS(data: any): CreateOrUpdateParkingInvoiceCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateParkingInvoiceCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceNumber"] = this.invoiceNumber;
        data["customerVatCode"] = this.customerVatCode;
        data["invoiceSource"] = this.invoiceSource;
        data["invoiceDateUtc"] = this.invoiceDateUtc ? this.invoiceDateUtc.toISOString() : <any>undefined;
        data["payment"] = this.payment ? this.payment.toJSON() : <any>undefined;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["companyProjectDetails"] = this.companyProjectDetails ? this.companyProjectDetails.toJSON() : <any>undefined;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        if (Array.isArray(this.invoiceItems)) {
            data["invoiceItems"] = [];
            for (let item of this.invoiceItems)
                data["invoiceItems"].push(item.toJSON());
        }
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (let item of this.locations)
                data["locations"].push(item.toJSON());
        }
        data["referenceId"] = this.referenceId;
        data["excludedVAT"] = this.excludedVAT;
        return data;
    }

    clone(): CreateOrUpdateParkingInvoiceCommand {
        const json = this.toJSON();
        let result = new CreateOrUpdateParkingInvoiceCommand();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateParkingInvoiceCommand {
    invoiceNumber: string | undefined;
    customerVatCode: string | undefined;
    invoiceSource: string | undefined;
    invoiceDateUtc: moment.Moment;
    payment: CreateParkingPaymentCommand;
    address: CreateAddressCommand;
    companyProjectDetails: CreateCompanyProjectDetailsCommand;
    customer: CreateParkingInvoiceCustomerCommand;
    invoiceItems: CreateParkingInvoiceItemCommand[] | undefined;
    locations: CreateParkingInvoiceLocationCommand[] | undefined;
    referenceId: string | undefined;
    excludedVAT: boolean;
}

export class CreateOrUpdatePriceDto implements ICreateOrUpdatePriceDto {
    id: number;
    hourRate: number;
    name: string | undefined;
    towingRate: number;
    clampingRate: number;
    impoundRatePerDay: number;

    constructor(data?: ICreateOrUpdatePriceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.hourRate = _data["hourRate"];
            this.name = _data["name"];
            this.towingRate = _data["towingRate"];
            this.clampingRate = _data["clampingRate"];
            this.impoundRatePerDay = _data["impoundRatePerDay"];
        }
    }

    static fromJS(data: any): CreateOrUpdatePriceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdatePriceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["hourRate"] = this.hourRate;
        data["name"] = this.name;
        data["towingRate"] = this.towingRate;
        data["clampingRate"] = this.clampingRate;
        data["impoundRatePerDay"] = this.impoundRatePerDay;
        return data;
    }

    clone(): CreateOrUpdatePriceDto {
        const json = this.toJSON();
        let result = new CreateOrUpdatePriceDto();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdatePriceDto {
    id: number;
    hourRate: number;
    name: string | undefined;
    towingRate: number;
    clampingRate: number;
    impoundRatePerDay: number;
}

export class CreateOrUpdateQRCodeDto implements ICreateOrUpdateQRCodeDto {
    id: number;
    name: string | undefined;
    code: string | undefined;
    slotsIds: number[] | undefined;
    description: string | undefined;
    locationId: number;
    isActive: boolean;

    constructor(data?: ICreateOrUpdateQRCodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
            if (Array.isArray(_data["slotsIds"])) {
                this.slotsIds = [] as any;
                for (let item of _data["slotsIds"])
                    this.slotsIds.push(item);
            }
            this.description = _data["description"];
            this.locationId = _data["locationId"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CreateOrUpdateQRCodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateQRCodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        if (Array.isArray(this.slotsIds)) {
            data["slotsIds"] = [];
            for (let item of this.slotsIds)
                data["slotsIds"].push(item);
        }
        data["description"] = this.description;
        data["locationId"] = this.locationId;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): CreateOrUpdateQRCodeDto {
        const json = this.toJSON();
        let result = new CreateOrUpdateQRCodeDto();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateQRCodeDto {
    id: number;
    name: string | undefined;
    code: string | undefined;
    slotsIds: number[] | undefined;
    description: string | undefined;
    locationId: number;
    isActive: boolean;
}

export class CreateOrUpdateViolationTypeDto implements ICreateOrUpdateViolationTypeDto {
    id: string | undefined;
    name_En: string | undefined;
    name_Ar: string | undefined;
    code: string | undefined;
    applyReservedTime: boolean;

    constructor(data?: ICreateOrUpdateViolationTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name_En = _data["name_En"];
            this.name_Ar = _data["name_Ar"];
            this.code = _data["code"];
            this.applyReservedTime = _data["applyReservedTime"];
        }
    }

    static fromJS(data: any): CreateOrUpdateViolationTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateViolationTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name_En"] = this.name_En;
        data["name_Ar"] = this.name_Ar;
        data["code"] = this.code;
        data["applyReservedTime"] = this.applyReservedTime;
        return data;
    }

    clone(): CreateOrUpdateViolationTypeDto {
        const json = this.toJSON();
        let result = new CreateOrUpdateViolationTypeDto();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateViolationTypeDto {
    id: string | undefined;
    name_En: string | undefined;
    name_Ar: string | undefined;
    code: string | undefined;
    applyReservedTime: boolean;
}

export class CreateOrUpdateViolationTypePriceDto implements ICreateOrUpdateViolationTypePriceDto {
    id: string | undefined;
    locationId: number;
    violationTypeId: string;
    price: number;

    constructor(data?: ICreateOrUpdateViolationTypePriceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.locationId = _data["locationId"];
            this.violationTypeId = _data["violationTypeId"];
            this.price = _data["price"];
        }
    }

    static fromJS(data: any): CreateOrUpdateViolationTypePriceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateViolationTypePriceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["locationId"] = this.locationId;
        data["violationTypeId"] = this.violationTypeId;
        data["price"] = this.price;
        return data;
    }

    clone(): CreateOrUpdateViolationTypePriceDto {
        const json = this.toJSON();
        let result = new CreateOrUpdateViolationTypePriceDto();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateViolationTypePriceDto {
    id: string | undefined;
    locationId: number;
    violationTypeId: string;
    price: number;
}

export class CreatePOSReservationInput implements ICreatePOSReservationInput {
    posTransactionId: string | undefined;
    slotId: number;
    hours: number;
    carPlateDigits: number;
    carPlateLetters: string | undefined;
    phoneNumber: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    countryCode: string | undefined;
    vehicleType: VehicleType;
    mobilityType: string | undefined;

    constructor(data?: ICreatePOSReservationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.posTransactionId = _data["posTransactionId"];
            this.slotId = _data["slotId"];
            this.hours = _data["hours"];
            this.carPlateDigits = _data["carPlateDigits"];
            this.carPlateLetters = _data["carPlateLetters"];
            this.phoneNumber = _data["phoneNumber"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.countryCode = _data["countryCode"];
            this.vehicleType = _data["vehicleType"];
            this.mobilityType = _data["mobilityType"];
        }
    }

    static fromJS(data: any): CreatePOSReservationInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePOSReservationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["posTransactionId"] = this.posTransactionId;
        data["slotId"] = this.slotId;
        data["hours"] = this.hours;
        data["carPlateDigits"] = this.carPlateDigits;
        data["carPlateLetters"] = this.carPlateLetters;
        data["phoneNumber"] = this.phoneNumber;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["countryCode"] = this.countryCode;
        data["vehicleType"] = this.vehicleType;
        data["mobilityType"] = this.mobilityType;
        return data;
    }

    clone(): CreatePOSReservationInput {
        const json = this.toJSON();
        let result = new CreatePOSReservationInput();
        result.init(json);
        return result;
    }
}

export interface ICreatePOSReservationInput {
    posTransactionId: string | undefined;
    slotId: number;
    hours: number;
    carPlateDigits: number;
    carPlateLetters: string | undefined;
    phoneNumber: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    countryCode: string | undefined;
    vehicleType: VehicleType;
    mobilityType: string | undefined;
}

export class CreateParkingInvoiceCustomerCommand implements ICreateParkingInvoiceCustomerCommand {
    contactName: string | undefined;
    contactPhoneNumber: string | undefined;
    vatNumber: string | undefined;
    crNumber: string | undefined;
    country: string | undefined;
    city: string | undefined;
    district: string | undefined;
    postalCode: string | undefined;
    street: string | undefined;
    buildingNumber: string | undefined;

    constructor(data?: ICreateParkingInvoiceCustomerCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contactName = _data["contactName"];
            this.contactPhoneNumber = _data["contactPhoneNumber"];
            this.vatNumber = _data["vatNumber"];
            this.crNumber = _data["crNumber"];
            this.country = _data["country"];
            this.city = _data["city"];
            this.district = _data["district"];
            this.postalCode = _data["postalCode"];
            this.street = _data["street"];
            this.buildingNumber = _data["buildingNumber"];
        }
    }

    static fromJS(data: any): CreateParkingInvoiceCustomerCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateParkingInvoiceCustomerCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactName"] = this.contactName;
        data["contactPhoneNumber"] = this.contactPhoneNumber;
        data["vatNumber"] = this.vatNumber;
        data["crNumber"] = this.crNumber;
        data["country"] = this.country;
        data["city"] = this.city;
        data["district"] = this.district;
        data["postalCode"] = this.postalCode;
        data["street"] = this.street;
        data["buildingNumber"] = this.buildingNumber;
        return data;
    }

    clone(): CreateParkingInvoiceCustomerCommand {
        const json = this.toJSON();
        let result = new CreateParkingInvoiceCustomerCommand();
        result.init(json);
        return result;
    }
}

export interface ICreateParkingInvoiceCustomerCommand {
    contactName: string | undefined;
    contactPhoneNumber: string | undefined;
    vatNumber: string | undefined;
    crNumber: string | undefined;
    country: string | undefined;
    city: string | undefined;
    district: string | undefined;
    postalCode: string | undefined;
    street: string | undefined;
    buildingNumber: string | undefined;
}

export class CreateParkingInvoiceItemCommand implements ICreateParkingInvoiceItemCommand {
    name: string | undefined;
    quantity: number;
    totalPrice: PriceValueObject;
    discount: PriceValueObject;
    vatPercentage: number;
    unitCode: InvoiceItemUnitCode;
    entryTime: moment.Moment | undefined;
    exitTime: moment.Moment | undefined;

    constructor(data?: ICreateParkingInvoiceItemCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.quantity = _data["quantity"];
            this.totalPrice = _data["totalPrice"] ? PriceValueObject.fromJS(_data["totalPrice"]) : <any>undefined;
            this.discount = _data["discount"] ? PriceValueObject.fromJS(_data["discount"]) : <any>undefined;
            this.vatPercentage = _data["vatPercentage"];
            this.unitCode = _data["unitCode"] ? InvoiceItemUnitCode.fromJS(_data["unitCode"]) : <any>undefined;
            this.entryTime = _data["entryTime"] ? moment(_data["entryTime"].toString()) : <any>undefined;
            this.exitTime = _data["exitTime"] ? moment(_data["exitTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateParkingInvoiceItemCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateParkingInvoiceItemCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["quantity"] = this.quantity;
        data["totalPrice"] = this.totalPrice ? this.totalPrice.toJSON() : <any>undefined;
        data["discount"] = this.discount ? this.discount.toJSON() : <any>undefined;
        data["vatPercentage"] = this.vatPercentage;
        data["unitCode"] = this.unitCode ? this.unitCode.toJSON() : <any>undefined;
        data["entryTime"] = this.entryTime ? this.entryTime.toISOString() : <any>undefined;
        data["exitTime"] = this.exitTime ? this.exitTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): CreateParkingInvoiceItemCommand {
        const json = this.toJSON();
        let result = new CreateParkingInvoiceItemCommand();
        result.init(json);
        return result;
    }
}

export interface ICreateParkingInvoiceItemCommand {
    name: string | undefined;
    quantity: number;
    totalPrice: PriceValueObject;
    discount: PriceValueObject;
    vatPercentage: number;
    unitCode: InvoiceItemUnitCode;
    entryTime: moment.Moment | undefined;
    exitTime: moment.Moment | undefined;
}

export class CreateParkingInvoiceLocationCommand implements ICreateParkingInvoiceLocationCommand {
    locationName: string | undefined;
    locationId: number;

    constructor(data?: ICreateParkingInvoiceLocationCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationName = _data["locationName"];
            this.locationId = _data["locationId"];
        }
    }

    static fromJS(data: any): CreateParkingInvoiceLocationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateParkingInvoiceLocationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationName"] = this.locationName;
        data["locationId"] = this.locationId;
        return data;
    }

    clone(): CreateParkingInvoiceLocationCommand {
        const json = this.toJSON();
        let result = new CreateParkingInvoiceLocationCommand();
        result.init(json);
        return result;
    }
}

export interface ICreateParkingInvoiceLocationCommand {
    locationName: string | undefined;
    locationId: number;
}

export class CreateParkingInvoiceRequest implements ICreateParkingInvoiceRequest {
    source: string | undefined;
    company: string | undefined;
    customerVATCode: string | undefined;
    country: string | undefined;
    city: string | undefined;
    location: string | undefined;
    project: string | undefined;
    site: string | undefined;
    details: string | undefined;
    cashierID: number;
    shift: number;
    invoiceNo: string | undefined;
    date: moment.Moment;
    description: string | undefined;
    entryTime: moment.Moment | undefined;
    exitTime: moment.Moment | undefined;
    qty: number;
    totalAmount: number;
    netAmount: number;
    vatAmount: number;
    unitPrice: number;
    discount: number;
    vatPercentage: number;
    paymentMethod: string | undefined;

    constructor(data?: ICreateParkingInvoiceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.source = _data["source"];
            this.company = _data["company"];
            this.customerVATCode = _data["customerVATCode"];
            this.country = _data["country"];
            this.city = _data["city"];
            this.location = _data["location"];
            this.project = _data["project"];
            this.site = _data["site"];
            this.details = _data["details"];
            this.cashierID = _data["cashierID"];
            this.shift = _data["shift"];
            this.invoiceNo = _data["invoiceNo"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.description = _data["description"];
            this.entryTime = _data["entryTime"] ? moment(_data["entryTime"].toString()) : <any>undefined;
            this.exitTime = _data["exitTime"] ? moment(_data["exitTime"].toString()) : <any>undefined;
            this.qty = _data["qty"];
            this.totalAmount = _data["totalAmount"];
            this.netAmount = _data["netAmount"];
            this.vatAmount = _data["vatAmount"];
            this.unitPrice = _data["unitPrice"];
            this.discount = _data["discount"];
            this.vatPercentage = _data["vatPercentage"];
            this.paymentMethod = _data["paymentMethod"];
        }
    }

    static fromJS(data: any): CreateParkingInvoiceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateParkingInvoiceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["source"] = this.source;
        data["company"] = this.company;
        data["customerVATCode"] = this.customerVATCode;
        data["country"] = this.country;
        data["city"] = this.city;
        data["location"] = this.location;
        data["project"] = this.project;
        data["site"] = this.site;
        data["details"] = this.details;
        data["cashierID"] = this.cashierID;
        data["shift"] = this.shift;
        data["invoiceNo"] = this.invoiceNo;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["entryTime"] = this.entryTime ? this.entryTime.toISOString() : <any>undefined;
        data["exitTime"] = this.exitTime ? this.exitTime.toISOString() : <any>undefined;
        data["qty"] = this.qty;
        data["totalAmount"] = this.totalAmount;
        data["netAmount"] = this.netAmount;
        data["vatAmount"] = this.vatAmount;
        data["unitPrice"] = this.unitPrice;
        data["discount"] = this.discount;
        data["vatPercentage"] = this.vatPercentage;
        data["paymentMethod"] = this.paymentMethod;
        return data;
    }

    clone(): CreateParkingInvoiceRequest {
        const json = this.toJSON();
        let result = new CreateParkingInvoiceRequest();
        result.init(json);
        return result;
    }
}

export interface ICreateParkingInvoiceRequest {
    source: string | undefined;
    company: string | undefined;
    customerVATCode: string | undefined;
    country: string | undefined;
    city: string | undefined;
    location: string | undefined;
    project: string | undefined;
    site: string | undefined;
    details: string | undefined;
    cashierID: number;
    shift: number;
    invoiceNo: string | undefined;
    date: moment.Moment;
    description: string | undefined;
    entryTime: moment.Moment | undefined;
    exitTime: moment.Moment | undefined;
    qty: number;
    totalAmount: number;
    netAmount: number;
    vatAmount: number;
    unitPrice: number;
    discount: number;
    vatPercentage: number;
    paymentMethod: string | undefined;
}

export class CreateParkingPaymentCommand implements ICreateParkingPaymentCommand {
    price: PriceValueObject;
    paymentMethod: string | undefined;
    cashierId: number;
    shiftId: number;

    constructor(data?: ICreateParkingPaymentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.price = _data["price"] ? PriceValueObject.fromJS(_data["price"]) : <any>undefined;
            this.paymentMethod = _data["paymentMethod"];
            this.cashierId = _data["cashierId"];
            this.shiftId = _data["shiftId"];
        }
    }

    static fromJS(data: any): CreateParkingPaymentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateParkingPaymentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["price"] = this.price ? this.price.toJSON() : <any>undefined;
        data["paymentMethod"] = this.paymentMethod;
        data["cashierId"] = this.cashierId;
        data["shiftId"] = this.shiftId;
        return data;
    }

    clone(): CreateParkingPaymentCommand {
        const json = this.toJSON();
        let result = new CreateParkingPaymentCommand();
        result.init(json);
        return result;
    }
}

export interface ICreateParkingPaymentCommand {
    price: PriceValueObject;
    paymentMethod: string | undefined;
    cashierId: number;
    shiftId: number;
}

export class CreateReservationInputDto implements ICreateReservationInputDto {
    qrCodeId: number;
    slotId: number;
    hours: number;
    carPlateDigits: number;
    carPlateLetters: string | undefined;
    phoneNumber: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    paymentMethodId: number;
    countryCode: string | undefined;
    vehicleType: VehicleType;
    mobilityType: string | undefined;

    constructor(data?: ICreateReservationInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qrCodeId = _data["qrCodeId"];
            this.slotId = _data["slotId"];
            this.hours = _data["hours"];
            this.carPlateDigits = _data["carPlateDigits"];
            this.carPlateLetters = _data["carPlateLetters"];
            this.phoneNumber = _data["phoneNumber"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.paymentMethodId = _data["paymentMethodId"];
            this.countryCode = _data["countryCode"];
            this.vehicleType = _data["vehicleType"];
            this.mobilityType = _data["mobilityType"];
        }
    }

    static fromJS(data: any): CreateReservationInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateReservationInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qrCodeId"] = this.qrCodeId;
        data["slotId"] = this.slotId;
        data["hours"] = this.hours;
        data["carPlateDigits"] = this.carPlateDigits;
        data["carPlateLetters"] = this.carPlateLetters;
        data["phoneNumber"] = this.phoneNumber;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["paymentMethodId"] = this.paymentMethodId;
        data["countryCode"] = this.countryCode;
        data["vehicleType"] = this.vehicleType;
        data["mobilityType"] = this.mobilityType;
        return data;
    }

    clone(): CreateReservationInputDto {
        const json = this.toJSON();
        let result = new CreateReservationInputDto();
        result.init(json);
        return result;
    }
}

export interface ICreateReservationInputDto {
    qrCodeId: number;
    slotId: number;
    hours: number;
    carPlateDigits: number;
    carPlateLetters: string | undefined;
    phoneNumber: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    paymentMethodId: number;
    countryCode: string | undefined;
    vehicleType: VehicleType;
    mobilityType: string | undefined;
}

export class CreateRoleDto implements ICreateRoleDto {
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    roleType: RoleType;
    grantedPermissions: string[] | undefined;

    constructor(data?: ICreateRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.normalizedName = _data["normalizedName"];
            this.description = _data["description"];
            this.roleType = _data["roleType"];
            if (Array.isArray(_data["grantedPermissions"])) {
                this.grantedPermissions = [] as any;
                for (let item of _data["grantedPermissions"])
                    this.grantedPermissions.push(item);
            }
        }
    }

    static fromJS(data: any): CreateRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["normalizedName"] = this.normalizedName;
        data["description"] = this.description;
        data["roleType"] = this.roleType;
        if (Array.isArray(this.grantedPermissions)) {
            data["grantedPermissions"] = [];
            for (let item of this.grantedPermissions)
                data["grantedPermissions"].push(item);
        }
        return data;
    }

    clone(): CreateRoleDto {
        const json = this.toJSON();
        let result = new CreateRoleDto();
        result.init(json);
        return result;
    }
}

export interface ICreateRoleDto {
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    roleType: RoleType;
    grantedPermissions: string[] | undefined;
}

export class CreateStaffAccountDto implements ICreateStaffAccountDto {
    firstName: string | undefined;
    lastName: string | undefined;
    userName: string | undefined;
    email: string | undefined;
    phoneNumber: string | undefined;
    roleName: string | undefined;
    isActive: boolean;
    shouldChangePasswordOnNextLogin: boolean;
    password: string | undefined;

    constructor(data?: ICreateStaffAccountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.userName = _data["userName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.roleName = _data["roleName"];
            this.isActive = _data["isActive"];
            this.shouldChangePasswordOnNextLogin = _data["shouldChangePasswordOnNextLogin"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): CreateStaffAccountDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateStaffAccountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["userName"] = this.userName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["roleName"] = this.roleName;
        data["isActive"] = this.isActive;
        data["shouldChangePasswordOnNextLogin"] = this.shouldChangePasswordOnNextLogin;
        data["password"] = this.password;
        return data;
    }

    clone(): CreateStaffAccountDto {
        const json = this.toJSON();
        let result = new CreateStaffAccountDto();
        result.init(json);
        return result;
    }
}

export interface ICreateStaffAccountDto {
    firstName: string | undefined;
    lastName: string | undefined;
    userName: string | undefined;
    email: string | undefined;
    phoneNumber: string | undefined;
    roleName: string | undefined;
    isActive: boolean;
    shouldChangePasswordOnNextLogin: boolean;
    password: string | undefined;
}

export class CreateStaffGroupDto implements ICreateStaffGroupDto {
    groupName: string | undefined;
    stafAccoutAdminIds: number[] | undefined;
    stafAccoutMemberIds: number[] | undefined;

    constructor(data?: ICreateStaffGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupName = _data["groupName"];
            if (Array.isArray(_data["stafAccoutAdminIds"])) {
                this.stafAccoutAdminIds = [] as any;
                for (let item of _data["stafAccoutAdminIds"])
                    this.stafAccoutAdminIds.push(item);
            }
            if (Array.isArray(_data["stafAccoutMemberIds"])) {
                this.stafAccoutMemberIds = [] as any;
                for (let item of _data["stafAccoutMemberIds"])
                    this.stafAccoutMemberIds.push(item);
            }
        }
    }

    static fromJS(data: any): CreateStaffGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateStaffGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupName"] = this.groupName;
        if (Array.isArray(this.stafAccoutAdminIds)) {
            data["stafAccoutAdminIds"] = [];
            for (let item of this.stafAccoutAdminIds)
                data["stafAccoutAdminIds"].push(item);
        }
        if (Array.isArray(this.stafAccoutMemberIds)) {
            data["stafAccoutMemberIds"] = [];
            for (let item of this.stafAccoutMemberIds)
                data["stafAccoutMemberIds"].push(item);
        }
        return data;
    }

    clone(): CreateStaffGroupDto {
        const json = this.toJSON();
        let result = new CreateStaffGroupDto();
        result.init(json);
        return result;
    }
}

export interface ICreateStaffGroupDto {
    groupName: string | undefined;
    stafAccoutAdminIds: number[] | undefined;
    stafAccoutMemberIds: number[] | undefined;
}

export class CreateSubscriptionCompanyInput implements ICreateSubscriptionCompanyInput {
    name: string | undefined;
    taxId: string | undefined;
    crNumber: string | undefined;
    address: string | undefined;
    contactPersonName: string | undefined;
    contactPersonPhoneNumber: string | undefined;
    addressDetails: SubscriptionCompanyAddressDto;

    constructor(data?: ICreateSubscriptionCompanyInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.taxId = _data["taxId"];
            this.crNumber = _data["crNumber"];
            this.address = _data["address"];
            this.contactPersonName = _data["contactPersonName"];
            this.contactPersonPhoneNumber = _data["contactPersonPhoneNumber"];
            this.addressDetails = _data["addressDetails"] ? SubscriptionCompanyAddressDto.fromJS(_data["addressDetails"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateSubscriptionCompanyInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSubscriptionCompanyInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["taxId"] = this.taxId;
        data["crNumber"] = this.crNumber;
        data["address"] = this.address;
        data["contactPersonName"] = this.contactPersonName;
        data["contactPersonPhoneNumber"] = this.contactPersonPhoneNumber;
        data["addressDetails"] = this.addressDetails ? this.addressDetails.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateSubscriptionCompanyInput {
        const json = this.toJSON();
        let result = new CreateSubscriptionCompanyInput();
        result.init(json);
        return result;
    }
}

export interface ICreateSubscriptionCompanyInput {
    name: string | undefined;
    taxId: string | undefined;
    crNumber: string | undefined;
    address: string | undefined;
    contactPersonName: string | undefined;
    contactPersonPhoneNumber: string | undefined;
    addressDetails: SubscriptionCompanyAddressDto;
}

export class CreateSubscriptionInput implements ICreateSubscriptionInput {
    subscriberType: SubscriberType;
    subscriptionType: SubscriptionType;
    startDate: moment.Moment;
    locationsIds: number[] | undefined;
    vehiclesIds: string[] | undefined;
    currency: string | undefined;
    paymentType: PaymentType;
    posTransactionId: string | undefined;
    benefeciaryId: string;
    subscriptionPackageId: string;
    benefeciaryName: string | undefined;

    constructor(data?: ICreateSubscriptionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subscriberType = _data["subscriberType"];
            this.subscriptionType = _data["subscriptionType"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["locationsIds"])) {
                this.locationsIds = [] as any;
                for (let item of _data["locationsIds"])
                    this.locationsIds.push(item);
            }
            if (Array.isArray(_data["vehiclesIds"])) {
                this.vehiclesIds = [] as any;
                for (let item of _data["vehiclesIds"])
                    this.vehiclesIds.push(item);
            }
            this.currency = _data["currency"];
            this.paymentType = _data["paymentType"];
            this.posTransactionId = _data["posTransactionId"];
            this.benefeciaryId = _data["benefeciaryId"];
            this.subscriptionPackageId = _data["subscriptionPackageId"];
            this.benefeciaryName = _data["benefeciaryName"];
        }
    }

    static fromJS(data: any): CreateSubscriptionInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSubscriptionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriberType"] = this.subscriberType;
        data["subscriptionType"] = this.subscriptionType;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        if (Array.isArray(this.locationsIds)) {
            data["locationsIds"] = [];
            for (let item of this.locationsIds)
                data["locationsIds"].push(item);
        }
        if (Array.isArray(this.vehiclesIds)) {
            data["vehiclesIds"] = [];
            for (let item of this.vehiclesIds)
                data["vehiclesIds"].push(item);
        }
        data["currency"] = this.currency;
        data["paymentType"] = this.paymentType;
        data["posTransactionId"] = this.posTransactionId;
        data["benefeciaryId"] = this.benefeciaryId;
        data["subscriptionPackageId"] = this.subscriptionPackageId;
        data["benefeciaryName"] = this.benefeciaryName;
        return data;
    }

    clone(): CreateSubscriptionInput {
        const json = this.toJSON();
        let result = new CreateSubscriptionInput();
        result.init(json);
        return result;
    }
}

export interface ICreateSubscriptionInput {
    subscriberType: SubscriberType;
    subscriptionType: SubscriptionType;
    startDate: moment.Moment;
    locationsIds: number[] | undefined;
    vehiclesIds: string[] | undefined;
    currency: string | undefined;
    paymentType: PaymentType;
    posTransactionId: string | undefined;
    benefeciaryId: string;
    subscriptionPackageId: string;
    benefeciaryName: string | undefined;
}

export class CreateSubscriptionOutput implements ICreateSubscriptionOutput {
    id: string;

    constructor(data?: ICreateSubscriptionOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateSubscriptionOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSubscriptionOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }

    clone(): CreateSubscriptionOutput {
        const json = this.toJSON();
        let result = new CreateSubscriptionOutput();
        result.init(json);
        return result;
    }
}

export interface ICreateSubscriptionOutput {
    id: string;
}

export class CreateSubscriptionPackageInput implements ICreateSubscriptionPackageInput {
    name: string | undefined;
    code: string | undefined;
    subscriptionTimeZoneId: string;
    /** Comma separated string with days' numbers (Saturday = 1, Sunday = 2 ...etc) */
    weekDays: number[] | undefined;
    daysCount: number;
    /** Represents whether a slot is reserved for the subscriber or not */
    reserved: boolean;
    price: number;
    isActive: boolean;
    locationsIds: number[] | undefined;

    constructor(data?: ICreateSubscriptionPackageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            this.subscriptionTimeZoneId = _data["subscriptionTimeZoneId"];
            if (Array.isArray(_data["weekDays"])) {
                this.weekDays = [] as any;
                for (let item of _data["weekDays"])
                    this.weekDays.push(item);
            }
            this.daysCount = _data["daysCount"];
            this.reserved = _data["reserved"];
            this.price = _data["price"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["locationsIds"])) {
                this.locationsIds = [] as any;
                for (let item of _data["locationsIds"])
                    this.locationsIds.push(item);
            }
        }
    }

    static fromJS(data: any): CreateSubscriptionPackageInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSubscriptionPackageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["subscriptionTimeZoneId"] = this.subscriptionTimeZoneId;
        if (Array.isArray(this.weekDays)) {
            data["weekDays"] = [];
            for (let item of this.weekDays)
                data["weekDays"].push(item);
        }
        data["daysCount"] = this.daysCount;
        data["reserved"] = this.reserved;
        data["price"] = this.price;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.locationsIds)) {
            data["locationsIds"] = [];
            for (let item of this.locationsIds)
                data["locationsIds"].push(item);
        }
        return data;
    }

    clone(): CreateSubscriptionPackageInput {
        const json = this.toJSON();
        let result = new CreateSubscriptionPackageInput();
        result.init(json);
        return result;
    }
}

export interface ICreateSubscriptionPackageInput {
    name: string | undefined;
    code: string | undefined;
    subscriptionTimeZoneId: string;
    /** Comma separated string with days' numbers (Saturday = 1, Sunday = 2 ...etc) */
    weekDays: number[] | undefined;
    daysCount: number;
    /** Represents whether a slot is reserved for the subscriber or not */
    reserved: boolean;
    price: number;
    isActive: boolean;
    locationsIds: number[] | undefined;
}

export class CreateSubscriptionTimeZoneInput implements ICreateSubscriptionTimeZoneInput {
    name: string | undefined;
    description: string | undefined;
    startTime: string | undefined;
    endTime: string | undefined;
    isActive: boolean;

    constructor(data?: ICreateSubscriptionTimeZoneInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.startTime = _data["startTime"];
            this.endTime = _data["endTime"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CreateSubscriptionTimeZoneInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSubscriptionTimeZoneInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["startTime"] = this.startTime;
        data["endTime"] = this.endTime;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): CreateSubscriptionTimeZoneInput {
        const json = this.toJSON();
        let result = new CreateSubscriptionTimeZoneInput();
        result.init(json);
        return result;
    }
}

export interface ICreateSubscriptionTimeZoneInput {
    name: string | undefined;
    description: string | undefined;
    startTime: string | undefined;
    endTime: string | undefined;
    isActive: boolean;
}

export class CreateTenantDto implements ICreateTenantDto {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    connectionString: string | undefined;
    isActive: boolean;

    constructor(data?: ICreateTenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.adminEmailAddress = _data["adminEmailAddress"];
            this.connectionString = _data["connectionString"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CreateTenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["adminEmailAddress"] = this.adminEmailAddress;
        data["connectionString"] = this.connectionString;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): CreateTenantDto {
        const json = this.toJSON();
        let result = new CreateTenantDto();
        result.init(json);
        return result;
    }
}

export interface ICreateTenantDto {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    connectionString: string | undefined;
    isActive: boolean;
}

export class CreateUserDto implements ICreateUserDto {
    userName: string;
    shouldChangePasswordOnNextLogin: boolean;
    name: string;
    surname: string;
    emailAddress: string;
    isActive: boolean;
    roleName: string | undefined;
    password: string | undefined;

    constructor(data?: ICreateUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.shouldChangePasswordOnNextLogin = _data["shouldChangePasswordOnNextLogin"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.emailAddress = _data["emailAddress"];
            this.isActive = _data["isActive"];
            this.roleName = _data["roleName"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): CreateUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["shouldChangePasswordOnNextLogin"] = this.shouldChangePasswordOnNextLogin;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["emailAddress"] = this.emailAddress;
        data["isActive"] = this.isActive;
        data["roleName"] = this.roleName;
        data["password"] = this.password;
        return data;
    }

    clone(): CreateUserDto {
        const json = this.toJSON();
        let result = new CreateUserDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUserDto {
    userName: string;
    shouldChangePasswordOnNextLogin: boolean;
    name: string;
    surname: string;
    emailAddress: string;
    isActive: boolean;
    roleName: string | undefined;
    password: string | undefined;
}

export class CreateVehicleInput implements ICreateVehicleInput {
    firstName: string | undefined;
    lastName: string | undefined;
    phoneNumber: string | undefined;
    countryCode: string | undefined;
    carPlateLetters: string | undefined;
    carPlateDigits: number;
    vehicleType: VehicleType;
    qrCodeId: number | undefined;
    mobilityType: string | undefined;

    constructor(data?: ICreateVehicleInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phoneNumber = _data["phoneNumber"];
            this.countryCode = _data["countryCode"];
            this.carPlateLetters = _data["carPlateLetters"];
            this.carPlateDigits = _data["carPlateDigits"];
            this.vehicleType = _data["vehicleType"];
            this.qrCodeId = _data["qrCodeId"];
            this.mobilityType = _data["mobilityType"];
        }
    }

    static fromJS(data: any): CreateVehicleInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateVehicleInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phoneNumber"] = this.phoneNumber;
        data["countryCode"] = this.countryCode;
        data["carPlateLetters"] = this.carPlateLetters;
        data["carPlateDigits"] = this.carPlateDigits;
        data["vehicleType"] = this.vehicleType;
        data["qrCodeId"] = this.qrCodeId;
        data["mobilityType"] = this.mobilityType;
        return data;
    }

    clone(): CreateVehicleInput {
        const json = this.toJSON();
        let result = new CreateVehicleInput();
        result.init(json);
        return result;
    }
}

export interface ICreateVehicleInput {
    firstName: string | undefined;
    lastName: string | undefined;
    phoneNumber: string | undefined;
    countryCode: string | undefined;
    carPlateLetters: string | undefined;
    carPlateDigits: number;
    vehicleType: VehicleType;
    qrCodeId: number | undefined;
    mobilityType: string | undefined;
}

export class CreateVehicleRequest implements ICreateVehicleRequest {
    mobilityType: string | undefined;
    countryId: number;
    vehiclePlate: VehiclePlate;
    vehicleType: VehicleType;
    customerId: string | undefined;

    constructor(data?: ICreateVehicleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mobilityType = _data["mobilityType"];
            this.countryId = _data["countryId"];
            this.vehiclePlate = _data["vehiclePlate"] ? VehiclePlate.fromJS(_data["vehiclePlate"]) : <any>undefined;
            this.vehicleType = _data["vehicleType"];
            this.customerId = _data["customerId"];
        }
    }

    static fromJS(data: any): CreateVehicleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateVehicleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mobilityType"] = this.mobilityType;
        data["countryId"] = this.countryId;
        data["vehiclePlate"] = this.vehiclePlate ? this.vehiclePlate.toJSON() : <any>undefined;
        data["vehicleType"] = this.vehicleType;
        data["customerId"] = this.customerId;
        return data;
    }

    clone(): CreateVehicleRequest {
        const json = this.toJSON();
        let result = new CreateVehicleRequest();
        result.init(json);
        return result;
    }
}

export interface ICreateVehicleRequest {
    mobilityType: string | undefined;
    countryId: number;
    vehiclePlate: VehiclePlate;
    vehicleType: VehicleType;
    customerId: string | undefined;
}

export class CreateViolationDto implements ICreateViolationDto {
    carPlateDigits: number;
    carPlateLetters: string | undefined;
    countryCode: string | undefined;
    vehicleType: VehicleType;
    mobilityType: string | undefined;
    customerName: string | undefined;
    phoneNumber: string | undefined;
    slotId: number;
    clampNumber: string | undefined;
    locationViolationPriceIds: string[] | undefined;
    reservationId: string | undefined;
    notes: string | undefined;

    constructor(data?: ICreateViolationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.carPlateDigits = _data["carPlateDigits"];
            this.carPlateLetters = _data["carPlateLetters"];
            this.countryCode = _data["countryCode"];
            this.vehicleType = _data["vehicleType"];
            this.mobilityType = _data["mobilityType"];
            this.customerName = _data["customerName"];
            this.phoneNumber = _data["phoneNumber"];
            this.slotId = _data["slotId"];
            this.clampNumber = _data["clampNumber"];
            if (Array.isArray(_data["locationViolationPriceIds"])) {
                this.locationViolationPriceIds = [] as any;
                for (let item of _data["locationViolationPriceIds"])
                    this.locationViolationPriceIds.push(item);
            }
            this.reservationId = _data["reservationId"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): CreateViolationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateViolationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["carPlateDigits"] = this.carPlateDigits;
        data["carPlateLetters"] = this.carPlateLetters;
        data["countryCode"] = this.countryCode;
        data["vehicleType"] = this.vehicleType;
        data["mobilityType"] = this.mobilityType;
        data["customerName"] = this.customerName;
        data["phoneNumber"] = this.phoneNumber;
        data["slotId"] = this.slotId;
        data["clampNumber"] = this.clampNumber;
        if (Array.isArray(this.locationViolationPriceIds)) {
            data["locationViolationPriceIds"] = [];
            for (let item of this.locationViolationPriceIds)
                data["locationViolationPriceIds"].push(item);
        }
        data["reservationId"] = this.reservationId;
        data["notes"] = this.notes;
        return data;
    }

    clone(): CreateViolationDto {
        const json = this.toJSON();
        let result = new CreateViolationDto();
        result.init(json);
        return result;
    }
}

export interface ICreateViolationDto {
    carPlateDigits: number;
    carPlateLetters: string | undefined;
    countryCode: string | undefined;
    vehicleType: VehicleType;
    mobilityType: string | undefined;
    customerName: string | undefined;
    phoneNumber: string | undefined;
    slotId: number;
    clampNumber: string | undefined;
    locationViolationPriceIds: string[] | undefined;
    reservationId: string | undefined;
    notes: string | undefined;
}

export class CreateZatcaDeviceDto implements ICreateZatcaDeviceDto {
    crNumber: string | undefined;
    vatNumber: string | undefined;
    organizationUnitName: string | undefined;
    organizationName: string | undefined;
    countryCode: string | undefined;
    locationAddress: string | undefined;
    industryBusinessCategory: string | undefined;
    otp: string | undefined;
    initialPIH: string | undefined;
    streetName: string | undefined;
    builingNumber: string | undefined;
    citySubdivisionName: string | undefined;
    cityName: string | undefined;
    postalZone: string | undefined;
    eInvoiceSourceId: number;
    isActive: boolean;

    constructor(data?: ICreateZatcaDeviceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.crNumber = _data["crNumber"];
            this.vatNumber = _data["vatNumber"];
            this.organizationUnitName = _data["organizationUnitName"];
            this.organizationName = _data["organizationName"];
            this.countryCode = _data["countryCode"];
            this.locationAddress = _data["locationAddress"];
            this.industryBusinessCategory = _data["industryBusinessCategory"];
            this.otp = _data["otp"];
            this.initialPIH = _data["initialPIH"];
            this.streetName = _data["streetName"];
            this.builingNumber = _data["builingNumber"];
            this.citySubdivisionName = _data["citySubdivisionName"];
            this.cityName = _data["cityName"];
            this.postalZone = _data["postalZone"];
            this.eInvoiceSourceId = _data["eInvoiceSourceId"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CreateZatcaDeviceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateZatcaDeviceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["crNumber"] = this.crNumber;
        data["vatNumber"] = this.vatNumber;
        data["organizationUnitName"] = this.organizationUnitName;
        data["organizationName"] = this.organizationName;
        data["countryCode"] = this.countryCode;
        data["locationAddress"] = this.locationAddress;
        data["industryBusinessCategory"] = this.industryBusinessCategory;
        data["otp"] = this.otp;
        data["initialPIH"] = this.initialPIH;
        data["streetName"] = this.streetName;
        data["builingNumber"] = this.builingNumber;
        data["citySubdivisionName"] = this.citySubdivisionName;
        data["cityName"] = this.cityName;
        data["postalZone"] = this.postalZone;
        data["eInvoiceSourceId"] = this.eInvoiceSourceId;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): CreateZatcaDeviceDto {
        const json = this.toJSON();
        let result = new CreateZatcaDeviceDto();
        result.init(json);
        return result;
    }
}

export interface ICreateZatcaDeviceDto {
    crNumber: string | undefined;
    vatNumber: string | undefined;
    organizationUnitName: string | undefined;
    organizationName: string | undefined;
    countryCode: string | undefined;
    locationAddress: string | undefined;
    industryBusinessCategory: string | undefined;
    otp: string | undefined;
    initialPIH: string | undefined;
    streetName: string | undefined;
    builingNumber: string | undefined;
    citySubdivisionName: string | undefined;
    cityName: string | undefined;
    postalZone: string | undefined;
    eInvoiceSourceId: number;
    isActive: boolean;
}

export class Customer implements ICustomer {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    readonly fullName: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    phoneNumber: string | undefined;
    isActive: boolean;
    readonly memberId: number;
    vehicles: Vehicle[] | undefined;
    subscriptionBenefeciaries: SubscriptionBenefeciary[] | undefined;

    constructor(data?: ICustomer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            (<any>this).fullName = _data["fullName"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phoneNumber = _data["phoneNumber"];
            this.isActive = _data["isActive"];
            (<any>this).memberId = _data["memberId"];
            if (Array.isArray(_data["vehicles"])) {
                this.vehicles = [] as any;
                for (let item of _data["vehicles"])
                    this.vehicles.push(Vehicle.fromJS(item));
            }
            if (Array.isArray(_data["subscriptionBenefeciaries"])) {
                this.subscriptionBenefeciaries = [] as any;
                for (let item of _data["subscriptionBenefeciaries"])
                    this.subscriptionBenefeciaries.push(SubscriptionBenefeciary.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Customer {
        data = typeof data === 'object' ? data : {};
        let result = new Customer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["fullName"] = this.fullName;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phoneNumber"] = this.phoneNumber;
        data["isActive"] = this.isActive;
        data["memberId"] = this.memberId;
        if (Array.isArray(this.vehicles)) {
            data["vehicles"] = [];
            for (let item of this.vehicles)
                data["vehicles"].push(item.toJSON());
        }
        if (Array.isArray(this.subscriptionBenefeciaries)) {
            data["subscriptionBenefeciaries"] = [];
            for (let item of this.subscriptionBenefeciaries)
                data["subscriptionBenefeciaries"].push(item.toJSON());
        }
        return data;
    }

    clone(): Customer {
        const json = this.toJSON();
        let result = new Customer();
        result.init(json);
        return result;
    }
}

export interface ICustomer {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    fullName: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    phoneNumber: string | undefined;
    isActive: boolean;
    memberId: number;
    vehicles: Vehicle[] | undefined;
    subscriptionBenefeciaries: SubscriptionBenefeciary[] | undefined;
}

export class CustomerDto implements ICustomerDto {
    firstName: string | undefined;
    lastName: string | undefined;
    phoneNumber: string | undefined;
    isActive: boolean;
    memberId: number;

    constructor(data?: ICustomerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phoneNumber = _data["phoneNumber"];
            this.isActive = _data["isActive"];
            this.memberId = _data["memberId"];
        }
    }

    static fromJS(data: any): CustomerDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phoneNumber"] = this.phoneNumber;
        data["isActive"] = this.isActive;
        data["memberId"] = this.memberId;
        return data;
    }

    clone(): CustomerDto {
        const json = this.toJSON();
        let result = new CustomerDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerDto {
    firstName: string | undefined;
    lastName: string | undefined;
    phoneNumber: string | undefined;
    isActive: boolean;
    memberId: number;
}

export class CustomerLookupDto implements ICustomerLookupDto {
    id: string;
    name: string | undefined;

    constructor(data?: ICustomerLookupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CustomerLookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerLookupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): CustomerLookupDto {
        const json = this.toJSON();
        let result = new CustomerLookupDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerLookupDto {
    id: string;
    name: string | undefined;
}

export class CustomerSupportStatus implements ICustomerSupportStatus {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    readonly nameEn: string | undefined;
    readonly nameAr: string | undefined;
    violations: Violation[] | undefined;
    customerSupportStatusLogsHistory: CustomerSupportStatusLogHistory[] | undefined;

    constructor(data?: ICustomerSupportStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            (<any>this).nameEn = _data["nameEn"];
            (<any>this).nameAr = _data["nameAr"];
            if (Array.isArray(_data["violations"])) {
                this.violations = [] as any;
                for (let item of _data["violations"])
                    this.violations.push(Violation.fromJS(item));
            }
            if (Array.isArray(_data["customerSupportStatusLogsHistory"])) {
                this.customerSupportStatusLogsHistory = [] as any;
                for (let item of _data["customerSupportStatusLogsHistory"])
                    this.customerSupportStatusLogsHistory.push(CustomerSupportStatusLogHistory.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomerSupportStatus {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerSupportStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["nameEn"] = this.nameEn;
        data["nameAr"] = this.nameAr;
        if (Array.isArray(this.violations)) {
            data["violations"] = [];
            for (let item of this.violations)
                data["violations"].push(item.toJSON());
        }
        if (Array.isArray(this.customerSupportStatusLogsHistory)) {
            data["customerSupportStatusLogsHistory"] = [];
            for (let item of this.customerSupportStatusLogsHistory)
                data["customerSupportStatusLogsHistory"].push(item.toJSON());
        }
        return data;
    }

    clone(): CustomerSupportStatus {
        const json = this.toJSON();
        let result = new CustomerSupportStatus();
        result.init(json);
        return result;
    }
}

export interface ICustomerSupportStatus {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    nameEn: string | undefined;
    nameAr: string | undefined;
    violations: Violation[] | undefined;
    customerSupportStatusLogsHistory: CustomerSupportStatusLogHistory[] | undefined;
}

export class CustomerSupportStatusDto implements ICustomerSupportStatusDto {
    id: number;
    nameEn: string | undefined;
    nameAr: string | undefined;

    constructor(data?: ICustomerSupportStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.nameEn = _data["nameEn"];
            this.nameAr = _data["nameAr"];
        }
    }

    static fromJS(data: any): CustomerSupportStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerSupportStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["nameEn"] = this.nameEn;
        data["nameAr"] = this.nameAr;
        return data;
    }

    clone(): CustomerSupportStatusDto {
        const json = this.toJSON();
        let result = new CustomerSupportStatusDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerSupportStatusDto {
    id: number;
    nameEn: string | undefined;
    nameAr: string | undefined;
}

export class CustomerSupportStatusLogHistory implements ICustomerSupportStatusLogHistory {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creatorUser: User;
    lastModifierUser: User;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    violationId: string;
    violation: Violation;
    statusId: number;
    status: CustomerSupportStatus;
    notes: string | undefined;

    constructor(data?: ICustomerSupportStatusLogHistory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.violationId = _data["violationId"];
            this.violation = _data["violation"] ? Violation.fromJS(_data["violation"]) : <any>undefined;
            this.statusId = _data["statusId"];
            this.status = _data["status"] ? CustomerSupportStatus.fromJS(_data["status"]) : <any>undefined;
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): CustomerSupportStatusLogHistory {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerSupportStatusLogHistory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["violationId"] = this.violationId;
        data["violation"] = this.violation ? this.violation.toJSON() : <any>undefined;
        data["statusId"] = this.statusId;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["notes"] = this.notes;
        return data;
    }

    clone(): CustomerSupportStatusLogHistory {
        const json = this.toJSON();
        let result = new CustomerSupportStatusLogHistory();
        result.init(json);
        return result;
    }
}

export interface ICustomerSupportStatusLogHistory {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creatorUser: User;
    lastModifierUser: User;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    violationId: string;
    violation: Violation;
    statusId: number;
    status: CustomerSupportStatus;
    notes: string | undefined;
}

export class DataMigrationSuccessLogResponse implements IDataMigrationSuccessLogResponse {
    id: string;
    readonly totalNumberOfRecords: number;
    readonly totalInsertedRecords: number;

    constructor(data?: IDataMigrationSuccessLogResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            (<any>this).totalNumberOfRecords = _data["totalNumberOfRecords"];
            (<any>this).totalInsertedRecords = _data["totalInsertedRecords"];
        }
    }

    static fromJS(data: any): DataMigrationSuccessLogResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DataMigrationSuccessLogResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["totalNumberOfRecords"] = this.totalNumberOfRecords;
        data["totalInsertedRecords"] = this.totalInsertedRecords;
        return data;
    }

    clone(): DataMigrationSuccessLogResponse {
        const json = this.toJSON();
        let result = new DataMigrationSuccessLogResponse();
        result.init(json);
        return result;
    }
}

export interface IDataMigrationSuccessLogResponse {
    id: string;
    totalNumberOfRecords: number;
    totalInsertedRecords: number;
}

export enum Dimension {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    __3 = -3,
    __2 = -2,
    __1 = -1,
}

export class District implements IDistrict {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    nameEn: string | undefined;
    nameAr: string | undefined;
    areaId: number;
    area: Area;

    constructor(data?: IDistrict) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.nameEn = _data["nameEn"];
            this.nameAr = _data["nameAr"];
            this.areaId = _data["areaId"];
            this.area = _data["area"] ? Area.fromJS(_data["area"]) : <any>undefined;
        }
    }

    static fromJS(data: any): District {
        data = typeof data === 'object' ? data : {};
        let result = new District();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["nameEn"] = this.nameEn;
        data["nameAr"] = this.nameAr;
        data["areaId"] = this.areaId;
        data["area"] = this.area ? this.area.toJSON() : <any>undefined;
        return data;
    }

    clone(): District {
        const json = this.toJSON();
        let result = new District();
        result.init(json);
        return result;
    }
}

export interface IDistrict {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    nameEn: string | undefined;
    nameAr: string | undefined;
    areaId: number;
    area: Area;
}

export class DistrictDto implements IDistrictDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    nameEn: string | undefined;
    nameAr: string | undefined;

    constructor(data?: IDistrictDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.nameEn = _data["nameEn"];
            this.nameAr = _data["nameAr"];
        }
    }

    static fromJS(data: any): DistrictDto {
        data = typeof data === 'object' ? data : {};
        let result = new DistrictDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["nameEn"] = this.nameEn;
        data["nameAr"] = this.nameAr;
        return data;
    }

    clone(): DistrictDto {
        const json = this.toJSON();
        let result = new DistrictDto();
        result.init(json);
        return result;
    }
}

export interface IDistrictDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    nameEn: string | undefined;
    nameAr: string | undefined;
}

export class DistrictDtoPagedResultDto implements IDistrictDtoPagedResultDto {
    items: DistrictDto[] | undefined;
    totalCount: number;

    constructor(data?: IDistrictDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(DistrictDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): DistrictDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new DistrictDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): DistrictDtoPagedResultDto {
        const json = this.toJSON();
        let result = new DistrictDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IDistrictDtoPagedResultDto {
    items: DistrictDto[] | undefined;
    totalCount: number;
}

export class EInvoiceType implements IEInvoiceType {
    readonly id: number;
    readonly name: string | undefined;
    code: number;
    type: string | undefined;

    constructor(data?: IEInvoiceType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).id = _data["id"];
            (<any>this).name = _data["name"];
            this.code = _data["code"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): EInvoiceType {
        data = typeof data === 'object' ? data : {};
        let result = new EInvoiceType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        data["type"] = this.type;
        return data;
    }

    clone(): EInvoiceType {
        const json = this.toJSON();
        let result = new EInvoiceType();
        result.init(json);
        return result;
    }
}

export interface IEInvoiceType {
    id: number;
    name: string | undefined;
    code: number;
    type: string | undefined;
}

export class EditSubscripionPackageInput implements IEditSubscripionPackageInput {
    id: string;
    name: string | undefined;
    code: string | undefined;
    subscriptionTimeZoneId: string;
    /** Comma separated string with days' numbers (Saturday = 1, Sunday = 2 ...etc) */
    weekDays: number[] | undefined;
    daysCount: number;
    /** Represents whether a slot is reserved for the subscriber or not */
    reserved: boolean;
    price: number;
    isActive: boolean;
    locationsIds: number[] | undefined;

    constructor(data?: IEditSubscripionPackageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.subscriptionTimeZoneId = _data["subscriptionTimeZoneId"];
            if (Array.isArray(_data["weekDays"])) {
                this.weekDays = [] as any;
                for (let item of _data["weekDays"])
                    this.weekDays.push(item);
            }
            this.daysCount = _data["daysCount"];
            this.reserved = _data["reserved"];
            this.price = _data["price"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["locationsIds"])) {
                this.locationsIds = [] as any;
                for (let item of _data["locationsIds"])
                    this.locationsIds.push(item);
            }
        }
    }

    static fromJS(data: any): EditSubscripionPackageInput {
        data = typeof data === 'object' ? data : {};
        let result = new EditSubscripionPackageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        data["subscriptionTimeZoneId"] = this.subscriptionTimeZoneId;
        if (Array.isArray(this.weekDays)) {
            data["weekDays"] = [];
            for (let item of this.weekDays)
                data["weekDays"].push(item);
        }
        data["daysCount"] = this.daysCount;
        data["reserved"] = this.reserved;
        data["price"] = this.price;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.locationsIds)) {
            data["locationsIds"] = [];
            for (let item of this.locationsIds)
                data["locationsIds"].push(item);
        }
        return data;
    }

    clone(): EditSubscripionPackageInput {
        const json = this.toJSON();
        let result = new EditSubscripionPackageInput();
        result.init(json);
        return result;
    }
}

export interface IEditSubscripionPackageInput {
    id: string;
    name: string | undefined;
    code: string | undefined;
    subscriptionTimeZoneId: string;
    /** Comma separated string with days' numbers (Saturday = 1, Sunday = 2 ...etc) */
    weekDays: number[] | undefined;
    daysCount: number;
    /** Represents whether a slot is reserved for the subscriber or not */
    reserved: boolean;
    price: number;
    isActive: boolean;
    locationsIds: number[] | undefined;
}

export class EditSubscriptionTimeZoneInput implements IEditSubscriptionTimeZoneInput {
    id: string;
    name: string | undefined;
    description: string | undefined;
    startTime: string | undefined;
    endTime: string | undefined;
    isActive: boolean;

    constructor(data?: IEditSubscriptionTimeZoneInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.startTime = _data["startTime"];
            this.endTime = _data["endTime"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): EditSubscriptionTimeZoneInput {
        data = typeof data === 'object' ? data : {};
        let result = new EditSubscriptionTimeZoneInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["startTime"] = this.startTime;
        data["endTime"] = this.endTime;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): EditSubscriptionTimeZoneInput {
        const json = this.toJSON();
        let result = new EditSubscriptionTimeZoneInput();
        result.init(json);
        return result;
    }
}

export interface IEditSubscriptionTimeZoneInput {
    id: string;
    name: string | undefined;
    description: string | undefined;
    startTime: string | undefined;
    endTime: string | undefined;
    isActive: boolean;
}

export class EditSubscriptionVehiclesInput implements IEditSubscriptionVehiclesInput {
    subscriptionId: string;
    removedVehiclesIds: string[] | undefined;
    addedVehiclesIds: string[] | undefined;

    constructor(data?: IEditSubscriptionVehiclesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subscriptionId = _data["subscriptionId"];
            if (Array.isArray(_data["removedVehiclesIds"])) {
                this.removedVehiclesIds = [] as any;
                for (let item of _data["removedVehiclesIds"])
                    this.removedVehiclesIds.push(item);
            }
            if (Array.isArray(_data["addedVehiclesIds"])) {
                this.addedVehiclesIds = [] as any;
                for (let item of _data["addedVehiclesIds"])
                    this.addedVehiclesIds.push(item);
            }
        }
    }

    static fromJS(data: any): EditSubscriptionVehiclesInput {
        data = typeof data === 'object' ? data : {};
        let result = new EditSubscriptionVehiclesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionId"] = this.subscriptionId;
        if (Array.isArray(this.removedVehiclesIds)) {
            data["removedVehiclesIds"] = [];
            for (let item of this.removedVehiclesIds)
                data["removedVehiclesIds"].push(item);
        }
        if (Array.isArray(this.addedVehiclesIds)) {
            data["addedVehiclesIds"] = [];
            for (let item of this.addedVehiclesIds)
                data["addedVehiclesIds"].push(item);
        }
        return data;
    }

    clone(): EditSubscriptionVehiclesInput {
        const json = this.toJSON();
        let result = new EditSubscriptionVehiclesInput();
        result.init(json);
        return result;
    }
}

export interface IEditSubscriptionVehiclesInput {
    subscriptionId: string;
    removedVehiclesIds: string[] | undefined;
    addedVehiclesIds: string[] | undefined;
}

export class EmailSettingsEditDto implements IEmailSettingsEditDto {
    defaultFromAddress: string | undefined;
    defaultFromDisplayName: string | undefined;
    smtpHost: string | undefined;
    smtpPort: number;
    smtpUserName: string | undefined;
    smtpPassword: string | undefined;
    smtpDomain: string | undefined;
    smtpEnableSsl: boolean;
    smtpUseDefaultCredentials: boolean;

    constructor(data?: IEmailSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.defaultFromAddress = _data["defaultFromAddress"];
            this.defaultFromDisplayName = _data["defaultFromDisplayName"];
            this.smtpHost = _data["smtpHost"];
            this.smtpPort = _data["smtpPort"];
            this.smtpUserName = _data["smtpUserName"];
            this.smtpPassword = _data["smtpPassword"];
            this.smtpDomain = _data["smtpDomain"];
            this.smtpEnableSsl = _data["smtpEnableSsl"];
            this.smtpUseDefaultCredentials = _data["smtpUseDefaultCredentials"];
        }
    }

    static fromJS(data: any): EmailSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmailSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["defaultFromAddress"] = this.defaultFromAddress;
        data["defaultFromDisplayName"] = this.defaultFromDisplayName;
        data["smtpHost"] = this.smtpHost;
        data["smtpPort"] = this.smtpPort;
        data["smtpUserName"] = this.smtpUserName;
        data["smtpPassword"] = this.smtpPassword;
        data["smtpDomain"] = this.smtpDomain;
        data["smtpEnableSsl"] = this.smtpEnableSsl;
        data["smtpUseDefaultCredentials"] = this.smtpUseDefaultCredentials;
        return data;
    }

    clone(): EmailSettingsEditDto {
        const json = this.toJSON();
        let result = new EmailSettingsEditDto();
        result.init(json);
        return result;
    }
}

export interface IEmailSettingsEditDto {
    defaultFromAddress: string | undefined;
    defaultFromDisplayName: string | undefined;
    smtpHost: string | undefined;
    smtpPort: number;
    smtpUserName: string | undefined;
    smtpPassword: string | undefined;
    smtpDomain: string | undefined;
    smtpEnableSsl: boolean;
    smtpUseDefaultCredentials: boolean;
}

export class EncryptedRequestBody implements IEncryptedRequestBody {
    encryptedBody: string;

    constructor(data?: IEncryptedRequestBody) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.encryptedBody = _data["encryptedBody"];
        }
    }

    static fromJS(data: any): EncryptedRequestBody {
        data = typeof data === 'object' ? data : {};
        let result = new EncryptedRequestBody();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["encryptedBody"] = this.encryptedBody;
        return data;
    }

    clone(): EncryptedRequestBody {
        const json = this.toJSON();
        let result = new EncryptedRequestBody();
        result.init(json);
        return result;
    }
}

export interface IEncryptedRequestBody {
    encryptedBody: string;
}

export class EndInOutReservationInputDto implements IEndInOutReservationInputDto {
    code: string | undefined;
    paymentType: PaymentType;
    posTransactionId: string | undefined;
    totalHours: number;
    applyDiscount: boolean;

    constructor(data?: IEndInOutReservationInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.paymentType = _data["paymentType"];
            this.posTransactionId = _data["posTransactionId"];
            this.totalHours = _data["totalHours"];
            this.applyDiscount = _data["applyDiscount"];
        }
    }

    static fromJS(data: any): EndInOutReservationInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new EndInOutReservationInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["paymentType"] = this.paymentType;
        data["posTransactionId"] = this.posTransactionId;
        data["totalHours"] = this.totalHours;
        data["applyDiscount"] = this.applyDiscount;
        return data;
    }

    clone(): EndInOutReservationInputDto {
        const json = this.toJSON();
        let result = new EndInOutReservationInputDto();
        result.init(json);
        return result;
    }
}

export interface IEndInOutReservationInputDto {
    code: string | undefined;
    paymentType: PaymentType;
    posTransactionId: string | undefined;
    totalHours: number;
    applyDiscount: boolean;
}

export class EntityChangeListDto implements IEntityChangeListDto {
    id: number;
    userId: number | undefined;
    userName: string | undefined;
    changeTime: moment.Moment;
    entityTypeFullName: string | undefined;
    changeType: EntityChangeType;
    readonly changeTypeName: string | undefined;
    entityChangeSetId: number;

    constructor(data?: IEntityChangeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.changeTime = _data["changeTime"] ? moment(_data["changeTime"].toString()) : <any>undefined;
            this.entityTypeFullName = _data["entityTypeFullName"];
            this.changeType = _data["changeType"];
            (<any>this).changeTypeName = _data["changeTypeName"];
            this.entityChangeSetId = _data["entityChangeSetId"];
        }
    }

    static fromJS(data: any): EntityChangeListDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityChangeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["changeTime"] = this.changeTime ? this.changeTime.toISOString() : <any>undefined;
        data["entityTypeFullName"] = this.entityTypeFullName;
        data["changeType"] = this.changeType;
        data["changeTypeName"] = this.changeTypeName;
        data["entityChangeSetId"] = this.entityChangeSetId;
        return data;
    }

    clone(): EntityChangeListDto {
        const json = this.toJSON();
        let result = new EntityChangeListDto();
        result.init(json);
        return result;
    }
}

export interface IEntityChangeListDto {
    id: number;
    userId: number | undefined;
    userName: string | undefined;
    changeTime: moment.Moment;
    entityTypeFullName: string | undefined;
    changeType: EntityChangeType;
    changeTypeName: string | undefined;
    entityChangeSetId: number;
}

export class EntityChangeListDtoPagedResultDto implements IEntityChangeListDtoPagedResultDto {
    items: EntityChangeListDto[] | undefined;
    totalCount: number;

    constructor(data?: IEntityChangeListDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(EntityChangeListDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): EntityChangeListDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityChangeListDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): EntityChangeListDtoPagedResultDto {
        const json = this.toJSON();
        let result = new EntityChangeListDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IEntityChangeListDtoPagedResultDto {
    items: EntityChangeListDto[] | undefined;
    totalCount: number;
}

export enum EntityChangeType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class EntityPropertyChangeDto implements IEntityPropertyChangeDto {
    id: number;
    entityChangeId: number;
    newValue: string | undefined;
    originalValue: string | undefined;
    propertyName: string | undefined;
    propertyTypeFullName: string | undefined;
    tenantId: number | undefined;

    constructor(data?: IEntityPropertyChangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.entityChangeId = _data["entityChangeId"];
            this.newValue = _data["newValue"];
            this.originalValue = _data["originalValue"];
            this.propertyName = _data["propertyName"];
            this.propertyTypeFullName = _data["propertyTypeFullName"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): EntityPropertyChangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityPropertyChangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["entityChangeId"] = this.entityChangeId;
        data["newValue"] = this.newValue;
        data["originalValue"] = this.originalValue;
        data["propertyName"] = this.propertyName;
        data["propertyTypeFullName"] = this.propertyTypeFullName;
        data["tenantId"] = this.tenantId;
        return data;
    }

    clone(): EntityPropertyChangeDto {
        const json = this.toJSON();
        let result = new EntityPropertyChangeDto();
        result.init(json);
        return result;
    }
}

export interface IEntityPropertyChangeDto {
    id: number;
    entityChangeId: number;
    newValue: string | undefined;
    originalValue: string | undefined;
    propertyName: string | undefined;
    propertyTypeFullName: string | undefined;
    tenantId: number | undefined;
}

export class Envelope implements IEnvelope {
    readonly isNull: boolean;
    readonly width: number;
    readonly height: number;
    readonly diameter: number;
    readonly minX: number;
    readonly maxX: number;
    readonly minY: number;
    readonly maxY: number;
    readonly area: number;
    readonly minExtent: number;
    readonly maxExtent: number;
    centre: Coordinate;

    constructor(data?: IEnvelope) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).isNull = _data["isNull"];
            (<any>this).width = _data["width"];
            (<any>this).height = _data["height"];
            (<any>this).diameter = _data["diameter"];
            (<any>this).minX = _data["minX"];
            (<any>this).maxX = _data["maxX"];
            (<any>this).minY = _data["minY"];
            (<any>this).maxY = _data["maxY"];
            (<any>this).area = _data["area"];
            (<any>this).minExtent = _data["minExtent"];
            (<any>this).maxExtent = _data["maxExtent"];
            this.centre = _data["centre"] ? Coordinate.fromJS(_data["centre"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Envelope {
        data = typeof data === 'object' ? data : {};
        let result = new Envelope();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isNull"] = this.isNull;
        data["width"] = this.width;
        data["height"] = this.height;
        data["diameter"] = this.diameter;
        data["minX"] = this.minX;
        data["maxX"] = this.maxX;
        data["minY"] = this.minY;
        data["maxY"] = this.maxY;
        data["area"] = this.area;
        data["minExtent"] = this.minExtent;
        data["maxExtent"] = this.maxExtent;
        data["centre"] = this.centre ? this.centre.toJSON() : <any>undefined;
        return data;
    }

    clone(): Envelope {
        const json = this.toJSON();
        let result = new Envelope();
        result.init(json);
        return result;
    }
}

export interface IEnvelope {
    isNull: boolean;
    width: number;
    height: number;
    diameter: number;
    minX: number;
    maxX: number;
    minY: number;
    maxY: number;
    area: number;
    minExtent: number;
    maxExtent: number;
    centre: Coordinate;
}

export class ExportReservationDto implements IExportReservationDto {
    id: string;
    invoiceNumber: number;
    fullName: string | undefined;
    locationName: string | undefined;
    qrCodeName: string | undefined;
    slotName: string | undefined;
    paymentType: string | undefined;
    hours: number;
    countryCode: string | undefined;
    phoneNumber: string | undefined;
    carPlate: string | undefined;
    vehicleType: VehicleType;
    country: string | undefined;
    currency: string | undefined;
    transactionReferenceId: string | undefined;
    paymentReferenceId: string | undefined;
    paymentStatus: string | undefined;
    hourRate: number;
    vatAmount: number;
    vatPercentage: number;
    subTotal: number;
    total: number;
    startTime: moment.Moment;
    endTime: moment.Moment;

    constructor(data?: IExportReservationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.fullName = _data["fullName"];
            this.locationName = _data["locationName"];
            this.qrCodeName = _data["qrCodeName"];
            this.slotName = _data["slotName"];
            this.paymentType = _data["paymentType"];
            this.hours = _data["hours"];
            this.countryCode = _data["countryCode"];
            this.phoneNumber = _data["phoneNumber"];
            this.carPlate = _data["carPlate"];
            this.vehicleType = _data["vehicleType"];
            this.country = _data["country"];
            this.currency = _data["currency"];
            this.transactionReferenceId = _data["transactionReferenceId"];
            this.paymentReferenceId = _data["paymentReferenceId"];
            this.paymentStatus = _data["paymentStatus"];
            this.hourRate = _data["hourRate"];
            this.vatAmount = _data["vatAmount"];
            this.vatPercentage = _data["vatPercentage"];
            this.subTotal = _data["subTotal"];
            this.total = _data["total"];
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ExportReservationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExportReservationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["invoiceNumber"] = this.invoiceNumber;
        data["fullName"] = this.fullName;
        data["locationName"] = this.locationName;
        data["qrCodeName"] = this.qrCodeName;
        data["slotName"] = this.slotName;
        data["paymentType"] = this.paymentType;
        data["hours"] = this.hours;
        data["countryCode"] = this.countryCode;
        data["phoneNumber"] = this.phoneNumber;
        data["carPlate"] = this.carPlate;
        data["vehicleType"] = this.vehicleType;
        data["country"] = this.country;
        data["currency"] = this.currency;
        data["transactionReferenceId"] = this.transactionReferenceId;
        data["paymentReferenceId"] = this.paymentReferenceId;
        data["paymentStatus"] = this.paymentStatus;
        data["hourRate"] = this.hourRate;
        data["vatAmount"] = this.vatAmount;
        data["vatPercentage"] = this.vatPercentage;
        data["subTotal"] = this.subTotal;
        data["total"] = this.total;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): ExportReservationDto {
        const json = this.toJSON();
        let result = new ExportReservationDto();
        result.init(json);
        return result;
    }
}

export interface IExportReservationDto {
    id: string;
    invoiceNumber: number;
    fullName: string | undefined;
    locationName: string | undefined;
    qrCodeName: string | undefined;
    slotName: string | undefined;
    paymentType: string | undefined;
    hours: number;
    countryCode: string | undefined;
    phoneNumber: string | undefined;
    carPlate: string | undefined;
    vehicleType: VehicleType;
    country: string | undefined;
    currency: string | undefined;
    transactionReferenceId: string | undefined;
    paymentReferenceId: string | undefined;
    paymentStatus: string | undefined;
    hourRate: number;
    vatAmount: number;
    vatPercentage: number;
    subTotal: number;
    total: number;
    startTime: moment.Moment;
    endTime: moment.Moment;
}

export class ExportViolationDto implements IExportViolationDto {
    id: string;
    code: number;
    fullCarPlate: string | undefined;
    vehicleType: VehicleType;
    country: string | undefined;
    customerName: string | undefined;
    phoneNumber: string | undefined;
    reservationNumber: string | undefined;
    price: number;
    shiftCode: number;
    slotName: string | undefined;
    status: string | undefined;
    creationTime: moment.Moment;
    transactionNumber: string | undefined;
    creator: string | undefined;
    history: string | undefined;
    transactioNumber: string | undefined;
    invoiceNumber: string | undefined;
    onlineTransactionReferenceNumber: string | undefined;
    posTransactionReferenceNumber: string | undefined;
    clampNumber: string | undefined;
    paymentReferenceId: string | undefined;

    constructor(data?: IExportViolationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.fullCarPlate = _data["fullCarPlate"];
            this.vehicleType = _data["vehicleType"];
            this.country = _data["country"];
            this.customerName = _data["customerName"];
            this.phoneNumber = _data["phoneNumber"];
            this.reservationNumber = _data["reservationNumber"];
            this.price = _data["price"];
            this.shiftCode = _data["shiftCode"];
            this.slotName = _data["slotName"];
            this.status = _data["status"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.transactionNumber = _data["transactionNumber"];
            this.creator = _data["creator"];
            this.history = _data["history"];
            this.transactioNumber = _data["transactioNumber"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.onlineTransactionReferenceNumber = _data["onlineTransactionReferenceNumber"];
            this.posTransactionReferenceNumber = _data["posTransactionReferenceNumber"];
            this.clampNumber = _data["clampNumber"];
            this.paymentReferenceId = _data["paymentReferenceId"];
        }
    }

    static fromJS(data: any): ExportViolationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExportViolationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["fullCarPlate"] = this.fullCarPlate;
        data["vehicleType"] = this.vehicleType;
        data["country"] = this.country;
        data["customerName"] = this.customerName;
        data["phoneNumber"] = this.phoneNumber;
        data["reservationNumber"] = this.reservationNumber;
        data["price"] = this.price;
        data["shiftCode"] = this.shiftCode;
        data["slotName"] = this.slotName;
        data["status"] = this.status;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["transactionNumber"] = this.transactionNumber;
        data["creator"] = this.creator;
        data["history"] = this.history;
        data["transactioNumber"] = this.transactioNumber;
        data["invoiceNumber"] = this.invoiceNumber;
        data["onlineTransactionReferenceNumber"] = this.onlineTransactionReferenceNumber;
        data["posTransactionReferenceNumber"] = this.posTransactionReferenceNumber;
        data["clampNumber"] = this.clampNumber;
        data["paymentReferenceId"] = this.paymentReferenceId;
        return data;
    }

    clone(): ExportViolationDto {
        const json = this.toJSON();
        let result = new ExportViolationDto();
        result.init(json);
        return result;
    }
}

export interface IExportViolationDto {
    id: string;
    code: number;
    fullCarPlate: string | undefined;
    vehicleType: VehicleType;
    country: string | undefined;
    customerName: string | undefined;
    phoneNumber: string | undefined;
    reservationNumber: string | undefined;
    price: number;
    shiftCode: number;
    slotName: string | undefined;
    status: string | undefined;
    creationTime: moment.Moment;
    transactionNumber: string | undefined;
    creator: string | undefined;
    history: string | undefined;
    transactioNumber: string | undefined;
    invoiceNumber: string | undefined;
    onlineTransactionReferenceNumber: string | undefined;
    posTransactionReferenceNumber: string | undefined;
    clampNumber: string | undefined;
    paymentReferenceId: string | undefined;
}

export class ExternalAuthenticateModel implements IExternalAuthenticateModel {
    authProvider: string;
    providerKey: string;
    providerAccessCode: string;

    constructor(data?: IExternalAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authProvider = _data["authProvider"];
            this.providerKey = _data["providerKey"];
            this.providerAccessCode = _data["providerAccessCode"];
        }
    }

    static fromJS(data: any): ExternalAuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalAuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authProvider"] = this.authProvider;
        data["providerKey"] = this.providerKey;
        data["providerAccessCode"] = this.providerAccessCode;
        return data;
    }

    clone(): ExternalAuthenticateModel {
        const json = this.toJSON();
        let result = new ExternalAuthenticateModel();
        result.init(json);
        return result;
    }
}

export interface IExternalAuthenticateModel {
    authProvider: string;
    providerKey: string;
    providerAccessCode: string;
}

export class ExternalAuthenticateResultModel implements IExternalAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    waitingForActivation: boolean;

    constructor(data?: IExternalAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
            this.waitingForActivation = _data["waitingForActivation"];
        }
    }

    static fromJS(data: any): ExternalAuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalAuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["waitingForActivation"] = this.waitingForActivation;
        return data;
    }

    clone(): ExternalAuthenticateResultModel {
        const json = this.toJSON();
        let result = new ExternalAuthenticateResultModel();
        result.init(json);
        return result;
    }
}

export interface IExternalAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    waitingForActivation: boolean;
}

export class ExternalInvoiceDto implements IExternalInvoiceDto {
    id: string;
    transactionReferenceId: string;
    identity: number;
    source: ExternalSource;
    invoiceNumber: string | undefined;
    total: number;
    subTotal: number;
    vatAmount: number;
    readonly currency: string | undefined;
    paymentReceivedTime: moment.Moment;
    creationTime: moment.Moment;

    constructor(data?: IExternalInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.transactionReferenceId = _data["transactionReferenceId"];
            this.identity = _data["identity"];
            this.source = _data["source"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.total = _data["total"];
            this.subTotal = _data["subTotal"];
            this.vatAmount = _data["vatAmount"];
            (<any>this).currency = _data["currency"];
            this.paymentReceivedTime = _data["paymentReceivedTime"] ? moment(_data["paymentReceivedTime"].toString()) : <any>undefined;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ExternalInvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalInvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["transactionReferenceId"] = this.transactionReferenceId;
        data["identity"] = this.identity;
        data["source"] = this.source;
        data["invoiceNumber"] = this.invoiceNumber;
        data["total"] = this.total;
        data["subTotal"] = this.subTotal;
        data["vatAmount"] = this.vatAmount;
        data["currency"] = this.currency;
        data["paymentReceivedTime"] = this.paymentReceivedTime ? this.paymentReceivedTime.toISOString() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): ExternalInvoiceDto {
        const json = this.toJSON();
        let result = new ExternalInvoiceDto();
        result.init(json);
        return result;
    }
}

export interface IExternalInvoiceDto {
    id: string;
    transactionReferenceId: string;
    identity: number;
    source: ExternalSource;
    invoiceNumber: string | undefined;
    total: number;
    subTotal: number;
    vatAmount: number;
    currency: string | undefined;
    paymentReceivedTime: moment.Moment;
    creationTime: moment.Moment;
}

export class ExternalInvoiceDtoPagedResultDto implements IExternalInvoiceDtoPagedResultDto {
    items: ExternalInvoiceDto[] | undefined;
    totalCount: number;

    constructor(data?: IExternalInvoiceDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ExternalInvoiceDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ExternalInvoiceDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalInvoiceDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ExternalInvoiceDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ExternalInvoiceDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IExternalInvoiceDtoPagedResultDto {
    items: ExternalInvoiceDto[] | undefined;
    totalCount: number;
}

export class ExternalLoginProviderInfoModel implements IExternalLoginProviderInfoModel {
    name: string | undefined;
    clientId: string | undefined;

    constructor(data?: IExternalLoginProviderInfoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.clientId = _data["clientId"];
        }
    }

    static fromJS(data: any): ExternalLoginProviderInfoModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalLoginProviderInfoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["clientId"] = this.clientId;
        return data;
    }

    clone(): ExternalLoginProviderInfoModel {
        const json = this.toJSON();
        let result = new ExternalLoginProviderInfoModel();
        result.init(json);
        return result;
    }
}

export interface IExternalLoginProviderInfoModel {
    name: string | undefined;
    clientId: string | undefined;
}

export enum ExternalSource {
    _0 = 0,
}

export class FailureLogResponse implements IFailureLogResponse {
    id: string;
    command: string | undefined;
    payload: string | undefined;
    error: string | undefined;
    stackTrace: string | undefined;
    creationTime: moment.Moment;

    constructor(data?: IFailureLogResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.command = _data["command"];
            this.payload = _data["payload"];
            this.error = _data["error"];
            this.stackTrace = _data["stackTrace"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): FailureLogResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FailureLogResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["command"] = this.command;
        data["payload"] = this.payload;
        data["error"] = this.error;
        data["stackTrace"] = this.stackTrace;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): FailureLogResponse {
        const json = this.toJSON();
        let result = new FailureLogResponse();
        result.init(json);
        return result;
    }
}

export interface IFailureLogResponse {
    id: string;
    command: string | undefined;
    payload: string | undefined;
    error: string | undefined;
    stackTrace: string | undefined;
    creationTime: moment.Moment;
}

export class FailureLogResponsePagedResultDto implements IFailureLogResponsePagedResultDto {
    items: FailureLogResponse[] | undefined;
    totalCount: number;

    constructor(data?: IFailureLogResponsePagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(FailureLogResponse.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): FailureLogResponsePagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new FailureLogResponsePagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): FailureLogResponsePagedResultDto {
        const json = this.toJSON();
        let result = new FailureLogResponsePagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IFailureLogResponsePagedResultDto {
    items: FailureLogResponse[] | undefined;
    totalCount: number;
}

export class FetchInvoicesRequest implements IFetchInvoicesRequest {
    source: string | undefined;
    fileName: string | undefined;
    filePath: string | undefined;

    constructor(data?: IFetchInvoicesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.source = _data["source"];
            this.fileName = _data["fileName"];
            this.filePath = _data["filePath"];
        }
    }

    static fromJS(data: any): FetchInvoicesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FetchInvoicesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["source"] = this.source;
        data["fileName"] = this.fileName;
        data["filePath"] = this.filePath;
        return data;
    }

    clone(): FetchInvoicesRequest {
        const json = this.toJSON();
        let result = new FetchInvoicesRequest();
        result.init(json);
        return result;
    }
}

export interface IFetchInvoicesRequest {
    source: string | undefined;
    fileName: string | undefined;
    filePath: string | undefined;
}

export class FetchMetricTransactionByDatesDto implements IFetchMetricTransactionByDatesDto {
    fromDate: moment.Moment;
    toDate: moment.Moment;

    constructor(data?: IFetchMetricTransactionByDatesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fromDate = _data["fromDate"] ? moment(_data["fromDate"].toString()) : <any>undefined;
            this.toDate = _data["toDate"] ? moment(_data["toDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): FetchMetricTransactionByDatesDto {
        data = typeof data === 'object' ? data : {};
        let result = new FetchMetricTransactionByDatesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fromDate"] = this.fromDate ? this.fromDate.format('YYYY-MM-DD') : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.format('YYYY-MM-DD') : <any>undefined;
        return data;
    }

    clone(): FetchMetricTransactionByDatesDto {
        const json = this.toJSON();
        let result = new FetchMetricTransactionByDatesDto();
        result.init(json);
        return result;
    }
}

export interface IFetchMetricTransactionByDatesDto {
    fromDate: moment.Moment;
    toDate: moment.Moment;
}

export class FileDto implements IFileDto {
    fileName: string;
    fileType: string;
    fileToken: string;

    constructor(data?: IFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.fileType = _data["fileType"];
            this.fileToken = _data["fileToken"];
        }
    }

    static fromJS(data: any): FileDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["fileToken"] = this.fileToken;
        return data;
    }

    clone(): FileDto {
        const json = this.toJSON();
        let result = new FileDto();
        result.init(json);
        return result;
    }
}

export interface IFileDto {
    fileName: string;
    fileType: string;
    fileToken: string;
}

export class FlatPermissionDto implements IFlatPermissionDto {
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    parent: FlatPermissionDto;
    readonly children: FlatPermissionDto[] | undefined;

    constructor(data?: IFlatPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.parent = _data["parent"] ? FlatPermissionDto.fromJS(_data["parent"]) : <any>undefined;
            if (Array.isArray(_data["children"])) {
                (<any>this).children = [] as any;
                for (let item of _data["children"])
                    (<any>this).children.push(FlatPermissionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FlatPermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["parent"] = this.parent ? this.parent.toJSON() : <any>undefined;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        return data;
    }

    clone(): FlatPermissionDto {
        const json = this.toJSON();
        let result = new FlatPermissionDto();
        result.init(json);
        return result;
    }
}

export interface IFlatPermissionDto {
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    parent: FlatPermissionDto;
    children: FlatPermissionDto[] | undefined;
}

export class GenerateQRCodeInput implements IGenerateQRCodeInput {
    count: number;

    constructor(data?: IGenerateQRCodeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): GenerateQRCodeInput {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateQRCodeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        return data;
    }

    clone(): GenerateQRCodeInput {
        const json = this.toJSON();
        let result = new GenerateQRCodeInput();
        result.init(json);
        return result;
    }
}

export interface IGenerateQRCodeInput {
    count: number;
}

export class GenerateSlotsInputDto implements IGenerateSlotsInputDto {
    locationId: number;
    capacity: number;
    identifier: string | undefined;
    isActive: boolean;

    constructor(data?: IGenerateSlotsInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationId = _data["locationId"];
            this.capacity = _data["capacity"];
            this.identifier = _data["identifier"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): GenerateSlotsInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateSlotsInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId;
        data["capacity"] = this.capacity;
        data["identifier"] = this.identifier;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): GenerateSlotsInputDto {
        const json = this.toJSON();
        let result = new GenerateSlotsInputDto();
        result.init(json);
        return result;
    }
}

export interface IGenerateSlotsInputDto {
    locationId: number;
    capacity: number;
    identifier: string | undefined;
    isActive: boolean;
}

export class Geometry implements IGeometry {
    factory: GeometryFactory;
    userData: any | undefined;
    srid: number;
    readonly geometryType: string | undefined;
    ogcGeometryType: OgcGeometryType;
    precisionModel: PrecisionModel;
    coordinate: Coordinate;
    readonly coordinates: Coordinate[] | undefined;
    readonly numPoints: number;
    readonly numGeometries: number;
    readonly isSimple: boolean;
    readonly isValid: boolean;
    readonly isEmpty: boolean;
    readonly area: number;
    readonly length: number;
    centroid: Point;
    interiorPoint: Point;
    pointOnSurface: Point;
    dimension: Dimension;
    boundary: Geometry;
    boundaryDimension: Dimension;
    envelope: Geometry;
    envelopeInternal: Envelope;
    readonly isRectangle: boolean;

    constructor(data?: IGeometry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.factory = _data["factory"] ? GeometryFactory.fromJS(_data["factory"]) : <any>undefined;
            this.userData = _data["userData"];
            this.srid = _data["srid"];
            (<any>this).geometryType = _data["geometryType"];
            this.ogcGeometryType = _data["ogcGeometryType"];
            this.precisionModel = _data["precisionModel"] ? PrecisionModel.fromJS(_data["precisionModel"]) : <any>undefined;
            this.coordinate = _data["coordinate"] ? Coordinate.fromJS(_data["coordinate"]) : <any>undefined;
            if (Array.isArray(_data["coordinates"])) {
                (<any>this).coordinates = [] as any;
                for (let item of _data["coordinates"])
                    (<any>this).coordinates.push(Coordinate.fromJS(item));
            }
            (<any>this).numPoints = _data["numPoints"];
            (<any>this).numGeometries = _data["numGeometries"];
            (<any>this).isSimple = _data["isSimple"];
            (<any>this).isValid = _data["isValid"];
            (<any>this).isEmpty = _data["isEmpty"];
            (<any>this).area = _data["area"];
            (<any>this).length = _data["length"];
            this.centroid = _data["centroid"] ? Point.fromJS(_data["centroid"]) : <any>undefined;
            this.interiorPoint = _data["interiorPoint"] ? Point.fromJS(_data["interiorPoint"]) : <any>undefined;
            this.pointOnSurface = _data["pointOnSurface"] ? Point.fromJS(_data["pointOnSurface"]) : <any>undefined;
            this.dimension = _data["dimension"];
            this.boundary = _data["boundary"] ? Geometry.fromJS(_data["boundary"]) : <any>undefined;
            this.boundaryDimension = _data["boundaryDimension"];
            this.envelope = _data["envelope"] ? Geometry.fromJS(_data["envelope"]) : <any>undefined;
            this.envelopeInternal = _data["envelopeInternal"] ? Envelope.fromJS(_data["envelopeInternal"]) : <any>undefined;
            (<any>this).isRectangle = _data["isRectangle"];
        }
    }

    static fromJS(data: any): Geometry {
        data = typeof data === 'object' ? data : {};
        let result = new Geometry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["factory"] = this.factory ? this.factory.toJSON() : <any>undefined;
        data["userData"] = this.userData;
        data["srid"] = this.srid;
        data["geometryType"] = this.geometryType;
        data["ogcGeometryType"] = this.ogcGeometryType;
        data["precisionModel"] = this.precisionModel ? this.precisionModel.toJSON() : <any>undefined;
        data["coordinate"] = this.coordinate ? this.coordinate.toJSON() : <any>undefined;
        if (Array.isArray(this.coordinates)) {
            data["coordinates"] = [];
            for (let item of this.coordinates)
                data["coordinates"].push(item.toJSON());
        }
        data["numPoints"] = this.numPoints;
        data["numGeometries"] = this.numGeometries;
        data["isSimple"] = this.isSimple;
        data["isValid"] = this.isValid;
        data["isEmpty"] = this.isEmpty;
        data["area"] = this.area;
        data["length"] = this.length;
        data["centroid"] = this.centroid ? this.centroid.toJSON() : <any>undefined;
        data["interiorPoint"] = this.interiorPoint ? this.interiorPoint.toJSON() : <any>undefined;
        data["pointOnSurface"] = this.pointOnSurface ? this.pointOnSurface.toJSON() : <any>undefined;
        data["dimension"] = this.dimension;
        data["boundary"] = this.boundary ? this.boundary.toJSON() : <any>undefined;
        data["boundaryDimension"] = this.boundaryDimension;
        data["envelope"] = this.envelope ? this.envelope.toJSON() : <any>undefined;
        data["envelopeInternal"] = this.envelopeInternal ? this.envelopeInternal.toJSON() : <any>undefined;
        data["isRectangle"] = this.isRectangle;
        return data;
    }

    clone(): Geometry {
        const json = this.toJSON();
        let result = new Geometry();
        result.init(json);
        return result;
    }
}

export interface IGeometry {
    factory: GeometryFactory;
    userData: any | undefined;
    srid: number;
    geometryType: string | undefined;
    ogcGeometryType: OgcGeometryType;
    precisionModel: PrecisionModel;
    coordinate: Coordinate;
    coordinates: Coordinate[] | undefined;
    numPoints: number;
    numGeometries: number;
    isSimple: boolean;
    isValid: boolean;
    isEmpty: boolean;
    area: number;
    length: number;
    centroid: Point;
    interiorPoint: Point;
    pointOnSurface: Point;
    dimension: Dimension;
    boundary: Geometry;
    boundaryDimension: Dimension;
    envelope: Geometry;
    envelopeInternal: Envelope;
    isRectangle: boolean;
}

export class GeometryFactory implements IGeometryFactory {
    precisionModel: PrecisionModel;
    coordinateSequenceFactory: CoordinateSequenceFactory;
    readonly srid: number;
    geometryServices: NtsGeometryServices;

    constructor(data?: IGeometryFactory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.precisionModel = _data["precisionModel"] ? PrecisionModel.fromJS(_data["precisionModel"]) : <any>undefined;
            this.coordinateSequenceFactory = _data["coordinateSequenceFactory"] ? CoordinateSequenceFactory.fromJS(_data["coordinateSequenceFactory"]) : <any>undefined;
            (<any>this).srid = _data["srid"];
            this.geometryServices = _data["geometryServices"] ? NtsGeometryServices.fromJS(_data["geometryServices"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GeometryFactory {
        data = typeof data === 'object' ? data : {};
        let result = new GeometryFactory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["precisionModel"] = this.precisionModel ? this.precisionModel.toJSON() : <any>undefined;
        data["coordinateSequenceFactory"] = this.coordinateSequenceFactory ? this.coordinateSequenceFactory.toJSON() : <any>undefined;
        data["srid"] = this.srid;
        data["geometryServices"] = this.geometryServices ? this.geometryServices.toJSON() : <any>undefined;
        return data;
    }

    clone(): GeometryFactory {
        const json = this.toJSON();
        let result = new GeometryFactory();
        result.init(json);
        return result;
    }
}

export interface IGeometryFactory {
    precisionModel: PrecisionModel;
    coordinateSequenceFactory: CoordinateSequenceFactory;
    srid: number;
    geometryServices: NtsGeometryServices;
}

export class GeometryOverlay implements IGeometryOverlay {

    constructor(data?: IGeometryOverlay) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GeometryOverlay {
        data = typeof data === 'object' ? data : {};
        let result = new GeometryOverlay();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): GeometryOverlay {
        const json = this.toJSON();
        let result = new GeometryOverlay();
        result.init(json);
        return result;
    }
}

export interface IGeometryOverlay {
}

export class GetAllTransactionListDto implements IGetAllTransactionListDto {
    id: string;
    transactionNumber: string | undefined;
    status: PaymentStatus;
    paymentType: PaymentType;
    source: TransactionSource;
    entityId: string;
    total: number;
    vatPercentage: number;
    vatAmount: number;
    subTotal: number;
    invoiceNumber: string | undefined;

    constructor(data?: IGetAllTransactionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.transactionNumber = _data["transactionNumber"];
            this.status = _data["status"] ? PaymentStatus.fromJS(_data["status"]) : <any>undefined;
            this.paymentType = _data["paymentType"];
            this.source = _data["source"];
            this.entityId = _data["entityId"];
            this.total = _data["total"];
            this.vatPercentage = _data["vatPercentage"];
            this.vatAmount = _data["vatAmount"];
            this.subTotal = _data["subTotal"];
            this.invoiceNumber = _data["invoiceNumber"];
        }
    }

    static fromJS(data: any): GetAllTransactionListDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllTransactionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["transactionNumber"] = this.transactionNumber;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["paymentType"] = this.paymentType;
        data["source"] = this.source;
        data["entityId"] = this.entityId;
        data["total"] = this.total;
        data["vatPercentage"] = this.vatPercentage;
        data["vatAmount"] = this.vatAmount;
        data["subTotal"] = this.subTotal;
        data["invoiceNumber"] = this.invoiceNumber;
        return data;
    }

    clone(): GetAllTransactionListDto {
        const json = this.toJSON();
        let result = new GetAllTransactionListDto();
        result.init(json);
        return result;
    }
}

export interface IGetAllTransactionListDto {
    id: string;
    transactionNumber: string | undefined;
    status: PaymentStatus;
    paymentType: PaymentType;
    source: TransactionSource;
    entityId: string;
    total: number;
    vatPercentage: number;
    vatAmount: number;
    subTotal: number;
    invoiceNumber: string | undefined;
}

export class GetAllTransactionListDtoPagedResultDto implements IGetAllTransactionListDtoPagedResultDto {
    items: GetAllTransactionListDto[] | undefined;
    totalCount: number;

    constructor(data?: IGetAllTransactionListDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(GetAllTransactionListDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): GetAllTransactionListDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllTransactionListDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): GetAllTransactionListDtoPagedResultDto {
        const json = this.toJSON();
        let result = new GetAllTransactionListDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IGetAllTransactionListDtoPagedResultDto {
    items: GetAllTransactionListDto[] | undefined;
    totalCount: number;
}

export class GetByCarPlateOutput implements IGetByCarPlateOutput {
    id: string;
    number: number;
    carPlateLetters: string | undefined;
    carPlateDigits: number;
    customerName: string | undefined;
    customerPhoneNumber: string | undefined;
    subscriberType: SubscriberType;
    subscriptionType: SubscriptionType;
    benefeciaryName: string | undefined;
    startDate: moment.Moment;
    endDate: moment.Moment;
    startTime: TimeSpan;
    endTime: TimeSpan;
    isExpired: boolean;
    locations: LocationItemDto[] | undefined;
    subscriptionPackage: SubscriptionPackageDto;
    expiryStatus: SubscriptionExpiryStatus;
    vehiclesCount: number;
    status: string | undefined;

    constructor(data?: IGetByCarPlateOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.number = _data["number"];
            this.carPlateLetters = _data["carPlateLetters"];
            this.carPlateDigits = _data["carPlateDigits"];
            this.customerName = _data["customerName"];
            this.customerPhoneNumber = _data["customerPhoneNumber"];
            this.subscriberType = _data["subscriberType"];
            this.subscriptionType = _data["subscriptionType"];
            this.benefeciaryName = _data["benefeciaryName"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.startTime = _data["startTime"] ? TimeSpan.fromJS(_data["startTime"]) : <any>undefined;
            this.endTime = _data["endTime"] ? TimeSpan.fromJS(_data["endTime"]) : <any>undefined;
            this.isExpired = _data["isExpired"];
            if (Array.isArray(_data["locations"])) {
                this.locations = [] as any;
                for (let item of _data["locations"])
                    this.locations.push(LocationItemDto.fromJS(item));
            }
            this.subscriptionPackage = _data["subscriptionPackage"] ? SubscriptionPackageDto.fromJS(_data["subscriptionPackage"]) : <any>undefined;
            this.expiryStatus = _data["expiryStatus"];
            this.vehiclesCount = _data["vehiclesCount"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): GetByCarPlateOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetByCarPlateOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["number"] = this.number;
        data["carPlateLetters"] = this.carPlateLetters;
        data["carPlateDigits"] = this.carPlateDigits;
        data["customerName"] = this.customerName;
        data["customerPhoneNumber"] = this.customerPhoneNumber;
        data["subscriberType"] = this.subscriberType;
        data["subscriptionType"] = this.subscriptionType;
        data["benefeciaryName"] = this.benefeciaryName;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["startTime"] = this.startTime ? this.startTime.toJSON() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toJSON() : <any>undefined;
        data["isExpired"] = this.isExpired;
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (let item of this.locations)
                data["locations"].push(item.toJSON());
        }
        data["subscriptionPackage"] = this.subscriptionPackage ? this.subscriptionPackage.toJSON() : <any>undefined;
        data["expiryStatus"] = this.expiryStatus;
        data["vehiclesCount"] = this.vehiclesCount;
        data["status"] = this.status;
        return data;
    }

    clone(): GetByCarPlateOutput {
        const json = this.toJSON();
        let result = new GetByCarPlateOutput();
        result.init(json);
        return result;
    }
}

export interface IGetByCarPlateOutput {
    id: string;
    number: number;
    carPlateLetters: string | undefined;
    carPlateDigits: number;
    customerName: string | undefined;
    customerPhoneNumber: string | undefined;
    subscriberType: SubscriberType;
    subscriptionType: SubscriptionType;
    benefeciaryName: string | undefined;
    startDate: moment.Moment;
    endDate: moment.Moment;
    startTime: TimeSpan;
    endTime: TimeSpan;
    isExpired: boolean;
    locations: LocationItemDto[] | undefined;
    subscriptionPackage: SubscriptionPackageDto;
    expiryStatus: SubscriptionExpiryStatus;
    vehiclesCount: number;
    status: string | undefined;
}

export class GetByCarPlateOutputPagedResultDto implements IGetByCarPlateOutputPagedResultDto {
    items: GetByCarPlateOutput[] | undefined;
    totalCount: number;

    constructor(data?: IGetByCarPlateOutputPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(GetByCarPlateOutput.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): GetByCarPlateOutputPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetByCarPlateOutputPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): GetByCarPlateOutputPagedResultDto {
        const json = this.toJSON();
        let result = new GetByCarPlateOutputPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IGetByCarPlateOutputPagedResultDto {
    items: GetByCarPlateOutput[] | undefined;
    totalCount: number;
}

export class GetByQRCodeOutput implements IGetByQRCodeOutput {
    id: string;
    number: number;
    carPlateLetters: string | undefined;
    carPlateDigits: number;
    customerName: string | undefined;
    customerPhoneNumber: string | undefined;
    subscriberType: SubscriberType;
    subscriptionType: SubscriptionType;
    benefeciaryName: string | undefined;
    startDate: moment.Moment;
    endDate: moment.Moment;
    startTime: TimeSpan;
    endTime: TimeSpan;
    isExpired: boolean;
    locations: LocationItemDto[] | undefined;
    subscriptionPackage: SubscriptionPackageDto;
    status: string | undefined;
    expiryStatus: SubscriptionExpiryStatus;

    constructor(data?: IGetByQRCodeOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.number = _data["number"];
            this.carPlateLetters = _data["carPlateLetters"];
            this.carPlateDigits = _data["carPlateDigits"];
            this.customerName = _data["customerName"];
            this.customerPhoneNumber = _data["customerPhoneNumber"];
            this.subscriberType = _data["subscriberType"];
            this.subscriptionType = _data["subscriptionType"];
            this.benefeciaryName = _data["benefeciaryName"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.startTime = _data["startTime"] ? TimeSpan.fromJS(_data["startTime"]) : <any>undefined;
            this.endTime = _data["endTime"] ? TimeSpan.fromJS(_data["endTime"]) : <any>undefined;
            this.isExpired = _data["isExpired"];
            if (Array.isArray(_data["locations"])) {
                this.locations = [] as any;
                for (let item of _data["locations"])
                    this.locations.push(LocationItemDto.fromJS(item));
            }
            this.subscriptionPackage = _data["subscriptionPackage"] ? SubscriptionPackageDto.fromJS(_data["subscriptionPackage"]) : <any>undefined;
            this.status = _data["status"];
            this.expiryStatus = _data["expiryStatus"];
        }
    }

    static fromJS(data: any): GetByQRCodeOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetByQRCodeOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["number"] = this.number;
        data["carPlateLetters"] = this.carPlateLetters;
        data["carPlateDigits"] = this.carPlateDigits;
        data["customerName"] = this.customerName;
        data["customerPhoneNumber"] = this.customerPhoneNumber;
        data["subscriberType"] = this.subscriberType;
        data["subscriptionType"] = this.subscriptionType;
        data["benefeciaryName"] = this.benefeciaryName;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["startTime"] = this.startTime ? this.startTime.toJSON() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toJSON() : <any>undefined;
        data["isExpired"] = this.isExpired;
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (let item of this.locations)
                data["locations"].push(item.toJSON());
        }
        data["subscriptionPackage"] = this.subscriptionPackage ? this.subscriptionPackage.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["expiryStatus"] = this.expiryStatus;
        return data;
    }

    clone(): GetByQRCodeOutput {
        const json = this.toJSON();
        let result = new GetByQRCodeOutput();
        result.init(json);
        return result;
    }
}

export interface IGetByQRCodeOutput {
    id: string;
    number: number;
    carPlateLetters: string | undefined;
    carPlateDigits: number;
    customerName: string | undefined;
    customerPhoneNumber: string | undefined;
    subscriberType: SubscriberType;
    subscriptionType: SubscriptionType;
    benefeciaryName: string | undefined;
    startDate: moment.Moment;
    endDate: moment.Moment;
    startTime: TimeSpan;
    endTime: TimeSpan;
    isExpired: boolean;
    locations: LocationItemDto[] | undefined;
    subscriptionPackage: SubscriptionPackageDto;
    status: string | undefined;
    expiryStatus: SubscriptionExpiryStatus;
}

export class GetCountsOutput implements IGetCountsOutput {
    reservationsCount: number;
    violationsCount: number;

    constructor(data?: IGetCountsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reservationsCount = _data["reservationsCount"];
            this.violationsCount = _data["violationsCount"];
        }
    }

    static fromJS(data: any): GetCountsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCountsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reservationsCount"] = this.reservationsCount;
        data["violationsCount"] = this.violationsCount;
        return data;
    }

    clone(): GetCountsOutput {
        const json = this.toJSON();
        let result = new GetCountsOutput();
        result.init(json);
        return result;
    }
}

export interface IGetCountsOutput {
    reservationsCount: number;
    violationsCount: number;
}

export class GetCreatedViolationsStatisticsDto implements IGetCreatedViolationsStatisticsDto {
    noticedViolationCount: number;
    createdViolationCount: number;
    dismissedViolationCount: number;
    setteledViolationCount: number;
    towedViolationCount: number;
    clampedViolationCount: number;
    pendingTowingViolationCount: number;
    pendingClampingViolationCount: number;
    revokedViolationCount: number;
    canceledViolationCount: number;

    constructor(data?: IGetCreatedViolationsStatisticsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.noticedViolationCount = _data["noticedViolationCount"];
            this.createdViolationCount = _data["createdViolationCount"];
            this.dismissedViolationCount = _data["dismissedViolationCount"];
            this.setteledViolationCount = _data["setteledViolationCount"];
            this.towedViolationCount = _data["towedViolationCount"];
            this.clampedViolationCount = _data["clampedViolationCount"];
            this.pendingTowingViolationCount = _data["pendingTowingViolationCount"];
            this.pendingClampingViolationCount = _data["pendingClampingViolationCount"];
            this.revokedViolationCount = _data["revokedViolationCount"];
            this.canceledViolationCount = _data["canceledViolationCount"];
        }
    }

    static fromJS(data: any): GetCreatedViolationsStatisticsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCreatedViolationsStatisticsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["noticedViolationCount"] = this.noticedViolationCount;
        data["createdViolationCount"] = this.createdViolationCount;
        data["dismissedViolationCount"] = this.dismissedViolationCount;
        data["setteledViolationCount"] = this.setteledViolationCount;
        data["towedViolationCount"] = this.towedViolationCount;
        data["clampedViolationCount"] = this.clampedViolationCount;
        data["pendingTowingViolationCount"] = this.pendingTowingViolationCount;
        data["pendingClampingViolationCount"] = this.pendingClampingViolationCount;
        data["revokedViolationCount"] = this.revokedViolationCount;
        data["canceledViolationCount"] = this.canceledViolationCount;
        return data;
    }

    clone(): GetCreatedViolationsStatisticsDto {
        const json = this.toJSON();
        let result = new GetCreatedViolationsStatisticsDto();
        result.init(json);
        return result;
    }
}

export interface IGetCreatedViolationsStatisticsDto {
    noticedViolationCount: number;
    createdViolationCount: number;
    dismissedViolationCount: number;
    setteledViolationCount: number;
    towedViolationCount: number;
    clampedViolationCount: number;
    pendingTowingViolationCount: number;
    pendingClampingViolationCount: number;
    revokedViolationCount: number;
    canceledViolationCount: number;
}

export class GetCurrentLoginInformationsOutput implements IGetCurrentLoginInformationsOutput {
    application: ApplicationInfoDto;
    user: UserLoginInfoDto;
    tenant: TenantLoginInfoDto;

    constructor(data?: IGetCurrentLoginInformationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.application = _data["application"] ? ApplicationInfoDto.fromJS(_data["application"]) : <any>undefined;
            this.user = _data["user"] ? UserLoginInfoDto.fromJS(_data["user"]) : <any>undefined;
            this.tenant = _data["tenant"] ? TenantLoginInfoDto.fromJS(_data["tenant"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCurrentLoginInformationsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCurrentLoginInformationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetCurrentLoginInformationsOutput {
        const json = this.toJSON();
        let result = new GetCurrentLoginInformationsOutput();
        result.init(json);
        return result;
    }
}

export interface IGetCurrentLoginInformationsOutput {
    application: ApplicationInfoDto;
    user: UserLoginInfoDto;
    tenant: TenantLoginInfoDto;
}

export class GetExternalInvoicesInputDto implements IGetExternalInvoicesInputDto {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    keyword: string | undefined;
    fromCreationDate: moment.Moment | undefined;
    toCreationDate: moment.Moment | undefined;
    fromPaymentReceivedDate: moment.Moment | undefined;
    toPaymentReceivedDate: moment.Moment | undefined;

    constructor(data?: IGetExternalInvoicesInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.sorting = _data["sorting"];
            this.keyword = _data["keyword"];
            this.fromCreationDate = _data["fromCreationDate"] ? moment(_data["fromCreationDate"].toString()) : <any>undefined;
            this.toCreationDate = _data["toCreationDate"] ? moment(_data["toCreationDate"].toString()) : <any>undefined;
            this.fromPaymentReceivedDate = _data["fromPaymentReceivedDate"] ? moment(_data["fromPaymentReceivedDate"].toString()) : <any>undefined;
            this.toPaymentReceivedDate = _data["toPaymentReceivedDate"] ? moment(_data["toPaymentReceivedDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetExternalInvoicesInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetExternalInvoicesInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["sorting"] = this.sorting;
        data["keyword"] = this.keyword;
        data["fromCreationDate"] = this.fromCreationDate ? this.fromCreationDate.toISOString() : <any>undefined;
        data["toCreationDate"] = this.toCreationDate ? this.toCreationDate.toISOString() : <any>undefined;
        data["fromPaymentReceivedDate"] = this.fromPaymentReceivedDate ? this.fromPaymentReceivedDate.toISOString() : <any>undefined;
        data["toPaymentReceivedDate"] = this.toPaymentReceivedDate ? this.toPaymentReceivedDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): GetExternalInvoicesInputDto {
        const json = this.toJSON();
        let result = new GetExternalInvoicesInputDto();
        result.init(json);
        return result;
    }
}

export interface IGetExternalInvoicesInputDto {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    keyword: string | undefined;
    fromCreationDate: moment.Moment | undefined;
    toCreationDate: moment.Moment | undefined;
    fromPaymentReceivedDate: moment.Moment | undefined;
    toPaymentReceivedDate: moment.Moment | undefined;
}

export class GetOnlineTransactionViewDto implements IGetOnlineTransactionViewDto {
    referenceId: string | undefined;
    brand: string | undefined;
    cardType: string | undefined;
    cardLast4Digits: string | undefined;
    cardHolder: string | undefined;
    cardExpiryMonth: number | undefined;
    cardExpiryYear: number | undefined;

    constructor(data?: IGetOnlineTransactionViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.referenceId = _data["referenceId"];
            this.brand = _data["brand"];
            this.cardType = _data["cardType"];
            this.cardLast4Digits = _data["cardLast4Digits"];
            this.cardHolder = _data["cardHolder"];
            this.cardExpiryMonth = _data["cardExpiryMonth"];
            this.cardExpiryYear = _data["cardExpiryYear"];
        }
    }

    static fromJS(data: any): GetOnlineTransactionViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetOnlineTransactionViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["referenceId"] = this.referenceId;
        data["brand"] = this.brand;
        data["cardType"] = this.cardType;
        data["cardLast4Digits"] = this.cardLast4Digits;
        data["cardHolder"] = this.cardHolder;
        data["cardExpiryMonth"] = this.cardExpiryMonth;
        data["cardExpiryYear"] = this.cardExpiryYear;
        return data;
    }

    clone(): GetOnlineTransactionViewDto {
        const json = this.toJSON();
        let result = new GetOnlineTransactionViewDto();
        result.init(json);
        return result;
    }
}

export interface IGetOnlineTransactionViewDto {
    referenceId: string | undefined;
    brand: string | undefined;
    cardType: string | undefined;
    cardLast4Digits: string | undefined;
    cardHolder: string | undefined;
    cardExpiryMonth: number | undefined;
    cardExpiryYear: number | undefined;
}

export class GetReservationDetailsInvoiceInfoOutput implements IGetReservationDetailsInvoiceInfoOutput {
    startTime: moment.Moment;
    endTime: moment.Moment;
    carPlateLetters: string | undefined;
    vehicle: VehicleDto;
    carPlateNumbers: number;
    firstName: string | undefined;
    lastName: string | undefined;
    mobileNumber: string | undefined;
    totalHours: number;
    location: ReservationInvoiceLocationDto;
    slot: SlotDto;
    successfulTransaction: TransactionDto;
    reporting: ReportDetailsResponse;

    constructor(data?: IGetReservationDetailsInvoiceInfoOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
            this.carPlateLetters = _data["carPlateLetters"];
            this.vehicle = _data["vehicle"] ? VehicleDto.fromJS(_data["vehicle"]) : <any>undefined;
            this.carPlateNumbers = _data["carPlateNumbers"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.mobileNumber = _data["mobileNumber"];
            this.totalHours = _data["totalHours"];
            this.location = _data["location"] ? ReservationInvoiceLocationDto.fromJS(_data["location"]) : <any>undefined;
            this.slot = _data["slot"] ? SlotDto.fromJS(_data["slot"]) : <any>undefined;
            this.successfulTransaction = _data["successfulTransaction"] ? TransactionDto.fromJS(_data["successfulTransaction"]) : <any>undefined;
            this.reporting = _data["reporting"] ? ReportDetailsResponse.fromJS(_data["reporting"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetReservationDetailsInvoiceInfoOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetReservationDetailsInvoiceInfoOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["carPlateLetters"] = this.carPlateLetters;
        data["vehicle"] = this.vehicle ? this.vehicle.toJSON() : <any>undefined;
        data["carPlateNumbers"] = this.carPlateNumbers;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["mobileNumber"] = this.mobileNumber;
        data["totalHours"] = this.totalHours;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["slot"] = this.slot ? this.slot.toJSON() : <any>undefined;
        data["successfulTransaction"] = this.successfulTransaction ? this.successfulTransaction.toJSON() : <any>undefined;
        data["reporting"] = this.reporting ? this.reporting.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetReservationDetailsInvoiceInfoOutput {
        const json = this.toJSON();
        let result = new GetReservationDetailsInvoiceInfoOutput();
        result.init(json);
        return result;
    }
}

export interface IGetReservationDetailsInvoiceInfoOutput {
    startTime: moment.Moment;
    endTime: moment.Moment;
    carPlateLetters: string | undefined;
    vehicle: VehicleDto;
    carPlateNumbers: number;
    firstName: string | undefined;
    lastName: string | undefined;
    mobileNumber: string | undefined;
    totalHours: number;
    location: ReservationInvoiceLocationDto;
    slot: SlotDto;
    successfulTransaction: TransactionDto;
    reporting: ReportDetailsResponse;
}

export class GetReservationForOnlineRenewalOutput implements IGetReservationForOnlineRenewalOutput {
    reservationNumber: number;
    customerName: string | undefined;
    customerMobileNumber: string | undefined;
    location: ReservationInvoiceLocationDto;
    slot: SlotListDto;
    startTime: moment.Moment;
    endTime: moment.Moment;
    totalHours: number;
    vatPercentage: number;
    totalPricing: number;
    price: ReservationPriceDto;
    carPlate: CarPlate;
    vehicle: VehicleDto;
    qrCode: QRCodeListDto;
    isReservationExpired: boolean;
    checkoutQRCode: string | undefined;

    constructor(data?: IGetReservationForOnlineRenewalOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reservationNumber = _data["reservationNumber"];
            this.customerName = _data["customerName"];
            this.customerMobileNumber = _data["customerMobileNumber"];
            this.location = _data["location"] ? ReservationInvoiceLocationDto.fromJS(_data["location"]) : <any>undefined;
            this.slot = _data["slot"] ? SlotListDto.fromJS(_data["slot"]) : <any>undefined;
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
            this.totalHours = _data["totalHours"];
            this.vatPercentage = _data["vatPercentage"];
            this.totalPricing = _data["totalPricing"];
            this.price = _data["price"] ? ReservationPriceDto.fromJS(_data["price"]) : <any>undefined;
            this.carPlate = _data["carPlate"] ? CarPlate.fromJS(_data["carPlate"]) : <any>undefined;
            this.vehicle = _data["vehicle"] ? VehicleDto.fromJS(_data["vehicle"]) : <any>undefined;
            this.qrCode = _data["qrCode"] ? QRCodeListDto.fromJS(_data["qrCode"]) : <any>undefined;
            this.isReservationExpired = _data["isReservationExpired"];
            this.checkoutQRCode = _data["checkoutQRCode"];
        }
    }

    static fromJS(data: any): GetReservationForOnlineRenewalOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetReservationForOnlineRenewalOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reservationNumber"] = this.reservationNumber;
        data["customerName"] = this.customerName;
        data["customerMobileNumber"] = this.customerMobileNumber;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["slot"] = this.slot ? this.slot.toJSON() : <any>undefined;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["totalHours"] = this.totalHours;
        data["vatPercentage"] = this.vatPercentage;
        data["totalPricing"] = this.totalPricing;
        data["price"] = this.price ? this.price.toJSON() : <any>undefined;
        data["carPlate"] = this.carPlate ? this.carPlate.toJSON() : <any>undefined;
        data["vehicle"] = this.vehicle ? this.vehicle.toJSON() : <any>undefined;
        data["qrCode"] = this.qrCode ? this.qrCode.toJSON() : <any>undefined;
        data["isReservationExpired"] = this.isReservationExpired;
        data["checkoutQRCode"] = this.checkoutQRCode;
        return data;
    }

    clone(): GetReservationForOnlineRenewalOutput {
        const json = this.toJSON();
        let result = new GetReservationForOnlineRenewalOutput();
        result.init(json);
        return result;
    }
}

export interface IGetReservationForOnlineRenewalOutput {
    reservationNumber: number;
    customerName: string | undefined;
    customerMobileNumber: string | undefined;
    location: ReservationInvoiceLocationDto;
    slot: SlotListDto;
    startTime: moment.Moment;
    endTime: moment.Moment;
    totalHours: number;
    vatPercentage: number;
    totalPricing: number;
    price: ReservationPriceDto;
    carPlate: CarPlate;
    vehicle: VehicleDto;
    qrCode: QRCodeListDto;
    isReservationExpired: boolean;
    checkoutQRCode: string | undefined;
}

export class GetRoleForEditOutput implements IGetRoleForEditOutput {
    role: RoleEditDto;
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;

    constructor(data?: IGetRoleForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"] ? RoleEditDto.fromJS(_data["role"]) : <any>undefined;
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions.push(FlatPermissionDto.fromJS(item));
            }
            if (Array.isArray(_data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data["grantedPermissionNames"])
                    this.grantedPermissionNames.push(item);
            }
        }
    }

    static fromJS(data: any): GetRoleForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRoleForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data;
    }

    clone(): GetRoleForEditOutput {
        const json = this.toJSON();
        let result = new GetRoleForEditOutput();
        result.init(json);
        return result;
    }
}

export interface IGetRoleForEditOutput {
    role: RoleEditDto;
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;
}

export class GetStaffAccountGroupDetailsDto implements IGetStaffAccountGroupDetailsDto {
    groupId: string;
    groupName: string | undefined;
    staffMembers: StaffMemberItemDto[] | undefined;
    assignedLocations: AssignedLocationItemDto[] | undefined;

    constructor(data?: IGetStaffAccountGroupDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupId = _data["groupId"];
            this.groupName = _data["groupName"];
            if (Array.isArray(_data["staffMembers"])) {
                this.staffMembers = [] as any;
                for (let item of _data["staffMembers"])
                    this.staffMembers.push(StaffMemberItemDto.fromJS(item));
            }
            if (Array.isArray(_data["assignedLocations"])) {
                this.assignedLocations = [] as any;
                for (let item of _data["assignedLocations"])
                    this.assignedLocations.push(AssignedLocationItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetStaffAccountGroupDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetStaffAccountGroupDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupId"] = this.groupId;
        data["groupName"] = this.groupName;
        if (Array.isArray(this.staffMembers)) {
            data["staffMembers"] = [];
            for (let item of this.staffMembers)
                data["staffMembers"].push(item.toJSON());
        }
        if (Array.isArray(this.assignedLocations)) {
            data["assignedLocations"] = [];
            for (let item of this.assignedLocations)
                data["assignedLocations"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetStaffAccountGroupDetailsDto {
        const json = this.toJSON();
        let result = new GetStaffAccountGroupDetailsDto();
        result.init(json);
        return result;
    }
}

export interface IGetStaffAccountGroupDetailsDto {
    groupId: string;
    groupName: string | undefined;
    staffMembers: StaffMemberItemDto[] | undefined;
    assignedLocations: AssignedLocationItemDto[] | undefined;
}

export class GetSubscriptionByIdOutput implements IGetSubscriptionByIdOutput {
    id: string;
    subscriberType: SubscriberType;
    subscriptionType: SubscriptionType;
    benefeciaryName: string | undefined;
    startDate: moment.Moment;
    endDate: moment.Moment;
    startTime: string | undefined;
    endTime: string | undefined;
    locations: LocationItemDto[] | undefined;
    vehicles: VehicleDto[] | undefined;
    subscriptionNumber: number;
    isExpired: boolean;
    isActive: boolean;
    transaction: TransactionDto;
    customer: CustomerDto;
    company: SubscriptionCompanyDto;
    subscriptionPackage: SubscriptionPackageDto;
    vatPercentage: number | undefined;
    beneficiaryName: string | undefined;
    expiryStatus: SubscriptionExpiryStatus;
    status: string | undefined;

    constructor(data?: IGetSubscriptionByIdOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.subscriberType = _data["subscriberType"];
            this.subscriptionType = _data["subscriptionType"];
            this.benefeciaryName = _data["benefeciaryName"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.startTime = _data["startTime"];
            this.endTime = _data["endTime"];
            if (Array.isArray(_data["locations"])) {
                this.locations = [] as any;
                for (let item of _data["locations"])
                    this.locations.push(LocationItemDto.fromJS(item));
            }
            if (Array.isArray(_data["vehicles"])) {
                this.vehicles = [] as any;
                for (let item of _data["vehicles"])
                    this.vehicles.push(VehicleDto.fromJS(item));
            }
            this.subscriptionNumber = _data["subscriptionNumber"];
            this.isExpired = _data["isExpired"];
            this.isActive = _data["isActive"];
            this.transaction = _data["transaction"] ? TransactionDto.fromJS(_data["transaction"]) : <any>undefined;
            this.customer = _data["customer"] ? CustomerDto.fromJS(_data["customer"]) : <any>undefined;
            this.company = _data["company"] ? SubscriptionCompanyDto.fromJS(_data["company"]) : <any>undefined;
            this.subscriptionPackage = _data["subscriptionPackage"] ? SubscriptionPackageDto.fromJS(_data["subscriptionPackage"]) : <any>undefined;
            this.vatPercentage = _data["vatPercentage"];
            this.beneficiaryName = _data["beneficiaryName"];
            this.expiryStatus = _data["expiryStatus"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): GetSubscriptionByIdOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSubscriptionByIdOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["subscriberType"] = this.subscriberType;
        data["subscriptionType"] = this.subscriptionType;
        data["benefeciaryName"] = this.benefeciaryName;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["startTime"] = this.startTime;
        data["endTime"] = this.endTime;
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (let item of this.locations)
                data["locations"].push(item.toJSON());
        }
        if (Array.isArray(this.vehicles)) {
            data["vehicles"] = [];
            for (let item of this.vehicles)
                data["vehicles"].push(item.toJSON());
        }
        data["subscriptionNumber"] = this.subscriptionNumber;
        data["isExpired"] = this.isExpired;
        data["isActive"] = this.isActive;
        data["transaction"] = this.transaction ? this.transaction.toJSON() : <any>undefined;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["subscriptionPackage"] = this.subscriptionPackage ? this.subscriptionPackage.toJSON() : <any>undefined;
        data["vatPercentage"] = this.vatPercentage;
        data["beneficiaryName"] = this.beneficiaryName;
        data["expiryStatus"] = this.expiryStatus;
        data["status"] = this.status;
        return data;
    }

    clone(): GetSubscriptionByIdOutput {
        const json = this.toJSON();
        let result = new GetSubscriptionByIdOutput();
        result.init(json);
        return result;
    }
}

export interface IGetSubscriptionByIdOutput {
    id: string;
    subscriberType: SubscriberType;
    subscriptionType: SubscriptionType;
    benefeciaryName: string | undefined;
    startDate: moment.Moment;
    endDate: moment.Moment;
    startTime: string | undefined;
    endTime: string | undefined;
    locations: LocationItemDto[] | undefined;
    vehicles: VehicleDto[] | undefined;
    subscriptionNumber: number;
    isExpired: boolean;
    isActive: boolean;
    transaction: TransactionDto;
    customer: CustomerDto;
    company: SubscriptionCompanyDto;
    subscriptionPackage: SubscriptionPackageDto;
    vatPercentage: number | undefined;
    beneficiaryName: string | undefined;
    expiryStatus: SubscriptionExpiryStatus;
    status: string | undefined;
}

export class GetSubscriptionInvoiceInfoOutput implements IGetSubscriptionInvoiceInfoOutput {
    id: string;
    subscriberType: SubscriberType;
    subscriptionType: SubscriptionType;
    benefeciaryName: string | undefined;
    startDate: moment.Moment;
    endDate: moment.Moment;
    startTime: TimeSpan;
    endTime: TimeSpan;
    locations: LocationItemDto[] | undefined;
    vehicles: VehicleDto[] | undefined;
    subscriptionNumber: number;
    isExpired: boolean;
    isActive: boolean;
    transactionInvoice: SubscriptionTransactionInvoiceDto;
    company: SubscriptionCompanyDto;
    customer: CustomerDto;
    expiryStatus: SubscriptionExpiryStatus;

    constructor(data?: IGetSubscriptionInvoiceInfoOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.subscriberType = _data["subscriberType"];
            this.subscriptionType = _data["subscriptionType"];
            this.benefeciaryName = _data["benefeciaryName"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.startTime = _data["startTime"] ? TimeSpan.fromJS(_data["startTime"]) : <any>undefined;
            this.endTime = _data["endTime"] ? TimeSpan.fromJS(_data["endTime"]) : <any>undefined;
            if (Array.isArray(_data["locations"])) {
                this.locations = [] as any;
                for (let item of _data["locations"])
                    this.locations.push(LocationItemDto.fromJS(item));
            }
            if (Array.isArray(_data["vehicles"])) {
                this.vehicles = [] as any;
                for (let item of _data["vehicles"])
                    this.vehicles.push(VehicleDto.fromJS(item));
            }
            this.subscriptionNumber = _data["subscriptionNumber"];
            this.isExpired = _data["isExpired"];
            this.isActive = _data["isActive"];
            this.transactionInvoice = _data["transactionInvoice"] ? SubscriptionTransactionInvoiceDto.fromJS(_data["transactionInvoice"]) : <any>undefined;
            this.company = _data["company"] ? SubscriptionCompanyDto.fromJS(_data["company"]) : <any>undefined;
            this.customer = _data["customer"] ? CustomerDto.fromJS(_data["customer"]) : <any>undefined;
            this.expiryStatus = _data["expiryStatus"];
        }
    }

    static fromJS(data: any): GetSubscriptionInvoiceInfoOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSubscriptionInvoiceInfoOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["subscriberType"] = this.subscriberType;
        data["subscriptionType"] = this.subscriptionType;
        data["benefeciaryName"] = this.benefeciaryName;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["startTime"] = this.startTime ? this.startTime.toJSON() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toJSON() : <any>undefined;
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (let item of this.locations)
                data["locations"].push(item.toJSON());
        }
        if (Array.isArray(this.vehicles)) {
            data["vehicles"] = [];
            for (let item of this.vehicles)
                data["vehicles"].push(item.toJSON());
        }
        data["subscriptionNumber"] = this.subscriptionNumber;
        data["isExpired"] = this.isExpired;
        data["isActive"] = this.isActive;
        data["transactionInvoice"] = this.transactionInvoice ? this.transactionInvoice.toJSON() : <any>undefined;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["expiryStatus"] = this.expiryStatus;
        return data;
    }

    clone(): GetSubscriptionInvoiceInfoOutput {
        const json = this.toJSON();
        let result = new GetSubscriptionInvoiceInfoOutput();
        result.init(json);
        return result;
    }
}

export interface IGetSubscriptionInvoiceInfoOutput {
    id: string;
    subscriberType: SubscriberType;
    subscriptionType: SubscriptionType;
    benefeciaryName: string | undefined;
    startDate: moment.Moment;
    endDate: moment.Moment;
    startTime: TimeSpan;
    endTime: TimeSpan;
    locations: LocationItemDto[] | undefined;
    vehicles: VehicleDto[] | undefined;
    subscriptionNumber: number;
    isExpired: boolean;
    isActive: boolean;
    transactionInvoice: SubscriptionTransactionInvoiceDto;
    company: SubscriptionCompanyDto;
    customer: CustomerDto;
    expiryStatus: SubscriptionExpiryStatus;
}

export class GetVehicleCountsOutput implements IGetVehicleCountsOutput {
    activeReservationsCount: number;
    notActiveReservationsCount: number;
    settledViolationsCount: number;
    notSettledViolationsCount: number;
    subscriptionsCount: number;
    metricsActiveCount: number;
    metricsNotActiveCount: number;

    constructor(data?: IGetVehicleCountsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activeReservationsCount = _data["activeReservationsCount"];
            this.notActiveReservationsCount = _data["notActiveReservationsCount"];
            this.settledViolationsCount = _data["settledViolationsCount"];
            this.notSettledViolationsCount = _data["notSettledViolationsCount"];
            this.subscriptionsCount = _data["subscriptionsCount"];
            this.metricsActiveCount = _data["metricsActiveCount"];
            this.metricsNotActiveCount = _data["metricsNotActiveCount"];
        }
    }

    static fromJS(data: any): GetVehicleCountsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetVehicleCountsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activeReservationsCount"] = this.activeReservationsCount;
        data["notActiveReservationsCount"] = this.notActiveReservationsCount;
        data["settledViolationsCount"] = this.settledViolationsCount;
        data["notSettledViolationsCount"] = this.notSettledViolationsCount;
        data["subscriptionsCount"] = this.subscriptionsCount;
        data["metricsActiveCount"] = this.metricsActiveCount;
        data["metricsNotActiveCount"] = this.metricsNotActiveCount;
        return data;
    }

    clone(): GetVehicleCountsOutput {
        const json = this.toJSON();
        let result = new GetVehicleCountsOutput();
        result.init(json);
        return result;
    }
}

export interface IGetVehicleCountsOutput {
    activeReservationsCount: number;
    notActiveReservationsCount: number;
    settledViolationsCount: number;
    notSettledViolationsCount: number;
    subscriptionsCount: number;
    metricsActiveCount: number;
    metricsNotActiveCount: number;
}

export class GetViolationCustomerSupportLogHistoryListDto implements IGetViolationCustomerSupportLogHistoryListDto {
    id: number;
    violationId: string;
    status: CustomerSupportStatusDto;
    updateBy: string | undefined;
    updateTime: moment.Moment;
    notes: string | undefined;

    constructor(data?: IGetViolationCustomerSupportLogHistoryListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.violationId = _data["violationId"];
            this.status = _data["status"] ? CustomerSupportStatusDto.fromJS(_data["status"]) : <any>undefined;
            this.updateBy = _data["updateBy"];
            this.updateTime = _data["updateTime"] ? moment(_data["updateTime"].toString()) : <any>undefined;
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): GetViolationCustomerSupportLogHistoryListDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetViolationCustomerSupportLogHistoryListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["violationId"] = this.violationId;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["updateBy"] = this.updateBy;
        data["updateTime"] = this.updateTime ? this.updateTime.toISOString() : <any>undefined;
        data["notes"] = this.notes;
        return data;
    }

    clone(): GetViolationCustomerSupportLogHistoryListDto {
        const json = this.toJSON();
        let result = new GetViolationCustomerSupportLogHistoryListDto();
        result.init(json);
        return result;
    }
}

export interface IGetViolationCustomerSupportLogHistoryListDto {
    id: number;
    violationId: string;
    status: CustomerSupportStatusDto;
    updateBy: string | undefined;
    updateTime: moment.Moment;
    notes: string | undefined;
}

export class GetViolationCustomerSupportLogHistoryListDtoPagedResultDto implements IGetViolationCustomerSupportLogHistoryListDtoPagedResultDto {
    items: GetViolationCustomerSupportLogHistoryListDto[] | undefined;
    totalCount: number;

    constructor(data?: IGetViolationCustomerSupportLogHistoryListDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(GetViolationCustomerSupportLogHistoryListDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): GetViolationCustomerSupportLogHistoryListDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetViolationCustomerSupportLogHistoryListDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): GetViolationCustomerSupportLogHistoryListDtoPagedResultDto {
        const json = this.toJSON();
        let result = new GetViolationCustomerSupportLogHistoryListDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IGetViolationCustomerSupportLogHistoryListDtoPagedResultDto {
    items: GetViolationCustomerSupportLogHistoryListDto[] | undefined;
    totalCount: number;
}

export class GetViolationForOnlineSettlementOutput implements IGetViolationForOnlineSettlementOutput {
    id: string;
    vehicle: VehicleDto;
    customerName: string | undefined;
    customerMobileNumber: string | undefined;
    location: LocationDto;
    slot: SlotDto;
    violationItems: ViolationItemDto[] | undefined;
    status: string | undefined;
    creationTime: moment.Moment;
    violationNumber: number;
    vat: number;
    total: number;
    subTotal: number;
    allowedForOnlineSettlement: boolean;
    reservedTimeDetails: ReservedTimeDetailsDto;
    towingImpoundDetails: TowingImpoundDetailsDto;
    country: CountryDto;

    constructor(data?: IGetViolationForOnlineSettlementOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.vehicle = _data["vehicle"] ? VehicleDto.fromJS(_data["vehicle"]) : <any>undefined;
            this.customerName = _data["customerName"];
            this.customerMobileNumber = _data["customerMobileNumber"];
            this.location = _data["location"] ? LocationDto.fromJS(_data["location"]) : <any>undefined;
            this.slot = _data["slot"] ? SlotDto.fromJS(_data["slot"]) : <any>undefined;
            if (Array.isArray(_data["violationItems"])) {
                this.violationItems = [] as any;
                for (let item of _data["violationItems"])
                    this.violationItems.push(ViolationItemDto.fromJS(item));
            }
            this.status = _data["status"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.violationNumber = _data["violationNumber"];
            this.vat = _data["vat"];
            this.total = _data["total"];
            this.subTotal = _data["subTotal"];
            this.allowedForOnlineSettlement = _data["allowedForOnlineSettlement"];
            this.reservedTimeDetails = _data["reservedTimeDetails"] ? ReservedTimeDetailsDto.fromJS(_data["reservedTimeDetails"]) : <any>undefined;
            this.towingImpoundDetails = _data["towingImpoundDetails"] ? TowingImpoundDetailsDto.fromJS(_data["towingImpoundDetails"]) : <any>undefined;
            this.country = _data["country"] ? CountryDto.fromJS(_data["country"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetViolationForOnlineSettlementOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetViolationForOnlineSettlementOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["vehicle"] = this.vehicle ? this.vehicle.toJSON() : <any>undefined;
        data["customerName"] = this.customerName;
        data["customerMobileNumber"] = this.customerMobileNumber;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["slot"] = this.slot ? this.slot.toJSON() : <any>undefined;
        if (Array.isArray(this.violationItems)) {
            data["violationItems"] = [];
            for (let item of this.violationItems)
                data["violationItems"].push(item.toJSON());
        }
        data["status"] = this.status;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["violationNumber"] = this.violationNumber;
        data["vat"] = this.vat;
        data["total"] = this.total;
        data["subTotal"] = this.subTotal;
        data["allowedForOnlineSettlement"] = this.allowedForOnlineSettlement;
        data["reservedTimeDetails"] = this.reservedTimeDetails ? this.reservedTimeDetails.toJSON() : <any>undefined;
        data["towingImpoundDetails"] = this.towingImpoundDetails ? this.towingImpoundDetails.toJSON() : <any>undefined;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetViolationForOnlineSettlementOutput {
        const json = this.toJSON();
        let result = new GetViolationForOnlineSettlementOutput();
        result.init(json);
        return result;
    }
}

export interface IGetViolationForOnlineSettlementOutput {
    id: string;
    vehicle: VehicleDto;
    customerName: string | undefined;
    customerMobileNumber: string | undefined;
    location: LocationDto;
    slot: SlotDto;
    violationItems: ViolationItemDto[] | undefined;
    status: string | undefined;
    creationTime: moment.Moment;
    violationNumber: number;
    vat: number;
    total: number;
    subTotal: number;
    allowedForOnlineSettlement: boolean;
    reservedTimeDetails: ReservedTimeDetailsDto;
    towingImpoundDetails: TowingImpoundDetailsDto;
    country: CountryDto;
}

export class GetViolationOutputDto implements IGetViolationOutputDto {
    violation: ViolationDto;
    transaction: TransactionDto;
    avaliableActions: ViolationActionDto[] | undefined;

    constructor(data?: IGetViolationOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.violation = _data["violation"] ? ViolationDto.fromJS(_data["violation"]) : <any>undefined;
            this.transaction = _data["transaction"] ? TransactionDto.fromJS(_data["transaction"]) : <any>undefined;
            if (Array.isArray(_data["avaliableActions"])) {
                this.avaliableActions = [] as any;
                for (let item of _data["avaliableActions"])
                    this.avaliableActions.push(ViolationActionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetViolationOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetViolationOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["violation"] = this.violation ? this.violation.toJSON() : <any>undefined;
        data["transaction"] = this.transaction ? this.transaction.toJSON() : <any>undefined;
        if (Array.isArray(this.avaliableActions)) {
            data["avaliableActions"] = [];
            for (let item of this.avaliableActions)
                data["avaliableActions"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetViolationOutputDto {
        const json = this.toJSON();
        let result = new GetViolationOutputDto();
        result.init(json);
        return result;
    }
}

export interface IGetViolationOutputDto {
    violation: ViolationDto;
    transaction: TransactionDto;
    avaliableActions: ViolationActionDto[] | undefined;
}

export class GetViolationOutputDtoPagedResultDto implements IGetViolationOutputDtoPagedResultDto {
    items: GetViolationOutputDto[] | undefined;
    totalCount: number;

    constructor(data?: IGetViolationOutputDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(GetViolationOutputDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): GetViolationOutputDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetViolationOutputDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): GetViolationOutputDtoPagedResultDto {
        const json = this.toJSON();
        let result = new GetViolationOutputDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IGetViolationOutputDtoPagedResultDto {
    items: GetViolationOutputDto[] | undefined;
    totalCount: number;
}

export class GetViolationTransactionsOutputDto implements IGetViolationTransactionsOutputDto {
    transactions: TransactionDto[] | undefined;

    constructor(data?: IGetViolationTransactionsOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["transactions"])) {
                this.transactions = [] as any;
                for (let item of _data["transactions"])
                    this.transactions.push(TransactionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetViolationTransactionsOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetViolationTransactionsOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.transactions)) {
            data["transactions"] = [];
            for (let item of this.transactions)
                data["transactions"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetViolationTransactionsOutputDto {
        const json = this.toJSON();
        let result = new GetViolationTransactionsOutputDto();
        result.init(json);
        return result;
    }
}

export interface IGetViolationTransactionsOutputDto {
    transactions: TransactionDto[] | undefined;
}

export class GetViolationViewDto implements IGetViolationViewDto {
    violation: ViolationViewDto;
    transaction: TransactionDto;
    avaliableActions: ViolationActionDto[] | undefined;
    grantedPermissions: string[] | undefined;
    actionPermissionsBefore: ActionPermission[] | undefined;
    actionPermissionsAfter: ActionPermission[] | undefined;

    constructor(data?: IGetViolationViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.violation = _data["violation"] ? ViolationViewDto.fromJS(_data["violation"]) : <any>undefined;
            this.transaction = _data["transaction"] ? TransactionDto.fromJS(_data["transaction"]) : <any>undefined;
            if (Array.isArray(_data["avaliableActions"])) {
                this.avaliableActions = [] as any;
                for (let item of _data["avaliableActions"])
                    this.avaliableActions.push(ViolationActionDto.fromJS(item));
            }
            if (Array.isArray(_data["grantedPermissions"])) {
                this.grantedPermissions = [] as any;
                for (let item of _data["grantedPermissions"])
                    this.grantedPermissions.push(item);
            }
            if (Array.isArray(_data["actionPermissionsBefore"])) {
                this.actionPermissionsBefore = [] as any;
                for (let item of _data["actionPermissionsBefore"])
                    this.actionPermissionsBefore.push(ActionPermission.fromJS(item));
            }
            if (Array.isArray(_data["actionPermissionsAfter"])) {
                this.actionPermissionsAfter = [] as any;
                for (let item of _data["actionPermissionsAfter"])
                    this.actionPermissionsAfter.push(ActionPermission.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetViolationViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetViolationViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["violation"] = this.violation ? this.violation.toJSON() : <any>undefined;
        data["transaction"] = this.transaction ? this.transaction.toJSON() : <any>undefined;
        if (Array.isArray(this.avaliableActions)) {
            data["avaliableActions"] = [];
            for (let item of this.avaliableActions)
                data["avaliableActions"].push(item.toJSON());
        }
        if (Array.isArray(this.grantedPermissions)) {
            data["grantedPermissions"] = [];
            for (let item of this.grantedPermissions)
                data["grantedPermissions"].push(item);
        }
        if (Array.isArray(this.actionPermissionsBefore)) {
            data["actionPermissionsBefore"] = [];
            for (let item of this.actionPermissionsBefore)
                data["actionPermissionsBefore"].push(item.toJSON());
        }
        if (Array.isArray(this.actionPermissionsAfter)) {
            data["actionPermissionsAfter"] = [];
            for (let item of this.actionPermissionsAfter)
                data["actionPermissionsAfter"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetViolationViewDto {
        const json = this.toJSON();
        let result = new GetViolationViewDto();
        result.init(json);
        return result;
    }
}

export interface IGetViolationViewDto {
    violation: ViolationViewDto;
    transaction: TransactionDto;
    avaliableActions: ViolationActionDto[] | undefined;
    grantedPermissions: string[] | undefined;
    actionPermissionsBefore: ActionPermission[] | undefined;
    actionPermissionsAfter: ActionPermission[] | undefined;
}

export class GetViolationsActionsStatisticsDto implements IGetViolationsActionsStatisticsDto {
    noticedViolationCount: number;
    createdViolationCount: number;
    dismissedViolationCount: number;
    settleedCashViolationCount: number;
    settleedPOSViolationCount: number;
    addedItemsViolationCount: number;
    canceledNoticeItemsViolationCount: number;
    towedViolationCount: number;
    clampedViolationCount: number;
    printedViolationCount: number;
    requestedTowingViolationCount: number;
    requestedClampingViolationCount: number;
    revokedViolationCount: number;
    canceledViolationItemsCount: number;
    canceledViolationCount: number;

    constructor(data?: IGetViolationsActionsStatisticsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.noticedViolationCount = _data["noticedViolationCount"];
            this.createdViolationCount = _data["createdViolationCount"];
            this.dismissedViolationCount = _data["dismissedViolationCount"];
            this.settleedCashViolationCount = _data["settleedCashViolationCount"];
            this.settleedPOSViolationCount = _data["settleedPOSViolationCount"];
            this.addedItemsViolationCount = _data["addedItemsViolationCount"];
            this.canceledNoticeItemsViolationCount = _data["canceledNoticeItemsViolationCount"];
            this.towedViolationCount = _data["towedViolationCount"];
            this.clampedViolationCount = _data["clampedViolationCount"];
            this.printedViolationCount = _data["printedViolationCount"];
            this.requestedTowingViolationCount = _data["requestedTowingViolationCount"];
            this.requestedClampingViolationCount = _data["requestedClampingViolationCount"];
            this.revokedViolationCount = _data["revokedViolationCount"];
            this.canceledViolationItemsCount = _data["canceledViolationItemsCount"];
            this.canceledViolationCount = _data["canceledViolationCount"];
        }
    }

    static fromJS(data: any): GetViolationsActionsStatisticsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetViolationsActionsStatisticsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["noticedViolationCount"] = this.noticedViolationCount;
        data["createdViolationCount"] = this.createdViolationCount;
        data["dismissedViolationCount"] = this.dismissedViolationCount;
        data["settleedCashViolationCount"] = this.settleedCashViolationCount;
        data["settleedPOSViolationCount"] = this.settleedPOSViolationCount;
        data["addedItemsViolationCount"] = this.addedItemsViolationCount;
        data["canceledNoticeItemsViolationCount"] = this.canceledNoticeItemsViolationCount;
        data["towedViolationCount"] = this.towedViolationCount;
        data["clampedViolationCount"] = this.clampedViolationCount;
        data["printedViolationCount"] = this.printedViolationCount;
        data["requestedTowingViolationCount"] = this.requestedTowingViolationCount;
        data["requestedClampingViolationCount"] = this.requestedClampingViolationCount;
        data["revokedViolationCount"] = this.revokedViolationCount;
        data["canceledViolationItemsCount"] = this.canceledViolationItemsCount;
        data["canceledViolationCount"] = this.canceledViolationCount;
        return data;
    }

    clone(): GetViolationsActionsStatisticsDto {
        const json = this.toJSON();
        let result = new GetViolationsActionsStatisticsDto();
        result.init(json);
        return result;
    }
}

export interface IGetViolationsActionsStatisticsDto {
    noticedViolationCount: number;
    createdViolationCount: number;
    dismissedViolationCount: number;
    settleedCashViolationCount: number;
    settleedPOSViolationCount: number;
    addedItemsViolationCount: number;
    canceledNoticeItemsViolationCount: number;
    towedViolationCount: number;
    clampedViolationCount: number;
    printedViolationCount: number;
    requestedTowingViolationCount: number;
    requestedClampingViolationCount: number;
    revokedViolationCount: number;
    canceledViolationItemsCount: number;
    canceledViolationCount: number;
}

export class GroupShiftDetailsDto implements IGroupShiftDetailsDto {
    groupId: string;
    staffGroupShiftNumber: number;
    groupName: string | undefined;
    startTime: moment.Moment;
    endTime: moment.Moment | undefined;
    duration: string | undefined;
    isActive: boolean;
    startStaffFirstName: string | undefined;
    startStaffLastName: string | undefined;
    startStaffAccountId: number;
    endStaffFirstName: string | undefined;
    endStaffLastName: string | undefined;
    endStaffAccountId: number | undefined;
    staffGroupShiftId: string;
    totalTransactions: number;
    totalViolations: number;
    totalReservations: number;
    totalSubscriptions: number;
    totalManualIncomes: number;
    totalInOutReservations: number;
    totalLostTickets: number;
    totalCashInOutReservationsCount: number;
    totalCashInOutReservationsAmount: number;
    totalPOSInOutReservationsCount: number;
    totalPOSInOutReservationsAmount: number;
    totalCashLostTicketsCount: number;
    totalCashLostTicketsAmount: number;
    totalPOSLostTicketsCount: number;
    totalPOSLostTicketsAmount: number;
    totalAmountGroupShift: number;
    totalCashAmount: number;
    totalCashCount: number;
    totalPOSAmount: number;
    totalPOSCount: number;
    totalStaffAccounts: number;
    totalShifts: number;
    totalActiveShifts: number;

    constructor(data?: IGroupShiftDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupId = _data["groupId"];
            this.staffGroupShiftNumber = _data["staffGroupShiftNumber"];
            this.groupName = _data["groupName"];
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
            this.duration = _data["duration"];
            this.isActive = _data["isActive"];
            this.startStaffFirstName = _data["startStaffFirstName"];
            this.startStaffLastName = _data["startStaffLastName"];
            this.startStaffAccountId = _data["startStaffAccountId"];
            this.endStaffFirstName = _data["endStaffFirstName"];
            this.endStaffLastName = _data["endStaffLastName"];
            this.endStaffAccountId = _data["endStaffAccountId"];
            this.staffGroupShiftId = _data["staffGroupShiftId"];
            this.totalTransactions = _data["totalTransactions"];
            this.totalViolations = _data["totalViolations"];
            this.totalReservations = _data["totalReservations"];
            this.totalSubscriptions = _data["totalSubscriptions"];
            this.totalManualIncomes = _data["totalManualIncomes"];
            this.totalInOutReservations = _data["totalInOutReservations"];
            this.totalLostTickets = _data["totalLostTickets"];
            this.totalCashInOutReservationsCount = _data["totalCashInOutReservationsCount"];
            this.totalCashInOutReservationsAmount = _data["totalCashInOutReservationsAmount"];
            this.totalPOSInOutReservationsCount = _data["totalPOSInOutReservationsCount"];
            this.totalPOSInOutReservationsAmount = _data["totalPOSInOutReservationsAmount"];
            this.totalCashLostTicketsCount = _data["totalCashLostTicketsCount"];
            this.totalCashLostTicketsAmount = _data["totalCashLostTicketsAmount"];
            this.totalPOSLostTicketsCount = _data["totalPOSLostTicketsCount"];
            this.totalPOSLostTicketsAmount = _data["totalPOSLostTicketsAmount"];
            this.totalAmountGroupShift = _data["totalAmountGroupShift"];
            this.totalCashAmount = _data["totalCashAmount"];
            this.totalCashCount = _data["totalCashCount"];
            this.totalPOSAmount = _data["totalPOSAmount"];
            this.totalPOSCount = _data["totalPOSCount"];
            this.totalStaffAccounts = _data["totalStaffAccounts"];
            this.totalShifts = _data["totalShifts"];
            this.totalActiveShifts = _data["totalActiveShifts"];
        }
    }

    static fromJS(data: any): GroupShiftDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GroupShiftDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupId"] = this.groupId;
        data["staffGroupShiftNumber"] = this.staffGroupShiftNumber;
        data["groupName"] = this.groupName;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["duration"] = this.duration;
        data["isActive"] = this.isActive;
        data["startStaffFirstName"] = this.startStaffFirstName;
        data["startStaffLastName"] = this.startStaffLastName;
        data["startStaffAccountId"] = this.startStaffAccountId;
        data["endStaffFirstName"] = this.endStaffFirstName;
        data["endStaffLastName"] = this.endStaffLastName;
        data["endStaffAccountId"] = this.endStaffAccountId;
        data["staffGroupShiftId"] = this.staffGroupShiftId;
        data["totalTransactions"] = this.totalTransactions;
        data["totalViolations"] = this.totalViolations;
        data["totalReservations"] = this.totalReservations;
        data["totalSubscriptions"] = this.totalSubscriptions;
        data["totalManualIncomes"] = this.totalManualIncomes;
        data["totalInOutReservations"] = this.totalInOutReservations;
        data["totalLostTickets"] = this.totalLostTickets;
        data["totalCashInOutReservationsCount"] = this.totalCashInOutReservationsCount;
        data["totalCashInOutReservationsAmount"] = this.totalCashInOutReservationsAmount;
        data["totalPOSInOutReservationsCount"] = this.totalPOSInOutReservationsCount;
        data["totalPOSInOutReservationsAmount"] = this.totalPOSInOutReservationsAmount;
        data["totalCashLostTicketsCount"] = this.totalCashLostTicketsCount;
        data["totalCashLostTicketsAmount"] = this.totalCashLostTicketsAmount;
        data["totalPOSLostTicketsCount"] = this.totalPOSLostTicketsCount;
        data["totalPOSLostTicketsAmount"] = this.totalPOSLostTicketsAmount;
        data["totalAmountGroupShift"] = this.totalAmountGroupShift;
        data["totalCashAmount"] = this.totalCashAmount;
        data["totalCashCount"] = this.totalCashCount;
        data["totalPOSAmount"] = this.totalPOSAmount;
        data["totalPOSCount"] = this.totalPOSCount;
        data["totalStaffAccounts"] = this.totalStaffAccounts;
        data["totalShifts"] = this.totalShifts;
        data["totalActiveShifts"] = this.totalActiveShifts;
        return data;
    }

    clone(): GroupShiftDetailsDto {
        const json = this.toJSON();
        let result = new GroupShiftDetailsDto();
        result.init(json);
        return result;
    }
}

export interface IGroupShiftDetailsDto {
    groupId: string;
    staffGroupShiftNumber: number;
    groupName: string | undefined;
    startTime: moment.Moment;
    endTime: moment.Moment | undefined;
    duration: string | undefined;
    isActive: boolean;
    startStaffFirstName: string | undefined;
    startStaffLastName: string | undefined;
    startStaffAccountId: number;
    endStaffFirstName: string | undefined;
    endStaffLastName: string | undefined;
    endStaffAccountId: number | undefined;
    staffGroupShiftId: string;
    totalTransactions: number;
    totalViolations: number;
    totalReservations: number;
    totalSubscriptions: number;
    totalManualIncomes: number;
    totalInOutReservations: number;
    totalLostTickets: number;
    totalCashInOutReservationsCount: number;
    totalCashInOutReservationsAmount: number;
    totalPOSInOutReservationsCount: number;
    totalPOSInOutReservationsAmount: number;
    totalCashLostTicketsCount: number;
    totalCashLostTicketsAmount: number;
    totalPOSLostTicketsCount: number;
    totalPOSLostTicketsAmount: number;
    totalAmountGroupShift: number;
    totalCashAmount: number;
    totalCashCount: number;
    totalPOSAmount: number;
    totalPOSCount: number;
    totalStaffAccounts: number;
    totalShifts: number;
    totalActiveShifts: number;
}

export class GroupShiftDetailsDtoPagedResultDto implements IGroupShiftDetailsDtoPagedResultDto {
    items: GroupShiftDetailsDto[] | undefined;
    totalCount: number;

    constructor(data?: IGroupShiftDetailsDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(GroupShiftDetailsDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): GroupShiftDetailsDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new GroupShiftDetailsDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): GroupShiftDetailsDtoPagedResultDto {
        const json = this.toJSON();
        let result = new GroupShiftDetailsDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IGroupShiftDetailsDtoPagedResultDto {
    items: GroupShiftDetailsDto[] | undefined;
    totalCount: number;
}

export class GroupShiftSummaryDto implements IGroupShiftSummaryDto {
    id: string;
    groupName: string | undefined;
    staffGroupShiftNumber: number;
    startTime: moment.Moment;
    endTime: moment.Moment | undefined;
    duration: string | undefined;
    isActive: boolean;
    startStaffFirstName: string | undefined;
    startStaffLastName: string | undefined;
    startStaffAccountId: number;
    endStaffFirstName: string | undefined;
    endStaffLastName: string | undefined;
    endStaffAccountId: number | undefined;
    totalTransactions: number;
    totalViolations: number;
    totalReservations: number;
    totalSubscriptions: number;
    totalManualIncomes: number;
    totalInOutReservations: number;
    totalLostTickets: number;
    totalAmountGroupShift: number;
    totalCashAmount: number;
    totalCashCount: number;
    totalPOSAmount: number;
    totalPOSCount: number;
    totalShifts: number;
    totalActiveShifts: number;

    constructor(data?: IGroupShiftSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.groupName = _data["groupName"];
            this.staffGroupShiftNumber = _data["staffGroupShiftNumber"];
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
            this.duration = _data["duration"];
            this.isActive = _data["isActive"];
            this.startStaffFirstName = _data["startStaffFirstName"];
            this.startStaffLastName = _data["startStaffLastName"];
            this.startStaffAccountId = _data["startStaffAccountId"];
            this.endStaffFirstName = _data["endStaffFirstName"];
            this.endStaffLastName = _data["endStaffLastName"];
            this.endStaffAccountId = _data["endStaffAccountId"];
            this.totalTransactions = _data["totalTransactions"];
            this.totalViolations = _data["totalViolations"];
            this.totalReservations = _data["totalReservations"];
            this.totalSubscriptions = _data["totalSubscriptions"];
            this.totalManualIncomes = _data["totalManualIncomes"];
            this.totalInOutReservations = _data["totalInOutReservations"];
            this.totalLostTickets = _data["totalLostTickets"];
            this.totalAmountGroupShift = _data["totalAmountGroupShift"];
            this.totalCashAmount = _data["totalCashAmount"];
            this.totalCashCount = _data["totalCashCount"];
            this.totalPOSAmount = _data["totalPOSAmount"];
            this.totalPOSCount = _data["totalPOSCount"];
            this.totalShifts = _data["totalShifts"];
            this.totalActiveShifts = _data["totalActiveShifts"];
        }
    }

    static fromJS(data: any): GroupShiftSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new GroupShiftSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["groupName"] = this.groupName;
        data["staffGroupShiftNumber"] = this.staffGroupShiftNumber;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["duration"] = this.duration;
        data["isActive"] = this.isActive;
        data["startStaffFirstName"] = this.startStaffFirstName;
        data["startStaffLastName"] = this.startStaffLastName;
        data["startStaffAccountId"] = this.startStaffAccountId;
        data["endStaffFirstName"] = this.endStaffFirstName;
        data["endStaffLastName"] = this.endStaffLastName;
        data["endStaffAccountId"] = this.endStaffAccountId;
        data["totalTransactions"] = this.totalTransactions;
        data["totalViolations"] = this.totalViolations;
        data["totalReservations"] = this.totalReservations;
        data["totalSubscriptions"] = this.totalSubscriptions;
        data["totalManualIncomes"] = this.totalManualIncomes;
        data["totalInOutReservations"] = this.totalInOutReservations;
        data["totalLostTickets"] = this.totalLostTickets;
        data["totalAmountGroupShift"] = this.totalAmountGroupShift;
        data["totalCashAmount"] = this.totalCashAmount;
        data["totalCashCount"] = this.totalCashCount;
        data["totalPOSAmount"] = this.totalPOSAmount;
        data["totalPOSCount"] = this.totalPOSCount;
        data["totalShifts"] = this.totalShifts;
        data["totalActiveShifts"] = this.totalActiveShifts;
        return data;
    }

    clone(): GroupShiftSummaryDto {
        const json = this.toJSON();
        let result = new GroupShiftSummaryDto();
        result.init(json);
        return result;
    }
}

export interface IGroupShiftSummaryDto {
    id: string;
    groupName: string | undefined;
    staffGroupShiftNumber: number;
    startTime: moment.Moment;
    endTime: moment.Moment | undefined;
    duration: string | undefined;
    isActive: boolean;
    startStaffFirstName: string | undefined;
    startStaffLastName: string | undefined;
    startStaffAccountId: number;
    endStaffFirstName: string | undefined;
    endStaffLastName: string | undefined;
    endStaffAccountId: number | undefined;
    totalTransactions: number;
    totalViolations: number;
    totalReservations: number;
    totalSubscriptions: number;
    totalManualIncomes: number;
    totalInOutReservations: number;
    totalLostTickets: number;
    totalAmountGroupShift: number;
    totalCashAmount: number;
    totalCashCount: number;
    totalPOSAmount: number;
    totalPOSCount: number;
    totalShifts: number;
    totalActiveShifts: number;
}

export class GuidEntityDto implements IGuidEntityDto {
    id: string;

    constructor(data?: IGuidEntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GuidEntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new GuidEntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }

    clone(): GuidEntityDto {
        const json = this.toJSON();
        let result = new GuidEntityDto();
        result.init(json);
        return result;
    }
}

export interface IGuidEntityDto {
    id: string;
}

export class IEventData implements IIEventData {
    eventTime: moment.Moment;
    eventSource: any | undefined;

    constructor(data?: IIEventData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eventTime = _data["eventTime"] ? moment(_data["eventTime"].toString()) : <any>undefined;
            this.eventSource = _data["eventSource"];
        }
    }

    static fromJS(data: any): IEventData {
        data = typeof data === 'object' ? data : {};
        let result = new IEventData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventTime"] = this.eventTime ? this.eventTime.toISOString() : <any>undefined;
        data["eventSource"] = this.eventSource;
        return data;
    }

    clone(): IEventData {
        const json = this.toJSON();
        let result = new IEventData();
        result.init(json);
        return result;
    }
}

export interface IIEventData {
    eventTime: moment.Moment;
    eventSource: any | undefined;
}

export class IWorkflowAction implements IIWorkflowAction {
    id: number;
    name: string | undefined;
    permission: string | undefined;
    isSingleUse: boolean;

    constructor(data?: IIWorkflowAction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.permission = _data["permission"];
            this.isSingleUse = _data["isSingleUse"];
        }
    }

    static fromJS(data: any): IWorkflowAction {
        data = typeof data === 'object' ? data : {};
        let result = new IWorkflowAction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["permission"] = this.permission;
        data["isSingleUse"] = this.isSingleUse;
        return data;
    }

    clone(): IWorkflowAction {
        const json = this.toJSON();
        let result = new IWorkflowAction();
        result.init(json);
        return result;
    }
}

export interface IIWorkflowAction {
    id: number;
    name: string | undefined;
    permission: string | undefined;
    isSingleUse: boolean;
}

export class IWorkflowState implements IIWorkflowState {
    id: number;
    name: string | undefined;

    constructor(data?: IIWorkflowState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): IWorkflowState {
        data = typeof data === 'object' ? data : {};
        let result = new IWorkflowState();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): IWorkflowState {
        const json = this.toJSON();
        let result = new IWorkflowState();
        result.init(json);
        return result;
    }
}

export interface IIWorkflowState {
    id: number;
    name: string | undefined;
}

export class InOutReservation implements IInOutReservation {
    id: string;
    readonly domainEvents: IEventData[] | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creatorUser: User;
    lastModifierUser: User;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    code: string | undefined;
    number: number;
    status: InOutReservationStatus;
    locationId: number;
    location: Location;
    pricingId: number;
    pricing: InOutReservationPricing;
    startTime: moment.Moment;
    endTime: moment.Moment | undefined;
    totalHours: number | undefined;
    totalPrice: number | undefined;
    subTotal: number | undefined;
    vat: number | undefined;
    startStaffAccountId: number;
    startStaffAccount: StaffAccount;
    startStaffAccountShiftId: string;
    startStaffAccountShift: StaffAccountShift;
    endStaffAccountId: number | undefined;
    endStaffAccount: StaffAccount;
    endStaffAccountShiftId: string | undefined;
    endStaffAccountShift: StaffAccountShift;
    vehicleId: string | undefined;
    vehicle: Vehicle;
    readonly vatPercentage: number | undefined;
    discount: number;
    readonly invoiceNumber: string | undefined;

    constructor(data?: IInOutReservation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["domainEvents"])) {
                (<any>this).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (<any>this).domainEvents.push(IEventData.fromJS(item));
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.code = _data["code"];
            this.number = _data["number"];
            this.status = _data["status"];
            this.locationId = _data["locationId"];
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : <any>undefined;
            this.pricingId = _data["pricingId"];
            this.pricing = _data["pricing"] ? InOutReservationPricing.fromJS(_data["pricing"]) : <any>undefined;
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
            this.totalHours = _data["totalHours"];
            this.totalPrice = _data["totalPrice"];
            this.subTotal = _data["subTotal"];
            this.vat = _data["vat"];
            this.startStaffAccountId = _data["startStaffAccountId"];
            this.startStaffAccount = _data["startStaffAccount"] ? StaffAccount.fromJS(_data["startStaffAccount"]) : <any>undefined;
            this.startStaffAccountShiftId = _data["startStaffAccountShiftId"];
            this.startStaffAccountShift = _data["startStaffAccountShift"] ? StaffAccountShift.fromJS(_data["startStaffAccountShift"]) : <any>undefined;
            this.endStaffAccountId = _data["endStaffAccountId"];
            this.endStaffAccount = _data["endStaffAccount"] ? StaffAccount.fromJS(_data["endStaffAccount"]) : <any>undefined;
            this.endStaffAccountShiftId = _data["endStaffAccountShiftId"];
            this.endStaffAccountShift = _data["endStaffAccountShift"] ? StaffAccountShift.fromJS(_data["endStaffAccountShift"]) : <any>undefined;
            this.vehicleId = _data["vehicleId"];
            this.vehicle = _data["vehicle"] ? Vehicle.fromJS(_data["vehicle"]) : <any>undefined;
            (<any>this).vatPercentage = _data["vatPercentage"];
            this.discount = _data["discount"];
            (<any>this).invoiceNumber = _data["invoiceNumber"];
        }
    }

    static fromJS(data: any): InOutReservation {
        data = typeof data === 'object' ? data : {};
        let result = new InOutReservation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item.toJSON());
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["code"] = this.code;
        data["number"] = this.number;
        data["status"] = this.status;
        data["locationId"] = this.locationId;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["pricingId"] = this.pricingId;
        data["pricing"] = this.pricing ? this.pricing.toJSON() : <any>undefined;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["totalHours"] = this.totalHours;
        data["totalPrice"] = this.totalPrice;
        data["subTotal"] = this.subTotal;
        data["vat"] = this.vat;
        data["startStaffAccountId"] = this.startStaffAccountId;
        data["startStaffAccount"] = this.startStaffAccount ? this.startStaffAccount.toJSON() : <any>undefined;
        data["startStaffAccountShiftId"] = this.startStaffAccountShiftId;
        data["startStaffAccountShift"] = this.startStaffAccountShift ? this.startStaffAccountShift.toJSON() : <any>undefined;
        data["endStaffAccountId"] = this.endStaffAccountId;
        data["endStaffAccount"] = this.endStaffAccount ? this.endStaffAccount.toJSON() : <any>undefined;
        data["endStaffAccountShiftId"] = this.endStaffAccountShiftId;
        data["endStaffAccountShift"] = this.endStaffAccountShift ? this.endStaffAccountShift.toJSON() : <any>undefined;
        data["vehicleId"] = this.vehicleId;
        data["vehicle"] = this.vehicle ? this.vehicle.toJSON() : <any>undefined;
        data["vatPercentage"] = this.vatPercentage;
        data["discount"] = this.discount;
        data["invoiceNumber"] = this.invoiceNumber;
        return data;
    }

    clone(): InOutReservation {
        const json = this.toJSON();
        let result = new InOutReservation();
        result.init(json);
        return result;
    }
}

export interface IInOutReservation {
    id: string;
    domainEvents: IEventData[] | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creatorUser: User;
    lastModifierUser: User;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    code: string | undefined;
    number: number;
    status: InOutReservationStatus;
    locationId: number;
    location: Location;
    pricingId: number;
    pricing: InOutReservationPricing;
    startTime: moment.Moment;
    endTime: moment.Moment | undefined;
    totalHours: number | undefined;
    totalPrice: number | undefined;
    subTotal: number | undefined;
    vat: number | undefined;
    startStaffAccountId: number;
    startStaffAccount: StaffAccount;
    startStaffAccountShiftId: string;
    startStaffAccountShift: StaffAccountShift;
    endStaffAccountId: number | undefined;
    endStaffAccount: StaffAccount;
    endStaffAccountShiftId: string | undefined;
    endStaffAccountShift: StaffAccountShift;
    vehicleId: string | undefined;
    vehicle: Vehicle;
    vatPercentage: number | undefined;
    discount: number;
    invoiceNumber: string | undefined;
}

export class InOutReservationAppliedPricingDto implements IInOutReservationAppliedPricingDto {
    initialAmount: number;
    initialHours: number;
    extraHourPrice: number;
    allowanceTime: number;
    lostTicketFees: number;

    constructor(data?: IInOutReservationAppliedPricingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.initialAmount = _data["initialAmount"];
            this.initialHours = _data["initialHours"];
            this.extraHourPrice = _data["extraHourPrice"];
            this.allowanceTime = _data["allowanceTime"];
            this.lostTicketFees = _data["lostTicketFees"];
        }
    }

    static fromJS(data: any): InOutReservationAppliedPricingDto {
        data = typeof data === 'object' ? data : {};
        let result = new InOutReservationAppliedPricingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["initialAmount"] = this.initialAmount;
        data["initialHours"] = this.initialHours;
        data["extraHourPrice"] = this.extraHourPrice;
        data["allowanceTime"] = this.allowanceTime;
        data["lostTicketFees"] = this.lostTicketFees;
        return data;
    }

    clone(): InOutReservationAppliedPricingDto {
        const json = this.toJSON();
        let result = new InOutReservationAppliedPricingDto();
        result.init(json);
        return result;
    }
}

export interface IInOutReservationAppliedPricingDto {
    initialAmount: number;
    initialHours: number;
    extraHourPrice: number;
    allowanceTime: number;
    lostTicketFees: number;
}

export class InOutReservationListDto implements IInOutReservationListDto {
    id: string;
    code: string | undefined;
    number: number;
    locationId: number;
    locationName: string | undefined;
    startTime: moment.Moment;
    endTime: moment.Moment | undefined;
    startStaffAccountId: number;
    startStaffAccount: string | undefined;
    endStaffAccountId: number | undefined;
    endStaffAccount: string | undefined;
    status: InOutReservationStatus;
    totalHours: number | undefined;
    pricingId: number;
    vatPercentage: number | undefined;
    discount: number;
    successTransaction: TransactionDto;
    pricingModel: InOutReservationPricingModelDto;

    constructor(data?: IInOutReservationListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.number = _data["number"];
            this.locationId = _data["locationId"];
            this.locationName = _data["locationName"];
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
            this.startStaffAccountId = _data["startStaffAccountId"];
            this.startStaffAccount = _data["startStaffAccount"];
            this.endStaffAccountId = _data["endStaffAccountId"];
            this.endStaffAccount = _data["endStaffAccount"];
            this.status = _data["status"];
            this.totalHours = _data["totalHours"];
            this.pricingId = _data["pricingId"];
            this.vatPercentage = _data["vatPercentage"];
            this.discount = _data["discount"];
            this.successTransaction = _data["successTransaction"] ? TransactionDto.fromJS(_data["successTransaction"]) : <any>undefined;
            this.pricingModel = _data["pricingModel"] ? InOutReservationPricingModelDto.fromJS(_data["pricingModel"]) : <any>undefined;
        }
    }

    static fromJS(data: any): InOutReservationListDto {
        data = typeof data === 'object' ? data : {};
        let result = new InOutReservationListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["number"] = this.number;
        data["locationId"] = this.locationId;
        data["locationName"] = this.locationName;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["startStaffAccountId"] = this.startStaffAccountId;
        data["startStaffAccount"] = this.startStaffAccount;
        data["endStaffAccountId"] = this.endStaffAccountId;
        data["endStaffAccount"] = this.endStaffAccount;
        data["status"] = this.status;
        data["totalHours"] = this.totalHours;
        data["pricingId"] = this.pricingId;
        data["vatPercentage"] = this.vatPercentage;
        data["discount"] = this.discount;
        data["successTransaction"] = this.successTransaction ? this.successTransaction.toJSON() : <any>undefined;
        data["pricingModel"] = this.pricingModel ? this.pricingModel.toJSON() : <any>undefined;
        return data;
    }

    clone(): InOutReservationListDto {
        const json = this.toJSON();
        let result = new InOutReservationListDto();
        result.init(json);
        return result;
    }
}

export interface IInOutReservationListDto {
    id: string;
    code: string | undefined;
    number: number;
    locationId: number;
    locationName: string | undefined;
    startTime: moment.Moment;
    endTime: moment.Moment | undefined;
    startStaffAccountId: number;
    startStaffAccount: string | undefined;
    endStaffAccountId: number | undefined;
    endStaffAccount: string | undefined;
    status: InOutReservationStatus;
    totalHours: number | undefined;
    pricingId: number;
    vatPercentage: number | undefined;
    discount: number;
    successTransaction: TransactionDto;
    pricingModel: InOutReservationPricingModelDto;
}

export class InOutReservationListDtoPagedResultDto implements IInOutReservationListDtoPagedResultDto {
    items: InOutReservationListDto[] | undefined;
    totalCount: number;

    constructor(data?: IInOutReservationListDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(InOutReservationListDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): InOutReservationListDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new InOutReservationListDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): InOutReservationListDtoPagedResultDto {
        const json = this.toJSON();
        let result = new InOutReservationListDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IInOutReservationListDtoPagedResultDto {
    items: InOutReservationListDto[] | undefined;
    totalCount: number;
}

export class InOutReservationOutputDto implements IInOutReservationOutputDto {
    id: string;
    code: string | undefined;
    number: number;
    locationId: number;
    locationName: string | undefined;
    startTime: moment.Moment;
    endTime: moment.Moment | undefined;
    startStaffAccountId: number;
    startStaffAccount: string | undefined;
    endStaffAccountId: number | undefined;
    endStaffAccount: string | undefined;
    startStaffAccountShiftId: string;
    startStaffAccountShift: string | undefined;
    endStaffAccountShiftId: string | undefined;
    endStaffAccountShift: string | undefined;
    status: InOutReservationStatus;
    totalHours: number | undefined;
    pricingId: number;
    vatPercentage: number | undefined;
    discount: number;
    successTransaction: TransactionDto;
    pricingModel: InOutReservationPricingModelDto;

    constructor(data?: IInOutReservationOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.number = _data["number"];
            this.locationId = _data["locationId"];
            this.locationName = _data["locationName"];
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
            this.startStaffAccountId = _data["startStaffAccountId"];
            this.startStaffAccount = _data["startStaffAccount"];
            this.endStaffAccountId = _data["endStaffAccountId"];
            this.endStaffAccount = _data["endStaffAccount"];
            this.startStaffAccountShiftId = _data["startStaffAccountShiftId"];
            this.startStaffAccountShift = _data["startStaffAccountShift"];
            this.endStaffAccountShiftId = _data["endStaffAccountShiftId"];
            this.endStaffAccountShift = _data["endStaffAccountShift"];
            this.status = _data["status"];
            this.totalHours = _data["totalHours"];
            this.pricingId = _data["pricingId"];
            this.vatPercentage = _data["vatPercentage"];
            this.discount = _data["discount"];
            this.successTransaction = _data["successTransaction"] ? TransactionDto.fromJS(_data["successTransaction"]) : <any>undefined;
            this.pricingModel = _data["pricingModel"] ? InOutReservationPricingModelDto.fromJS(_data["pricingModel"]) : <any>undefined;
        }
    }

    static fromJS(data: any): InOutReservationOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new InOutReservationOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["number"] = this.number;
        data["locationId"] = this.locationId;
        data["locationName"] = this.locationName;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["startStaffAccountId"] = this.startStaffAccountId;
        data["startStaffAccount"] = this.startStaffAccount;
        data["endStaffAccountId"] = this.endStaffAccountId;
        data["endStaffAccount"] = this.endStaffAccount;
        data["startStaffAccountShiftId"] = this.startStaffAccountShiftId;
        data["startStaffAccountShift"] = this.startStaffAccountShift;
        data["endStaffAccountShiftId"] = this.endStaffAccountShiftId;
        data["endStaffAccountShift"] = this.endStaffAccountShift;
        data["status"] = this.status;
        data["totalHours"] = this.totalHours;
        data["pricingId"] = this.pricingId;
        data["vatPercentage"] = this.vatPercentage;
        data["discount"] = this.discount;
        data["successTransaction"] = this.successTransaction ? this.successTransaction.toJSON() : <any>undefined;
        data["pricingModel"] = this.pricingModel ? this.pricingModel.toJSON() : <any>undefined;
        return data;
    }

    clone(): InOutReservationOutputDto {
        const json = this.toJSON();
        let result = new InOutReservationOutputDto();
        result.init(json);
        return result;
    }
}

export interface IInOutReservationOutputDto {
    id: string;
    code: string | undefined;
    number: number;
    locationId: number;
    locationName: string | undefined;
    startTime: moment.Moment;
    endTime: moment.Moment | undefined;
    startStaffAccountId: number;
    startStaffAccount: string | undefined;
    endStaffAccountId: number | undefined;
    endStaffAccount: string | undefined;
    startStaffAccountShiftId: string;
    startStaffAccountShift: string | undefined;
    endStaffAccountShiftId: string | undefined;
    endStaffAccountShift: string | undefined;
    status: InOutReservationStatus;
    totalHours: number | undefined;
    pricingId: number;
    vatPercentage: number | undefined;
    discount: number;
    successTransaction: TransactionDto;
    pricingModel: InOutReservationPricingModelDto;
}

export class InOutReservationPricing implements IInOutReservationPricing {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creatorUser: User;
    lastModifierUser: User;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    readonly name: string | undefined;
    readonly initialAmount: number;
    readonly initialHours: number;
    readonly extraHourPrice: number;
    readonly allowanceTime: number;
    readonly isEnabled: boolean;
    readonly allowedToEdit: boolean;
    readonly lostTicketFees: number;
    readonly discount: number;
    readonly inOutReservations: InOutReservation[] | undefined;
    readonly lostInOutReservationTickets: LostInOutReservationTicket[] | undefined;

    constructor(data?: IInOutReservationPricing) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            (<any>this).name = _data["name"];
            (<any>this).initialAmount = _data["initialAmount"];
            (<any>this).initialHours = _data["initialHours"];
            (<any>this).extraHourPrice = _data["extraHourPrice"];
            (<any>this).allowanceTime = _data["allowanceTime"];
            (<any>this).isEnabled = _data["isEnabled"];
            (<any>this).allowedToEdit = _data["allowedToEdit"];
            (<any>this).lostTicketFees = _data["lostTicketFees"];
            (<any>this).discount = _data["discount"];
            if (Array.isArray(_data["inOutReservations"])) {
                (<any>this).inOutReservations = [] as any;
                for (let item of _data["inOutReservations"])
                    (<any>this).inOutReservations.push(InOutReservation.fromJS(item));
            }
            if (Array.isArray(_data["lostInOutReservationTickets"])) {
                (<any>this).lostInOutReservationTickets = [] as any;
                for (let item of _data["lostInOutReservationTickets"])
                    (<any>this).lostInOutReservationTickets.push(LostInOutReservationTicket.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InOutReservationPricing {
        data = typeof data === 'object' ? data : {};
        let result = new InOutReservationPricing();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["initialAmount"] = this.initialAmount;
        data["initialHours"] = this.initialHours;
        data["extraHourPrice"] = this.extraHourPrice;
        data["allowanceTime"] = this.allowanceTime;
        data["isEnabled"] = this.isEnabled;
        data["allowedToEdit"] = this.allowedToEdit;
        data["lostTicketFees"] = this.lostTicketFees;
        data["discount"] = this.discount;
        if (Array.isArray(this.inOutReservations)) {
            data["inOutReservations"] = [];
            for (let item of this.inOutReservations)
                data["inOutReservations"].push(item.toJSON());
        }
        if (Array.isArray(this.lostInOutReservationTickets)) {
            data["lostInOutReservationTickets"] = [];
            for (let item of this.lostInOutReservationTickets)
                data["lostInOutReservationTickets"].push(item.toJSON());
        }
        return data;
    }

    clone(): InOutReservationPricing {
        const json = this.toJSON();
        let result = new InOutReservationPricing();
        result.init(json);
        return result;
    }
}

export interface IInOutReservationPricing {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creatorUser: User;
    lastModifierUser: User;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    name: string | undefined;
    initialAmount: number;
    initialHours: number;
    extraHourPrice: number;
    allowanceTime: number;
    isEnabled: boolean;
    allowedToEdit: boolean;
    lostTicketFees: number;
    discount: number;
    inOutReservations: InOutReservation[] | undefined;
    lostInOutReservationTickets: LostInOutReservationTicket[] | undefined;
}

export class InOutReservationPricingCreateOrEditDto implements IInOutReservationPricingCreateOrEditDto {
    id: number | undefined;
    name: string | undefined;
    initialAmount: number;
    initialHours: number;
    extraHourPrice: number;
    allowanceTime: number;
    isEnabled: boolean;
    lostTicketFees: number;
    discount: number;

    constructor(data?: IInOutReservationPricingCreateOrEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.initialAmount = _data["initialAmount"];
            this.initialHours = _data["initialHours"];
            this.extraHourPrice = _data["extraHourPrice"];
            this.allowanceTime = _data["allowanceTime"];
            this.isEnabled = _data["isEnabled"];
            this.lostTicketFees = _data["lostTicketFees"];
            this.discount = _data["discount"];
        }
    }

    static fromJS(data: any): InOutReservationPricingCreateOrEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new InOutReservationPricingCreateOrEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["initialAmount"] = this.initialAmount;
        data["initialHours"] = this.initialHours;
        data["extraHourPrice"] = this.extraHourPrice;
        data["allowanceTime"] = this.allowanceTime;
        data["isEnabled"] = this.isEnabled;
        data["lostTicketFees"] = this.lostTicketFees;
        data["discount"] = this.discount;
        return data;
    }

    clone(): InOutReservationPricingCreateOrEditDto {
        const json = this.toJSON();
        let result = new InOutReservationPricingCreateOrEditDto();
        result.init(json);
        return result;
    }
}

export interface IInOutReservationPricingCreateOrEditDto {
    id: number | undefined;
    name: string | undefined;
    initialAmount: number;
    initialHours: number;
    extraHourPrice: number;
    allowanceTime: number;
    isEnabled: boolean;
    lostTicketFees: number;
    discount: number;
}

export class InOutReservationPricingListDto implements IInOutReservationPricingListDto {
    id: number;
    name: string | undefined;
    initialAmount: number;
    initialHours: number;
    extraHourPrice: number;
    allowanceTime: number;
    isEnabled: boolean;
    allowedToEdit: boolean;
    lostTicketFees: number;
    discount: number;

    constructor(data?: IInOutReservationPricingListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.initialAmount = _data["initialAmount"];
            this.initialHours = _data["initialHours"];
            this.extraHourPrice = _data["extraHourPrice"];
            this.allowanceTime = _data["allowanceTime"];
            this.isEnabled = _data["isEnabled"];
            this.allowedToEdit = _data["allowedToEdit"];
            this.lostTicketFees = _data["lostTicketFees"];
            this.discount = _data["discount"];
        }
    }

    static fromJS(data: any): InOutReservationPricingListDto {
        data = typeof data === 'object' ? data : {};
        let result = new InOutReservationPricingListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["initialAmount"] = this.initialAmount;
        data["initialHours"] = this.initialHours;
        data["extraHourPrice"] = this.extraHourPrice;
        data["allowanceTime"] = this.allowanceTime;
        data["isEnabled"] = this.isEnabled;
        data["allowedToEdit"] = this.allowedToEdit;
        data["lostTicketFees"] = this.lostTicketFees;
        data["discount"] = this.discount;
        return data;
    }

    clone(): InOutReservationPricingListDto {
        const json = this.toJSON();
        let result = new InOutReservationPricingListDto();
        result.init(json);
        return result;
    }
}

export interface IInOutReservationPricingListDto {
    id: number;
    name: string | undefined;
    initialAmount: number;
    initialHours: number;
    extraHourPrice: number;
    allowanceTime: number;
    isEnabled: boolean;
    allowedToEdit: boolean;
    lostTicketFees: number;
    discount: number;
}

export class InOutReservationPricingListDtoPagedResultDto implements IInOutReservationPricingListDtoPagedResultDto {
    items: InOutReservationPricingListDto[] | undefined;
    totalCount: number;

    constructor(data?: IInOutReservationPricingListDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(InOutReservationPricingListDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): InOutReservationPricingListDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new InOutReservationPricingListDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): InOutReservationPricingListDtoPagedResultDto {
        const json = this.toJSON();
        let result = new InOutReservationPricingListDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IInOutReservationPricingListDtoPagedResultDto {
    items: InOutReservationPricingListDto[] | undefined;
    totalCount: number;
}

export class InOutReservationPricingModelDto implements IInOutReservationPricingModelDto {
    total: number | undefined;
    subtotal: number | undefined;
    vatAmount: number | undefined;
    discount: number;

    constructor(data?: IInOutReservationPricingModelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"];
            this.subtotal = _data["subtotal"];
            this.vatAmount = _data["vatAmount"];
            this.discount = _data["discount"];
        }
    }

    static fromJS(data: any): InOutReservationPricingModelDto {
        data = typeof data === 'object' ? data : {};
        let result = new InOutReservationPricingModelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        data["subtotal"] = this.subtotal;
        data["vatAmount"] = this.vatAmount;
        data["discount"] = this.discount;
        return data;
    }

    clone(): InOutReservationPricingModelDto {
        const json = this.toJSON();
        let result = new InOutReservationPricingModelDto();
        result.init(json);
        return result;
    }
}

export interface IInOutReservationPricingModelDto {
    total: number | undefined;
    subtotal: number | undefined;
    vatAmount: number | undefined;
    discount: number;
}

export class InOutReservationPricingViewDto implements IInOutReservationPricingViewDto {
    id: number;
    readonly name: string | undefined;
    initialAmount: number;
    initialHours: number;
    extraHourPrice: number;
    allowanceTime: number;
    isEnabled: boolean;
    allowedToEdit: boolean;
    lostTicketFees: number;

    constructor(data?: IInOutReservationPricingViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            (<any>this).name = _data["name"];
            this.initialAmount = _data["initialAmount"];
            this.initialHours = _data["initialHours"];
            this.extraHourPrice = _data["extraHourPrice"];
            this.allowanceTime = _data["allowanceTime"];
            this.isEnabled = _data["isEnabled"];
            this.allowedToEdit = _data["allowedToEdit"];
            this.lostTicketFees = _data["lostTicketFees"];
        }
    }

    static fromJS(data: any): InOutReservationPricingViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new InOutReservationPricingViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["initialAmount"] = this.initialAmount;
        data["initialHours"] = this.initialHours;
        data["extraHourPrice"] = this.extraHourPrice;
        data["allowanceTime"] = this.allowanceTime;
        data["isEnabled"] = this.isEnabled;
        data["allowedToEdit"] = this.allowedToEdit;
        data["lostTicketFees"] = this.lostTicketFees;
        return data;
    }

    clone(): InOutReservationPricingViewDto {
        const json = this.toJSON();
        let result = new InOutReservationPricingViewDto();
        result.init(json);
        return result;
    }
}

export interface IInOutReservationPricingViewDto {
    id: number;
    name: string | undefined;
    initialAmount: number;
    initialHours: number;
    extraHourPrice: number;
    allowanceTime: number;
    isEnabled: boolean;
    allowedToEdit: boolean;
    lostTicketFees: number;
}

export enum InOutReservationStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class InOutReservationViewDto implements IInOutReservationViewDto {
    id: string;
    code: string | undefined;
    number: number;
    locationId: number;
    locationName: string | undefined;
    startTime: moment.Moment;
    endTime: moment.Moment | undefined;
    startStaffAccountId: number;
    startStaffAccount: string | undefined;
    endStaffAccountId: number | undefined;
    endStaffAccount: string | undefined;
    startStaffAccountShiftId: string;
    startStaffAccountShift: string | undefined;
    endStaffAccountShiftId: string | undefined;
    endStaffAccountShift: string | undefined;
    status: InOutReservationStatus;
    totalHours: number | undefined;
    pricingId: number;
    vatPercentage: number | undefined;
    discount: number;
    successTransaction: TransactionDto;
    pricingModel: InOutReservationPricingModelDto;
    appliedPricingModel: InOutReservationAppliedPricingDto;

    constructor(data?: IInOutReservationViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.number = _data["number"];
            this.locationId = _data["locationId"];
            this.locationName = _data["locationName"];
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
            this.startStaffAccountId = _data["startStaffAccountId"];
            this.startStaffAccount = _data["startStaffAccount"];
            this.endStaffAccountId = _data["endStaffAccountId"];
            this.endStaffAccount = _data["endStaffAccount"];
            this.startStaffAccountShiftId = _data["startStaffAccountShiftId"];
            this.startStaffAccountShift = _data["startStaffAccountShift"];
            this.endStaffAccountShiftId = _data["endStaffAccountShiftId"];
            this.endStaffAccountShift = _data["endStaffAccountShift"];
            this.status = _data["status"];
            this.totalHours = _data["totalHours"];
            this.pricingId = _data["pricingId"];
            this.vatPercentage = _data["vatPercentage"];
            this.discount = _data["discount"];
            this.successTransaction = _data["successTransaction"] ? TransactionDto.fromJS(_data["successTransaction"]) : <any>undefined;
            this.pricingModel = _data["pricingModel"] ? InOutReservationPricingModelDto.fromJS(_data["pricingModel"]) : <any>undefined;
            this.appliedPricingModel = _data["appliedPricingModel"] ? InOutReservationAppliedPricingDto.fromJS(_data["appliedPricingModel"]) : <any>undefined;
        }
    }

    static fromJS(data: any): InOutReservationViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new InOutReservationViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["number"] = this.number;
        data["locationId"] = this.locationId;
        data["locationName"] = this.locationName;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["startStaffAccountId"] = this.startStaffAccountId;
        data["startStaffAccount"] = this.startStaffAccount;
        data["endStaffAccountId"] = this.endStaffAccountId;
        data["endStaffAccount"] = this.endStaffAccount;
        data["startStaffAccountShiftId"] = this.startStaffAccountShiftId;
        data["startStaffAccountShift"] = this.startStaffAccountShift;
        data["endStaffAccountShiftId"] = this.endStaffAccountShiftId;
        data["endStaffAccountShift"] = this.endStaffAccountShift;
        data["status"] = this.status;
        data["totalHours"] = this.totalHours;
        data["pricingId"] = this.pricingId;
        data["vatPercentage"] = this.vatPercentage;
        data["discount"] = this.discount;
        data["successTransaction"] = this.successTransaction ? this.successTransaction.toJSON() : <any>undefined;
        data["pricingModel"] = this.pricingModel ? this.pricingModel.toJSON() : <any>undefined;
        data["appliedPricingModel"] = this.appliedPricingModel ? this.appliedPricingModel.toJSON() : <any>undefined;
        return data;
    }

    clone(): InOutReservationViewDto {
        const json = this.toJSON();
        let result = new InOutReservationViewDto();
        result.init(json);
        return result;
    }
}

export interface IInOutReservationViewDto {
    id: string;
    code: string | undefined;
    number: number;
    locationId: number;
    locationName: string | undefined;
    startTime: moment.Moment;
    endTime: moment.Moment | undefined;
    startStaffAccountId: number;
    startStaffAccount: string | undefined;
    endStaffAccountId: number | undefined;
    endStaffAccount: string | undefined;
    startStaffAccountShiftId: string;
    startStaffAccountShift: string | undefined;
    endStaffAccountShiftId: string | undefined;
    endStaffAccountShift: string | undefined;
    status: InOutReservationStatus;
    totalHours: number | undefined;
    pricingId: number;
    vatPercentage: number | undefined;
    discount: number;
    successTransaction: TransactionDto;
    pricingModel: InOutReservationPricingModelDto;
    appliedPricingModel: InOutReservationAppliedPricingDto;
}

export class InOutReservationViewDtoRecieptDto implements IInOutReservationViewDtoRecieptDto {
    header: RecieptHeaderDto;
    information: InOutReservationViewDto;

    constructor(data?: IInOutReservationViewDtoRecieptDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.header = _data["header"] ? RecieptHeaderDto.fromJS(_data["header"]) : <any>undefined;
            this.information = _data["information"] ? InOutReservationViewDto.fromJS(_data["information"]) : <any>undefined;
        }
    }

    static fromJS(data: any): InOutReservationViewDtoRecieptDto {
        data = typeof data === 'object' ? data : {};
        let result = new InOutReservationViewDtoRecieptDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["header"] = this.header ? this.header.toJSON() : <any>undefined;
        data["information"] = this.information ? this.information.toJSON() : <any>undefined;
        return data;
    }

    clone(): InOutReservationViewDtoRecieptDto {
        const json = this.toJSON();
        let result = new InOutReservationViewDtoRecieptDto();
        result.init(json);
        return result;
    }
}

export interface IInOutReservationViewDtoRecieptDto {
    header: RecieptHeaderDto;
    information: InOutReservationViewDto;
}

export class InOutReservationsSummaryDto implements IInOutReservationsSummaryDto {
    amount: number;
    count: number;

    constructor(data?: IInOutReservationsSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): InOutReservationsSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new InOutReservationsSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["count"] = this.count;
        return data;
    }

    clone(): InOutReservationsSummaryDto {
        const json = this.toJSON();
        let result = new InOutReservationsSummaryDto();
        result.init(json);
        return result;
    }
}

export interface IInOutReservationsSummaryDto {
    amount: number;
    count: number;
}

export class Int64EntityDto implements IInt64EntityDto {
    id: number;

    constructor(data?: IInt64EntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Int64EntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new Int64EntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }

    clone(): Int64EntityDto {
        const json = this.toJSON();
        let result = new Int64EntityDto();
        result.init(json);
        return result;
    }
}

export interface IInt64EntityDto {
    id: number;
}

export class Int64StringKeyValuePair implements IInt64StringKeyValuePair {
    key: number;
    value: string | undefined;

    constructor(data?: IInt64StringKeyValuePair) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): Int64StringKeyValuePair {
        data = typeof data === 'object' ? data : {};
        let result = new Int64StringKeyValuePair();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }

    clone(): Int64StringKeyValuePair {
        const json = this.toJSON();
        let result = new Int64StringKeyValuePair();
        result.init(json);
        return result;
    }
}

export interface IInt64StringKeyValuePair {
    key: number;
    value: string | undefined;
}

export class IntegratedInvoiceDto implements IIntegratedInvoiceDto {
    id: string;
    company: string | undefined;
    customerVATCode: string | undefined;
    country: string | undefined;
    city: string | undefined;
    location: string | undefined;
    project: string | undefined;
    site: string | undefined;
    details: string | undefined;
    cashierID: number;
    shift: number;
    invoiceNo: string | undefined;
    date: moment.Moment;
    description: string | undefined;
    entryTime: moment.Moment | undefined;
    exitTime: moment.Moment | undefined;
    qty: number;
    totalAmount: number;
    netAmount: number;
    vatAmount: number;
    vatPercentage: number;
    paymentMethod: IntegratedInvoicePaymentTypes;
    sourceType: IntegratedInvoiceSourceTypes;
    sourceCompany: IntegratedInvoiceSourceCompanies;

    constructor(data?: IIntegratedInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.company = _data["company"];
            this.customerVATCode = _data["customerVATCode"];
            this.country = _data["country"];
            this.city = _data["city"];
            this.location = _data["location"];
            this.project = _data["project"];
            this.site = _data["site"];
            this.details = _data["details"];
            this.cashierID = _data["cashierID"];
            this.shift = _data["shift"];
            this.invoiceNo = _data["invoiceNo"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.description = _data["description"];
            this.entryTime = _data["entryTime"] ? moment(_data["entryTime"].toString()) : <any>undefined;
            this.exitTime = _data["exitTime"] ? moment(_data["exitTime"].toString()) : <any>undefined;
            this.qty = _data["qty"];
            this.totalAmount = _data["totalAmount"];
            this.netAmount = _data["netAmount"];
            this.vatAmount = _data["vatAmount"];
            this.vatPercentage = _data["vatPercentage"];
            this.paymentMethod = _data["paymentMethod"];
            this.sourceType = _data["sourceType"];
            this.sourceCompany = _data["sourceCompany"];
        }
    }

    static fromJS(data: any): IntegratedInvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new IntegratedInvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["company"] = this.company;
        data["customerVATCode"] = this.customerVATCode;
        data["country"] = this.country;
        data["city"] = this.city;
        data["location"] = this.location;
        data["project"] = this.project;
        data["site"] = this.site;
        data["details"] = this.details;
        data["cashierID"] = this.cashierID;
        data["shift"] = this.shift;
        data["invoiceNo"] = this.invoiceNo;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["entryTime"] = this.entryTime ? this.entryTime.toISOString() : <any>undefined;
        data["exitTime"] = this.exitTime ? this.exitTime.toISOString() : <any>undefined;
        data["qty"] = this.qty;
        data["totalAmount"] = this.totalAmount;
        data["netAmount"] = this.netAmount;
        data["vatAmount"] = this.vatAmount;
        data["vatPercentage"] = this.vatPercentage;
        data["paymentMethod"] = this.paymentMethod;
        data["sourceType"] = this.sourceType;
        data["sourceCompany"] = this.sourceCompany;
        return data;
    }

    clone(): IntegratedInvoiceDto {
        const json = this.toJSON();
        let result = new IntegratedInvoiceDto();
        result.init(json);
        return result;
    }
}

export interface IIntegratedInvoiceDto {
    id: string;
    company: string | undefined;
    customerVATCode: string | undefined;
    country: string | undefined;
    city: string | undefined;
    location: string | undefined;
    project: string | undefined;
    site: string | undefined;
    details: string | undefined;
    cashierID: number;
    shift: number;
    invoiceNo: string | undefined;
    date: moment.Moment;
    description: string | undefined;
    entryTime: moment.Moment | undefined;
    exitTime: moment.Moment | undefined;
    qty: number;
    totalAmount: number;
    netAmount: number;
    vatAmount: number;
    vatPercentage: number;
    paymentMethod: IntegratedInvoicePaymentTypes;
    sourceType: IntegratedInvoiceSourceTypes;
    sourceCompany: IntegratedInvoiceSourceCompanies;
}

export class IntegratedInvoiceDtoPagedResultDto implements IIntegratedInvoiceDtoPagedResultDto {
    items: IntegratedInvoiceDto[] | undefined;
    totalCount: number;

    constructor(data?: IIntegratedInvoiceDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(IntegratedInvoiceDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): IntegratedInvoiceDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new IntegratedInvoiceDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): IntegratedInvoiceDtoPagedResultDto {
        const json = this.toJSON();
        let result = new IntegratedInvoiceDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IIntegratedInvoiceDtoPagedResultDto {
    items: IntegratedInvoiceDto[] | undefined;
    totalCount: number;
}

export enum IntegratedInvoicePaymentTypes {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum IntegratedInvoiceSourceCompanies {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum IntegratedInvoiceSourceTypes {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class IntegratedInvoiceStatus implements IIntegratedInvoiceStatus {
    readonly id: number;
    readonly name: string | undefined;

    constructor(data?: IIntegratedInvoiceStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).id = _data["id"];
            (<any>this).name = _data["name"];
        }
    }

    static fromJS(data: any): IntegratedInvoiceStatus {
        data = typeof data === 'object' ? data : {};
        let result = new IntegratedInvoiceStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): IntegratedInvoiceStatus {
        const json = this.toJSON();
        let result = new IntegratedInvoiceStatus();
        result.init(json);
        return result;
    }
}

export interface IIntegratedInvoiceStatus {
    id: number;
    name: string | undefined;
}

export class IntegrationDataMigrationIntegrityLogResponse implements IIntegrationDataMigrationIntegrityLogResponse {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    status: string | undefined;
    key: string | undefined;
    maxRetryCount: number;
    retryCount: number;
    failures: IntegrityFailureLogResponse[] | undefined;
    successes: DataMigrationSuccessLogResponse[] | undefined;
    readonly totalNumberOfRecords: number;
    source: string | undefined;

    constructor(data?: IIntegrationDataMigrationIntegrityLogResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.key = _data["key"];
            this.maxRetryCount = _data["maxRetryCount"];
            this.retryCount = _data["retryCount"];
            if (Array.isArray(_data["failures"])) {
                this.failures = [] as any;
                for (let item of _data["failures"])
                    this.failures.push(IntegrityFailureLogResponse.fromJS(item));
            }
            if (Array.isArray(_data["successes"])) {
                this.successes = [] as any;
                for (let item of _data["successes"])
                    this.successes.push(DataMigrationSuccessLogResponse.fromJS(item));
            }
            (<any>this).totalNumberOfRecords = _data["totalNumberOfRecords"];
            this.source = _data["source"];
        }
    }

    static fromJS(data: any): IntegrationDataMigrationIntegrityLogResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IntegrationDataMigrationIntegrityLogResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["key"] = this.key;
        data["maxRetryCount"] = this.maxRetryCount;
        data["retryCount"] = this.retryCount;
        if (Array.isArray(this.failures)) {
            data["failures"] = [];
            for (let item of this.failures)
                data["failures"].push(item.toJSON());
        }
        if (Array.isArray(this.successes)) {
            data["successes"] = [];
            for (let item of this.successes)
                data["successes"].push(item.toJSON());
        }
        data["totalNumberOfRecords"] = this.totalNumberOfRecords;
        data["source"] = this.source;
        return data;
    }

    clone(): IntegrationDataMigrationIntegrityLogResponse {
        const json = this.toJSON();
        let result = new IntegrationDataMigrationIntegrityLogResponse();
        result.init(json);
        return result;
    }
}

export interface IIntegrationDataMigrationIntegrityLogResponse {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    status: string | undefined;
    key: string | undefined;
    maxRetryCount: number;
    retryCount: number;
    failures: IntegrityFailureLogResponse[] | undefined;
    successes: DataMigrationSuccessLogResponse[] | undefined;
    totalNumberOfRecords: number;
    source: string | undefined;
}

export class IntegrationDataMigrationIntegrityLogResponsePagedResultDto implements IIntegrationDataMigrationIntegrityLogResponsePagedResultDto {
    items: IntegrationDataMigrationIntegrityLogResponse[] | undefined;
    totalCount: number;

    constructor(data?: IIntegrationDataMigrationIntegrityLogResponsePagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(IntegrationDataMigrationIntegrityLogResponse.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): IntegrationDataMigrationIntegrityLogResponsePagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new IntegrationDataMigrationIntegrityLogResponsePagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): IntegrationDataMigrationIntegrityLogResponsePagedResultDto {
        const json = this.toJSON();
        let result = new IntegrationDataMigrationIntegrityLogResponsePagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IIntegrationDataMigrationIntegrityLogResponsePagedResultDto {
    items: IntegrationDataMigrationIntegrityLogResponse[] | undefined;
    totalCount: number;
}

export class IntegrityFailureLogResponse implements IIntegrityFailureLogResponse {
    id: string;
    errorMessage: string | undefined;
    traceId: string | undefined;

    constructor(data?: IIntegrityFailureLogResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.errorMessage = _data["errorMessage"];
            this.traceId = _data["traceId"];
        }
    }

    static fromJS(data: any): IntegrityFailureLogResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IntegrityFailureLogResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["errorMessage"] = this.errorMessage;
        data["traceId"] = this.traceId;
        return data;
    }

    clone(): IntegrityFailureLogResponse {
        const json = this.toJSON();
        let result = new IntegrityFailureLogResponse();
        result.init(json);
        return result;
    }
}

export interface IIntegrityFailureLogResponse {
    id: string;
    errorMessage: string | undefined;
    traceId: string | undefined;
}

export class Invoice implements IInvoice {
    id: string;
    readonly domainEvents: IEventData[] | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creatorUser: User;
    lastModifierUser: User;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    readonly identifier: string | undefined;
    readonly transactionId: string;
    transaction: Transaction;
    readonly identity: number;
    readonly invoiceNumber: string | undefined;
    status: InvoiceStatus;
    readonly locations: InvoiceLocation[] | undefined;

    constructor(data?: IInvoice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["domainEvents"])) {
                (<any>this).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (<any>this).domainEvents.push(IEventData.fromJS(item));
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            (<any>this).identifier = _data["identifier"];
            (<any>this).transactionId = _data["transactionId"];
            this.transaction = _data["transaction"] ? Transaction.fromJS(_data["transaction"]) : <any>undefined;
            (<any>this).identity = _data["identity"];
            (<any>this).invoiceNumber = _data["invoiceNumber"];
            this.status = _data["status"];
            if (Array.isArray(_data["locations"])) {
                (<any>this).locations = [] as any;
                for (let item of _data["locations"])
                    (<any>this).locations.push(InvoiceLocation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Invoice {
        data = typeof data === 'object' ? data : {};
        let result = new Invoice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item.toJSON());
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["identifier"] = this.identifier;
        data["transactionId"] = this.transactionId;
        data["transaction"] = this.transaction ? this.transaction.toJSON() : <any>undefined;
        data["identity"] = this.identity;
        data["invoiceNumber"] = this.invoiceNumber;
        data["status"] = this.status;
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (let item of this.locations)
                data["locations"].push(item.toJSON());
        }
        return data;
    }

    clone(): Invoice {
        const json = this.toJSON();
        let result = new Invoice();
        result.init(json);
        return result;
    }
}

export interface IInvoice {
    id: string;
    domainEvents: IEventData[] | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creatorUser: User;
    lastModifierUser: User;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    identifier: string | undefined;
    transactionId: string;
    transaction: Transaction;
    identity: number;
    invoiceNumber: string | undefined;
    status: InvoiceStatus;
    locations: InvoiceLocation[] | undefined;
}

export class InvoiceCategory implements IInvoiceCategory {
    readonly id: number;
    readonly name: string | undefined;

    constructor(data?: IInvoiceCategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).id = _data["id"];
            (<any>this).name = _data["name"];
        }
    }

    static fromJS(data: any): InvoiceCategory {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): InvoiceCategory {
        const json = this.toJSON();
        let result = new InvoiceCategory();
        result.init(json);
        return result;
    }
}

export interface IInvoiceCategory {
    id: number;
    name: string | undefined;
}

export class InvoiceDto implements IInvoiceDto {
    invoiceId: string;
    invoiceNumber: string | undefined;
    locationId: number;
    locationName: string | undefined;
    slotId: number;
    slotName: string | undefined;
    transactionId: string;
    entityId: string;
    paymentType: PaymentType;
    transactionNumber: string | undefined;
    statusId: number;
    total: number;
    vatPercentage: number;
    readonly subTotal: number;
    readonly vatAmount: number;
    currency: string | undefined;
    source: TransactionSource;
    creationTime: moment.Moment | undefined;
    creator: string | undefined;
    creatorUserId: number | undefined;
    shiftId: string | undefined;
    onlineTransaction: OnlineTransaction;
    posTransaction: POSTransaction;
    status: InvoiceStatus;

    constructor(data?: IInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceId = _data["invoiceId"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.locationId = _data["locationId"];
            this.locationName = _data["locationName"];
            this.slotId = _data["slotId"];
            this.slotName = _data["slotName"];
            this.transactionId = _data["transactionId"];
            this.entityId = _data["entityId"];
            this.paymentType = _data["paymentType"];
            this.transactionNumber = _data["transactionNumber"];
            this.statusId = _data["statusId"];
            this.total = _data["total"];
            this.vatPercentage = _data["vatPercentage"];
            (<any>this).subTotal = _data["subTotal"];
            (<any>this).vatAmount = _data["vatAmount"];
            this.currency = _data["currency"];
            this.source = _data["source"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creator = _data["creator"];
            this.creatorUserId = _data["creatorUserId"];
            this.shiftId = _data["shiftId"];
            this.onlineTransaction = _data["onlineTransaction"] ? OnlineTransaction.fromJS(_data["onlineTransaction"]) : <any>undefined;
            this.posTransaction = _data["posTransaction"] ? POSTransaction.fromJS(_data["posTransaction"]) : <any>undefined;
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): InvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceId"] = this.invoiceId;
        data["invoiceNumber"] = this.invoiceNumber;
        data["locationId"] = this.locationId;
        data["locationName"] = this.locationName;
        data["slotId"] = this.slotId;
        data["slotName"] = this.slotName;
        data["transactionId"] = this.transactionId;
        data["entityId"] = this.entityId;
        data["paymentType"] = this.paymentType;
        data["transactionNumber"] = this.transactionNumber;
        data["statusId"] = this.statusId;
        data["total"] = this.total;
        data["vatPercentage"] = this.vatPercentage;
        data["subTotal"] = this.subTotal;
        data["vatAmount"] = this.vatAmount;
        data["currency"] = this.currency;
        data["source"] = this.source;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creator"] = this.creator;
        data["creatorUserId"] = this.creatorUserId;
        data["shiftId"] = this.shiftId;
        data["onlineTransaction"] = this.onlineTransaction ? this.onlineTransaction.toJSON() : <any>undefined;
        data["posTransaction"] = this.posTransaction ? this.posTransaction.toJSON() : <any>undefined;
        data["status"] = this.status;
        return data;
    }

    clone(): InvoiceDto {
        const json = this.toJSON();
        let result = new InvoiceDto();
        result.init(json);
        return result;
    }
}

export interface IInvoiceDto {
    invoiceId: string;
    invoiceNumber: string | undefined;
    locationId: number;
    locationName: string | undefined;
    slotId: number;
    slotName: string | undefined;
    transactionId: string;
    entityId: string;
    paymentType: PaymentType;
    transactionNumber: string | undefined;
    statusId: number;
    total: number;
    vatPercentage: number;
    subTotal: number;
    vatAmount: number;
    currency: string | undefined;
    source: TransactionSource;
    creationTime: moment.Moment | undefined;
    creator: string | undefined;
    creatorUserId: number | undefined;
    shiftId: string | undefined;
    onlineTransaction: OnlineTransaction;
    posTransaction: POSTransaction;
    status: InvoiceStatus;
}

export class InvoiceDtoPagedResultDto implements IInvoiceDtoPagedResultDto {
    items: InvoiceDto[] | undefined;
    totalCount: number;

    constructor(data?: IInvoiceDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(InvoiceDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): InvoiceDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): InvoiceDtoPagedResultDto {
        const json = this.toJSON();
        let result = new InvoiceDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IInvoiceDtoPagedResultDto {
    items: InvoiceDto[] | undefined;
    totalCount: number;
}

export class InvoiceDto_V2 implements IInvoiceDto_V2 {
    id: string;
    invoiceNumber: string | undefined;
    source: TransactionSource;
    paymentType: PaymentType;
    entityId: string;
    total: number;
    subTotal: number;
    vatAmount: number;
    operator: string | undefined;
    locations: InvoiceLocationDto[] | undefined;
    creationTime: moment.Moment;
    status: InvoiceStatus;

    constructor(data?: IInvoiceDto_V2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.source = _data["source"];
            this.paymentType = _data["paymentType"];
            this.entityId = _data["entityId"];
            this.total = _data["total"];
            this.subTotal = _data["subTotal"];
            this.vatAmount = _data["vatAmount"];
            this.operator = _data["operator"];
            if (Array.isArray(_data["locations"])) {
                this.locations = [] as any;
                for (let item of _data["locations"])
                    this.locations.push(InvoiceLocationDto.fromJS(item));
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): InvoiceDto_V2 {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceDto_V2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["invoiceNumber"] = this.invoiceNumber;
        data["source"] = this.source;
        data["paymentType"] = this.paymentType;
        data["entityId"] = this.entityId;
        data["total"] = this.total;
        data["subTotal"] = this.subTotal;
        data["vatAmount"] = this.vatAmount;
        data["operator"] = this.operator;
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (let item of this.locations)
                data["locations"].push(item.toJSON());
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["status"] = this.status;
        return data;
    }

    clone(): InvoiceDto_V2 {
        const json = this.toJSON();
        let result = new InvoiceDto_V2();
        result.init(json);
        return result;
    }
}

export interface IInvoiceDto_V2 {
    id: string;
    invoiceNumber: string | undefined;
    source: TransactionSource;
    paymentType: PaymentType;
    entityId: string;
    total: number;
    subTotal: number;
    vatAmount: number;
    operator: string | undefined;
    locations: InvoiceLocationDto[] | undefined;
    creationTime: moment.Moment;
    status: InvoiceStatus;
}

export class InvoiceDto_V2PagedResultDto implements IInvoiceDto_V2PagedResultDto {
    items: InvoiceDto_V2[] | undefined;
    totalCount: number;

    constructor(data?: IInvoiceDto_V2PagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(InvoiceDto_V2.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): InvoiceDto_V2PagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceDto_V2PagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): InvoiceDto_V2PagedResultDto {
        const json = this.toJSON();
        let result = new InvoiceDto_V2PagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IInvoiceDto_V2PagedResultDto {
    items: InvoiceDto_V2[] | undefined;
    totalCount: number;
}

export class InvoiceItemDto implements IInvoiceItemDto {
    id: string;
    identifier: string | undefined;
    identity: number;
    invoiceNumber: string | undefined;

    constructor(data?: IInvoiceItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.identifier = _data["identifier"];
            this.identity = _data["identity"];
            this.invoiceNumber = _data["invoiceNumber"];
        }
    }

    static fromJS(data: any): InvoiceItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["identifier"] = this.identifier;
        data["identity"] = this.identity;
        data["invoiceNumber"] = this.invoiceNumber;
        return data;
    }

    clone(): InvoiceItemDto {
        const json = this.toJSON();
        let result = new InvoiceItemDto();
        result.init(json);
        return result;
    }
}

export interface IInvoiceItemDto {
    id: string;
    identifier: string | undefined;
    identity: number;
    invoiceNumber: string | undefined;
}

export class InvoiceItemUnitCode implements IInvoiceItemUnitCode {
    readonly id: number;
    readonly name: string | undefined;

    constructor(data?: IInvoiceItemUnitCode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).id = _data["id"];
            (<any>this).name = _data["name"];
        }
    }

    static fromJS(data: any): InvoiceItemUnitCode {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceItemUnitCode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): InvoiceItemUnitCode {
        const json = this.toJSON();
        let result = new InvoiceItemUnitCode();
        result.init(json);
        return result;
    }
}

export interface IInvoiceItemUnitCode {
    id: number;
    name: string | undefined;
}

export class InvoiceLocation implements IInvoiceLocation {
    id: string;
    readonly invoiceId: string;
    invoice: Invoice;
    readonly locationId: number;
    readonly locationName: string | undefined;
    readonly slotId: number | undefined;
    readonly slotName: string | undefined;

    constructor(data?: IInvoiceLocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            (<any>this).invoiceId = _data["invoiceId"];
            this.invoice = _data["invoice"] ? Invoice.fromJS(_data["invoice"]) : <any>undefined;
            (<any>this).locationId = _data["locationId"];
            (<any>this).locationName = _data["locationName"];
            (<any>this).slotId = _data["slotId"];
            (<any>this).slotName = _data["slotName"];
        }
    }

    static fromJS(data: any): InvoiceLocation {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceLocation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["invoiceId"] = this.invoiceId;
        data["invoice"] = this.invoice ? this.invoice.toJSON() : <any>undefined;
        data["locationId"] = this.locationId;
        data["locationName"] = this.locationName;
        data["slotId"] = this.slotId;
        data["slotName"] = this.slotName;
        return data;
    }

    clone(): InvoiceLocation {
        const json = this.toJSON();
        let result = new InvoiceLocation();
        result.init(json);
        return result;
    }
}

export interface IInvoiceLocation {
    id: string;
    invoiceId: string;
    invoice: Invoice;
    locationId: number;
    locationName: string | undefined;
    slotId: number | undefined;
    slotName: string | undefined;
}

export class InvoiceLocationDto implements IInvoiceLocationDto {
    id: string;
    locationId: number;
    locationName: string | undefined;
    slotId: number | undefined;
    slotName: string | undefined;

    constructor(data?: IInvoiceLocationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.locationId = _data["locationId"];
            this.locationName = _data["locationName"];
            this.slotId = _data["slotId"];
            this.slotName = _data["slotName"];
        }
    }

    static fromJS(data: any): InvoiceLocationDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceLocationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["locationId"] = this.locationId;
        data["locationName"] = this.locationName;
        data["slotId"] = this.slotId;
        data["slotName"] = this.slotName;
        return data;
    }

    clone(): InvoiceLocationDto {
        const json = this.toJSON();
        let result = new InvoiceLocationDto();
        result.init(json);
        return result;
    }
}

export interface IInvoiceLocationDto {
    id: string;
    locationId: number;
    locationName: string | undefined;
    slotId: number | undefined;
    slotName: string | undefined;
}

export class InvoiceReport implements IInvoiceReport {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    parkingInvoice: ParkingInvoice;
    readonly parkingInvoiceId: string;
    readonly signedXML: string | undefined;
    readonly qrCode: string | undefined;
    invoiceType: EInvoiceType;
    reportStatus: ReportStatus;
    readonly failureResponse: string | undefined;

    constructor(data?: IInvoiceReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.parkingInvoice = _data["parkingInvoice"] ? ParkingInvoice.fromJS(_data["parkingInvoice"]) : <any>undefined;
            (<any>this).parkingInvoiceId = _data["parkingInvoiceId"];
            (<any>this).signedXML = _data["signedXML"];
            (<any>this).qrCode = _data["qrCode"];
            this.invoiceType = _data["invoiceType"] ? EInvoiceType.fromJS(_data["invoiceType"]) : <any>undefined;
            this.reportStatus = _data["reportStatus"] ? ReportStatus.fromJS(_data["reportStatus"]) : <any>undefined;
            (<any>this).failureResponse = _data["failureResponse"];
        }
    }

    static fromJS(data: any): InvoiceReport {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["parkingInvoice"] = this.parkingInvoice ? this.parkingInvoice.toJSON() : <any>undefined;
        data["parkingInvoiceId"] = this.parkingInvoiceId;
        data["signedXML"] = this.signedXML;
        data["qrCode"] = this.qrCode;
        data["invoiceType"] = this.invoiceType ? this.invoiceType.toJSON() : <any>undefined;
        data["reportStatus"] = this.reportStatus ? this.reportStatus.toJSON() : <any>undefined;
        data["failureResponse"] = this.failureResponse;
        return data;
    }

    clone(): InvoiceReport {
        const json = this.toJSON();
        let result = new InvoiceReport();
        result.init(json);
        return result;
    }
}

export interface IInvoiceReport {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    parkingInvoice: ParkingInvoice;
    parkingInvoiceId: string;
    signedXML: string | undefined;
    qrCode: string | undefined;
    invoiceType: EInvoiceType;
    reportStatus: ReportStatus;
    failureResponse: string | undefined;
}

export class InvoiceReportDto implements IInvoiceReportDto {
    totalInvoicesCount: number;
    totalInvoicesAmount: number;
    totalCashInvoicesCount: number;
    totalCashInvoicesAmount: number;
    totalPOSInvoicesCount: number;
    totalPOSInvoicesAmount: number;
    totalReservationsCount: number;
    totalReservationsAmount: number;
    totalViolationCount: number;
    totalViolationAmount: number;
    totalCashReservationsCount: number;
    totalCashReservationsAmount: number;
    totalPOSReservationsCount: number;
    totalPOSReservationsAmount: number;
    totalCashViolationsCount: number;
    totalCashViolationsAmount: number;
    totalPOSViolationsCount: number;
    totalPOSViolationsAmount: number;
    totalOnlineInvoicesCount: number;
    totalOnlineInvoicesAmount: number;
    totalOnlineReservationsCount: number;
    totalOnlineReservationsAmount: number;
    totalOnlineViolationsCount: number;
    totalOnlineViolationsAmount: number;
    totalInOutReservationsCount: number;
    totalInOutReservationsAmount: number;
    totalLostInOutReservationTicketsCount: number;
    totalLostInOutReservationTicketsAmount: number;

    constructor(data?: IInvoiceReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalInvoicesCount = _data["totalInvoicesCount"];
            this.totalInvoicesAmount = _data["totalInvoicesAmount"];
            this.totalCashInvoicesCount = _data["totalCashInvoicesCount"];
            this.totalCashInvoicesAmount = _data["totalCashInvoicesAmount"];
            this.totalPOSInvoicesCount = _data["totalPOSInvoicesCount"];
            this.totalPOSInvoicesAmount = _data["totalPOSInvoicesAmount"];
            this.totalReservationsCount = _data["totalReservationsCount"];
            this.totalReservationsAmount = _data["totalReservationsAmount"];
            this.totalViolationCount = _data["totalViolationCount"];
            this.totalViolationAmount = _data["totalViolationAmount"];
            this.totalCashReservationsCount = _data["totalCashReservationsCount"];
            this.totalCashReservationsAmount = _data["totalCashReservationsAmount"];
            this.totalPOSReservationsCount = _data["totalPOSReservationsCount"];
            this.totalPOSReservationsAmount = _data["totalPOSReservationsAmount"];
            this.totalCashViolationsCount = _data["totalCashViolationsCount"];
            this.totalCashViolationsAmount = _data["totalCashViolationsAmount"];
            this.totalPOSViolationsCount = _data["totalPOSViolationsCount"];
            this.totalPOSViolationsAmount = _data["totalPOSViolationsAmount"];
            this.totalOnlineInvoicesCount = _data["totalOnlineInvoicesCount"];
            this.totalOnlineInvoicesAmount = _data["totalOnlineInvoicesAmount"];
            this.totalOnlineReservationsCount = _data["totalOnlineReservationsCount"];
            this.totalOnlineReservationsAmount = _data["totalOnlineReservationsAmount"];
            this.totalOnlineViolationsCount = _data["totalOnlineViolationsCount"];
            this.totalOnlineViolationsAmount = _data["totalOnlineViolationsAmount"];
            this.totalInOutReservationsCount = _data["totalInOutReservationsCount"];
            this.totalInOutReservationsAmount = _data["totalInOutReservationsAmount"];
            this.totalLostInOutReservationTicketsCount = _data["totalLostInOutReservationTicketsCount"];
            this.totalLostInOutReservationTicketsAmount = _data["totalLostInOutReservationTicketsAmount"];
        }
    }

    static fromJS(data: any): InvoiceReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalInvoicesCount"] = this.totalInvoicesCount;
        data["totalInvoicesAmount"] = this.totalInvoicesAmount;
        data["totalCashInvoicesCount"] = this.totalCashInvoicesCount;
        data["totalCashInvoicesAmount"] = this.totalCashInvoicesAmount;
        data["totalPOSInvoicesCount"] = this.totalPOSInvoicesCount;
        data["totalPOSInvoicesAmount"] = this.totalPOSInvoicesAmount;
        data["totalReservationsCount"] = this.totalReservationsCount;
        data["totalReservationsAmount"] = this.totalReservationsAmount;
        data["totalViolationCount"] = this.totalViolationCount;
        data["totalViolationAmount"] = this.totalViolationAmount;
        data["totalCashReservationsCount"] = this.totalCashReservationsCount;
        data["totalCashReservationsAmount"] = this.totalCashReservationsAmount;
        data["totalPOSReservationsCount"] = this.totalPOSReservationsCount;
        data["totalPOSReservationsAmount"] = this.totalPOSReservationsAmount;
        data["totalCashViolationsCount"] = this.totalCashViolationsCount;
        data["totalCashViolationsAmount"] = this.totalCashViolationsAmount;
        data["totalPOSViolationsCount"] = this.totalPOSViolationsCount;
        data["totalPOSViolationsAmount"] = this.totalPOSViolationsAmount;
        data["totalOnlineInvoicesCount"] = this.totalOnlineInvoicesCount;
        data["totalOnlineInvoicesAmount"] = this.totalOnlineInvoicesAmount;
        data["totalOnlineReservationsCount"] = this.totalOnlineReservationsCount;
        data["totalOnlineReservationsAmount"] = this.totalOnlineReservationsAmount;
        data["totalOnlineViolationsCount"] = this.totalOnlineViolationsCount;
        data["totalOnlineViolationsAmount"] = this.totalOnlineViolationsAmount;
        data["totalInOutReservationsCount"] = this.totalInOutReservationsCount;
        data["totalInOutReservationsAmount"] = this.totalInOutReservationsAmount;
        data["totalLostInOutReservationTicketsCount"] = this.totalLostInOutReservationTicketsCount;
        data["totalLostInOutReservationTicketsAmount"] = this.totalLostInOutReservationTicketsAmount;
        return data;
    }

    clone(): InvoiceReportDto {
        const json = this.toJSON();
        let result = new InvoiceReportDto();
        result.init(json);
        return result;
    }
}

export interface IInvoiceReportDto {
    totalInvoicesCount: number;
    totalInvoicesAmount: number;
    totalCashInvoicesCount: number;
    totalCashInvoicesAmount: number;
    totalPOSInvoicesCount: number;
    totalPOSInvoicesAmount: number;
    totalReservationsCount: number;
    totalReservationsAmount: number;
    totalViolationCount: number;
    totalViolationAmount: number;
    totalCashReservationsCount: number;
    totalCashReservationsAmount: number;
    totalPOSReservationsCount: number;
    totalPOSReservationsAmount: number;
    totalCashViolationsCount: number;
    totalCashViolationsAmount: number;
    totalPOSViolationsCount: number;
    totalPOSViolationsAmount: number;
    totalOnlineInvoicesCount: number;
    totalOnlineInvoicesAmount: number;
    totalOnlineReservationsCount: number;
    totalOnlineReservationsAmount: number;
    totalOnlineViolationsCount: number;
    totalOnlineViolationsAmount: number;
    totalInOutReservationsCount: number;
    totalInOutReservationsAmount: number;
    totalLostInOutReservationTicketsCount: number;
    totalLostInOutReservationTicketsAmount: number;
}

export class InvoiceReportResponse implements IInvoiceReportResponse {
    id: string;
    reportStatus: string | undefined;
    invoiceType: string | undefined;
    qrCode: string | undefined;
    failureResponse: string | undefined;
    creationTime: moment.Moment;

    constructor(data?: IInvoiceReportResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.reportStatus = _data["reportStatus"];
            this.invoiceType = _data["invoiceType"];
            this.qrCode = _data["qrCode"];
            this.failureResponse = _data["failureResponse"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): InvoiceReportResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceReportResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["reportStatus"] = this.reportStatus;
        data["invoiceType"] = this.invoiceType;
        data["qrCode"] = this.qrCode;
        data["failureResponse"] = this.failureResponse;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): InvoiceReportResponse {
        const json = this.toJSON();
        let result = new InvoiceReportResponse();
        result.init(json);
        return result;
    }
}

export interface IInvoiceReportResponse {
    id: string;
    reportStatus: string | undefined;
    invoiceType: string | undefined;
    qrCode: string | undefined;
    failureResponse: string | undefined;
    creationTime: moment.Moment;
}

export enum InvoiceStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class InvoicesStatisticsOutput implements IInvoicesStatisticsOutput {
    totalInvoicesCount: number;
    totalInvoiceAmount: number;
    cashTransactionsAmount: number;
    cashTransactionsCount: number;
    onlineTransactionAmount: number;
    onlineTransactionCount: number;
    posTransactionAmount: number;
    posTransactionCount: number;
    bankTransferTransactionAmount: number;
    bankTransferTransactionCount: number;
    totalReservationsCount: number;
    totalReservationsAmount: number;
    reservationsCashTransactionsAmount: number;
    reservationsCashTransactionsCount: number;
    reservationsOnlineTransactionAmount: number;
    reservationsOnlineTransactionCount: number;
    reservationsPOSTransactionAmount: number;
    reservationsPOSTransactionCount: number;
    reservationsBankTransferTransactionAmount: number;
    reservationsBankTransferTransactionCount: number;
    totalViolationsCount: number;
    totalViolationsAmount: number;
    violationsCashTransactionsAmount: number;
    violationsCashTransactionsCount: number;
    violationsOnlineTransactionAmount: number;
    violationsOnlineTransactionCount: number;
    violationsPOSTransactionAmount: number;
    violationsPOSTransactionCount: number;
    violationsBankTransferTransactionAmount: number;
    violationsBankTransferTransactionCount: number;
    totalInOutReservationsCount: number;
    totalInOutReservationsAmount: number;
    inOutReservationsCashTransactionsAmount: number;
    inOutReservationsCashTransactionsCount: number;
    inOutReservationsOnlineTransactionAmount: number;
    inOutReservationsOnlineTransactionCount: number;
    inOutReservationsPOSTransactionAmount: number;
    inOutReservationsPOSTransactionCount: number;
    inOutReservationsBankTransferTransactionAmount: number;
    inOutReservationsBankTransferTransactionCount: number;
    totalLostTicketCount: number;
    totalLostTicketAmount: number;
    lostTicketCashTransactionsAmount: number;
    lostTicketCashTransactionsCount: number;
    lostTicketOnlineTransactionAmount: number;
    lostTicketOnlineTransactionCount: number;
    lostTicketPOSTransactionAmount: number;
    lostTicketPOSTransactionCount: number;
    lostTicketBankTransferTransactionAmount: number;
    lostTicketBankTransferTransactionCount: number;
    totalManualIncomeCount: number;
    totalManualIncomeAmount: number;
    manualIncomeCashTransactionsAmount: number;
    manualIncomeCashTransactionsCount: number;
    manualIncomeOnlineTransactionAmount: number;
    manualIncomeOnlineTransactionCount: number;
    manualIncomePOSTransactionAmount: number;
    manualIncomePOSTransactionCount: number;
    manualIncomeBankTransferTransactionAmount: number;
    manualIncomeBankTransferTransactionCount: number;
    totalSubscriptionsCount: number;
    totalSubscriptionsAmount: number;
    subscriptionsCashTransactionsAmount: number;
    subscriptionsCashTransactionsCount: number;
    subscriptionsOnlineTransactionAmount: number;
    subscriptionsOnlineTransactionCount: number;
    subscriptionsPOSTransactionAmount: number;
    subscriptionsPOSTransactionCount: number;
    subscriptionsBankTransferTransactionAmount: number;
    subscriptionsBankTransferTransactionCount: number;

    constructor(data?: IInvoicesStatisticsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalInvoicesCount = _data["totalInvoicesCount"];
            this.totalInvoiceAmount = _data["totalInvoiceAmount"];
            this.cashTransactionsAmount = _data["cashTransactionsAmount"];
            this.cashTransactionsCount = _data["cashTransactionsCount"];
            this.onlineTransactionAmount = _data["onlineTransactionAmount"];
            this.onlineTransactionCount = _data["onlineTransactionCount"];
            this.posTransactionAmount = _data["posTransactionAmount"];
            this.posTransactionCount = _data["posTransactionCount"];
            this.bankTransferTransactionAmount = _data["bankTransferTransactionAmount"];
            this.bankTransferTransactionCount = _data["bankTransferTransactionCount"];
            this.totalReservationsCount = _data["totalReservationsCount"];
            this.totalReservationsAmount = _data["totalReservationsAmount"];
            this.reservationsCashTransactionsAmount = _data["reservationsCashTransactionsAmount"];
            this.reservationsCashTransactionsCount = _data["reservationsCashTransactionsCount"];
            this.reservationsOnlineTransactionAmount = _data["reservationsOnlineTransactionAmount"];
            this.reservationsOnlineTransactionCount = _data["reservationsOnlineTransactionCount"];
            this.reservationsPOSTransactionAmount = _data["reservationsPOSTransactionAmount"];
            this.reservationsPOSTransactionCount = _data["reservationsPOSTransactionCount"];
            this.reservationsBankTransferTransactionAmount = _data["reservationsBankTransferTransactionAmount"];
            this.reservationsBankTransferTransactionCount = _data["reservationsBankTransferTransactionCount"];
            this.totalViolationsCount = _data["totalViolationsCount"];
            this.totalViolationsAmount = _data["totalViolationsAmount"];
            this.violationsCashTransactionsAmount = _data["violationsCashTransactionsAmount"];
            this.violationsCashTransactionsCount = _data["violationsCashTransactionsCount"];
            this.violationsOnlineTransactionAmount = _data["violationsOnlineTransactionAmount"];
            this.violationsOnlineTransactionCount = _data["violationsOnlineTransactionCount"];
            this.violationsPOSTransactionAmount = _data["violationsPOSTransactionAmount"];
            this.violationsPOSTransactionCount = _data["violationsPOSTransactionCount"];
            this.violationsBankTransferTransactionAmount = _data["violationsBankTransferTransactionAmount"];
            this.violationsBankTransferTransactionCount = _data["violationsBankTransferTransactionCount"];
            this.totalInOutReservationsCount = _data["totalInOutReservationsCount"];
            this.totalInOutReservationsAmount = _data["totalInOutReservationsAmount"];
            this.inOutReservationsCashTransactionsAmount = _data["inOutReservationsCashTransactionsAmount"];
            this.inOutReservationsCashTransactionsCount = _data["inOutReservationsCashTransactionsCount"];
            this.inOutReservationsOnlineTransactionAmount = _data["inOutReservationsOnlineTransactionAmount"];
            this.inOutReservationsOnlineTransactionCount = _data["inOutReservationsOnlineTransactionCount"];
            this.inOutReservationsPOSTransactionAmount = _data["inOutReservationsPOSTransactionAmount"];
            this.inOutReservationsPOSTransactionCount = _data["inOutReservationsPOSTransactionCount"];
            this.inOutReservationsBankTransferTransactionAmount = _data["inOutReservationsBankTransferTransactionAmount"];
            this.inOutReservationsBankTransferTransactionCount = _data["inOutReservationsBankTransferTransactionCount"];
            this.totalLostTicketCount = _data["totalLostTicketCount"];
            this.totalLostTicketAmount = _data["totalLostTicketAmount"];
            this.lostTicketCashTransactionsAmount = _data["lostTicketCashTransactionsAmount"];
            this.lostTicketCashTransactionsCount = _data["lostTicketCashTransactionsCount"];
            this.lostTicketOnlineTransactionAmount = _data["lostTicketOnlineTransactionAmount"];
            this.lostTicketOnlineTransactionCount = _data["lostTicketOnlineTransactionCount"];
            this.lostTicketPOSTransactionAmount = _data["lostTicketPOSTransactionAmount"];
            this.lostTicketPOSTransactionCount = _data["lostTicketPOSTransactionCount"];
            this.lostTicketBankTransferTransactionAmount = _data["lostTicketBankTransferTransactionAmount"];
            this.lostTicketBankTransferTransactionCount = _data["lostTicketBankTransferTransactionCount"];
            this.totalManualIncomeCount = _data["totalManualIncomeCount"];
            this.totalManualIncomeAmount = _data["totalManualIncomeAmount"];
            this.manualIncomeCashTransactionsAmount = _data["manualIncomeCashTransactionsAmount"];
            this.manualIncomeCashTransactionsCount = _data["manualIncomeCashTransactionsCount"];
            this.manualIncomeOnlineTransactionAmount = _data["manualIncomeOnlineTransactionAmount"];
            this.manualIncomeOnlineTransactionCount = _data["manualIncomeOnlineTransactionCount"];
            this.manualIncomePOSTransactionAmount = _data["manualIncomePOSTransactionAmount"];
            this.manualIncomePOSTransactionCount = _data["manualIncomePOSTransactionCount"];
            this.manualIncomeBankTransferTransactionAmount = _data["manualIncomeBankTransferTransactionAmount"];
            this.manualIncomeBankTransferTransactionCount = _data["manualIncomeBankTransferTransactionCount"];
            this.totalSubscriptionsCount = _data["totalSubscriptionsCount"];
            this.totalSubscriptionsAmount = _data["totalSubscriptionsAmount"];
            this.subscriptionsCashTransactionsAmount = _data["subscriptionsCashTransactionsAmount"];
            this.subscriptionsCashTransactionsCount = _data["subscriptionsCashTransactionsCount"];
            this.subscriptionsOnlineTransactionAmount = _data["subscriptionsOnlineTransactionAmount"];
            this.subscriptionsOnlineTransactionCount = _data["subscriptionsOnlineTransactionCount"];
            this.subscriptionsPOSTransactionAmount = _data["subscriptionsPOSTransactionAmount"];
            this.subscriptionsPOSTransactionCount = _data["subscriptionsPOSTransactionCount"];
            this.subscriptionsBankTransferTransactionAmount = _data["subscriptionsBankTransferTransactionAmount"];
            this.subscriptionsBankTransferTransactionCount = _data["subscriptionsBankTransferTransactionCount"];
        }
    }

    static fromJS(data: any): InvoicesStatisticsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new InvoicesStatisticsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalInvoicesCount"] = this.totalInvoicesCount;
        data["totalInvoiceAmount"] = this.totalInvoiceAmount;
        data["cashTransactionsAmount"] = this.cashTransactionsAmount;
        data["cashTransactionsCount"] = this.cashTransactionsCount;
        data["onlineTransactionAmount"] = this.onlineTransactionAmount;
        data["onlineTransactionCount"] = this.onlineTransactionCount;
        data["posTransactionAmount"] = this.posTransactionAmount;
        data["posTransactionCount"] = this.posTransactionCount;
        data["bankTransferTransactionAmount"] = this.bankTransferTransactionAmount;
        data["bankTransferTransactionCount"] = this.bankTransferTransactionCount;
        data["totalReservationsCount"] = this.totalReservationsCount;
        data["totalReservationsAmount"] = this.totalReservationsAmount;
        data["reservationsCashTransactionsAmount"] = this.reservationsCashTransactionsAmount;
        data["reservationsCashTransactionsCount"] = this.reservationsCashTransactionsCount;
        data["reservationsOnlineTransactionAmount"] = this.reservationsOnlineTransactionAmount;
        data["reservationsOnlineTransactionCount"] = this.reservationsOnlineTransactionCount;
        data["reservationsPOSTransactionAmount"] = this.reservationsPOSTransactionAmount;
        data["reservationsPOSTransactionCount"] = this.reservationsPOSTransactionCount;
        data["reservationsBankTransferTransactionAmount"] = this.reservationsBankTransferTransactionAmount;
        data["reservationsBankTransferTransactionCount"] = this.reservationsBankTransferTransactionCount;
        data["totalViolationsCount"] = this.totalViolationsCount;
        data["totalViolationsAmount"] = this.totalViolationsAmount;
        data["violationsCashTransactionsAmount"] = this.violationsCashTransactionsAmount;
        data["violationsCashTransactionsCount"] = this.violationsCashTransactionsCount;
        data["violationsOnlineTransactionAmount"] = this.violationsOnlineTransactionAmount;
        data["violationsOnlineTransactionCount"] = this.violationsOnlineTransactionCount;
        data["violationsPOSTransactionAmount"] = this.violationsPOSTransactionAmount;
        data["violationsPOSTransactionCount"] = this.violationsPOSTransactionCount;
        data["violationsBankTransferTransactionAmount"] = this.violationsBankTransferTransactionAmount;
        data["violationsBankTransferTransactionCount"] = this.violationsBankTransferTransactionCount;
        data["totalInOutReservationsCount"] = this.totalInOutReservationsCount;
        data["totalInOutReservationsAmount"] = this.totalInOutReservationsAmount;
        data["inOutReservationsCashTransactionsAmount"] = this.inOutReservationsCashTransactionsAmount;
        data["inOutReservationsCashTransactionsCount"] = this.inOutReservationsCashTransactionsCount;
        data["inOutReservationsOnlineTransactionAmount"] = this.inOutReservationsOnlineTransactionAmount;
        data["inOutReservationsOnlineTransactionCount"] = this.inOutReservationsOnlineTransactionCount;
        data["inOutReservationsPOSTransactionAmount"] = this.inOutReservationsPOSTransactionAmount;
        data["inOutReservationsPOSTransactionCount"] = this.inOutReservationsPOSTransactionCount;
        data["inOutReservationsBankTransferTransactionAmount"] = this.inOutReservationsBankTransferTransactionAmount;
        data["inOutReservationsBankTransferTransactionCount"] = this.inOutReservationsBankTransferTransactionCount;
        data["totalLostTicketCount"] = this.totalLostTicketCount;
        data["totalLostTicketAmount"] = this.totalLostTicketAmount;
        data["lostTicketCashTransactionsAmount"] = this.lostTicketCashTransactionsAmount;
        data["lostTicketCashTransactionsCount"] = this.lostTicketCashTransactionsCount;
        data["lostTicketOnlineTransactionAmount"] = this.lostTicketOnlineTransactionAmount;
        data["lostTicketOnlineTransactionCount"] = this.lostTicketOnlineTransactionCount;
        data["lostTicketPOSTransactionAmount"] = this.lostTicketPOSTransactionAmount;
        data["lostTicketPOSTransactionCount"] = this.lostTicketPOSTransactionCount;
        data["lostTicketBankTransferTransactionAmount"] = this.lostTicketBankTransferTransactionAmount;
        data["lostTicketBankTransferTransactionCount"] = this.lostTicketBankTransferTransactionCount;
        data["totalManualIncomeCount"] = this.totalManualIncomeCount;
        data["totalManualIncomeAmount"] = this.totalManualIncomeAmount;
        data["manualIncomeCashTransactionsAmount"] = this.manualIncomeCashTransactionsAmount;
        data["manualIncomeCashTransactionsCount"] = this.manualIncomeCashTransactionsCount;
        data["manualIncomeOnlineTransactionAmount"] = this.manualIncomeOnlineTransactionAmount;
        data["manualIncomeOnlineTransactionCount"] = this.manualIncomeOnlineTransactionCount;
        data["manualIncomePOSTransactionAmount"] = this.manualIncomePOSTransactionAmount;
        data["manualIncomePOSTransactionCount"] = this.manualIncomePOSTransactionCount;
        data["manualIncomeBankTransferTransactionAmount"] = this.manualIncomeBankTransferTransactionAmount;
        data["manualIncomeBankTransferTransactionCount"] = this.manualIncomeBankTransferTransactionCount;
        data["totalSubscriptionsCount"] = this.totalSubscriptionsCount;
        data["totalSubscriptionsAmount"] = this.totalSubscriptionsAmount;
        data["subscriptionsCashTransactionsAmount"] = this.subscriptionsCashTransactionsAmount;
        data["subscriptionsCashTransactionsCount"] = this.subscriptionsCashTransactionsCount;
        data["subscriptionsOnlineTransactionAmount"] = this.subscriptionsOnlineTransactionAmount;
        data["subscriptionsOnlineTransactionCount"] = this.subscriptionsOnlineTransactionCount;
        data["subscriptionsPOSTransactionAmount"] = this.subscriptionsPOSTransactionAmount;
        data["subscriptionsPOSTransactionCount"] = this.subscriptionsPOSTransactionCount;
        data["subscriptionsBankTransferTransactionAmount"] = this.subscriptionsBankTransferTransactionAmount;
        data["subscriptionsBankTransferTransactionCount"] = this.subscriptionsBankTransferTransactionCount;
        return data;
    }

    clone(): InvoicesStatisticsOutput {
        const json = this.toJSON();
        let result = new InvoicesStatisticsOutput();
        result.init(json);
        return result;
    }
}

export interface IInvoicesStatisticsOutput {
    totalInvoicesCount: number;
    totalInvoiceAmount: number;
    cashTransactionsAmount: number;
    cashTransactionsCount: number;
    onlineTransactionAmount: number;
    onlineTransactionCount: number;
    posTransactionAmount: number;
    posTransactionCount: number;
    bankTransferTransactionAmount: number;
    bankTransferTransactionCount: number;
    totalReservationsCount: number;
    totalReservationsAmount: number;
    reservationsCashTransactionsAmount: number;
    reservationsCashTransactionsCount: number;
    reservationsOnlineTransactionAmount: number;
    reservationsOnlineTransactionCount: number;
    reservationsPOSTransactionAmount: number;
    reservationsPOSTransactionCount: number;
    reservationsBankTransferTransactionAmount: number;
    reservationsBankTransferTransactionCount: number;
    totalViolationsCount: number;
    totalViolationsAmount: number;
    violationsCashTransactionsAmount: number;
    violationsCashTransactionsCount: number;
    violationsOnlineTransactionAmount: number;
    violationsOnlineTransactionCount: number;
    violationsPOSTransactionAmount: number;
    violationsPOSTransactionCount: number;
    violationsBankTransferTransactionAmount: number;
    violationsBankTransferTransactionCount: number;
    totalInOutReservationsCount: number;
    totalInOutReservationsAmount: number;
    inOutReservationsCashTransactionsAmount: number;
    inOutReservationsCashTransactionsCount: number;
    inOutReservationsOnlineTransactionAmount: number;
    inOutReservationsOnlineTransactionCount: number;
    inOutReservationsPOSTransactionAmount: number;
    inOutReservationsPOSTransactionCount: number;
    inOutReservationsBankTransferTransactionAmount: number;
    inOutReservationsBankTransferTransactionCount: number;
    totalLostTicketCount: number;
    totalLostTicketAmount: number;
    lostTicketCashTransactionsAmount: number;
    lostTicketCashTransactionsCount: number;
    lostTicketOnlineTransactionAmount: number;
    lostTicketOnlineTransactionCount: number;
    lostTicketPOSTransactionAmount: number;
    lostTicketPOSTransactionCount: number;
    lostTicketBankTransferTransactionAmount: number;
    lostTicketBankTransferTransactionCount: number;
    totalManualIncomeCount: number;
    totalManualIncomeAmount: number;
    manualIncomeCashTransactionsAmount: number;
    manualIncomeCashTransactionsCount: number;
    manualIncomeOnlineTransactionAmount: number;
    manualIncomeOnlineTransactionCount: number;
    manualIncomePOSTransactionAmount: number;
    manualIncomePOSTransactionCount: number;
    manualIncomeBankTransferTransactionAmount: number;
    manualIncomeBankTransferTransactionCount: number;
    totalSubscriptionsCount: number;
    totalSubscriptionsAmount: number;
    subscriptionsCashTransactionsAmount: number;
    subscriptionsCashTransactionsCount: number;
    subscriptionsOnlineTransactionAmount: number;
    subscriptionsOnlineTransactionCount: number;
    subscriptionsPOSTransactionAmount: number;
    subscriptionsPOSTransactionCount: number;
    subscriptionsBankTransferTransactionAmount: number;
    subscriptionsBankTransferTransactionCount: number;
}

export class IsTenantAvailableInput implements IIsTenantAvailableInput {
    tenancyName: string;

    constructor(data?: IIsTenantAvailableInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
        }
    }

    static fromJS(data: any): IsTenantAvailableInput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        return data;
    }

    clone(): IsTenantAvailableInput {
        const json = this.toJSON();
        let result = new IsTenantAvailableInput();
        result.init(json);
        return result;
    }
}

export interface IIsTenantAvailableInput {
    tenancyName: string;
}

export class IsTenantAvailableOutput implements IIsTenantAvailableOutput {
    state: TenantAvailabilityState;
    tenantId: number | undefined;

    constructor(data?: IIsTenantAvailableOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): IsTenantAvailableOutput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["tenantId"] = this.tenantId;
        return data;
    }

    clone(): IsTenantAvailableOutput {
        const json = this.toJSON();
        let result = new IsTenantAvailableOutput();
        result.init(json);
        return result;
    }
}

export interface IIsTenantAvailableOutput {
    state: TenantAvailabilityState;
    tenantId: number | undefined;
}

export class Location implements ILocation {
    id: number;
    readonly domainEvents: IEventData[] | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creatorUser: User;
    lastModifierUser: User;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    name: string | undefined;
    priceId: number;
    price: Price;
    locationPoint: Point;
    districtId: number;
    district: District;
    readonly sendInvoiceSMS: boolean;
    readonly sendRenewSMS: boolean;
    inOutReservationEnabled: boolean;
    inOutReservationPricingId: number | undefined;
    isDefault: boolean;
    allowanceTime: number | undefined;
    inOutReservationPricing: InOutReservationPricing;
    readonly slots: Slot[] | undefined;
    readonly qrCodes: QRCode[] | undefined;
    impoundAllowanceDays: number | undefined;
    readonly locationStaffAccounts: LocationStaffAccount[] | undefined;
    readonly staffAccounts: StaffAccount[] | undefined;
    readonly locationViolationTypePrices: LocationViolationTypePrice[] | undefined;
    isActive: boolean;
    subscriptions: Subscription[] | undefined;
    locationStaffGroups: LocationStaffGroup[] | undefined;
    readonly lostInOutReservationTickets: LostInOutReservationTicket[] | undefined;

    constructor(data?: ILocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["domainEvents"])) {
                (<any>this).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (<any>this).domainEvents.push(IEventData.fromJS(item));
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.priceId = _data["priceId"];
            this.price = _data["price"] ? Price.fromJS(_data["price"]) : <any>undefined;
            this.locationPoint = _data["locationPoint"] ? Point.fromJS(_data["locationPoint"]) : <any>undefined;
            this.districtId = _data["districtId"];
            this.district = _data["district"] ? District.fromJS(_data["district"]) : <any>undefined;
            (<any>this).sendInvoiceSMS = _data["sendInvoiceSMS"];
            (<any>this).sendRenewSMS = _data["sendRenewSMS"];
            this.inOutReservationEnabled = _data["inOutReservationEnabled"];
            this.inOutReservationPricingId = _data["inOutReservationPricingId"];
            this.isDefault = _data["isDefault"];
            this.allowanceTime = _data["allowanceTime"];
            this.inOutReservationPricing = _data["inOutReservationPricing"] ? InOutReservationPricing.fromJS(_data["inOutReservationPricing"]) : <any>undefined;
            if (Array.isArray(_data["slots"])) {
                (<any>this).slots = [] as any;
                for (let item of _data["slots"])
                    (<any>this).slots.push(Slot.fromJS(item));
            }
            if (Array.isArray(_data["qrCodes"])) {
                (<any>this).qrCodes = [] as any;
                for (let item of _data["qrCodes"])
                    (<any>this).qrCodes.push(QRCode.fromJS(item));
            }
            this.impoundAllowanceDays = _data["impoundAllowanceDays"];
            if (Array.isArray(_data["locationStaffAccounts"])) {
                (<any>this).locationStaffAccounts = [] as any;
                for (let item of _data["locationStaffAccounts"])
                    (<any>this).locationStaffAccounts.push(LocationStaffAccount.fromJS(item));
            }
            if (Array.isArray(_data["staffAccounts"])) {
                (<any>this).staffAccounts = [] as any;
                for (let item of _data["staffAccounts"])
                    (<any>this).staffAccounts.push(StaffAccount.fromJS(item));
            }
            if (Array.isArray(_data["locationViolationTypePrices"])) {
                (<any>this).locationViolationTypePrices = [] as any;
                for (let item of _data["locationViolationTypePrices"])
                    (<any>this).locationViolationTypePrices.push(LocationViolationTypePrice.fromJS(item));
            }
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["subscriptions"])) {
                this.subscriptions = [] as any;
                for (let item of _data["subscriptions"])
                    this.subscriptions.push(Subscription.fromJS(item));
            }
            if (Array.isArray(_data["locationStaffGroups"])) {
                this.locationStaffGroups = [] as any;
                for (let item of _data["locationStaffGroups"])
                    this.locationStaffGroups.push(LocationStaffGroup.fromJS(item));
            }
            if (Array.isArray(_data["lostInOutReservationTickets"])) {
                (<any>this).lostInOutReservationTickets = [] as any;
                for (let item of _data["lostInOutReservationTickets"])
                    (<any>this).lostInOutReservationTickets.push(LostInOutReservationTicket.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Location {
        data = typeof data === 'object' ? data : {};
        let result = new Location();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item.toJSON());
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["priceId"] = this.priceId;
        data["price"] = this.price ? this.price.toJSON() : <any>undefined;
        data["locationPoint"] = this.locationPoint ? this.locationPoint.toJSON() : <any>undefined;
        data["districtId"] = this.districtId;
        data["district"] = this.district ? this.district.toJSON() : <any>undefined;
        data["sendInvoiceSMS"] = this.sendInvoiceSMS;
        data["sendRenewSMS"] = this.sendRenewSMS;
        data["inOutReservationEnabled"] = this.inOutReservationEnabled;
        data["inOutReservationPricingId"] = this.inOutReservationPricingId;
        data["isDefault"] = this.isDefault;
        data["allowanceTime"] = this.allowanceTime;
        data["inOutReservationPricing"] = this.inOutReservationPricing ? this.inOutReservationPricing.toJSON() : <any>undefined;
        if (Array.isArray(this.slots)) {
            data["slots"] = [];
            for (let item of this.slots)
                data["slots"].push(item.toJSON());
        }
        if (Array.isArray(this.qrCodes)) {
            data["qrCodes"] = [];
            for (let item of this.qrCodes)
                data["qrCodes"].push(item.toJSON());
        }
        data["impoundAllowanceDays"] = this.impoundAllowanceDays;
        if (Array.isArray(this.locationStaffAccounts)) {
            data["locationStaffAccounts"] = [];
            for (let item of this.locationStaffAccounts)
                data["locationStaffAccounts"].push(item.toJSON());
        }
        if (Array.isArray(this.staffAccounts)) {
            data["staffAccounts"] = [];
            for (let item of this.staffAccounts)
                data["staffAccounts"].push(item.toJSON());
        }
        if (Array.isArray(this.locationViolationTypePrices)) {
            data["locationViolationTypePrices"] = [];
            for (let item of this.locationViolationTypePrices)
                data["locationViolationTypePrices"].push(item.toJSON());
        }
        data["isActive"] = this.isActive;
        if (Array.isArray(this.subscriptions)) {
            data["subscriptions"] = [];
            for (let item of this.subscriptions)
                data["subscriptions"].push(item.toJSON());
        }
        if (Array.isArray(this.locationStaffGroups)) {
            data["locationStaffGroups"] = [];
            for (let item of this.locationStaffGroups)
                data["locationStaffGroups"].push(item.toJSON());
        }
        if (Array.isArray(this.lostInOutReservationTickets)) {
            data["lostInOutReservationTickets"] = [];
            for (let item of this.lostInOutReservationTickets)
                data["lostInOutReservationTickets"].push(item.toJSON());
        }
        return data;
    }

    clone(): Location {
        const json = this.toJSON();
        let result = new Location();
        result.init(json);
        return result;
    }
}

export interface ILocation {
    id: number;
    domainEvents: IEventData[] | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creatorUser: User;
    lastModifierUser: User;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    name: string | undefined;
    priceId: number;
    price: Price;
    locationPoint: Point;
    districtId: number;
    district: District;
    sendInvoiceSMS: boolean;
    sendRenewSMS: boolean;
    inOutReservationEnabled: boolean;
    inOutReservationPricingId: number | undefined;
    isDefault: boolean;
    allowanceTime: number | undefined;
    inOutReservationPricing: InOutReservationPricing;
    slots: Slot[] | undefined;
    qrCodes: QRCode[] | undefined;
    impoundAllowanceDays: number | undefined;
    locationStaffAccounts: LocationStaffAccount[] | undefined;
    staffAccounts: StaffAccount[] | undefined;
    locationViolationTypePrices: LocationViolationTypePrice[] | undefined;
    isActive: boolean;
    subscriptions: Subscription[] | undefined;
    locationStaffGroups: LocationStaffGroup[] | undefined;
    lostInOutReservationTickets: LostInOutReservationTicket[] | undefined;
}

export class LocationDetailsDto implements ILocationDetailsDto {
    id: number;
    name: string | undefined;
    latitude: number;
    longitude: number;
    priceId: number;
    price: PriceListDto;
    country: CountryDto;
    city: CityDto;
    area: AreaDto;
    district: DistrictDto;
    qrCodes: QRCodeListDto[] | undefined;
    isActive: boolean;
    inOutReservationEnabled: boolean;
    inOutReservationPricing: InOutReservationPricingListDto;

    constructor(data?: ILocationDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.priceId = _data["priceId"];
            this.price = _data["price"] ? PriceListDto.fromJS(_data["price"]) : <any>undefined;
            this.country = _data["country"] ? CountryDto.fromJS(_data["country"]) : <any>undefined;
            this.city = _data["city"] ? CityDto.fromJS(_data["city"]) : <any>undefined;
            this.area = _data["area"] ? AreaDto.fromJS(_data["area"]) : <any>undefined;
            this.district = _data["district"] ? DistrictDto.fromJS(_data["district"]) : <any>undefined;
            if (Array.isArray(_data["qrCodes"])) {
                this.qrCodes = [] as any;
                for (let item of _data["qrCodes"])
                    this.qrCodes.push(QRCodeListDto.fromJS(item));
            }
            this.isActive = _data["isActive"];
            this.inOutReservationEnabled = _data["inOutReservationEnabled"];
            this.inOutReservationPricing = _data["inOutReservationPricing"] ? InOutReservationPricingListDto.fromJS(_data["inOutReservationPricing"]) : <any>undefined;
        }
    }

    static fromJS(data: any): LocationDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocationDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["priceId"] = this.priceId;
        data["price"] = this.price ? this.price.toJSON() : <any>undefined;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        data["city"] = this.city ? this.city.toJSON() : <any>undefined;
        data["area"] = this.area ? this.area.toJSON() : <any>undefined;
        data["district"] = this.district ? this.district.toJSON() : <any>undefined;
        if (Array.isArray(this.qrCodes)) {
            data["qrCodes"] = [];
            for (let item of this.qrCodes)
                data["qrCodes"].push(item.toJSON());
        }
        data["isActive"] = this.isActive;
        data["inOutReservationEnabled"] = this.inOutReservationEnabled;
        data["inOutReservationPricing"] = this.inOutReservationPricing ? this.inOutReservationPricing.toJSON() : <any>undefined;
        return data;
    }

    clone(): LocationDetailsDto {
        const json = this.toJSON();
        let result = new LocationDetailsDto();
        result.init(json);
        return result;
    }
}

export interface ILocationDetailsDto {
    id: number;
    name: string | undefined;
    latitude: number;
    longitude: number;
    priceId: number;
    price: PriceListDto;
    country: CountryDto;
    city: CityDto;
    area: AreaDto;
    district: DistrictDto;
    qrCodes: QRCodeListDto[] | undefined;
    isActive: boolean;
    inOutReservationEnabled: boolean;
    inOutReservationPricing: InOutReservationPricingListDto;
}

export class LocationDto implements ILocationDto {
    id: number;
    name: string | undefined;
    latitude: number;
    longitude: number;
    slotsCount: number;
    price: PriceListDto;
    country: CountryDto;
    city: CityDto;
    area: AreaDto;
    district: DistrictDto;
    isActive: boolean;

    constructor(data?: ILocationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.slotsCount = _data["slotsCount"];
            this.price = _data["price"] ? PriceListDto.fromJS(_data["price"]) : <any>undefined;
            this.country = _data["country"] ? CountryDto.fromJS(_data["country"]) : <any>undefined;
            this.city = _data["city"] ? CityDto.fromJS(_data["city"]) : <any>undefined;
            this.area = _data["area"] ? AreaDto.fromJS(_data["area"]) : <any>undefined;
            this.district = _data["district"] ? DistrictDto.fromJS(_data["district"]) : <any>undefined;
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): LocationDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["slotsCount"] = this.slotsCount;
        data["price"] = this.price ? this.price.toJSON() : <any>undefined;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        data["city"] = this.city ? this.city.toJSON() : <any>undefined;
        data["area"] = this.area ? this.area.toJSON() : <any>undefined;
        data["district"] = this.district ? this.district.toJSON() : <any>undefined;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): LocationDto {
        const json = this.toJSON();
        let result = new LocationDto();
        result.init(json);
        return result;
    }
}

export interface ILocationDto {
    id: number;
    name: string | undefined;
    latitude: number;
    longitude: number;
    slotsCount: number;
    price: PriceListDto;
    country: CountryDto;
    city: CityDto;
    area: AreaDto;
    district: DistrictDto;
    isActive: boolean;
}

export class LocationDtoPagedResultDto implements ILocationDtoPagedResultDto {
    items: LocationDto[] | undefined;
    totalCount: number;

    constructor(data?: ILocationDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(LocationDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): LocationDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocationDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): LocationDtoPagedResultDto {
        const json = this.toJSON();
        let result = new LocationDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ILocationDtoPagedResultDto {
    items: LocationDto[] | undefined;
    totalCount: number;
}

export class LocationItemDto implements ILocationItemDto {
    id: number;
    name: string | undefined;

    constructor(data?: ILocationItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): LocationItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocationItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): LocationItemDto {
        const json = this.toJSON();
        let result = new LocationItemDto();
        result.init(json);
        return result;
    }
}

export interface ILocationItemDto {
    id: number;
    name: string | undefined;
}

export class LocationListDto implements ILocationListDto {
    id: number;
    name: string | undefined;
    latitude: number;
    longitude: number;
    price: PriceListDto;
    isActive: boolean;
    sendInvoiceSMS: boolean;
    sendRenewSMS: boolean;
    inOutReservationEnabled: boolean;
    allowanceTime: number | undefined;
    inOutReservationPricing: InOutReservationPricingListDto;

    constructor(data?: ILocationListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.price = _data["price"] ? PriceListDto.fromJS(_data["price"]) : <any>undefined;
            this.isActive = _data["isActive"];
            this.sendInvoiceSMS = _data["sendInvoiceSMS"];
            this.sendRenewSMS = _data["sendRenewSMS"];
            this.inOutReservationEnabled = _data["inOutReservationEnabled"];
            this.allowanceTime = _data["allowanceTime"];
            this.inOutReservationPricing = _data["inOutReservationPricing"] ? InOutReservationPricingListDto.fromJS(_data["inOutReservationPricing"]) : <any>undefined;
        }
    }

    static fromJS(data: any): LocationListDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocationListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["price"] = this.price ? this.price.toJSON() : <any>undefined;
        data["isActive"] = this.isActive;
        data["sendInvoiceSMS"] = this.sendInvoiceSMS;
        data["sendRenewSMS"] = this.sendRenewSMS;
        data["inOutReservationEnabled"] = this.inOutReservationEnabled;
        data["allowanceTime"] = this.allowanceTime;
        data["inOutReservationPricing"] = this.inOutReservationPricing ? this.inOutReservationPricing.toJSON() : <any>undefined;
        return data;
    }

    clone(): LocationListDto {
        const json = this.toJSON();
        let result = new LocationListDto();
        result.init(json);
        return result;
    }
}

export interface ILocationListDto {
    id: number;
    name: string | undefined;
    latitude: number;
    longitude: number;
    price: PriceListDto;
    isActive: boolean;
    sendInvoiceSMS: boolean;
    sendRenewSMS: boolean;
    inOutReservationEnabled: boolean;
    allowanceTime: number | undefined;
    inOutReservationPricing: InOutReservationPricingListDto;
}

export class LocationListDtoPagedResultDto implements ILocationListDtoPagedResultDto {
    items: LocationListDto[] | undefined;
    totalCount: number;

    constructor(data?: ILocationListDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(LocationListDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): LocationListDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocationListDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): LocationListDtoPagedResultDto {
        const json = this.toJSON();
        let result = new LocationListDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ILocationListDtoPagedResultDto {
    items: LocationListDto[] | undefined;
    totalCount: number;
}

export class LocationLookupDto implements ILocationLookupDto {
    id: number;
    name: string | undefined;

    constructor(data?: ILocationLookupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): LocationLookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocationLookupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): LocationLookupDto {
        const json = this.toJSON();
        let result = new LocationLookupDto();
        result.init(json);
        return result;
    }
}

export interface ILocationLookupDto {
    id: number;
    name: string | undefined;
}

export class LocationLookupDtoPagedResultDto implements ILocationLookupDtoPagedResultDto {
    items: LocationLookupDto[] | undefined;
    totalCount: number;

    constructor(data?: ILocationLookupDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(LocationLookupDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): LocationLookupDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocationLookupDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): LocationLookupDtoPagedResultDto {
        const json = this.toJSON();
        let result = new LocationLookupDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ILocationLookupDtoPagedResultDto {
    items: LocationLookupDto[] | undefined;
    totalCount: number;
}

export class LocationStaffAccount implements ILocationStaffAccount {
    id: string;
    locationId: number;
    location: Location;
    staffAccountId: number;
    staffAccount: StaffAccount;

    constructor(data?: ILocationStaffAccount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.locationId = _data["locationId"];
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : <any>undefined;
            this.staffAccountId = _data["staffAccountId"];
            this.staffAccount = _data["staffAccount"] ? StaffAccount.fromJS(_data["staffAccount"]) : <any>undefined;
        }
    }

    static fromJS(data: any): LocationStaffAccount {
        data = typeof data === 'object' ? data : {};
        let result = new LocationStaffAccount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["locationId"] = this.locationId;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["staffAccountId"] = this.staffAccountId;
        data["staffAccount"] = this.staffAccount ? this.staffAccount.toJSON() : <any>undefined;
        return data;
    }

    clone(): LocationStaffAccount {
        const json = this.toJSON();
        let result = new LocationStaffAccount();
        result.init(json);
        return result;
    }
}

export interface ILocationStaffAccount {
    id: string;
    locationId: number;
    location: Location;
    staffAccountId: number;
    staffAccount: StaffAccount;
}

export class LocationStaffGroup implements ILocationStaffGroup {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    staffGroupId: string;
    staffGroup: StaffGroup;
    locationId: number;
    location: Location;

    constructor(data?: ILocationStaffGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.staffGroupId = _data["staffGroupId"];
            this.staffGroup = _data["staffGroup"] ? StaffGroup.fromJS(_data["staffGroup"]) : <any>undefined;
            this.locationId = _data["locationId"];
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : <any>undefined;
        }
    }

    static fromJS(data: any): LocationStaffGroup {
        data = typeof data === 'object' ? data : {};
        let result = new LocationStaffGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["staffGroupId"] = this.staffGroupId;
        data["staffGroup"] = this.staffGroup ? this.staffGroup.toJSON() : <any>undefined;
        data["locationId"] = this.locationId;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        return data;
    }

    clone(): LocationStaffGroup {
        const json = this.toJSON();
        let result = new LocationStaffGroup();
        result.init(json);
        return result;
    }
}

export interface ILocationStaffGroup {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    staffGroupId: string;
    staffGroup: StaffGroup;
    locationId: number;
    location: Location;
}

export class LocationStaffGroupDto implements ILocationStaffGroupDto {
    staffGroupId: string;
    staffGroup: StaffGroup;
    locationId: number;
    location: Location;

    constructor(data?: ILocationStaffGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.staffGroupId = _data["staffGroupId"];
            this.staffGroup = _data["staffGroup"] ? StaffGroup.fromJS(_data["staffGroup"]) : <any>undefined;
            this.locationId = _data["locationId"];
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : <any>undefined;
        }
    }

    static fromJS(data: any): LocationStaffGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocationStaffGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["staffGroupId"] = this.staffGroupId;
        data["staffGroup"] = this.staffGroup ? this.staffGroup.toJSON() : <any>undefined;
        data["locationId"] = this.locationId;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        return data;
    }

    clone(): LocationStaffGroupDto {
        const json = this.toJSON();
        let result = new LocationStaffGroupDto();
        result.init(json);
        return result;
    }
}

export interface ILocationStaffGroupDto {
    staffGroupId: string;
    staffGroup: StaffGroup;
    locationId: number;
    location: Location;
}

export class LocationStaffGroupDtoPagedResultDto implements ILocationStaffGroupDtoPagedResultDto {
    items: LocationStaffGroupDto[] | undefined;
    totalCount: number;

    constructor(data?: ILocationStaffGroupDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(LocationStaffGroupDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): LocationStaffGroupDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocationStaffGroupDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): LocationStaffGroupDtoPagedResultDto {
        const json = this.toJSON();
        let result = new LocationStaffGroupDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ILocationStaffGroupDtoPagedResultDto {
    items: LocationStaffGroupDto[] | undefined;
    totalCount: number;
}

export class LocationViolationPriceDto implements ILocationViolationPriceDto {
    id: string;
    violationTypeId: string;
    location: LocationLookupDto;
    violationType: ViolationTypeDto;
    price: number;
    vatPercentage: number;
    vatAmount: number;
    subTotal: number;

    constructor(data?: ILocationViolationPriceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.violationTypeId = _data["violationTypeId"];
            this.location = _data["location"] ? LocationLookupDto.fromJS(_data["location"]) : <any>undefined;
            this.violationType = _data["violationType"] ? ViolationTypeDto.fromJS(_data["violationType"]) : <any>undefined;
            this.price = _data["price"];
            this.vatPercentage = _data["vatPercentage"];
            this.vatAmount = _data["vatAmount"];
            this.subTotal = _data["subTotal"];
        }
    }

    static fromJS(data: any): LocationViolationPriceDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocationViolationPriceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["violationTypeId"] = this.violationTypeId;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["violationType"] = this.violationType ? this.violationType.toJSON() : <any>undefined;
        data["price"] = this.price;
        data["vatPercentage"] = this.vatPercentage;
        data["vatAmount"] = this.vatAmount;
        data["subTotal"] = this.subTotal;
        return data;
    }

    clone(): LocationViolationPriceDto {
        const json = this.toJSON();
        let result = new LocationViolationPriceDto();
        result.init(json);
        return result;
    }
}

export interface ILocationViolationPriceDto {
    id: string;
    violationTypeId: string;
    location: LocationLookupDto;
    violationType: ViolationTypeDto;
    price: number;
    vatPercentage: number;
    vatAmount: number;
    subTotal: number;
}

export class LocationViolationPriceDtoPagedResultDto implements ILocationViolationPriceDtoPagedResultDto {
    items: LocationViolationPriceDto[] | undefined;
    totalCount: number;

    constructor(data?: ILocationViolationPriceDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(LocationViolationPriceDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): LocationViolationPriceDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocationViolationPriceDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): LocationViolationPriceDtoPagedResultDto {
        const json = this.toJSON();
        let result = new LocationViolationPriceDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ILocationViolationPriceDtoPagedResultDto {
    items: LocationViolationPriceDto[] | undefined;
    totalCount: number;
}

export class LocationViolationTypePrice implements ILocationViolationTypePrice {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    readonly locationId: number;
    location: Location;
    violationTypeId: string;
    violationType: ViolationType;
    price: number;

    constructor(data?: ILocationViolationTypePrice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            (<any>this).locationId = _data["locationId"];
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : <any>undefined;
            this.violationTypeId = _data["violationTypeId"];
            this.violationType = _data["violationType"] ? ViolationType.fromJS(_data["violationType"]) : <any>undefined;
            this.price = _data["price"];
        }
    }

    static fromJS(data: any): LocationViolationTypePrice {
        data = typeof data === 'object' ? data : {};
        let result = new LocationViolationTypePrice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["locationId"] = this.locationId;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["violationTypeId"] = this.violationTypeId;
        data["violationType"] = this.violationType ? this.violationType.toJSON() : <any>undefined;
        data["price"] = this.price;
        return data;
    }

    clone(): LocationViolationTypePrice {
        const json = this.toJSON();
        let result = new LocationViolationTypePrice();
        result.init(json);
        return result;
    }
}

export interface ILocationViolationTypePrice {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    locationId: number;
    location: Location;
    violationTypeId: string;
    violationType: ViolationType;
    price: number;
}

export class LostInOutReservationTicket implements ILostInOutReservationTicket {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creatorUser: User;
    lastModifierUser: User;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    number: number;
    locationId: number;
    location: Location;
    pricingId: number;
    pricing: InOutReservationPricing;
    staffAccountShiftId: string;
    staffAccountShift: StaffAccountShift;
    readonly vatPercentage: number | undefined;
    readonly invoiceNumber: string | undefined;
    carPlate: CarPlate;

    constructor(data?: ILostInOutReservationTicket) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.number = _data["number"];
            this.locationId = _data["locationId"];
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : <any>undefined;
            this.pricingId = _data["pricingId"];
            this.pricing = _data["pricing"] ? InOutReservationPricing.fromJS(_data["pricing"]) : <any>undefined;
            this.staffAccountShiftId = _data["staffAccountShiftId"];
            this.staffAccountShift = _data["staffAccountShift"] ? StaffAccountShift.fromJS(_data["staffAccountShift"]) : <any>undefined;
            (<any>this).vatPercentage = _data["vatPercentage"];
            (<any>this).invoiceNumber = _data["invoiceNumber"];
            this.carPlate = _data["carPlate"] ? CarPlate.fromJS(_data["carPlate"]) : <any>undefined;
        }
    }

    static fromJS(data: any): LostInOutReservationTicket {
        data = typeof data === 'object' ? data : {};
        let result = new LostInOutReservationTicket();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["number"] = this.number;
        data["locationId"] = this.locationId;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["pricingId"] = this.pricingId;
        data["pricing"] = this.pricing ? this.pricing.toJSON() : <any>undefined;
        data["staffAccountShiftId"] = this.staffAccountShiftId;
        data["staffAccountShift"] = this.staffAccountShift ? this.staffAccountShift.toJSON() : <any>undefined;
        data["vatPercentage"] = this.vatPercentage;
        data["invoiceNumber"] = this.invoiceNumber;
        data["carPlate"] = this.carPlate ? this.carPlate.toJSON() : <any>undefined;
        return data;
    }

    clone(): LostInOutReservationTicket {
        const json = this.toJSON();
        let result = new LostInOutReservationTicket();
        result.init(json);
        return result;
    }
}

export interface ILostInOutReservationTicket {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creatorUser: User;
    lastModifierUser: User;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    number: number;
    locationId: number;
    location: Location;
    pricingId: number;
    pricing: InOutReservationPricing;
    staffAccountShiftId: string;
    staffAccountShift: StaffAccountShift;
    vatPercentage: number | undefined;
    invoiceNumber: string | undefined;
    carPlate: CarPlate;
}

export class LostInOutReservationTicketCreateOrEditDto implements ILostInOutReservationTicketCreateOrEditDto {
    locationId: number;
    paymentType: PaymentType;
    posIdentifier: string | undefined;
    carPlate: CarPlate;

    constructor(data?: ILostInOutReservationTicketCreateOrEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationId = _data["locationId"];
            this.paymentType = _data["paymentType"];
            this.posIdentifier = _data["posIdentifier"];
            this.carPlate = _data["carPlate"] ? CarPlate.fromJS(_data["carPlate"]) : <any>undefined;
        }
    }

    static fromJS(data: any): LostInOutReservationTicketCreateOrEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new LostInOutReservationTicketCreateOrEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId;
        data["paymentType"] = this.paymentType;
        data["posIdentifier"] = this.posIdentifier;
        data["carPlate"] = this.carPlate ? this.carPlate.toJSON() : <any>undefined;
        return data;
    }

    clone(): LostInOutReservationTicketCreateOrEditDto {
        const json = this.toJSON();
        let result = new LostInOutReservationTicketCreateOrEditDto();
        result.init(json);
        return result;
    }
}

export interface ILostInOutReservationTicketCreateOrEditDto {
    locationId: number;
    paymentType: PaymentType;
    posIdentifier: string | undefined;
    carPlate: CarPlate;
}

export class LostInOutReservationTicketListDto implements ILostInOutReservationTicketListDto {
    id: string;
    number: number;
    locationId: number;
    location: string | undefined;
    pricingId: number;
    price: number;
    invoiceNumber: string | undefined;
    creator: string | undefined;
    vatPercentage: number | undefined;
    creationDate: moment.Moment;
    carPlate: CarPlate;

    constructor(data?: ILostInOutReservationTicketListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.number = _data["number"];
            this.locationId = _data["locationId"];
            this.location = _data["location"];
            this.pricingId = _data["pricingId"];
            this.price = _data["price"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.creator = _data["creator"];
            this.vatPercentage = _data["vatPercentage"];
            this.creationDate = _data["creationDate"] ? moment(_data["creationDate"].toString()) : <any>undefined;
            this.carPlate = _data["carPlate"] ? CarPlate.fromJS(_data["carPlate"]) : <any>undefined;
        }
    }

    static fromJS(data: any): LostInOutReservationTicketListDto {
        data = typeof data === 'object' ? data : {};
        let result = new LostInOutReservationTicketListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["number"] = this.number;
        data["locationId"] = this.locationId;
        data["location"] = this.location;
        data["pricingId"] = this.pricingId;
        data["price"] = this.price;
        data["invoiceNumber"] = this.invoiceNumber;
        data["creator"] = this.creator;
        data["vatPercentage"] = this.vatPercentage;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
        data["carPlate"] = this.carPlate ? this.carPlate.toJSON() : <any>undefined;
        return data;
    }

    clone(): LostInOutReservationTicketListDto {
        const json = this.toJSON();
        let result = new LostInOutReservationTicketListDto();
        result.init(json);
        return result;
    }
}

export interface ILostInOutReservationTicketListDto {
    id: string;
    number: number;
    locationId: number;
    location: string | undefined;
    pricingId: number;
    price: number;
    invoiceNumber: string | undefined;
    creator: string | undefined;
    vatPercentage: number | undefined;
    creationDate: moment.Moment;
    carPlate: CarPlate;
}

export class LostInOutReservationTicketListDtoPagedResultDto implements ILostInOutReservationTicketListDtoPagedResultDto {
    items: LostInOutReservationTicketListDto[] | undefined;
    totalCount: number;

    constructor(data?: ILostInOutReservationTicketListDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(LostInOutReservationTicketListDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): LostInOutReservationTicketListDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new LostInOutReservationTicketListDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): LostInOutReservationTicketListDtoPagedResultDto {
        const json = this.toJSON();
        let result = new LostInOutReservationTicketListDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ILostInOutReservationTicketListDtoPagedResultDto {
    items: LostInOutReservationTicketListDto[] | undefined;
    totalCount: number;
}

export class LostInOutReservationTicketViewDto implements ILostInOutReservationTicketViewDto {
    id: string;
    number: number;
    locationId: number;
    location: string | undefined;
    pricingId: number;
    price: number;
    creator: string | undefined;
    vatPercentage: number | undefined;
    creationDate: moment.Moment;
    successTransaction: TransactionDto;
    carPlate: CarPlate;

    constructor(data?: ILostInOutReservationTicketViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.number = _data["number"];
            this.locationId = _data["locationId"];
            this.location = _data["location"];
            this.pricingId = _data["pricingId"];
            this.price = _data["price"];
            this.creator = _data["creator"];
            this.vatPercentage = _data["vatPercentage"];
            this.creationDate = _data["creationDate"] ? moment(_data["creationDate"].toString()) : <any>undefined;
            this.successTransaction = _data["successTransaction"] ? TransactionDto.fromJS(_data["successTransaction"]) : <any>undefined;
            this.carPlate = _data["carPlate"] ? CarPlate.fromJS(_data["carPlate"]) : <any>undefined;
        }
    }

    static fromJS(data: any): LostInOutReservationTicketViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new LostInOutReservationTicketViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["number"] = this.number;
        data["locationId"] = this.locationId;
        data["location"] = this.location;
        data["pricingId"] = this.pricingId;
        data["price"] = this.price;
        data["creator"] = this.creator;
        data["vatPercentage"] = this.vatPercentage;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
        data["successTransaction"] = this.successTransaction ? this.successTransaction.toJSON() : <any>undefined;
        data["carPlate"] = this.carPlate ? this.carPlate.toJSON() : <any>undefined;
        return data;
    }

    clone(): LostInOutReservationTicketViewDto {
        const json = this.toJSON();
        let result = new LostInOutReservationTicketViewDto();
        result.init(json);
        return result;
    }
}

export interface ILostInOutReservationTicketViewDto {
    id: string;
    number: number;
    locationId: number;
    location: string | undefined;
    pricingId: number;
    price: number;
    creator: string | undefined;
    vatPercentage: number | undefined;
    creationDate: moment.Moment;
    successTransaction: TransactionDto;
    carPlate: CarPlate;
}

export class LostInOutReservationTicketViewDtoRecieptDto implements ILostInOutReservationTicketViewDtoRecieptDto {
    header: RecieptHeaderDto;
    information: LostInOutReservationTicketViewDto;

    constructor(data?: ILostInOutReservationTicketViewDtoRecieptDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.header = _data["header"] ? RecieptHeaderDto.fromJS(_data["header"]) : <any>undefined;
            this.information = _data["information"] ? LostInOutReservationTicketViewDto.fromJS(_data["information"]) : <any>undefined;
        }
    }

    static fromJS(data: any): LostInOutReservationTicketViewDtoRecieptDto {
        data = typeof data === 'object' ? data : {};
        let result = new LostInOutReservationTicketViewDtoRecieptDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["header"] = this.header ? this.header.toJSON() : <any>undefined;
        data["information"] = this.information ? this.information.toJSON() : <any>undefined;
        return data;
    }

    clone(): LostInOutReservationTicketViewDtoRecieptDto {
        const json = this.toJSON();
        let result = new LostInOutReservationTicketViewDtoRecieptDto();
        result.init(json);
        return result;
    }
}

export interface ILostInOutReservationTicketViewDtoRecieptDto {
    header: RecieptHeaderDto;
    information: LostInOutReservationTicketViewDto;
}

export class LostTicketReservationsSummaryDto implements ILostTicketReservationsSummaryDto {
    amount: number;
    count: number;

    constructor(data?: ILostTicketReservationsSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): LostTicketReservationsSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new LostTicketReservationsSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["count"] = this.count;
        return data;
    }

    clone(): LostTicketReservationsSummaryDto {
        const json = this.toJSON();
        let result = new LostTicketReservationsSummaryDto();
        result.init(json);
        return result;
    }
}

export interface ILostTicketReservationsSummaryDto {
    amount: number;
    count: number;
}

export class ManualIncome implements IManualIncome {
    id: string;
    readonly domainEvents: IEventData[] | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creatorUser: User;
    lastModifierUser: User;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    customerName: string | undefined;
    customerMobileNumber: string | undefined;
    description: string | undefined;
    readonly vehicleId: string | undefined;
    vehicle: Vehicle;
    carPlate: CarPlate;
    paymentType: PaymentType;
    totalAmount: number;
    posTransactionId: string | undefined;
    readonly invoiceNumber: string | undefined;
    manualIncomeNumber: number;
    vatPercentage: number | undefined;
    shiftId: string;
    shift: StaffAccountShift;

    constructor(data?: IManualIncome) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["domainEvents"])) {
                (<any>this).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (<any>this).domainEvents.push(IEventData.fromJS(item));
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.customerName = _data["customerName"];
            this.customerMobileNumber = _data["customerMobileNumber"];
            this.description = _data["description"];
            (<any>this).vehicleId = _data["vehicleId"];
            this.vehicle = _data["vehicle"] ? Vehicle.fromJS(_data["vehicle"]) : <any>undefined;
            this.carPlate = _data["carPlate"] ? CarPlate.fromJS(_data["carPlate"]) : <any>undefined;
            this.paymentType = _data["paymentType"];
            this.totalAmount = _data["totalAmount"];
            this.posTransactionId = _data["posTransactionId"];
            (<any>this).invoiceNumber = _data["invoiceNumber"];
            this.manualIncomeNumber = _data["manualIncomeNumber"];
            this.vatPercentage = _data["vatPercentage"];
            this.shiftId = _data["shiftId"];
            this.shift = _data["shift"] ? StaffAccountShift.fromJS(_data["shift"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ManualIncome {
        data = typeof data === 'object' ? data : {};
        let result = new ManualIncome();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item.toJSON());
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["customerName"] = this.customerName;
        data["customerMobileNumber"] = this.customerMobileNumber;
        data["description"] = this.description;
        data["vehicleId"] = this.vehicleId;
        data["vehicle"] = this.vehicle ? this.vehicle.toJSON() : <any>undefined;
        data["carPlate"] = this.carPlate ? this.carPlate.toJSON() : <any>undefined;
        data["paymentType"] = this.paymentType;
        data["totalAmount"] = this.totalAmount;
        data["posTransactionId"] = this.posTransactionId;
        data["invoiceNumber"] = this.invoiceNumber;
        data["manualIncomeNumber"] = this.manualIncomeNumber;
        data["vatPercentage"] = this.vatPercentage;
        data["shiftId"] = this.shiftId;
        data["shift"] = this.shift ? this.shift.toJSON() : <any>undefined;
        return data;
    }

    clone(): ManualIncome {
        const json = this.toJSON();
        let result = new ManualIncome();
        result.init(json);
        return result;
    }
}

export interface IManualIncome {
    id: string;
    domainEvents: IEventData[] | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creatorUser: User;
    lastModifierUser: User;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    customerName: string | undefined;
    customerMobileNumber: string | undefined;
    description: string | undefined;
    vehicleId: string | undefined;
    vehicle: Vehicle;
    carPlate: CarPlate;
    paymentType: PaymentType;
    totalAmount: number;
    posTransactionId: string | undefined;
    invoiceNumber: string | undefined;
    manualIncomeNumber: number;
    vatPercentage: number | undefined;
    shiftId: string;
    shift: StaffAccountShift;
}

export class ManualIncomeDto implements IManualIncomeDto {
    id: string;
    customerName: string | undefined;
    customerMobileNumber: string | undefined;
    description: string | undefined;
    carPlate: VehiclePlate;
    vehicle: VehicleDto;
    paymentType: PaymentType;
    totalAmount: number;
    manualIncomeNumber: number;
    creationTime: moment.Moment;
    creator: string | undefined;
    vatPercentage: number | undefined;

    constructor(data?: IManualIncomeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.customerName = _data["customerName"];
            this.customerMobileNumber = _data["customerMobileNumber"];
            this.description = _data["description"];
            this.carPlate = _data["carPlate"] ? VehiclePlate.fromJS(_data["carPlate"]) : <any>undefined;
            this.vehicle = _data["vehicle"] ? VehicleDto.fromJS(_data["vehicle"]) : <any>undefined;
            this.paymentType = _data["paymentType"];
            this.totalAmount = _data["totalAmount"];
            this.manualIncomeNumber = _data["manualIncomeNumber"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creator = _data["creator"];
            this.vatPercentage = _data["vatPercentage"];
        }
    }

    static fromJS(data: any): ManualIncomeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ManualIncomeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["customerName"] = this.customerName;
        data["customerMobileNumber"] = this.customerMobileNumber;
        data["description"] = this.description;
        data["carPlate"] = this.carPlate ? this.carPlate.toJSON() : <any>undefined;
        data["vehicle"] = this.vehicle ? this.vehicle.toJSON() : <any>undefined;
        data["paymentType"] = this.paymentType;
        data["totalAmount"] = this.totalAmount;
        data["manualIncomeNumber"] = this.manualIncomeNumber;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creator"] = this.creator;
        data["vatPercentage"] = this.vatPercentage;
        return data;
    }

    clone(): ManualIncomeDto {
        const json = this.toJSON();
        let result = new ManualIncomeDto();
        result.init(json);
        return result;
    }
}

export interface IManualIncomeDto {
    id: string;
    customerName: string | undefined;
    customerMobileNumber: string | undefined;
    description: string | undefined;
    carPlate: VehiclePlate;
    vehicle: VehicleDto;
    paymentType: PaymentType;
    totalAmount: number;
    manualIncomeNumber: number;
    creationTime: moment.Moment;
    creator: string | undefined;
    vatPercentage: number | undefined;
}

export class ManualIncomeDtoPagedResultDto implements IManualIncomeDtoPagedResultDto {
    items: ManualIncomeDto[] | undefined;
    totalCount: number;

    constructor(data?: IManualIncomeDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ManualIncomeDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ManualIncomeDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ManualIncomeDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ManualIncomeDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ManualIncomeDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IManualIncomeDtoPagedResultDto {
    items: ManualIncomeDto[] | undefined;
    totalCount: number;
}

export class ManualIncomeInvoiceInfoDto implements IManualIncomeInvoiceInfoDto {
    manualIncome: ManualIncomeDto;
    successfulTransaction: TransactionDto;

    constructor(data?: IManualIncomeInvoiceInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.manualIncome = _data["manualIncome"] ? ManualIncomeDto.fromJS(_data["manualIncome"]) : <any>undefined;
            this.successfulTransaction = _data["successfulTransaction"] ? TransactionDto.fromJS(_data["successfulTransaction"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ManualIncomeInvoiceInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ManualIncomeInvoiceInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["manualIncome"] = this.manualIncome ? this.manualIncome.toJSON() : <any>undefined;
        data["successfulTransaction"] = this.successfulTransaction ? this.successfulTransaction.toJSON() : <any>undefined;
        return data;
    }

    clone(): ManualIncomeInvoiceInfoDto {
        const json = this.toJSON();
        let result = new ManualIncomeInvoiceInfoDto();
        result.init(json);
        return result;
    }
}

export interface IManualIncomeInvoiceInfoDto {
    manualIncome: ManualIncomeDto;
    successfulTransaction: TransactionDto;
}

export class ManualIncomeViewDto implements IManualIncomeViewDto {
    id: string;
    customerName: string | undefined;
    customerMobileNumber: string | undefined;
    description: string | undefined;
    carPlate: VehiclePlate;
    vehicle: VehicleDto;
    paymentType: PaymentType;
    totalAmount: number;
    manualIncomeNumber: number;
    creationTime: moment.Moment;
    creator: string | undefined;
    vatPercentage: number | undefined;
    successfulTransaction: TransactionDto;

    constructor(data?: IManualIncomeViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.customerName = _data["customerName"];
            this.customerMobileNumber = _data["customerMobileNumber"];
            this.description = _data["description"];
            this.carPlate = _data["carPlate"] ? VehiclePlate.fromJS(_data["carPlate"]) : <any>undefined;
            this.vehicle = _data["vehicle"] ? VehicleDto.fromJS(_data["vehicle"]) : <any>undefined;
            this.paymentType = _data["paymentType"];
            this.totalAmount = _data["totalAmount"];
            this.manualIncomeNumber = _data["manualIncomeNumber"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creator = _data["creator"];
            this.vatPercentage = _data["vatPercentage"];
            this.successfulTransaction = _data["successfulTransaction"] ? TransactionDto.fromJS(_data["successfulTransaction"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ManualIncomeViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new ManualIncomeViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["customerName"] = this.customerName;
        data["customerMobileNumber"] = this.customerMobileNumber;
        data["description"] = this.description;
        data["carPlate"] = this.carPlate ? this.carPlate.toJSON() : <any>undefined;
        data["vehicle"] = this.vehicle ? this.vehicle.toJSON() : <any>undefined;
        data["paymentType"] = this.paymentType;
        data["totalAmount"] = this.totalAmount;
        data["manualIncomeNumber"] = this.manualIncomeNumber;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creator"] = this.creator;
        data["vatPercentage"] = this.vatPercentage;
        data["successfulTransaction"] = this.successfulTransaction ? this.successfulTransaction.toJSON() : <any>undefined;
        return data;
    }

    clone(): ManualIncomeViewDto {
        const json = this.toJSON();
        let result = new ManualIncomeViewDto();
        result.init(json);
        return result;
    }
}

export interface IManualIncomeViewDto {
    id: string;
    customerName: string | undefined;
    customerMobileNumber: string | undefined;
    description: string | undefined;
    carPlate: VehiclePlate;
    vehicle: VehicleDto;
    paymentType: PaymentType;
    totalAmount: number;
    manualIncomeNumber: number;
    creationTime: moment.Moment;
    creator: string | undefined;
    vatPercentage: number | undefined;
    successfulTransaction: TransactionDto;
}

export class MetricInvoiceWithTransactionDto implements IMetricInvoiceWithTransactionDto {
    invoice: ExternalInvoiceDto;
    transaction: MetricTransactionResponse;

    constructor(data?: IMetricInvoiceWithTransactionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoice = _data["invoice"] ? ExternalInvoiceDto.fromJS(_data["invoice"]) : <any>undefined;
            this.transaction = _data["transaction"] ? MetricTransactionResponse.fromJS(_data["transaction"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MetricInvoiceWithTransactionDto {
        data = typeof data === 'object' ? data : {};
        let result = new MetricInvoiceWithTransactionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoice"] = this.invoice ? this.invoice.toJSON() : <any>undefined;
        data["transaction"] = this.transaction ? this.transaction.toJSON() : <any>undefined;
        return data;
    }

    clone(): MetricInvoiceWithTransactionDto {
        const json = this.toJSON();
        let result = new MetricInvoiceWithTransactionDto();
        result.init(json);
        return result;
    }
}

export interface IMetricInvoiceWithTransactionDto {
    invoice: ExternalInvoiceDto;
    transaction: MetricTransactionResponse;
}

export class MetricPaymentViewDto implements IMetricPaymentViewDto {
    id: string;
    machineName: string | undefined;
    sequenceNumber: number;
    transactionSerialNumber: string | undefined;
    paymentDateTime: moment.Moment;
    paymentCardType: string | undefined;
    paymentCardNumber: string | undefined;
    paymentISO4217Code: string | undefined;
    paymentAuthorisationCode: string | undefined;
    paymentStatus: string | undefined;
    paymentAmount: number;
    paymentBalance: number;
    paymentPaymentType: number;
    paymentTerminalID: string | undefined;
    paymentTokenChannelID: string | undefined;
    dateCreated: moment.Moment;
    loyaltyId: string | undefined;

    constructor(data?: IMetricPaymentViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.machineName = _data["machineName"];
            this.sequenceNumber = _data["sequenceNumber"];
            this.transactionSerialNumber = _data["transactionSerialNumber"];
            this.paymentDateTime = _data["paymentDateTime"] ? moment(_data["paymentDateTime"].toString()) : <any>undefined;
            this.paymentCardType = _data["paymentCardType"];
            this.paymentCardNumber = _data["paymentCardNumber"];
            this.paymentISO4217Code = _data["paymentISO4217Code"];
            this.paymentAuthorisationCode = _data["paymentAuthorisationCode"];
            this.paymentStatus = _data["paymentStatus"];
            this.paymentAmount = _data["paymentAmount"];
            this.paymentBalance = _data["paymentBalance"];
            this.paymentPaymentType = _data["paymentPaymentType"];
            this.paymentTerminalID = _data["paymentTerminalID"];
            this.paymentTokenChannelID = _data["paymentTokenChannelID"];
            this.dateCreated = _data["dateCreated"] ? moment(_data["dateCreated"].toString()) : <any>undefined;
            this.loyaltyId = _data["loyaltyId"];
        }
    }

    static fromJS(data: any): MetricPaymentViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new MetricPaymentViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["machineName"] = this.machineName;
        data["sequenceNumber"] = this.sequenceNumber;
        data["transactionSerialNumber"] = this.transactionSerialNumber;
        data["paymentDateTime"] = this.paymentDateTime ? this.paymentDateTime.toISOString() : <any>undefined;
        data["paymentCardType"] = this.paymentCardType;
        data["paymentCardNumber"] = this.paymentCardNumber;
        data["paymentISO4217Code"] = this.paymentISO4217Code;
        data["paymentAuthorisationCode"] = this.paymentAuthorisationCode;
        data["paymentStatus"] = this.paymentStatus;
        data["paymentAmount"] = this.paymentAmount;
        data["paymentBalance"] = this.paymentBalance;
        data["paymentPaymentType"] = this.paymentPaymentType;
        data["paymentTerminalID"] = this.paymentTerminalID;
        data["paymentTokenChannelID"] = this.paymentTokenChannelID;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : <any>undefined;
        data["loyaltyId"] = this.loyaltyId;
        return data;
    }

    clone(): MetricPaymentViewDto {
        const json = this.toJSON();
        let result = new MetricPaymentViewDto();
        result.init(json);
        return result;
    }
}

export interface IMetricPaymentViewDto {
    id: string;
    machineName: string | undefined;
    sequenceNumber: number;
    transactionSerialNumber: string | undefined;
    paymentDateTime: moment.Moment;
    paymentCardType: string | undefined;
    paymentCardNumber: string | undefined;
    paymentISO4217Code: string | undefined;
    paymentAuthorisationCode: string | undefined;
    paymentStatus: string | undefined;
    paymentAmount: number;
    paymentBalance: number;
    paymentPaymentType: number;
    paymentTerminalID: string | undefined;
    paymentTokenChannelID: string | undefined;
    dateCreated: moment.Moment;
    loyaltyId: string | undefined;
}

export class MetricTransactionResponse implements IMetricTransactionResponse {
    transactionId: number | undefined;
    transactionSerialNumber: string | undefined;
    registrationNumber: string | undefined;
    registrationNumberMapped: string | undefined;
    startTime: moment.Moment;
    expiryTime: moment.Moment;
    amountPaid: number;
    machineName: string | undefined;
    receivedTime: moment.Moment;
    readonly transactionIdentifier: string | undefined;

    constructor(data?: IMetricTransactionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transactionId = _data["transactionId"];
            this.transactionSerialNumber = _data["transactionSerialNumber"];
            this.registrationNumber = _data["registrationNumber"];
            this.registrationNumberMapped = _data["registrationNumberMapped"];
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.expiryTime = _data["expiryTime"] ? moment(_data["expiryTime"].toString()) : <any>undefined;
            this.amountPaid = _data["amountPaid"];
            this.machineName = _data["machineName"];
            this.receivedTime = _data["receivedTime"] ? moment(_data["receivedTime"].toString()) : <any>undefined;
            (<any>this).transactionIdentifier = _data["transactionIdentifier"];
        }
    }

    static fromJS(data: any): MetricTransactionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MetricTransactionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionId"] = this.transactionId;
        data["transactionSerialNumber"] = this.transactionSerialNumber;
        data["registrationNumber"] = this.registrationNumber;
        data["registrationNumberMapped"] = this.registrationNumberMapped;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["expiryTime"] = this.expiryTime ? this.expiryTime.toISOString() : <any>undefined;
        data["amountPaid"] = this.amountPaid;
        data["machineName"] = this.machineName;
        data["receivedTime"] = this.receivedTime ? this.receivedTime.toISOString() : <any>undefined;
        data["transactionIdentifier"] = this.transactionIdentifier;
        return data;
    }

    clone(): MetricTransactionResponse {
        const json = this.toJSON();
        let result = new MetricTransactionResponse();
        result.init(json);
        return result;
    }
}

export interface IMetricTransactionResponse {
    transactionId: number | undefined;
    transactionSerialNumber: string | undefined;
    registrationNumber: string | undefined;
    registrationNumberMapped: string | undefined;
    startTime: moment.Moment;
    expiryTime: moment.Moment;
    amountPaid: number;
    machineName: string | undefined;
    receivedTime: moment.Moment;
    transactionIdentifier: string | undefined;
}

export class MetricTransactionViewDto implements IMetricTransactionViewDto {
    id: string;
    transactionId: number | undefined;
    transactionSerialNumber: string | undefined;
    registrationNumber: string | undefined;
    registrationNumberMapped: string | undefined;
    startTime: moment.Moment;
    expiryTime: moment.Moment;
    amountPaid: number;
    machineName: string | undefined;
    receivedTime: moment.Moment;
    payments: MetricPaymentViewDto[] | undefined;

    constructor(data?: IMetricTransactionViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.transactionId = _data["transactionId"];
            this.transactionSerialNumber = _data["transactionSerialNumber"];
            this.registrationNumber = _data["registrationNumber"];
            this.registrationNumberMapped = _data["registrationNumberMapped"];
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.expiryTime = _data["expiryTime"] ? moment(_data["expiryTime"].toString()) : <any>undefined;
            this.amountPaid = _data["amountPaid"];
            this.machineName = _data["machineName"];
            this.receivedTime = _data["receivedTime"] ? moment(_data["receivedTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["payments"])) {
                this.payments = [] as any;
                for (let item of _data["payments"])
                    this.payments.push(MetricPaymentViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MetricTransactionViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new MetricTransactionViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["transactionId"] = this.transactionId;
        data["transactionSerialNumber"] = this.transactionSerialNumber;
        data["registrationNumber"] = this.registrationNumber;
        data["registrationNumberMapped"] = this.registrationNumberMapped;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["expiryTime"] = this.expiryTime ? this.expiryTime.toISOString() : <any>undefined;
        data["amountPaid"] = this.amountPaid;
        data["machineName"] = this.machineName;
        data["receivedTime"] = this.receivedTime ? this.receivedTime.toISOString() : <any>undefined;
        if (Array.isArray(this.payments)) {
            data["payments"] = [];
            for (let item of this.payments)
                data["payments"].push(item.toJSON());
        }
        return data;
    }

    clone(): MetricTransactionViewDto {
        const json = this.toJSON();
        let result = new MetricTransactionViewDto();
        result.init(json);
        return result;
    }
}

export interface IMetricTransactionViewDto {
    id: string;
    transactionId: number | undefined;
    transactionSerialNumber: string | undefined;
    registrationNumber: string | undefined;
    registrationNumberMapped: string | undefined;
    startTime: moment.Moment;
    expiryTime: moment.Moment;
    amountPaid: number;
    machineName: string | undefined;
    receivedTime: moment.Moment;
    payments: MetricPaymentViewDto[] | undefined;
}

export class MetricTransactionViewDtoPagedResultDto implements IMetricTransactionViewDtoPagedResultDto {
    items: MetricTransactionViewDto[] | undefined;
    totalCount: number;

    constructor(data?: IMetricTransactionViewDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(MetricTransactionViewDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): MetricTransactionViewDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new MetricTransactionViewDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): MetricTransactionViewDtoPagedResultDto {
        const json = this.toJSON();
        let result = new MetricTransactionViewDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IMetricTransactionViewDtoPagedResultDto {
    items: MetricTransactionViewDto[] | undefined;
    totalCount: number;
}

export class MetricTransactionWithInvoiceViewDto implements IMetricTransactionWithInvoiceViewDto {
    transaction: MetricTransactionViewDto;
    invoice: ExternalInvoiceDto;

    constructor(data?: IMetricTransactionWithInvoiceViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transaction = _data["transaction"] ? MetricTransactionViewDto.fromJS(_data["transaction"]) : <any>undefined;
            this.invoice = _data["invoice"] ? ExternalInvoiceDto.fromJS(_data["invoice"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MetricTransactionWithInvoiceViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new MetricTransactionWithInvoiceViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transaction"] = this.transaction ? this.transaction.toJSON() : <any>undefined;
        data["invoice"] = this.invoice ? this.invoice.toJSON() : <any>undefined;
        return data;
    }

    clone(): MetricTransactionWithInvoiceViewDto {
        const json = this.toJSON();
        let result = new MetricTransactionWithInvoiceViewDto();
        result.init(json);
        return result;
    }
}

export interface IMetricTransactionWithInvoiceViewDto {
    transaction: MetricTransactionViewDto;
    invoice: ExternalInvoiceDto;
}

export class MetricTransactionsSyncDto implements IMetricTransactionsSyncDto {
    id: string;
    transactionType: string | undefined;
    totalTransactions: number;
    addedTransactions: number;
    updatedTransactions: number;
    isSuccess: boolean;
    exception: string | undefined;
    startTime: moment.Moment;
    endTime: moment.Moment;

    constructor(data?: IMetricTransactionsSyncDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.transactionType = _data["transactionType"];
            this.totalTransactions = _data["totalTransactions"];
            this.addedTransactions = _data["addedTransactions"];
            this.updatedTransactions = _data["updatedTransactions"];
            this.isSuccess = _data["isSuccess"];
            this.exception = _data["exception"];
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MetricTransactionsSyncDto {
        data = typeof data === 'object' ? data : {};
        let result = new MetricTransactionsSyncDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["transactionType"] = this.transactionType;
        data["totalTransactions"] = this.totalTransactions;
        data["addedTransactions"] = this.addedTransactions;
        data["updatedTransactions"] = this.updatedTransactions;
        data["isSuccess"] = this.isSuccess;
        data["exception"] = this.exception;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): MetricTransactionsSyncDto {
        const json = this.toJSON();
        let result = new MetricTransactionsSyncDto();
        result.init(json);
        return result;
    }
}

export interface IMetricTransactionsSyncDto {
    id: string;
    transactionType: string | undefined;
    totalTransactions: number;
    addedTransactions: number;
    updatedTransactions: number;
    isSuccess: boolean;
    exception: string | undefined;
    startTime: moment.Moment;
    endTime: moment.Moment;
}

export class MetricTransactionsSyncDtoPagedResultDto implements IMetricTransactionsSyncDtoPagedResultDto {
    items: MetricTransactionsSyncDto[] | undefined;
    totalCount: number;

    constructor(data?: IMetricTransactionsSyncDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(MetricTransactionsSyncDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): MetricTransactionsSyncDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new MetricTransactionsSyncDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): MetricTransactionsSyncDtoPagedResultDto {
        const json = this.toJSON();
        let result = new MetricTransactionsSyncDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IMetricTransactionsSyncDtoPagedResultDto {
    items: MetricTransactionsSyncDto[] | undefined;
    totalCount: number;
}

export class MetrixSystemSettingsEditDto implements IMetrixSystemSettingsEditDto {
    baseUrl: string | undefined;
    clientToken: string | undefined;
    username: string | undefined;
    password: string | undefined;

    constructor(data?: IMetrixSystemSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseUrl = _data["baseUrl"];
            this.clientToken = _data["clientToken"];
            this.username = _data["username"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): MetrixSystemSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new MetrixSystemSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseUrl"] = this.baseUrl;
        data["clientToken"] = this.clientToken;
        data["username"] = this.username;
        data["password"] = this.password;
        return data;
    }

    clone(): MetrixSystemSettingsEditDto {
        const json = this.toJSON();
        let result = new MetrixSystemSettingsEditDto();
        result.init(json);
        return result;
    }
}

export interface IMetrixSystemSettingsEditDto {
    baseUrl: string | undefined;
    clientToken: string | undefined;
    username: string | undefined;
    password: string | undefined;
}

export class MobilityType implements IMobilityType {
    readonly id: number;
    readonly name: string | undefined;

    constructor(data?: IMobilityType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).id = _data["id"];
            (<any>this).name = _data["name"];
        }
    }

    static fromJS(data: any): MobilityType {
        data = typeof data === 'object' ? data : {};
        let result = new MobilityType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): MobilityType {
        const json = this.toJSON();
        let result = new MobilityType();
        result.init(json);
        return result;
    }
}

export interface IMobilityType {
    id: number;
    name: string | undefined;
}

export class NameValueDto implements INameValueDto {
    name: string | undefined;
    value: string | undefined;

    constructor(data?: INameValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): NameValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new NameValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }

    clone(): NameValueDto {
        const json = this.toJSON();
        let result = new NameValueDto();
        result.init(json);
        return result;
    }
}

export interface INameValueDto {
    name: string | undefined;
    value: string | undefined;
}

export class NtsGeometryServices implements INtsGeometryServices {
    geometryOverlay: GeometryOverlay;
    coordinateEqualityComparer: CoordinateEqualityComparer;
    readonly defaultSRID: number;
    defaultCoordinateSequenceFactory: CoordinateSequenceFactory;
    defaultPrecisionModel: PrecisionModel;

    constructor(data?: INtsGeometryServices) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.geometryOverlay = _data["geometryOverlay"] ? GeometryOverlay.fromJS(_data["geometryOverlay"]) : <any>undefined;
            this.coordinateEqualityComparer = _data["coordinateEqualityComparer"] ? CoordinateEqualityComparer.fromJS(_data["coordinateEqualityComparer"]) : <any>undefined;
            (<any>this).defaultSRID = _data["defaultSRID"];
            this.defaultCoordinateSequenceFactory = _data["defaultCoordinateSequenceFactory"] ? CoordinateSequenceFactory.fromJS(_data["defaultCoordinateSequenceFactory"]) : <any>undefined;
            this.defaultPrecisionModel = _data["defaultPrecisionModel"] ? PrecisionModel.fromJS(_data["defaultPrecisionModel"]) : <any>undefined;
        }
    }

    static fromJS(data: any): NtsGeometryServices {
        data = typeof data === 'object' ? data : {};
        let result = new NtsGeometryServices();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["geometryOverlay"] = this.geometryOverlay ? this.geometryOverlay.toJSON() : <any>undefined;
        data["coordinateEqualityComparer"] = this.coordinateEqualityComparer ? this.coordinateEqualityComparer.toJSON() : <any>undefined;
        data["defaultSRID"] = this.defaultSRID;
        data["defaultCoordinateSequenceFactory"] = this.defaultCoordinateSequenceFactory ? this.defaultCoordinateSequenceFactory.toJSON() : <any>undefined;
        data["defaultPrecisionModel"] = this.defaultPrecisionModel ? this.defaultPrecisionModel.toJSON() : <any>undefined;
        return data;
    }

    clone(): NtsGeometryServices {
        const json = this.toJSON();
        let result = new NtsGeometryServices();
        result.init(json);
        return result;
    }
}

export interface INtsGeometryServices {
    geometryOverlay: GeometryOverlay;
    coordinateEqualityComparer: CoordinateEqualityComparer;
    defaultSRID: number;
    defaultCoordinateSequenceFactory: CoordinateSequenceFactory;
    defaultPrecisionModel: PrecisionModel;
}

export enum OgcGeometryType {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _9 = 9,
    _10 = 10,
    _11 = 11,
    _12 = 12,
    _13 = 13,
    _14 = 14,
    _15 = 15,
    _16 = 16,
}

export class OldReservationCheckoutDto implements IOldReservationCheckoutDto {
    oldReservationId: string;
    totalHours: number;
    paymentMethodId: number;

    constructor(data?: IOldReservationCheckoutDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.oldReservationId = _data["oldReservationId"];
            this.totalHours = _data["totalHours"];
            this.paymentMethodId = _data["paymentMethodId"];
        }
    }

    static fromJS(data: any): OldReservationCheckoutDto {
        data = typeof data === 'object' ? data : {};
        let result = new OldReservationCheckoutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oldReservationId"] = this.oldReservationId;
        data["totalHours"] = this.totalHours;
        data["paymentMethodId"] = this.paymentMethodId;
        return data;
    }

    clone(): OldReservationCheckoutDto {
        const json = this.toJSON();
        let result = new OldReservationCheckoutDto();
        result.init(json);
        return result;
    }
}

export interface IOldReservationCheckoutDto {
    oldReservationId: string;
    totalHours: number;
    paymentMethodId: number;
}

export class OnlinePaymentMethod implements IOnlinePaymentMethod {
    readonly name: string | undefined;
    readonly id: number;

    constructor(data?: IOnlinePaymentMethod) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data["name"];
            (<any>this).id = _data["id"];
        }
    }

    static fromJS(data: any): OnlinePaymentMethod {
        data = typeof data === 'object' ? data : {};
        let result = new OnlinePaymentMethod();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }

    clone(): OnlinePaymentMethod {
        const json = this.toJSON();
        let result = new OnlinePaymentMethod();
        result.init(json);
        return result;
    }
}

export interface IOnlinePaymentMethod {
    name: string | undefined;
    id: number;
}

export class OnlineReservationDetailsCountDto implements IOnlineReservationDetailsCountDto {
    amount: number;
    count: number;

    constructor(data?: IOnlineReservationDetailsCountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): OnlineReservationDetailsCountDto {
        data = typeof data === 'object' ? data : {};
        let result = new OnlineReservationDetailsCountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["count"] = this.count;
        return data;
    }

    clone(): OnlineReservationDetailsCountDto {
        const json = this.toJSON();
        let result = new OnlineReservationDetailsCountDto();
        result.init(json);
        return result;
    }
}

export interface IOnlineReservationDetailsCountDto {
    amount: number;
    count: number;
}

export class OnlineTransaction implements IOnlineTransaction {
    readonly paymentMethodEntityId: string | undefined;
    readonly transactionId: string | undefined;
    readonly referenceId: string | undefined;
    readonly brand: string | undefined;
    readonly cardType: string | undefined;
    readonly cardLast4Digits: string | undefined;
    readonly cardHolder: string | undefined;
    readonly cardExpiryMonth: number | undefined;
    readonly cardExpiryYear: number | undefined;
    paymentMethod: OnlinePaymentMethod;
    readonly paymentMethodId: number | undefined;

    constructor(data?: IOnlineTransaction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).paymentMethodEntityId = _data["paymentMethodEntityId"];
            (<any>this).transactionId = _data["transactionId"];
            (<any>this).referenceId = _data["referenceId"];
            (<any>this).brand = _data["brand"];
            (<any>this).cardType = _data["cardType"];
            (<any>this).cardLast4Digits = _data["cardLast4Digits"];
            (<any>this).cardHolder = _data["cardHolder"];
            (<any>this).cardExpiryMonth = _data["cardExpiryMonth"];
            (<any>this).cardExpiryYear = _data["cardExpiryYear"];
            this.paymentMethod = _data["paymentMethod"] ? OnlinePaymentMethod.fromJS(_data["paymentMethod"]) : <any>undefined;
            (<any>this).paymentMethodId = _data["paymentMethodId"];
        }
    }

    static fromJS(data: any): OnlineTransaction {
        data = typeof data === 'object' ? data : {};
        let result = new OnlineTransaction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentMethodEntityId"] = this.paymentMethodEntityId;
        data["transactionId"] = this.transactionId;
        data["referenceId"] = this.referenceId;
        data["brand"] = this.brand;
        data["cardType"] = this.cardType;
        data["cardLast4Digits"] = this.cardLast4Digits;
        data["cardHolder"] = this.cardHolder;
        data["cardExpiryMonth"] = this.cardExpiryMonth;
        data["cardExpiryYear"] = this.cardExpiryYear;
        data["paymentMethod"] = this.paymentMethod ? this.paymentMethod.toJSON() : <any>undefined;
        data["paymentMethodId"] = this.paymentMethodId;
        return data;
    }

    clone(): OnlineTransaction {
        const json = this.toJSON();
        let result = new OnlineTransaction();
        result.init(json);
        return result;
    }
}

export interface IOnlineTransaction {
    paymentMethodEntityId: string | undefined;
    transactionId: string | undefined;
    referenceId: string | undefined;
    brand: string | undefined;
    cardType: string | undefined;
    cardLast4Digits: string | undefined;
    cardHolder: string | undefined;
    cardExpiryMonth: number | undefined;
    cardExpiryYear: number | undefined;
    paymentMethod: OnlinePaymentMethod;
    paymentMethodId: number | undefined;
}

export class OnlineTransactionDto implements IOnlineTransactionDto {
    paymentMethodEntityId: string | undefined;
    transactionId: string | undefined;
    referenceId: string | undefined;
    brand: string | undefined;
    cardType: string | undefined;
    cardLast4Digits: string | undefined;
    cardHolder: string | undefined;
    cardExpiryMonth: number | undefined;
    cardExpiryYear: number | undefined;
    paymentMethod: OnlinePaymentMethod;

    constructor(data?: IOnlineTransactionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentMethodEntityId = _data["paymentMethodEntityId"];
            this.transactionId = _data["transactionId"];
            this.referenceId = _data["referenceId"];
            this.brand = _data["brand"];
            this.cardType = _data["cardType"];
            this.cardLast4Digits = _data["cardLast4Digits"];
            this.cardHolder = _data["cardHolder"];
            this.cardExpiryMonth = _data["cardExpiryMonth"];
            this.cardExpiryYear = _data["cardExpiryYear"];
            this.paymentMethod = _data["paymentMethod"] ? OnlinePaymentMethod.fromJS(_data["paymentMethod"]) : <any>undefined;
        }
    }

    static fromJS(data: any): OnlineTransactionDto {
        data = typeof data === 'object' ? data : {};
        let result = new OnlineTransactionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentMethodEntityId"] = this.paymentMethodEntityId;
        data["transactionId"] = this.transactionId;
        data["referenceId"] = this.referenceId;
        data["brand"] = this.brand;
        data["cardType"] = this.cardType;
        data["cardLast4Digits"] = this.cardLast4Digits;
        data["cardHolder"] = this.cardHolder;
        data["cardExpiryMonth"] = this.cardExpiryMonth;
        data["cardExpiryYear"] = this.cardExpiryYear;
        data["paymentMethod"] = this.paymentMethod ? this.paymentMethod.toJSON() : <any>undefined;
        return data;
    }

    clone(): OnlineTransactionDto {
        const json = this.toJSON();
        let result = new OnlineTransactionDto();
        result.init(json);
        return result;
    }
}

export interface IOnlineTransactionDto {
    paymentMethodEntityId: string | undefined;
    transactionId: string | undefined;
    referenceId: string | undefined;
    brand: string | undefined;
    cardType: string | undefined;
    cardLast4Digits: string | undefined;
    cardHolder: string | undefined;
    cardExpiryMonth: number | undefined;
    cardExpiryYear: number | undefined;
    paymentMethod: OnlinePaymentMethod;
}

export class OperationNote implements IOperationNote {
    id: string;
    readonly domainEvents: IEventData[] | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creatorUser: User;
    lastModifierUser: User;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    violationId: string;
    violation: Violation;
    staffAccountShiftId: string;
    staffAccountShift: StaffAccountShift;
    currentViolationStatus: number;
    comment: string | undefined;

    constructor(data?: IOperationNote) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["domainEvents"])) {
                (<any>this).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (<any>this).domainEvents.push(IEventData.fromJS(item));
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.violationId = _data["violationId"];
            this.violation = _data["violation"] ? Violation.fromJS(_data["violation"]) : <any>undefined;
            this.staffAccountShiftId = _data["staffAccountShiftId"];
            this.staffAccountShift = _data["staffAccountShift"] ? StaffAccountShift.fromJS(_data["staffAccountShift"]) : <any>undefined;
            this.currentViolationStatus = _data["currentViolationStatus"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): OperationNote {
        data = typeof data === 'object' ? data : {};
        let result = new OperationNote();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item.toJSON());
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["violationId"] = this.violationId;
        data["violation"] = this.violation ? this.violation.toJSON() : <any>undefined;
        data["staffAccountShiftId"] = this.staffAccountShiftId;
        data["staffAccountShift"] = this.staffAccountShift ? this.staffAccountShift.toJSON() : <any>undefined;
        data["currentViolationStatus"] = this.currentViolationStatus;
        data["comment"] = this.comment;
        return data;
    }

    clone(): OperationNote {
        const json = this.toJSON();
        let result = new OperationNote();
        result.init(json);
        return result;
    }
}

export interface IOperationNote {
    id: string;
    domainEvents: IEventData[] | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creatorUser: User;
    lastModifierUser: User;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    violationId: string;
    violation: Violation;
    staffAccountShiftId: string;
    staffAccountShift: StaffAccountShift;
    currentViolationStatus: number;
    comment: string | undefined;
}

export class OperationNoteDto implements IOperationNoteDto {
    id: string;
    violationId: string;
    staffAccountShiftId: string;
    currentViolationStatus: string | undefined;
    comment: string | undefined;
    creationTime: moment.Moment;
    creatorName: string | undefined;

    constructor(data?: IOperationNoteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.violationId = _data["violationId"];
            this.staffAccountShiftId = _data["staffAccountShiftId"];
            this.currentViolationStatus = _data["currentViolationStatus"];
            this.comment = _data["comment"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorName = _data["creatorName"];
        }
    }

    static fromJS(data: any): OperationNoteDto {
        data = typeof data === 'object' ? data : {};
        let result = new OperationNoteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["violationId"] = this.violationId;
        data["staffAccountShiftId"] = this.staffAccountShiftId;
        data["currentViolationStatus"] = this.currentViolationStatus;
        data["comment"] = this.comment;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorName"] = this.creatorName;
        return data;
    }

    clone(): OperationNoteDto {
        const json = this.toJSON();
        let result = new OperationNoteDto();
        result.init(json);
        return result;
    }
}

export interface IOperationNoteDto {
    id: string;
    violationId: string;
    staffAccountShiftId: string;
    currentViolationStatus: string | undefined;
    comment: string | undefined;
    creationTime: moment.Moment;
    creatorName: string | undefined;
}

export class OperationNoteDtoPagedResultDto implements IOperationNoteDtoPagedResultDto {
    items: OperationNoteDto[] | undefined;
    totalCount: number;

    constructor(data?: IOperationNoteDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(OperationNoteDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): OperationNoteDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new OperationNoteDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): OperationNoteDtoPagedResultDto {
        const json = this.toJSON();
        let result = new OperationNoteDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IOperationNoteDtoPagedResultDto {
    items: OperationNoteDto[] | undefined;
    totalCount: number;
}

export enum Ordinates {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _7 = 7,
    _8 = 8,
    _16 = 16,
    _32 = 32,
    _64 = 64,
    _128 = 128,
    _256 = 256,
    _512 = 512,
    _1024 = 1024,
    _2048 = 2048,
    _4096 = 4096,
    _8192 = 8192,
    _16384 = 16384,
    _32768 = 32768,
    _65535 = 65535,
    _65536 = 65536,
    _65539 = 65539,
    _65543 = 65543,
    _131072 = 131072,
    _262144 = 262144,
    _524288 = 524288,
    _1048576 = 1048576,
    _2097152 = 2097152,
    _4194304 = 4194304,
    _8388608 = 8388608,
    _16777216 = 16777216,
    _33554432 = 33554432,
    _67108864 = 67108864,
    _134217728 = 134217728,
    _268435456 = 268435456,
    _536870912 = 536870912,
    _1073741824 = 1073741824,
    __2147483648 = -2147483648,
    __65536 = -65536,
    __1 = -1,
}

export class POSTransaction implements IPOSTransaction {
    posTransactionId: string | undefined;

    constructor(data?: IPOSTransaction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.posTransactionId = _data["posTransactionId"];
        }
    }

    static fromJS(data: any): POSTransaction {
        data = typeof data === 'object' ? data : {};
        let result = new POSTransaction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["posTransactionId"] = this.posTransactionId;
        return data;
    }

    clone(): POSTransaction {
        const json = this.toJSON();
        let result = new POSTransaction();
        result.init(json);
        return result;
    }
}

export interface IPOSTransaction {
    posTransactionId: string | undefined;
}

export class ParameterErrors implements IParameterErrors {
    name: string | undefined;
    value: string | undefined;
    message: string | undefined;

    constructor(data?: IParameterErrors) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ParameterErrors {
        data = typeof data === 'object' ? data : {};
        let result = new ParameterErrors();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        data["message"] = this.message;
        return data;
    }

    clone(): ParameterErrors {
        const json = this.toJSON();
        let result = new ParameterErrors();
        result.init(json);
        return result;
    }
}

export interface IParameterErrors {
    name: string | undefined;
    value: string | undefined;
    message: string | undefined;
}

export class ParentReservationDto implements IParentReservationDto {
    id: string;
    parentReservationStartTime: moment.Moment;
    parentReservationEndTime: moment.Moment;
    parentReservationStatus: ReservationStatus;
    reservationNumber: string | undefined;
    carPlate: string | undefined;
    firstname: string | undefined;
    lastname: string | undefined;
    mobileNumber: string | undefined;
    parentTotalHours: number;
    vatPercentage: number;
    vatAmount: number;
    total: number;
    subTotal: number;
    currency: string | undefined;
    creationTime: moment.Moment;
    locationName: string | undefined;
    slotName: string | undefined;
    sucessReservations: number;
    paymentTypes: PaymentType[] | undefined;

    constructor(data?: IParentReservationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.parentReservationStartTime = _data["parentReservationStartTime"] ? moment(_data["parentReservationStartTime"].toString()) : <any>undefined;
            this.parentReservationEndTime = _data["parentReservationEndTime"] ? moment(_data["parentReservationEndTime"].toString()) : <any>undefined;
            this.parentReservationStatus = _data["parentReservationStatus"];
            this.reservationNumber = _data["reservationNumber"];
            this.carPlate = _data["carPlate"];
            this.firstname = _data["firstname"];
            this.lastname = _data["lastname"];
            this.mobileNumber = _data["mobileNumber"];
            this.parentTotalHours = _data["parentTotalHours"];
            this.vatPercentage = _data["vatPercentage"];
            this.vatAmount = _data["vatAmount"];
            this.total = _data["total"];
            this.subTotal = _data["subTotal"];
            this.currency = _data["currency"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.locationName = _data["locationName"];
            this.slotName = _data["slotName"];
            this.sucessReservations = _data["sucessReservations"];
            if (Array.isArray(_data["paymentTypes"])) {
                this.paymentTypes = [] as any;
                for (let item of _data["paymentTypes"])
                    this.paymentTypes.push(item);
            }
        }
    }

    static fromJS(data: any): ParentReservationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ParentReservationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["parentReservationStartTime"] = this.parentReservationStartTime ? this.parentReservationStartTime.toISOString() : <any>undefined;
        data["parentReservationEndTime"] = this.parentReservationEndTime ? this.parentReservationEndTime.toISOString() : <any>undefined;
        data["parentReservationStatus"] = this.parentReservationStatus;
        data["reservationNumber"] = this.reservationNumber;
        data["carPlate"] = this.carPlate;
        data["firstname"] = this.firstname;
        data["lastname"] = this.lastname;
        data["mobileNumber"] = this.mobileNumber;
        data["parentTotalHours"] = this.parentTotalHours;
        data["vatPercentage"] = this.vatPercentage;
        data["vatAmount"] = this.vatAmount;
        data["total"] = this.total;
        data["subTotal"] = this.subTotal;
        data["currency"] = this.currency;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["locationName"] = this.locationName;
        data["slotName"] = this.slotName;
        data["sucessReservations"] = this.sucessReservations;
        if (Array.isArray(this.paymentTypes)) {
            data["paymentTypes"] = [];
            for (let item of this.paymentTypes)
                data["paymentTypes"].push(item);
        }
        return data;
    }

    clone(): ParentReservationDto {
        const json = this.toJSON();
        let result = new ParentReservationDto();
        result.init(json);
        return result;
    }
}

export interface IParentReservationDto {
    id: string;
    parentReservationStartTime: moment.Moment;
    parentReservationEndTime: moment.Moment;
    parentReservationStatus: ReservationStatus;
    reservationNumber: string | undefined;
    carPlate: string | undefined;
    firstname: string | undefined;
    lastname: string | undefined;
    mobileNumber: string | undefined;
    parentTotalHours: number;
    vatPercentage: number;
    vatAmount: number;
    total: number;
    subTotal: number;
    currency: string | undefined;
    creationTime: moment.Moment;
    locationName: string | undefined;
    slotName: string | undefined;
    sucessReservations: number;
    paymentTypes: PaymentType[] | undefined;
}

export class ParentReservationDtoPagedResultDto implements IParentReservationDtoPagedResultDto {
    items: ParentReservationDto[] | undefined;
    totalCount: number;

    constructor(data?: IParentReservationDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ParentReservationDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ParentReservationDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ParentReservationDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ParentReservationDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ParentReservationDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IParentReservationDtoPagedResultDto {
    items: ParentReservationDto[] | undefined;
    totalCount: number;
}

export class ParkingInvoice implements IParkingInvoice {
    id: string;
    readonly domainEvents: IEventData[] | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    invoiceNumber: string | undefined;
    invoiceDateUtc: moment.Moment;
    totalPrice: PriceValueObject;
    discount: PriceValueObject;
    netPrice: PriceValueObject;
    vatAmount: PriceValueObject;
    readonly vatPercentage: number;
    payment: ParkingPayment;
    invoiceItems: ParkingInvoiceItem[] | undefined;
    status: IntegratedInvoiceStatus;
    category: InvoiceCategory;
    readonly referenceId: string | undefined;
    readonly customerVatCode: string | undefined;
    customer: ParkingInvoiceCustomer;
    source: ParkingInvoiceSource;
    address: Address;
    companyProjectDetails: CompanyProjectDetails;
    readonly reportingDate: moment.Moment | undefined;
    readonly isReported: boolean;
    readonly reports: InvoiceReport[] | undefined;
    readonly locations: ParkingInvoiceLocation[] | undefined;

    constructor(data?: IParkingInvoice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["domainEvents"])) {
                (<any>this).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (<any>this).domainEvents.push(IEventData.fromJS(item));
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.invoiceNumber = _data["invoiceNumber"];
            this.invoiceDateUtc = _data["invoiceDateUtc"] ? moment(_data["invoiceDateUtc"].toString()) : <any>undefined;
            this.totalPrice = _data["totalPrice"] ? PriceValueObject.fromJS(_data["totalPrice"]) : <any>undefined;
            this.discount = _data["discount"] ? PriceValueObject.fromJS(_data["discount"]) : <any>undefined;
            this.netPrice = _data["netPrice"] ? PriceValueObject.fromJS(_data["netPrice"]) : <any>undefined;
            this.vatAmount = _data["vatAmount"] ? PriceValueObject.fromJS(_data["vatAmount"]) : <any>undefined;
            (<any>this).vatPercentage = _data["vatPercentage"];
            this.payment = _data["payment"] ? ParkingPayment.fromJS(_data["payment"]) : <any>undefined;
            if (Array.isArray(_data["invoiceItems"])) {
                this.invoiceItems = [] as any;
                for (let item of _data["invoiceItems"])
                    this.invoiceItems.push(ParkingInvoiceItem.fromJS(item));
            }
            this.status = _data["status"] ? IntegratedInvoiceStatus.fromJS(_data["status"]) : <any>undefined;
            this.category = _data["category"] ? InvoiceCategory.fromJS(_data["category"]) : <any>undefined;
            (<any>this).referenceId = _data["referenceId"];
            (<any>this).customerVatCode = _data["customerVatCode"];
            this.customer = _data["customer"] ? ParkingInvoiceCustomer.fromJS(_data["customer"]) : <any>undefined;
            this.source = _data["source"] ? ParkingInvoiceSource.fromJS(_data["source"]) : <any>undefined;
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>undefined;
            this.companyProjectDetails = _data["companyProjectDetails"] ? CompanyProjectDetails.fromJS(_data["companyProjectDetails"]) : <any>undefined;
            (<any>this).reportingDate = _data["reportingDate"] ? moment(_data["reportingDate"].toString()) : <any>undefined;
            (<any>this).isReported = _data["isReported"];
            if (Array.isArray(_data["reports"])) {
                (<any>this).reports = [] as any;
                for (let item of _data["reports"])
                    (<any>this).reports.push(InvoiceReport.fromJS(item));
            }
            if (Array.isArray(_data["locations"])) {
                (<any>this).locations = [] as any;
                for (let item of _data["locations"])
                    (<any>this).locations.push(ParkingInvoiceLocation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ParkingInvoice {
        data = typeof data === 'object' ? data : {};
        let result = new ParkingInvoice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item.toJSON());
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["invoiceNumber"] = this.invoiceNumber;
        data["invoiceDateUtc"] = this.invoiceDateUtc ? this.invoiceDateUtc.toISOString() : <any>undefined;
        data["totalPrice"] = this.totalPrice ? this.totalPrice.toJSON() : <any>undefined;
        data["discount"] = this.discount ? this.discount.toJSON() : <any>undefined;
        data["netPrice"] = this.netPrice ? this.netPrice.toJSON() : <any>undefined;
        data["vatAmount"] = this.vatAmount ? this.vatAmount.toJSON() : <any>undefined;
        data["vatPercentage"] = this.vatPercentage;
        data["payment"] = this.payment ? this.payment.toJSON() : <any>undefined;
        if (Array.isArray(this.invoiceItems)) {
            data["invoiceItems"] = [];
            for (let item of this.invoiceItems)
                data["invoiceItems"].push(item.toJSON());
        }
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["category"] = this.category ? this.category.toJSON() : <any>undefined;
        data["referenceId"] = this.referenceId;
        data["customerVatCode"] = this.customerVatCode;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["source"] = this.source ? this.source.toJSON() : <any>undefined;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["companyProjectDetails"] = this.companyProjectDetails ? this.companyProjectDetails.toJSON() : <any>undefined;
        data["reportingDate"] = this.reportingDate ? this.reportingDate.toISOString() : <any>undefined;
        data["isReported"] = this.isReported;
        if (Array.isArray(this.reports)) {
            data["reports"] = [];
            for (let item of this.reports)
                data["reports"].push(item.toJSON());
        }
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (let item of this.locations)
                data["locations"].push(item.toJSON());
        }
        return data;
    }

    clone(): ParkingInvoice {
        const json = this.toJSON();
        let result = new ParkingInvoice();
        result.init(json);
        return result;
    }
}

export interface IParkingInvoice {
    id: string;
    domainEvents: IEventData[] | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    invoiceNumber: string | undefined;
    invoiceDateUtc: moment.Moment;
    totalPrice: PriceValueObject;
    discount: PriceValueObject;
    netPrice: PriceValueObject;
    vatAmount: PriceValueObject;
    vatPercentage: number;
    payment: ParkingPayment;
    invoiceItems: ParkingInvoiceItem[] | undefined;
    status: IntegratedInvoiceStatus;
    category: InvoiceCategory;
    referenceId: string | undefined;
    customerVatCode: string | undefined;
    customer: ParkingInvoiceCustomer;
    source: ParkingInvoiceSource;
    address: Address;
    companyProjectDetails: CompanyProjectDetails;
    reportingDate: moment.Moment | undefined;
    isReported: boolean;
    reports: InvoiceReport[] | undefined;
    locations: ParkingInvoiceLocation[] | undefined;
}

export class ParkingInvoiceCustomer implements IParkingInvoiceCustomer {
    vatNumber: string | undefined;
    crNumber: string | undefined;
    contactName: string | undefined;
    contactPhoneNumber: string | undefined;
    country: string | undefined;
    city: string | undefined;
    district: string | undefined;
    postalCode: string | undefined;
    street: string | undefined;
    buildingNumber: string | undefined;

    constructor(data?: IParkingInvoiceCustomer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vatNumber = _data["vatNumber"];
            this.crNumber = _data["crNumber"];
            this.contactName = _data["contactName"];
            this.contactPhoneNumber = _data["contactPhoneNumber"];
            this.country = _data["country"];
            this.city = _data["city"];
            this.district = _data["district"];
            this.postalCode = _data["postalCode"];
            this.street = _data["street"];
            this.buildingNumber = _data["buildingNumber"];
        }
    }

    static fromJS(data: any): ParkingInvoiceCustomer {
        data = typeof data === 'object' ? data : {};
        let result = new ParkingInvoiceCustomer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vatNumber"] = this.vatNumber;
        data["crNumber"] = this.crNumber;
        data["contactName"] = this.contactName;
        data["contactPhoneNumber"] = this.contactPhoneNumber;
        data["country"] = this.country;
        data["city"] = this.city;
        data["district"] = this.district;
        data["postalCode"] = this.postalCode;
        data["street"] = this.street;
        data["buildingNumber"] = this.buildingNumber;
        return data;
    }

    clone(): ParkingInvoiceCustomer {
        const json = this.toJSON();
        let result = new ParkingInvoiceCustomer();
        result.init(json);
        return result;
    }
}

export interface IParkingInvoiceCustomer {
    vatNumber: string | undefined;
    crNumber: string | undefined;
    contactName: string | undefined;
    contactPhoneNumber: string | undefined;
    country: string | undefined;
    city: string | undefined;
    district: string | undefined;
    postalCode: string | undefined;
    street: string | undefined;
    buildingNumber: string | undefined;
}

export class ParkingInvoiceExportExcelResponse implements IParkingInvoiceExportExcelResponse {
    invoiceNumber: string | undefined;
    invoiceDateUtc: moment.Moment;
    totalPrice: number;
    netPrice: number;
    vatAmount: number;
    vatPercentage: number;
    discount: number;
    source: string | undefined;
    paymentType: string | undefined;
    creationTime: moment.Moment;
    isReported: boolean;
    reportingTime: moment.Moment | undefined;
    addressLocation: string | undefined;
    companySite: string | undefined;
    firstInvoiceEntryTime: moment.Moment;
    firstInvoiceExitTime: moment.Moment;
    firstInvoiceUnitCode: string | undefined;
    firstInvoiceName: string | undefined;

    constructor(data?: IParkingInvoiceExportExcelResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceNumber = _data["invoiceNumber"];
            this.invoiceDateUtc = _data["invoiceDateUtc"] ? moment(_data["invoiceDateUtc"].toString()) : <any>undefined;
            this.totalPrice = _data["totalPrice"];
            this.netPrice = _data["netPrice"];
            this.vatAmount = _data["vatAmount"];
            this.vatPercentage = _data["vatPercentage"];
            this.discount = _data["discount"];
            this.source = _data["source"];
            this.paymentType = _data["paymentType"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.isReported = _data["isReported"];
            this.reportingTime = _data["reportingTime"] ? moment(_data["reportingTime"].toString()) : <any>undefined;
            this.addressLocation = _data["addressLocation"];
            this.companySite = _data["companySite"];
            this.firstInvoiceEntryTime = _data["firstInvoiceEntryTime"] ? moment(_data["firstInvoiceEntryTime"].toString()) : <any>undefined;
            this.firstInvoiceExitTime = _data["firstInvoiceExitTime"] ? moment(_data["firstInvoiceExitTime"].toString()) : <any>undefined;
            this.firstInvoiceUnitCode = _data["firstInvoiceUnitCode"];
            this.firstInvoiceName = _data["firstInvoiceName"];
        }
    }

    static fromJS(data: any): ParkingInvoiceExportExcelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ParkingInvoiceExportExcelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceNumber"] = this.invoiceNumber;
        data["invoiceDateUtc"] = this.invoiceDateUtc ? this.invoiceDateUtc.toISOString() : <any>undefined;
        data["totalPrice"] = this.totalPrice;
        data["netPrice"] = this.netPrice;
        data["vatAmount"] = this.vatAmount;
        data["vatPercentage"] = this.vatPercentage;
        data["discount"] = this.discount;
        data["source"] = this.source;
        data["paymentType"] = this.paymentType;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["isReported"] = this.isReported;
        data["reportingTime"] = this.reportingTime ? this.reportingTime.toISOString() : <any>undefined;
        data["addressLocation"] = this.addressLocation;
        data["companySite"] = this.companySite;
        data["firstInvoiceEntryTime"] = this.firstInvoiceEntryTime ? this.firstInvoiceEntryTime.toISOString() : <any>undefined;
        data["firstInvoiceExitTime"] = this.firstInvoiceExitTime ? this.firstInvoiceExitTime.toISOString() : <any>undefined;
        data["firstInvoiceUnitCode"] = this.firstInvoiceUnitCode;
        data["firstInvoiceName"] = this.firstInvoiceName;
        return data;
    }

    clone(): ParkingInvoiceExportExcelResponse {
        const json = this.toJSON();
        let result = new ParkingInvoiceExportExcelResponse();
        result.init(json);
        return result;
    }
}

export interface IParkingInvoiceExportExcelResponse {
    invoiceNumber: string | undefined;
    invoiceDateUtc: moment.Moment;
    totalPrice: number;
    netPrice: number;
    vatAmount: number;
    vatPercentage: number;
    discount: number;
    source: string | undefined;
    paymentType: string | undefined;
    creationTime: moment.Moment;
    isReported: boolean;
    reportingTime: moment.Moment | undefined;
    addressLocation: string | undefined;
    companySite: string | undefined;
    firstInvoiceEntryTime: moment.Moment;
    firstInvoiceExitTime: moment.Moment;
    firstInvoiceUnitCode: string | undefined;
    firstInvoiceName: string | undefined;
}

export class ParkingInvoiceItem implements IParkingInvoiceItem {
    id: string;
    name: string | undefined;
    quantity: number;
    unitPrice: PriceValueObject;
    totalPrice: PriceValueObject;
    netPrice: PriceValueObject;
    vatAmount: PriceValueObject;
    discount: PriceValueObject;
    vatPercentage: number;
    unitCode: InvoiceItemUnitCode;
    entryTime: moment.Moment | undefined;
    exitTime: moment.Moment | undefined;

    constructor(data?: IParkingInvoiceItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.quantity = _data["quantity"];
            this.unitPrice = _data["unitPrice"] ? PriceValueObject.fromJS(_data["unitPrice"]) : <any>undefined;
            this.totalPrice = _data["totalPrice"] ? PriceValueObject.fromJS(_data["totalPrice"]) : <any>undefined;
            this.netPrice = _data["netPrice"] ? PriceValueObject.fromJS(_data["netPrice"]) : <any>undefined;
            this.vatAmount = _data["vatAmount"] ? PriceValueObject.fromJS(_data["vatAmount"]) : <any>undefined;
            this.discount = _data["discount"] ? PriceValueObject.fromJS(_data["discount"]) : <any>undefined;
            this.vatPercentage = _data["vatPercentage"];
            this.unitCode = _data["unitCode"] ? InvoiceItemUnitCode.fromJS(_data["unitCode"]) : <any>undefined;
            this.entryTime = _data["entryTime"] ? moment(_data["entryTime"].toString()) : <any>undefined;
            this.exitTime = _data["exitTime"] ? moment(_data["exitTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ParkingInvoiceItem {
        data = typeof data === 'object' ? data : {};
        let result = new ParkingInvoiceItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["quantity"] = this.quantity;
        data["unitPrice"] = this.unitPrice ? this.unitPrice.toJSON() : <any>undefined;
        data["totalPrice"] = this.totalPrice ? this.totalPrice.toJSON() : <any>undefined;
        data["netPrice"] = this.netPrice ? this.netPrice.toJSON() : <any>undefined;
        data["vatAmount"] = this.vatAmount ? this.vatAmount.toJSON() : <any>undefined;
        data["discount"] = this.discount ? this.discount.toJSON() : <any>undefined;
        data["vatPercentage"] = this.vatPercentage;
        data["unitCode"] = this.unitCode ? this.unitCode.toJSON() : <any>undefined;
        data["entryTime"] = this.entryTime ? this.entryTime.toISOString() : <any>undefined;
        data["exitTime"] = this.exitTime ? this.exitTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): ParkingInvoiceItem {
        const json = this.toJSON();
        let result = new ParkingInvoiceItem();
        result.init(json);
        return result;
    }
}

export interface IParkingInvoiceItem {
    id: string;
    name: string | undefined;
    quantity: number;
    unitPrice: PriceValueObject;
    totalPrice: PriceValueObject;
    netPrice: PriceValueObject;
    vatAmount: PriceValueObject;
    discount: PriceValueObject;
    vatPercentage: number;
    unitCode: InvoiceItemUnitCode;
    entryTime: moment.Moment | undefined;
    exitTime: moment.Moment | undefined;
}

export class ParkingInvoiceItemResponse implements IParkingInvoiceItemResponse {
    id: string;
    name: string | undefined;
    quantity: number;
    unitPrice: number;
    totalPrice: number;
    netPrice: number;
    discount: number;
    vatAmount: number;
    vatPercentage: number;
    unitCode: string | undefined;
    entryTime: moment.Moment | undefined;
    exitTime: moment.Moment | undefined;

    constructor(data?: IParkingInvoiceItemResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.quantity = _data["quantity"];
            this.unitPrice = _data["unitPrice"];
            this.totalPrice = _data["totalPrice"];
            this.netPrice = _data["netPrice"];
            this.discount = _data["discount"];
            this.vatAmount = _data["vatAmount"];
            this.vatPercentage = _data["vatPercentage"];
            this.unitCode = _data["unitCode"];
            this.entryTime = _data["entryTime"] ? moment(_data["entryTime"].toString()) : <any>undefined;
            this.exitTime = _data["exitTime"] ? moment(_data["exitTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ParkingInvoiceItemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ParkingInvoiceItemResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["quantity"] = this.quantity;
        data["unitPrice"] = this.unitPrice;
        data["totalPrice"] = this.totalPrice;
        data["netPrice"] = this.netPrice;
        data["discount"] = this.discount;
        data["vatAmount"] = this.vatAmount;
        data["vatPercentage"] = this.vatPercentage;
        data["unitCode"] = this.unitCode;
        data["entryTime"] = this.entryTime ? this.entryTime.toISOString() : <any>undefined;
        data["exitTime"] = this.exitTime ? this.exitTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): ParkingInvoiceItemResponse {
        const json = this.toJSON();
        let result = new ParkingInvoiceItemResponse();
        result.init(json);
        return result;
    }
}

export interface IParkingInvoiceItemResponse {
    id: string;
    name: string | undefined;
    quantity: number;
    unitPrice: number;
    totalPrice: number;
    netPrice: number;
    discount: number;
    vatAmount: number;
    vatPercentage: number;
    unitCode: string | undefined;
    entryTime: moment.Moment | undefined;
    exitTime: moment.Moment | undefined;
}

export class ParkingInvoiceLocation implements IParkingInvoiceLocation {
    id: string;
    name: string | undefined;
    locationId: number;

    constructor(data?: IParkingInvoiceLocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.locationId = _data["locationId"];
        }
    }

    static fromJS(data: any): ParkingInvoiceLocation {
        data = typeof data === 'object' ? data : {};
        let result = new ParkingInvoiceLocation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["locationId"] = this.locationId;
        return data;
    }

    clone(): ParkingInvoiceLocation {
        const json = this.toJSON();
        let result = new ParkingInvoiceLocation();
        result.init(json);
        return result;
    }
}

export interface IParkingInvoiceLocation {
    id: string;
    name: string | undefined;
    locationId: number;
}

export class ParkingInvoiceResponse implements IParkingInvoiceResponse {
    id: string;
    invoiceNumber: string | undefined;
    invoiceDateUtc: moment.Moment;
    totalPrice: number;
    netPrice: number;
    vatAmount: number;
    vatPercentage: number;
    discount: number;
    currency: string | undefined;
    payment: ParkingPaymentResponse;
    customerVatCode: string | undefined;
    source: string | undefined;
    status: string | undefined;
    category: string | undefined;
    creationTime: moment.Moment;
    isReported: boolean;
    reportingDate: moment.Moment | undefined;
    address: AddressResponse;
    companyProjectDetails: CompanyProjectDetailsResponse;
    reports: InvoiceReportResponse[] | undefined;
    invoiceItems: ParkingInvoiceItemResponse[] | undefined;

    constructor(data?: IParkingInvoiceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.invoiceDateUtc = _data["invoiceDateUtc"] ? moment(_data["invoiceDateUtc"].toString()) : <any>undefined;
            this.totalPrice = _data["totalPrice"];
            this.netPrice = _data["netPrice"];
            this.vatAmount = _data["vatAmount"];
            this.vatPercentage = _data["vatPercentage"];
            this.discount = _data["discount"];
            this.currency = _data["currency"];
            this.payment = _data["payment"] ? ParkingPaymentResponse.fromJS(_data["payment"]) : <any>undefined;
            this.customerVatCode = _data["customerVatCode"];
            this.source = _data["source"];
            this.status = _data["status"];
            this.category = _data["category"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.isReported = _data["isReported"];
            this.reportingDate = _data["reportingDate"] ? moment(_data["reportingDate"].toString()) : <any>undefined;
            this.address = _data["address"] ? AddressResponse.fromJS(_data["address"]) : <any>undefined;
            this.companyProjectDetails = _data["companyProjectDetails"] ? CompanyProjectDetailsResponse.fromJS(_data["companyProjectDetails"]) : <any>undefined;
            if (Array.isArray(_data["reports"])) {
                this.reports = [] as any;
                for (let item of _data["reports"])
                    this.reports.push(InvoiceReportResponse.fromJS(item));
            }
            if (Array.isArray(_data["invoiceItems"])) {
                this.invoiceItems = [] as any;
                for (let item of _data["invoiceItems"])
                    this.invoiceItems.push(ParkingInvoiceItemResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ParkingInvoiceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ParkingInvoiceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["invoiceNumber"] = this.invoiceNumber;
        data["invoiceDateUtc"] = this.invoiceDateUtc ? this.invoiceDateUtc.toISOString() : <any>undefined;
        data["totalPrice"] = this.totalPrice;
        data["netPrice"] = this.netPrice;
        data["vatAmount"] = this.vatAmount;
        data["vatPercentage"] = this.vatPercentage;
        data["discount"] = this.discount;
        data["currency"] = this.currency;
        data["payment"] = this.payment ? this.payment.toJSON() : <any>undefined;
        data["customerVatCode"] = this.customerVatCode;
        data["source"] = this.source;
        data["status"] = this.status;
        data["category"] = this.category;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["isReported"] = this.isReported;
        data["reportingDate"] = this.reportingDate ? this.reportingDate.toISOString() : <any>undefined;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["companyProjectDetails"] = this.companyProjectDetails ? this.companyProjectDetails.toJSON() : <any>undefined;
        if (Array.isArray(this.reports)) {
            data["reports"] = [];
            for (let item of this.reports)
                data["reports"].push(item.toJSON());
        }
        if (Array.isArray(this.invoiceItems)) {
            data["invoiceItems"] = [];
            for (let item of this.invoiceItems)
                data["invoiceItems"].push(item.toJSON());
        }
        return data;
    }

    clone(): ParkingInvoiceResponse {
        const json = this.toJSON();
        let result = new ParkingInvoiceResponse();
        result.init(json);
        return result;
    }
}

export interface IParkingInvoiceResponse {
    id: string;
    invoiceNumber: string | undefined;
    invoiceDateUtc: moment.Moment;
    totalPrice: number;
    netPrice: number;
    vatAmount: number;
    vatPercentage: number;
    discount: number;
    currency: string | undefined;
    payment: ParkingPaymentResponse;
    customerVatCode: string | undefined;
    source: string | undefined;
    status: string | undefined;
    category: string | undefined;
    creationTime: moment.Moment;
    isReported: boolean;
    reportingDate: moment.Moment | undefined;
    address: AddressResponse;
    companyProjectDetails: CompanyProjectDetailsResponse;
    reports: InvoiceReportResponse[] | undefined;
    invoiceItems: ParkingInvoiceItemResponse[] | undefined;
}

export class ParkingInvoiceResponsePagedResultDto implements IParkingInvoiceResponsePagedResultDto {
    items: ParkingInvoiceResponse[] | undefined;
    totalCount: number;

    constructor(data?: IParkingInvoiceResponsePagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ParkingInvoiceResponse.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ParkingInvoiceResponsePagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ParkingInvoiceResponsePagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ParkingInvoiceResponsePagedResultDto {
        const json = this.toJSON();
        let result = new ParkingInvoiceResponsePagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IParkingInvoiceResponsePagedResultDto {
    items: ParkingInvoiceResponse[] | undefined;
    totalCount: number;
}

export class ParkingInvoiceSource implements IParkingInvoiceSource {
    readonly id: number;
    readonly name: string | undefined;

    constructor(data?: IParkingInvoiceSource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).id = _data["id"];
            (<any>this).name = _data["name"];
        }
    }

    static fromJS(data: any): ParkingInvoiceSource {
        data = typeof data === 'object' ? data : {};
        let result = new ParkingInvoiceSource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): ParkingInvoiceSource {
        const json = this.toJSON();
        let result = new ParkingInvoiceSource();
        result.init(json);
        return result;
    }
}

export interface IParkingInvoiceSource {
    id: number;
    name: string | undefined;
}

export class ParkingPayment implements IParkingPayment {
    paymentMethod: PaymentMethodType;
    amount: PriceValueObject;
    pointOfSale: PointOfSale;

    constructor(data?: IParkingPayment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.paymentMethod = new PaymentMethodType();
            this.amount = new PriceValueObject();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentMethod = _data["paymentMethod"] ? PaymentMethodType.fromJS(_data["paymentMethod"]) : new PaymentMethodType();
            this.amount = _data["amount"] ? PriceValueObject.fromJS(_data["amount"]) : new PriceValueObject();
            this.pointOfSale = _data["pointOfSale"] ? PointOfSale.fromJS(_data["pointOfSale"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ParkingPayment {
        data = typeof data === 'object' ? data : {};
        let result = new ParkingPayment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentMethod"] = this.paymentMethod ? this.paymentMethod.toJSON() : <any>undefined;
        data["amount"] = this.amount ? this.amount.toJSON() : <any>undefined;
        data["pointOfSale"] = this.pointOfSale ? this.pointOfSale.toJSON() : <any>undefined;
        return data;
    }

    clone(): ParkingPayment {
        const json = this.toJSON();
        let result = new ParkingPayment();
        result.init(json);
        return result;
    }
}

export interface IParkingPayment {
    paymentMethod: PaymentMethodType;
    amount: PriceValueObject;
    pointOfSale: PointOfSale;
}

export class ParkingPaymentResponse implements IParkingPaymentResponse {
    paymentMethod: string | undefined;
    amount: number;
    cashierId: number;
    shiftId: number;

    constructor(data?: IParkingPaymentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentMethod = _data["paymentMethod"];
            this.amount = _data["amount"];
            this.cashierId = _data["cashierId"];
            this.shiftId = _data["shiftId"];
        }
    }

    static fromJS(data: any): ParkingPaymentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ParkingPaymentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentMethod"] = this.paymentMethod;
        data["amount"] = this.amount;
        data["cashierId"] = this.cashierId;
        data["shiftId"] = this.shiftId;
        return data;
    }

    clone(): ParkingPaymentResponse {
        const json = this.toJSON();
        let result = new ParkingPaymentResponse();
        result.init(json);
        return result;
    }
}

export interface IParkingPaymentResponse {
    paymentMethod: string | undefined;
    amount: number;
    cashierId: number;
    shiftId: number;
}

export class Payment implements IPayment {
    transactionId: string | undefined;
    readonly referenceId: string | undefined;
    entityId: string | undefined;
    readonly brand: string | undefined;
    readonly cardType: string | undefined;
    readonly cardLast4Digits: string | undefined;
    readonly cardHolder: string | undefined;
    readonly cardExpiryMonth: number;
    readonly cardExpiryYear: number;
    status: PaymentStatus;
    readonly statusId: number;
    paymentMethod: OnlinePaymentMethod;
    paymentMethodId: number;

    constructor(data?: IPayment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transactionId = _data["transactionId"];
            (<any>this).referenceId = _data["referenceId"];
            this.entityId = _data["entityId"];
            (<any>this).brand = _data["brand"];
            (<any>this).cardType = _data["cardType"];
            (<any>this).cardLast4Digits = _data["cardLast4Digits"];
            (<any>this).cardHolder = _data["cardHolder"];
            (<any>this).cardExpiryMonth = _data["cardExpiryMonth"];
            (<any>this).cardExpiryYear = _data["cardExpiryYear"];
            this.status = _data["status"] ? PaymentStatus.fromJS(_data["status"]) : <any>undefined;
            (<any>this).statusId = _data["statusId"];
            this.paymentMethod = _data["paymentMethod"] ? OnlinePaymentMethod.fromJS(_data["paymentMethod"]) : <any>undefined;
            this.paymentMethodId = _data["paymentMethodId"];
        }
    }

    static fromJS(data: any): Payment {
        data = typeof data === 'object' ? data : {};
        let result = new Payment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionId"] = this.transactionId;
        data["referenceId"] = this.referenceId;
        data["entityId"] = this.entityId;
        data["brand"] = this.brand;
        data["cardType"] = this.cardType;
        data["cardLast4Digits"] = this.cardLast4Digits;
        data["cardHolder"] = this.cardHolder;
        data["cardExpiryMonth"] = this.cardExpiryMonth;
        data["cardExpiryYear"] = this.cardExpiryYear;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["statusId"] = this.statusId;
        data["paymentMethod"] = this.paymentMethod ? this.paymentMethod.toJSON() : <any>undefined;
        data["paymentMethodId"] = this.paymentMethodId;
        return data;
    }

    clone(): Payment {
        const json = this.toJSON();
        let result = new Payment();
        result.init(json);
        return result;
    }
}

export interface IPayment {
    transactionId: string | undefined;
    referenceId: string | undefined;
    entityId: string | undefined;
    brand: string | undefined;
    cardType: string | undefined;
    cardLast4Digits: string | undefined;
    cardHolder: string | undefined;
    cardExpiryMonth: number;
    cardExpiryYear: number;
    status: PaymentStatus;
    statusId: number;
    paymentMethod: OnlinePaymentMethod;
    paymentMethodId: number;
}

export class PaymentDto implements IPaymentDto {
    referenceId: string | undefined;
    transactionId: string | undefined;
    brand: string | undefined;
    cardType: string | undefined;
    cardLast4Digits: string | undefined;
    cardHolder: string | undefined;
    cardExpiryMonth: number;
    cardExpiryYear: number;
    status: PaymentStatus;
    statusId: number;

    constructor(data?: IPaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.referenceId = _data["referenceId"];
            this.transactionId = _data["transactionId"];
            this.brand = _data["brand"];
            this.cardType = _data["cardType"];
            this.cardLast4Digits = _data["cardLast4Digits"];
            this.cardHolder = _data["cardHolder"];
            this.cardExpiryMonth = _data["cardExpiryMonth"];
            this.cardExpiryYear = _data["cardExpiryYear"];
            this.status = _data["status"] ? PaymentStatus.fromJS(_data["status"]) : <any>undefined;
            this.statusId = _data["statusId"];
        }
    }

    static fromJS(data: any): PaymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["referenceId"] = this.referenceId;
        data["transactionId"] = this.transactionId;
        data["brand"] = this.brand;
        data["cardType"] = this.cardType;
        data["cardLast4Digits"] = this.cardLast4Digits;
        data["cardHolder"] = this.cardHolder;
        data["cardExpiryMonth"] = this.cardExpiryMonth;
        data["cardExpiryYear"] = this.cardExpiryYear;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["statusId"] = this.statusId;
        return data;
    }

    clone(): PaymentDto {
        const json = this.toJSON();
        let result = new PaymentDto();
        result.init(json);
        return result;
    }
}

export interface IPaymentDto {
    referenceId: string | undefined;
    transactionId: string | undefined;
    brand: string | undefined;
    cardType: string | undefined;
    cardLast4Digits: string | undefined;
    cardHolder: string | undefined;
    cardExpiryMonth: number;
    cardExpiryYear: number;
    status: PaymentStatus;
    statusId: number;
}

export class PaymentMethodType implements IPaymentMethodType {
    readonly id: number;
    readonly name: string | undefined;

    constructor(data?: IPaymentMethodType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).id = _data["id"];
            (<any>this).name = _data["name"];
        }
    }

    static fromJS(data: any): PaymentMethodType {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentMethodType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): PaymentMethodType {
        const json = this.toJSON();
        let result = new PaymentMethodType();
        result.init(json);
        return result;
    }
}

export interface IPaymentMethodType {
    id: number;
    name: string | undefined;
}

export class PaymentResult implements IPaymentResult {
    code: string | undefined;
    description: string | undefined;
    parameterErrors: ParameterErrors[] | undefined;

    constructor(data?: IPaymentResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.description = _data["description"];
            if (Array.isArray(_data["parameterErrors"])) {
                this.parameterErrors = [] as any;
                for (let item of _data["parameterErrors"])
                    this.parameterErrors.push(ParameterErrors.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaymentResult {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["description"] = this.description;
        if (Array.isArray(this.parameterErrors)) {
            data["parameterErrors"] = [];
            for (let item of this.parameterErrors)
                data["parameterErrors"].push(item.toJSON());
        }
        return data;
    }

    clone(): PaymentResult {
        const json = this.toJSON();
        let result = new PaymentResult();
        result.init(json);
        return result;
    }
}

export interface IPaymentResult {
    code: string | undefined;
    description: string | undefined;
    parameterErrors: ParameterErrors[] | undefined;
}

export class PaymentSettingsEditDto implements IPaymentSettingsEditDto {
    baseURL: string | undefined;
    token: string | undefined;
    checkoutPath: string | undefined;
    queryPath: string | undefined;
    paymentPath: string | undefined;
    currency: string | undefined;
    paymentType: string | undefined;
    refundType: string | undefined;
    entityIdForCards: string | undefined;
    entityIdForApplePay: string | undefined;
    configurationKey: string | undefined;
    testMode: boolean;
    vatPercentage: number;
    moneyMultiplicationFactor: number;

    constructor(data?: IPaymentSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseURL = _data["baseURL"];
            this.token = _data["token"];
            this.checkoutPath = _data["checkoutPath"];
            this.queryPath = _data["queryPath"];
            this.paymentPath = _data["paymentPath"];
            this.currency = _data["currency"];
            this.paymentType = _data["paymentType"];
            this.refundType = _data["refundType"];
            this.entityIdForCards = _data["entityIdForCards"];
            this.entityIdForApplePay = _data["entityIdForApplePay"];
            this.configurationKey = _data["configurationKey"];
            this.testMode = _data["testMode"];
            this.vatPercentage = _data["vatPercentage"];
            this.moneyMultiplicationFactor = _data["moneyMultiplicationFactor"];
        }
    }

    static fromJS(data: any): PaymentSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseURL"] = this.baseURL;
        data["token"] = this.token;
        data["checkoutPath"] = this.checkoutPath;
        data["queryPath"] = this.queryPath;
        data["paymentPath"] = this.paymentPath;
        data["currency"] = this.currency;
        data["paymentType"] = this.paymentType;
        data["refundType"] = this.refundType;
        data["entityIdForCards"] = this.entityIdForCards;
        data["entityIdForApplePay"] = this.entityIdForApplePay;
        data["configurationKey"] = this.configurationKey;
        data["testMode"] = this.testMode;
        data["vatPercentage"] = this.vatPercentage;
        data["moneyMultiplicationFactor"] = this.moneyMultiplicationFactor;
        return data;
    }

    clone(): PaymentSettingsEditDto {
        const json = this.toJSON();
        let result = new PaymentSettingsEditDto();
        result.init(json);
        return result;
    }
}

export interface IPaymentSettingsEditDto {
    baseURL: string | undefined;
    token: string | undefined;
    checkoutPath: string | undefined;
    queryPath: string | undefined;
    paymentPath: string | undefined;
    currency: string | undefined;
    paymentType: string | undefined;
    refundType: string | undefined;
    entityIdForCards: string | undefined;
    entityIdForApplePay: string | undefined;
    configurationKey: string | undefined;
    testMode: boolean;
    vatPercentage: number;
    moneyMultiplicationFactor: number;
}

export class PaymentStatus implements IPaymentStatus {
    readonly name: string | undefined;
    readonly id: number;
    code: string | undefined;

    constructor(data?: IPaymentStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data["name"];
            (<any>this).id = _data["id"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): PaymentStatus {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        data["code"] = this.code;
        return data;
    }

    clone(): PaymentStatus {
        const json = this.toJSON();
        let result = new PaymentStatus();
        result.init(json);
        return result;
    }
}

export interface IPaymentStatus {
    name: string | undefined;
    id: number;
    code: string | undefined;
}

export enum PaymentType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class PermissionDto implements IPermissionDto {
    id: number;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    parent: FlatPermissionDto;
    readonly children: FlatPermissionDto[] | undefined;

    constructor(data?: IPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.parent = _data["parent"] ? FlatPermissionDto.fromJS(_data["parent"]) : <any>undefined;
            if (Array.isArray(_data["children"])) {
                (<any>this).children = [] as any;
                for (let item of _data["children"])
                    (<any>this).children.push(FlatPermissionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["parent"] = this.parent ? this.parent.toJSON() : <any>undefined;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        return data;
    }

    clone(): PermissionDto {
        const json = this.toJSON();
        let result = new PermissionDto();
        result.init(json);
        return result;
    }
}

export interface IPermissionDto {
    id: number;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    parent: FlatPermissionDto;
    children: FlatPermissionDto[] | undefined;
}

export class PermissionDtoListResultDto implements IPermissionDtoListResultDto {
    items: PermissionDto[] | undefined;

    constructor(data?: IPermissionDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PermissionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PermissionDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PermissionDtoListResultDto {
        const json = this.toJSON();
        let result = new PermissionDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IPermissionDtoListResultDto {
    items: PermissionDto[] | undefined;
}

export class PlateMapLetter implements IPlateMapLetter {
    id: string;
    countryId: number;
    country: Country;
    mappingKey: string;
    mappingValue: string;

    constructor(data?: IPlateMapLetter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.countryId = _data["countryId"];
            this.country = _data["country"] ? Country.fromJS(_data["country"]) : <any>undefined;
            this.mappingKey = _data["mappingKey"];
            this.mappingValue = _data["mappingValue"];
        }
    }

    static fromJS(data: any): PlateMapLetter {
        data = typeof data === 'object' ? data : {};
        let result = new PlateMapLetter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["countryId"] = this.countryId;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        data["mappingKey"] = this.mappingKey;
        data["mappingValue"] = this.mappingValue;
        return data;
    }

    clone(): PlateMapLetter {
        const json = this.toJSON();
        let result = new PlateMapLetter();
        result.init(json);
        return result;
    }
}

export interface IPlateMapLetter {
    id: string;
    countryId: number;
    country: Country;
    mappingKey: string;
    mappingValue: string;
}

export class PlateValidation implements IPlateValidation {
    id: string;
    mobilityType: MobilityType;
    minLetters: number;
    maxLetters: number;
    minDigits: number;
    maxDigits: number;
    isArabicLetters: boolean;
    countryId: number;

    constructor(data?: IPlateValidation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.mobilityType = _data["mobilityType"] ? MobilityType.fromJS(_data["mobilityType"]) : <any>undefined;
            this.minLetters = _data["minLetters"];
            this.maxLetters = _data["maxLetters"];
            this.minDigits = _data["minDigits"];
            this.maxDigits = _data["maxDigits"];
            this.isArabicLetters = _data["isArabicLetters"];
            this.countryId = _data["countryId"];
        }
    }

    static fromJS(data: any): PlateValidation {
        data = typeof data === 'object' ? data : {};
        let result = new PlateValidation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["mobilityType"] = this.mobilityType ? this.mobilityType.toJSON() : <any>undefined;
        data["minLetters"] = this.minLetters;
        data["maxLetters"] = this.maxLetters;
        data["minDigits"] = this.minDigits;
        data["maxDigits"] = this.maxDigits;
        data["isArabicLetters"] = this.isArabicLetters;
        data["countryId"] = this.countryId;
        return data;
    }

    clone(): PlateValidation {
        const json = this.toJSON();
        let result = new PlateValidation();
        result.init(json);
        return result;
    }
}

export interface IPlateValidation {
    id: string;
    mobilityType: MobilityType;
    minLetters: number;
    maxLetters: number;
    minDigits: number;
    maxDigits: number;
    isArabicLetters: boolean;
    countryId: number;
}

export class PlateValidationDto implements IPlateValidationDto {
    minLetters: number;
    maxLetters: number;
    minDigits: number;
    maxDigits: number;
    isArabicLetters: boolean;
    mobilityType: string | undefined;

    constructor(data?: IPlateValidationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.minLetters = _data["minLetters"];
            this.maxLetters = _data["maxLetters"];
            this.minDigits = _data["minDigits"];
            this.maxDigits = _data["maxDigits"];
            this.isArabicLetters = _data["isArabicLetters"];
            this.mobilityType = _data["mobilityType"];
        }
    }

    static fromJS(data: any): PlateValidationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlateValidationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minLetters"] = this.minLetters;
        data["maxLetters"] = this.maxLetters;
        data["minDigits"] = this.minDigits;
        data["maxDigits"] = this.maxDigits;
        data["isArabicLetters"] = this.isArabicLetters;
        data["mobilityType"] = this.mobilityType;
        return data;
    }

    clone(): PlateValidationDto {
        const json = this.toJSON();
        let result = new PlateValidationDto();
        result.init(json);
        return result;
    }
}

export interface IPlateValidationDto {
    minLetters: number;
    maxLetters: number;
    minDigits: number;
    maxDigits: number;
    isArabicLetters: boolean;
    mobilityType: string | undefined;
}

export class Point implements IPoint {
    factory: GeometryFactory;
    userData: any | undefined;
    srid: number;
    precisionModel: PrecisionModel;
    readonly numGeometries: number;
    readonly isSimple: boolean;
    readonly isValid: boolean;
    readonly area: number;
    readonly length: number;
    centroid: Point;
    interiorPoint: Point;
    pointOnSurface: Point;
    envelope: Geometry;
    envelopeInternal: Envelope;
    readonly isRectangle: boolean;
    coordinateSequence: CoordinateSequence;
    readonly coordinates: Coordinate[] | undefined;
    readonly numPoints: number;
    readonly isEmpty: boolean;
    dimension: Dimension;
    boundaryDimension: Dimension;
    x: number;
    y: number;
    coordinate: Coordinate;
    readonly geometryType: string | undefined;
    ogcGeometryType: OgcGeometryType;
    boundary: Geometry;
    z: number;
    m: number;

    constructor(data?: IPoint) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.factory = _data["factory"] ? GeometryFactory.fromJS(_data["factory"]) : <any>undefined;
            this.userData = _data["userData"];
            this.srid = _data["srid"];
            this.precisionModel = _data["precisionModel"] ? PrecisionModel.fromJS(_data["precisionModel"]) : <any>undefined;
            (<any>this).numGeometries = _data["numGeometries"];
            (<any>this).isSimple = _data["isSimple"];
            (<any>this).isValid = _data["isValid"];
            (<any>this).area = _data["area"];
            (<any>this).length = _data["length"];
            this.centroid = _data["centroid"] ? Point.fromJS(_data["centroid"]) : <any>undefined;
            this.interiorPoint = _data["interiorPoint"] ? Point.fromJS(_data["interiorPoint"]) : <any>undefined;
            this.pointOnSurface = _data["pointOnSurface"] ? Point.fromJS(_data["pointOnSurface"]) : <any>undefined;
            this.envelope = _data["envelope"] ? Geometry.fromJS(_data["envelope"]) : <any>undefined;
            this.envelopeInternal = _data["envelopeInternal"] ? Envelope.fromJS(_data["envelopeInternal"]) : <any>undefined;
            (<any>this).isRectangle = _data["isRectangle"];
            this.coordinateSequence = _data["coordinateSequence"] ? CoordinateSequence.fromJS(_data["coordinateSequence"]) : <any>undefined;
            if (Array.isArray(_data["coordinates"])) {
                (<any>this).coordinates = [] as any;
                for (let item of _data["coordinates"])
                    (<any>this).coordinates.push(Coordinate.fromJS(item));
            }
            (<any>this).numPoints = _data["numPoints"];
            (<any>this).isEmpty = _data["isEmpty"];
            this.dimension = _data["dimension"];
            this.boundaryDimension = _data["boundaryDimension"];
            this.x = _data["x"];
            this.y = _data["y"];
            this.coordinate = _data["coordinate"] ? Coordinate.fromJS(_data["coordinate"]) : <any>undefined;
            (<any>this).geometryType = _data["geometryType"];
            this.ogcGeometryType = _data["ogcGeometryType"];
            this.boundary = _data["boundary"] ? Geometry.fromJS(_data["boundary"]) : <any>undefined;
            this.z = _data["z"];
            this.m = _data["m"];
        }
    }

    static fromJS(data: any): Point {
        data = typeof data === 'object' ? data : {};
        let result = new Point();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["factory"] = this.factory ? this.factory.toJSON() : <any>undefined;
        data["userData"] = this.userData;
        data["srid"] = this.srid;
        data["precisionModel"] = this.precisionModel ? this.precisionModel.toJSON() : <any>undefined;
        data["numGeometries"] = this.numGeometries;
        data["isSimple"] = this.isSimple;
        data["isValid"] = this.isValid;
        data["area"] = this.area;
        data["length"] = this.length;
        data["centroid"] = this.centroid ? this.centroid.toJSON() : <any>undefined;
        data["interiorPoint"] = this.interiorPoint ? this.interiorPoint.toJSON() : <any>undefined;
        data["pointOnSurface"] = this.pointOnSurface ? this.pointOnSurface.toJSON() : <any>undefined;
        data["envelope"] = this.envelope ? this.envelope.toJSON() : <any>undefined;
        data["envelopeInternal"] = this.envelopeInternal ? this.envelopeInternal.toJSON() : <any>undefined;
        data["isRectangle"] = this.isRectangle;
        data["coordinateSequence"] = this.coordinateSequence ? this.coordinateSequence.toJSON() : <any>undefined;
        if (Array.isArray(this.coordinates)) {
            data["coordinates"] = [];
            for (let item of this.coordinates)
                data["coordinates"].push(item.toJSON());
        }
        data["numPoints"] = this.numPoints;
        data["isEmpty"] = this.isEmpty;
        data["dimension"] = this.dimension;
        data["boundaryDimension"] = this.boundaryDimension;
        data["x"] = this.x;
        data["y"] = this.y;
        data["coordinate"] = this.coordinate ? this.coordinate.toJSON() : <any>undefined;
        data["geometryType"] = this.geometryType;
        data["ogcGeometryType"] = this.ogcGeometryType;
        data["boundary"] = this.boundary ? this.boundary.toJSON() : <any>undefined;
        data["z"] = this.z;
        data["m"] = this.m;
        return data;
    }

    clone(): Point {
        const json = this.toJSON();
        let result = new Point();
        result.init(json);
        return result;
    }
}

export interface IPoint {
    factory: GeometryFactory;
    userData: any | undefined;
    srid: number;
    precisionModel: PrecisionModel;
    numGeometries: number;
    isSimple: boolean;
    isValid: boolean;
    area: number;
    length: number;
    centroid: Point;
    interiorPoint: Point;
    pointOnSurface: Point;
    envelope: Geometry;
    envelopeInternal: Envelope;
    isRectangle: boolean;
    coordinateSequence: CoordinateSequence;
    coordinates: Coordinate[] | undefined;
    numPoints: number;
    isEmpty: boolean;
    dimension: Dimension;
    boundaryDimension: Dimension;
    x: number;
    y: number;
    coordinate: Coordinate;
    geometryType: string | undefined;
    ogcGeometryType: OgcGeometryType;
    boundary: Geometry;
    z: number;
    m: number;
}

export class PointOfSale implements IPointOfSale {
    cashierId: number;
    shiftId: number;

    constructor(data?: IPointOfSale) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cashierId = _data["cashierId"];
            this.shiftId = _data["shiftId"];
        }
    }

    static fromJS(data: any): PointOfSale {
        data = typeof data === 'object' ? data : {};
        let result = new PointOfSale();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cashierId"] = this.cashierId;
        data["shiftId"] = this.shiftId;
        return data;
    }

    clone(): PointOfSale {
        const json = this.toJSON();
        let result = new PointOfSale();
        result.init(json);
        return result;
    }
}

export interface IPointOfSale {
    cashierId: number;
    shiftId: number;
}

export class PrecisionModel implements IPrecisionModel {
    readonly isFloating: boolean;
    readonly maximumSignificantDigits: number;
    scale: number;
    readonly gridSize: number;
    precisionModelType: PrecisionModels;

    constructor(data?: IPrecisionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).isFloating = _data["isFloating"];
            (<any>this).maximumSignificantDigits = _data["maximumSignificantDigits"];
            this.scale = _data["scale"];
            (<any>this).gridSize = _data["gridSize"];
            this.precisionModelType = _data["precisionModelType"];
        }
    }

    static fromJS(data: any): PrecisionModel {
        data = typeof data === 'object' ? data : {};
        let result = new PrecisionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isFloating"] = this.isFloating;
        data["maximumSignificantDigits"] = this.maximumSignificantDigits;
        data["scale"] = this.scale;
        data["gridSize"] = this.gridSize;
        data["precisionModelType"] = this.precisionModelType;
        return data;
    }

    clone(): PrecisionModel {
        const json = this.toJSON();
        let result = new PrecisionModel();
        result.init(json);
        return result;
    }
}

export interface IPrecisionModel {
    isFloating: boolean;
    maximumSignificantDigits: number;
    scale: number;
    gridSize: number;
    precisionModelType: PrecisionModels;
}

export enum PrecisionModels {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class Price implements IPrice {
    id: number;
    hourRate: number;
    name: string | undefined;
    towingRate: number;
    clampingRate: number;
    impoundRatePerDay: number;

    constructor(data?: IPrice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.hourRate = _data["hourRate"];
            this.name = _data["name"];
            this.towingRate = _data["towingRate"];
            this.clampingRate = _data["clampingRate"];
            this.impoundRatePerDay = _data["impoundRatePerDay"];
        }
    }

    static fromJS(data: any): Price {
        data = typeof data === 'object' ? data : {};
        let result = new Price();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["hourRate"] = this.hourRate;
        data["name"] = this.name;
        data["towingRate"] = this.towingRate;
        data["clampingRate"] = this.clampingRate;
        data["impoundRatePerDay"] = this.impoundRatePerDay;
        return data;
    }

    clone(): Price {
        const json = this.toJSON();
        let result = new Price();
        result.init(json);
        return result;
    }
}

export interface IPrice {
    id: number;
    hourRate: number;
    name: string | undefined;
    towingRate: number;
    clampingRate: number;
    impoundRatePerDay: number;
}

export class PriceDto implements IPriceDto {
    id: number;
    name: string | undefined;

    constructor(data?: IPriceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): PriceDto {
        data = typeof data === 'object' ? data : {};
        let result = new PriceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): PriceDto {
        const json = this.toJSON();
        let result = new PriceDto();
        result.init(json);
        return result;
    }
}

export interface IPriceDto {
    id: number;
    name: string | undefined;
}

export class PriceListDto implements IPriceListDto {
    id: number;
    hourRate: number;
    name: string | undefined;
    towingRate: number;
    clampingRate: number;

    constructor(data?: IPriceListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.hourRate = _data["hourRate"];
            this.name = _data["name"];
            this.towingRate = _data["towingRate"];
            this.clampingRate = _data["clampingRate"];
        }
    }

    static fromJS(data: any): PriceListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PriceListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["hourRate"] = this.hourRate;
        data["name"] = this.name;
        data["towingRate"] = this.towingRate;
        data["clampingRate"] = this.clampingRate;
        return data;
    }

    clone(): PriceListDto {
        const json = this.toJSON();
        let result = new PriceListDto();
        result.init(json);
        return result;
    }
}

export interface IPriceListDto {
    id: number;
    hourRate: number;
    name: string | undefined;
    towingRate: number;
    clampingRate: number;
}

export class PriceListDtoPagedResultDto implements IPriceListDtoPagedResultDto {
    items: PriceListDto[] | undefined;
    totalCount: number;

    constructor(data?: IPriceListDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PriceListDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PriceListDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PriceListDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): PriceListDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PriceListDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPriceListDtoPagedResultDto {
    items: PriceListDto[] | undefined;
    totalCount: number;
}

export class PriceValueObject implements IPriceValueObject {
    value: number;
    currency: string;

    constructor(data?: IPriceValueObject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.currency = _data["currency"];
        }
    }

    static fromJS(data: any): PriceValueObject {
        data = typeof data === 'object' ? data : {};
        let result = new PriceValueObject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["currency"] = this.currency;
        return data;
    }

    clone(): PriceValueObject {
        const json = this.toJSON();
        let result = new PriceValueObject();
        result.init(json);
        return result;
    }
}

export interface IPriceValueObject {
    value: number;
    currency: string;
}

export class QRCode implements IQRCode {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    code: string | undefined;
    name: string | undefined;
    locationId: number;
    location: Location;
    description: string | undefined;
    url: string | undefined;
    isActive: boolean;
    readonly qrCodesSlots: QRCodeSlot[] | undefined;

    constructor(data?: IQRCode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.code = _data["code"];
            this.name = _data["name"];
            this.locationId = _data["locationId"];
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : <any>undefined;
            this.description = _data["description"];
            this.url = _data["url"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["qrCodesSlots"])) {
                (<any>this).qrCodesSlots = [] as any;
                for (let item of _data["qrCodesSlots"])
                    (<any>this).qrCodesSlots.push(QRCodeSlot.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QRCode {
        data = typeof data === 'object' ? data : {};
        let result = new QRCode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["code"] = this.code;
        data["name"] = this.name;
        data["locationId"] = this.locationId;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["description"] = this.description;
        data["url"] = this.url;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.qrCodesSlots)) {
            data["qrCodesSlots"] = [];
            for (let item of this.qrCodesSlots)
                data["qrCodesSlots"].push(item.toJSON());
        }
        return data;
    }

    clone(): QRCode {
        const json = this.toJSON();
        let result = new QRCode();
        result.init(json);
        return result;
    }
}

export interface IQRCode {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    code: string | undefined;
    name: string | undefined;
    locationId: number;
    location: Location;
    description: string | undefined;
    url: string | undefined;
    isActive: boolean;
    qrCodesSlots: QRCodeSlot[] | undefined;
}

export class QRCodeDetailsDto implements IQRCodeDetailsDto {
    id: number;
    name: string | undefined;
    code: string | undefined;
    description: string | undefined;
    location: LocationListDto;
    slots: SlotListDto[] | undefined;
    vatPercentage: number;

    constructor(data?: IQRCodeDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.description = _data["description"];
            this.location = _data["location"] ? LocationListDto.fromJS(_data["location"]) : <any>undefined;
            if (Array.isArray(_data["slots"])) {
                this.slots = [] as any;
                for (let item of _data["slots"])
                    this.slots.push(SlotListDto.fromJS(item));
            }
            this.vatPercentage = _data["vatPercentage"];
        }
    }

    static fromJS(data: any): QRCodeDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new QRCodeDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        data["description"] = this.description;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        if (Array.isArray(this.slots)) {
            data["slots"] = [];
            for (let item of this.slots)
                data["slots"].push(item.toJSON());
        }
        data["vatPercentage"] = this.vatPercentage;
        return data;
    }

    clone(): QRCodeDetailsDto {
        const json = this.toJSON();
        let result = new QRCodeDetailsDto();
        result.init(json);
        return result;
    }
}

export interface IQRCodeDetailsDto {
    id: number;
    name: string | undefined;
    code: string | undefined;
    description: string | undefined;
    location: LocationListDto;
    slots: SlotListDto[] | undefined;
    vatPercentage: number;
}

export class QRCodeListDto implements IQRCodeListDto {
    id: number;
    name: string | undefined;
    code: string | undefined;
    description: string | undefined;
    url: string | undefined;
    isActive: boolean;
    slots: string[] | undefined;

    constructor(data?: IQRCodeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.description = _data["description"];
            this.url = _data["url"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["slots"])) {
                this.slots = [] as any;
                for (let item of _data["slots"])
                    this.slots.push(item);
            }
        }
    }

    static fromJS(data: any): QRCodeListDto {
        data = typeof data === 'object' ? data : {};
        let result = new QRCodeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        data["description"] = this.description;
        data["url"] = this.url;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.slots)) {
            data["slots"] = [];
            for (let item of this.slots)
                data["slots"].push(item);
        }
        return data;
    }

    clone(): QRCodeListDto {
        const json = this.toJSON();
        let result = new QRCodeListDto();
        result.init(json);
        return result;
    }
}

export interface IQRCodeListDto {
    id: number;
    name: string | undefined;
    code: string | undefined;
    description: string | undefined;
    url: string | undefined;
    isActive: boolean;
    slots: string[] | undefined;
}

export class QRCodeListDtoPagedResultDto implements IQRCodeListDtoPagedResultDto {
    items: QRCodeListDto[] | undefined;
    totalCount: number;

    constructor(data?: IQRCodeListDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(QRCodeListDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): QRCodeListDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new QRCodeListDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): QRCodeListDtoPagedResultDto {
        const json = this.toJSON();
        let result = new QRCodeListDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IQRCodeListDtoPagedResultDto {
    items: QRCodeListDto[] | undefined;
    totalCount: number;
}

export class QRCodeSlot implements IQRCodeSlot {
    readonly qrCodeId: number;
    slotId: number;
    qrCode: QRCode;
    slot: Slot;

    constructor(data?: IQRCodeSlot) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).qrCodeId = _data["qrCodeId"];
            this.slotId = _data["slotId"];
            this.qrCode = _data["qrCode"] ? QRCode.fromJS(_data["qrCode"]) : <any>undefined;
            this.slot = _data["slot"] ? Slot.fromJS(_data["slot"]) : <any>undefined;
        }
    }

    static fromJS(data: any): QRCodeSlot {
        data = typeof data === 'object' ? data : {};
        let result = new QRCodeSlot();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qrCodeId"] = this.qrCodeId;
        data["slotId"] = this.slotId;
        data["qrCode"] = this.qrCode ? this.qrCode.toJSON() : <any>undefined;
        data["slot"] = this.slot ? this.slot.toJSON() : <any>undefined;
        return data;
    }

    clone(): QRCodeSlot {
        const json = this.toJSON();
        let result = new QRCodeSlot();
        result.init(json);
        return result;
    }
}

export interface IQRCodeSlot {
    qrCodeId: number;
    slotId: number;
    qrCode: QRCode;
    slot: Slot;
}

export class ReceiptSettingsEditDto implements IReceiptSettingsEditDto {
    seller: string | undefined;
    sellerAr: string | undefined;
    logo: string | undefined;
    itemName: string | undefined;
    crNumber: string | undefined;
    vatNumber: string | undefined;

    constructor(data?: IReceiptSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.seller = _data["seller"];
            this.sellerAr = _data["sellerAr"];
            this.logo = _data["logo"];
            this.itemName = _data["itemName"];
            this.crNumber = _data["crNumber"];
            this.vatNumber = _data["vatNumber"];
        }
    }

    static fromJS(data: any): ReceiptSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReceiptSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["seller"] = this.seller;
        data["sellerAr"] = this.sellerAr;
        data["logo"] = this.logo;
        data["itemName"] = this.itemName;
        data["crNumber"] = this.crNumber;
        data["vatNumber"] = this.vatNumber;
        return data;
    }

    clone(): ReceiptSettingsEditDto {
        const json = this.toJSON();
        let result = new ReceiptSettingsEditDto();
        result.init(json);
        return result;
    }
}

export interface IReceiptSettingsEditDto {
    seller: string | undefined;
    sellerAr: string | undefined;
    logo: string | undefined;
    itemName: string | undefined;
    crNumber: string | undefined;
    vatNumber: string | undefined;
}

export class RecieptHeaderDto implements IRecieptHeaderDto {
    sellerName: string | undefined;
    sellerNameAr: string | undefined;
    crNumber: string | undefined;
    vatNumber: string | undefined;
    logo: string | undefined;

    constructor(data?: IRecieptHeaderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sellerName = _data["sellerName"];
            this.sellerNameAr = _data["sellerNameAr"];
            this.crNumber = _data["crNumber"];
            this.vatNumber = _data["vatNumber"];
            this.logo = _data["logo"];
        }
    }

    static fromJS(data: any): RecieptHeaderDto {
        data = typeof data === 'object' ? data : {};
        let result = new RecieptHeaderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sellerName"] = this.sellerName;
        data["sellerNameAr"] = this.sellerNameAr;
        data["crNumber"] = this.crNumber;
        data["vatNumber"] = this.vatNumber;
        data["logo"] = this.logo;
        return data;
    }

    clone(): RecieptHeaderDto {
        const json = this.toJSON();
        let result = new RecieptHeaderDto();
        result.init(json);
        return result;
    }
}

export interface IRecieptHeaderDto {
    sellerName: string | undefined;
    sellerNameAr: string | undefined;
    crNumber: string | undefined;
    vatNumber: string | undefined;
    logo: string | undefined;
}

export class RegisterInput implements IRegisterInput {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    password: string;
    captchaResponse: string | undefined;

    constructor(data?: IRegisterInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.password = _data["password"];
            this.captchaResponse = _data["captchaResponse"];
        }
    }

    static fromJS(data: any): RegisterInput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["password"] = this.password;
        data["captchaResponse"] = this.captchaResponse;
        return data;
    }

    clone(): RegisterInput {
        const json = this.toJSON();
        let result = new RegisterInput();
        result.init(json);
        return result;
    }
}

export interface IRegisterInput {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    password: string;
    captchaResponse: string | undefined;
}

export class RegisterOutput implements IRegisterOutput {
    canLogin: boolean;

    constructor(data?: IRegisterOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canLogin = _data["canLogin"];
        }
    }

    static fromJS(data: any): RegisterOutput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canLogin"] = this.canLogin;
        return data;
    }

    clone(): RegisterOutput {
        const json = this.toJSON();
        let result = new RegisterOutput();
        result.init(json);
        return result;
    }
}

export interface IRegisterOutput {
    canLogin: boolean;
}

export class RejectCancellationRequest implements IRejectCancellationRequest {
    requestId: string;
    notes: string | undefined;
    attachments: CreateAttachmentDto[] | undefined;

    constructor(data?: IRejectCancellationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestId = _data["requestId"];
            this.notes = _data["notes"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments.push(CreateAttachmentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RejectCancellationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RejectCancellationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestId"] = this.requestId;
        data["notes"] = this.notes;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        return data;
    }

    clone(): RejectCancellationRequest {
        const json = this.toJSON();
        let result = new RejectCancellationRequest();
        result.init(json);
        return result;
    }
}

export interface IRejectCancellationRequest {
    requestId: string;
    notes: string | undefined;
    attachments: CreateAttachmentDto[] | undefined;
}

export class RenewReservationCashInputDTO implements IRenewReservationCashInputDTO {
    reservationId: string;
    hours: number;

    constructor(data?: IRenewReservationCashInputDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reservationId = _data["reservationId"];
            this.hours = _data["hours"];
        }
    }

    static fromJS(data: any): RenewReservationCashInputDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RenewReservationCashInputDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reservationId"] = this.reservationId;
        data["hours"] = this.hours;
        return data;
    }

    clone(): RenewReservationCashInputDTO {
        const json = this.toJSON();
        let result = new RenewReservationCashInputDTO();
        result.init(json);
        return result;
    }
}

export interface IRenewReservationCashInputDTO {
    reservationId: string;
    hours: number;
}

export class RenewReservationOnlineInputDTO implements IRenewReservationOnlineInputDTO {
    reservationId: string;
    onlinePaymentMethodId: number;
    hours: number;

    constructor(data?: IRenewReservationOnlineInputDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reservationId = _data["reservationId"];
            this.onlinePaymentMethodId = _data["onlinePaymentMethodId"];
            this.hours = _data["hours"];
        }
    }

    static fromJS(data: any): RenewReservationOnlineInputDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RenewReservationOnlineInputDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reservationId"] = this.reservationId;
        data["onlinePaymentMethodId"] = this.onlinePaymentMethodId;
        data["hours"] = this.hours;
        return data;
    }

    clone(): RenewReservationOnlineInputDTO {
        const json = this.toJSON();
        let result = new RenewReservationOnlineInputDTO();
        result.init(json);
        return result;
    }
}

export interface IRenewReservationOnlineInputDTO {
    reservationId: string;
    onlinePaymentMethodId: number;
    hours: number;
}

export class RenewReservationPOSInputDTO implements IRenewReservationPOSInputDTO {
    posTransactionId: string | undefined;
    reservationId: string;
    hours: number;

    constructor(data?: IRenewReservationPOSInputDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.posTransactionId = _data["posTransactionId"];
            this.reservationId = _data["reservationId"];
            this.hours = _data["hours"];
        }
    }

    static fromJS(data: any): RenewReservationPOSInputDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RenewReservationPOSInputDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["posTransactionId"] = this.posTransactionId;
        data["reservationId"] = this.reservationId;
        data["hours"] = this.hours;
        return data;
    }

    clone(): RenewReservationPOSInputDTO {
        const json = this.toJSON();
        let result = new RenewReservationPOSInputDTO();
        result.init(json);
        return result;
    }
}

export interface IRenewReservationPOSInputDTO {
    posTransactionId: string | undefined;
    reservationId: string;
    hours: number;
}

export class RenewReservationResponse implements IRenewReservationResponse {
    response: CheckoutReservationOutput;
    isRenewed: boolean;

    constructor(data?: IRenewReservationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.response = _data["response"] ? CheckoutReservationOutput.fromJS(_data["response"]) : <any>undefined;
            this.isRenewed = _data["isRenewed"];
        }
    }

    static fromJS(data: any): RenewReservationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RenewReservationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["response"] = this.response ? this.response.toJSON() : <any>undefined;
        data["isRenewed"] = this.isRenewed;
        return data;
    }

    clone(): RenewReservationResponse {
        const json = this.toJSON();
        let result = new RenewReservationResponse();
        result.init(json);
        return result;
    }
}

export interface IRenewReservationResponse {
    response: CheckoutReservationOutput;
    isRenewed: boolean;
}

export class RenewZatcaDeviceDto implements IRenewZatcaDeviceDto {
    id: string;
    otp: string | undefined;

    constructor(data?: IRenewZatcaDeviceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.otp = _data["otp"];
        }
    }

    static fromJS(data: any): RenewZatcaDeviceDto {
        data = typeof data === 'object' ? data : {};
        let result = new RenewZatcaDeviceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["otp"] = this.otp;
        return data;
    }

    clone(): RenewZatcaDeviceDto {
        const json = this.toJSON();
        let result = new RenewZatcaDeviceDto();
        result.init(json);
        return result;
    }
}

export interface IRenewZatcaDeviceDto {
    id: string;
    otp: string | undefined;
}

export class ReportDetailsResponse implements IReportDetailsResponse {
    id: string;
    qrCode: string | undefined;
    reportingDate: moment.Moment;
    reportStatus: string | undefined;

    constructor(data?: IReportDetailsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.qrCode = _data["qrCode"];
            this.reportingDate = _data["reportingDate"] ? moment(_data["reportingDate"].toString()) : <any>undefined;
            this.reportStatus = _data["reportStatus"];
        }
    }

    static fromJS(data: any): ReportDetailsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ReportDetailsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["qrCode"] = this.qrCode;
        data["reportingDate"] = this.reportingDate ? this.reportingDate.toISOString() : <any>undefined;
        data["reportStatus"] = this.reportStatus;
        return data;
    }

    clone(): ReportDetailsResponse {
        const json = this.toJSON();
        let result = new ReportDetailsResponse();
        result.init(json);
        return result;
    }
}

export interface IReportDetailsResponse {
    id: string;
    qrCode: string | undefined;
    reportingDate: moment.Moment;
    reportStatus: string | undefined;
}

export class ReportInvoiceDto implements IReportInvoiceDto {
    source: string | undefined;

    constructor(data?: IReportInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.source = _data["source"];
        }
    }

    static fromJS(data: any): ReportInvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportInvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["source"] = this.source;
        return data;
    }

    clone(): ReportInvoiceDto {
        const json = this.toJSON();
        let result = new ReportInvoiceDto();
        result.init(json);
        return result;
    }
}

export interface IReportInvoiceDto {
    source: string | undefined;
}

export class ReportParkingInvoiceRequest implements IReportParkingInvoiceRequest {
    invoiceId: string;

    constructor(data?: IReportParkingInvoiceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceId = _data["invoiceId"];
        }
    }

    static fromJS(data: any): ReportParkingInvoiceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ReportParkingInvoiceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceId"] = this.invoiceId;
        return data;
    }

    clone(): ReportParkingInvoiceRequest {
        const json = this.toJSON();
        let result = new ReportParkingInvoiceRequest();
        result.init(json);
        return result;
    }
}

export interface IReportParkingInvoiceRequest {
    invoiceId: string;
}

export class ReportStatus implements IReportStatus {
    readonly id: number;
    readonly name: string | undefined;

    constructor(data?: IReportStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).id = _data["id"];
            (<any>this).name = _data["name"];
        }
    }

    static fromJS(data: any): ReportStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ReportStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): ReportStatus {
        const json = this.toJSON();
        let result = new ReportStatus();
        result.init(json);
        return result;
    }
}

export interface IReportStatus {
    id: number;
    name: string | undefined;
}

export class RequestState implements IRequestState {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    creatorUser: User;
    status: RequestStatus;
    readonly notes: string | undefined;
    readonly duration: number;
    readonly isActive: boolean;
    readonly version: string | undefined;

    constructor(data?: IRequestState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            this.status = _data["status"] ? RequestStatus.fromJS(_data["status"]) : <any>undefined;
            (<any>this).notes = _data["notes"];
            (<any>this).duration = _data["duration"];
            (<any>this).isActive = _data["isActive"];
            (<any>this).version = _data["version"];
        }
    }

    static fromJS(data: any): RequestState {
        data = typeof data === 'object' ? data : {};
        let result = new RequestState();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["notes"] = this.notes;
        data["duration"] = this.duration;
        data["isActive"] = this.isActive;
        data["version"] = this.version;
        return data;
    }

    clone(): RequestState {
        const json = this.toJSON();
        let result = new RequestState();
        result.init(json);
        return result;
    }
}

export interface IRequestState {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    creatorUser: User;
    status: RequestStatus;
    notes: string | undefined;
    duration: number;
    isActive: boolean;
    version: string | undefined;
}

export class RequestStatus implements IRequestStatus {
    readonly id: number;
    readonly name: string | undefined;

    constructor(data?: IRequestStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).id = _data["id"];
            (<any>this).name = _data["name"];
        }
    }

    static fromJS(data: any): RequestStatus {
        data = typeof data === 'object' ? data : {};
        let result = new RequestStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): RequestStatus {
        const json = this.toJSON();
        let result = new RequestStatus();
        result.init(json);
        return result;
    }
}

export interface IRequestStatus {
    id: number;
    name: string | undefined;
}

export class RequestType implements IRequestType {
    readonly id: number;
    readonly name: string | undefined;

    constructor(data?: IRequestType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).id = _data["id"];
            (<any>this).name = _data["name"];
        }
    }

    static fromJS(data: any): RequestType {
        data = typeof data === 'object' ? data : {};
        let result = new RequestType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): RequestType {
        const json = this.toJSON();
        let result = new RequestType();
        result.init(json);
        return result;
    }
}

export interface IRequestType {
    id: number;
    name: string | undefined;
}

export class Reservation implements IReservation {
    id: string;
    readonly domainEvents: IEventData[] | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creatorUser: User;
    lastModifierUser: User;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    readonly invoiceNumber: number;
    firstname: string | undefined;
    lastname: string | undefined;
    readonly qrCodeId: number | undefined;
    qrCode: QRCode;
    readonly code: string | undefined;
    readonly countryCode: string | undefined;
    readonly slotId: number;
    slot: Slot;
    readonly hours: number;
    readonly phoneNumber: string | undefined;
    carPlate: CarPlate;
    readonly vehicleId: string | undefined;
    vehicle: Vehicle;
    readonly hourRate: number;
    readonly vatPercentage: number;
    readonly currency: string | undefined;
    paymentType: PaymentType;
    payment: Payment;
    status: ReservationStatus;
    readonly total: number;
    readonly totalPaid: number;
    readonly totalHours: number;
    readonly subTotal: number;
    readonly vatAmount: number;
    readonly endTime: moment.Moment | undefined;
    readonly isActive: boolean;
    readonly shiftId: string | undefined;
    readonly startTime: moment.Moment;
    shift: StaffAccountShift;
    reservationDetails: ReservationDetail[] | undefined;

    constructor(data?: IReservation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["domainEvents"])) {
                (<any>this).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (<any>this).domainEvents.push(IEventData.fromJS(item));
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            (<any>this).invoiceNumber = _data["invoiceNumber"];
            this.firstname = _data["firstname"];
            this.lastname = _data["lastname"];
            (<any>this).qrCodeId = _data["qrCodeId"];
            this.qrCode = _data["qrCode"] ? QRCode.fromJS(_data["qrCode"]) : <any>undefined;
            (<any>this).code = _data["code"];
            (<any>this).countryCode = _data["countryCode"];
            (<any>this).slotId = _data["slotId"];
            this.slot = _data["slot"] ? Slot.fromJS(_data["slot"]) : <any>undefined;
            (<any>this).hours = _data["hours"];
            (<any>this).phoneNumber = _data["phoneNumber"];
            this.carPlate = _data["carPlate"] ? CarPlate.fromJS(_data["carPlate"]) : <any>undefined;
            (<any>this).vehicleId = _data["vehicleId"];
            this.vehicle = _data["vehicle"] ? Vehicle.fromJS(_data["vehicle"]) : <any>undefined;
            (<any>this).hourRate = _data["hourRate"];
            (<any>this).vatPercentage = _data["vatPercentage"];
            (<any>this).currency = _data["currency"];
            this.paymentType = _data["paymentType"];
            this.payment = _data["payment"] ? Payment.fromJS(_data["payment"]) : <any>undefined;
            this.status = _data["status"];
            (<any>this).total = _data["total"];
            (<any>this).totalPaid = _data["totalPaid"];
            (<any>this).totalHours = _data["totalHours"];
            (<any>this).subTotal = _data["subTotal"];
            (<any>this).vatAmount = _data["vatAmount"];
            (<any>this).endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
            (<any>this).isActive = _data["isActive"];
            (<any>this).shiftId = _data["shiftId"];
            (<any>this).startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.shift = _data["shift"] ? StaffAccountShift.fromJS(_data["shift"]) : <any>undefined;
            if (Array.isArray(_data["reservationDetails"])) {
                this.reservationDetails = [] as any;
                for (let item of _data["reservationDetails"])
                    this.reservationDetails.push(ReservationDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Reservation {
        data = typeof data === 'object' ? data : {};
        let result = new Reservation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item.toJSON());
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["invoiceNumber"] = this.invoiceNumber;
        data["firstname"] = this.firstname;
        data["lastname"] = this.lastname;
        data["qrCodeId"] = this.qrCodeId;
        data["qrCode"] = this.qrCode ? this.qrCode.toJSON() : <any>undefined;
        data["code"] = this.code;
        data["countryCode"] = this.countryCode;
        data["slotId"] = this.slotId;
        data["slot"] = this.slot ? this.slot.toJSON() : <any>undefined;
        data["hours"] = this.hours;
        data["phoneNumber"] = this.phoneNumber;
        data["carPlate"] = this.carPlate ? this.carPlate.toJSON() : <any>undefined;
        data["vehicleId"] = this.vehicleId;
        data["vehicle"] = this.vehicle ? this.vehicle.toJSON() : <any>undefined;
        data["hourRate"] = this.hourRate;
        data["vatPercentage"] = this.vatPercentage;
        data["currency"] = this.currency;
        data["paymentType"] = this.paymentType;
        data["payment"] = this.payment ? this.payment.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["total"] = this.total;
        data["totalPaid"] = this.totalPaid;
        data["totalHours"] = this.totalHours;
        data["subTotal"] = this.subTotal;
        data["vatAmount"] = this.vatAmount;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["shiftId"] = this.shiftId;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["shift"] = this.shift ? this.shift.toJSON() : <any>undefined;
        if (Array.isArray(this.reservationDetails)) {
            data["reservationDetails"] = [];
            for (let item of this.reservationDetails)
                data["reservationDetails"].push(item.toJSON());
        }
        return data;
    }

    clone(): Reservation {
        const json = this.toJSON();
        let result = new Reservation();
        result.init(json);
        return result;
    }
}

export interface IReservation {
    id: string;
    domainEvents: IEventData[] | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creatorUser: User;
    lastModifierUser: User;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    invoiceNumber: number;
    firstname: string | undefined;
    lastname: string | undefined;
    qrCodeId: number | undefined;
    qrCode: QRCode;
    code: string | undefined;
    countryCode: string | undefined;
    slotId: number;
    slot: Slot;
    hours: number;
    phoneNumber: string | undefined;
    carPlate: CarPlate;
    vehicleId: string | undefined;
    vehicle: Vehicle;
    hourRate: number;
    vatPercentage: number;
    currency: string | undefined;
    paymentType: PaymentType;
    payment: Payment;
    status: ReservationStatus;
    total: number;
    totalPaid: number;
    totalHours: number;
    subTotal: number;
    vatAmount: number;
    endTime: moment.Moment | undefined;
    isActive: boolean;
    shiftId: string | undefined;
    startTime: moment.Moment;
    shift: StaffAccountShift;
    reservationDetails: ReservationDetail[] | undefined;
}

export class ReservationDetail implements IReservationDetail {
    id: string;
    readonly domainEvents: IEventData[] | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creatorUser: User;
    lastModifierUser: User;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    readonly invoiceNumberValue: number;
    startTime: moment.Moment;
    hours: number;
    hourRate: number;
    reservationId: string;
    readonly shiftId: string | undefined;
    status: ReservationStatus;
    endTime: moment.Moment | undefined;
    reservation: Reservation;
    shift: StaffAccountShift;
    readonly totalPaid: number;
    readonly invoiceNumber: string | undefined;

    constructor(data?: IReservationDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["domainEvents"])) {
                (<any>this).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (<any>this).domainEvents.push(IEventData.fromJS(item));
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            (<any>this).invoiceNumberValue = _data["invoiceNumberValue"];
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.hours = _data["hours"];
            this.hourRate = _data["hourRate"];
            this.reservationId = _data["reservationId"];
            (<any>this).shiftId = _data["shiftId"];
            this.status = _data["status"];
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
            this.reservation = _data["reservation"] ? Reservation.fromJS(_data["reservation"]) : <any>undefined;
            this.shift = _data["shift"] ? StaffAccountShift.fromJS(_data["shift"]) : <any>undefined;
            (<any>this).totalPaid = _data["totalPaid"];
            (<any>this).invoiceNumber = _data["invoiceNumber"];
        }
    }

    static fromJS(data: any): ReservationDetail {
        data = typeof data === 'object' ? data : {};
        let result = new ReservationDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item.toJSON());
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["invoiceNumberValue"] = this.invoiceNumberValue;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["hours"] = this.hours;
        data["hourRate"] = this.hourRate;
        data["reservationId"] = this.reservationId;
        data["shiftId"] = this.shiftId;
        data["status"] = this.status;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["reservation"] = this.reservation ? this.reservation.toJSON() : <any>undefined;
        data["shift"] = this.shift ? this.shift.toJSON() : <any>undefined;
        data["totalPaid"] = this.totalPaid;
        data["invoiceNumber"] = this.invoiceNumber;
        return data;
    }

    clone(): ReservationDetail {
        const json = this.toJSON();
        let result = new ReservationDetail();
        result.init(json);
        return result;
    }
}

export interface IReservationDetail {
    id: string;
    domainEvents: IEventData[] | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creatorUser: User;
    lastModifierUser: User;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    invoiceNumberValue: number;
    startTime: moment.Moment;
    hours: number;
    hourRate: number;
    reservationId: string;
    shiftId: string | undefined;
    status: ReservationStatus;
    endTime: moment.Moment | undefined;
    reservation: Reservation;
    shift: StaffAccountShift;
    totalPaid: number;
    invoiceNumber: string | undefined;
}

export class ReservationDetailDTO implements IReservationDetailDTO {
    id: string;
    invoiceNumber: number;
    startTime: moment.Moment;
    hours: number;
    status: ReservationStatus;
    transactions: TransactionDto[] | undefined;
    total: number;
    readonly subTotal: number;
    readonly vatAmount: number;
    vatPercentage: number;

    constructor(data?: IReservationDetailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.hours = _data["hours"];
            this.status = _data["status"];
            if (Array.isArray(_data["transactions"])) {
                this.transactions = [] as any;
                for (let item of _data["transactions"])
                    this.transactions.push(TransactionDto.fromJS(item));
            }
            this.total = _data["total"];
            (<any>this).subTotal = _data["subTotal"];
            (<any>this).vatAmount = _data["vatAmount"];
            this.vatPercentage = _data["vatPercentage"];
        }
    }

    static fromJS(data: any): ReservationDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ReservationDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["invoiceNumber"] = this.invoiceNumber;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["hours"] = this.hours;
        data["status"] = this.status;
        if (Array.isArray(this.transactions)) {
            data["transactions"] = [];
            for (let item of this.transactions)
                data["transactions"].push(item.toJSON());
        }
        data["total"] = this.total;
        data["subTotal"] = this.subTotal;
        data["vatAmount"] = this.vatAmount;
        data["vatPercentage"] = this.vatPercentage;
        return data;
    }

    clone(): ReservationDetailDTO {
        const json = this.toJSON();
        let result = new ReservationDetailDTO();
        result.init(json);
        return result;
    }
}

export interface IReservationDetailDTO {
    id: string;
    invoiceNumber: number;
    startTime: moment.Moment;
    hours: number;
    status: ReservationStatus;
    transactions: TransactionDto[] | undefined;
    total: number;
    subTotal: number;
    vatAmount: number;
    vatPercentage: number;
}

export class ReservationDetailInvoiceDto implements IReservationDetailInvoiceDto {
    reservationDetailId: string;
    invoiceNumber: string | undefined;
    startTime: moment.Moment;
    endTime: moment.Moment | undefined;
    creationDate: moment.Moment;
    paymentType: PaymentType;
    totalHours: number;
    invoiceStatus: InvoiceStatus;

    constructor(data?: IReservationDetailInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reservationDetailId = _data["reservationDetailId"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
            this.creationDate = _data["creationDate"] ? moment(_data["creationDate"].toString()) : <any>undefined;
            this.paymentType = _data["paymentType"];
            this.totalHours = _data["totalHours"];
            this.invoiceStatus = _data["invoiceStatus"];
        }
    }

    static fromJS(data: any): ReservationDetailInvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReservationDetailInvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reservationDetailId"] = this.reservationDetailId;
        data["invoiceNumber"] = this.invoiceNumber;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
        data["paymentType"] = this.paymentType;
        data["totalHours"] = this.totalHours;
        data["invoiceStatus"] = this.invoiceStatus;
        return data;
    }

    clone(): ReservationDetailInvoiceDto {
        const json = this.toJSON();
        let result = new ReservationDetailInvoiceDto();
        result.init(json);
        return result;
    }
}

export interface IReservationDetailInvoiceDto {
    reservationDetailId: string;
    invoiceNumber: string | undefined;
    startTime: moment.Moment;
    endTime: moment.Moment | undefined;
    creationDate: moment.Moment;
    paymentType: PaymentType;
    totalHours: number;
    invoiceStatus: InvoiceStatus;
}

export class ReservationDetailOutputDto implements IReservationDetailOutputDto {
    reservationDetail: ReservationDetailsDto;
    transaction: TransactionDto;

    constructor(data?: IReservationDetailOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reservationDetail = _data["reservationDetail"] ? ReservationDetailsDto.fromJS(_data["reservationDetail"]) : <any>undefined;
            this.transaction = _data["transaction"] ? TransactionDto.fromJS(_data["transaction"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ReservationDetailOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReservationDetailOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reservationDetail"] = this.reservationDetail ? this.reservationDetail.toJSON() : <any>undefined;
        data["transaction"] = this.transaction ? this.transaction.toJSON() : <any>undefined;
        return data;
    }

    clone(): ReservationDetailOutputDto {
        const json = this.toJSON();
        let result = new ReservationDetailOutputDto();
        result.init(json);
        return result;
    }
}

export interface IReservationDetailOutputDto {
    reservationDetail: ReservationDetailsDto;
    transaction: TransactionDto;
}

export class ReservationDetailOutputDtoPagedResultDto implements IReservationDetailOutputDtoPagedResultDto {
    items: ReservationDetailOutputDto[] | undefined;
    totalCount: number;

    constructor(data?: IReservationDetailOutputDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ReservationDetailOutputDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ReservationDetailOutputDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReservationDetailOutputDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ReservationDetailOutputDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ReservationDetailOutputDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IReservationDetailOutputDtoPagedResultDto {
    items: ReservationDetailOutputDto[] | undefined;
    totalCount: number;
}

export class ReservationDetailsDto implements IReservationDetailsDto {
    id: string;
    invoiceNumberValue: number;
    startTime: moment.Moment;
    hours: number;
    subTotal: number;
    total: number;
    vatAmount: number;
    location: LocationDto;
    slot: SlotDto;
    vehicle: VehicleDto;
    hourRate: number;
    reservationId: string;
    shiftId: string | undefined;
    status: ReservationStatus;
    endTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    creator: string | undefined;

    constructor(data?: IReservationDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.invoiceNumberValue = _data["invoiceNumberValue"];
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.hours = _data["hours"];
            this.subTotal = _data["subTotal"];
            this.total = _data["total"];
            this.vatAmount = _data["vatAmount"];
            this.location = _data["location"] ? LocationDto.fromJS(_data["location"]) : <any>undefined;
            this.slot = _data["slot"] ? SlotDto.fromJS(_data["slot"]) : <any>undefined;
            this.vehicle = _data["vehicle"] ? VehicleDto.fromJS(_data["vehicle"]) : <any>undefined;
            this.hourRate = _data["hourRate"];
            this.reservationId = _data["reservationId"];
            this.shiftId = _data["shiftId"];
            this.status = _data["status"];
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creator = _data["creator"];
        }
    }

    static fromJS(data: any): ReservationDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReservationDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["invoiceNumberValue"] = this.invoiceNumberValue;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["hours"] = this.hours;
        data["subTotal"] = this.subTotal;
        data["total"] = this.total;
        data["vatAmount"] = this.vatAmount;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["slot"] = this.slot ? this.slot.toJSON() : <any>undefined;
        data["vehicle"] = this.vehicle ? this.vehicle.toJSON() : <any>undefined;
        data["hourRate"] = this.hourRate;
        data["reservationId"] = this.reservationId;
        data["shiftId"] = this.shiftId;
        data["status"] = this.status;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creator"] = this.creator;
        return data;
    }

    clone(): ReservationDetailsDto {
        const json = this.toJSON();
        let result = new ReservationDetailsDto();
        result.init(json);
        return result;
    }
}

export interface IReservationDetailsDto {
    id: string;
    invoiceNumberValue: number;
    startTime: moment.Moment;
    hours: number;
    subTotal: number;
    total: number;
    vatAmount: number;
    location: LocationDto;
    slot: SlotDto;
    vehicle: VehicleDto;
    hourRate: number;
    reservationId: string;
    shiftId: string | undefined;
    status: ReservationStatus;
    endTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    creator: string | undefined;
}

export class ReservationDetailsView implements IReservationDetailsView {
    reservationDetailsId: string;
    reservationNumber: number;
    reservationDetailsStartTime: moment.Moment;
    reservationDetailsEndTime: moment.Moment | undefined;
    reservationDetailsStatus: ReservationStatus;
    reservationDetailsHours: number;
    parentReservationStartTime: moment.Moment;
    parentReservationEndTime: moment.Moment;
    reservationDetailsInvoiceNumber: number;
    parentReservationId: string;
    parentReservationStatus: ReservationStatus;
    carPlate: string | undefined;
    firstname: string | undefined;
    lastname: string | undefined;
    mobileNumber: string | undefined;
    parentTotalHours: number;
    vatPercentage: number;
    hourRate: number;
    readonly vatAmount: number;
    total: number;
    subTotal: number;
    creationTime: moment.Moment;
    creator: string | undefined;
    locationName: string | undefined;
    locationId: number;
    slotName: string | undefined;
    slotId: number;
    invoiceNumber: string | undefined;
    paymentType: PaymentType;
    transactionReferenceId: string | undefined;
    currency: string | undefined;
    posTransactionId: string | undefined;
    transactionId: string | undefined;
    sucessReservations: number;
    paymentTypes: string | undefined;
    shiftId: string | undefined;
    parentTotalAmount: number;
    parentVATAmount: number;
    successInvoiceNumber: string | undefined;
    successPaymentType: PaymentType;
    successTransactionReferenceId: string | undefined;
    successCurrency: string | undefined;
    successPOSTransactionId: string | undefined;
    successTransactionStatus: string | undefined;
    successTransactionId: string | undefined;
    failedPaymentType: PaymentType;
    failedTransactionReferenceId: string | undefined;
    failedCurrency: string | undefined;
    failedPOSTransactionId: string | undefined;
    failedTransactionStatus: string | undefined;
    failedTransactionId: string | undefined;
    pendingPaymentType: PaymentType;
    pendingTransactionReferenceId: string | undefined;
    pendingCurrency: string | undefined;
    pendingPOSTransactionId: string | undefined;
    pendingTransactionStatus: string | undefined;
    pendingTransactionId: string | undefined;

    constructor(data?: IReservationDetailsView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reservationDetailsId = _data["reservationDetailsId"];
            this.reservationNumber = _data["reservationNumber"];
            this.reservationDetailsStartTime = _data["reservationDetailsStartTime"] ? moment(_data["reservationDetailsStartTime"].toString()) : <any>undefined;
            this.reservationDetailsEndTime = _data["reservationDetailsEndTime"] ? moment(_data["reservationDetailsEndTime"].toString()) : <any>undefined;
            this.reservationDetailsStatus = _data["reservationDetailsStatus"];
            this.reservationDetailsHours = _data["reservationDetailsHours"];
            this.parentReservationStartTime = _data["parentReservationStartTime"] ? moment(_data["parentReservationStartTime"].toString()) : <any>undefined;
            this.parentReservationEndTime = _data["parentReservationEndTime"] ? moment(_data["parentReservationEndTime"].toString()) : <any>undefined;
            this.reservationDetailsInvoiceNumber = _data["reservationDetailsInvoiceNumber"];
            this.parentReservationId = _data["parentReservationId"];
            this.parentReservationStatus = _data["parentReservationStatus"];
            this.carPlate = _data["carPlate"];
            this.firstname = _data["firstname"];
            this.lastname = _data["lastname"];
            this.mobileNumber = _data["mobileNumber"];
            this.parentTotalHours = _data["parentTotalHours"];
            this.vatPercentage = _data["vatPercentage"];
            this.hourRate = _data["hourRate"];
            (<any>this).vatAmount = _data["vatAmount"];
            this.total = _data["total"];
            this.subTotal = _data["subTotal"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creator = _data["creator"];
            this.locationName = _data["locationName"];
            this.locationId = _data["locationId"];
            this.slotName = _data["slotName"];
            this.slotId = _data["slotId"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.paymentType = _data["paymentType"];
            this.transactionReferenceId = _data["transactionReferenceId"];
            this.currency = _data["currency"];
            this.posTransactionId = _data["posTransactionId"];
            this.transactionId = _data["transactionId"];
            this.sucessReservations = _data["sucessReservations"];
            this.paymentTypes = _data["paymentTypes"];
            this.shiftId = _data["shiftId"];
            this.parentTotalAmount = _data["parentTotalAmount"];
            this.parentVATAmount = _data["parentVATAmount"];
            this.successInvoiceNumber = _data["successInvoiceNumber"];
            this.successPaymentType = _data["successPaymentType"];
            this.successTransactionReferenceId = _data["successTransactionReferenceId"];
            this.successCurrency = _data["successCurrency"];
            this.successPOSTransactionId = _data["successPOSTransactionId"];
            this.successTransactionStatus = _data["successTransactionStatus"];
            this.successTransactionId = _data["successTransactionId"];
            this.failedPaymentType = _data["failedPaymentType"];
            this.failedTransactionReferenceId = _data["failedTransactionReferenceId"];
            this.failedCurrency = _data["failedCurrency"];
            this.failedPOSTransactionId = _data["failedPOSTransactionId"];
            this.failedTransactionStatus = _data["failedTransactionStatus"];
            this.failedTransactionId = _data["failedTransactionId"];
            this.pendingPaymentType = _data["pendingPaymentType"];
            this.pendingTransactionReferenceId = _data["pendingTransactionReferenceId"];
            this.pendingCurrency = _data["pendingCurrency"];
            this.pendingPOSTransactionId = _data["pendingPOSTransactionId"];
            this.pendingTransactionStatus = _data["pendingTransactionStatus"];
            this.pendingTransactionId = _data["pendingTransactionId"];
        }
    }

    static fromJS(data: any): ReservationDetailsView {
        data = typeof data === 'object' ? data : {};
        let result = new ReservationDetailsView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reservationDetailsId"] = this.reservationDetailsId;
        data["reservationNumber"] = this.reservationNumber;
        data["reservationDetailsStartTime"] = this.reservationDetailsStartTime ? this.reservationDetailsStartTime.toISOString() : <any>undefined;
        data["reservationDetailsEndTime"] = this.reservationDetailsEndTime ? this.reservationDetailsEndTime.toISOString() : <any>undefined;
        data["reservationDetailsStatus"] = this.reservationDetailsStatus;
        data["reservationDetailsHours"] = this.reservationDetailsHours;
        data["parentReservationStartTime"] = this.parentReservationStartTime ? this.parentReservationStartTime.toISOString() : <any>undefined;
        data["parentReservationEndTime"] = this.parentReservationEndTime ? this.parentReservationEndTime.toISOString() : <any>undefined;
        data["reservationDetailsInvoiceNumber"] = this.reservationDetailsInvoiceNumber;
        data["parentReservationId"] = this.parentReservationId;
        data["parentReservationStatus"] = this.parentReservationStatus;
        data["carPlate"] = this.carPlate;
        data["firstname"] = this.firstname;
        data["lastname"] = this.lastname;
        data["mobileNumber"] = this.mobileNumber;
        data["parentTotalHours"] = this.parentTotalHours;
        data["vatPercentage"] = this.vatPercentage;
        data["hourRate"] = this.hourRate;
        data["vatAmount"] = this.vatAmount;
        data["total"] = this.total;
        data["subTotal"] = this.subTotal;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creator"] = this.creator;
        data["locationName"] = this.locationName;
        data["locationId"] = this.locationId;
        data["slotName"] = this.slotName;
        data["slotId"] = this.slotId;
        data["invoiceNumber"] = this.invoiceNumber;
        data["paymentType"] = this.paymentType;
        data["transactionReferenceId"] = this.transactionReferenceId;
        data["currency"] = this.currency;
        data["posTransactionId"] = this.posTransactionId;
        data["transactionId"] = this.transactionId;
        data["sucessReservations"] = this.sucessReservations;
        data["paymentTypes"] = this.paymentTypes;
        data["shiftId"] = this.shiftId;
        data["parentTotalAmount"] = this.parentTotalAmount;
        data["parentVATAmount"] = this.parentVATAmount;
        data["successInvoiceNumber"] = this.successInvoiceNumber;
        data["successPaymentType"] = this.successPaymentType;
        data["successTransactionReferenceId"] = this.successTransactionReferenceId;
        data["successCurrency"] = this.successCurrency;
        data["successPOSTransactionId"] = this.successPOSTransactionId;
        data["successTransactionStatus"] = this.successTransactionStatus;
        data["successTransactionId"] = this.successTransactionId;
        data["failedPaymentType"] = this.failedPaymentType;
        data["failedTransactionReferenceId"] = this.failedTransactionReferenceId;
        data["failedCurrency"] = this.failedCurrency;
        data["failedPOSTransactionId"] = this.failedPOSTransactionId;
        data["failedTransactionStatus"] = this.failedTransactionStatus;
        data["failedTransactionId"] = this.failedTransactionId;
        data["pendingPaymentType"] = this.pendingPaymentType;
        data["pendingTransactionReferenceId"] = this.pendingTransactionReferenceId;
        data["pendingCurrency"] = this.pendingCurrency;
        data["pendingPOSTransactionId"] = this.pendingPOSTransactionId;
        data["pendingTransactionStatus"] = this.pendingTransactionStatus;
        data["pendingTransactionId"] = this.pendingTransactionId;
        return data;
    }

    clone(): ReservationDetailsView {
        const json = this.toJSON();
        let result = new ReservationDetailsView();
        result.init(json);
        return result;
    }
}

export interface IReservationDetailsView {
    reservationDetailsId: string;
    reservationNumber: number;
    reservationDetailsStartTime: moment.Moment;
    reservationDetailsEndTime: moment.Moment | undefined;
    reservationDetailsStatus: ReservationStatus;
    reservationDetailsHours: number;
    parentReservationStartTime: moment.Moment;
    parentReservationEndTime: moment.Moment;
    reservationDetailsInvoiceNumber: number;
    parentReservationId: string;
    parentReservationStatus: ReservationStatus;
    carPlate: string | undefined;
    firstname: string | undefined;
    lastname: string | undefined;
    mobileNumber: string | undefined;
    parentTotalHours: number;
    vatPercentage: number;
    hourRate: number;
    vatAmount: number;
    total: number;
    subTotal: number;
    creationTime: moment.Moment;
    creator: string | undefined;
    locationName: string | undefined;
    locationId: number;
    slotName: string | undefined;
    slotId: number;
    invoiceNumber: string | undefined;
    paymentType: PaymentType;
    transactionReferenceId: string | undefined;
    currency: string | undefined;
    posTransactionId: string | undefined;
    transactionId: string | undefined;
    sucessReservations: number;
    paymentTypes: string | undefined;
    shiftId: string | undefined;
    parentTotalAmount: number;
    parentVATAmount: number;
    successInvoiceNumber: string | undefined;
    successPaymentType: PaymentType;
    successTransactionReferenceId: string | undefined;
    successCurrency: string | undefined;
    successPOSTransactionId: string | undefined;
    successTransactionStatus: string | undefined;
    successTransactionId: string | undefined;
    failedPaymentType: PaymentType;
    failedTransactionReferenceId: string | undefined;
    failedCurrency: string | undefined;
    failedPOSTransactionId: string | undefined;
    failedTransactionStatus: string | undefined;
    failedTransactionId: string | undefined;
    pendingPaymentType: PaymentType;
    pendingTransactionReferenceId: string | undefined;
    pendingCurrency: string | undefined;
    pendingPOSTransactionId: string | undefined;
    pendingTransactionStatus: string | undefined;
    pendingTransactionId: string | undefined;
}

export class ReservationDetailsViewDto implements IReservationDetailsViewDto {
    reservationDetailsId: string;
    reservationNumber: string | undefined;
    reservationDetailsStartTime: moment.Moment;
    reservationDetailsEndTime: moment.Moment;
    reservationDetailsStatus: ReservationStatus;
    reservationDetailsHours: number;
    parentReservationId: string;
    carPlate: string | undefined;
    firstname: string | undefined;
    lastname: string | undefined;
    mobileNumber: string | undefined;
    vatPercentage: number;
    readonly vatAmount: number;
    total: number;
    subTotal: number;
    creationTime: moment.Moment;
    creator: string | undefined;
    locationName: string | undefined;
    locationId: number;
    slotName: string | undefined;
    slotId: number;
    paymentType: PaymentType;
    sucessReservations: number;
    parentTotalAmount: number;
    parentVATAmount: number;
    successInvoiceNumber: string | undefined;
    successPaymentType: PaymentType;
    successTransactionReferenceId: string | undefined;
    successCurrency: string | undefined;
    successPOSTransactionId: string | undefined;
    successTransactionStatus: string | undefined;
    successTransactionId: string | undefined;
    failedPaymentType: PaymentType;
    failedTransactionReferenceId: string | undefined;
    failedCurrency: string | undefined;
    failedPOSTransactionId: string | undefined;
    failedTransactionStatus: string | undefined;
    failedTransactionId: string | undefined;
    pendingPaymentType: PaymentType;
    pendingTransactionReferenceId: string | undefined;
    pendingCurrency: string | undefined;
    pendingPOSTransactionId: string | undefined;
    pendingTransactionStatus: string | undefined;
    pendingTransactionId: string | undefined;

    constructor(data?: IReservationDetailsViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reservationDetailsId = _data["reservationDetailsId"];
            this.reservationNumber = _data["reservationNumber"];
            this.reservationDetailsStartTime = _data["reservationDetailsStartTime"] ? moment(_data["reservationDetailsStartTime"].toString()) : <any>undefined;
            this.reservationDetailsEndTime = _data["reservationDetailsEndTime"] ? moment(_data["reservationDetailsEndTime"].toString()) : <any>undefined;
            this.reservationDetailsStatus = _data["reservationDetailsStatus"];
            this.reservationDetailsHours = _data["reservationDetailsHours"];
            this.parentReservationId = _data["parentReservationId"];
            this.carPlate = _data["carPlate"];
            this.firstname = _data["firstname"];
            this.lastname = _data["lastname"];
            this.mobileNumber = _data["mobileNumber"];
            this.vatPercentage = _data["vatPercentage"];
            (<any>this).vatAmount = _data["vatAmount"];
            this.total = _data["total"];
            this.subTotal = _data["subTotal"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creator = _data["creator"];
            this.locationName = _data["locationName"];
            this.locationId = _data["locationId"];
            this.slotName = _data["slotName"];
            this.slotId = _data["slotId"];
            this.paymentType = _data["paymentType"];
            this.sucessReservations = _data["sucessReservations"];
            this.parentTotalAmount = _data["parentTotalAmount"];
            this.parentVATAmount = _data["parentVATAmount"];
            this.successInvoiceNumber = _data["successInvoiceNumber"];
            this.successPaymentType = _data["successPaymentType"];
            this.successTransactionReferenceId = _data["successTransactionReferenceId"];
            this.successCurrency = _data["successCurrency"];
            this.successPOSTransactionId = _data["successPOSTransactionId"];
            this.successTransactionStatus = _data["successTransactionStatus"];
            this.successTransactionId = _data["successTransactionId"];
            this.failedPaymentType = _data["failedPaymentType"];
            this.failedTransactionReferenceId = _data["failedTransactionReferenceId"];
            this.failedCurrency = _data["failedCurrency"];
            this.failedPOSTransactionId = _data["failedPOSTransactionId"];
            this.failedTransactionStatus = _data["failedTransactionStatus"];
            this.failedTransactionId = _data["failedTransactionId"];
            this.pendingPaymentType = _data["pendingPaymentType"];
            this.pendingTransactionReferenceId = _data["pendingTransactionReferenceId"];
            this.pendingCurrency = _data["pendingCurrency"];
            this.pendingPOSTransactionId = _data["pendingPOSTransactionId"];
            this.pendingTransactionStatus = _data["pendingTransactionStatus"];
            this.pendingTransactionId = _data["pendingTransactionId"];
        }
    }

    static fromJS(data: any): ReservationDetailsViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReservationDetailsViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reservationDetailsId"] = this.reservationDetailsId;
        data["reservationNumber"] = this.reservationNumber;
        data["reservationDetailsStartTime"] = this.reservationDetailsStartTime ? this.reservationDetailsStartTime.toISOString() : <any>undefined;
        data["reservationDetailsEndTime"] = this.reservationDetailsEndTime ? this.reservationDetailsEndTime.toISOString() : <any>undefined;
        data["reservationDetailsStatus"] = this.reservationDetailsStatus;
        data["reservationDetailsHours"] = this.reservationDetailsHours;
        data["parentReservationId"] = this.parentReservationId;
        data["carPlate"] = this.carPlate;
        data["firstname"] = this.firstname;
        data["lastname"] = this.lastname;
        data["mobileNumber"] = this.mobileNumber;
        data["vatPercentage"] = this.vatPercentage;
        data["vatAmount"] = this.vatAmount;
        data["total"] = this.total;
        data["subTotal"] = this.subTotal;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creator"] = this.creator;
        data["locationName"] = this.locationName;
        data["locationId"] = this.locationId;
        data["slotName"] = this.slotName;
        data["slotId"] = this.slotId;
        data["paymentType"] = this.paymentType;
        data["sucessReservations"] = this.sucessReservations;
        data["parentTotalAmount"] = this.parentTotalAmount;
        data["parentVATAmount"] = this.parentVATAmount;
        data["successInvoiceNumber"] = this.successInvoiceNumber;
        data["successPaymentType"] = this.successPaymentType;
        data["successTransactionReferenceId"] = this.successTransactionReferenceId;
        data["successCurrency"] = this.successCurrency;
        data["successPOSTransactionId"] = this.successPOSTransactionId;
        data["successTransactionStatus"] = this.successTransactionStatus;
        data["successTransactionId"] = this.successTransactionId;
        data["failedPaymentType"] = this.failedPaymentType;
        data["failedTransactionReferenceId"] = this.failedTransactionReferenceId;
        data["failedCurrency"] = this.failedCurrency;
        data["failedPOSTransactionId"] = this.failedPOSTransactionId;
        data["failedTransactionStatus"] = this.failedTransactionStatus;
        data["failedTransactionId"] = this.failedTransactionId;
        data["pendingPaymentType"] = this.pendingPaymentType;
        data["pendingTransactionReferenceId"] = this.pendingTransactionReferenceId;
        data["pendingCurrency"] = this.pendingCurrency;
        data["pendingPOSTransactionId"] = this.pendingPOSTransactionId;
        data["pendingTransactionStatus"] = this.pendingTransactionStatus;
        data["pendingTransactionId"] = this.pendingTransactionId;
        return data;
    }

    clone(): ReservationDetailsViewDto {
        const json = this.toJSON();
        let result = new ReservationDetailsViewDto();
        result.init(json);
        return result;
    }
}

export interface IReservationDetailsViewDto {
    reservationDetailsId: string;
    reservationNumber: string | undefined;
    reservationDetailsStartTime: moment.Moment;
    reservationDetailsEndTime: moment.Moment;
    reservationDetailsStatus: ReservationStatus;
    reservationDetailsHours: number;
    parentReservationId: string;
    carPlate: string | undefined;
    firstname: string | undefined;
    lastname: string | undefined;
    mobileNumber: string | undefined;
    vatPercentage: number;
    vatAmount: number;
    total: number;
    subTotal: number;
    creationTime: moment.Moment;
    creator: string | undefined;
    locationName: string | undefined;
    locationId: number;
    slotName: string | undefined;
    slotId: number;
    paymentType: PaymentType;
    sucessReservations: number;
    parentTotalAmount: number;
    parentVATAmount: number;
    successInvoiceNumber: string | undefined;
    successPaymentType: PaymentType;
    successTransactionReferenceId: string | undefined;
    successCurrency: string | undefined;
    successPOSTransactionId: string | undefined;
    successTransactionStatus: string | undefined;
    successTransactionId: string | undefined;
    failedPaymentType: PaymentType;
    failedTransactionReferenceId: string | undefined;
    failedCurrency: string | undefined;
    failedPOSTransactionId: string | undefined;
    failedTransactionStatus: string | undefined;
    failedTransactionId: string | undefined;
    pendingPaymentType: PaymentType;
    pendingTransactionReferenceId: string | undefined;
    pendingCurrency: string | undefined;
    pendingPOSTransactionId: string | undefined;
    pendingTransactionStatus: string | undefined;
    pendingTransactionId: string | undefined;
}

export class ReservationDetailsViewDtoPagedResultDto implements IReservationDetailsViewDtoPagedResultDto {
    items: ReservationDetailsViewDto[] | undefined;
    totalCount: number;

    constructor(data?: IReservationDetailsViewDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ReservationDetailsViewDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ReservationDetailsViewDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReservationDetailsViewDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ReservationDetailsViewDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ReservationDetailsViewDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IReservationDetailsViewDtoPagedResultDto {
    items: ReservationDetailsViewDto[] | undefined;
    totalCount: number;
}

export class ReservationDto implements IReservationDto {
    id: string;
    invoiceNumber: number;
    code: string | undefined;
    firstname: string | undefined;
    lastname: string | undefined;
    location: LocationListDto;
    qrCode: QRCodeListDto;
    slot: SlotListDto;
    paymentType: PaymentType;
    hours: number;
    countryCode: string | undefined;
    phoneNumber: string | undefined;
    carPlate: CarPlate;
    vehicle: VehicleDto;
    currency: string | undefined;
    payment: PaymentDto;
    hourRate: number;
    vatAmount: number;
    vatPercentage: number;
    subTotal: number;
    total: number;
    creationTime: moment.Moment;
    creator: string | undefined;
    startTime: moment.Moment;
    endTime: moment.Moment;
    reservationDetails: ReservationDetailDTO[] | undefined;
    reservationStatus: ReservationStatus;

    constructor(data?: IReservationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.code = _data["code"];
            this.firstname = _data["firstname"];
            this.lastname = _data["lastname"];
            this.location = _data["location"] ? LocationListDto.fromJS(_data["location"]) : <any>undefined;
            this.qrCode = _data["qrCode"] ? QRCodeListDto.fromJS(_data["qrCode"]) : <any>undefined;
            this.slot = _data["slot"] ? SlotListDto.fromJS(_data["slot"]) : <any>undefined;
            this.paymentType = _data["paymentType"];
            this.hours = _data["hours"];
            this.countryCode = _data["countryCode"];
            this.phoneNumber = _data["phoneNumber"];
            this.carPlate = _data["carPlate"] ? CarPlate.fromJS(_data["carPlate"]) : <any>undefined;
            this.vehicle = _data["vehicle"] ? VehicleDto.fromJS(_data["vehicle"]) : <any>undefined;
            this.currency = _data["currency"];
            this.payment = _data["payment"] ? PaymentDto.fromJS(_data["payment"]) : <any>undefined;
            this.hourRate = _data["hourRate"];
            this.vatAmount = _data["vatAmount"];
            this.vatPercentage = _data["vatPercentage"];
            this.subTotal = _data["subTotal"];
            this.total = _data["total"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creator = _data["creator"];
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["reservationDetails"])) {
                this.reservationDetails = [] as any;
                for (let item of _data["reservationDetails"])
                    this.reservationDetails.push(ReservationDetailDTO.fromJS(item));
            }
            this.reservationStatus = _data["reservationStatus"];
        }
    }

    static fromJS(data: any): ReservationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReservationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["invoiceNumber"] = this.invoiceNumber;
        data["code"] = this.code;
        data["firstname"] = this.firstname;
        data["lastname"] = this.lastname;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["qrCode"] = this.qrCode ? this.qrCode.toJSON() : <any>undefined;
        data["slot"] = this.slot ? this.slot.toJSON() : <any>undefined;
        data["paymentType"] = this.paymentType;
        data["hours"] = this.hours;
        data["countryCode"] = this.countryCode;
        data["phoneNumber"] = this.phoneNumber;
        data["carPlate"] = this.carPlate ? this.carPlate.toJSON() : <any>undefined;
        data["vehicle"] = this.vehicle ? this.vehicle.toJSON() : <any>undefined;
        data["currency"] = this.currency;
        data["payment"] = this.payment ? this.payment.toJSON() : <any>undefined;
        data["hourRate"] = this.hourRate;
        data["vatAmount"] = this.vatAmount;
        data["vatPercentage"] = this.vatPercentage;
        data["subTotal"] = this.subTotal;
        data["total"] = this.total;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creator"] = this.creator;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        if (Array.isArray(this.reservationDetails)) {
            data["reservationDetails"] = [];
            for (let item of this.reservationDetails)
                data["reservationDetails"].push(item.toJSON());
        }
        data["reservationStatus"] = this.reservationStatus;
        return data;
    }

    clone(): ReservationDto {
        const json = this.toJSON();
        let result = new ReservationDto();
        result.init(json);
        return result;
    }
}

export interface IReservationDto {
    id: string;
    invoiceNumber: number;
    code: string | undefined;
    firstname: string | undefined;
    lastname: string | undefined;
    location: LocationListDto;
    qrCode: QRCodeListDto;
    slot: SlotListDto;
    paymentType: PaymentType;
    hours: number;
    countryCode: string | undefined;
    phoneNumber: string | undefined;
    carPlate: CarPlate;
    vehicle: VehicleDto;
    currency: string | undefined;
    payment: PaymentDto;
    hourRate: number;
    vatAmount: number;
    vatPercentage: number;
    subTotal: number;
    total: number;
    creationTime: moment.Moment;
    creator: string | undefined;
    startTime: moment.Moment;
    endTime: moment.Moment;
    reservationDetails: ReservationDetailDTO[] | undefined;
    reservationStatus: ReservationStatus;
}

export class ReservationInvoiceLocationDto implements IReservationInvoiceLocationDto {
    id: number;
    name: string | undefined;
    price: ReservationPriceDto;

    constructor(data?: IReservationInvoiceLocationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.price = _data["price"] ? ReservationPriceDto.fromJS(_data["price"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ReservationInvoiceLocationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReservationInvoiceLocationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["price"] = this.price ? this.price.toJSON() : <any>undefined;
        return data;
    }

    clone(): ReservationInvoiceLocationDto {
        const json = this.toJSON();
        let result = new ReservationInvoiceLocationDto();
        result.init(json);
        return result;
    }
}

export interface IReservationInvoiceLocationDto {
    id: number;
    name: string | undefined;
    price: ReservationPriceDto;
}

export class ReservationListDto implements IReservationListDto {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    invoiceNumber: number;
    code: string | undefined;
    firstname: string | undefined;
    lastname: string | undefined;
    location: LocationListDto;
    qrCode: QRCodeListDto;
    slot: SlotListDto;
    paymentType: PaymentType;
    hours: number;
    countryCode: string | undefined;
    phoneNumber: string | undefined;
    carPlate: CarPlate;
    vehicle: VehicleDto;
    currency: string | undefined;
    payment: PaymentDto;
    hourRate: number;
    vatAmount: number;
    vatPercentage: number;
    subTotal: number;
    total: number;
    isActive: boolean;
    startTime: moment.Moment;
    endTime: moment.Moment;
    status: ReservationStatus;
    validDetailsCount: number;
    usedPaymentTypes: PaymentType[] | undefined;

    constructor(data?: IReservationListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.invoiceNumber = _data["invoiceNumber"];
            this.code = _data["code"];
            this.firstname = _data["firstname"];
            this.lastname = _data["lastname"];
            this.location = _data["location"] ? LocationListDto.fromJS(_data["location"]) : <any>undefined;
            this.qrCode = _data["qrCode"] ? QRCodeListDto.fromJS(_data["qrCode"]) : <any>undefined;
            this.slot = _data["slot"] ? SlotListDto.fromJS(_data["slot"]) : <any>undefined;
            this.paymentType = _data["paymentType"];
            this.hours = _data["hours"];
            this.countryCode = _data["countryCode"];
            this.phoneNumber = _data["phoneNumber"];
            this.carPlate = _data["carPlate"] ? CarPlate.fromJS(_data["carPlate"]) : <any>undefined;
            this.vehicle = _data["vehicle"] ? VehicleDto.fromJS(_data["vehicle"]) : <any>undefined;
            this.currency = _data["currency"];
            this.payment = _data["payment"] ? PaymentDto.fromJS(_data["payment"]) : <any>undefined;
            this.hourRate = _data["hourRate"];
            this.vatAmount = _data["vatAmount"];
            this.vatPercentage = _data["vatPercentage"];
            this.subTotal = _data["subTotal"];
            this.total = _data["total"];
            this.isActive = _data["isActive"];
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.validDetailsCount = _data["validDetailsCount"];
            if (Array.isArray(_data["usedPaymentTypes"])) {
                this.usedPaymentTypes = [] as any;
                for (let item of _data["usedPaymentTypes"])
                    this.usedPaymentTypes.push(item);
            }
        }
    }

    static fromJS(data: any): ReservationListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReservationListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["invoiceNumber"] = this.invoiceNumber;
        data["code"] = this.code;
        data["firstname"] = this.firstname;
        data["lastname"] = this.lastname;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["qrCode"] = this.qrCode ? this.qrCode.toJSON() : <any>undefined;
        data["slot"] = this.slot ? this.slot.toJSON() : <any>undefined;
        data["paymentType"] = this.paymentType;
        data["hours"] = this.hours;
        data["countryCode"] = this.countryCode;
        data["phoneNumber"] = this.phoneNumber;
        data["carPlate"] = this.carPlate ? this.carPlate.toJSON() : <any>undefined;
        data["vehicle"] = this.vehicle ? this.vehicle.toJSON() : <any>undefined;
        data["currency"] = this.currency;
        data["payment"] = this.payment ? this.payment.toJSON() : <any>undefined;
        data["hourRate"] = this.hourRate;
        data["vatAmount"] = this.vatAmount;
        data["vatPercentage"] = this.vatPercentage;
        data["subTotal"] = this.subTotal;
        data["total"] = this.total;
        data["isActive"] = this.isActive;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["validDetailsCount"] = this.validDetailsCount;
        if (Array.isArray(this.usedPaymentTypes)) {
            data["usedPaymentTypes"] = [];
            for (let item of this.usedPaymentTypes)
                data["usedPaymentTypes"].push(item);
        }
        return data;
    }

    clone(): ReservationListDto {
        const json = this.toJSON();
        let result = new ReservationListDto();
        result.init(json);
        return result;
    }
}

export interface IReservationListDto {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    invoiceNumber: number;
    code: string | undefined;
    firstname: string | undefined;
    lastname: string | undefined;
    location: LocationListDto;
    qrCode: QRCodeListDto;
    slot: SlotListDto;
    paymentType: PaymentType;
    hours: number;
    countryCode: string | undefined;
    phoneNumber: string | undefined;
    carPlate: CarPlate;
    vehicle: VehicleDto;
    currency: string | undefined;
    payment: PaymentDto;
    hourRate: number;
    vatAmount: number;
    vatPercentage: number;
    subTotal: number;
    total: number;
    isActive: boolean;
    startTime: moment.Moment;
    endTime: moment.Moment;
    status: ReservationStatus;
    validDetailsCount: number;
    usedPaymentTypes: PaymentType[] | undefined;
}

export class ReservationListDtoPagedResultDto implements IReservationListDtoPagedResultDto {
    items: ReservationListDto[] | undefined;
    totalCount: number;

    constructor(data?: IReservationListDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ReservationListDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ReservationListDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReservationListDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ReservationListDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ReservationListDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IReservationListDtoPagedResultDto {
    items: ReservationListDto[] | undefined;
    totalCount: number;
}

export class ReservationPriceDto implements IReservationPriceDto {
    id: number;
    hourRate: number;
    name: string | undefined;
    towingRate: number;
    clampingRate: number;

    constructor(data?: IReservationPriceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.hourRate = _data["hourRate"];
            this.name = _data["name"];
            this.towingRate = _data["towingRate"];
            this.clampingRate = _data["clampingRate"];
        }
    }

    static fromJS(data: any): ReservationPriceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReservationPriceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["hourRate"] = this.hourRate;
        data["name"] = this.name;
        data["towingRate"] = this.towingRate;
        data["clampingRate"] = this.clampingRate;
        return data;
    }

    clone(): ReservationPriceDto {
        const json = this.toJSON();
        let result = new ReservationPriceDto();
        result.init(json);
        return result;
    }
}

export interface IReservationPriceDto {
    id: number;
    hourRate: number;
    name: string | undefined;
    towingRate: number;
    clampingRate: number;
}

export class ReservationSettingsDto implements IReservationSettingsDto {
    aboutToExpireTimeInterval: string | undefined;

    constructor(data?: IReservationSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.aboutToExpireTimeInterval = _data["aboutToExpireTimeInterval"];
        }
    }

    static fromJS(data: any): ReservationSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReservationSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["aboutToExpireTimeInterval"] = this.aboutToExpireTimeInterval;
        return data;
    }

    clone(): ReservationSettingsDto {
        const json = this.toJSON();
        let result = new ReservationSettingsDto();
        result.init(json);
        return result;
    }
}

export interface IReservationSettingsDto {
    aboutToExpireTimeInterval: string | undefined;
}

export enum ReservationStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class ReservationSummaryDto implements IReservationSummaryDto {
    startTime: moment.Moment;
    endTime: moment.Moment;
    carPlate: string | undefined;
    location: LocationDto;
    slot: SlotDto;
    successDetails: ReservationDetailDTO[] | undefined;
    totalPricing: number;
    paymentsTypes: PaymentType[] | undefined;

    constructor(data?: IReservationSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
            this.carPlate = _data["carPlate"];
            this.location = _data["location"] ? LocationDto.fromJS(_data["location"]) : <any>undefined;
            this.slot = _data["slot"] ? SlotDto.fromJS(_data["slot"]) : <any>undefined;
            if (Array.isArray(_data["successDetails"])) {
                this.successDetails = [] as any;
                for (let item of _data["successDetails"])
                    this.successDetails.push(ReservationDetailDTO.fromJS(item));
            }
            this.totalPricing = _data["totalPricing"];
            if (Array.isArray(_data["paymentsTypes"])) {
                this.paymentsTypes = [] as any;
                for (let item of _data["paymentsTypes"])
                    this.paymentsTypes.push(item);
            }
        }
    }

    static fromJS(data: any): ReservationSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReservationSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["carPlate"] = this.carPlate;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["slot"] = this.slot ? this.slot.toJSON() : <any>undefined;
        if (Array.isArray(this.successDetails)) {
            data["successDetails"] = [];
            for (let item of this.successDetails)
                data["successDetails"].push(item.toJSON());
        }
        data["totalPricing"] = this.totalPricing;
        if (Array.isArray(this.paymentsTypes)) {
            data["paymentsTypes"] = [];
            for (let item of this.paymentsTypes)
                data["paymentsTypes"].push(item);
        }
        return data;
    }

    clone(): ReservationSummaryDto {
        const json = this.toJSON();
        let result = new ReservationSummaryDto();
        result.init(json);
        return result;
    }
}

export interface IReservationSummaryDto {
    startTime: moment.Moment;
    endTime: moment.Moment;
    carPlate: string | undefined;
    location: LocationDto;
    slot: SlotDto;
    successDetails: ReservationDetailDTO[] | undefined;
    totalPricing: number;
    paymentsTypes: PaymentType[] | undefined;
}

export class ReservationWithPaymentDto implements IReservationWithPaymentDto {
    reservationDetail: ReservationDetailDTO;
    reservation: ReservationDto;
    transaction: TransactionResponse;
    reporting: ReportDetailsResponse;

    constructor(data?: IReservationWithPaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reservationDetail = _data["reservationDetail"] ? ReservationDetailDTO.fromJS(_data["reservationDetail"]) : <any>undefined;
            this.reservation = _data["reservation"] ? ReservationDto.fromJS(_data["reservation"]) : <any>undefined;
            this.transaction = _data["transaction"] ? TransactionResponse.fromJS(_data["transaction"]) : <any>undefined;
            this.reporting = _data["reporting"] ? ReportDetailsResponse.fromJS(_data["reporting"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ReservationWithPaymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReservationWithPaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reservationDetail"] = this.reservationDetail ? this.reservationDetail.toJSON() : <any>undefined;
        data["reservation"] = this.reservation ? this.reservation.toJSON() : <any>undefined;
        data["transaction"] = this.transaction ? this.transaction.toJSON() : <any>undefined;
        data["reporting"] = this.reporting ? this.reporting.toJSON() : <any>undefined;
        return data;
    }

    clone(): ReservationWithPaymentDto {
        const json = this.toJSON();
        let result = new ReservationWithPaymentDto();
        result.init(json);
        return result;
    }
}

export interface IReservationWithPaymentDto {
    reservationDetail: ReservationDetailDTO;
    reservation: ReservationDto;
    transaction: TransactionResponse;
    reporting: ReportDetailsResponse;
}

export class ReservedTimeDetails implements IReservedTimeDetails {
    id: string;
    readonly domainEvents: IEventData[] | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creatorUser: User;
    lastModifierUser: User;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    readonly violationId: string;
    violation: Violation;
    totalHours: number;
    hourRate: number;
    totalAmount: number;
    vatPercentage: number;
    readonly subTotal: number;
    readonly vatAmount: number;

    constructor(data?: IReservedTimeDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["domainEvents"])) {
                (<any>this).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (<any>this).domainEvents.push(IEventData.fromJS(item));
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            (<any>this).violationId = _data["violationId"];
            this.violation = _data["violation"] ? Violation.fromJS(_data["violation"]) : <any>undefined;
            this.totalHours = _data["totalHours"];
            this.hourRate = _data["hourRate"];
            this.totalAmount = _data["totalAmount"];
            this.vatPercentage = _data["vatPercentage"];
            (<any>this).subTotal = _data["subTotal"];
            (<any>this).vatAmount = _data["vatAmount"];
        }
    }

    static fromJS(data: any): ReservedTimeDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ReservedTimeDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item.toJSON());
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["violationId"] = this.violationId;
        data["violation"] = this.violation ? this.violation.toJSON() : <any>undefined;
        data["totalHours"] = this.totalHours;
        data["hourRate"] = this.hourRate;
        data["totalAmount"] = this.totalAmount;
        data["vatPercentage"] = this.vatPercentage;
        data["subTotal"] = this.subTotal;
        data["vatAmount"] = this.vatAmount;
        return data;
    }

    clone(): ReservedTimeDetails {
        const json = this.toJSON();
        let result = new ReservedTimeDetails();
        result.init(json);
        return result;
    }
}

export interface IReservedTimeDetails {
    id: string;
    domainEvents: IEventData[] | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creatorUser: User;
    lastModifierUser: User;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    violationId: string;
    violation: Violation;
    totalHours: number;
    hourRate: number;
    totalAmount: number;
    vatPercentage: number;
    subTotal: number;
    vatAmount: number;
}

export class ReservedTimeDetailsDto implements IReservedTimeDetailsDto {
    totalHours: number;
    hourRate: number;
    totalAmount: number;
    vatPercentage: number;
    subTotal: number;
    vatAmount: number;

    constructor(data?: IReservedTimeDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalHours = _data["totalHours"];
            this.hourRate = _data["hourRate"];
            this.totalAmount = _data["totalAmount"];
            this.vatPercentage = _data["vatPercentage"];
            this.subTotal = _data["subTotal"];
            this.vatAmount = _data["vatAmount"];
        }
    }

    static fromJS(data: any): ReservedTimeDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReservedTimeDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalHours"] = this.totalHours;
        data["hourRate"] = this.hourRate;
        data["totalAmount"] = this.totalAmount;
        data["vatPercentage"] = this.vatPercentage;
        data["subTotal"] = this.subTotal;
        data["vatAmount"] = this.vatAmount;
        return data;
    }

    clone(): ReservedTimeDetailsDto {
        const json = this.toJSON();
        let result = new ReservedTimeDetailsDto();
        result.init(json);
        return result;
    }
}

export interface IReservedTimeDetailsDto {
    totalHours: number;
    hourRate: number;
    totalAmount: number;
    vatPercentage: number;
    subTotal: number;
    vatAmount: number;
}

export class ResetPasswordDto implements IResetPasswordDto {
    adminPassword: string;
    userId: number;
    newPassword: string;

    constructor(data?: IResetPasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.adminPassword = _data["adminPassword"];
            this.userId = _data["userId"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ResetPasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adminPassword"] = this.adminPassword;
        data["userId"] = this.userId;
        data["newPassword"] = this.newPassword;
        return data;
    }

    clone(): ResetPasswordDto {
        const json = this.toJSON();
        let result = new ResetPasswordDto();
        result.init(json);
        return result;
    }
}

export interface IResetPasswordDto {
    adminPassword: string;
    userId: number;
    newPassword: string;
}

export class Rider implements IRider {
    id: string;
    readonly fullName: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    mobileNumber: string | undefined;
    vehicleId: string;

    constructor(data?: IRider) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            (<any>this).fullName = _data["fullName"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.mobileNumber = _data["mobileNumber"];
            this.vehicleId = _data["vehicleId"];
        }
    }

    static fromJS(data: any): Rider {
        data = typeof data === 'object' ? data : {};
        let result = new Rider();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fullName"] = this.fullName;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["mobileNumber"] = this.mobileNumber;
        data["vehicleId"] = this.vehicleId;
        return data;
    }

    clone(): Rider {
        const json = this.toJSON();
        let result = new Rider();
        result.init(json);
        return result;
    }
}

export interface IRider {
    id: string;
    fullName: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    mobileNumber: string | undefined;
    vehicleId: string;
}

export class RoleDto implements IRoleDto {
    id: number;
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    grantedPermissions: string[] | undefined;
    isStaffRole: boolean;
    roleType: RoleType;
    isStatic: boolean;

    constructor(data?: IRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.normalizedName = _data["normalizedName"];
            this.description = _data["description"];
            if (Array.isArray(_data["grantedPermissions"])) {
                this.grantedPermissions = [] as any;
                for (let item of _data["grantedPermissions"])
                    this.grantedPermissions.push(item);
            }
            this.isStaffRole = _data["isStaffRole"];
            this.roleType = _data["roleType"];
            this.isStatic = _data["isStatic"];
        }
    }

    static fromJS(data: any): RoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["normalizedName"] = this.normalizedName;
        data["description"] = this.description;
        if (Array.isArray(this.grantedPermissions)) {
            data["grantedPermissions"] = [];
            for (let item of this.grantedPermissions)
                data["grantedPermissions"].push(item);
        }
        data["isStaffRole"] = this.isStaffRole;
        data["roleType"] = this.roleType;
        data["isStatic"] = this.isStatic;
        return data;
    }

    clone(): RoleDto {
        const json = this.toJSON();
        let result = new RoleDto();
        result.init(json);
        return result;
    }
}

export interface IRoleDto {
    id: number;
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    grantedPermissions: string[] | undefined;
    isStaffRole: boolean;
    roleType: RoleType;
    isStatic: boolean;
}

export class RoleDtoListResultDto implements IRoleDtoListResultDto {
    items: RoleDto[] | undefined;

    constructor(data?: IRoleDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(RoleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoleDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): RoleDtoListResultDto {
        const json = this.toJSON();
        let result = new RoleDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IRoleDtoListResultDto {
    items: RoleDto[] | undefined;
}

export class RoleDtoPagedResultDto implements IRoleDtoPagedResultDto {
    items: RoleDto[] | undefined;
    totalCount: number;

    constructor(data?: IRoleDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(RoleDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): RoleDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): RoleDtoPagedResultDto {
        const json = this.toJSON();
        let result = new RoleDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IRoleDtoPagedResultDto {
    items: RoleDto[] | undefined;
    totalCount: number;
}

export class RoleEditDto implements IRoleEditDto {
    id: number;
    name: string;
    displayName: string;
    description: string | undefined;
    isStatic: boolean;
    isStaffRole: boolean;
    roleType: RoleType;

    constructor(data?: IRoleEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.isStatic = _data["isStatic"];
            this.isStaffRole = _data["isStaffRole"];
            this.roleType = _data["roleType"];
        }
    }

    static fromJS(data: any): RoleEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["isStatic"] = this.isStatic;
        data["isStaffRole"] = this.isStaffRole;
        data["roleType"] = this.roleType;
        return data;
    }

    clone(): RoleEditDto {
        const json = this.toJSON();
        let result = new RoleEditDto();
        result.init(json);
        return result;
    }
}

export interface IRoleEditDto {
    id: number;
    name: string;
    displayName: string;
    description: string | undefined;
    isStatic: boolean;
    isStaffRole: boolean;
    roleType: RoleType;
}

export class RoleListDto implements IRoleListDto {
    id: number;
    name: string | undefined;
    displayName: string | undefined;
    isStatic: boolean;
    isStaffRole: boolean;
    roleType: RoleType;
    isDefault: boolean;
    creationTime: moment.Moment;

    constructor(data?: IRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.isStatic = _data["isStatic"];
            this.isStaffRole = _data["isStaffRole"];
            this.roleType = _data["roleType"];
            this.isDefault = _data["isDefault"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["isStatic"] = this.isStatic;
        data["isStaffRole"] = this.isStaffRole;
        data["roleType"] = this.roleType;
        data["isDefault"] = this.isDefault;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): RoleListDto {
        const json = this.toJSON();
        let result = new RoleListDto();
        result.init(json);
        return result;
    }
}

export interface IRoleListDto {
    id: number;
    name: string | undefined;
    displayName: string | undefined;
    isStatic: boolean;
    isStaffRole: boolean;
    roleType: RoleType;
    isDefault: boolean;
    creationTime: moment.Moment;
}

export class RoleListDtoListResultDto implements IRoleListDtoListResultDto {
    items: RoleListDto[] | undefined;

    constructor(data?: IRoleListDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(RoleListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoleListDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleListDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): RoleListDtoListResultDto {
        const json = this.toJSON();
        let result = new RoleListDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IRoleListDtoListResultDto {
    items: RoleListDto[] | undefined;
}

export enum RoleType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class SMSSettingsEditDto implements ISMSSettingsEditDto {
    isJawalyEnabled: boolean;
    isTqnyatEnabled: boolean;
    url: string | undefined;
    appKey: string | undefined;
    appSecret: string | undefined;
    sendAtActive: boolean;
    isActive: boolean;
    sender: string | undefined;
    renewMessage: string | undefined;
    reservationMessage: string | undefined;
    invoiceMessage: string | undefined;
    tqnyatURL: string | undefined;
    tqnyatAppKey: string | undefined;
    tqnyatAppSecret: string | undefined;
    tqnyatSendAtActive: boolean;
    tqnyatIsActive: boolean;
    tqnyatSender: string | undefined;
    tqnyatRenewMessage: string | undefined;
    tqnyatReservationMessage: string | undefined;
    tqnyatInvoiceMessage: string | undefined;

    constructor(data?: ISMSSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isJawalyEnabled = _data["isJawalyEnabled"];
            this.isTqnyatEnabled = _data["isTqnyatEnabled"];
            this.url = _data["url"];
            this.appKey = _data["appKey"];
            this.appSecret = _data["appSecret"];
            this.sendAtActive = _data["sendAtActive"];
            this.isActive = _data["isActive"];
            this.sender = _data["sender"];
            this.renewMessage = _data["renewMessage"];
            this.reservationMessage = _data["reservationMessage"];
            this.invoiceMessage = _data["invoiceMessage"];
            this.tqnyatURL = _data["tqnyatURL"];
            this.tqnyatAppKey = _data["tqnyatAppKey"];
            this.tqnyatAppSecret = _data["tqnyatAppSecret"];
            this.tqnyatSendAtActive = _data["tqnyatSendAtActive"];
            this.tqnyatIsActive = _data["tqnyatIsActive"];
            this.tqnyatSender = _data["tqnyatSender"];
            this.tqnyatRenewMessage = _data["tqnyatRenewMessage"];
            this.tqnyatReservationMessage = _data["tqnyatReservationMessage"];
            this.tqnyatInvoiceMessage = _data["tqnyatInvoiceMessage"];
        }
    }

    static fromJS(data: any): SMSSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new SMSSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isJawalyEnabled"] = this.isJawalyEnabled;
        data["isTqnyatEnabled"] = this.isTqnyatEnabled;
        data["url"] = this.url;
        data["appKey"] = this.appKey;
        data["appSecret"] = this.appSecret;
        data["sendAtActive"] = this.sendAtActive;
        data["isActive"] = this.isActive;
        data["sender"] = this.sender;
        data["renewMessage"] = this.renewMessage;
        data["reservationMessage"] = this.reservationMessage;
        data["invoiceMessage"] = this.invoiceMessage;
        data["tqnyatURL"] = this.tqnyatURL;
        data["tqnyatAppKey"] = this.tqnyatAppKey;
        data["tqnyatAppSecret"] = this.tqnyatAppSecret;
        data["tqnyatSendAtActive"] = this.tqnyatSendAtActive;
        data["tqnyatIsActive"] = this.tqnyatIsActive;
        data["tqnyatSender"] = this.tqnyatSender;
        data["tqnyatRenewMessage"] = this.tqnyatRenewMessage;
        data["tqnyatReservationMessage"] = this.tqnyatReservationMessage;
        data["tqnyatInvoiceMessage"] = this.tqnyatInvoiceMessage;
        return data;
    }

    clone(): SMSSettingsEditDto {
        const json = this.toJSON();
        let result = new SMSSettingsEditDto();
        result.init(json);
        return result;
    }
}

export interface ISMSSettingsEditDto {
    isJawalyEnabled: boolean;
    isTqnyatEnabled: boolean;
    url: string | undefined;
    appKey: string | undefined;
    appSecret: string | undefined;
    sendAtActive: boolean;
    isActive: boolean;
    sender: string | undefined;
    renewMessage: string | undefined;
    reservationMessage: string | undefined;
    invoiceMessage: string | undefined;
    tqnyatURL: string | undefined;
    tqnyatAppKey: string | undefined;
    tqnyatAppSecret: string | undefined;
    tqnyatSendAtActive: boolean;
    tqnyatIsActive: boolean;
    tqnyatSender: string | undefined;
    tqnyatRenewMessage: string | undefined;
    tqnyatReservationMessage: string | undefined;
    tqnyatInvoiceMessage: string | undefined;
}

export class SendSMSInput implements ISendSMSInput {
    message: string | undefined;

    constructor(data?: ISendSMSInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): SendSMSInput {
        data = typeof data === 'object' ? data : {};
        let result = new SendSMSInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        return data;
    }

    clone(): SendSMSInput {
        const json = this.toJSON();
        let result = new SendSMSInput();
        result.init(json);
        return result;
    }
}

export interface ISendSMSInput {
    message: string | undefined;
}

export class SetSubscriptionConfigurationInput implements ISetSubscriptionConfigurationInput {
    allDayStartTimeHours: number | undefined;
    allDayStartTimeMinutes: number | undefined;
    allDayEndTimeHours: number | undefined;
    allDayEndTimeMinutes: number | undefined;
    morningStartTimeHours: number | undefined;
    morningStartTimeMinutes: number | undefined;
    morningEndTimeHours: number | undefined;
    morningEndTimeMinutes: number | undefined;
    afternoonStartTimeHours: number | undefined;
    afternoonStartTimeMinutes: number | undefined;
    afternoonEndTimeHours: number | undefined;
    afternoonEndTimeMinutes: number | undefined;
    nightStartTimeHours: number | undefined;
    nightStartTimeMinutes: number | undefined;
    nightEndTimeHours: number | undefined;
    nightEndTimeMinutes: number | undefined;

    constructor(data?: ISetSubscriptionConfigurationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allDayStartTimeHours = _data["allDayStartTimeHours"];
            this.allDayStartTimeMinutes = _data["allDayStartTimeMinutes"];
            this.allDayEndTimeHours = _data["allDayEndTimeHours"];
            this.allDayEndTimeMinutes = _data["allDayEndTimeMinutes"];
            this.morningStartTimeHours = _data["morningStartTimeHours"];
            this.morningStartTimeMinutes = _data["morningStartTimeMinutes"];
            this.morningEndTimeHours = _data["morningEndTimeHours"];
            this.morningEndTimeMinutes = _data["morningEndTimeMinutes"];
            this.afternoonStartTimeHours = _data["afternoonStartTimeHours"];
            this.afternoonStartTimeMinutes = _data["afternoonStartTimeMinutes"];
            this.afternoonEndTimeHours = _data["afternoonEndTimeHours"];
            this.afternoonEndTimeMinutes = _data["afternoonEndTimeMinutes"];
            this.nightStartTimeHours = _data["nightStartTimeHours"];
            this.nightStartTimeMinutes = _data["nightStartTimeMinutes"];
            this.nightEndTimeHours = _data["nightEndTimeHours"];
            this.nightEndTimeMinutes = _data["nightEndTimeMinutes"];
        }
    }

    static fromJS(data: any): SetSubscriptionConfigurationInput {
        data = typeof data === 'object' ? data : {};
        let result = new SetSubscriptionConfigurationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allDayStartTimeHours"] = this.allDayStartTimeHours;
        data["allDayStartTimeMinutes"] = this.allDayStartTimeMinutes;
        data["allDayEndTimeHours"] = this.allDayEndTimeHours;
        data["allDayEndTimeMinutes"] = this.allDayEndTimeMinutes;
        data["morningStartTimeHours"] = this.morningStartTimeHours;
        data["morningStartTimeMinutes"] = this.morningStartTimeMinutes;
        data["morningEndTimeHours"] = this.morningEndTimeHours;
        data["morningEndTimeMinutes"] = this.morningEndTimeMinutes;
        data["afternoonStartTimeHours"] = this.afternoonStartTimeHours;
        data["afternoonStartTimeMinutes"] = this.afternoonStartTimeMinutes;
        data["afternoonEndTimeHours"] = this.afternoonEndTimeHours;
        data["afternoonEndTimeMinutes"] = this.afternoonEndTimeMinutes;
        data["nightStartTimeHours"] = this.nightStartTimeHours;
        data["nightStartTimeMinutes"] = this.nightStartTimeMinutes;
        data["nightEndTimeHours"] = this.nightEndTimeHours;
        data["nightEndTimeMinutes"] = this.nightEndTimeMinutes;
        return data;
    }

    clone(): SetSubscriptionConfigurationInput {
        const json = this.toJSON();
        let result = new SetSubscriptionConfigurationInput();
        result.init(json);
        return result;
    }
}

export interface ISetSubscriptionConfigurationInput {
    allDayStartTimeHours: number | undefined;
    allDayStartTimeMinutes: number | undefined;
    allDayEndTimeHours: number | undefined;
    allDayEndTimeMinutes: number | undefined;
    morningStartTimeHours: number | undefined;
    morningStartTimeMinutes: number | undefined;
    morningEndTimeHours: number | undefined;
    morningEndTimeMinutes: number | undefined;
    afternoonStartTimeHours: number | undefined;
    afternoonStartTimeMinutes: number | undefined;
    afternoonEndTimeHours: number | undefined;
    afternoonEndTimeMinutes: number | undefined;
    nightStartTimeHours: number | undefined;
    nightStartTimeMinutes: number | undefined;
    nightEndTimeHours: number | undefined;
    nightEndTimeMinutes: number | undefined;
}

export class Setting implements ISetting {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    tenantId: number | undefined;
    userId: number | undefined;
    name: string;
    value: string | undefined;

    constructor(data?: ISetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): Setting {
        data = typeof data === 'object' ? data : {};
        let result = new Setting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }

    clone(): Setting {
        const json = this.toJSON();
        let result = new Setting();
        result.init(json);
        return result;
    }
}

export interface ISetting {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    tenantId: number | undefined;
    userId: number | undefined;
    name: string;
    value: string | undefined;
}

export class SettingEditDto implements ISettingEditDto {
    timezone: string | undefined;
    timezoneForComparison: string | undefined;

    constructor(data?: ISettingEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timezone = _data["timezone"];
            this.timezoneForComparison = _data["timezoneForComparison"];
        }
    }

    static fromJS(data: any): SettingEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new SettingEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timezone"] = this.timezone;
        data["timezoneForComparison"] = this.timezoneForComparison;
        return data;
    }

    clone(): SettingEditDto {
        const json = this.toJSON();
        let result = new SettingEditDto();
        result.init(json);
        return result;
    }
}

export interface ISettingEditDto {
    timezone: string | undefined;
    timezoneForComparison: string | undefined;
}

export class ShiftDetailsDto implements IShiftDetailsDto {
    staffAccountFirstName: string | undefined;
    staffAccountLastName: string | undefined;
    staffAccountRole: string | undefined;
    staffAccountEmail: string | undefined;
    totalPOSTransactionAmount: number;
    vehicleSummaryCallingCount: number;
    totalPOSTransactionCount: number;
    totalCashTransactionAmount: number;
    totalCashTransactionCount: number;
    startTime: moment.Moment;
    endTime: moment.Moment;
    duration: string | undefined;
    shiftNumber: number;
    isActive: boolean;
    totalViolations: number;
    totalReservations: number;
    totalSubscriptions: number;
    totalManualIncomes: number;
    totalInOutReservations: number;
    totalLostTickets: number;
    totalCashInOutReservationsCount: number;
    totalCashInOutReservationsAmount: number;
    totalPOSInOutReservationsCount: number;
    totalPOSInOutReservationsAmount: number;
    totalCashLostTicketsCount: number;
    totalCashLostTicketsAmount: number;
    totalPOSLostTicketsCount: number;
    totalPOSLostTicketsAmount: number;
    staffGroupShiftId: string | undefined;

    constructor(data?: IShiftDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.staffAccountFirstName = _data["staffAccountFirstName"];
            this.staffAccountLastName = _data["staffAccountLastName"];
            this.staffAccountRole = _data["staffAccountRole"];
            this.staffAccountEmail = _data["staffAccountEmail"];
            this.totalPOSTransactionAmount = _data["totalPOSTransactionAmount"];
            this.vehicleSummaryCallingCount = _data["vehicleSummaryCallingCount"];
            this.totalPOSTransactionCount = _data["totalPOSTransactionCount"];
            this.totalCashTransactionAmount = _data["totalCashTransactionAmount"];
            this.totalCashTransactionCount = _data["totalCashTransactionCount"];
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
            this.duration = _data["duration"];
            this.shiftNumber = _data["shiftNumber"];
            this.isActive = _data["isActive"];
            this.totalViolations = _data["totalViolations"];
            this.totalReservations = _data["totalReservations"];
            this.totalSubscriptions = _data["totalSubscriptions"];
            this.totalManualIncomes = _data["totalManualIncomes"];
            this.totalInOutReservations = _data["totalInOutReservations"];
            this.totalLostTickets = _data["totalLostTickets"];
            this.totalCashInOutReservationsCount = _data["totalCashInOutReservationsCount"];
            this.totalCashInOutReservationsAmount = _data["totalCashInOutReservationsAmount"];
            this.totalPOSInOutReservationsCount = _data["totalPOSInOutReservationsCount"];
            this.totalPOSInOutReservationsAmount = _data["totalPOSInOutReservationsAmount"];
            this.totalCashLostTicketsCount = _data["totalCashLostTicketsCount"];
            this.totalCashLostTicketsAmount = _data["totalCashLostTicketsAmount"];
            this.totalPOSLostTicketsCount = _data["totalPOSLostTicketsCount"];
            this.totalPOSLostTicketsAmount = _data["totalPOSLostTicketsAmount"];
            this.staffGroupShiftId = _data["staffGroupShiftId"];
        }
    }

    static fromJS(data: any): ShiftDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["staffAccountFirstName"] = this.staffAccountFirstName;
        data["staffAccountLastName"] = this.staffAccountLastName;
        data["staffAccountRole"] = this.staffAccountRole;
        data["staffAccountEmail"] = this.staffAccountEmail;
        data["totalPOSTransactionAmount"] = this.totalPOSTransactionAmount;
        data["vehicleSummaryCallingCount"] = this.vehicleSummaryCallingCount;
        data["totalPOSTransactionCount"] = this.totalPOSTransactionCount;
        data["totalCashTransactionAmount"] = this.totalCashTransactionAmount;
        data["totalCashTransactionCount"] = this.totalCashTransactionCount;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["duration"] = this.duration;
        data["shiftNumber"] = this.shiftNumber;
        data["isActive"] = this.isActive;
        data["totalViolations"] = this.totalViolations;
        data["totalReservations"] = this.totalReservations;
        data["totalSubscriptions"] = this.totalSubscriptions;
        data["totalManualIncomes"] = this.totalManualIncomes;
        data["totalInOutReservations"] = this.totalInOutReservations;
        data["totalLostTickets"] = this.totalLostTickets;
        data["totalCashInOutReservationsCount"] = this.totalCashInOutReservationsCount;
        data["totalCashInOutReservationsAmount"] = this.totalCashInOutReservationsAmount;
        data["totalPOSInOutReservationsCount"] = this.totalPOSInOutReservationsCount;
        data["totalPOSInOutReservationsAmount"] = this.totalPOSInOutReservationsAmount;
        data["totalCashLostTicketsCount"] = this.totalCashLostTicketsCount;
        data["totalCashLostTicketsAmount"] = this.totalCashLostTicketsAmount;
        data["totalPOSLostTicketsCount"] = this.totalPOSLostTicketsCount;
        data["totalPOSLostTicketsAmount"] = this.totalPOSLostTicketsAmount;
        data["staffGroupShiftId"] = this.staffGroupShiftId;
        return data;
    }

    clone(): ShiftDetailsDto {
        const json = this.toJSON();
        let result = new ShiftDetailsDto();
        result.init(json);
        return result;
    }
}

export interface IShiftDetailsDto {
    staffAccountFirstName: string | undefined;
    staffAccountLastName: string | undefined;
    staffAccountRole: string | undefined;
    staffAccountEmail: string | undefined;
    totalPOSTransactionAmount: number;
    vehicleSummaryCallingCount: number;
    totalPOSTransactionCount: number;
    totalCashTransactionAmount: number;
    totalCashTransactionCount: number;
    startTime: moment.Moment;
    endTime: moment.Moment;
    duration: string | undefined;
    shiftNumber: number;
    isActive: boolean;
    totalViolations: number;
    totalReservations: number;
    totalSubscriptions: number;
    totalManualIncomes: number;
    totalInOutReservations: number;
    totalLostTickets: number;
    totalCashInOutReservationsCount: number;
    totalCashInOutReservationsAmount: number;
    totalPOSInOutReservationsCount: number;
    totalPOSInOutReservationsAmount: number;
    totalCashLostTicketsCount: number;
    totalCashLostTicketsAmount: number;
    totalPOSLostTicketsCount: number;
    totalPOSLostTicketsAmount: number;
    staffGroupShiftId: string | undefined;
}

export class ShiftSummaryDto implements IShiftSummaryDto {
    id: string;
    staffAccountFirstName: string | undefined;
    vehicleSummaryCallingCount: number;
    staffAccountLastName: string | undefined;
    staffAccountRole: string | undefined;
    staffAccountEmail: string | undefined;
    totalPOSTransactionAmount: number;
    totalPOSTransactionCount: number;
    totalCashTransactionAmount: number;
    totalCashTransactionCount: number;
    startTime: moment.Moment;
    endTime: moment.Moment | undefined;
    duration: string | undefined;
    shiftNumber: number;
    groupShiftNumber: number;
    isActive: boolean;
    totalViolations: number;
    totalReservations: number;
    totalSubscriptions: number;
    totalManualIncomes: number;
    totalInOutReservations: number;
    totalLostTickets: number;
    staffGroupShiftId: string | undefined;

    constructor(data?: IShiftSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.staffAccountFirstName = _data["staffAccountFirstName"];
            this.vehicleSummaryCallingCount = _data["vehicleSummaryCallingCount"];
            this.staffAccountLastName = _data["staffAccountLastName"];
            this.staffAccountRole = _data["staffAccountRole"];
            this.staffAccountEmail = _data["staffAccountEmail"];
            this.totalPOSTransactionAmount = _data["totalPOSTransactionAmount"];
            this.totalPOSTransactionCount = _data["totalPOSTransactionCount"];
            this.totalCashTransactionAmount = _data["totalCashTransactionAmount"];
            this.totalCashTransactionCount = _data["totalCashTransactionCount"];
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
            this.duration = _data["duration"];
            this.shiftNumber = _data["shiftNumber"];
            this.groupShiftNumber = _data["groupShiftNumber"];
            this.isActive = _data["isActive"];
            this.totalViolations = _data["totalViolations"];
            this.totalReservations = _data["totalReservations"];
            this.totalSubscriptions = _data["totalSubscriptions"];
            this.totalManualIncomes = _data["totalManualIncomes"];
            this.totalInOutReservations = _data["totalInOutReservations"];
            this.totalLostTickets = _data["totalLostTickets"];
            this.staffGroupShiftId = _data["staffGroupShiftId"];
        }
    }

    static fromJS(data: any): ShiftSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["staffAccountFirstName"] = this.staffAccountFirstName;
        data["vehicleSummaryCallingCount"] = this.vehicleSummaryCallingCount;
        data["staffAccountLastName"] = this.staffAccountLastName;
        data["staffAccountRole"] = this.staffAccountRole;
        data["staffAccountEmail"] = this.staffAccountEmail;
        data["totalPOSTransactionAmount"] = this.totalPOSTransactionAmount;
        data["totalPOSTransactionCount"] = this.totalPOSTransactionCount;
        data["totalCashTransactionAmount"] = this.totalCashTransactionAmount;
        data["totalCashTransactionCount"] = this.totalCashTransactionCount;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["duration"] = this.duration;
        data["shiftNumber"] = this.shiftNumber;
        data["groupShiftNumber"] = this.groupShiftNumber;
        data["isActive"] = this.isActive;
        data["totalViolations"] = this.totalViolations;
        data["totalReservations"] = this.totalReservations;
        data["totalSubscriptions"] = this.totalSubscriptions;
        data["totalManualIncomes"] = this.totalManualIncomes;
        data["totalInOutReservations"] = this.totalInOutReservations;
        data["totalLostTickets"] = this.totalLostTickets;
        data["staffGroupShiftId"] = this.staffGroupShiftId;
        return data;
    }

    clone(): ShiftSummaryDto {
        const json = this.toJSON();
        let result = new ShiftSummaryDto();
        result.init(json);
        return result;
    }
}

export interface IShiftSummaryDto {
    id: string;
    staffAccountFirstName: string | undefined;
    vehicleSummaryCallingCount: number;
    staffAccountLastName: string | undefined;
    staffAccountRole: string | undefined;
    staffAccountEmail: string | undefined;
    totalPOSTransactionAmount: number;
    totalPOSTransactionCount: number;
    totalCashTransactionAmount: number;
    totalCashTransactionCount: number;
    startTime: moment.Moment;
    endTime: moment.Moment | undefined;
    duration: string | undefined;
    shiftNumber: number;
    groupShiftNumber: number;
    isActive: boolean;
    totalViolations: number;
    totalReservations: number;
    totalSubscriptions: number;
    totalManualIncomes: number;
    totalInOutReservations: number;
    totalLostTickets: number;
    staffGroupShiftId: string | undefined;
}

export class Slot implements ISlot {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    slotNumber: number;
    readonly identifier: string | undefined;
    isActive: boolean;
    readonly locationId: number;
    location: Location;
    readonly slotName: string | undefined;
    readonly qrCodesSlots: QRCodeSlot[] | undefined;
    readonly qrCodes: QRCode[] | undefined;

    constructor(data?: ISlot) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.slotNumber = _data["slotNumber"];
            (<any>this).identifier = _data["identifier"];
            this.isActive = _data["isActive"];
            (<any>this).locationId = _data["locationId"];
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : <any>undefined;
            (<any>this).slotName = _data["slotName"];
            if (Array.isArray(_data["qrCodesSlots"])) {
                (<any>this).qrCodesSlots = [] as any;
                for (let item of _data["qrCodesSlots"])
                    (<any>this).qrCodesSlots.push(QRCodeSlot.fromJS(item));
            }
            if (Array.isArray(_data["qrCodes"])) {
                (<any>this).qrCodes = [] as any;
                for (let item of _data["qrCodes"])
                    (<any>this).qrCodes.push(QRCode.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Slot {
        data = typeof data === 'object' ? data : {};
        let result = new Slot();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["slotNumber"] = this.slotNumber;
        data["identifier"] = this.identifier;
        data["isActive"] = this.isActive;
        data["locationId"] = this.locationId;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["slotName"] = this.slotName;
        if (Array.isArray(this.qrCodesSlots)) {
            data["qrCodesSlots"] = [];
            for (let item of this.qrCodesSlots)
                data["qrCodesSlots"].push(item.toJSON());
        }
        if (Array.isArray(this.qrCodes)) {
            data["qrCodes"] = [];
            for (let item of this.qrCodes)
                data["qrCodes"].push(item.toJSON());
        }
        return data;
    }

    clone(): Slot {
        const json = this.toJSON();
        let result = new Slot();
        result.init(json);
        return result;
    }
}

export interface ISlot {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    slotNumber: number;
    identifier: string | undefined;
    isActive: boolean;
    locationId: number;
    location: Location;
    slotName: string | undefined;
    qrCodesSlots: QRCodeSlot[] | undefined;
    qrCodes: QRCode[] | undefined;
}

export class SlotDto implements ISlotDto {
    id: number;
    readonly slotNumber: number;
    readonly identifier: string | undefined;

    constructor(data?: ISlotDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            (<any>this).slotNumber = _data["slotNumber"];
            (<any>this).identifier = _data["identifier"];
        }
    }

    static fromJS(data: any): SlotDto {
        data = typeof data === 'object' ? data : {};
        let result = new SlotDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["slotNumber"] = this.slotNumber;
        data["identifier"] = this.identifier;
        return data;
    }

    clone(): SlotDto {
        const json = this.toJSON();
        let result = new SlotDto();
        result.init(json);
        return result;
    }
}

export interface ISlotDto {
    id: number;
    slotNumber: number;
    identifier: string | undefined;
}

export class SlotListDto implements ISlotListDto {
    id: number;
    name: string | undefined;
    slotNumber: number;
    identifier: string | undefined;
    isActive: boolean;

    constructor(data?: ISlotListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.slotNumber = _data["slotNumber"];
            this.identifier = _data["identifier"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): SlotListDto {
        data = typeof data === 'object' ? data : {};
        let result = new SlotListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["slotNumber"] = this.slotNumber;
        data["identifier"] = this.identifier;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): SlotListDto {
        const json = this.toJSON();
        let result = new SlotListDto();
        result.init(json);
        return result;
    }
}

export interface ISlotListDto {
    id: number;
    name: string | undefined;
    slotNumber: number;
    identifier: string | undefined;
    isActive: boolean;
}

export class SlotListDtoPagedResultDto implements ISlotListDtoPagedResultDto {
    items: SlotListDto[] | undefined;
    totalCount: number;

    constructor(data?: ISlotListDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(SlotListDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): SlotListDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new SlotListDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): SlotListDtoPagedResultDto {
        const json = this.toJSON();
        let result = new SlotListDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ISlotListDtoPagedResultDto {
    items: SlotListDto[] | undefined;
    totalCount: number;
}

export class StaffAccount implements IStaffAccount {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    userName: string | undefined;
    email: string | undefined;
    phoneNumber: string | undefined;
    roleName: string | undefined;
    userId: number;
    isActive: boolean;
    shouldChangePasswordOnNextLogin: boolean;
    readonly fullName: string | undefined;
    staffgroupMember: StaffGroupMember;
    readonly locationStaffAccounts: LocationStaffAccount[] | undefined;
    readonly locations: Location[] | undefined;
    readonly shifts: StaffAccountShift[] | undefined;
    readonly startInOutReservation: InOutReservation[] | undefined;
    readonly endInOutReservation: InOutReservation[] | undefined;

    constructor(data?: IStaffAccount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.userName = _data["userName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.roleName = _data["roleName"];
            this.userId = _data["userId"];
            this.isActive = _data["isActive"];
            this.shouldChangePasswordOnNextLogin = _data["shouldChangePasswordOnNextLogin"];
            (<any>this).fullName = _data["fullName"];
            this.staffgroupMember = _data["staffgroupMember"] ? StaffGroupMember.fromJS(_data["staffgroupMember"]) : <any>undefined;
            if (Array.isArray(_data["locationStaffAccounts"])) {
                (<any>this).locationStaffAccounts = [] as any;
                for (let item of _data["locationStaffAccounts"])
                    (<any>this).locationStaffAccounts.push(LocationStaffAccount.fromJS(item));
            }
            if (Array.isArray(_data["locations"])) {
                (<any>this).locations = [] as any;
                for (let item of _data["locations"])
                    (<any>this).locations.push(Location.fromJS(item));
            }
            if (Array.isArray(_data["shifts"])) {
                (<any>this).shifts = [] as any;
                for (let item of _data["shifts"])
                    (<any>this).shifts.push(StaffAccountShift.fromJS(item));
            }
            if (Array.isArray(_data["startInOutReservation"])) {
                (<any>this).startInOutReservation = [] as any;
                for (let item of _data["startInOutReservation"])
                    (<any>this).startInOutReservation.push(InOutReservation.fromJS(item));
            }
            if (Array.isArray(_data["endInOutReservation"])) {
                (<any>this).endInOutReservation = [] as any;
                for (let item of _data["endInOutReservation"])
                    (<any>this).endInOutReservation.push(InOutReservation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StaffAccount {
        data = typeof data === 'object' ? data : {};
        let result = new StaffAccount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["userName"] = this.userName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["roleName"] = this.roleName;
        data["userId"] = this.userId;
        data["isActive"] = this.isActive;
        data["shouldChangePasswordOnNextLogin"] = this.shouldChangePasswordOnNextLogin;
        data["fullName"] = this.fullName;
        data["staffgroupMember"] = this.staffgroupMember ? this.staffgroupMember.toJSON() : <any>undefined;
        if (Array.isArray(this.locationStaffAccounts)) {
            data["locationStaffAccounts"] = [];
            for (let item of this.locationStaffAccounts)
                data["locationStaffAccounts"].push(item.toJSON());
        }
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (let item of this.locations)
                data["locations"].push(item.toJSON());
        }
        if (Array.isArray(this.shifts)) {
            data["shifts"] = [];
            for (let item of this.shifts)
                data["shifts"].push(item.toJSON());
        }
        if (Array.isArray(this.startInOutReservation)) {
            data["startInOutReservation"] = [];
            for (let item of this.startInOutReservation)
                data["startInOutReservation"].push(item.toJSON());
        }
        if (Array.isArray(this.endInOutReservation)) {
            data["endInOutReservation"] = [];
            for (let item of this.endInOutReservation)
                data["endInOutReservation"].push(item.toJSON());
        }
        return data;
    }

    clone(): StaffAccount {
        const json = this.toJSON();
        let result = new StaffAccount();
        result.init(json);
        return result;
    }
}

export interface IStaffAccount {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    userName: string | undefined;
    email: string | undefined;
    phoneNumber: string | undefined;
    roleName: string | undefined;
    userId: number;
    isActive: boolean;
    shouldChangePasswordOnNextLogin: boolean;
    fullName: string | undefined;
    staffgroupMember: StaffGroupMember;
    locationStaffAccounts: LocationStaffAccount[] | undefined;
    locations: Location[] | undefined;
    shifts: StaffAccountShift[] | undefined;
    startInOutReservation: InOutReservation[] | undefined;
    endInOutReservation: InOutReservation[] | undefined;
}

export class StaffAccountDto implements IStaffAccountDto {
    id: number;
    readonly fullName: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    userName: string | undefined;
    email: string | undefined;
    phoneNumber: string | undefined;
    userTypeId: number;
    roleName: string | undefined;
    userId: number;
    isActive: boolean;
    staffGroup: StaffGroupListDto;

    constructor(data?: IStaffAccountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            (<any>this).fullName = _data["fullName"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.userName = _data["userName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.userTypeId = _data["userTypeId"];
            this.roleName = _data["roleName"];
            this.userId = _data["userId"];
            this.isActive = _data["isActive"];
            this.staffGroup = _data["staffGroup"] ? StaffGroupListDto.fromJS(_data["staffGroup"]) : <any>undefined;
        }
    }

    static fromJS(data: any): StaffAccountDto {
        data = typeof data === 'object' ? data : {};
        let result = new StaffAccountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fullName"] = this.fullName;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["userName"] = this.userName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["userTypeId"] = this.userTypeId;
        data["roleName"] = this.roleName;
        data["userId"] = this.userId;
        data["isActive"] = this.isActive;
        data["staffGroup"] = this.staffGroup ? this.staffGroup.toJSON() : <any>undefined;
        return data;
    }

    clone(): StaffAccountDto {
        const json = this.toJSON();
        let result = new StaffAccountDto();
        result.init(json);
        return result;
    }
}

export interface IStaffAccountDto {
    id: number;
    fullName: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    userName: string | undefined;
    email: string | undefined;
    phoneNumber: string | undefined;
    userTypeId: number;
    roleName: string | undefined;
    userId: number;
    isActive: boolean;
    staffGroup: StaffGroupListDto;
}

export class StaffAccountDtoPagedResultDto implements IStaffAccountDtoPagedResultDto {
    items: StaffAccountDto[] | undefined;
    totalCount: number;

    constructor(data?: IStaffAccountDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(StaffAccountDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): StaffAccountDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new StaffAccountDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): StaffAccountDtoPagedResultDto {
        const json = this.toJSON();
        let result = new StaffAccountDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IStaffAccountDtoPagedResultDto {
    items: StaffAccountDto[] | undefined;
    totalCount: number;
}

export class StaffAccountEditDto implements IStaffAccountEditDto {
    id: number;
    firstName: string | undefined;
    lastName: string | undefined;
    userName: string | undefined;
    email: string | undefined;
    phoneNumber: string | undefined;
    roleName: string | undefined;
    isActive: boolean;

    constructor(data?: IStaffAccountEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.userName = _data["userName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.roleName = _data["roleName"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): StaffAccountEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new StaffAccountEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["userName"] = this.userName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["roleName"] = this.roleName;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): StaffAccountEditDto {
        const json = this.toJSON();
        let result = new StaffAccountEditDto();
        result.init(json);
        return result;
    }
}

export interface IStaffAccountEditDto {
    id: number;
    firstName: string | undefined;
    lastName: string | undefined;
    userName: string | undefined;
    email: string | undefined;
    phoneNumber: string | undefined;
    roleName: string | undefined;
    isActive: boolean;
}

export class StaffAccountShift implements IStaffAccountShift {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creatorUser: User;
    lastModifierUser: User;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    readonly code: number;
    readonly endTime: moment.Moment | undefined;
    readonly isActive: boolean;
    readonly staffAccountId: number;
    staffAccount: StaffAccount;
    readonly staffGroupShiftId: string | undefined;
    staffGroupShift: StaffGroupShift;
    readonly reservationDetails: ReservationDetail[] | undefined;
    readonly violationStates: ViolationState[] | undefined;
    readonly transactions: Transaction[] | undefined;
    readonly subscriptions: Subscription[] | undefined;
    readonly manualIncomes: ManualIncome[] | undefined;
    readonly operationNotes: OperationNote[] | undefined;
    readonly totalViolationsCount: number;
    readonly totalReservationsCount: number;
    readonly totalTransactionsCount: number;
    readonly totalSubscriptions: number;
    readonly totalManualIncomes: number;
    readonly duration: string | undefined;
    readonly startInOutReservation: InOutReservation[] | undefined;
    readonly endInOutReservation: InOutReservation[] | undefined;
    readonly lostTickets: LostInOutReservationTicket[] | undefined;
    readonly totalInOutReservations: number;
    readonly totalLostTickets: number;
    readonly vehicleSummaryCallingCount: number;

    constructor(data?: IStaffAccountShift) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            (<any>this).code = _data["code"];
            (<any>this).endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
            (<any>this).isActive = _data["isActive"];
            (<any>this).staffAccountId = _data["staffAccountId"];
            this.staffAccount = _data["staffAccount"] ? StaffAccount.fromJS(_data["staffAccount"]) : <any>undefined;
            (<any>this).staffGroupShiftId = _data["staffGroupShiftId"];
            this.staffGroupShift = _data["staffGroupShift"] ? StaffGroupShift.fromJS(_data["staffGroupShift"]) : <any>undefined;
            if (Array.isArray(_data["reservationDetails"])) {
                (<any>this).reservationDetails = [] as any;
                for (let item of _data["reservationDetails"])
                    (<any>this).reservationDetails.push(ReservationDetail.fromJS(item));
            }
            if (Array.isArray(_data["violationStates"])) {
                (<any>this).violationStates = [] as any;
                for (let item of _data["violationStates"])
                    (<any>this).violationStates.push(ViolationState.fromJS(item));
            }
            if (Array.isArray(_data["transactions"])) {
                (<any>this).transactions = [] as any;
                for (let item of _data["transactions"])
                    (<any>this).transactions.push(Transaction.fromJS(item));
            }
            if (Array.isArray(_data["subscriptions"])) {
                (<any>this).subscriptions = [] as any;
                for (let item of _data["subscriptions"])
                    (<any>this).subscriptions.push(Subscription.fromJS(item));
            }
            if (Array.isArray(_data["manualIncomes"])) {
                (<any>this).manualIncomes = [] as any;
                for (let item of _data["manualIncomes"])
                    (<any>this).manualIncomes.push(ManualIncome.fromJS(item));
            }
            if (Array.isArray(_data["operationNotes"])) {
                (<any>this).operationNotes = [] as any;
                for (let item of _data["operationNotes"])
                    (<any>this).operationNotes.push(OperationNote.fromJS(item));
            }
            (<any>this).totalViolationsCount = _data["totalViolationsCount"];
            (<any>this).totalReservationsCount = _data["totalReservationsCount"];
            (<any>this).totalTransactionsCount = _data["totalTransactionsCount"];
            (<any>this).totalSubscriptions = _data["totalSubscriptions"];
            (<any>this).totalManualIncomes = _data["totalManualIncomes"];
            (<any>this).duration = _data["duration"];
            if (Array.isArray(_data["startInOutReservation"])) {
                (<any>this).startInOutReservation = [] as any;
                for (let item of _data["startInOutReservation"])
                    (<any>this).startInOutReservation.push(InOutReservation.fromJS(item));
            }
            if (Array.isArray(_data["endInOutReservation"])) {
                (<any>this).endInOutReservation = [] as any;
                for (let item of _data["endInOutReservation"])
                    (<any>this).endInOutReservation.push(InOutReservation.fromJS(item));
            }
            if (Array.isArray(_data["lostTickets"])) {
                (<any>this).lostTickets = [] as any;
                for (let item of _data["lostTickets"])
                    (<any>this).lostTickets.push(LostInOutReservationTicket.fromJS(item));
            }
            (<any>this).totalInOutReservations = _data["totalInOutReservations"];
            (<any>this).totalLostTickets = _data["totalLostTickets"];
            (<any>this).vehicleSummaryCallingCount = _data["vehicleSummaryCallingCount"];
        }
    }

    static fromJS(data: any): StaffAccountShift {
        data = typeof data === 'object' ? data : {};
        let result = new StaffAccountShift();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["code"] = this.code;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["staffAccountId"] = this.staffAccountId;
        data["staffAccount"] = this.staffAccount ? this.staffAccount.toJSON() : <any>undefined;
        data["staffGroupShiftId"] = this.staffGroupShiftId;
        data["staffGroupShift"] = this.staffGroupShift ? this.staffGroupShift.toJSON() : <any>undefined;
        if (Array.isArray(this.reservationDetails)) {
            data["reservationDetails"] = [];
            for (let item of this.reservationDetails)
                data["reservationDetails"].push(item.toJSON());
        }
        if (Array.isArray(this.violationStates)) {
            data["violationStates"] = [];
            for (let item of this.violationStates)
                data["violationStates"].push(item.toJSON());
        }
        if (Array.isArray(this.transactions)) {
            data["transactions"] = [];
            for (let item of this.transactions)
                data["transactions"].push(item.toJSON());
        }
        if (Array.isArray(this.subscriptions)) {
            data["subscriptions"] = [];
            for (let item of this.subscriptions)
                data["subscriptions"].push(item.toJSON());
        }
        if (Array.isArray(this.manualIncomes)) {
            data["manualIncomes"] = [];
            for (let item of this.manualIncomes)
                data["manualIncomes"].push(item.toJSON());
        }
        if (Array.isArray(this.operationNotes)) {
            data["operationNotes"] = [];
            for (let item of this.operationNotes)
                data["operationNotes"].push(item.toJSON());
        }
        data["totalViolationsCount"] = this.totalViolationsCount;
        data["totalReservationsCount"] = this.totalReservationsCount;
        data["totalTransactionsCount"] = this.totalTransactionsCount;
        data["totalSubscriptions"] = this.totalSubscriptions;
        data["totalManualIncomes"] = this.totalManualIncomes;
        data["duration"] = this.duration;
        if (Array.isArray(this.startInOutReservation)) {
            data["startInOutReservation"] = [];
            for (let item of this.startInOutReservation)
                data["startInOutReservation"].push(item.toJSON());
        }
        if (Array.isArray(this.endInOutReservation)) {
            data["endInOutReservation"] = [];
            for (let item of this.endInOutReservation)
                data["endInOutReservation"].push(item.toJSON());
        }
        if (Array.isArray(this.lostTickets)) {
            data["lostTickets"] = [];
            for (let item of this.lostTickets)
                data["lostTickets"].push(item.toJSON());
        }
        data["totalInOutReservations"] = this.totalInOutReservations;
        data["totalLostTickets"] = this.totalLostTickets;
        data["vehicleSummaryCallingCount"] = this.vehicleSummaryCallingCount;
        return data;
    }

    clone(): StaffAccountShift {
        const json = this.toJSON();
        let result = new StaffAccountShift();
        result.init(json);
        return result;
    }
}

export interface IStaffAccountShift {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creatorUser: User;
    lastModifierUser: User;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    code: number;
    endTime: moment.Moment | undefined;
    isActive: boolean;
    staffAccountId: number;
    staffAccount: StaffAccount;
    staffGroupShiftId: string | undefined;
    staffGroupShift: StaffGroupShift;
    reservationDetails: ReservationDetail[] | undefined;
    violationStates: ViolationState[] | undefined;
    transactions: Transaction[] | undefined;
    subscriptions: Subscription[] | undefined;
    manualIncomes: ManualIncome[] | undefined;
    operationNotes: OperationNote[] | undefined;
    totalViolationsCount: number;
    totalReservationsCount: number;
    totalTransactionsCount: number;
    totalSubscriptions: number;
    totalManualIncomes: number;
    duration: string | undefined;
    startInOutReservation: InOutReservation[] | undefined;
    endInOutReservation: InOutReservation[] | undefined;
    lostTickets: LostInOutReservationTicket[] | undefined;
    totalInOutReservations: number;
    totalLostTickets: number;
    vehicleSummaryCallingCount: number;
}

export class StaffAccountShiftDto implements IStaffAccountShiftDto {
    startTime: moment.Moment;
    endTime: moment.Moment | undefined;
    vehicleSummaryCallingCount: number;
    code: number;
    staffAccount: StaffAccountDto;
    staffGroups: StaffGroupsDto;
    staffGroupShift: StaffGroupShiftListDto;
    duration: string | undefined;
    shiftId: string;
    isActive: boolean;

    constructor(data?: IStaffAccountShiftDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
            this.vehicleSummaryCallingCount = _data["vehicleSummaryCallingCount"];
            this.code = _data["code"];
            this.staffAccount = _data["staffAccount"] ? StaffAccountDto.fromJS(_data["staffAccount"]) : <any>undefined;
            this.staffGroups = _data["staffGroups"] ? StaffGroupsDto.fromJS(_data["staffGroups"]) : <any>undefined;
            this.staffGroupShift = _data["staffGroupShift"] ? StaffGroupShiftListDto.fromJS(_data["staffGroupShift"]) : <any>undefined;
            this.duration = _data["duration"];
            this.shiftId = _data["shiftId"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): StaffAccountShiftDto {
        data = typeof data === 'object' ? data : {};
        let result = new StaffAccountShiftDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["vehicleSummaryCallingCount"] = this.vehicleSummaryCallingCount;
        data["code"] = this.code;
        data["staffAccount"] = this.staffAccount ? this.staffAccount.toJSON() : <any>undefined;
        data["staffGroups"] = this.staffGroups ? this.staffGroups.toJSON() : <any>undefined;
        data["staffGroupShift"] = this.staffGroupShift ? this.staffGroupShift.toJSON() : <any>undefined;
        data["duration"] = this.duration;
        data["shiftId"] = this.shiftId;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): StaffAccountShiftDto {
        const json = this.toJSON();
        let result = new StaffAccountShiftDto();
        result.init(json);
        return result;
    }
}

export interface IStaffAccountShiftDto {
    startTime: moment.Moment;
    endTime: moment.Moment | undefined;
    vehicleSummaryCallingCount: number;
    code: number;
    staffAccount: StaffAccountDto;
    staffGroups: StaffGroupsDto;
    staffGroupShift: StaffGroupShiftListDto;
    duration: string | undefined;
    shiftId: string;
    isActive: boolean;
}

export class StaffAccountShiftDtoPagedResultDto implements IStaffAccountShiftDtoPagedResultDto {
    items: StaffAccountShiftDto[] | undefined;
    totalCount: number;

    constructor(data?: IStaffAccountShiftDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(StaffAccountShiftDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): StaffAccountShiftDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new StaffAccountShiftDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): StaffAccountShiftDtoPagedResultDto {
        const json = this.toJSON();
        let result = new StaffAccountShiftDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IStaffAccountShiftDtoPagedResultDto {
    items: StaffAccountShiftDto[] | undefined;
    totalCount: number;
}

export class StaffGroup implements IStaffGroup {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    groupName: string | undefined;
    locationStaffGroups: LocationStaffGroup[] | undefined;
    staffGroupMembers: StaffGroupMember[] | undefined;
    readonly admins: StaffGroupMember[] | undefined;
    readonly members: StaffGroupMember[] | undefined;
    readonly shifts: StaffGroupShift[] | undefined;

    constructor(data?: IStaffGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.groupName = _data["groupName"];
            if (Array.isArray(_data["locationStaffGroups"])) {
                this.locationStaffGroups = [] as any;
                for (let item of _data["locationStaffGroups"])
                    this.locationStaffGroups.push(LocationStaffGroup.fromJS(item));
            }
            if (Array.isArray(_data["staffGroupMembers"])) {
                this.staffGroupMembers = [] as any;
                for (let item of _data["staffGroupMembers"])
                    this.staffGroupMembers.push(StaffGroupMember.fromJS(item));
            }
            if (Array.isArray(_data["admins"])) {
                (<any>this).admins = [] as any;
                for (let item of _data["admins"])
                    (<any>this).admins.push(StaffGroupMember.fromJS(item));
            }
            if (Array.isArray(_data["members"])) {
                (<any>this).members = [] as any;
                for (let item of _data["members"])
                    (<any>this).members.push(StaffGroupMember.fromJS(item));
            }
            if (Array.isArray(_data["shifts"])) {
                (<any>this).shifts = [] as any;
                for (let item of _data["shifts"])
                    (<any>this).shifts.push(StaffGroupShift.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StaffGroup {
        data = typeof data === 'object' ? data : {};
        let result = new StaffGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["groupName"] = this.groupName;
        if (Array.isArray(this.locationStaffGroups)) {
            data["locationStaffGroups"] = [];
            for (let item of this.locationStaffGroups)
                data["locationStaffGroups"].push(item.toJSON());
        }
        if (Array.isArray(this.staffGroupMembers)) {
            data["staffGroupMembers"] = [];
            for (let item of this.staffGroupMembers)
                data["staffGroupMembers"].push(item.toJSON());
        }
        if (Array.isArray(this.admins)) {
            data["admins"] = [];
            for (let item of this.admins)
                data["admins"].push(item.toJSON());
        }
        if (Array.isArray(this.members)) {
            data["members"] = [];
            for (let item of this.members)
                data["members"].push(item.toJSON());
        }
        if (Array.isArray(this.shifts)) {
            data["shifts"] = [];
            for (let item of this.shifts)
                data["shifts"].push(item.toJSON());
        }
        return data;
    }

    clone(): StaffGroup {
        const json = this.toJSON();
        let result = new StaffGroup();
        result.init(json);
        return result;
    }
}

export interface IStaffGroup {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    groupName: string | undefined;
    locationStaffGroups: LocationStaffGroup[] | undefined;
    staffGroupMembers: StaffGroupMember[] | undefined;
    admins: StaffGroupMember[] | undefined;
    members: StaffGroupMember[] | undefined;
    shifts: StaffGroupShift[] | undefined;
}

export class StaffGroupListDto implements IStaffGroupListDto {
    id: string;
    groupName: string | undefined;

    constructor(data?: IStaffGroupListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.groupName = _data["groupName"];
        }
    }

    static fromJS(data: any): StaffGroupListDto {
        data = typeof data === 'object' ? data : {};
        let result = new StaffGroupListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["groupName"] = this.groupName;
        return data;
    }

    clone(): StaffGroupListDto {
        const json = this.toJSON();
        let result = new StaffGroupListDto();
        result.init(json);
        return result;
    }
}

export interface IStaffGroupListDto {
    id: string;
    groupName: string | undefined;
}

export class StaffGroupListItemDto implements IStaffGroupListItemDto {
    id: string;
    name: string | undefined;
    assignedLocationsCount: number;
    membersCount: number;

    constructor(data?: IStaffGroupListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.assignedLocationsCount = _data["assignedLocationsCount"];
            this.membersCount = _data["membersCount"];
        }
    }

    static fromJS(data: any): StaffGroupListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new StaffGroupListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["assignedLocationsCount"] = this.assignedLocationsCount;
        data["membersCount"] = this.membersCount;
        return data;
    }

    clone(): StaffGroupListItemDto {
        const json = this.toJSON();
        let result = new StaffGroupListItemDto();
        result.init(json);
        return result;
    }
}

export interface IStaffGroupListItemDto {
    id: string;
    name: string | undefined;
    assignedLocationsCount: number;
    membersCount: number;
}

export class StaffGroupListItemDtoPagedResultDto implements IStaffGroupListItemDtoPagedResultDto {
    items: StaffGroupListItemDto[] | undefined;
    totalCount: number;

    constructor(data?: IStaffGroupListItemDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(StaffGroupListItemDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): StaffGroupListItemDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new StaffGroupListItemDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): StaffGroupListItemDtoPagedResultDto {
        const json = this.toJSON();
        let result = new StaffGroupListItemDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IStaffGroupListItemDtoPagedResultDto {
    items: StaffGroupListItemDto[] | undefined;
    totalCount: number;
}

export class StaffGroupMember implements IStaffGroupMember {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    staffAccountId: number;
    isGroupAdmin: boolean;
    staffAccount: StaffAccount;
    staffGroup: StaffGroup;

    constructor(data?: IStaffGroupMember) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.staffAccountId = _data["staffAccountId"];
            this.isGroupAdmin = _data["isGroupAdmin"];
            this.staffAccount = _data["staffAccount"] ? StaffAccount.fromJS(_data["staffAccount"]) : <any>undefined;
            this.staffGroup = _data["staffGroup"] ? StaffGroup.fromJS(_data["staffGroup"]) : <any>undefined;
        }
    }

    static fromJS(data: any): StaffGroupMember {
        data = typeof data === 'object' ? data : {};
        let result = new StaffGroupMember();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["staffAccountId"] = this.staffAccountId;
        data["isGroupAdmin"] = this.isGroupAdmin;
        data["staffAccount"] = this.staffAccount ? this.staffAccount.toJSON() : <any>undefined;
        data["staffGroup"] = this.staffGroup ? this.staffGroup.toJSON() : <any>undefined;
        return data;
    }

    clone(): StaffGroupMember {
        const json = this.toJSON();
        let result = new StaffGroupMember();
        result.init(json);
        return result;
    }
}

export interface IStaffGroupMember {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    staffAccountId: number;
    isGroupAdmin: boolean;
    staffAccount: StaffAccount;
    staffGroup: StaffGroup;
}

export class StaffGroupShift implements IStaffGroupShift {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    staffGroupId: string;
    staffGroup: StaffGroup;
    readonly staffGroupShiftNumber: number;
    startStaffAccountId: number;
    endStaffAccountId: number | undefined;
    startStaffAccount: StaffAccount;
    endStaffAccount: StaffAccount;
    readonly endTime: moment.Moment | undefined;
    readonly startTime: moment.Moment;
    readonly duration: string | undefined;
    readonly isActive: boolean;
    staffAccountShifts: StaffAccountShift[] | undefined;

    constructor(data?: IStaffGroupShift) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.staffGroupId = _data["staffGroupId"];
            this.staffGroup = _data["staffGroup"] ? StaffGroup.fromJS(_data["staffGroup"]) : <any>undefined;
            (<any>this).staffGroupShiftNumber = _data["staffGroupShiftNumber"];
            this.startStaffAccountId = _data["startStaffAccountId"];
            this.endStaffAccountId = _data["endStaffAccountId"];
            this.startStaffAccount = _data["startStaffAccount"] ? StaffAccount.fromJS(_data["startStaffAccount"]) : <any>undefined;
            this.endStaffAccount = _data["endStaffAccount"] ? StaffAccount.fromJS(_data["endStaffAccount"]) : <any>undefined;
            (<any>this).endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
            (<any>this).startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            (<any>this).duration = _data["duration"];
            (<any>this).isActive = _data["isActive"];
            if (Array.isArray(_data["staffAccountShifts"])) {
                this.staffAccountShifts = [] as any;
                for (let item of _data["staffAccountShifts"])
                    this.staffAccountShifts.push(StaffAccountShift.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StaffGroupShift {
        data = typeof data === 'object' ? data : {};
        let result = new StaffGroupShift();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["staffGroupId"] = this.staffGroupId;
        data["staffGroup"] = this.staffGroup ? this.staffGroup.toJSON() : <any>undefined;
        data["staffGroupShiftNumber"] = this.staffGroupShiftNumber;
        data["startStaffAccountId"] = this.startStaffAccountId;
        data["endStaffAccountId"] = this.endStaffAccountId;
        data["startStaffAccount"] = this.startStaffAccount ? this.startStaffAccount.toJSON() : <any>undefined;
        data["endStaffAccount"] = this.endStaffAccount ? this.endStaffAccount.toJSON() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["duration"] = this.duration;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.staffAccountShifts)) {
            data["staffAccountShifts"] = [];
            for (let item of this.staffAccountShifts)
                data["staffAccountShifts"].push(item.toJSON());
        }
        return data;
    }

    clone(): StaffGroupShift {
        const json = this.toJSON();
        let result = new StaffGroupShift();
        result.init(json);
        return result;
    }
}

export interface IStaffGroupShift {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    staffGroupId: string;
    staffGroup: StaffGroup;
    staffGroupShiftNumber: number;
    startStaffAccountId: number;
    endStaffAccountId: number | undefined;
    startStaffAccount: StaffAccount;
    endStaffAccount: StaffAccount;
    endTime: moment.Moment | undefined;
    startTime: moment.Moment;
    duration: string | undefined;
    isActive: boolean;
    staffAccountShifts: StaffAccountShift[] | undefined;
}

export class StaffGroupShiftDto implements IStaffGroupShiftDto {
    staffGroupId: string;
    groupName: string | undefined;
    startStaffAccount: StaffAccountDto;
    endStaffAccount: StaffAccountDto;
    duration: string | undefined;
    endTime: moment.Moment | undefined;
    startTime: moment.Moment;
    isActive: boolean;
    shiftsCount: number;
    activeShiftsCount: number;
    groupShiftNumber: number;

    constructor(data?: IStaffGroupShiftDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.staffGroupId = _data["staffGroupId"];
            this.groupName = _data["groupName"];
            this.startStaffAccount = _data["startStaffAccount"] ? StaffAccountDto.fromJS(_data["startStaffAccount"]) : <any>undefined;
            this.endStaffAccount = _data["endStaffAccount"] ? StaffAccountDto.fromJS(_data["endStaffAccount"]) : <any>undefined;
            this.duration = _data["duration"];
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
            this.shiftsCount = _data["shiftsCount"];
            this.activeShiftsCount = _data["activeShiftsCount"];
            this.groupShiftNumber = _data["groupShiftNumber"];
        }
    }

    static fromJS(data: any): StaffGroupShiftDto {
        data = typeof data === 'object' ? data : {};
        let result = new StaffGroupShiftDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["staffGroupId"] = this.staffGroupId;
        data["groupName"] = this.groupName;
        data["startStaffAccount"] = this.startStaffAccount ? this.startStaffAccount.toJSON() : <any>undefined;
        data["endStaffAccount"] = this.endStaffAccount ? this.endStaffAccount.toJSON() : <any>undefined;
        data["duration"] = this.duration;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["shiftsCount"] = this.shiftsCount;
        data["activeShiftsCount"] = this.activeShiftsCount;
        data["groupShiftNumber"] = this.groupShiftNumber;
        return data;
    }

    clone(): StaffGroupShiftDto {
        const json = this.toJSON();
        let result = new StaffGroupShiftDto();
        result.init(json);
        return result;
    }
}

export interface IStaffGroupShiftDto {
    staffGroupId: string;
    groupName: string | undefined;
    startStaffAccount: StaffAccountDto;
    endStaffAccount: StaffAccountDto;
    duration: string | undefined;
    endTime: moment.Moment | undefined;
    startTime: moment.Moment;
    isActive: boolean;
    shiftsCount: number;
    activeShiftsCount: number;
    groupShiftNumber: number;
}

export class StaffGroupShiftListDto implements IStaffGroupShiftListDto {
    id: string;
    staffGroupShiftNumber: number;
    readonly endTime: moment.Moment | undefined;
    readonly startTime: moment.Moment;

    constructor(data?: IStaffGroupShiftListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.staffGroupShiftNumber = _data["staffGroupShiftNumber"];
            (<any>this).endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
            (<any>this).startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): StaffGroupShiftListDto {
        data = typeof data === 'object' ? data : {};
        let result = new StaffGroupShiftListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["staffGroupShiftNumber"] = this.staffGroupShiftNumber;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): StaffGroupShiftListDto {
        const json = this.toJSON();
        let result = new StaffGroupShiftListDto();
        result.init(json);
        return result;
    }
}

export interface IStaffGroupShiftListDto {
    id: string;
    staffGroupShiftNumber: number;
    endTime: moment.Moment | undefined;
    startTime: moment.Moment;
}

export class StaffGroupsDto implements IStaffGroupsDto {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    groupName: string | undefined;
    staffGroupMembers: StaffGroupMember[] | undefined;

    constructor(data?: IStaffGroupsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.groupName = _data["groupName"];
            if (Array.isArray(_data["staffGroupMembers"])) {
                this.staffGroupMembers = [] as any;
                for (let item of _data["staffGroupMembers"])
                    this.staffGroupMembers.push(StaffGroupMember.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StaffGroupsDto {
        data = typeof data === 'object' ? data : {};
        let result = new StaffGroupsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["groupName"] = this.groupName;
        if (Array.isArray(this.staffGroupMembers)) {
            data["staffGroupMembers"] = [];
            for (let item of this.staffGroupMembers)
                data["staffGroupMembers"].push(item.toJSON());
        }
        return data;
    }

    clone(): StaffGroupsDto {
        const json = this.toJSON();
        let result = new StaffGroupsDto();
        result.init(json);
        return result;
    }
}

export interface IStaffGroupsDto {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    groupName: string | undefined;
    staffGroupMembers: StaffGroupMember[] | undefined;
}

export class StaffMemberItemDto implements IStaffMemberItemDto {
    staffAccountId: number;
    staffAccountName: string | undefined;
    isAdmin: boolean;

    constructor(data?: IStaffMemberItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.staffAccountId = _data["staffAccountId"];
            this.staffAccountName = _data["staffAccountName"];
            this.isAdmin = _data["isAdmin"];
        }
    }

    static fromJS(data: any): StaffMemberItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new StaffMemberItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["staffAccountId"] = this.staffAccountId;
        data["staffAccountName"] = this.staffAccountName;
        data["isAdmin"] = this.isAdmin;
        return data;
    }

    clone(): StaffMemberItemDto {
        const json = this.toJSON();
        let result = new StaffMemberItemDto();
        result.init(json);
        return result;
    }
}

export interface IStaffMemberItemDto {
    staffAccountId: number;
    staffAccountName: string | undefined;
    isAdmin: boolean;
}

export enum SubscriberType {
    _1 = 1,
    _2 = 2,
}

export class Subscription implements ISubscription {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    subscriberType: SubscriberType;
    subscriptionType: SubscriptionType;
    startDate: moment.Moment;
    endDate: moment.Moment;
    startTime: TimeSpan;
    endTime: TimeSpan;
    shiftId: string;
    shift: StaffAccountShift;
    readonly isActive: boolean;
    readonly price: number;
    readonly currency: string | undefined;
    number: number;
    vatPercentage: number | undefined;
    invoiceNumber: string | undefined;
    subscriptionPackageId: string | undefined;
    beneficiaryName: string | undefined;
    vehicles: Vehicle[] | undefined;
    locations: Location[] | undefined;
    subscriptionCompanies: SubscriptionCompany[] | undefined;
    subscriptionPackage: SubscriptionPackage;
    status: SubscriptionStatus;

    constructor(data?: ISubscription) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.subscriberType = _data["subscriberType"];
            this.subscriptionType = _data["subscriptionType"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.startTime = _data["startTime"] ? TimeSpan.fromJS(_data["startTime"]) : <any>undefined;
            this.endTime = _data["endTime"] ? TimeSpan.fromJS(_data["endTime"]) : <any>undefined;
            this.shiftId = _data["shiftId"];
            this.shift = _data["shift"] ? StaffAccountShift.fromJS(_data["shift"]) : <any>undefined;
            (<any>this).isActive = _data["isActive"];
            (<any>this).price = _data["price"];
            (<any>this).currency = _data["currency"];
            this.number = _data["number"];
            this.vatPercentage = _data["vatPercentage"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.subscriptionPackageId = _data["subscriptionPackageId"];
            this.beneficiaryName = _data["beneficiaryName"];
            if (Array.isArray(_data["vehicles"])) {
                this.vehicles = [] as any;
                for (let item of _data["vehicles"])
                    this.vehicles.push(Vehicle.fromJS(item));
            }
            if (Array.isArray(_data["locations"])) {
                this.locations = [] as any;
                for (let item of _data["locations"])
                    this.locations.push(Location.fromJS(item));
            }
            if (Array.isArray(_data["subscriptionCompanies"])) {
                this.subscriptionCompanies = [] as any;
                for (let item of _data["subscriptionCompanies"])
                    this.subscriptionCompanies.push(SubscriptionCompany.fromJS(item));
            }
            this.subscriptionPackage = _data["subscriptionPackage"] ? SubscriptionPackage.fromJS(_data["subscriptionPackage"]) : <any>undefined;
            this.status = _data["status"] ? SubscriptionStatus.fromJS(_data["status"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Subscription {
        data = typeof data === 'object' ? data : {};
        let result = new Subscription();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["subscriberType"] = this.subscriberType;
        data["subscriptionType"] = this.subscriptionType;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["startTime"] = this.startTime ? this.startTime.toJSON() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toJSON() : <any>undefined;
        data["shiftId"] = this.shiftId;
        data["shift"] = this.shift ? this.shift.toJSON() : <any>undefined;
        data["isActive"] = this.isActive;
        data["price"] = this.price;
        data["currency"] = this.currency;
        data["number"] = this.number;
        data["vatPercentage"] = this.vatPercentage;
        data["invoiceNumber"] = this.invoiceNumber;
        data["subscriptionPackageId"] = this.subscriptionPackageId;
        data["beneficiaryName"] = this.beneficiaryName;
        if (Array.isArray(this.vehicles)) {
            data["vehicles"] = [];
            for (let item of this.vehicles)
                data["vehicles"].push(item.toJSON());
        }
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (let item of this.locations)
                data["locations"].push(item.toJSON());
        }
        if (Array.isArray(this.subscriptionCompanies)) {
            data["subscriptionCompanies"] = [];
            for (let item of this.subscriptionCompanies)
                data["subscriptionCompanies"].push(item.toJSON());
        }
        data["subscriptionPackage"] = this.subscriptionPackage ? this.subscriptionPackage.toJSON() : <any>undefined;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        return data;
    }

    clone(): Subscription {
        const json = this.toJSON();
        let result = new Subscription();
        result.init(json);
        return result;
    }
}

export interface ISubscription {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    subscriberType: SubscriberType;
    subscriptionType: SubscriptionType;
    startDate: moment.Moment;
    endDate: moment.Moment;
    startTime: TimeSpan;
    endTime: TimeSpan;
    shiftId: string;
    shift: StaffAccountShift;
    isActive: boolean;
    price: number;
    currency: string | undefined;
    number: number;
    vatPercentage: number | undefined;
    invoiceNumber: string | undefined;
    subscriptionPackageId: string | undefined;
    beneficiaryName: string | undefined;
    vehicles: Vehicle[] | undefined;
    locations: Location[] | undefined;
    subscriptionCompanies: SubscriptionCompany[] | undefined;
    subscriptionPackage: SubscriptionPackage;
    status: SubscriptionStatus;
}

export class SubscriptionBenefeciary implements ISubscriptionBenefeciary {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    subscriptionId: string;
    customerId: string | undefined;
    companyId: string | undefined;
    customer: Customer;
    company: SubscriptionCompany;
    subscription: Subscription;

    constructor(data?: ISubscriptionBenefeciary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.subscriptionId = _data["subscriptionId"];
            this.customerId = _data["customerId"];
            this.companyId = _data["companyId"];
            this.customer = _data["customer"] ? Customer.fromJS(_data["customer"]) : <any>undefined;
            this.company = _data["company"] ? SubscriptionCompany.fromJS(_data["company"]) : <any>undefined;
            this.subscription = _data["subscription"] ? Subscription.fromJS(_data["subscription"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SubscriptionBenefeciary {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionBenefeciary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["subscriptionId"] = this.subscriptionId;
        data["customerId"] = this.customerId;
        data["companyId"] = this.companyId;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["subscription"] = this.subscription ? this.subscription.toJSON() : <any>undefined;
        return data;
    }

    clone(): SubscriptionBenefeciary {
        const json = this.toJSON();
        let result = new SubscriptionBenefeciary();
        result.init(json);
        return result;
    }
}

export interface ISubscriptionBenefeciary {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    subscriptionId: string;
    customerId: string | undefined;
    companyId: string | undefined;
    customer: Customer;
    company: SubscriptionCompany;
    subscription: Subscription;
}

export class SubscriptionCompany implements ISubscriptionCompany {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    name: string | undefined;
    taxId: string | undefined;
    crNumber: string | undefined;
    address: string | undefined;
    contactPersonName: string | undefined;
    contactPersonPhoneNumber: string | undefined;
    addressDetails: SubscriptionCompanyAddress;
    subscriptionBenefeciaries: SubscriptionBenefeciary[] | undefined;

    constructor(data?: ISubscriptionCompany) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.taxId = _data["taxId"];
            this.crNumber = _data["crNumber"];
            this.address = _data["address"];
            this.contactPersonName = _data["contactPersonName"];
            this.contactPersonPhoneNumber = _data["contactPersonPhoneNumber"];
            this.addressDetails = _data["addressDetails"] ? SubscriptionCompanyAddress.fromJS(_data["addressDetails"]) : <any>undefined;
            if (Array.isArray(_data["subscriptionBenefeciaries"])) {
                this.subscriptionBenefeciaries = [] as any;
                for (let item of _data["subscriptionBenefeciaries"])
                    this.subscriptionBenefeciaries.push(SubscriptionBenefeciary.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SubscriptionCompany {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionCompany();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["taxId"] = this.taxId;
        data["crNumber"] = this.crNumber;
        data["address"] = this.address;
        data["contactPersonName"] = this.contactPersonName;
        data["contactPersonPhoneNumber"] = this.contactPersonPhoneNumber;
        data["addressDetails"] = this.addressDetails ? this.addressDetails.toJSON() : <any>undefined;
        if (Array.isArray(this.subscriptionBenefeciaries)) {
            data["subscriptionBenefeciaries"] = [];
            for (let item of this.subscriptionBenefeciaries)
                data["subscriptionBenefeciaries"].push(item.toJSON());
        }
        return data;
    }

    clone(): SubscriptionCompany {
        const json = this.toJSON();
        let result = new SubscriptionCompany();
        result.init(json);
        return result;
    }
}

export interface ISubscriptionCompany {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    name: string | undefined;
    taxId: string | undefined;
    crNumber: string | undefined;
    address: string | undefined;
    contactPersonName: string | undefined;
    contactPersonPhoneNumber: string | undefined;
    addressDetails: SubscriptionCompanyAddress;
    subscriptionBenefeciaries: SubscriptionBenefeciary[] | undefined;
}

export class SubscriptionCompanyAddress implements ISubscriptionCompanyAddress {
    country: string | undefined;
    city: string | undefined;
    district: string | undefined;
    postalCode: string | undefined;
    street: string | undefined;
    buildingNumber: string | undefined;
    additionalNumber: string | undefined;

    constructor(data?: ISubscriptionCompanyAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.country = _data["country"];
            this.city = _data["city"];
            this.district = _data["district"];
            this.postalCode = _data["postalCode"];
            this.street = _data["street"];
            this.buildingNumber = _data["buildingNumber"];
            this.additionalNumber = _data["additionalNumber"];
        }
    }

    static fromJS(data: any): SubscriptionCompanyAddress {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionCompanyAddress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["country"] = this.country;
        data["city"] = this.city;
        data["district"] = this.district;
        data["postalCode"] = this.postalCode;
        data["street"] = this.street;
        data["buildingNumber"] = this.buildingNumber;
        data["additionalNumber"] = this.additionalNumber;
        return data;
    }

    clone(): SubscriptionCompanyAddress {
        const json = this.toJSON();
        let result = new SubscriptionCompanyAddress();
        result.init(json);
        return result;
    }
}

export interface ISubscriptionCompanyAddress {
    country: string | undefined;
    city: string | undefined;
    district: string | undefined;
    postalCode: string | undefined;
    street: string | undefined;
    buildingNumber: string | undefined;
    additionalNumber: string | undefined;
}

export class SubscriptionCompanyAddressDto implements ISubscriptionCompanyAddressDto {
    country: string | undefined;
    city: string | undefined;
    district: string | undefined;
    postalCode: string | undefined;
    street: string | undefined;
    buildingNumber: string | undefined;
    additionalNumber: string | undefined;

    constructor(data?: ISubscriptionCompanyAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.country = _data["country"];
            this.city = _data["city"];
            this.district = _data["district"];
            this.postalCode = _data["postalCode"];
            this.street = _data["street"];
            this.buildingNumber = _data["buildingNumber"];
            this.additionalNumber = _data["additionalNumber"];
        }
    }

    static fromJS(data: any): SubscriptionCompanyAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionCompanyAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["country"] = this.country;
        data["city"] = this.city;
        data["district"] = this.district;
        data["postalCode"] = this.postalCode;
        data["street"] = this.street;
        data["buildingNumber"] = this.buildingNumber;
        data["additionalNumber"] = this.additionalNumber;
        return data;
    }

    clone(): SubscriptionCompanyAddressDto {
        const json = this.toJSON();
        let result = new SubscriptionCompanyAddressDto();
        result.init(json);
        return result;
    }
}

export interface ISubscriptionCompanyAddressDto {
    country: string | undefined;
    city: string | undefined;
    district: string | undefined;
    postalCode: string | undefined;
    street: string | undefined;
    buildingNumber: string | undefined;
    additionalNumber: string | undefined;
}

export class SubscriptionCompanyDto implements ISubscriptionCompanyDto {
    id: string;
    name: string | undefined;
    taxId: string | undefined;
    crNumber: string | undefined;
    address: string | undefined;
    contactPersonName: string | undefined;
    contactPersonPhoneNumber: string | undefined;
    addressDetails: SubscriptionCompanyAddressDto;

    constructor(data?: ISubscriptionCompanyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.taxId = _data["taxId"];
            this.crNumber = _data["crNumber"];
            this.address = _data["address"];
            this.contactPersonName = _data["contactPersonName"];
            this.contactPersonPhoneNumber = _data["contactPersonPhoneNumber"];
            this.addressDetails = _data["addressDetails"] ? SubscriptionCompanyAddressDto.fromJS(_data["addressDetails"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SubscriptionCompanyDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionCompanyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["taxId"] = this.taxId;
        data["crNumber"] = this.crNumber;
        data["address"] = this.address;
        data["contactPersonName"] = this.contactPersonName;
        data["contactPersonPhoneNumber"] = this.contactPersonPhoneNumber;
        data["addressDetails"] = this.addressDetails ? this.addressDetails.toJSON() : <any>undefined;
        return data;
    }

    clone(): SubscriptionCompanyDto {
        const json = this.toJSON();
        let result = new SubscriptionCompanyDto();
        result.init(json);
        return result;
    }
}

export interface ISubscriptionCompanyDto {
    id: string;
    name: string | undefined;
    taxId: string | undefined;
    crNumber: string | undefined;
    address: string | undefined;
    contactPersonName: string | undefined;
    contactPersonPhoneNumber: string | undefined;
    addressDetails: SubscriptionCompanyAddressDto;
}

export class SubscriptionCompanyDtoPagedResultDto implements ISubscriptionCompanyDtoPagedResultDto {
    items: SubscriptionCompanyDto[] | undefined;
    totalCount: number;

    constructor(data?: ISubscriptionCompanyDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(SubscriptionCompanyDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): SubscriptionCompanyDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionCompanyDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): SubscriptionCompanyDtoPagedResultDto {
        const json = this.toJSON();
        let result = new SubscriptionCompanyDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ISubscriptionCompanyDtoPagedResultDto {
    items: SubscriptionCompanyDto[] | undefined;
    totalCount: number;
}

export class SubscriptionConfigurationOutput implements ISubscriptionConfigurationOutput {
    allDayStartTime: TimeSpan;
    allDayEndTime: TimeSpan;
    morningStartTime: TimeSpan;
    morningEndTime: TimeSpan;
    afternoonStartTime: TimeSpan;
    afternoonEndTime: TimeSpan;
    nightStartTime: TimeSpan;
    nightEndTime: TimeSpan;

    constructor(data?: ISubscriptionConfigurationOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allDayStartTime = _data["allDayStartTime"] ? TimeSpan.fromJS(_data["allDayStartTime"]) : <any>undefined;
            this.allDayEndTime = _data["allDayEndTime"] ? TimeSpan.fromJS(_data["allDayEndTime"]) : <any>undefined;
            this.morningStartTime = _data["morningStartTime"] ? TimeSpan.fromJS(_data["morningStartTime"]) : <any>undefined;
            this.morningEndTime = _data["morningEndTime"] ? TimeSpan.fromJS(_data["morningEndTime"]) : <any>undefined;
            this.afternoonStartTime = _data["afternoonStartTime"] ? TimeSpan.fromJS(_data["afternoonStartTime"]) : <any>undefined;
            this.afternoonEndTime = _data["afternoonEndTime"] ? TimeSpan.fromJS(_data["afternoonEndTime"]) : <any>undefined;
            this.nightStartTime = _data["nightStartTime"] ? TimeSpan.fromJS(_data["nightStartTime"]) : <any>undefined;
            this.nightEndTime = _data["nightEndTime"] ? TimeSpan.fromJS(_data["nightEndTime"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SubscriptionConfigurationOutput {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionConfigurationOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allDayStartTime"] = this.allDayStartTime ? this.allDayStartTime.toJSON() : <any>undefined;
        data["allDayEndTime"] = this.allDayEndTime ? this.allDayEndTime.toJSON() : <any>undefined;
        data["morningStartTime"] = this.morningStartTime ? this.morningStartTime.toJSON() : <any>undefined;
        data["morningEndTime"] = this.morningEndTime ? this.morningEndTime.toJSON() : <any>undefined;
        data["afternoonStartTime"] = this.afternoonStartTime ? this.afternoonStartTime.toJSON() : <any>undefined;
        data["afternoonEndTime"] = this.afternoonEndTime ? this.afternoonEndTime.toJSON() : <any>undefined;
        data["nightStartTime"] = this.nightStartTime ? this.nightStartTime.toJSON() : <any>undefined;
        data["nightEndTime"] = this.nightEndTime ? this.nightEndTime.toJSON() : <any>undefined;
        return data;
    }

    clone(): SubscriptionConfigurationOutput {
        const json = this.toJSON();
        let result = new SubscriptionConfigurationOutput();
        result.init(json);
        return result;
    }
}

export interface ISubscriptionConfigurationOutput {
    allDayStartTime: TimeSpan;
    allDayEndTime: TimeSpan;
    morningStartTime: TimeSpan;
    morningEndTime: TimeSpan;
    afternoonStartTime: TimeSpan;
    afternoonEndTime: TimeSpan;
    nightStartTime: TimeSpan;
    nightEndTime: TimeSpan;
}

export class SubscriptionDto implements ISubscriptionDto {
    id: string;
    subscriberType: SubscriberType;
    subscriptionType: SubscriptionType;
    startDate: moment.Moment;
    endDate: moment.Moment;
    startTime: TimeSpan;
    endTime: TimeSpan;
    locations: LocationDto[] | undefined;
    vehicles: VehicleDto[] | undefined;
    price: number;
    currency: string | undefined;
    customer: CustomerDto;
    company: SubscriptionCompanyDto;
    subscriptionPackage: SubscriptionPackageDto;
    benefeciaryName: string | undefined;
    expiryStatus: SubscriptionExpiryStatus;
    status: string | undefined;

    constructor(data?: ISubscriptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.subscriberType = _data["subscriberType"];
            this.subscriptionType = _data["subscriptionType"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.startTime = _data["startTime"] ? TimeSpan.fromJS(_data["startTime"]) : <any>undefined;
            this.endTime = _data["endTime"] ? TimeSpan.fromJS(_data["endTime"]) : <any>undefined;
            if (Array.isArray(_data["locations"])) {
                this.locations = [] as any;
                for (let item of _data["locations"])
                    this.locations.push(LocationDto.fromJS(item));
            }
            if (Array.isArray(_data["vehicles"])) {
                this.vehicles = [] as any;
                for (let item of _data["vehicles"])
                    this.vehicles.push(VehicleDto.fromJS(item));
            }
            this.price = _data["price"];
            this.currency = _data["currency"];
            this.customer = _data["customer"] ? CustomerDto.fromJS(_data["customer"]) : <any>undefined;
            this.company = _data["company"] ? SubscriptionCompanyDto.fromJS(_data["company"]) : <any>undefined;
            this.subscriptionPackage = _data["subscriptionPackage"] ? SubscriptionPackageDto.fromJS(_data["subscriptionPackage"]) : <any>undefined;
            this.benefeciaryName = _data["benefeciaryName"];
            this.expiryStatus = _data["expiryStatus"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): SubscriptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["subscriberType"] = this.subscriberType;
        data["subscriptionType"] = this.subscriptionType;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["startTime"] = this.startTime ? this.startTime.toJSON() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toJSON() : <any>undefined;
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (let item of this.locations)
                data["locations"].push(item.toJSON());
        }
        if (Array.isArray(this.vehicles)) {
            data["vehicles"] = [];
            for (let item of this.vehicles)
                data["vehicles"].push(item.toJSON());
        }
        data["price"] = this.price;
        data["currency"] = this.currency;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["subscriptionPackage"] = this.subscriptionPackage ? this.subscriptionPackage.toJSON() : <any>undefined;
        data["benefeciaryName"] = this.benefeciaryName;
        data["expiryStatus"] = this.expiryStatus;
        data["status"] = this.status;
        return data;
    }

    clone(): SubscriptionDto {
        const json = this.toJSON();
        let result = new SubscriptionDto();
        result.init(json);
        return result;
    }
}

export interface ISubscriptionDto {
    id: string;
    subscriberType: SubscriberType;
    subscriptionType: SubscriptionType;
    startDate: moment.Moment;
    endDate: moment.Moment;
    startTime: TimeSpan;
    endTime: TimeSpan;
    locations: LocationDto[] | undefined;
    vehicles: VehicleDto[] | undefined;
    price: number;
    currency: string | undefined;
    customer: CustomerDto;
    company: SubscriptionCompanyDto;
    subscriptionPackage: SubscriptionPackageDto;
    benefeciaryName: string | undefined;
    expiryStatus: SubscriptionExpiryStatus;
    status: string | undefined;
}

export enum SubscriptionExpiryStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class SubscriptionListItemDto implements ISubscriptionListItemDto {
    id: string;
    subscriptionNumber: number;
    subscriberType: SubscriberType;
    subscriptionType: SubscriptionType;
    startDate: moment.Moment;
    endDate: moment.Moment;
    startTime: string | undefined;
    endTime: string | undefined;
    vehiclesCount: number;
    price: number;
    currency: string | undefined;
    company: SubscriptionCompanyDto;
    customer: CustomerDto;
    isExpired: boolean;
    isActive: boolean;
    locationsCount: number;
    status: string | undefined;
    transaction: TransactionDto;
    packageId: string;
    packageName: string | undefined;
    beneficiaryName: string | undefined;
    expiryStatus: SubscriptionExpiryStatus;

    constructor(data?: ISubscriptionListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.subscriptionNumber = _data["subscriptionNumber"];
            this.subscriberType = _data["subscriberType"];
            this.subscriptionType = _data["subscriptionType"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.startTime = _data["startTime"];
            this.endTime = _data["endTime"];
            this.vehiclesCount = _data["vehiclesCount"];
            this.price = _data["price"];
            this.currency = _data["currency"];
            this.company = _data["company"] ? SubscriptionCompanyDto.fromJS(_data["company"]) : <any>undefined;
            this.customer = _data["customer"] ? CustomerDto.fromJS(_data["customer"]) : <any>undefined;
            this.isExpired = _data["isExpired"];
            this.isActive = _data["isActive"];
            this.locationsCount = _data["locationsCount"];
            this.status = _data["status"];
            this.transaction = _data["transaction"] ? TransactionDto.fromJS(_data["transaction"]) : <any>undefined;
            this.packageId = _data["packageId"];
            this.packageName = _data["packageName"];
            this.beneficiaryName = _data["beneficiaryName"];
            this.expiryStatus = _data["expiryStatus"];
        }
    }

    static fromJS(data: any): SubscriptionListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["subscriptionNumber"] = this.subscriptionNumber;
        data["subscriberType"] = this.subscriberType;
        data["subscriptionType"] = this.subscriptionType;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["startTime"] = this.startTime;
        data["endTime"] = this.endTime;
        data["vehiclesCount"] = this.vehiclesCount;
        data["price"] = this.price;
        data["currency"] = this.currency;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["isExpired"] = this.isExpired;
        data["isActive"] = this.isActive;
        data["locationsCount"] = this.locationsCount;
        data["status"] = this.status;
        data["transaction"] = this.transaction ? this.transaction.toJSON() : <any>undefined;
        data["packageId"] = this.packageId;
        data["packageName"] = this.packageName;
        data["beneficiaryName"] = this.beneficiaryName;
        data["expiryStatus"] = this.expiryStatus;
        return data;
    }

    clone(): SubscriptionListItemDto {
        const json = this.toJSON();
        let result = new SubscriptionListItemDto();
        result.init(json);
        return result;
    }
}

export interface ISubscriptionListItemDto {
    id: string;
    subscriptionNumber: number;
    subscriberType: SubscriberType;
    subscriptionType: SubscriptionType;
    startDate: moment.Moment;
    endDate: moment.Moment;
    startTime: string | undefined;
    endTime: string | undefined;
    vehiclesCount: number;
    price: number;
    currency: string | undefined;
    company: SubscriptionCompanyDto;
    customer: CustomerDto;
    isExpired: boolean;
    isActive: boolean;
    locationsCount: number;
    status: string | undefined;
    transaction: TransactionDto;
    packageId: string;
    packageName: string | undefined;
    beneficiaryName: string | undefined;
    expiryStatus: SubscriptionExpiryStatus;
}

export class SubscriptionListItemDtoPagedResultDto implements ISubscriptionListItemDtoPagedResultDto {
    items: SubscriptionListItemDto[] | undefined;
    totalCount: number;

    constructor(data?: ISubscriptionListItemDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(SubscriptionListItemDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): SubscriptionListItemDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionListItemDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): SubscriptionListItemDtoPagedResultDto {
        const json = this.toJSON();
        let result = new SubscriptionListItemDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ISubscriptionListItemDtoPagedResultDto {
    items: SubscriptionListItemDto[] | undefined;
    totalCount: number;
}

export class SubscriptionLocation implements ISubscriptionLocation {
    id: string;
    locationId: number;
    location: Location;
    subscriptionPackageId: string;
    subscriptionPackage: SubscriptionPackage;

    constructor(data?: ISubscriptionLocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.locationId = _data["locationId"];
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : <any>undefined;
            this.subscriptionPackageId = _data["subscriptionPackageId"];
            this.subscriptionPackage = _data["subscriptionPackage"] ? SubscriptionPackage.fromJS(_data["subscriptionPackage"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SubscriptionLocation {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionLocation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["locationId"] = this.locationId;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["subscriptionPackageId"] = this.subscriptionPackageId;
        data["subscriptionPackage"] = this.subscriptionPackage ? this.subscriptionPackage.toJSON() : <any>undefined;
        return data;
    }

    clone(): SubscriptionLocation {
        const json = this.toJSON();
        let result = new SubscriptionLocation();
        result.init(json);
        return result;
    }
}

export interface ISubscriptionLocation {
    id: string;
    locationId: number;
    location: Location;
    subscriptionPackageId: string;
    subscriptionPackage: SubscriptionPackage;
}

export class SubscriptionPackage implements ISubscriptionPackage {
    id: string;
    readonly domainEvents: IEventData[] | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    name: string | undefined;
    code: string | undefined;
    subscriptionTimeZoneId: string;
    weekDays: string | undefined;
    daysCount: number;
    reserved: boolean;
    price: number;
    isActive: boolean;
    subscriptionTimeZone: SubscriptionTimeZone;
    subscriptionLocations: SubscriptionLocation[] | undefined;
    subscriptions: Subscription[] | undefined;

    constructor(data?: ISubscriptionPackage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["domainEvents"])) {
                (<any>this).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (<any>this).domainEvents.push(IEventData.fromJS(item));
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.code = _data["code"];
            this.subscriptionTimeZoneId = _data["subscriptionTimeZoneId"];
            this.weekDays = _data["weekDays"];
            this.daysCount = _data["daysCount"];
            this.reserved = _data["reserved"];
            this.price = _data["price"];
            this.isActive = _data["isActive"];
            this.subscriptionTimeZone = _data["subscriptionTimeZone"] ? SubscriptionTimeZone.fromJS(_data["subscriptionTimeZone"]) : <any>undefined;
            if (Array.isArray(_data["subscriptionLocations"])) {
                this.subscriptionLocations = [] as any;
                for (let item of _data["subscriptionLocations"])
                    this.subscriptionLocations.push(SubscriptionLocation.fromJS(item));
            }
            if (Array.isArray(_data["subscriptions"])) {
                this.subscriptions = [] as any;
                for (let item of _data["subscriptions"])
                    this.subscriptions.push(Subscription.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SubscriptionPackage {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionPackage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item.toJSON());
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["code"] = this.code;
        data["subscriptionTimeZoneId"] = this.subscriptionTimeZoneId;
        data["weekDays"] = this.weekDays;
        data["daysCount"] = this.daysCount;
        data["reserved"] = this.reserved;
        data["price"] = this.price;
        data["isActive"] = this.isActive;
        data["subscriptionTimeZone"] = this.subscriptionTimeZone ? this.subscriptionTimeZone.toJSON() : <any>undefined;
        if (Array.isArray(this.subscriptionLocations)) {
            data["subscriptionLocations"] = [];
            for (let item of this.subscriptionLocations)
                data["subscriptionLocations"].push(item.toJSON());
        }
        if (Array.isArray(this.subscriptions)) {
            data["subscriptions"] = [];
            for (let item of this.subscriptions)
                data["subscriptions"].push(item.toJSON());
        }
        return data;
    }

    clone(): SubscriptionPackage {
        const json = this.toJSON();
        let result = new SubscriptionPackage();
        result.init(json);
        return result;
    }
}

export interface ISubscriptionPackage {
    id: string;
    domainEvents: IEventData[] | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    name: string | undefined;
    code: string | undefined;
    subscriptionTimeZoneId: string;
    weekDays: string | undefined;
    daysCount: number;
    reserved: boolean;
    price: number;
    isActive: boolean;
    subscriptionTimeZone: SubscriptionTimeZone;
    subscriptionLocations: SubscriptionLocation[] | undefined;
    subscriptions: Subscription[] | undefined;
}

export class SubscriptionPackageDto implements ISubscriptionPackageDto {
    id: string;
    name: string | undefined;
    code: string | undefined;
    subscriptionTimeZoneId: string;
    /** Comma separated string with days' numbers (Saturday = 1, Sunday = 2 ...etc) */
    weekDays: string | undefined;
    daysCount: number;
    /** Represents whether a slot is reserved for the subscriber or not */
    reserved: boolean;
    price: number;
    isActive: boolean;

    constructor(data?: ISubscriptionPackageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.subscriptionTimeZoneId = _data["subscriptionTimeZoneId"];
            this.weekDays = _data["weekDays"];
            this.daysCount = _data["daysCount"];
            this.reserved = _data["reserved"];
            this.price = _data["price"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): SubscriptionPackageDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionPackageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        data["subscriptionTimeZoneId"] = this.subscriptionTimeZoneId;
        data["weekDays"] = this.weekDays;
        data["daysCount"] = this.daysCount;
        data["reserved"] = this.reserved;
        data["price"] = this.price;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): SubscriptionPackageDto {
        const json = this.toJSON();
        let result = new SubscriptionPackageDto();
        result.init(json);
        return result;
    }
}

export interface ISubscriptionPackageDto {
    id: string;
    name: string | undefined;
    code: string | undefined;
    subscriptionTimeZoneId: string;
    /** Comma separated string with days' numbers (Saturday = 1, Sunday = 2 ...etc) */
    weekDays: string | undefined;
    daysCount: number;
    /** Represents whether a slot is reserved for the subscriber or not */
    reserved: boolean;
    price: number;
    isActive: boolean;
}

export class SubscriptionPackageListItemDto implements ISubscriptionPackageListItemDto {
    id: string;
    name: string | undefined;
    code: string | undefined;
    subscriptionTimeZoneId: string;
    /** Comma separated string with days' numbers (Saturday = 1, Sunday = 2 ...etc) */
    weekDays: number[] | undefined;
    daysCount: number;
    /** Represents whether a slot is reserved for the subscriber or not */
    reserved: boolean;
    price: number;
    isActive: boolean;
    editable: boolean;
    locations: Int64StringKeyValuePair[] | undefined;
    subscriptionTimeZone: SubscriptionTimeZoneItemDto;

    constructor(data?: ISubscriptionPackageListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.subscriptionTimeZoneId = _data["subscriptionTimeZoneId"];
            if (Array.isArray(_data["weekDays"])) {
                this.weekDays = [] as any;
                for (let item of _data["weekDays"])
                    this.weekDays.push(item);
            }
            this.daysCount = _data["daysCount"];
            this.reserved = _data["reserved"];
            this.price = _data["price"];
            this.isActive = _data["isActive"];
            this.editable = _data["editable"];
            if (Array.isArray(_data["locations"])) {
                this.locations = [] as any;
                for (let item of _data["locations"])
                    this.locations.push(Int64StringKeyValuePair.fromJS(item));
            }
            this.subscriptionTimeZone = _data["subscriptionTimeZone"] ? SubscriptionTimeZoneItemDto.fromJS(_data["subscriptionTimeZone"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SubscriptionPackageListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionPackageListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        data["subscriptionTimeZoneId"] = this.subscriptionTimeZoneId;
        if (Array.isArray(this.weekDays)) {
            data["weekDays"] = [];
            for (let item of this.weekDays)
                data["weekDays"].push(item);
        }
        data["daysCount"] = this.daysCount;
        data["reserved"] = this.reserved;
        data["price"] = this.price;
        data["isActive"] = this.isActive;
        data["editable"] = this.editable;
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (let item of this.locations)
                data["locations"].push(item.toJSON());
        }
        data["subscriptionTimeZone"] = this.subscriptionTimeZone ? this.subscriptionTimeZone.toJSON() : <any>undefined;
        return data;
    }

    clone(): SubscriptionPackageListItemDto {
        const json = this.toJSON();
        let result = new SubscriptionPackageListItemDto();
        result.init(json);
        return result;
    }
}

export interface ISubscriptionPackageListItemDto {
    id: string;
    name: string | undefined;
    code: string | undefined;
    subscriptionTimeZoneId: string;
    /** Comma separated string with days' numbers (Saturday = 1, Sunday = 2 ...etc) */
    weekDays: number[] | undefined;
    daysCount: number;
    /** Represents whether a slot is reserved for the subscriber or not */
    reserved: boolean;
    price: number;
    isActive: boolean;
    editable: boolean;
    locations: Int64StringKeyValuePair[] | undefined;
    subscriptionTimeZone: SubscriptionTimeZoneItemDto;
}

export class SubscriptionPackageListItemDtoPagedResultDto implements ISubscriptionPackageListItemDtoPagedResultDto {
    items: SubscriptionPackageListItemDto[] | undefined;
    totalCount: number;

    constructor(data?: ISubscriptionPackageListItemDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(SubscriptionPackageListItemDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): SubscriptionPackageListItemDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionPackageListItemDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): SubscriptionPackageListItemDtoPagedResultDto {
        const json = this.toJSON();
        let result = new SubscriptionPackageListItemDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ISubscriptionPackageListItemDtoPagedResultDto {
    items: SubscriptionPackageListItemDto[] | undefined;
    totalCount: number;
}

export class SubscriptionSettingsDto implements ISubscriptionSettingsDto {
    aboutToExpireDays: number;

    constructor(data?: ISubscriptionSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.aboutToExpireDays = _data["aboutToExpireDays"];
        }
    }

    static fromJS(data: any): SubscriptionSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["aboutToExpireDays"] = this.aboutToExpireDays;
        return data;
    }

    clone(): SubscriptionSettingsDto {
        const json = this.toJSON();
        let result = new SubscriptionSettingsDto();
        result.init(json);
        return result;
    }
}

export interface ISubscriptionSettingsDto {
    aboutToExpireDays: number;
}

export class SubscriptionStatus implements ISubscriptionStatus {
    readonly id: number;
    readonly name: string | undefined;

    constructor(data?: ISubscriptionStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).id = _data["id"];
            (<any>this).name = _data["name"];
        }
    }

    static fromJS(data: any): SubscriptionStatus {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): SubscriptionStatus {
        const json = this.toJSON();
        let result = new SubscriptionStatus();
        result.init(json);
        return result;
    }
}

export interface ISubscriptionStatus {
    id: number;
    name: string | undefined;
}

export class SubscriptionTimeZone implements ISubscriptionTimeZone {
    id: string;
    readonly domainEvents: IEventData[] | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    name: string | undefined;
    description: string | undefined;
    startTime: TimeSpan;
    endTime: TimeSpan;
    isActive: boolean;
    subscriptionPackages: SubscriptionPackage[] | undefined;

    constructor(data?: ISubscriptionTimeZone) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["domainEvents"])) {
                (<any>this).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (<any>this).domainEvents.push(IEventData.fromJS(item));
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.description = _data["description"];
            this.startTime = _data["startTime"] ? TimeSpan.fromJS(_data["startTime"]) : <any>undefined;
            this.endTime = _data["endTime"] ? TimeSpan.fromJS(_data["endTime"]) : <any>undefined;
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["subscriptionPackages"])) {
                this.subscriptionPackages = [] as any;
                for (let item of _data["subscriptionPackages"])
                    this.subscriptionPackages.push(SubscriptionPackage.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SubscriptionTimeZone {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionTimeZone();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item.toJSON());
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["description"] = this.description;
        data["startTime"] = this.startTime ? this.startTime.toJSON() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toJSON() : <any>undefined;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.subscriptionPackages)) {
            data["subscriptionPackages"] = [];
            for (let item of this.subscriptionPackages)
                data["subscriptionPackages"].push(item.toJSON());
        }
        return data;
    }

    clone(): SubscriptionTimeZone {
        const json = this.toJSON();
        let result = new SubscriptionTimeZone();
        result.init(json);
        return result;
    }
}

export interface ISubscriptionTimeZone {
    id: string;
    domainEvents: IEventData[] | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    name: string | undefined;
    description: string | undefined;
    startTime: TimeSpan;
    endTime: TimeSpan;
    isActive: boolean;
    subscriptionPackages: SubscriptionPackage[] | undefined;
}

export class SubscriptionTimeZoneItemDto implements ISubscriptionTimeZoneItemDto {
    id: string;
    name: string | undefined;
    description: string | undefined;
    startTime: string | undefined;
    endTime: string | undefined;
    isActive: boolean;

    constructor(data?: ISubscriptionTimeZoneItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.startTime = _data["startTime"];
            this.endTime = _data["endTime"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): SubscriptionTimeZoneItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionTimeZoneItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["startTime"] = this.startTime;
        data["endTime"] = this.endTime;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): SubscriptionTimeZoneItemDto {
        const json = this.toJSON();
        let result = new SubscriptionTimeZoneItemDto();
        result.init(json);
        return result;
    }
}

export interface ISubscriptionTimeZoneItemDto {
    id: string;
    name: string | undefined;
    description: string | undefined;
    startTime: string | undefined;
    endTime: string | undefined;
    isActive: boolean;
}

export class SubscriptionTimeZoneItemDtoPagedResultDto implements ISubscriptionTimeZoneItemDtoPagedResultDto {
    items: SubscriptionTimeZoneItemDto[] | undefined;
    totalCount: number;

    constructor(data?: ISubscriptionTimeZoneItemDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(SubscriptionTimeZoneItemDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): SubscriptionTimeZoneItemDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionTimeZoneItemDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): SubscriptionTimeZoneItemDtoPagedResultDto {
        const json = this.toJSON();
        let result = new SubscriptionTimeZoneItemDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ISubscriptionTimeZoneItemDtoPagedResultDto {
    items: SubscriptionTimeZoneItemDto[] | undefined;
    totalCount: number;
}

export class SubscriptionTransactionInvoiceDto implements ISubscriptionTransactionInvoiceDto {
    id: string;
    paymentType: PaymentType;
    total: number;
    subTotal: number;
    currency: string | undefined;
    vatPercentage: number;
    vatAmount: number;
    transactionNumber: string | undefined;
    onlineTransaction: OnlineTransactionDto;
    posTransaction: POSTransaction;
    status: PaymentStatus;
    creationTime: moment.Moment;
    creatorUserName: string | undefined;
    source: TransactionSource;
    invoiceNumber: string | undefined;
    invoiceStatus: InvoiceStatus;
    invoice: InvoiceItemDto;

    constructor(data?: ISubscriptionTransactionInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.paymentType = _data["paymentType"];
            this.total = _data["total"];
            this.subTotal = _data["subTotal"];
            this.currency = _data["currency"];
            this.vatPercentage = _data["vatPercentage"];
            this.vatAmount = _data["vatAmount"];
            this.transactionNumber = _data["transactionNumber"];
            this.onlineTransaction = _data["onlineTransaction"] ? OnlineTransactionDto.fromJS(_data["onlineTransaction"]) : <any>undefined;
            this.posTransaction = _data["posTransaction"] ? POSTransaction.fromJS(_data["posTransaction"]) : <any>undefined;
            this.status = _data["status"] ? PaymentStatus.fromJS(_data["status"]) : <any>undefined;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserName = _data["creatorUserName"];
            this.source = _data["source"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.invoiceStatus = _data["invoiceStatus"];
            this.invoice = _data["invoice"] ? InvoiceItemDto.fromJS(_data["invoice"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SubscriptionTransactionInvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionTransactionInvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["paymentType"] = this.paymentType;
        data["total"] = this.total;
        data["subTotal"] = this.subTotal;
        data["currency"] = this.currency;
        data["vatPercentage"] = this.vatPercentage;
        data["vatAmount"] = this.vatAmount;
        data["transactionNumber"] = this.transactionNumber;
        data["onlineTransaction"] = this.onlineTransaction ? this.onlineTransaction.toJSON() : <any>undefined;
        data["posTransaction"] = this.posTransaction ? this.posTransaction.toJSON() : <any>undefined;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserName"] = this.creatorUserName;
        data["source"] = this.source;
        data["invoiceNumber"] = this.invoiceNumber;
        data["invoiceStatus"] = this.invoiceStatus;
        data["invoice"] = this.invoice ? this.invoice.toJSON() : <any>undefined;
        return data;
    }

    clone(): SubscriptionTransactionInvoiceDto {
        const json = this.toJSON();
        let result = new SubscriptionTransactionInvoiceDto();
        result.init(json);
        return result;
    }
}

export interface ISubscriptionTransactionInvoiceDto {
    id: string;
    paymentType: PaymentType;
    total: number;
    subTotal: number;
    currency: string | undefined;
    vatPercentage: number;
    vatAmount: number;
    transactionNumber: string | undefined;
    onlineTransaction: OnlineTransactionDto;
    posTransaction: POSTransaction;
    status: PaymentStatus;
    creationTime: moment.Moment;
    creatorUserName: string | undefined;
    source: TransactionSource;
    invoiceNumber: string | undefined;
    invoiceStatus: InvoiceStatus;
    invoice: InvoiceItemDto;
}

export enum SubscriptionType {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
}

export class SubscriptionTypesInfoDto implements ISubscriptionTypesInfoDto {
    name: string | undefined;
    value: number;
    startTime: TimeSpan;
    endTime: TimeSpan;

    constructor(data?: ISubscriptionTypesInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
            this.startTime = _data["startTime"] ? TimeSpan.fromJS(_data["startTime"]) : <any>undefined;
            this.endTime = _data["endTime"] ? TimeSpan.fromJS(_data["endTime"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SubscriptionTypesInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionTypesInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        data["startTime"] = this.startTime ? this.startTime.toJSON() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toJSON() : <any>undefined;
        return data;
    }

    clone(): SubscriptionTypesInfoDto {
        const json = this.toJSON();
        let result = new SubscriptionTypesInfoDto();
        result.init(json);
        return result;
    }
}

export interface ISubscriptionTypesInfoDto {
    name: string | undefined;
    value: number;
    startTime: TimeSpan;
    endTime: TimeSpan;
}

export class SubscriptionVehicleHistory implements ISubscriptionVehicleHistory {
    id: string;
    readonly domainEvents: IEventData[] | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creatorUser: User;
    lastModifierUser: User;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    oldVehicleId: string;
    newVehicleId: string;
    subscriptionId: string;
    subscription: Subscription;

    constructor(data?: ISubscriptionVehicleHistory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["domainEvents"])) {
                (<any>this).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (<any>this).domainEvents.push(IEventData.fromJS(item));
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.oldVehicleId = _data["oldVehicleId"];
            this.newVehicleId = _data["newVehicleId"];
            this.subscriptionId = _data["subscriptionId"];
            this.subscription = _data["subscription"] ? Subscription.fromJS(_data["subscription"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SubscriptionVehicleHistory {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionVehicleHistory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item.toJSON());
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["oldVehicleId"] = this.oldVehicleId;
        data["newVehicleId"] = this.newVehicleId;
        data["subscriptionId"] = this.subscriptionId;
        data["subscription"] = this.subscription ? this.subscription.toJSON() : <any>undefined;
        return data;
    }

    clone(): SubscriptionVehicleHistory {
        const json = this.toJSON();
        let result = new SubscriptionVehicleHistory();
        result.init(json);
        return result;
    }
}

export interface ISubscriptionVehicleHistory {
    id: string;
    domainEvents: IEventData[] | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creatorUser: User;
    lastModifierUser: User;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    oldVehicleId: string;
    newVehicleId: string;
    subscriptionId: string;
    subscription: Subscription;
}

export enum TenantAvailabilityState {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class TenantDto implements ITenantDto {
    id: number;
    tenancyName: string;
    name: string;
    isActive: boolean;

    constructor(data?: ITenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): TenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): TenantDto {
        const json = this.toJSON();
        let result = new TenantDto();
        result.init(json);
        return result;
    }
}

export interface ITenantDto {
    id: number;
    tenancyName: string;
    name: string;
    isActive: boolean;
}

export class TenantDtoPagedResultDto implements ITenantDtoPagedResultDto {
    items: TenantDto[] | undefined;
    totalCount: number;

    constructor(data?: ITenantDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(TenantDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): TenantDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): TenantDtoPagedResultDto {
        const json = this.toJSON();
        let result = new TenantDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ITenantDtoPagedResultDto {
    items: TenantDto[] | undefined;
    totalCount: number;
}

export class TenantLoginInfoDto implements ITenantLoginInfoDto {
    id: number;
    tenancyName: string | undefined;
    name: string | undefined;

    constructor(data?: ITenantLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): TenantLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        return data;
    }

    clone(): TenantLoginInfoDto {
        const json = this.toJSON();
        let result = new TenantLoginInfoDto();
        result.init(json);
        return result;
    }
}

export interface ITenantLoginInfoDto {
    id: number;
    tenancyName: string | undefined;
    name: string | undefined;
}

export class ThreeDSecure implements IThreeDSecure {
    eci: string | undefined;
    xid: string | undefined;

    constructor(data?: IThreeDSecure) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eci = _data["eci"];
            this.xid = _data["xid"];
        }
    }

    static fromJS(data: any): ThreeDSecure {
        data = typeof data === 'object' ? data : {};
        let result = new ThreeDSecure();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eci"] = this.eci;
        data["xid"] = this.xid;
        return data;
    }

    clone(): ThreeDSecure {
        const json = this.toJSON();
        let result = new ThreeDSecure();
        result.init(json);
        return result;
    }
}

export interface IThreeDSecure {
    eci: string | undefined;
    xid: string | undefined;
}

export class TimeSpan implements ITimeSpan {
    ticks: number;
    readonly days: number;
    readonly hours: number;
    readonly milliseconds: number;
    readonly microseconds: number;
    readonly nanoseconds: number;
    readonly minutes: number;
    readonly seconds: number;
    readonly totalDays: number;
    readonly totalHours: number;
    readonly totalMilliseconds: number;
    readonly totalMicroseconds: number;
    readonly totalNanoseconds: number;
    readonly totalMinutes: number;
    readonly totalSeconds: number;

    constructor(data?: ITimeSpan) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticks = _data["ticks"];
            (<any>this).days = _data["days"];
            (<any>this).hours = _data["hours"];
            (<any>this).milliseconds = _data["milliseconds"];
            (<any>this).microseconds = _data["microseconds"];
            (<any>this).nanoseconds = _data["nanoseconds"];
            (<any>this).minutes = _data["minutes"];
            (<any>this).seconds = _data["seconds"];
            (<any>this).totalDays = _data["totalDays"];
            (<any>this).totalHours = _data["totalHours"];
            (<any>this).totalMilliseconds = _data["totalMilliseconds"];
            (<any>this).totalMicroseconds = _data["totalMicroseconds"];
            (<any>this).totalNanoseconds = _data["totalNanoseconds"];
            (<any>this).totalMinutes = _data["totalMinutes"];
            (<any>this).totalSeconds = _data["totalSeconds"];
        }
    }

    static fromJS(data: any): TimeSpan {
        data = typeof data === 'object' ? data : {};
        let result = new TimeSpan();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticks"] = this.ticks;
        data["days"] = this.days;
        data["hours"] = this.hours;
        data["milliseconds"] = this.milliseconds;
        data["microseconds"] = this.microseconds;
        data["nanoseconds"] = this.nanoseconds;
        data["minutes"] = this.minutes;
        data["seconds"] = this.seconds;
        data["totalDays"] = this.totalDays;
        data["totalHours"] = this.totalHours;
        data["totalMilliseconds"] = this.totalMilliseconds;
        data["totalMicroseconds"] = this.totalMicroseconds;
        data["totalNanoseconds"] = this.totalNanoseconds;
        data["totalMinutes"] = this.totalMinutes;
        data["totalSeconds"] = this.totalSeconds;
        return data;
    }

    clone(): TimeSpan {
        const json = this.toJSON();
        let result = new TimeSpan();
        result.init(json);
        return result;
    }
}

export interface ITimeSpan {
    ticks: number;
    days: number;
    hours: number;
    milliseconds: number;
    microseconds: number;
    nanoseconds: number;
    minutes: number;
    seconds: number;
    totalDays: number;
    totalHours: number;
    totalMilliseconds: number;
    totalMicroseconds: number;
    totalNanoseconds: number;
    totalMinutes: number;
    totalSeconds: number;
}

export class TowingImpoundDetails implements ITowingImpoundDetails {
    id: string;
    readonly domainEvents: IEventData[] | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creatorUser: User;
    lastModifierUser: User;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    violationId: string;
    violation: Violation;
    impoundDays: number;
    impoundRatePerDay: number;
    readonly totalAmount: number;
    vatPercentage: number;
    subTotal: number;
    readonly vatAmount: number;

    constructor(data?: ITowingImpoundDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["domainEvents"])) {
                (<any>this).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (<any>this).domainEvents.push(IEventData.fromJS(item));
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.violationId = _data["violationId"];
            this.violation = _data["violation"] ? Violation.fromJS(_data["violation"]) : <any>undefined;
            this.impoundDays = _data["impoundDays"];
            this.impoundRatePerDay = _data["impoundRatePerDay"];
            (<any>this).totalAmount = _data["totalAmount"];
            this.vatPercentage = _data["vatPercentage"];
            this.subTotal = _data["subTotal"];
            (<any>this).vatAmount = _data["vatAmount"];
        }
    }

    static fromJS(data: any): TowingImpoundDetails {
        data = typeof data === 'object' ? data : {};
        let result = new TowingImpoundDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item.toJSON());
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["violationId"] = this.violationId;
        data["violation"] = this.violation ? this.violation.toJSON() : <any>undefined;
        data["impoundDays"] = this.impoundDays;
        data["impoundRatePerDay"] = this.impoundRatePerDay;
        data["totalAmount"] = this.totalAmount;
        data["vatPercentage"] = this.vatPercentage;
        data["subTotal"] = this.subTotal;
        data["vatAmount"] = this.vatAmount;
        return data;
    }

    clone(): TowingImpoundDetails {
        const json = this.toJSON();
        let result = new TowingImpoundDetails();
        result.init(json);
        return result;
    }
}

export interface ITowingImpoundDetails {
    id: string;
    domainEvents: IEventData[] | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creatorUser: User;
    lastModifierUser: User;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    violationId: string;
    violation: Violation;
    impoundDays: number;
    impoundRatePerDay: number;
    totalAmount: number;
    vatPercentage: number;
    subTotal: number;
    vatAmount: number;
}

export class TowingImpoundDetailsDto implements ITowingImpoundDetailsDto {
    impoundDays: number;
    impoundRatePerDay: number;
    totalAmount: number;
    vatPercentage: number;
    subTotal: number;
    vatAmount: number;

    constructor(data?: ITowingImpoundDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.impoundDays = _data["impoundDays"];
            this.impoundRatePerDay = _data["impoundRatePerDay"];
            this.totalAmount = _data["totalAmount"];
            this.vatPercentage = _data["vatPercentage"];
            this.subTotal = _data["subTotal"];
            this.vatAmount = _data["vatAmount"];
        }
    }

    static fromJS(data: any): TowingImpoundDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new TowingImpoundDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["impoundDays"] = this.impoundDays;
        data["impoundRatePerDay"] = this.impoundRatePerDay;
        data["totalAmount"] = this.totalAmount;
        data["vatPercentage"] = this.vatPercentage;
        data["subTotal"] = this.subTotal;
        data["vatAmount"] = this.vatAmount;
        return data;
    }

    clone(): TowingImpoundDetailsDto {
        const json = this.toJSON();
        let result = new TowingImpoundDetailsDto();
        result.init(json);
        return result;
    }
}

export interface ITowingImpoundDetailsDto {
    impoundDays: number;
    impoundRatePerDay: number;
    totalAmount: number;
    vatPercentage: number;
    subTotal: number;
    vatAmount: number;
}

export class Transaction implements ITransaction {
    id: string;
    readonly domainEvents: IEventData[] | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creatorUser: User;
    lastModifierUser: User;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    readonly entityId: string;
    paymentType: PaymentType;
    readonly transactionIdentifier: string | undefined;
    transactionNumber: string | undefined;
    readonly statusId: number;
    readonly total: number;
    readonly vatPercentage: number;
    readonly subTotal: number;
    readonly vatAmount: number;
    readonly currency: string | undefined;
    source: TransactionSource;
    onlineTransaction: OnlineTransaction;
    posTransaction: POSTransaction;
    bankTransferTransaction: BankTransferTransaction;
    status: PaymentStatus;
    readonly shiftId: string | undefined;
    shift: StaffAccountShift;
    readonly identity: number;
    invoice: Invoice;

    constructor(data?: ITransaction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["domainEvents"])) {
                (<any>this).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (<any>this).domainEvents.push(IEventData.fromJS(item));
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            (<any>this).entityId = _data["entityId"];
            this.paymentType = _data["paymentType"];
            (<any>this).transactionIdentifier = _data["transactionIdentifier"];
            this.transactionNumber = _data["transactionNumber"];
            (<any>this).statusId = _data["statusId"];
            (<any>this).total = _data["total"];
            (<any>this).vatPercentage = _data["vatPercentage"];
            (<any>this).subTotal = _data["subTotal"];
            (<any>this).vatAmount = _data["vatAmount"];
            (<any>this).currency = _data["currency"];
            this.source = _data["source"];
            this.onlineTransaction = _data["onlineTransaction"] ? OnlineTransaction.fromJS(_data["onlineTransaction"]) : <any>undefined;
            this.posTransaction = _data["posTransaction"] ? POSTransaction.fromJS(_data["posTransaction"]) : <any>undefined;
            this.bankTransferTransaction = _data["bankTransferTransaction"] ? BankTransferTransaction.fromJS(_data["bankTransferTransaction"]) : <any>undefined;
            this.status = _data["status"] ? PaymentStatus.fromJS(_data["status"]) : <any>undefined;
            (<any>this).shiftId = _data["shiftId"];
            this.shift = _data["shift"] ? StaffAccountShift.fromJS(_data["shift"]) : <any>undefined;
            (<any>this).identity = _data["identity"];
            this.invoice = _data["invoice"] ? Invoice.fromJS(_data["invoice"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Transaction {
        data = typeof data === 'object' ? data : {};
        let result = new Transaction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item.toJSON());
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["entityId"] = this.entityId;
        data["paymentType"] = this.paymentType;
        data["transactionIdentifier"] = this.transactionIdentifier;
        data["transactionNumber"] = this.transactionNumber;
        data["statusId"] = this.statusId;
        data["total"] = this.total;
        data["vatPercentage"] = this.vatPercentage;
        data["subTotal"] = this.subTotal;
        data["vatAmount"] = this.vatAmount;
        data["currency"] = this.currency;
        data["source"] = this.source;
        data["onlineTransaction"] = this.onlineTransaction ? this.onlineTransaction.toJSON() : <any>undefined;
        data["posTransaction"] = this.posTransaction ? this.posTransaction.toJSON() : <any>undefined;
        data["bankTransferTransaction"] = this.bankTransferTransaction ? this.bankTransferTransaction.toJSON() : <any>undefined;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["shiftId"] = this.shiftId;
        data["shift"] = this.shift ? this.shift.toJSON() : <any>undefined;
        data["identity"] = this.identity;
        data["invoice"] = this.invoice ? this.invoice.toJSON() : <any>undefined;
        return data;
    }

    clone(): Transaction {
        const json = this.toJSON();
        let result = new Transaction();
        result.init(json);
        return result;
    }
}

export interface ITransaction {
    id: string;
    domainEvents: IEventData[] | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creatorUser: User;
    lastModifierUser: User;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    entityId: string;
    paymentType: PaymentType;
    transactionIdentifier: string | undefined;
    transactionNumber: string | undefined;
    statusId: number;
    total: number;
    vatPercentage: number;
    subTotal: number;
    vatAmount: number;
    currency: string | undefined;
    source: TransactionSource;
    onlineTransaction: OnlineTransaction;
    posTransaction: POSTransaction;
    bankTransferTransaction: BankTransferTransaction;
    status: PaymentStatus;
    shiftId: string | undefined;
    shift: StaffAccountShift;
    identity: number;
    invoice: Invoice;
}

export class TransactionCard implements ITransactionCard {
    bin: string | undefined;
    binCountry: string | undefined;
    last4Digits: string | undefined;
    holder: string | undefined;
    expiryMonth: string | undefined;
    expiryYear: string | undefined;
    issuer: TransactionCardIssuer;
    type: string | undefined;
    country: string | undefined;
    maxPanLength: string | undefined;
    regulatedFlag: string | undefined;

    constructor(data?: ITransactionCard) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bin = _data["bin"];
            this.binCountry = _data["binCountry"];
            this.last4Digits = _data["last4Digits"];
            this.holder = _data["holder"];
            this.expiryMonth = _data["expiryMonth"];
            this.expiryYear = _data["expiryYear"];
            this.issuer = _data["issuer"] ? TransactionCardIssuer.fromJS(_data["issuer"]) : <any>undefined;
            this.type = _data["type"];
            this.country = _data["country"];
            this.maxPanLength = _data["maxPanLength"];
            this.regulatedFlag = _data["regulatedFlag"];
        }
    }

    static fromJS(data: any): TransactionCard {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionCard();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bin"] = this.bin;
        data["binCountry"] = this.binCountry;
        data["last4Digits"] = this.last4Digits;
        data["holder"] = this.holder;
        data["expiryMonth"] = this.expiryMonth;
        data["expiryYear"] = this.expiryYear;
        data["issuer"] = this.issuer ? this.issuer.toJSON() : <any>undefined;
        data["type"] = this.type;
        data["country"] = this.country;
        data["maxPanLength"] = this.maxPanLength;
        data["regulatedFlag"] = this.regulatedFlag;
        return data;
    }

    clone(): TransactionCard {
        const json = this.toJSON();
        let result = new TransactionCard();
        result.init(json);
        return result;
    }
}

export interface ITransactionCard {
    bin: string | undefined;
    binCountry: string | undefined;
    last4Digits: string | undefined;
    holder: string | undefined;
    expiryMonth: string | undefined;
    expiryYear: string | undefined;
    issuer: TransactionCardIssuer;
    type: string | undefined;
    country: string | undefined;
    maxPanLength: string | undefined;
    regulatedFlag: string | undefined;
}

export class TransactionCardIssuer implements ITransactionCardIssuer {
    bank: string | undefined;
    website: string | undefined;
    phone: string | undefined;

    constructor(data?: ITransactionCardIssuer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bank = _data["bank"];
            this.website = _data["website"];
            this.phone = _data["phone"];
        }
    }

    static fromJS(data: any): TransactionCardIssuer {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionCardIssuer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bank"] = this.bank;
        data["website"] = this.website;
        data["phone"] = this.phone;
        return data;
    }

    clone(): TransactionCardIssuer {
        const json = this.toJSON();
        let result = new TransactionCardIssuer();
        result.init(json);
        return result;
    }
}

export interface ITransactionCardIssuer {
    bank: string | undefined;
    website: string | undefined;
    phone: string | undefined;
}

export class TransactionCustomParameters implements ITransactionCustomParameters {
    shoppeR_EndToEndIdentity: string | undefined;
    ctpE_DESCRIPTOR_TEMPLATE: string | undefined;

    constructor(data?: ITransactionCustomParameters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shoppeR_EndToEndIdentity = _data["shoppeR_EndToEndIdentity"];
            this.ctpE_DESCRIPTOR_TEMPLATE = _data["ctpE_DESCRIPTOR_TEMPLATE"];
        }
    }

    static fromJS(data: any): TransactionCustomParameters {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionCustomParameters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shoppeR_EndToEndIdentity"] = this.shoppeR_EndToEndIdentity;
        data["ctpE_DESCRIPTOR_TEMPLATE"] = this.ctpE_DESCRIPTOR_TEMPLATE;
        return data;
    }

    clone(): TransactionCustomParameters {
        const json = this.toJSON();
        let result = new TransactionCustomParameters();
        result.init(json);
        return result;
    }
}

export interface ITransactionCustomParameters {
    shoppeR_EndToEndIdentity: string | undefined;
    ctpE_DESCRIPTOR_TEMPLATE: string | undefined;
}

export class TransactionCustomer implements ITransactionCustomer {
    ip: string | undefined;
    ipCountry: string | undefined;

    constructor(data?: ITransactionCustomer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ip = _data["ip"];
            this.ipCountry = _data["ipCountry"];
        }
    }

    static fromJS(data: any): TransactionCustomer {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionCustomer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ip"] = this.ip;
        data["ipCountry"] = this.ipCountry;
        return data;
    }

    clone(): TransactionCustomer {
        const json = this.toJSON();
        let result = new TransactionCustomer();
        result.init(json);
        return result;
    }
}

export interface ITransactionCustomer {
    ip: string | undefined;
    ipCountry: string | undefined;
}

export class TransactionDto implements ITransactionDto {
    id: string;
    paymentType: PaymentType;
    total: number;
    subTotal: number;
    currency: string | undefined;
    vatPercentage: number;
    vatAmount: number;
    transactionNumber: string | undefined;
    onlineTransaction: OnlineTransactionDto;
    posTransaction: POSTransaction;
    status: PaymentStatus;
    creationTime: moment.Moment;
    creatorUserName: string | undefined;
    source: TransactionSource;
    invoiceNumber: string | undefined;
    invoiceStatus: InvoiceStatus;

    constructor(data?: ITransactionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.paymentType = _data["paymentType"];
            this.total = _data["total"];
            this.subTotal = _data["subTotal"];
            this.currency = _data["currency"];
            this.vatPercentage = _data["vatPercentage"];
            this.vatAmount = _data["vatAmount"];
            this.transactionNumber = _data["transactionNumber"];
            this.onlineTransaction = _data["onlineTransaction"] ? OnlineTransactionDto.fromJS(_data["onlineTransaction"]) : <any>undefined;
            this.posTransaction = _data["posTransaction"] ? POSTransaction.fromJS(_data["posTransaction"]) : <any>undefined;
            this.status = _data["status"] ? PaymentStatus.fromJS(_data["status"]) : <any>undefined;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserName = _data["creatorUserName"];
            this.source = _data["source"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.invoiceStatus = _data["invoiceStatus"];
        }
    }

    static fromJS(data: any): TransactionDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["paymentType"] = this.paymentType;
        data["total"] = this.total;
        data["subTotal"] = this.subTotal;
        data["currency"] = this.currency;
        data["vatPercentage"] = this.vatPercentage;
        data["vatAmount"] = this.vatAmount;
        data["transactionNumber"] = this.transactionNumber;
        data["onlineTransaction"] = this.onlineTransaction ? this.onlineTransaction.toJSON() : <any>undefined;
        data["posTransaction"] = this.posTransaction ? this.posTransaction.toJSON() : <any>undefined;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserName"] = this.creatorUserName;
        data["source"] = this.source;
        data["invoiceNumber"] = this.invoiceNumber;
        data["invoiceStatus"] = this.invoiceStatus;
        return data;
    }

    clone(): TransactionDto {
        const json = this.toJSON();
        let result = new TransactionDto();
        result.init(json);
        return result;
    }
}

export interface ITransactionDto {
    id: string;
    paymentType: PaymentType;
    total: number;
    subTotal: number;
    currency: string | undefined;
    vatPercentage: number;
    vatAmount: number;
    transactionNumber: string | undefined;
    onlineTransaction: OnlineTransactionDto;
    posTransaction: POSTransaction;
    status: PaymentStatus;
    creationTime: moment.Moment;
    creatorUserName: string | undefined;
    source: TransactionSource;
    invoiceNumber: string | undefined;
    invoiceStatus: InvoiceStatus;
}

export class TransactionDtoPagedResultDto implements ITransactionDtoPagedResultDto {
    items: TransactionDto[] | undefined;
    totalCount: number;

    constructor(data?: ITransactionDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(TransactionDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): TransactionDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): TransactionDtoPagedResultDto {
        const json = this.toJSON();
        let result = new TransactionDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ITransactionDtoPagedResultDto {
    items: TransactionDto[] | undefined;
    totalCount: number;
}

export class TransactionRecieptDto implements ITransactionRecieptDto {
    id: string;
    transactionNumber: string | undefined;
    invoiceNumber: string | undefined;
    invoiceStatus: InvoiceStatus;
    subTotal: number;
    total: number;
    vatAmount: number;
    creationTime: moment.Moment;
    paymentType: PaymentType;
    transactionIdentifier: string | undefined;

    constructor(data?: ITransactionRecieptDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.transactionNumber = _data["transactionNumber"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.invoiceStatus = _data["invoiceStatus"];
            this.subTotal = _data["subTotal"];
            this.total = _data["total"];
            this.vatAmount = _data["vatAmount"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.paymentType = _data["paymentType"];
            this.transactionIdentifier = _data["transactionIdentifier"];
        }
    }

    static fromJS(data: any): TransactionRecieptDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionRecieptDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["transactionNumber"] = this.transactionNumber;
        data["invoiceNumber"] = this.invoiceNumber;
        data["invoiceStatus"] = this.invoiceStatus;
        data["subTotal"] = this.subTotal;
        data["total"] = this.total;
        data["vatAmount"] = this.vatAmount;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["paymentType"] = this.paymentType;
        data["transactionIdentifier"] = this.transactionIdentifier;
        return data;
    }

    clone(): TransactionRecieptDto {
        const json = this.toJSON();
        let result = new TransactionRecieptDto();
        result.init(json);
        return result;
    }
}

export interface ITransactionRecieptDto {
    id: string;
    transactionNumber: string | undefined;
    invoiceNumber: string | undefined;
    invoiceStatus: InvoiceStatus;
    subTotal: number;
    total: number;
    vatAmount: number;
    creationTime: moment.Moment;
    paymentType: PaymentType;
    transactionIdentifier: string | undefined;
}

export class TransactionResponse implements ITransactionResponse {
    id: string | undefined;
    paymentType: string | undefined;
    paymentBrand: string | undefined;
    amount: string | undefined;
    currency: string | undefined;
    descriptor: string | undefined;
    result: PaymentResult;
    resultDetails: TransactionResultDetails;
    card: TransactionCard;
    customer: TransactionCustomer;
    threeDSecure: ThreeDSecure;
    customParameters: TransactionCustomParameters;
    risk: TransactionRisk;
    ndc: string | undefined;

    constructor(data?: ITransactionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.paymentType = _data["paymentType"];
            this.paymentBrand = _data["paymentBrand"];
            this.amount = _data["amount"];
            this.currency = _data["currency"];
            this.descriptor = _data["descriptor"];
            this.result = _data["result"] ? PaymentResult.fromJS(_data["result"]) : <any>undefined;
            this.resultDetails = _data["resultDetails"] ? TransactionResultDetails.fromJS(_data["resultDetails"]) : <any>undefined;
            this.card = _data["card"] ? TransactionCard.fromJS(_data["card"]) : <any>undefined;
            this.customer = _data["customer"] ? TransactionCustomer.fromJS(_data["customer"]) : <any>undefined;
            this.threeDSecure = _data["threeDSecure"] ? ThreeDSecure.fromJS(_data["threeDSecure"]) : <any>undefined;
            this.customParameters = _data["customParameters"] ? TransactionCustomParameters.fromJS(_data["customParameters"]) : <any>undefined;
            this.risk = _data["risk"] ? TransactionRisk.fromJS(_data["risk"]) : <any>undefined;
            this.ndc = _data["ndc"];
        }
    }

    static fromJS(data: any): TransactionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["paymentType"] = this.paymentType;
        data["paymentBrand"] = this.paymentBrand;
        data["amount"] = this.amount;
        data["currency"] = this.currency;
        data["descriptor"] = this.descriptor;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["resultDetails"] = this.resultDetails ? this.resultDetails.toJSON() : <any>undefined;
        data["card"] = this.card ? this.card.toJSON() : <any>undefined;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["threeDSecure"] = this.threeDSecure ? this.threeDSecure.toJSON() : <any>undefined;
        data["customParameters"] = this.customParameters ? this.customParameters.toJSON() : <any>undefined;
        data["risk"] = this.risk ? this.risk.toJSON() : <any>undefined;
        data["ndc"] = this.ndc;
        return data;
    }

    clone(): TransactionResponse {
        const json = this.toJSON();
        let result = new TransactionResponse();
        result.init(json);
        return result;
    }
}

export interface ITransactionResponse {
    id: string | undefined;
    paymentType: string | undefined;
    paymentBrand: string | undefined;
    amount: string | undefined;
    currency: string | undefined;
    descriptor: string | undefined;
    result: PaymentResult;
    resultDetails: TransactionResultDetails;
    card: TransactionCard;
    customer: TransactionCustomer;
    threeDSecure: ThreeDSecure;
    customParameters: TransactionCustomParameters;
    risk: TransactionRisk;
    ndc: string | undefined;
}

export class TransactionResultDetails implements ITransactionResultDetails {
    riskStatusCode: string | undefined;
    responseCode: string | undefined;
    clearingInstituteName: string | undefined;
    requestId: string | undefined;
    riskResponseCode: string | undefined;
    action: string | undefined;
    orderId: string | undefined;

    constructor(data?: ITransactionResultDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.riskStatusCode = _data["riskStatusCode"];
            this.responseCode = _data["responseCode"];
            this.clearingInstituteName = _data["clearingInstituteName"];
            this.requestId = _data["requestId"];
            this.riskResponseCode = _data["riskResponseCode"];
            this.action = _data["action"];
            this.orderId = _data["orderId"];
        }
    }

    static fromJS(data: any): TransactionResultDetails {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionResultDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["riskStatusCode"] = this.riskStatusCode;
        data["responseCode"] = this.responseCode;
        data["clearingInstituteName"] = this.clearingInstituteName;
        data["requestId"] = this.requestId;
        data["riskResponseCode"] = this.riskResponseCode;
        data["action"] = this.action;
        data["orderId"] = this.orderId;
        return data;
    }

    clone(): TransactionResultDetails {
        const json = this.toJSON();
        let result = new TransactionResultDetails();
        result.init(json);
        return result;
    }
}

export interface ITransactionResultDetails {
    riskStatusCode: string | undefined;
    responseCode: string | undefined;
    clearingInstituteName: string | undefined;
    requestId: string | undefined;
    riskResponseCode: string | undefined;
    action: string | undefined;
    orderId: string | undefined;
}

export class TransactionRisk implements ITransactionRisk {
    score: string | undefined;

    constructor(data?: ITransactionRisk) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.score = _data["score"];
        }
    }

    static fromJS(data: any): TransactionRisk {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionRisk();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["score"] = this.score;
        return data;
    }

    clone(): TransactionRisk {
        const json = this.toJSON();
        let result = new TransactionRisk();
        result.init(json);
        return result;
    }
}

export interface ITransactionRisk {
    score: string | undefined;
}

export enum TransactionSource {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
}

export class UpdateCustomerInput implements IUpdateCustomerInput {
    id: string;
    firstName: string | undefined;
    lastName: string | undefined;
    phoneNumber: string | undefined;
    isActive: boolean;

    constructor(data?: IUpdateCustomerInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phoneNumber = _data["phoneNumber"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): UpdateCustomerInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCustomerInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phoneNumber"] = this.phoneNumber;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): UpdateCustomerInput {
        const json = this.toJSON();
        let result = new UpdateCustomerInput();
        result.init(json);
        return result;
    }
}

export interface IUpdateCustomerInput {
    id: string;
    firstName: string | undefined;
    lastName: string | undefined;
    phoneNumber: string | undefined;
    isActive: boolean;
}

export class UpdateCustomerSupportStatusInputDto implements IUpdateCustomerSupportStatusInputDto {
    violationId: string;
    statusId: number;
    notes: string | undefined;

    constructor(data?: IUpdateCustomerSupportStatusInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.violationId = _data["violationId"];
            this.statusId = _data["statusId"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): UpdateCustomerSupportStatusInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCustomerSupportStatusInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["violationId"] = this.violationId;
        data["statusId"] = this.statusId;
        data["notes"] = this.notes;
        return data;
    }

    clone(): UpdateCustomerSupportStatusInputDto {
        const json = this.toJSON();
        let result = new UpdateCustomerSupportStatusInputDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateCustomerSupportStatusInputDto {
    violationId: string;
    statusId: number;
    notes: string | undefined;
}

export class UpdateInOutReservationPricingDiscount implements IUpdateInOutReservationPricingDiscount {
    id: number;
    discount: number;

    constructor(data?: IUpdateInOutReservationPricingDiscount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.discount = _data["discount"];
        }
    }

    static fromJS(data: any): UpdateInOutReservationPricingDiscount {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateInOutReservationPricingDiscount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["discount"] = this.discount;
        return data;
    }

    clone(): UpdateInOutReservationPricingDiscount {
        const json = this.toJSON();
        let result = new UpdateInOutReservationPricingDiscount();
        result.init(json);
        return result;
    }
}

export interface IUpdateInOutReservationPricingDiscount {
    id: number;
    discount: number;
}

export class UpdateStaffGroupDto implements IUpdateStaffGroupDto {
    staffGroupId: string;
    groupName: string | undefined;
    stafAccoutAdminIds: number[] | undefined;
    stafAccoutMemberIds: number[] | undefined;

    constructor(data?: IUpdateStaffGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.staffGroupId = _data["staffGroupId"];
            this.groupName = _data["groupName"];
            if (Array.isArray(_data["stafAccoutAdminIds"])) {
                this.stafAccoutAdminIds = [] as any;
                for (let item of _data["stafAccoutAdminIds"])
                    this.stafAccoutAdminIds.push(item);
            }
            if (Array.isArray(_data["stafAccoutMemberIds"])) {
                this.stafAccoutMemberIds = [] as any;
                for (let item of _data["stafAccoutMemberIds"])
                    this.stafAccoutMemberIds.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateStaffGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStaffGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["staffGroupId"] = this.staffGroupId;
        data["groupName"] = this.groupName;
        if (Array.isArray(this.stafAccoutAdminIds)) {
            data["stafAccoutAdminIds"] = [];
            for (let item of this.stafAccoutAdminIds)
                data["stafAccoutAdminIds"].push(item);
        }
        if (Array.isArray(this.stafAccoutMemberIds)) {
            data["stafAccoutMemberIds"] = [];
            for (let item of this.stafAccoutMemberIds)
                data["stafAccoutMemberIds"].push(item);
        }
        return data;
    }

    clone(): UpdateStaffGroupDto {
        const json = this.toJSON();
        let result = new UpdateStaffGroupDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateStaffGroupDto {
    staffGroupId: string;
    groupName: string | undefined;
    stafAccoutAdminIds: number[] | undefined;
    stafAccoutMemberIds: number[] | undefined;
}

export class UpdateSubscriptionCompanyInput implements IUpdateSubscriptionCompanyInput {
    id: string;
    name: string | undefined;
    taxId: string | undefined;
    crNumber: string | undefined;
    address: string | undefined;
    contactPersonName: string | undefined;
    contactPersonPhoneNumber: string | undefined;
    addressDetails: SubscriptionCompanyAddressDto;

    constructor(data?: IUpdateSubscriptionCompanyInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.taxId = _data["taxId"];
            this.crNumber = _data["crNumber"];
            this.address = _data["address"];
            this.contactPersonName = _data["contactPersonName"];
            this.contactPersonPhoneNumber = _data["contactPersonPhoneNumber"];
            this.addressDetails = _data["addressDetails"] ? SubscriptionCompanyAddressDto.fromJS(_data["addressDetails"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateSubscriptionCompanyInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSubscriptionCompanyInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["taxId"] = this.taxId;
        data["crNumber"] = this.crNumber;
        data["address"] = this.address;
        data["contactPersonName"] = this.contactPersonName;
        data["contactPersonPhoneNumber"] = this.contactPersonPhoneNumber;
        data["addressDetails"] = this.addressDetails ? this.addressDetails.toJSON() : <any>undefined;
        return data;
    }

    clone(): UpdateSubscriptionCompanyInput {
        const json = this.toJSON();
        let result = new UpdateSubscriptionCompanyInput();
        result.init(json);
        return result;
    }
}

export interface IUpdateSubscriptionCompanyInput {
    id: string;
    name: string | undefined;
    taxId: string | undefined;
    crNumber: string | undefined;
    address: string | undefined;
    contactPersonName: string | undefined;
    contactPersonPhoneNumber: string | undefined;
    addressDetails: SubscriptionCompanyAddressDto;
}

export class UpdateVehicleInput implements IUpdateVehicleInput {
    countryCode: string | undefined;
    vehicleId: string;
    firstName: string | undefined;
    lastName: string | undefined;
    phoneNumber: string | undefined;
    vehicleType: VehicleType;
    mobilityType: string | undefined;
    qrCodeId: number | undefined;

    constructor(data?: IUpdateVehicleInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryCode = _data["countryCode"];
            this.vehicleId = _data["vehicleId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phoneNumber = _data["phoneNumber"];
            this.vehicleType = _data["vehicleType"];
            this.mobilityType = _data["mobilityType"];
            this.qrCodeId = _data["qrCodeId"];
        }
    }

    static fromJS(data: any): UpdateVehicleInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateVehicleInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryCode"] = this.countryCode;
        data["vehicleId"] = this.vehicleId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phoneNumber"] = this.phoneNumber;
        data["vehicleType"] = this.vehicleType;
        data["mobilityType"] = this.mobilityType;
        data["qrCodeId"] = this.qrCodeId;
        return data;
    }

    clone(): UpdateVehicleInput {
        const json = this.toJSON();
        let result = new UpdateVehicleInput();
        result.init(json);
        return result;
    }
}

export interface IUpdateVehicleInput {
    countryCode: string | undefined;
    vehicleId: string;
    firstName: string | undefined;
    lastName: string | undefined;
    phoneNumber: string | undefined;
    vehicleType: VehicleType;
    mobilityType: string | undefined;
    qrCodeId: number | undefined;
}

export class UpdateVehicleListingInput implements IUpdateVehicleListingInput {
    id: string;
    status: string | undefined;
    notes: string | undefined;

    constructor(data?: IUpdateVehicleListingInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): UpdateVehicleListingInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateVehicleListingInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["notes"] = this.notes;
        return data;
    }

    clone(): UpdateVehicleListingInput {
        const json = this.toJSON();
        let result = new UpdateVehicleListingInput();
        result.init(json);
        return result;
    }
}

export interface IUpdateVehicleListingInput {
    id: string;
    status: string | undefined;
    notes: string | undefined;
}

export class UpdateVehicleRequest implements IUpdateVehicleRequest {
    id: string;
    countryId: number;
    vehiclePlate: VehiclePlate;
    vehicleType: VehicleType;
    mobilityType: string | undefined;
    customerId: string | undefined;

    constructor(data?: IUpdateVehicleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.countryId = _data["countryId"];
            this.vehiclePlate = _data["vehiclePlate"] ? VehiclePlate.fromJS(_data["vehiclePlate"]) : <any>undefined;
            this.vehicleType = _data["vehicleType"];
            this.mobilityType = _data["mobilityType"];
            this.customerId = _data["customerId"];
        }
    }

    static fromJS(data: any): UpdateVehicleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateVehicleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["countryId"] = this.countryId;
        data["vehiclePlate"] = this.vehiclePlate ? this.vehiclePlate.toJSON() : <any>undefined;
        data["vehicleType"] = this.vehicleType;
        data["mobilityType"] = this.mobilityType;
        data["customerId"] = this.customerId;
        return data;
    }

    clone(): UpdateVehicleRequest {
        const json = this.toJSON();
        let result = new UpdateVehicleRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateVehicleRequest {
    id: string;
    countryId: number;
    vehiclePlate: VehiclePlate;
    vehicleType: VehicleType;
    mobilityType: string | undefined;
    customerId: string | undefined;
}

export class User implements IUser {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    authenticationSource: string | undefined;
    userName: string;
    tenantId: number | undefined;
    emailAddress: string;
    name: string;
    surname: string;
    readonly fullName: string | undefined;
    password: string;
    emailConfirmationCode: string | undefined;
    passwordResetCode: string | undefined;
    lockoutEndDateUtc: moment.Moment | undefined;
    accessFailedCount: number;
    isLockoutEnabled: boolean;
    phoneNumber: string | undefined;
    isPhoneNumberConfirmed: boolean;
    securityStamp: string | undefined;
    isTwoFactorEnabled: boolean;
    logins: UserLogin[] | undefined;
    roles: UserRole[] | undefined;
    claims: UserClaim[] | undefined;
    permissions: UserPermissionSetting[] | undefined;
    settings: Setting[] | undefined;
    isEmailConfirmed: boolean;
    isActive: boolean;
    normalizedUserName: string;
    normalizedEmailAddress: string;
    concurrencyStamp: string | undefined;
    tokens: UserToken[] | undefined;
    deleterUser: User;
    creatorUser: User;
    lastModifierUser: User;
    shouldChangePasswordOnNextLogin: boolean;

    constructor(data?: IUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.authenticationSource = _data["authenticationSource"];
            this.userName = _data["userName"];
            this.tenantId = _data["tenantId"];
            this.emailAddress = _data["emailAddress"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            (<any>this).fullName = _data["fullName"];
            this.password = _data["password"];
            this.emailConfirmationCode = _data["emailConfirmationCode"];
            this.passwordResetCode = _data["passwordResetCode"];
            this.lockoutEndDateUtc = _data["lockoutEndDateUtc"] ? moment(_data["lockoutEndDateUtc"].toString()) : <any>undefined;
            this.accessFailedCount = _data["accessFailedCount"];
            this.isLockoutEnabled = _data["isLockoutEnabled"];
            this.phoneNumber = _data["phoneNumber"];
            this.isPhoneNumberConfirmed = _data["isPhoneNumberConfirmed"];
            this.securityStamp = _data["securityStamp"];
            this.isTwoFactorEnabled = _data["isTwoFactorEnabled"];
            if (Array.isArray(_data["logins"])) {
                this.logins = [] as any;
                for (let item of _data["logins"])
                    this.logins.push(UserLogin.fromJS(item));
            }
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles.push(UserRole.fromJS(item));
            }
            if (Array.isArray(_data["claims"])) {
                this.claims = [] as any;
                for (let item of _data["claims"])
                    this.claims.push(UserClaim.fromJS(item));
            }
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions.push(UserPermissionSetting.fromJS(item));
            }
            if (Array.isArray(_data["settings"])) {
                this.settings = [] as any;
                for (let item of _data["settings"])
                    this.settings.push(Setting.fromJS(item));
            }
            this.isEmailConfirmed = _data["isEmailConfirmed"];
            this.isActive = _data["isActive"];
            this.normalizedUserName = _data["normalizedUserName"];
            this.normalizedEmailAddress = _data["normalizedEmailAddress"];
            this.concurrencyStamp = _data["concurrencyStamp"];
            if (Array.isArray(_data["tokens"])) {
                this.tokens = [] as any;
                for (let item of _data["tokens"])
                    this.tokens.push(UserToken.fromJS(item));
            }
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : <any>undefined;
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : <any>undefined;
            this.shouldChangePasswordOnNextLogin = _data["shouldChangePasswordOnNextLogin"];
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["authenticationSource"] = this.authenticationSource;
        data["userName"] = this.userName;
        data["tenantId"] = this.tenantId;
        data["emailAddress"] = this.emailAddress;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["fullName"] = this.fullName;
        data["password"] = this.password;
        data["emailConfirmationCode"] = this.emailConfirmationCode;
        data["passwordResetCode"] = this.passwordResetCode;
        data["lockoutEndDateUtc"] = this.lockoutEndDateUtc ? this.lockoutEndDateUtc.toISOString() : <any>undefined;
        data["accessFailedCount"] = this.accessFailedCount;
        data["isLockoutEnabled"] = this.isLockoutEnabled;
        data["phoneNumber"] = this.phoneNumber;
        data["isPhoneNumberConfirmed"] = this.isPhoneNumberConfirmed;
        data["securityStamp"] = this.securityStamp;
        data["isTwoFactorEnabled"] = this.isTwoFactorEnabled;
        if (Array.isArray(this.logins)) {
            data["logins"] = [];
            for (let item of this.logins)
                data["logins"].push(item.toJSON());
        }
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        if (Array.isArray(this.claims)) {
            data["claims"] = [];
            for (let item of this.claims)
                data["claims"].push(item.toJSON());
        }
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        if (Array.isArray(this.settings)) {
            data["settings"] = [];
            for (let item of this.settings)
                data["settings"].push(item.toJSON());
        }
        data["isEmailConfirmed"] = this.isEmailConfirmed;
        data["isActive"] = this.isActive;
        data["normalizedUserName"] = this.normalizedUserName;
        data["normalizedEmailAddress"] = this.normalizedEmailAddress;
        data["concurrencyStamp"] = this.concurrencyStamp;
        if (Array.isArray(this.tokens)) {
            data["tokens"] = [];
            for (let item of this.tokens)
                data["tokens"].push(item.toJSON());
        }
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["shouldChangePasswordOnNextLogin"] = this.shouldChangePasswordOnNextLogin;
        return data;
    }

    clone(): User {
        const json = this.toJSON();
        let result = new User();
        result.init(json);
        return result;
    }
}

export interface IUser {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    authenticationSource: string | undefined;
    userName: string;
    tenantId: number | undefined;
    emailAddress: string;
    name: string;
    surname: string;
    fullName: string | undefined;
    password: string;
    emailConfirmationCode: string | undefined;
    passwordResetCode: string | undefined;
    lockoutEndDateUtc: moment.Moment | undefined;
    accessFailedCount: number;
    isLockoutEnabled: boolean;
    phoneNumber: string | undefined;
    isPhoneNumberConfirmed: boolean;
    securityStamp: string | undefined;
    isTwoFactorEnabled: boolean;
    logins: UserLogin[] | undefined;
    roles: UserRole[] | undefined;
    claims: UserClaim[] | undefined;
    permissions: UserPermissionSetting[] | undefined;
    settings: Setting[] | undefined;
    isEmailConfirmed: boolean;
    isActive: boolean;
    normalizedUserName: string;
    normalizedEmailAddress: string;
    concurrencyStamp: string | undefined;
    tokens: UserToken[] | undefined;
    deleterUser: User;
    creatorUser: User;
    lastModifierUser: User;
    shouldChangePasswordOnNextLogin: boolean;
}

export class UserClaim implements IUserClaim {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    tenantId: number | undefined;
    userId: number;
    claimType: string | undefined;
    claimValue: string | undefined;

    constructor(data?: IUserClaim) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.claimType = _data["claimType"];
            this.claimValue = _data["claimValue"];
        }
    }

    static fromJS(data: any): UserClaim {
        data = typeof data === 'object' ? data : {};
        let result = new UserClaim();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["claimType"] = this.claimType;
        data["claimValue"] = this.claimValue;
        return data;
    }

    clone(): UserClaim {
        const json = this.toJSON();
        let result = new UserClaim();
        result.init(json);
        return result;
    }
}

export interface IUserClaim {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    tenantId: number | undefined;
    userId: number;
    claimType: string | undefined;
    claimValue: string | undefined;
}

export class UserDto implements IUserDto {
    id: number;
    userName: string;
    name: string;
    surname: string;
    emailAddress: string;
    isActive: boolean;
    fullName: string | undefined;
    lastLoginTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    roleName: string | undefined;
    shouldChangePasswordOnNextLogin: boolean;
    canDelete: boolean;

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.emailAddress = _data["emailAddress"];
            this.isActive = _data["isActive"];
            this.fullName = _data["fullName"];
            this.lastLoginTime = _data["lastLoginTime"] ? moment(_data["lastLoginTime"].toString()) : <any>undefined;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.roleName = _data["roleName"];
            this.shouldChangePasswordOnNextLogin = _data["shouldChangePasswordOnNextLogin"];
            this.canDelete = _data["canDelete"];
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["emailAddress"] = this.emailAddress;
        data["isActive"] = this.isActive;
        data["fullName"] = this.fullName;
        data["lastLoginTime"] = this.lastLoginTime ? this.lastLoginTime.toISOString() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["roleName"] = this.roleName;
        data["shouldChangePasswordOnNextLogin"] = this.shouldChangePasswordOnNextLogin;
        data["canDelete"] = this.canDelete;
        return data;
    }

    clone(): UserDto {
        const json = this.toJSON();
        let result = new UserDto();
        result.init(json);
        return result;
    }
}

export interface IUserDto {
    id: number;
    userName: string;
    name: string;
    surname: string;
    emailAddress: string;
    isActive: boolean;
    fullName: string | undefined;
    lastLoginTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    roleName: string | undefined;
    shouldChangePasswordOnNextLogin: boolean;
    canDelete: boolean;
}

export class UserDtoPagedResultDto implements IUserDtoPagedResultDto {
    items: UserDto[] | undefined;
    totalCount: number;

    constructor(data?: IUserDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(UserDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): UserDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): UserDtoPagedResultDto {
        const json = this.toJSON();
        let result = new UserDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IUserDtoPagedResultDto {
    items: UserDto[] | undefined;
    totalCount: number;
}

export class UserInterface implements IUserInterface {
    icon: string | undefined;
    backgroundColor: string | undefined;
    borderColor: string | undefined;
    textColor: string | undefined;
    text: string | undefined;

    constructor(data?: IUserInterface) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.icon = _data["icon"];
            this.backgroundColor = _data["backgroundColor"];
            this.borderColor = _data["borderColor"];
            this.textColor = _data["textColor"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): UserInterface {
        data = typeof data === 'object' ? data : {};
        let result = new UserInterface();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["icon"] = this.icon;
        data["backgroundColor"] = this.backgroundColor;
        data["borderColor"] = this.borderColor;
        data["textColor"] = this.textColor;
        data["text"] = this.text;
        return data;
    }

    clone(): UserInterface {
        const json = this.toJSON();
        let result = new UserInterface();
        result.init(json);
        return result;
    }
}

export interface IUserInterface {
    icon: string | undefined;
    backgroundColor: string | undefined;
    borderColor: string | undefined;
    textColor: string | undefined;
    text: string | undefined;
}

export class UserInterfaceDto implements IUserInterfaceDto {
    icon: string | undefined;
    backgroundColor: string | undefined;
    borderColor: string | undefined;
    text: string | undefined;
    textColor: string | undefined;

    constructor(data?: IUserInterfaceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.icon = _data["icon"];
            this.backgroundColor = _data["backgroundColor"];
            this.borderColor = _data["borderColor"];
            this.text = _data["text"];
            this.textColor = _data["textColor"];
        }
    }

    static fromJS(data: any): UserInterfaceDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserInterfaceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["icon"] = this.icon;
        data["backgroundColor"] = this.backgroundColor;
        data["borderColor"] = this.borderColor;
        data["text"] = this.text;
        data["textColor"] = this.textColor;
        return data;
    }

    clone(): UserInterfaceDto {
        const json = this.toJSON();
        let result = new UserInterfaceDto();
        result.init(json);
        return result;
    }
}

export interface IUserInterfaceDto {
    icon: string | undefined;
    backgroundColor: string | undefined;
    borderColor: string | undefined;
    text: string | undefined;
    textColor: string | undefined;
}

export class UserLogin implements IUserLogin {
    id: number;
    tenantId: number | undefined;
    userId: number;
    loginProvider: string;
    providerKey: string;

    constructor(data?: IUserLogin) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.loginProvider = _data["loginProvider"];
            this.providerKey = _data["providerKey"];
        }
    }

    static fromJS(data: any): UserLogin {
        data = typeof data === 'object' ? data : {};
        let result = new UserLogin();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["loginProvider"] = this.loginProvider;
        data["providerKey"] = this.providerKey;
        return data;
    }

    clone(): UserLogin {
        const json = this.toJSON();
        let result = new UserLogin();
        result.init(json);
        return result;
    }
}

export interface IUserLogin {
    id: number;
    tenantId: number | undefined;
    userId: number;
    loginProvider: string;
    providerKey: string;
}

export class UserLoginInfoDto implements IUserLoginInfoDto {
    id: number;
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    shouldChangePasswordOnNextLogin: boolean;
    role: UserLoginRoleInfo;

    constructor(data?: IUserLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.shouldChangePasswordOnNextLogin = _data["shouldChangePasswordOnNextLogin"];
            this.role = _data["role"] ? UserLoginRoleInfo.fromJS(_data["role"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["shouldChangePasswordOnNextLogin"] = this.shouldChangePasswordOnNextLogin;
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        return data;
    }

    clone(): UserLoginInfoDto {
        const json = this.toJSON();
        let result = new UserLoginInfoDto();
        result.init(json);
        return result;
    }
}

export interface IUserLoginInfoDto {
    id: number;
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    shouldChangePasswordOnNextLogin: boolean;
    role: UserLoginRoleInfo;
}

export class UserLoginRoleInfo implements IUserLoginRoleInfo {
    name: string | undefined;
    roleType: RoleType;

    constructor(data?: IUserLoginRoleInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.roleType = _data["roleType"];
        }
    }

    static fromJS(data: any): UserLoginRoleInfo {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginRoleInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["roleType"] = this.roleType;
        return data;
    }

    clone(): UserLoginRoleInfo {
        const json = this.toJSON();
        let result = new UserLoginRoleInfo();
        result.init(json);
        return result;
    }
}

export interface IUserLoginRoleInfo {
    name: string | undefined;
    roleType: RoleType;
}

export class UserPermissionSetting implements IUserPermissionSetting {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    tenantId: number | undefined;
    name: string;
    isGranted: boolean;
    userId: number;

    constructor(data?: IUserPermissionSetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.isGranted = _data["isGranted"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): UserPermissionSetting {
        data = typeof data === 'object' ? data : {};
        let result = new UserPermissionSetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["isGranted"] = this.isGranted;
        data["userId"] = this.userId;
        return data;
    }

    clone(): UserPermissionSetting {
        const json = this.toJSON();
        let result = new UserPermissionSetting();
        result.init(json);
        return result;
    }
}

export interface IUserPermissionSetting {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    tenantId: number | undefined;
    name: string;
    isGranted: boolean;
    userId: number;
}

export class UserRole implements IUserRole {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    tenantId: number | undefined;
    userId: number;
    roleId: number;

    constructor(data?: IUserRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.roleId = _data["roleId"];
        }
    }

    static fromJS(data: any): UserRole {
        data = typeof data === 'object' ? data : {};
        let result = new UserRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["roleId"] = this.roleId;
        return data;
    }

    clone(): UserRole {
        const json = this.toJSON();
        let result = new UserRole();
        result.init(json);
        return result;
    }
}

export interface IUserRole {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    tenantId: number | undefined;
    userId: number;
    roleId: number;
}

export class UserToken implements IUserToken {
    id: number;
    tenantId: number | undefined;
    userId: number;
    loginProvider: string | undefined;
    name: string | undefined;
    value: string | undefined;
    expireDate: moment.Moment | undefined;

    constructor(data?: IUserToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.loginProvider = _data["loginProvider"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.expireDate = _data["expireDate"] ? moment(_data["expireDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UserToken {
        data = typeof data === 'object' ? data : {};
        let result = new UserToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["loginProvider"] = this.loginProvider;
        data["name"] = this.name;
        data["value"] = this.value;
        data["expireDate"] = this.expireDate ? this.expireDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): UserToken {
        const json = this.toJSON();
        let result = new UserToken();
        result.init(json);
        return result;
    }
}

export interface IUserToken {
    id: number;
    tenantId: number | undefined;
    userId: number;
    loginProvider: string | undefined;
    name: string | undefined;
    value: string | undefined;
    expireDate: moment.Moment | undefined;
}

export class Vehicle implements IVehicle {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creatorUser: User;
    lastModifierUser: User;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    readonly countryId: number;
    country: Country;
    vehiclePlate: VehiclePlate;
    readonly vehicleKey: string | undefined;
    vehicleQRCode: VehicleQRCode;
    vehicleType: VehicleType;
    mobilityType: MobilityType;
    customerId: string | undefined;
    customer: Customer;
    vehicleListing: VehicleListing;
    subscriptions: Subscription[] | undefined;
    history: SubscriptionVehicleHistory[] | undefined;
    readonly riders: Rider[] | undefined;

    constructor(data?: IVehicle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            (<any>this).countryId = _data["countryId"];
            this.country = _data["country"] ? Country.fromJS(_data["country"]) : <any>undefined;
            this.vehiclePlate = _data["vehiclePlate"] ? VehiclePlate.fromJS(_data["vehiclePlate"]) : <any>undefined;
            (<any>this).vehicleKey = _data["vehicleKey"];
            this.vehicleQRCode = _data["vehicleQRCode"] ? VehicleQRCode.fromJS(_data["vehicleQRCode"]) : <any>undefined;
            this.vehicleType = _data["vehicleType"];
            this.mobilityType = _data["mobilityType"] ? MobilityType.fromJS(_data["mobilityType"]) : <any>undefined;
            this.customerId = _data["customerId"];
            this.customer = _data["customer"] ? Customer.fromJS(_data["customer"]) : <any>undefined;
            this.vehicleListing = _data["vehicleListing"] ? VehicleListing.fromJS(_data["vehicleListing"]) : <any>undefined;
            if (Array.isArray(_data["subscriptions"])) {
                this.subscriptions = [] as any;
                for (let item of _data["subscriptions"])
                    this.subscriptions.push(Subscription.fromJS(item));
            }
            if (Array.isArray(_data["history"])) {
                this.history = [] as any;
                for (let item of _data["history"])
                    this.history.push(SubscriptionVehicleHistory.fromJS(item));
            }
            if (Array.isArray(_data["riders"])) {
                (<any>this).riders = [] as any;
                for (let item of _data["riders"])
                    (<any>this).riders.push(Rider.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Vehicle {
        data = typeof data === 'object' ? data : {};
        let result = new Vehicle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["countryId"] = this.countryId;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        data["vehiclePlate"] = this.vehiclePlate ? this.vehiclePlate.toJSON() : <any>undefined;
        data["vehicleKey"] = this.vehicleKey;
        data["vehicleQRCode"] = this.vehicleQRCode ? this.vehicleQRCode.toJSON() : <any>undefined;
        data["vehicleType"] = this.vehicleType;
        data["mobilityType"] = this.mobilityType ? this.mobilityType.toJSON() : <any>undefined;
        data["customerId"] = this.customerId;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["vehicleListing"] = this.vehicleListing ? this.vehicleListing.toJSON() : <any>undefined;
        if (Array.isArray(this.subscriptions)) {
            data["subscriptions"] = [];
            for (let item of this.subscriptions)
                data["subscriptions"].push(item.toJSON());
        }
        if (Array.isArray(this.history)) {
            data["history"] = [];
            for (let item of this.history)
                data["history"].push(item.toJSON());
        }
        if (Array.isArray(this.riders)) {
            data["riders"] = [];
            for (let item of this.riders)
                data["riders"].push(item.toJSON());
        }
        return data;
    }

    clone(): Vehicle {
        const json = this.toJSON();
        let result = new Vehicle();
        result.init(json);
        return result;
    }
}

export interface IVehicle {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creatorUser: User;
    lastModifierUser: User;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    countryId: number;
    country: Country;
    vehiclePlate: VehiclePlate;
    vehicleKey: string | undefined;
    vehicleQRCode: VehicleQRCode;
    vehicleType: VehicleType;
    mobilityType: MobilityType;
    customerId: string | undefined;
    customer: Customer;
    vehicleListing: VehicleListing;
    subscriptions: Subscription[] | undefined;
    history: SubscriptionVehicleHistory[] | undefined;
    riders: Rider[] | undefined;
}

export class VehicleDto implements IVehicleDto {
    id: string;
    vehicleType: VehicleType;
    vehicleTypeNameAr: string | undefined;
    vehicleTypeNameEn: string | undefined;
    countryId: number;
    country: CountryListDto;
    carPlate: VehiclePlate;
    qrCode: VehicleQRCodeDto;
    mobilityType: string | undefined;
    customerId: string;
    customer: CustomerDto;
    riders: VehicleRiderDto[] | undefined;

    constructor(data?: IVehicleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.vehicleType = _data["vehicleType"];
            this.vehicleTypeNameAr = _data["vehicleTypeNameAr"];
            this.vehicleTypeNameEn = _data["vehicleTypeNameEn"];
            this.countryId = _data["countryId"];
            this.country = _data["country"] ? CountryListDto.fromJS(_data["country"]) : <any>undefined;
            this.carPlate = _data["carPlate"] ? VehiclePlate.fromJS(_data["carPlate"]) : <any>undefined;
            this.qrCode = _data["qrCode"] ? VehicleQRCodeDto.fromJS(_data["qrCode"]) : <any>undefined;
            this.mobilityType = _data["mobilityType"];
            this.customerId = _data["customerId"];
            this.customer = _data["customer"] ? CustomerDto.fromJS(_data["customer"]) : <any>undefined;
            if (Array.isArray(_data["riders"])) {
                this.riders = [] as any;
                for (let item of _data["riders"])
                    this.riders.push(VehicleRiderDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VehicleDto {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["vehicleType"] = this.vehicleType;
        data["vehicleTypeNameAr"] = this.vehicleTypeNameAr;
        data["vehicleTypeNameEn"] = this.vehicleTypeNameEn;
        data["countryId"] = this.countryId;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        data["carPlate"] = this.carPlate ? this.carPlate.toJSON() : <any>undefined;
        data["qrCode"] = this.qrCode ? this.qrCode.toJSON() : <any>undefined;
        data["mobilityType"] = this.mobilityType;
        data["customerId"] = this.customerId;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        if (Array.isArray(this.riders)) {
            data["riders"] = [];
            for (let item of this.riders)
                data["riders"].push(item.toJSON());
        }
        return data;
    }

    clone(): VehicleDto {
        const json = this.toJSON();
        let result = new VehicleDto();
        result.init(json);
        return result;
    }
}

export interface IVehicleDto {
    id: string;
    vehicleType: VehicleType;
    vehicleTypeNameAr: string | undefined;
    vehicleTypeNameEn: string | undefined;
    countryId: number;
    country: CountryListDto;
    carPlate: VehiclePlate;
    qrCode: VehicleQRCodeDto;
    mobilityType: string | undefined;
    customerId: string;
    customer: CustomerDto;
    riders: VehicleRiderDto[] | undefined;
}

export class VehicleDtoPagedResultDto implements IVehicleDtoPagedResultDto {
    items: VehicleDto[] | undefined;
    totalCount: number;

    constructor(data?: IVehicleDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(VehicleDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): VehicleDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): VehicleDtoPagedResultDto {
        const json = this.toJSON();
        let result = new VehicleDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IVehicleDtoPagedResultDto {
    items: VehicleDto[] | undefined;
    totalCount: number;
}

export class VehicleListResponse implements IVehicleListResponse {
    id: string;
    vehicleType: VehicleType;
    vehicleTypeNameAr: string | undefined;
    vehicleTypeNameEn: string | undefined;
    mobilityType: string | undefined;
    carPlate: VehiclePlate;
    qrCode: VehicleQRCodeDto;
    customer: CustomerDto;
    country: CountryResponse;

    constructor(data?: IVehicleListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.vehicleType = _data["vehicleType"];
            this.vehicleTypeNameAr = _data["vehicleTypeNameAr"];
            this.vehicleTypeNameEn = _data["vehicleTypeNameEn"];
            this.mobilityType = _data["mobilityType"];
            this.carPlate = _data["carPlate"] ? VehiclePlate.fromJS(_data["carPlate"]) : <any>undefined;
            this.qrCode = _data["qrCode"] ? VehicleQRCodeDto.fromJS(_data["qrCode"]) : <any>undefined;
            this.customer = _data["customer"] ? CustomerDto.fromJS(_data["customer"]) : <any>undefined;
            this.country = _data["country"] ? CountryResponse.fromJS(_data["country"]) : <any>undefined;
        }
    }

    static fromJS(data: any): VehicleListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["vehicleType"] = this.vehicleType;
        data["vehicleTypeNameAr"] = this.vehicleTypeNameAr;
        data["vehicleTypeNameEn"] = this.vehicleTypeNameEn;
        data["mobilityType"] = this.mobilityType;
        data["carPlate"] = this.carPlate ? this.carPlate.toJSON() : <any>undefined;
        data["qrCode"] = this.qrCode ? this.qrCode.toJSON() : <any>undefined;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        return data;
    }

    clone(): VehicleListResponse {
        const json = this.toJSON();
        let result = new VehicleListResponse();
        result.init(json);
        return result;
    }
}

export interface IVehicleListResponse {
    id: string;
    vehicleType: VehicleType;
    vehicleTypeNameAr: string | undefined;
    vehicleTypeNameEn: string | undefined;
    mobilityType: string | undefined;
    carPlate: VehiclePlate;
    qrCode: VehicleQRCodeDto;
    customer: CustomerDto;
    country: CountryResponse;
}

export class VehicleListing implements IVehicleListing {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creatorUser: User;
    lastModifierUser: User;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    status: VehicleListingStatusEnum;
    vehicleId: string;
    vehicle: Vehicle;
    notes: string | undefined;

    constructor(data?: IVehicleListing) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.status = _data["status"] ? VehicleListingStatusEnum.fromJS(_data["status"]) : <any>undefined;
            this.vehicleId = _data["vehicleId"];
            this.vehicle = _data["vehicle"] ? Vehicle.fromJS(_data["vehicle"]) : <any>undefined;
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): VehicleListing {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleListing();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["vehicleId"] = this.vehicleId;
        data["vehicle"] = this.vehicle ? this.vehicle.toJSON() : <any>undefined;
        data["notes"] = this.notes;
        return data;
    }

    clone(): VehicleListing {
        const json = this.toJSON();
        let result = new VehicleListing();
        result.init(json);
        return result;
    }
}

export interface IVehicleListing {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creatorUser: User;
    lastModifierUser: User;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    status: VehicleListingStatusEnum;
    vehicleId: string;
    vehicle: Vehicle;
    notes: string | undefined;
}

export class VehicleListingDto implements IVehicleListingDto {
    id: string;
    status: VehicleListingStatusEnum;
    vehicle: VehicleDto;
    notes: string | undefined;

    constructor(data?: IVehicleListingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"] ? VehicleListingStatusEnum.fromJS(_data["status"]) : <any>undefined;
            this.vehicle = _data["vehicle"] ? VehicleDto.fromJS(_data["vehicle"]) : <any>undefined;
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): VehicleListingDto {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleListingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["vehicle"] = this.vehicle ? this.vehicle.toJSON() : <any>undefined;
        data["notes"] = this.notes;
        return data;
    }

    clone(): VehicleListingDto {
        const json = this.toJSON();
        let result = new VehicleListingDto();
        result.init(json);
        return result;
    }
}

export interface IVehicleListingDto {
    id: string;
    status: VehicleListingStatusEnum;
    vehicle: VehicleDto;
    notes: string | undefined;
}

export class VehicleListingDtoPagedResultDto implements IVehicleListingDtoPagedResultDto {
    items: VehicleListingDto[] | undefined;
    totalCount: number;

    constructor(data?: IVehicleListingDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(VehicleListingDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): VehicleListingDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleListingDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): VehicleListingDtoPagedResultDto {
        const json = this.toJSON();
        let result = new VehicleListingDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IVehicleListingDtoPagedResultDto {
    items: VehicleListingDto[] | undefined;
    totalCount: number;
}

export class VehicleListingStatusEnum implements IVehicleListingStatusEnum {
    readonly id: number;
    readonly name: string | undefined;

    constructor(data?: IVehicleListingStatusEnum) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).id = _data["id"];
            (<any>this).name = _data["name"];
        }
    }

    static fromJS(data: any): VehicleListingStatusEnum {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleListingStatusEnum();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): VehicleListingStatusEnum {
        const json = this.toJSON();
        let result = new VehicleListingStatusEnum();
        result.init(json);
        return result;
    }
}

export interface IVehicleListingStatusEnum {
    id: number;
    name: string | undefined;
}

export class VehicleLookupDto implements IVehicleLookupDto {
    id: string;
    vehiclePlate: VehiclePlate;
    mobilityType: string | undefined;

    constructor(data?: IVehicleLookupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.vehiclePlate = _data["vehiclePlate"] ? VehiclePlate.fromJS(_data["vehiclePlate"]) : <any>undefined;
            this.mobilityType = _data["mobilityType"];
        }
    }

    static fromJS(data: any): VehicleLookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleLookupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["vehiclePlate"] = this.vehiclePlate ? this.vehiclePlate.toJSON() : <any>undefined;
        data["mobilityType"] = this.mobilityType;
        return data;
    }

    clone(): VehicleLookupDto {
        const json = this.toJSON();
        let result = new VehicleLookupDto();
        result.init(json);
        return result;
    }
}

export interface IVehicleLookupDto {
    id: string;
    vehiclePlate: VehiclePlate;
    mobilityType: string | undefined;
}

export class VehiclePlate implements IVehiclePlate {
    letters: string | undefined;
    digits: number;
    readonly fullCarPlate: string | undefined;

    constructor(data?: IVehiclePlate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.letters = _data["letters"];
            this.digits = _data["digits"];
            (<any>this).fullCarPlate = _data["fullCarPlate"];
        }
    }

    static fromJS(data: any): VehiclePlate {
        data = typeof data === 'object' ? data : {};
        let result = new VehiclePlate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["letters"] = this.letters;
        data["digits"] = this.digits;
        data["fullCarPlate"] = this.fullCarPlate;
        return data;
    }

    clone(): VehiclePlate {
        const json = this.toJSON();
        let result = new VehiclePlate();
        result.init(json);
        return result;
    }
}

export interface IVehiclePlate {
    letters: string | undefined;
    digits: number;
    fullCarPlate: string | undefined;
}

export class VehicleQRCode implements IVehicleQRCode {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    readonly code: string | undefined;
    isActive: boolean;
    vehicleId: string | undefined;
    vehicle: Vehicle;

    constructor(data?: IVehicleQRCode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            (<any>this).code = _data["code"];
            this.isActive = _data["isActive"];
            this.vehicleId = _data["vehicleId"];
            this.vehicle = _data["vehicle"] ? Vehicle.fromJS(_data["vehicle"]) : <any>undefined;
        }
    }

    static fromJS(data: any): VehicleQRCode {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleQRCode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["code"] = this.code;
        data["isActive"] = this.isActive;
        data["vehicleId"] = this.vehicleId;
        data["vehicle"] = this.vehicle ? this.vehicle.toJSON() : <any>undefined;
        return data;
    }

    clone(): VehicleQRCode {
        const json = this.toJSON();
        let result = new VehicleQRCode();
        result.init(json);
        return result;
    }
}

export interface IVehicleQRCode {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    code: string | undefined;
    isActive: boolean;
    vehicleId: string | undefined;
    vehicle: Vehicle;
}

export class VehicleQRCodeDto implements IVehicleQRCodeDto {
    id: number;
    readonly code: string | undefined;
    isActive: boolean;
    vehicleId: string | undefined;

    constructor(data?: IVehicleQRCodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            (<any>this).code = _data["code"];
            this.isActive = _data["isActive"];
            this.vehicleId = _data["vehicleId"];
        }
    }

    static fromJS(data: any): VehicleQRCodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleQRCodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["isActive"] = this.isActive;
        data["vehicleId"] = this.vehicleId;
        return data;
    }

    clone(): VehicleQRCodeDto {
        const json = this.toJSON();
        let result = new VehicleQRCodeDto();
        result.init(json);
        return result;
    }
}

export interface IVehicleQRCodeDto {
    id: number;
    code: string | undefined;
    isActive: boolean;
    vehicleId: string | undefined;
}

export class VehicleQRCodeDtoPagedResultDto implements IVehicleQRCodeDtoPagedResultDto {
    items: VehicleQRCodeDto[] | undefined;
    totalCount: number;

    constructor(data?: IVehicleQRCodeDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(VehicleQRCodeDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): VehicleQRCodeDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleQRCodeDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): VehicleQRCodeDtoPagedResultDto {
        const json = this.toJSON();
        let result = new VehicleQRCodeDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IVehicleQRCodeDtoPagedResultDto {
    items: VehicleQRCodeDto[] | undefined;
    totalCount: number;
}

export class VehicleRiderDto implements IVehicleRiderDto {
    fullName: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    mobileNumber: string | undefined;

    constructor(data?: IVehicleRiderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data["fullName"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.mobileNumber = _data["mobileNumber"];
        }
    }

    static fromJS(data: any): VehicleRiderDto {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleRiderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullName"] = this.fullName;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["mobileNumber"] = this.mobileNumber;
        return data;
    }

    clone(): VehicleRiderDto {
        const json = this.toJSON();
        let result = new VehicleRiderDto();
        result.init(json);
        return result;
    }
}

export interface IVehicleRiderDto {
    fullName: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    mobileNumber: string | undefined;
}

export class VehicleStatus implements IVehicleStatus {
    readonly name: string | undefined;
    readonly id: number;

    constructor(data?: IVehicleStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data["name"];
            (<any>this).id = _data["id"];
        }
    }

    static fromJS(data: any): VehicleStatus {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }

    clone(): VehicleStatus {
        const json = this.toJSON();
        let result = new VehicleStatus();
        result.init(json);
        return result;
    }
}

export interface IVehicleStatus {
    name: string | undefined;
    id: number;
}

export enum VehicleType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
}

export class VehicleTypeDto implements IVehicleTypeDto {
    id: number;
    nameAr: string | undefined;
    nameEn: string | undefined;

    constructor(data?: IVehicleTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.nameAr = _data["nameAr"];
            this.nameEn = _data["nameEn"];
        }
    }

    static fromJS(data: any): VehicleTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["nameAr"] = this.nameAr;
        data["nameEn"] = this.nameEn;
        return data;
    }

    clone(): VehicleTypeDto {
        const json = this.toJSON();
        let result = new VehicleTypeDto();
        result.init(json);
        return result;
    }
}

export interface IVehicleTypeDto {
    id: number;
    nameAr: string | undefined;
    nameEn: string | undefined;
}

export class ViewCustomerDto implements IViewCustomerDto {
    id: string;
    firstName: string | undefined;
    lastName: string | undefined;
    phoneNumber: string | undefined;
    isActive: boolean;
    vehicles: VehicleDto[] | undefined;

    constructor(data?: IViewCustomerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phoneNumber = _data["phoneNumber"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["vehicles"])) {
                this.vehicles = [] as any;
                for (let item of _data["vehicles"])
                    this.vehicles.push(VehicleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ViewCustomerDto {
        data = typeof data === 'object' ? data : {};
        let result = new ViewCustomerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phoneNumber"] = this.phoneNumber;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.vehicles)) {
            data["vehicles"] = [];
            for (let item of this.vehicles)
                data["vehicles"].push(item.toJSON());
        }
        return data;
    }

    clone(): ViewCustomerDto {
        const json = this.toJSON();
        let result = new ViewCustomerDto();
        result.init(json);
        return result;
    }
}

export interface IViewCustomerDto {
    id: string;
    firstName: string | undefined;
    lastName: string | undefined;
    phoneNumber: string | undefined;
    isActive: boolean;
    vehicles: VehicleDto[] | undefined;
}

export class ViewCustomerDtoPagedResultDto implements IViewCustomerDtoPagedResultDto {
    items: ViewCustomerDto[] | undefined;
    totalCount: number;

    constructor(data?: IViewCustomerDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ViewCustomerDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ViewCustomerDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ViewCustomerDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ViewCustomerDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ViewCustomerDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IViewCustomerDtoPagedResultDto {
    items: ViewCustomerDto[] | undefined;
    totalCount: number;
}

export class Violation implements IViolation {
    id: string;
    readonly domainEvents: IEventData[] | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creatorUser: User;
    lastModifierUser: User;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    readonly code: number;
    carPlate: CarPlate;
    readonly vehicleId: string | undefined;
    vehicle: Vehicle;
    customerName: string | undefined;
    readonly countryCode: string | undefined;
    phoneNumber: string | undefined;
    slotId: number;
    slot: Slot;
    locationPoint: Point;
    reservationId: string | undefined;
    reservation: Reservation;
    readonly invoiceNumber: string | undefined;
    currentState: ViolationState;
    readonly states: ViolationState[] | undefined;
    readonly violationItems: ViolationItem[] | undefined;
    readonly operationNotes: OperationNote[] | undefined;
    readonly cancellationRequests: CancellationRequest[] | undefined;
    currency: string | undefined;
    readonly total: number;
    readonly subTotal: number;
    readonly vatAmount: number;
    notes: string | undefined;
    clampNumber: string | undefined;
    reservedTimeLockDate: moment.Moment | undefined;
    towingImpoundLockDate: moment.Moment | undefined;
    vatPercentage: number | undefined;
    reservedTimeDetails: ReservedTimeDetails;
    towingImpoundDetails: TowingImpoundDetails;
    readonly customerSupportStatusId: number | undefined;
    customerSupportStatus: CustomerSupportStatus;

    constructor(data?: IViolation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["domainEvents"])) {
                (<any>this).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (<any>this).domainEvents.push(IEventData.fromJS(item));
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            (<any>this).code = _data["code"];
            this.carPlate = _data["carPlate"] ? CarPlate.fromJS(_data["carPlate"]) : <any>undefined;
            (<any>this).vehicleId = _data["vehicleId"];
            this.vehicle = _data["vehicle"] ? Vehicle.fromJS(_data["vehicle"]) : <any>undefined;
            this.customerName = _data["customerName"];
            (<any>this).countryCode = _data["countryCode"];
            this.phoneNumber = _data["phoneNumber"];
            this.slotId = _data["slotId"];
            this.slot = _data["slot"] ? Slot.fromJS(_data["slot"]) : <any>undefined;
            this.locationPoint = _data["locationPoint"] ? Point.fromJS(_data["locationPoint"]) : <any>undefined;
            this.reservationId = _data["reservationId"];
            this.reservation = _data["reservation"] ? Reservation.fromJS(_data["reservation"]) : <any>undefined;
            (<any>this).invoiceNumber = _data["invoiceNumber"];
            this.currentState = _data["currentState"] ? ViolationState.fromJS(_data["currentState"]) : <any>undefined;
            if (Array.isArray(_data["states"])) {
                (<any>this).states = [] as any;
                for (let item of _data["states"])
                    (<any>this).states.push(ViolationState.fromJS(item));
            }
            if (Array.isArray(_data["violationItems"])) {
                (<any>this).violationItems = [] as any;
                for (let item of _data["violationItems"])
                    (<any>this).violationItems.push(ViolationItem.fromJS(item));
            }
            if (Array.isArray(_data["operationNotes"])) {
                (<any>this).operationNotes = [] as any;
                for (let item of _data["operationNotes"])
                    (<any>this).operationNotes.push(OperationNote.fromJS(item));
            }
            if (Array.isArray(_data["cancellationRequests"])) {
                (<any>this).cancellationRequests = [] as any;
                for (let item of _data["cancellationRequests"])
                    (<any>this).cancellationRequests.push(CancellationRequest.fromJS(item));
            }
            this.currency = _data["currency"];
            (<any>this).total = _data["total"];
            (<any>this).subTotal = _data["subTotal"];
            (<any>this).vatAmount = _data["vatAmount"];
            this.notes = _data["notes"];
            this.clampNumber = _data["clampNumber"];
            this.reservedTimeLockDate = _data["reservedTimeLockDate"] ? moment(_data["reservedTimeLockDate"].toString()) : <any>undefined;
            this.towingImpoundLockDate = _data["towingImpoundLockDate"] ? moment(_data["towingImpoundLockDate"].toString()) : <any>undefined;
            this.vatPercentage = _data["vatPercentage"];
            this.reservedTimeDetails = _data["reservedTimeDetails"] ? ReservedTimeDetails.fromJS(_data["reservedTimeDetails"]) : <any>undefined;
            this.towingImpoundDetails = _data["towingImpoundDetails"] ? TowingImpoundDetails.fromJS(_data["towingImpoundDetails"]) : <any>undefined;
            (<any>this).customerSupportStatusId = _data["customerSupportStatusId"];
            this.customerSupportStatus = _data["customerSupportStatus"] ? CustomerSupportStatus.fromJS(_data["customerSupportStatus"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Violation {
        data = typeof data === 'object' ? data : {};
        let result = new Violation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item.toJSON());
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["code"] = this.code;
        data["carPlate"] = this.carPlate ? this.carPlate.toJSON() : <any>undefined;
        data["vehicleId"] = this.vehicleId;
        data["vehicle"] = this.vehicle ? this.vehicle.toJSON() : <any>undefined;
        data["customerName"] = this.customerName;
        data["countryCode"] = this.countryCode;
        data["phoneNumber"] = this.phoneNumber;
        data["slotId"] = this.slotId;
        data["slot"] = this.slot ? this.slot.toJSON() : <any>undefined;
        data["locationPoint"] = this.locationPoint ? this.locationPoint.toJSON() : <any>undefined;
        data["reservationId"] = this.reservationId;
        data["reservation"] = this.reservation ? this.reservation.toJSON() : <any>undefined;
        data["invoiceNumber"] = this.invoiceNumber;
        data["currentState"] = this.currentState ? this.currentState.toJSON() : <any>undefined;
        if (Array.isArray(this.states)) {
            data["states"] = [];
            for (let item of this.states)
                data["states"].push(item.toJSON());
        }
        if (Array.isArray(this.violationItems)) {
            data["violationItems"] = [];
            for (let item of this.violationItems)
                data["violationItems"].push(item.toJSON());
        }
        if (Array.isArray(this.operationNotes)) {
            data["operationNotes"] = [];
            for (let item of this.operationNotes)
                data["operationNotes"].push(item.toJSON());
        }
        if (Array.isArray(this.cancellationRequests)) {
            data["cancellationRequests"] = [];
            for (let item of this.cancellationRequests)
                data["cancellationRequests"].push(item.toJSON());
        }
        data["currency"] = this.currency;
        data["total"] = this.total;
        data["subTotal"] = this.subTotal;
        data["vatAmount"] = this.vatAmount;
        data["notes"] = this.notes;
        data["clampNumber"] = this.clampNumber;
        data["reservedTimeLockDate"] = this.reservedTimeLockDate ? this.reservedTimeLockDate.toISOString() : <any>undefined;
        data["towingImpoundLockDate"] = this.towingImpoundLockDate ? this.towingImpoundLockDate.toISOString() : <any>undefined;
        data["vatPercentage"] = this.vatPercentage;
        data["reservedTimeDetails"] = this.reservedTimeDetails ? this.reservedTimeDetails.toJSON() : <any>undefined;
        data["towingImpoundDetails"] = this.towingImpoundDetails ? this.towingImpoundDetails.toJSON() : <any>undefined;
        data["customerSupportStatusId"] = this.customerSupportStatusId;
        data["customerSupportStatus"] = this.customerSupportStatus ? this.customerSupportStatus.toJSON() : <any>undefined;
        return data;
    }

    clone(): Violation {
        const json = this.toJSON();
        let result = new Violation();
        result.init(json);
        return result;
    }
}

export interface IViolation {
    id: string;
    domainEvents: IEventData[] | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creatorUser: User;
    lastModifierUser: User;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    code: number;
    carPlate: CarPlate;
    vehicleId: string | undefined;
    vehicle: Vehicle;
    customerName: string | undefined;
    countryCode: string | undefined;
    phoneNumber: string | undefined;
    slotId: number;
    slot: Slot;
    locationPoint: Point;
    reservationId: string | undefined;
    reservation: Reservation;
    invoiceNumber: string | undefined;
    currentState: ViolationState;
    states: ViolationState[] | undefined;
    violationItems: ViolationItem[] | undefined;
    operationNotes: OperationNote[] | undefined;
    cancellationRequests: CancellationRequest[] | undefined;
    currency: string | undefined;
    total: number;
    subTotal: number;
    vatAmount: number;
    notes: string | undefined;
    clampNumber: string | undefined;
    reservedTimeLockDate: moment.Moment | undefined;
    towingImpoundLockDate: moment.Moment | undefined;
    vatPercentage: number | undefined;
    reservedTimeDetails: ReservedTimeDetails;
    towingImpoundDetails: TowingImpoundDetails;
    customerSupportStatusId: number | undefined;
    customerSupportStatus: CustomerSupportStatus;
}

export class ViolationAction implements IViolationAction {
    readonly name: string | undefined;
    readonly id: number;
    ui: UserInterface;
    action: IWorkflowAction;

    constructor(data?: IViolationAction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data["name"];
            (<any>this).id = _data["id"];
            this.ui = _data["ui"] ? UserInterface.fromJS(_data["ui"]) : <any>undefined;
            this.action = _data["action"] ? IWorkflowAction.fromJS(_data["action"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ViolationAction {
        data = typeof data === 'object' ? data : {};
        let result = new ViolationAction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        data["ui"] = this.ui ? this.ui.toJSON() : <any>undefined;
        data["action"] = this.action ? this.action.toJSON() : <any>undefined;
        return data;
    }

    clone(): ViolationAction {
        const json = this.toJSON();
        let result = new ViolationAction();
        result.init(json);
        return result;
    }
}

export interface IViolationAction {
    name: string | undefined;
    id: number;
    ui: UserInterface;
    action: IWorkflowAction;
}

export class ViolationActionDto implements IViolationActionDto {
    id: number;
    name: string | undefined;
    ui: UserInterfaceDto;

    constructor(data?: IViolationActionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.ui = _data["ui"] ? UserInterfaceDto.fromJS(_data["ui"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ViolationActionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ViolationActionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["ui"] = this.ui ? this.ui.toJSON() : <any>undefined;
        return data;
    }

    clone(): ViolationActionDto {
        const json = this.toJSON();
        let result = new ViolationActionDto();
        result.init(json);
        return result;
    }
}

export interface IViolationActionDto {
    id: number;
    name: string | undefined;
    ui: UserInterfaceDto;
}

export enum ViolationActions {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _9 = 9,
    _10 = 10,
    _11 = 11,
    _12 = 12,
    _13 = 13,
    _14 = 14,
    _15 = 15,
    _16 = 16,
    _17 = 17,
    _18 = 18,
    _19 = 19,
    _20 = 20,
    _21 = 21,
    _22 = 22,
}

export class ViolationDto implements IViolationDto {
    id: string;
    code: number;
    carPlate: CarPlate;
    vehicle: VehicleListResponse;
    customerName: string | undefined;
    phoneNumber: string | undefined;
    latitude: number | undefined;
    longitude: number | undefined;
    reservationId: string | undefined;
    reservation: ReservationDto;
    shift: StaffAccountShiftDto;
    location: LocationListDto;
    slot: SlotListDto;
    violationItems: ViolationItemDto[] | undefined;
    states: ViolationStateDto[] | undefined;
    currentState: ViolationStateDto;
    reservedTimeDetails: ReservedTimeDetailsDto;
    towingImpoundDetails: TowingImpoundDetailsDto;
    notes: string | undefined;
    currency: string | undefined;
    total: number;
    subTotal: number;
    vatAmount: number;
    creationTime: moment.Moment;
    creator: string | undefined;
    clampNumber: string | undefined;
    referenceNumber: string | undefined;
    customerSupportStatus: CustomerSupportStatusDto;
    hasActiveCancellationRequest: boolean;

    constructor(data?: IViolationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.carPlate = _data["carPlate"] ? CarPlate.fromJS(_data["carPlate"]) : <any>undefined;
            this.vehicle = _data["vehicle"] ? VehicleListResponse.fromJS(_data["vehicle"]) : <any>undefined;
            this.customerName = _data["customerName"];
            this.phoneNumber = _data["phoneNumber"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.reservationId = _data["reservationId"];
            this.reservation = _data["reservation"] ? ReservationDto.fromJS(_data["reservation"]) : <any>undefined;
            this.shift = _data["shift"] ? StaffAccountShiftDto.fromJS(_data["shift"]) : <any>undefined;
            this.location = _data["location"] ? LocationListDto.fromJS(_data["location"]) : <any>undefined;
            this.slot = _data["slot"] ? SlotListDto.fromJS(_data["slot"]) : <any>undefined;
            if (Array.isArray(_data["violationItems"])) {
                this.violationItems = [] as any;
                for (let item of _data["violationItems"])
                    this.violationItems.push(ViolationItemDto.fromJS(item));
            }
            if (Array.isArray(_data["states"])) {
                this.states = [] as any;
                for (let item of _data["states"])
                    this.states.push(ViolationStateDto.fromJS(item));
            }
            this.currentState = _data["currentState"] ? ViolationStateDto.fromJS(_data["currentState"]) : <any>undefined;
            this.reservedTimeDetails = _data["reservedTimeDetails"] ? ReservedTimeDetailsDto.fromJS(_data["reservedTimeDetails"]) : <any>undefined;
            this.towingImpoundDetails = _data["towingImpoundDetails"] ? TowingImpoundDetailsDto.fromJS(_data["towingImpoundDetails"]) : <any>undefined;
            this.notes = _data["notes"];
            this.currency = _data["currency"];
            this.total = _data["total"];
            this.subTotal = _data["subTotal"];
            this.vatAmount = _data["vatAmount"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creator = _data["creator"];
            this.clampNumber = _data["clampNumber"];
            this.referenceNumber = _data["referenceNumber"];
            this.customerSupportStatus = _data["customerSupportStatus"] ? CustomerSupportStatusDto.fromJS(_data["customerSupportStatus"]) : <any>undefined;
            this.hasActiveCancellationRequest = _data["hasActiveCancellationRequest"];
        }
    }

    static fromJS(data: any): ViolationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ViolationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["carPlate"] = this.carPlate ? this.carPlate.toJSON() : <any>undefined;
        data["vehicle"] = this.vehicle ? this.vehicle.toJSON() : <any>undefined;
        data["customerName"] = this.customerName;
        data["phoneNumber"] = this.phoneNumber;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["reservationId"] = this.reservationId;
        data["reservation"] = this.reservation ? this.reservation.toJSON() : <any>undefined;
        data["shift"] = this.shift ? this.shift.toJSON() : <any>undefined;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["slot"] = this.slot ? this.slot.toJSON() : <any>undefined;
        if (Array.isArray(this.violationItems)) {
            data["violationItems"] = [];
            for (let item of this.violationItems)
                data["violationItems"].push(item.toJSON());
        }
        if (Array.isArray(this.states)) {
            data["states"] = [];
            for (let item of this.states)
                data["states"].push(item.toJSON());
        }
        data["currentState"] = this.currentState ? this.currentState.toJSON() : <any>undefined;
        data["reservedTimeDetails"] = this.reservedTimeDetails ? this.reservedTimeDetails.toJSON() : <any>undefined;
        data["towingImpoundDetails"] = this.towingImpoundDetails ? this.towingImpoundDetails.toJSON() : <any>undefined;
        data["notes"] = this.notes;
        data["currency"] = this.currency;
        data["total"] = this.total;
        data["subTotal"] = this.subTotal;
        data["vatAmount"] = this.vatAmount;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creator"] = this.creator;
        data["clampNumber"] = this.clampNumber;
        data["referenceNumber"] = this.referenceNumber;
        data["customerSupportStatus"] = this.customerSupportStatus ? this.customerSupportStatus.toJSON() : <any>undefined;
        data["hasActiveCancellationRequest"] = this.hasActiveCancellationRequest;
        return data;
    }

    clone(): ViolationDto {
        const json = this.toJSON();
        let result = new ViolationDto();
        result.init(json);
        return result;
    }
}

export interface IViolationDto {
    id: string;
    code: number;
    carPlate: CarPlate;
    vehicle: VehicleListResponse;
    customerName: string | undefined;
    phoneNumber: string | undefined;
    latitude: number | undefined;
    longitude: number | undefined;
    reservationId: string | undefined;
    reservation: ReservationDto;
    shift: StaffAccountShiftDto;
    location: LocationListDto;
    slot: SlotListDto;
    violationItems: ViolationItemDto[] | undefined;
    states: ViolationStateDto[] | undefined;
    currentState: ViolationStateDto;
    reservedTimeDetails: ReservedTimeDetailsDto;
    towingImpoundDetails: TowingImpoundDetailsDto;
    notes: string | undefined;
    currency: string | undefined;
    total: number;
    subTotal: number;
    vatAmount: number;
    creationTime: moment.Moment;
    creator: string | undefined;
    clampNumber: string | undefined;
    referenceNumber: string | undefined;
    customerSupportStatus: CustomerSupportStatusDto;
    hasActiveCancellationRequest: boolean;
}

export class ViolationDtoPagedResultDto implements IViolationDtoPagedResultDto {
    items: ViolationDto[] | undefined;
    totalCount: number;

    constructor(data?: IViolationDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ViolationDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ViolationDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ViolationDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ViolationDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ViolationDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IViolationDtoPagedResultDto {
    items: ViolationDto[] | undefined;
    totalCount: number;
}

export class ViolationItem implements IViolationItem {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creatorUser: User;
    lastModifierUser: User;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    readonly violationId: string;
    violation: Violation;
    itemType: ViolationItemType;
    readonly violationTypeId: string | undefined;
    violationType: ViolationType;
    readonly itemStatusId: number;
    readonly price: number;
    readonly vatPercentage: number;
    readonly subPrice: number;
    readonly vatAmount: number;
    itemStatus: ViolationItemStatus;

    constructor(data?: IViolationItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            (<any>this).violationId = _data["violationId"];
            this.violation = _data["violation"] ? Violation.fromJS(_data["violation"]) : <any>undefined;
            this.itemType = _data["itemType"];
            (<any>this).violationTypeId = _data["violationTypeId"];
            this.violationType = _data["violationType"] ? ViolationType.fromJS(_data["violationType"]) : <any>undefined;
            (<any>this).itemStatusId = _data["itemStatusId"];
            (<any>this).price = _data["price"];
            (<any>this).vatPercentage = _data["vatPercentage"];
            (<any>this).subPrice = _data["subPrice"];
            (<any>this).vatAmount = _data["vatAmount"];
            this.itemStatus = _data["itemStatus"] ? ViolationItemStatus.fromJS(_data["itemStatus"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ViolationItem {
        data = typeof data === 'object' ? data : {};
        let result = new ViolationItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["violationId"] = this.violationId;
        data["violation"] = this.violation ? this.violation.toJSON() : <any>undefined;
        data["itemType"] = this.itemType;
        data["violationTypeId"] = this.violationTypeId;
        data["violationType"] = this.violationType ? this.violationType.toJSON() : <any>undefined;
        data["itemStatusId"] = this.itemStatusId;
        data["price"] = this.price;
        data["vatPercentage"] = this.vatPercentage;
        data["subPrice"] = this.subPrice;
        data["vatAmount"] = this.vatAmount;
        data["itemStatus"] = this.itemStatus ? this.itemStatus.toJSON() : <any>undefined;
        return data;
    }

    clone(): ViolationItem {
        const json = this.toJSON();
        let result = new ViolationItem();
        result.init(json);
        return result;
    }
}

export interface IViolationItem {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creatorUser: User;
    lastModifierUser: User;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    violationId: string;
    violation: Violation;
    itemType: ViolationItemType;
    violationTypeId: string | undefined;
    violationType: ViolationType;
    itemStatusId: number;
    price: number;
    vatPercentage: number;
    subPrice: number;
    vatAmount: number;
    itemStatus: ViolationItemStatus;
}

export class ViolationItemDto implements IViolationItemDto {
    id: string;
    itemType: ViolationItemType;
    readonly itemTypeName: string | undefined;
    violationType: ViolationTypeDto;
    itemStatus: ViolationItemStatus;
    price: number;
    currency: string | undefined;
    subPrice: number;
    vatAmount: number;
    creationTime: moment.Moment;
    creator: string | undefined;

    constructor(data?: IViolationItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.itemType = _data["itemType"];
            (<any>this).itemTypeName = _data["itemTypeName"];
            this.violationType = _data["violationType"] ? ViolationTypeDto.fromJS(_data["violationType"]) : <any>undefined;
            this.itemStatus = _data["itemStatus"] ? ViolationItemStatus.fromJS(_data["itemStatus"]) : <any>undefined;
            this.price = _data["price"];
            this.currency = _data["currency"];
            this.subPrice = _data["subPrice"];
            this.vatAmount = _data["vatAmount"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creator = _data["creator"];
        }
    }

    static fromJS(data: any): ViolationItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ViolationItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["itemType"] = this.itemType;
        data["itemTypeName"] = this.itemTypeName;
        data["violationType"] = this.violationType ? this.violationType.toJSON() : <any>undefined;
        data["itemStatus"] = this.itemStatus ? this.itemStatus.toJSON() : <any>undefined;
        data["price"] = this.price;
        data["currency"] = this.currency;
        data["subPrice"] = this.subPrice;
        data["vatAmount"] = this.vatAmount;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creator"] = this.creator;
        return data;
    }

    clone(): ViolationItemDto {
        const json = this.toJSON();
        let result = new ViolationItemDto();
        result.init(json);
        return result;
    }
}

export interface IViolationItemDto {
    id: string;
    itemType: ViolationItemType;
    itemTypeName: string | undefined;
    violationType: ViolationTypeDto;
    itemStatus: ViolationItemStatus;
    price: number;
    currency: string | undefined;
    subPrice: number;
    vatAmount: number;
    creationTime: moment.Moment;
    creator: string | undefined;
}

export class ViolationItemStatus implements IViolationItemStatus {
    readonly name: string | undefined;
    readonly id: number;

    constructor(data?: IViolationItemStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data["name"];
            (<any>this).id = _data["id"];
        }
    }

    static fromJS(data: any): ViolationItemStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ViolationItemStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }

    clone(): ViolationItemStatus {
        const json = this.toJSON();
        let result = new ViolationItemStatus();
        result.init(json);
        return result;
    }
}

export interface IViolationItemStatus {
    name: string | undefined;
    id: number;
}

export enum ViolationItemType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class ViolationRecieptDto implements IViolationRecieptDto {
    location: string | undefined;
    violationItems: ViolationItemDto[] | undefined;
    price: string | undefined;
    creationTime: moment.Moment;
    total: number;
    subTotal: number;
    vatAmount: number;
    reservedTimeDetails: ReservedTimeDetailsDto;
    vehicle: VehicleDto;

    constructor(data?: IViolationRecieptDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.location = _data["location"];
            if (Array.isArray(_data["violationItems"])) {
                this.violationItems = [] as any;
                for (let item of _data["violationItems"])
                    this.violationItems.push(ViolationItemDto.fromJS(item));
            }
            this.price = _data["price"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.total = _data["total"];
            this.subTotal = _data["subTotal"];
            this.vatAmount = _data["vatAmount"];
            this.reservedTimeDetails = _data["reservedTimeDetails"] ? ReservedTimeDetailsDto.fromJS(_data["reservedTimeDetails"]) : <any>undefined;
            this.vehicle = _data["vehicle"] ? VehicleDto.fromJS(_data["vehicle"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ViolationRecieptDto {
        data = typeof data === 'object' ? data : {};
        let result = new ViolationRecieptDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["location"] = this.location;
        if (Array.isArray(this.violationItems)) {
            data["violationItems"] = [];
            for (let item of this.violationItems)
                data["violationItems"].push(item.toJSON());
        }
        data["price"] = this.price;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["total"] = this.total;
        data["subTotal"] = this.subTotal;
        data["vatAmount"] = this.vatAmount;
        data["reservedTimeDetails"] = this.reservedTimeDetails ? this.reservedTimeDetails.toJSON() : <any>undefined;
        data["vehicle"] = this.vehicle ? this.vehicle.toJSON() : <any>undefined;
        return data;
    }

    clone(): ViolationRecieptDto {
        const json = this.toJSON();
        let result = new ViolationRecieptDto();
        result.init(json);
        return result;
    }
}

export interface IViolationRecieptDto {
    location: string | undefined;
    violationItems: ViolationItemDto[] | undefined;
    price: string | undefined;
    creationTime: moment.Moment;
    total: number;
    subTotal: number;
    vatAmount: number;
    reservedTimeDetails: ReservedTimeDetailsDto;
    vehicle: VehicleDto;
}

export class ViolationRecieptDtoRecieptWithTransactionDto implements IViolationRecieptDtoRecieptWithTransactionDto {
    header: RecieptHeaderDto;
    information: ViolationRecieptDto;
    transaction: TransactionRecieptDto;

    constructor(data?: IViolationRecieptDtoRecieptWithTransactionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.header = _data["header"] ? RecieptHeaderDto.fromJS(_data["header"]) : <any>undefined;
            this.information = _data["information"] ? ViolationRecieptDto.fromJS(_data["information"]) : <any>undefined;
            this.transaction = _data["transaction"] ? TransactionRecieptDto.fromJS(_data["transaction"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ViolationRecieptDtoRecieptWithTransactionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ViolationRecieptDtoRecieptWithTransactionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["header"] = this.header ? this.header.toJSON() : <any>undefined;
        data["information"] = this.information ? this.information.toJSON() : <any>undefined;
        data["transaction"] = this.transaction ? this.transaction.toJSON() : <any>undefined;
        return data;
    }

    clone(): ViolationRecieptDtoRecieptWithTransactionDto {
        const json = this.toJSON();
        let result = new ViolationRecieptDtoRecieptWithTransactionDto();
        result.init(json);
        return result;
    }
}

export interface IViolationRecieptDtoRecieptWithTransactionDto {
    header: RecieptHeaderDto;
    information: ViolationRecieptDto;
    transaction: TransactionRecieptDto;
}

export class ViolationSettingsDto implements IViolationSettingsDto {
    differenceBetweenNoticeAndViolationCreation: string | undefined;
    reservedTimeAllowence: number | undefined;

    constructor(data?: IViolationSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.differenceBetweenNoticeAndViolationCreation = _data["differenceBetweenNoticeAndViolationCreation"];
            this.reservedTimeAllowence = _data["reservedTimeAllowence"];
        }
    }

    static fromJS(data: any): ViolationSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ViolationSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["differenceBetweenNoticeAndViolationCreation"] = this.differenceBetweenNoticeAndViolationCreation;
        data["reservedTimeAllowence"] = this.reservedTimeAllowence;
        return data;
    }

    clone(): ViolationSettingsDto {
        const json = this.toJSON();
        let result = new ViolationSettingsDto();
        result.init(json);
        return result;
    }
}

export interface IViolationSettingsDto {
    differenceBetweenNoticeAndViolationCreation: string | undefined;
    reservedTimeAllowence: number | undefined;
}

export class ViolationState implements IViolationState {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creatorUser: User;
    lastModifierUser: User;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    readonly violationId: string;
    violation: Violation;
    statusId: number;
    status: ViolationStatus;
    workflowState: IWorkflowState;
    workflowAction: IWorkflowAction;
    takenActionId: number;
    shiftId: string | undefined;
    shift: StaffAccountShift;
    takenAction: ViolationAction;
    vehicleStatusId: number;
    vehicleStatus: VehicleStatus;
    readonly duration: number;
    readonly isActive: boolean;
    notes: string | undefined;
    longitude: number;
    latitude: number;
    version: string | undefined;

    constructor(data?: IViolationState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            (<any>this).violationId = _data["violationId"];
            this.violation = _data["violation"] ? Violation.fromJS(_data["violation"]) : <any>undefined;
            this.statusId = _data["statusId"];
            this.status = _data["status"] ? ViolationStatus.fromJS(_data["status"]) : <any>undefined;
            this.workflowState = _data["workflowState"] ? IWorkflowState.fromJS(_data["workflowState"]) : <any>undefined;
            this.workflowAction = _data["workflowAction"] ? IWorkflowAction.fromJS(_data["workflowAction"]) : <any>undefined;
            this.takenActionId = _data["takenActionId"];
            this.shiftId = _data["shiftId"];
            this.shift = _data["shift"] ? StaffAccountShift.fromJS(_data["shift"]) : <any>undefined;
            this.takenAction = _data["takenAction"] ? ViolationAction.fromJS(_data["takenAction"]) : <any>undefined;
            this.vehicleStatusId = _data["vehicleStatusId"];
            this.vehicleStatus = _data["vehicleStatus"] ? VehicleStatus.fromJS(_data["vehicleStatus"]) : <any>undefined;
            (<any>this).duration = _data["duration"];
            (<any>this).isActive = _data["isActive"];
            this.notes = _data["notes"];
            this.longitude = _data["longitude"];
            this.latitude = _data["latitude"];
            this.version = _data["version"];
        }
    }

    static fromJS(data: any): ViolationState {
        data = typeof data === 'object' ? data : {};
        let result = new ViolationState();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["violationId"] = this.violationId;
        data["violation"] = this.violation ? this.violation.toJSON() : <any>undefined;
        data["statusId"] = this.statusId;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["workflowState"] = this.workflowState ? this.workflowState.toJSON() : <any>undefined;
        data["workflowAction"] = this.workflowAction ? this.workflowAction.toJSON() : <any>undefined;
        data["takenActionId"] = this.takenActionId;
        data["shiftId"] = this.shiftId;
        data["shift"] = this.shift ? this.shift.toJSON() : <any>undefined;
        data["takenAction"] = this.takenAction ? this.takenAction.toJSON() : <any>undefined;
        data["vehicleStatusId"] = this.vehicleStatusId;
        data["vehicleStatus"] = this.vehicleStatus ? this.vehicleStatus.toJSON() : <any>undefined;
        data["duration"] = this.duration;
        data["isActive"] = this.isActive;
        data["notes"] = this.notes;
        data["longitude"] = this.longitude;
        data["latitude"] = this.latitude;
        data["version"] = this.version;
        return data;
    }

    clone(): ViolationState {
        const json = this.toJSON();
        let result = new ViolationState();
        result.init(json);
        return result;
    }
}

export interface IViolationState {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creatorUser: User;
    lastModifierUser: User;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    violationId: string;
    violation: Violation;
    statusId: number;
    status: ViolationStatus;
    workflowState: IWorkflowState;
    workflowAction: IWorkflowAction;
    takenActionId: number;
    shiftId: string | undefined;
    shift: StaffAccountShift;
    takenAction: ViolationAction;
    vehicleStatusId: number;
    vehicleStatus: VehicleStatus;
    duration: number;
    isActive: boolean;
    notes: string | undefined;
    longitude: number;
    latitude: number;
    version: string | undefined;
}

export class ViolationStateDto implements IViolationStateDto {
    id: string;
    status: ViolationStatus;
    takenAction: ViolationAction;
    vehicleStatus: VehicleStatus;
    duration: number;
    notes: string | undefined;
    attachments: AttachmentViewDto[] | undefined;
    isActive: boolean;
    creationTime: moment.Moment;
    creator: string | undefined;
    longitude: number;
    latitude: number;

    constructor(data?: IViolationStateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"] ? ViolationStatus.fromJS(_data["status"]) : <any>undefined;
            this.takenAction = _data["takenAction"] ? ViolationAction.fromJS(_data["takenAction"]) : <any>undefined;
            this.vehicleStatus = _data["vehicleStatus"] ? VehicleStatus.fromJS(_data["vehicleStatus"]) : <any>undefined;
            this.duration = _data["duration"];
            this.notes = _data["notes"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments.push(AttachmentViewDto.fromJS(item));
            }
            this.isActive = _data["isActive"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creator = _data["creator"];
            this.longitude = _data["longitude"];
            this.latitude = _data["latitude"];
        }
    }

    static fromJS(data: any): ViolationStateDto {
        data = typeof data === 'object' ? data : {};
        let result = new ViolationStateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["takenAction"] = this.takenAction ? this.takenAction.toJSON() : <any>undefined;
        data["vehicleStatus"] = this.vehicleStatus ? this.vehicleStatus.toJSON() : <any>undefined;
        data["duration"] = this.duration;
        data["notes"] = this.notes;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        data["isActive"] = this.isActive;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creator"] = this.creator;
        data["longitude"] = this.longitude;
        data["latitude"] = this.latitude;
        return data;
    }

    clone(): ViolationStateDto {
        const json = this.toJSON();
        let result = new ViolationStateDto();
        result.init(json);
        return result;
    }
}

export interface IViolationStateDto {
    id: string;
    status: ViolationStatus;
    takenAction: ViolationAction;
    vehicleStatus: VehicleStatus;
    duration: number;
    notes: string | undefined;
    attachments: AttachmentViewDto[] | undefined;
    isActive: boolean;
    creationTime: moment.Moment;
    creator: string | undefined;
    longitude: number;
    latitude: number;
}

export class ViolationStatisticsResponse implements IViolationStatisticsResponse {
    count: number;
    amount: number;

    constructor(data?: IViolationStatisticsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): ViolationStatisticsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ViolationStatisticsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        data["amount"] = this.amount;
        return data;
    }

    clone(): ViolationStatisticsResponse {
        const json = this.toJSON();
        let result = new ViolationStatisticsResponse();
        result.init(json);
        return result;
    }
}

export interface IViolationStatisticsResponse {
    count: number;
    amount: number;
}

export class ViolationStatus implements IViolationStatus {
    readonly name: string | undefined;
    readonly id: number;
    ui: UserInterface;
    state: WorkflowState;

    constructor(data?: IViolationStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data["name"];
            (<any>this).id = _data["id"];
            this.ui = _data["ui"] ? UserInterface.fromJS(_data["ui"]) : <any>undefined;
            this.state = _data["state"] ? WorkflowState.fromJS(_data["state"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ViolationStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ViolationStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        data["ui"] = this.ui ? this.ui.toJSON() : <any>undefined;
        data["state"] = this.state ? this.state.toJSON() : <any>undefined;
        return data;
    }

    clone(): ViolationStatus {
        const json = this.toJSON();
        let result = new ViolationStatus();
        result.init(json);
        return result;
    }
}

export interface IViolationStatus {
    name: string | undefined;
    id: number;
    ui: UserInterface;
    state: WorkflowState;
}

export class ViolationType implements IViolationType {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    name_En: string | undefined;
    name_Ar: string | undefined;
    code: string | undefined;
    applyReservedTime: boolean;
    readonly locationViolationTypePrices: LocationViolationTypePrice[] | undefined;
    readonly locations: Location[] | undefined;

    constructor(data?: IViolationType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.name_En = _data["name_En"];
            this.name_Ar = _data["name_Ar"];
            this.code = _data["code"];
            this.applyReservedTime = _data["applyReservedTime"];
            if (Array.isArray(_data["locationViolationTypePrices"])) {
                (<any>this).locationViolationTypePrices = [] as any;
                for (let item of _data["locationViolationTypePrices"])
                    (<any>this).locationViolationTypePrices.push(LocationViolationTypePrice.fromJS(item));
            }
            if (Array.isArray(_data["locations"])) {
                (<any>this).locations = [] as any;
                for (let item of _data["locations"])
                    (<any>this).locations.push(Location.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ViolationType {
        data = typeof data === 'object' ? data : {};
        let result = new ViolationType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["name_En"] = this.name_En;
        data["name_Ar"] = this.name_Ar;
        data["code"] = this.code;
        data["applyReservedTime"] = this.applyReservedTime;
        if (Array.isArray(this.locationViolationTypePrices)) {
            data["locationViolationTypePrices"] = [];
            for (let item of this.locationViolationTypePrices)
                data["locationViolationTypePrices"].push(item.toJSON());
        }
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (let item of this.locations)
                data["locations"].push(item.toJSON());
        }
        return data;
    }

    clone(): ViolationType {
        const json = this.toJSON();
        let result = new ViolationType();
        result.init(json);
        return result;
    }
}

export interface IViolationType {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    name_En: string | undefined;
    name_Ar: string | undefined;
    code: string | undefined;
    applyReservedTime: boolean;
    locationViolationTypePrices: LocationViolationTypePrice[] | undefined;
    locations: Location[] | undefined;
}

export class ViolationTypeDto implements IViolationTypeDto {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    readonly name_En: string | undefined;
    readonly name_Ar: string | undefined;
    readonly code: string | undefined;
    readonly applyReservedTime: boolean;

    constructor(data?: IViolationTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            (<any>this).name_En = _data["name_En"];
            (<any>this).name_Ar = _data["name_Ar"];
            (<any>this).code = _data["code"];
            (<any>this).applyReservedTime = _data["applyReservedTime"];
        }
    }

    static fromJS(data: any): ViolationTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ViolationTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["name_En"] = this.name_En;
        data["name_Ar"] = this.name_Ar;
        data["code"] = this.code;
        data["applyReservedTime"] = this.applyReservedTime;
        return data;
    }

    clone(): ViolationTypeDto {
        const json = this.toJSON();
        let result = new ViolationTypeDto();
        result.init(json);
        return result;
    }
}

export interface IViolationTypeDto {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    name_En: string | undefined;
    name_Ar: string | undefined;
    code: string | undefined;
    applyReservedTime: boolean;
}

export class ViolationTypeDtoPagedResultDto implements IViolationTypeDtoPagedResultDto {
    items: ViolationTypeDto[] | undefined;
    totalCount: number;

    constructor(data?: IViolationTypeDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ViolationTypeDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ViolationTypeDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ViolationTypeDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ViolationTypeDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ViolationTypeDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IViolationTypeDtoPagedResultDto {
    items: ViolationTypeDto[] | undefined;
    totalCount: number;
}

export class ViolationTypeLookupDto implements IViolationTypeLookupDto {
    id: string;
    name_En: string | undefined;
    name_Ar: string | undefined;
    name: string | undefined;
    code: string | undefined;
    applyReservedTime: boolean;

    constructor(data?: IViolationTypeLookupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name_En = _data["name_En"];
            this.name_Ar = _data["name_Ar"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.applyReservedTime = _data["applyReservedTime"];
        }
    }

    static fromJS(data: any): ViolationTypeLookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new ViolationTypeLookupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name_En"] = this.name_En;
        data["name_Ar"] = this.name_Ar;
        data["name"] = this.name;
        data["code"] = this.code;
        data["applyReservedTime"] = this.applyReservedTime;
        return data;
    }

    clone(): ViolationTypeLookupDto {
        const json = this.toJSON();
        let result = new ViolationTypeLookupDto();
        result.init(json);
        return result;
    }
}

export interface IViolationTypeLookupDto {
    id: string;
    name_En: string | undefined;
    name_Ar: string | undefined;
    name: string | undefined;
    code: string | undefined;
    applyReservedTime: boolean;
}

export class ViolationTypeLookupDtoPagedResultDto implements IViolationTypeLookupDtoPagedResultDto {
    items: ViolationTypeLookupDto[] | undefined;
    totalCount: number;

    constructor(data?: IViolationTypeLookupDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ViolationTypeLookupDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ViolationTypeLookupDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ViolationTypeLookupDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ViolationTypeLookupDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ViolationTypeLookupDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IViolationTypeLookupDtoPagedResultDto {
    items: ViolationTypeLookupDto[] | undefined;
    totalCount: number;
}

export class ViolationViewDto implements IViolationViewDto {
    id: string;
    code: number;
    carPlate: CarPlate;
    vehicle: VehicleListResponse;
    customerName: string | undefined;
    phoneNumber: string | undefined;
    latitude: number | undefined;
    longitude: number | undefined;
    reservationId: string | undefined;
    reservation: ReservationDto;
    shift: StaffAccountShiftDto;
    location: LocationListDto;
    slot: SlotListDto;
    violationItems: ViolationItemDto[] | undefined;
    states: ViolationStateDto[] | undefined;
    currentState: ViolationStateDto;
    reservedTimeDetails: ReservedTimeDetailsDto;
    towingImpoundDetails: TowingImpoundDetailsDto;
    notes: string | undefined;
    currency: string | undefined;
    total: number;
    subTotal: number;
    vatAmount: number;
    creationTime: moment.Moment;
    creator: string | undefined;
    clampNumber: string | undefined;
    referenceNumber: string | undefined;
    customerSupportStatus: CustomerSupportStatusDto;
    hasActiveCancellationRequest: boolean;

    constructor(data?: IViolationViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.carPlate = _data["carPlate"] ? CarPlate.fromJS(_data["carPlate"]) : <any>undefined;
            this.vehicle = _data["vehicle"] ? VehicleListResponse.fromJS(_data["vehicle"]) : <any>undefined;
            this.customerName = _data["customerName"];
            this.phoneNumber = _data["phoneNumber"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.reservationId = _data["reservationId"];
            this.reservation = _data["reservation"] ? ReservationDto.fromJS(_data["reservation"]) : <any>undefined;
            this.shift = _data["shift"] ? StaffAccountShiftDto.fromJS(_data["shift"]) : <any>undefined;
            this.location = _data["location"] ? LocationListDto.fromJS(_data["location"]) : <any>undefined;
            this.slot = _data["slot"] ? SlotListDto.fromJS(_data["slot"]) : <any>undefined;
            if (Array.isArray(_data["violationItems"])) {
                this.violationItems = [] as any;
                for (let item of _data["violationItems"])
                    this.violationItems.push(ViolationItemDto.fromJS(item));
            }
            if (Array.isArray(_data["states"])) {
                this.states = [] as any;
                for (let item of _data["states"])
                    this.states.push(ViolationStateDto.fromJS(item));
            }
            this.currentState = _data["currentState"] ? ViolationStateDto.fromJS(_data["currentState"]) : <any>undefined;
            this.reservedTimeDetails = _data["reservedTimeDetails"] ? ReservedTimeDetailsDto.fromJS(_data["reservedTimeDetails"]) : <any>undefined;
            this.towingImpoundDetails = _data["towingImpoundDetails"] ? TowingImpoundDetailsDto.fromJS(_data["towingImpoundDetails"]) : <any>undefined;
            this.notes = _data["notes"];
            this.currency = _data["currency"];
            this.total = _data["total"];
            this.subTotal = _data["subTotal"];
            this.vatAmount = _data["vatAmount"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creator = _data["creator"];
            this.clampNumber = _data["clampNumber"];
            this.referenceNumber = _data["referenceNumber"];
            this.customerSupportStatus = _data["customerSupportStatus"] ? CustomerSupportStatusDto.fromJS(_data["customerSupportStatus"]) : <any>undefined;
            this.hasActiveCancellationRequest = _data["hasActiveCancellationRequest"];
        }
    }

    static fromJS(data: any): ViolationViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new ViolationViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["carPlate"] = this.carPlate ? this.carPlate.toJSON() : <any>undefined;
        data["vehicle"] = this.vehicle ? this.vehicle.toJSON() : <any>undefined;
        data["customerName"] = this.customerName;
        data["phoneNumber"] = this.phoneNumber;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["reservationId"] = this.reservationId;
        data["reservation"] = this.reservation ? this.reservation.toJSON() : <any>undefined;
        data["shift"] = this.shift ? this.shift.toJSON() : <any>undefined;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["slot"] = this.slot ? this.slot.toJSON() : <any>undefined;
        if (Array.isArray(this.violationItems)) {
            data["violationItems"] = [];
            for (let item of this.violationItems)
                data["violationItems"].push(item.toJSON());
        }
        if (Array.isArray(this.states)) {
            data["states"] = [];
            for (let item of this.states)
                data["states"].push(item.toJSON());
        }
        data["currentState"] = this.currentState ? this.currentState.toJSON() : <any>undefined;
        data["reservedTimeDetails"] = this.reservedTimeDetails ? this.reservedTimeDetails.toJSON() : <any>undefined;
        data["towingImpoundDetails"] = this.towingImpoundDetails ? this.towingImpoundDetails.toJSON() : <any>undefined;
        data["notes"] = this.notes;
        data["currency"] = this.currency;
        data["total"] = this.total;
        data["subTotal"] = this.subTotal;
        data["vatAmount"] = this.vatAmount;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creator"] = this.creator;
        data["clampNumber"] = this.clampNumber;
        data["referenceNumber"] = this.referenceNumber;
        data["customerSupportStatus"] = this.customerSupportStatus ? this.customerSupportStatus.toJSON() : <any>undefined;
        data["hasActiveCancellationRequest"] = this.hasActiveCancellationRequest;
        return data;
    }

    clone(): ViolationViewDto {
        const json = this.toJSON();
        let result = new ViolationViewDto();
        result.init(json);
        return result;
    }
}

export interface IViolationViewDto {
    id: string;
    code: number;
    carPlate: CarPlate;
    vehicle: VehicleListResponse;
    customerName: string | undefined;
    phoneNumber: string | undefined;
    latitude: number | undefined;
    longitude: number | undefined;
    reservationId: string | undefined;
    reservation: ReservationDto;
    shift: StaffAccountShiftDto;
    location: LocationListDto;
    slot: SlotListDto;
    violationItems: ViolationItemDto[] | undefined;
    states: ViolationStateDto[] | undefined;
    currentState: ViolationStateDto;
    reservedTimeDetails: ReservedTimeDetailsDto;
    towingImpoundDetails: TowingImpoundDetailsDto;
    notes: string | undefined;
    currency: string | undefined;
    total: number;
    subTotal: number;
    vatAmount: number;
    creationTime: moment.Moment;
    creator: string | undefined;
    clampNumber: string | undefined;
    referenceNumber: string | undefined;
    customerSupportStatus: CustomerSupportStatusDto;
    hasActiveCancellationRequest: boolean;
}

export class WorkflowState implements IWorkflowState {
    id: number;
    name: string | undefined;

    constructor(data?: IWorkflowState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): WorkflowState {
        data = typeof data === 'object' ? data : {};
        let result = new WorkflowState();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): WorkflowState {
        const json = this.toJSON();
        let result = new WorkflowState();
        result.init(json);
        return result;
    }
}

export interface IWorkflowState {
    id: number;
    name: string | undefined;
}

export class ZatcaDeviceDto implements IZatcaDeviceDto {
    id: string;
    commonName: string | undefined;
    serialNumber: string | undefined;
    organizationIdentifier: string | undefined;
    organizationUnitName: string | undefined;
    organizationName: string | undefined;
    countryName: string | undefined;
    invoiceType: string | undefined;
    locationAddress: string | undefined;
    industryBusinessCategory: string | undefined;
    otp: string | undefined;
    icv: number;
    onBoarded: boolean;
    onBoardStatusReason: string | undefined;

    constructor(data?: IZatcaDeviceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.commonName = _data["commonName"];
            this.serialNumber = _data["serialNumber"];
            this.organizationIdentifier = _data["organizationIdentifier"];
            this.organizationUnitName = _data["organizationUnitName"];
            this.organizationName = _data["organizationName"];
            this.countryName = _data["countryName"];
            this.invoiceType = _data["invoiceType"];
            this.locationAddress = _data["locationAddress"];
            this.industryBusinessCategory = _data["industryBusinessCategory"];
            this.otp = _data["otp"];
            this.icv = _data["icv"];
            this.onBoarded = _data["onBoarded"];
            this.onBoardStatusReason = _data["onBoardStatusReason"];
        }
    }

    static fromJS(data: any): ZatcaDeviceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ZatcaDeviceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["commonName"] = this.commonName;
        data["serialNumber"] = this.serialNumber;
        data["organizationIdentifier"] = this.organizationIdentifier;
        data["organizationUnitName"] = this.organizationUnitName;
        data["organizationName"] = this.organizationName;
        data["countryName"] = this.countryName;
        data["invoiceType"] = this.invoiceType;
        data["locationAddress"] = this.locationAddress;
        data["industryBusinessCategory"] = this.industryBusinessCategory;
        data["otp"] = this.otp;
        data["icv"] = this.icv;
        data["onBoarded"] = this.onBoarded;
        data["onBoardStatusReason"] = this.onBoardStatusReason;
        return data;
    }

    clone(): ZatcaDeviceDto {
        const json = this.toJSON();
        let result = new ZatcaDeviceDto();
        result.init(json);
        return result;
    }
}

export interface IZatcaDeviceDto {
    id: string;
    commonName: string | undefined;
    serialNumber: string | undefined;
    organizationIdentifier: string | undefined;
    organizationUnitName: string | undefined;
    organizationName: string | undefined;
    countryName: string | undefined;
    invoiceType: string | undefined;
    locationAddress: string | undefined;
    industryBusinessCategory: string | undefined;
    otp: string | undefined;
    icv: number;
    onBoarded: boolean;
    onBoardStatusReason: string | undefined;
}

export class ZatcaDeviceDtoPagedResultDto implements IZatcaDeviceDtoPagedResultDto {
    items: ZatcaDeviceDto[] | undefined;
    totalCount: number;

    constructor(data?: IZatcaDeviceDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ZatcaDeviceDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ZatcaDeviceDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ZatcaDeviceDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ZatcaDeviceDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ZatcaDeviceDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IZatcaDeviceDtoPagedResultDto {
    items: ZatcaDeviceDto[] | undefined;
    totalCount: number;
}

export class ZatcaIntegrityLogResponse implements IZatcaIntegrityLogResponse {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    status: string | undefined;
    key: string;
    maxRetryCount: number;
    retryCount: number;
    failures: IntegrityFailureLogResponse[] | undefined;

    constructor(data?: IZatcaIntegrityLogResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.key = _data["key"];
            this.maxRetryCount = _data["maxRetryCount"];
            this.retryCount = _data["retryCount"];
            if (Array.isArray(_data["failures"])) {
                this.failures = [] as any;
                for (let item of _data["failures"])
                    this.failures.push(IntegrityFailureLogResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ZatcaIntegrityLogResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ZatcaIntegrityLogResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["key"] = this.key;
        data["maxRetryCount"] = this.maxRetryCount;
        data["retryCount"] = this.retryCount;
        if (Array.isArray(this.failures)) {
            data["failures"] = [];
            for (let item of this.failures)
                data["failures"].push(item.toJSON());
        }
        return data;
    }

    clone(): ZatcaIntegrityLogResponse {
        const json = this.toJSON();
        let result = new ZatcaIntegrityLogResponse();
        result.init(json);
        return result;
    }
}

export interface IZatcaIntegrityLogResponse {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    status: string | undefined;
    key: string;
    maxRetryCount: number;
    retryCount: number;
    failures: IntegrityFailureLogResponse[] | undefined;
}

export class ZatcaIntegrityLogResponsePagedResultDto implements IZatcaIntegrityLogResponsePagedResultDto {
    items: ZatcaIntegrityLogResponse[] | undefined;
    totalCount: number;

    constructor(data?: IZatcaIntegrityLogResponsePagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ZatcaIntegrityLogResponse.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ZatcaIntegrityLogResponsePagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ZatcaIntegrityLogResponsePagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ZatcaIntegrityLogResponsePagedResultDto {
        const json = this.toJSON();
        let result = new ZatcaIntegrityLogResponsePagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IZatcaIntegrityLogResponsePagedResultDto {
    items: ZatcaIntegrityLogResponse[] | undefined;
    totalCount: number;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}